import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: any; output: any; }
};

export type AccountingRecord = {
  __typename?: 'AccountingRecord';
  booking: Booking;
  createdAt: Scalars['Int']['output'];
  discountedAmount: Scalars['Int']['output'];
  discountedSubTotal: Scalars['Int']['output'];
  lineItems: Array<DetailedPrice>;
  revenues: Array<Revenue>;
  stripePaymentIntent: PaymentIntent;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripeTransferIds?: Maybe<Array<Scalars['String']['output']>>;
  subTotal: Scalars['Int']['output'];
  tipAmount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalTaxAmount: Scalars['Int']['output'];
  uid: Scalars['String']['output'];
};

export type Alias = {
  __typename?: 'Alias';
  externalUid?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type AnalyticsEventMetadataInput = {
  appointmentId: Scalars['String']['input'];
};

export enum AnalyticsEventType {
  AnalyticsEventTypeCustomerBrowseServiceProvider = 'AnalyticsEventTypeCustomerBrowseServiceProvider',
  AnalyticsEventTypeCustomerBrowseServiceType = 'AnalyticsEventTypeCustomerBrowseServiceType',
  AnalyticsEventTypeCustomerCopyEventShareLink = 'AnalyticsEventTypeCustomerCopyEventShareLink',
  AnalyticsEventTypeCustomerOpenEventShareLink = 'AnalyticsEventTypeCustomerOpenEventShareLink',
  AnalyticsEventTypeUnspecified = 'AnalyticsEventTypeUnspecified'
}

export type Appointment = {
  __typename?: 'Appointment';
  bookings: Array<Booking>;
  bookingsWithSiblings: Array<Booking>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelledByUid?: Maybe<Scalars['String']['output']>;
  denialReason?: Maybe<Scalars['String']['output']>;
  discountRuleProgress: Array<DiscountRuleWithProgress>;
  discounts: Array<Discount>;
  eventEndDateTime?: Maybe<Scalars['Int']['output']>;
  eventOffering?: Maybe<EventOffering>;
  eventOfferingId: Scalars['String']['output'];
  expectedEarnings?: Maybe<AppointmentExpectedEarnings>;
  id: Scalars['String']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  isCoveredByBusiness?: Maybe<Scalars['Boolean']['output']>;
  isDenied: Scalars['Boolean']['output'];
  location: Location;
  locationUid: Scalars['String']['output'];
  maxEndDateTime: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  ownerUid: Scalars['String']['output'];
  preferences: Array<AppointmentPreference>;
  serviceArea?: Maybe<ServiceArea>;
  serviceAreaUid?: Maybe<Scalars['String']['output']>;
  serviceProvider: ServiceProvider;
  startDateTime: Scalars['Int']['output'];
  timezoneLocation: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  userUid: Scalars['String']['output'];
};


export type AppointmentBookingsArgs = {
  statusQuery?: InputMaybe<BookingStatusQuery>;
};


export type AppointmentDiscountRuleProgressArgs = {
  bookingSelections?: InputMaybe<BookingSelectionsInput>;
};

export type AppointmentCart = {
  __typename?: 'AppointmentCart';
  appointmentSelections: AppointmentSelections;
  createdAt: Scalars['Int']['output'];
  owner: User;
  serviceProviderUid: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  viewedAt: Scalars['Int']['output'];
};

export type AppointmentCartQuery = {
  ownerUids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  serviceProviderUids?: InputMaybe<Array<Scalars['String']['input']>>;
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppointmentCartQueryResult = {
  __typename?: 'AppointmentCartQueryResult';
  appointmentCarts: Array<AppointmentCart>;
  hasMoreResults: Scalars['Boolean']['output'];
};

export type AppointmentChangeProposal = {
  __typename?: 'AppointmentChangeProposal';
  appointmentId: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  ownerUserUID: Scalars['String']['output'];
  startDateTime: Scalars['Int']['output'];
  status: AppointmentChangeProposalStatus;
  updatedAt: Scalars['Int']['output'];
};

export type AppointmentChangeProposalInput = {
  appointmentId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
};

export enum AppointmentChangeProposalStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Unspecified = 'UNSPECIFIED'
}

export type AppointmentExpectedEarnings = {
  __typename?: 'AppointmentExpectedEarnings';
  bookingsExpectedEarnings: Array<ExpectedEarnings>;
  expectedEarnings: ExpectedEarnings;
};

export type AppointmentOracleQuery = {
  cancelledStatus?: InputMaybe<CancelledStatus>;
  completeStatus?: InputMaybe<CompletedStatus>;
  confirmedStatus?: InputMaybe<ConfirmedStatus>;
  deniedStatus?: InputMaybe<DeniedStatus>;
  geohashBounds?: InputMaybe<BoundsStringInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  timeUtcSecondsBounds?: InputMaybe<BoundsInput>;
};

export type AppointmentPreference = {
  __typename?: 'AppointmentPreference';
  appointment: Appointment;
  owner: User;
  type: AppointmentPreferenceType;
  uid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AppointmentPreferenceQuery = {
  appointmentUids?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerUids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  types: Array<AppointmentPreferenceType>;
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppointmentPreferenceQueryResult = {
  __typename?: 'AppointmentPreferenceQueryResult';
  appointmentPreferences: Array<AppointmentPreference>;
  hasMoreResults: Scalars['Boolean']['output'];
};

export enum AppointmentPreferenceType {
  EnabledServiceOfferingUids = 'ENABLED_SERVICE_OFFERING_UIDS',
  Unspecified = 'UNSPECIFIED'
}

export type AppointmentQuery = {
  cancelledStatus?: InputMaybe<CancelledStatus>;
  completeStatus?: InputMaybe<CompletedStatus>;
  confirmedStatus?: InputMaybe<ConfirmedStatus>;
  deniedStatus?: InputMaybe<DeniedStatus>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  timeUtcSecondsBounds?: InputMaybe<BoundsInput>;
};

export type AppointmentRequest = {
  __typename?: 'AppointmentRequest';
  appointmentUid?: Maybe<Scalars['String']['output']>;
  denialReason: Scalars['String']['output'];
  externalUid: Scalars['String']['output'];
  location: Location;
  locationUid: Scalars['String']['output'];
  minEndDateTime: Scalars['Int']['output'];
  ownerUid: Scalars['String']['output'];
  serviceArea?: Maybe<ServiceArea>;
  serviceAreaUid: Scalars['String']['output'];
  serviceProvider: LegacyServiceProvider;
  startDateTime: Scalars['Int']['output'];
  status: AppointmentRequestStatus;
  timezoneLocation: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type AppointmentRequestQuery = {
  locationUids: Array<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  timeUtcSecondsBounds?: InputMaybe<BoundsInput>;
};

export enum AppointmentRequestStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export type AppointmentSelections = {
  __typename?: 'AppointmentSelections';
  locationUid: Scalars['String']['output'];
  serviceAreaUid?: Maybe<Scalars['String']['output']>;
  serviceProviderOwnerUid: Scalars['String']['output'];
  startDateTime: Scalars['Int']['output'];
};

export type AppointmentSelectionsInput = {
  locationUid: Scalars['String']['input'];
  serviceAreaUid?: InputMaybe<Scalars['String']['input']>;
  serviceProviderOwnerUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
};

export type AppointmentStatusQuery = {
  cancelledStatus?: InputMaybe<CancelledStatus>;
  completeStatus?: InputMaybe<CompletedStatus>;
  confirmedStatus?: InputMaybe<ConfirmedStatus>;
  deniedStatus?: InputMaybe<DeniedStatus>;
};

export type Availability = {
  __typename?: 'Availability';
  timeUtcSecondsBounds: Array<Bounds>;
};

export type AvailabilityInput = {
  timeUtcSecondsBounds: Array<BoundsInput>;
};

export type Booking = {
  __typename?: 'Booking';
  accountingRecord?: Maybe<AccountingRecord>;
  appointment: Appointment;
  appointmentUid: Scalars['String']['output'];
  customer: Customer;
  customerInputGroupSelections?: Maybe<Array<Array<CustomerInputGroupSelectionsV2>>>;
  customerInputSelections?: Maybe<Array<CustomerInputSelection>>;
  customerProfileId: Scalars['String']['output'];
  discounts: Array<Discount>;
  dropoff?: Maybe<Dropoff>;
  earnings?: Maybe<Scalars['Int']['output']>;
  endDateTime: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  isCustomerConfirmed: Scalars['Boolean']['output'];
  isInProgress: Scalars['Boolean']['output'];
  isNoShow: Scalars['Boolean']['output'];
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notes: Array<BookingNote>;
  owner: User;
  ownerUid: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  review?: Maybe<Review>;
  serviceOffering: ServiceOffering;
  serviceOfferingUid: Scalars['String']['output'];
  startDateTime: Scalars['Int']['output'];
  tipPercent: Scalars['Int']['output'];
  uid: Scalars['String']['output'];
};

export type BookingAttribute = {
  __typename?: 'BookingAttribute';
  bookingUid: Scalars['String']['output'];
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  ownerUid: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  type: BookingAttributeType;
  uid: Scalars['String']['output'];
};

export type BookingAttributeInput = {
  bookingUid: Scalars['String']['input'];
  description: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  type: BookingAttributeType;
};

export enum BookingAttributeType {
  External = 'EXTERNAL',
  Generic = 'GENERIC',
  LineItem = 'LINE_ITEM',
  Note = 'NOTE',
  Room = 'ROOM'
}

export enum BookingCancelledStatus {
  Cancelled = 'CANCELLED',
  CancelledOrNotCancelled = 'CANCELLED_OR_NOT_CANCELLED',
  NotCancelled = 'NOT_CANCELLED'
}

export type BookingCart = {
  __typename?: 'BookingCart';
  appointment?: Maybe<Appointment>;
  appointmentUid?: Maybe<Scalars['String']['output']>;
  bookingSelections: BookingSelections;
  createdAt: Scalars['Int']['output'];
  owner: User;
  ownerUid: Scalars['String']['output'];
  redeemable?: Maybe<Redeemable>;
  redeemableSecret?: Maybe<Scalars['String']['output']>;
  serviceProviderUid: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  viewedAt: Scalars['Int']['output'];
};

export type BookingCartQuery = {
  appointmentUids?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerUids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  serviceProviderUids?: InputMaybe<Array<Scalars['String']['input']>>;
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BookingCartQueryResult = {
  __typename?: 'BookingCartQueryResult';
  bookingCarts: Array<BookingCart>;
  hasMoreResults: Scalars['Boolean']['output'];
};

export enum BookingCompletedStatus {
  Complete = 'COMPLETE',
  CompleteOrIncomplete = 'COMPLETE_OR_INCOMPLETE',
  Incomplete = 'INCOMPLETE'
}

export type BookingDurationOverride = {
  __typename?: 'BookingDurationOverride';
  bookingID: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  customerInputDurations: Array<Maybe<CustomerInputDuration>>;
  id: Scalars['String']['output'];
  serviceOfferingDuration: Scalars['Int']['output'];
  serviceProviderID: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type BookingDurationOverrideInput = {
  bookingID: Scalars['String']['input'];
  customerInputDurations: Array<InputMaybe<CustomerInputDurationInput>>;
  serviceOfferingDuration: Scalars['Int']['input'];
  serviceProviderID: Scalars['String']['input'];
};

export enum BookingNoShowStatus {
  NoShowStatusNotNoShow = 'NoShowStatus_NOT_NO_SHOW',
  NoShowStatusNoShow = 'NoShowStatus_NO_SHOW',
  NoShowStatusUnspecified = 'NoShowStatus_UNSPECIFIED'
}

export type BookingNote = {
  __typename?: 'BookingNote';
  bookingId: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type BookingNoteInput = {
  bookingId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BookingPriceBreakdown = {
  __typename?: 'BookingPriceBreakdown';
  customLineItems: Array<DetailedPrice>;
  customerInputs: Array<CustomerInputPriceBreakdown>;
  discountedSubTotal: Scalars['Int']['output'];
  discountsApplied: Array<DiscountApplied>;
  serviceOffering: DetailedPrice;
  subTotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  tipAmount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BookingQuery = {
  cancelledStatus?: InputMaybe<BookingCancelledStatus>;
  completedStatus?: InputMaybe<BookingCompletedStatus>;
  noShowStatus?: InputMaybe<BookingNoShowStatus>;
  pagination?: InputMaybe<V1Beta3_PaginationInput>;
  referenceMatches?: InputMaybe<Array<V1Beta3_ReferenceMatch>>;
  timeUtcSecondsBounds: BoundsInput;
};

export type BookingQueryResult = {
  __typename?: 'BookingQueryResult';
  bookings: Array<Booking>;
};

export type BookingSelections = {
  __typename?: 'BookingSelections';
  appointmentUid: Scalars['String']['output'];
  customerInputGroupSelections?: Maybe<Array<Array<CustomerInputGroupSelectionsV2>>>;
  customerInputSelections?: Maybe<Array<CustomerInputSelection>>;
  customerProfileId: Scalars['String']['output'];
  serviceOffering: ServiceOffering;
  serviceOfferingUid: Scalars['String']['output'];
  startDateTime: Scalars['Int']['output'];
  tipPercent: Scalars['Int']['output'];
};

export type BookingSelectionsInput = {
  appointmentUid: Scalars['String']['input'];
  customerInputGroupSelections?: InputMaybe<Array<Array<CustomerInputGroupSelectionsInput>>>;
  customerInputSelections?: InputMaybe<Array<CustomerInputSelectionInput>>;
  serviceOfferingUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
  tipPercent: Scalars['Int']['input'];
};

export type BookingStatusQuery = {
  cancelledStatus?: InputMaybe<BookingCancelledStatus>;
  completedStatus?: InputMaybe<BookingCompletedStatus>;
  noShowStatus?: InputMaybe<BookingNoShowStatus>;
};

export type BookingsForAppointment = {
  __typename?: 'BookingsForAppointment';
  appointmentUid: Scalars['String']['output'];
  completeBookings: Array<Booking>;
  incompleteBookings: Array<Booking>;
  totalComplete: Scalars['Int']['output'];
  totalIncomplete: Scalars['Int']['output'];
};

export type Bounds = {
  __typename?: 'Bounds';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type BoundsInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type BoundsStringInput = {
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
};

export type Business = {
  __typename?: 'Business';
  admin: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  hasLinkedStripeSource: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inviteCode: Scalars['String']['output'];
  locations: Array<Location>;
  name: Scalars['String']['output'];
  province: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type BusinessInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  numEmployees?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessQuery = {
  pagination?: InputMaybe<V1Beta3_PaginationInput>;
  referenceMatches?: InputMaybe<Array<V1Beta3_ReferenceMatch>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessQueryResult = {
  __typename?: 'BusinessQueryResult';
  businesses: Array<Business>;
};

export type BusinessRegistrationInfo = {
  businessName: Scalars['String']['input'];
  numEmployees: Scalars['Int']['input'];
};

export type CalendarAccess = {
  __typename?: 'CalendarAccess';
  hasAccess: Scalars['Boolean']['output'];
  provider: CalendarProvider;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  description: Scalars['String']['output'];
  endDateTime: Scalars['Int']['output'];
  eventType: CalendarEventType;
  externalCalendarEventId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  startDateTime: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type CalendarEventInput = {
  description: Scalars['String']['input'];
  endDateTime: Scalars['Int']['input'];
  startDateTime: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type CalendarEventQuery = {
  eventType?: InputMaybe<CalendarEventType>;
  fromDateTime: Scalars['Int']['input'];
  toDateTime: Scalars['Int']['input'];
};

export enum CalendarEventType {
  CalendarEventTypeBreak = 'CalendarEventType_BREAK',
  CalendarEventTypeImportedFromExternalCalendar = 'CalendarEventType_IMPORTED_FROM_EXTERNAL_CALENDAR'
}

export enum CalendarProvider {
  Google = 'GOOGLE',
  NoCalendar = 'NO_CALENDAR'
}

export enum CancelledStatus {
  Cancelled = 'CANCELLED',
  CancelledOrNotCancelled = 'CANCELLED_OR_NOT_CANCELLED',
  NotCancelled = 'NOT_CANCELLED'
}

export type Card = {
  __typename?: 'Card';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  createdAt: Scalars['Int']['output'];
  isEdited: Scalars['Boolean']['output'];
  owner: User;
  room: ChatRoom;
  roomUid: Scalars['String']['output'];
  text: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type ChatMessageQuery = {
  ownerUids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  roomUids?: InputMaybe<Array<Scalars['String']['input']>>;
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChatMessageQueryResult = {
  __typename?: 'ChatMessageQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  messages: Array<ChatMessage>;
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  participants: Array<User>;
  uid: Scalars['String']['output'];
};

export type ChatRoomQuery = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  participantOwnerUids?: InputMaybe<Array<Scalars['String']['input']>>;
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChatRoomQueryResult = {
  __typename?: 'ChatRoomQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  rooms: Array<ChatRoom>;
};

export type CompleteBookingResponse = {
  __typename?: 'CompleteBookingResponse';
  error?: Maybe<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
};

export enum CompletedStatus {
  Complete = 'COMPLETE',
  CompleteOrIncomplete = 'COMPLETE_OR_INCOMPLETE',
  Incomplete = 'INCOMPLETE'
}

export enum ConfirmedStatus {
  Confirmed = 'CONFIRMED',
  ConfirmedOrUnconfirmed = 'CONFIRMED_OR_UNCONFIRMED',
  Unconfirmed = 'UNCONFIRMED'
}

export type CreateAppointmentCartInput = {
  appointmentSelections: AppointmentSelectionsInput;
  serviceProviderUid: Scalars['String']['input'];
};

export type CreateAppointmentFromEventCartResponse = {
  __typename?: 'CreateAppointmentFromEventCartResponse';
  appointmentId: Scalars['String']['output'];
};

export type CreateAppointmentInput = {
  locationUid: Scalars['String']['input'];
  maxEndDateTime?: InputMaybe<Scalars['Int']['input']>;
  nonce?: InputMaybe<Scalars['String']['input']>;
  serviceAreaUid?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['Int']['input'];
  timezoneLocation: Scalars['String']['input'];
  userUid: Scalars['String']['input'];
};

export type CreateAppointmentPreferenceInput = {
  appointmentUid: Scalars['String']['input'];
  type: AppointmentPreferenceType;
  value: Scalars['String']['input'];
};

export type CreateAppointmentRequestAndEagerBookingFromCartsResponse = {
  __typename?: 'CreateAppointmentRequestAndEagerBookingFromCartsResponse';
  appointment?: Maybe<Appointment>;
  appointmentRequest: AppointmentRequest;
  booking?: Maybe<Booking>;
  eagerBooking?: Maybe<EagerBooking>;
};

export type CreateAppointmentRequestInput = {
  externalUid: Scalars['String']['input'];
  locationUid: Scalars['String']['input'];
  minEndDateTime: Scalars['Int']['input'];
  nonce?: InputMaybe<Scalars['String']['input']>;
  serviceAreaUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
  timezoneLocation: Scalars['String']['input'];
};

export type CreateAppointmentRequestResponse = {
  __typename?: 'CreateAppointmentRequestResponse';
  appointmentRequestUid: Scalars['String']['output'];
  appointmentUid?: Maybe<Scalars['String']['output']>;
  nonce?: Maybe<Scalars['String']['output']>;
};

export type CreateBookingCartInput = {
  appointmentUid?: InputMaybe<Scalars['String']['input']>;
  bookingSelections: BookingSelectionsInput;
  serviceProviderUid: Scalars['String']['input'];
};

export type CreateBookingFromCartResponse = {
  __typename?: 'CreateBookingFromCartResponse';
  booking: Booking;
};

export type CreateBookingInput = {
  appointmentUid?: InputMaybe<Scalars['String']['input']>;
  customerInputGroupSelections?: InputMaybe<Array<Array<CustomerInputGroupSelectionsInput>>>;
  customerInputSelections?: InputMaybe<Array<CustomerInputSelectionInput>>;
  customerProfileId: Scalars['String']['input'];
  nonce?: InputMaybe<Scalars['String']['input']>;
  serviceOfferingUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
  tipPercent: Scalars['Int']['input'];
};

export type CreateChatRoomInput = {
  participantOwnerUids: Array<Scalars['String']['input']>;
};

export type CreateCustomTaxRateLineItemInput = {
  microPercent: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateCustomerInput = {
  country: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  timezoneLocation: Scalars['String']['input'];
};

export type CreateCustomerInputOptionResponse = {
  __typename?: 'CreateCustomerInputOptionResponse';
  customerInputOptionUid: Scalars['String']['output'];
  nonce?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomerInputResponse = {
  __typename?: 'CreateCustomerInputResponse';
  customerInputUid: Scalars['String']['output'];
  options: Array<CreateCustomerInputOptionResponse>;
};

export type CreateCustomerInputsResponse = {
  __typename?: 'CreateCustomerInputsResponse';
  customerInputs: Array<CreateCustomerInputResponse>;
};

export type CreateDropoffInput = {
  bookingUid: Scalars['String']['input'];
  dropoffDateTime: Scalars['Int']['input'];
};

export type CreateEagerBookingInput = {
  booking: CreateBookingInput;
  externalUid: Scalars['String']['input'];
};

export type CreateEventCartInput = {
  enabledServiceOfferingUids: Array<Scalars['String']['input']>;
  eventEndDateTime?: InputMaybe<Scalars['Int']['input']>;
  isCoveredByBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  locationUid: Scalars['String']['input'];
  serviceAreaUid?: InputMaybe<Scalars['String']['input']>;
  serviceProviderId: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
};

export type CreateEventOffering = {
  baseDuration: Scalars['Int']['input'];
  basePrice: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  isPublished: Scalars['Boolean']['input'];
  maxBookings: Scalars['Int']['input'];
  serviceOfferingUids: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: EventOfferingType;
};

export type CreateFileInput = {
  externalUid?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  uploadedFile: UploadedFileInput;
};

export type CreateLocationInput = {
  extendedAddress?: InputMaybe<Scalars['String']['input']>;
  externalUid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  type: LocationType;
};

export type CreateLocationPolicyInput = {
  externalUid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  policyType: LocationPolicyType;
  value: Scalars['String']['input'];
  valueType: LocationPolicyValueType;
};

export type CreateLocationResponse = {
  __typename?: 'CreateLocationResponse';
  location: Location;
};

export type CreateLocationSubscriptionInput = {
  locationUid: Scalars['String']['input'];
};

export type CreateLocationSubscriptionRequestInput = {
  locationSubscription: CreateLocationSubscriptionInput;
};

export type CreateLocationSubscriptionRequestsResponse = {
  __typename?: 'CreateLocationSubscriptionRequestsResponse';
  internalUids: Array<Scalars['String']['output']>;
};

export type CreateLocationsResponse = {
  __typename?: 'CreateLocationsResponse';
  internalUids: Array<Scalars['String']['output']>;
};

export type CreatePaymentInput = {
  amountMoney: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
};

export type CreatePaymentResponse = {
  __typename?: 'CreatePaymentResponse';
  paymentId: Scalars['String']['output'];
};

export type CreateRecurringAppointmentInput = {
  appointment: CreateAppointmentInput;
  recurrenceRule: Scalars['String']['input'];
};

export type CreateServiceAreaInput = {
  description: Scalars['String']['input'];
  externalUid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nonce?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<ServiceAreaSize>;
};

export type CreateServiceOffering = {
  allowTip: Scalars['Boolean']['input'];
  basePrice: Scalars['Int']['input'];
  baseTime: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isHidden: Scalars['Boolean']['input'];
  maxConcurrentBookings: Scalars['Int']['input'];
  postServiceNote: Scalars['String']['input'];
  shortDesc?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: ServiceOfferingType;
};

export type CreateServiceOfferingCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  serviceOfferingUids: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateServiceOfferingInput = {
  nonce?: InputMaybe<Scalars['String']['input']>;
  serviceOffering: CreateServiceOffering;
};

export type CreateSiblingBookingDiscountRuleInput = {
  discountType: DiscountType;
  discountValue: Scalars['Int']['input'];
  isDisabled: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  triggerCondition: SiblingBookingTriggerConditionInput;
};

export type CreateSurveyResponseInput = {
  nonce?: InputMaybe<Scalars['String']['input']>;
  ownerRef: V1Beta3_SingleReferenceInput;
  surveyOptionRef: V1Beta3_SingleReferenceInput;
};

export type CreateTimeDurationBookedAtLocationDiscountRuleInput = {
  discountType: DiscountType;
  discountValue: Scalars['Int']['input'];
  isDisabled: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  triggerCondition: TimeDurationBookedAtLocationTriggerConditionInput;
};

export type CreatedEagerBooking = {
  __typename?: 'CreatedEagerBooking';
  bookingUid: Scalars['String']['output'];
  eagerBookingUid: Scalars['String']['output'];
};

export type CreatedServiceArea = {
  __typename?: 'CreatedServiceArea';
  nonce?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
};

export type CustomLineItem = {
  __typename?: 'CustomLineItem';
  bookingId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  durationMinutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  taxRateToggle?: Maybe<TaxRateToggle>;
};

export type CustomLineItemInput = {
  bookingId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  durationMinutes: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
};

export type CustomTaxRateLineItem = {
  __typename?: 'CustomTaxRateLineItem';
  microPercent: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  bookings: Array<Booking>;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  profiles: Array<CustomerProfile>;
  reminders: ServiceProviderReminderPage;
  user: User;
};


export type CustomerBookingsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerRemindersArgs = {
  maxDateTime: Scalars['Int']['input'];
  minDateTime: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerInput = {
  __typename?: 'CustomerInput';
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  options: Array<CustomerInputOption>;
  ownerUid: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: CustomerInputType;
  uid: Scalars['String']['output'];
  unitPrice?: Maybe<Scalars['Int']['output']>;
};

export type CustomerInputDuration = {
  __typename?: 'CustomerInputDuration';
  customerInputUID: Scalars['String']['output'];
  optionDurations: Array<Maybe<CustomerInputOptionDuration>>;
};

export type CustomerInputDurationInput = {
  customerInputUID: Scalars['String']['input'];
  optionDurations: Array<InputMaybe<CustomerInputOptionDurationInput>>;
};

export type CustomerInputGroup = {
  __typename?: 'CustomerInputGroup';
  dependencies: Array<DependencyTreeLevelNode>;
  index?: Maybe<Scalars['Int']['output']>;
  ownerUid: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type CustomerInputGroupInput = {
  dependencies: Array<DependencyTreeLevelNodeInput>;
  index?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type CustomerInputGroupSelection = {
  __typename?: 'CustomerInputGroupSelection';
  customerInputUids: Array<Scalars['String']['output']>;
  customerInputs: Array<CustomerInput>;
  level: Scalars['Int']['output'];
  optionValues: Array<Scalars['String']['output']>;
  selectedOptions: Array<Array<CustomerInputOption>>;
};

export type CustomerInputGroupSelections = {
  __typename?: 'CustomerInputGroupSelections';
  selections: Array<CustomerInputGroupSelection>;
};

export type CustomerInputGroupSelectionsInput = {
  customerInputUids: Array<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  optionValues: Array<Scalars['String']['input']>;
};

export type CustomerInputGroupSelectionsV2 = {
  __typename?: 'CustomerInputGroupSelectionsV2';
  customerInputUids: Array<Scalars['String']['output']>;
  customerInputs: Array<CustomerInput>;
  level: Scalars['Int']['output'];
  optionValues: Array<Scalars['String']['output']>;
  selectedOptions: Array<Array<CustomerInputOption>>;
};

export type CustomerInputInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<CustomerInputOptionInput>>;
  required: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  type: CustomerInputType;
  unitPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerInputOption = {
  __typename?: 'CustomerInputOption';
  duration: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  uid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomerInputOptionDuration = {
  __typename?: 'CustomerInputOptionDuration';
  customerInputOptionUID: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
};

export type CustomerInputOptionDurationInput = {
  customerInputOptionUID: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
};

export type CustomerInputOptionInput = {
  duration: Scalars['Int']['input'];
  nonce?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomerInputPriceBreakdown = {
  __typename?: 'CustomerInputPriceBreakdown';
  customerInputUid: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  selectedOptions: Array<DetailedPrice>;
};

export type CustomerInputSelection = {
  __typename?: 'CustomerInputSelection';
  customerInput: CustomerInput;
  customerInputUid: Scalars['String']['output'];
  optionValue: Scalars['String']['output'];
  selectedOptions: Array<CustomerInputOption>;
};

export type CustomerInputSelectionInput = {
  customerInputUid: Scalars['String']['input'];
  optionValue: Scalars['String']['input'];
};

export enum CustomerInputType {
  Checkbox = 'CHECKBOX',
  Number = 'NUMBER',
  Radio = 'RADIO',
  Select = 'SELECT',
  Text = 'TEXT'
}

export type CustomerInvite = {
  __typename?: 'CustomerInvite';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  serviceProviderID: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CustomerInviteInput = {
  customerID?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expires?: InputMaybe<Scalars['Int']['input']>;
  fullName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerProfile = {
  __typename?: 'CustomerProfile';
  customerID: Scalars['String']['output'];
  fieldValues: Array<CustomerProfileFieldValue>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  notes: Array<CustomerProfileNote>;
};

export type CustomerProfileField = {
  __typename?: 'CustomerProfileField';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  options: Array<CustomerProfileFieldOption>;
  serviceProviderId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: CustomerProfileFieldType;
};

export type CustomerProfileFieldInput = {
  description: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  options: Array<CustomerProfileFieldOptionInput>;
  title: Scalars['String']['input'];
  type: CustomerProfileFieldType;
};

export type CustomerProfileFieldOption = {
  __typename?: 'CustomerProfileFieldOption';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomerProfileFieldOptionInput = {
  value: Scalars['String']['input'];
};

export enum CustomerProfileFieldType {
  CustomerProfileFieldTypeBoolean = 'CustomerProfileFieldType_BOOLEAN',
  CustomerProfileFieldTypeNumber = 'CustomerProfileFieldType_NUMBER',
  CustomerProfileFieldTypeSelect = 'CustomerProfileFieldType_SELECT',
  CustomerProfileFieldTypeText = 'CustomerProfileFieldType_TEXT',
  CustomerProfileFieldTypeUnspecified = 'CustomerProfileFieldType_UNSPECIFIED'
}

export type CustomerProfileFieldValue = {
  __typename?: 'CustomerProfileFieldValue';
  customerProfileFieldID: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomerProfileFieldValueInput = {
  customerProfileFieldID: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CustomerProfileInput = {
  customerID: Scalars['String']['input'];
  fieldValues?: InputMaybe<Array<CustomerProfileFieldValueInput>>;
  label: Scalars['String']['input'];
  notes: Array<CustomerProfileNoteInput>;
};

export type CustomerProfileNote = {
  __typename?: 'CustomerProfileNote';
  createdAt: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CustomerProfileNoteInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type DateAvailability = {
  __typename?: 'DateAvailability';
  availability: Availability;
  date: Scalars['Int']['output'];
  ownerUid: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type DateAvailabilityInput = {
  availability: AvailabilityInput;
  date: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};

export type DateAvailabilityQuery = {
  pagination?: InputMaybe<V1Beta3_PaginationInput>;
  referenceMatches?: InputMaybe<Array<V1Beta3_ReferenceMatch>>;
  timeUtcSecondsBounds: BoundsInput;
};

export type DateAvailabilityQueryResult = {
  __typename?: 'DateAvailabilityQueryResult';
  dateAvailability: Array<DateAvailability>;
  hasMoreResults: Scalars['Boolean']['output'];
};

export type DayOfWeekAvailability = {
  __typename?: 'DayOfWeekAvailability';
  availability: Availability;
  dayOfWeek: Scalars['Int']['output'];
  ownerUid: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type DayOfWeekAvailabilityInput = {
  availability: AvailabilityInput;
  dayOfWeek: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};

export type DayOfWeekAvailabilityQuery = {
  referenceMatches?: InputMaybe<Array<V1Beta3_ReferenceMatch>>;
};

export type DayOfWeekAvailabilityQueryResult = {
  __typename?: 'DayOfWeekAvailabilityQueryResult';
  dayOfWeekAvailability: Array<DayOfWeekAvailability>;
};

export enum DeniedStatus {
  Denied = 'DENIED',
  DeniedOrNotDenied = 'DENIED_OR_NOT_DENIED',
  NotDenied = 'NOT_DENIED'
}

export type DependencyTreeLevelNode = {
  __typename?: 'DependencyTreeLevelNode';
  dependencyCustomerInputUid: Scalars['String']['output'];
  dependentTriggerValues: Array<DependentInputTriggerValues>;
  level: Scalars['Int']['output'];
};

export type DependencyTreeLevelNodeInput = {
  dependencyCustomerInputUid: Scalars['String']['input'];
  dependentTriggerValues: Array<DependentInputTriggerValuesInput>;
  level: Scalars['Int']['input'];
};

export type DependentInputTriggerValues = {
  __typename?: 'DependentInputTriggerValues';
  dependentCustomerInputUid: Scalars['String']['output'];
  triggerValues: Array<Scalars['String']['output']>;
};

export type DependentInputTriggerValuesInput = {
  dependentCustomerInputUid: Scalars['String']['input'];
  triggerValues: Array<Scalars['String']['input']>;
};

export type DetailedPrice = {
  __typename?: 'DetailedPrice';
  basePrice: Scalars['Int']['output'];
  discountedPrice: Scalars['Int']['output'];
  discountsApplied: Array<DiscountApplied>;
  displayName: Scalars['String']['output'];
  taxAmount: TaxAmount;
  taxRate: TaxRate;
};

export type DeviceCode = {
  __typename?: 'DeviceCode';
  code: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pairBy?: Maybe<Scalars['String']['output']>;
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Discount = {
  __typename?: 'Discount';
  booking?: Maybe<Booking>;
  change: DiscountValueChange;
  isStackable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: DiscountType;
  uid: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type DiscountApplied = {
  __typename?: 'DiscountApplied';
  amountDiscounted: Scalars['Int']['output'];
  discount: Discount;
  displayName: Scalars['String']['output'];
};

export type DiscountQuery = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  references?: InputMaybe<Array<V1Beta1_ReferenceInput>>;
};

export type DiscountQueryResult = {
  __typename?: 'DiscountQueryResult';
  discounts: Array<Discount>;
  hasMoreResults: Scalars['Boolean']['output'];
};

export type DiscountRule = {
  __typename?: 'DiscountRule';
  discountType: DiscountType;
  discountValue: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  serviceProviderId: Scalars['String']['output'];
  triggerCondition: DiscountRuleTriggerCondition;
};

export type DiscountRuleSearchResult = {
  __typename?: 'DiscountRuleSearchResult';
  discountRules: Array<DiscountRule>;
  hasMoreResults: Scalars['Boolean']['output'];
};

export type DiscountRuleTriggerCondition = {
  __typename?: 'DiscountRuleTriggerCondition';
  siblingBookingTriggerCondition?: Maybe<SiblingBookingTriggerCondition>;
  timeDurationBookedAtLocationTriggerCondition?: Maybe<TimeDurationBookedAtLocationTriggerCondition>;
};

export type DiscountRuleWithProgress = {
  __typename?: 'DiscountRuleWithProgress';
  discountRule: DiscountRuleWithProgressDiscountRule;
  progressPercent: Scalars['Float']['output'];
};

export type DiscountRuleWithProgressDiscountRule = {
  __typename?: 'DiscountRuleWithProgressDiscountRule';
  discountType: DiscountType;
  discountValue: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  requireBookingCount: Scalars['Int']['output'];
  requireDurationBookedSeconds: Scalars['Int']['output'];
};

export enum DiscountType {
  CappedPercent = 'CAPPED_PERCENT',
  Flat = 'FLAT',
  Percent = 'PERCENT'
}

export type DiscountValueChange = {
  __typename?: 'DiscountValueChange';
  isCoveredByLocation: Scalars['Boolean']['output'];
  isCoveredByPlatform: Scalars['Boolean']['output'];
  type: DiscountValueChangeType;
};

export enum DiscountValueChangeType {
  Covered = 'COVERED',
  EndToEnd = 'END_TO_END'
}

export type Dropoff = {
  __typename?: 'Dropoff';
  booking: Booking;
  customerUid: Scalars['String']['output'];
  dropoffDateTime: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  serviceProviderUid: Scalars['String']['output'];
  status: DropoffStatus;
};

export type DropoffQuery = {
  dropoffDateTimeMax?: InputMaybe<Scalars['Int']['input']>;
  dropoffDateTimeMin?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<DropoffStatus>;
};

export type DropoffSearchResult = {
  __typename?: 'DropoffSearchResult';
  dropoffs: Array<Dropoff>;
  hasMoreResults: Scalars['Boolean']['output'];
};

export enum DropoffStatus {
  DropOffStatusCompleted = 'DROP_OFF_STATUS_COMPLETED',
  DropOffStatusPending = 'DROP_OFF_STATUS_PENDING',
  DropOffStatusUnspecified = 'DROP_OFF_STATUS_UNSPECIFIED'
}

export type EagerBooking = {
  __typename?: 'EagerBooking';
  appointmentRequest: AppointmentRequest;
  booking: BookingSelections;
  externalUid: Scalars['String']['output'];
  ownerUid: Scalars['String']['output'];
  quotedDuration: Scalars['Int']['output'];
  uid: Scalars['String']['output'];
  uidForBooking: Scalars['String']['output'];
};

export type EagerBookingQuery = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  references: Array<V1Beta3_ReferenceMatch>;
  timeUtcSecondsBounds?: InputMaybe<BoundsInput>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  htmlBody: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mjmlJson: Scalars['String']['output'];
  serviceProviderId: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  templateType: TemplateTopicType;
};

export type EmailTemplateInput = {
  htmlBody: Scalars['String']['input'];
  mjmlJson: Scalars['String']['input'];
  serviceProviderId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  templateType: TemplateTopicType;
};

export type EmployeeRegistrationInfo = {
  businessLocationUid: Scalars['String']['input'];
  inviteCode: Scalars['String']['input'];
};

export type EventCart = {
  __typename?: 'EventCart';
  enabledServiceOfferingUids: Array<Scalars['String']['output']>;
  enabledServiceOfferings: Array<ServiceOffering>;
  eventEndDateTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isCoveredByBusiness?: Maybe<Scalars['Boolean']['output']>;
  locationUid: Scalars['String']['output'];
  note: Scalars['String']['output'];
  serviceAreaUid?: Maybe<Scalars['String']['output']>;
  serviceProvider: ServiceProvider;
  serviceProviderId: Scalars['String']['output'];
  startDateTime: Scalars['Int']['output'];
};

export type EventOffering = {
  __typename?: 'EventOffering';
  attendanceServiceOffering: ServiceOffering;
  attendanceServiceOfferingUid: Scalars['String']['output'];
  baseDuration: Scalars['Int']['output'];
  basePrice: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  isPublished: Scalars['Boolean']['output'];
  maxBookings: Scalars['Int']['output'];
  serviceOfferingUids: Array<Scalars['String']['output']>;
  serviceProviderId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: EventOfferingType;
};

export type EventOfferingQuery = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  serviceProviderId: Scalars['String']['input'];
};

export type EventOfferingQueryResult = {
  __typename?: 'EventOfferingQueryResult';
  eventOfferings: Array<EventOffering>;
  hasMoreResults: Scalars['Boolean']['output'];
};

export enum EventOfferingType {
  EventOfferingTypeGroup = 'EventOfferingType_GROUP',
  EventOfferingTypeOneOnOne = 'EventOfferingType_ONE_ON_ONE',
  EventOfferingTypeUnspecified = 'EventOfferingType_UNSPECIFIED'
}

export type ExpectedEarnings = {
  __typename?: 'ExpectedEarnings';
  externalUid: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type File = {
  __typename?: 'File';
  externalUid?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  uploadedFile: UploadedFile;
};

export type GeoBounds = {
  __typename?: 'GeoBounds';
  max: GeoPoint;
  min: GeoPoint;
};

export type GeoPoint = {
  __typename?: 'GeoPoint';
  geoHash: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type GetDeviceCodesResponse = {
  __typename?: 'GetDeviceCodesResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  deviceCodes: Array<DeviceCode>;
};

export type GetIsAvailableResult = {
  __typename?: 'GetIsAvailableResult';
  isAvailable: Scalars['Boolean']['output'];
  ownerUid: Scalars['String']['output'];
};

export type Identity = {
  __typename?: 'Identity';
  emailAddress: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type InsuranceClaimableServiceProvider = {
  __typename?: 'InsuranceClaimableServiceProvider';
  licenseId?: Maybe<Scalars['String']['output']>;
  ownerUid: Scalars['String']['output'];
  titlePrefix?: Maybe<Scalars['String']['output']>;
  titleSuffix?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type InsuranceClaimableServiceProviderInput = {
  licenseId?: InputMaybe<Scalars['String']['input']>;
  titlePrefix?: InputMaybe<Scalars['String']['input']>;
  titleSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type LegacyServiceProvider = {
  __typename?: 'LegacyServiceProvider';
  averageRating: Scalars['Float']['output'];
  dateAvailability: Array<DateAvailability>;
  dayOfWeekAvailability: Array<DayOfWeekAvailability>;
  discountRules: Array<DiscountRule>;
  displayName: Scalars['String']['output'];
  formattedAddress: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  insuranceInformation?: Maybe<InsuranceClaimableServiceProvider>;
  isApproved: Scalars['Boolean']['output'];
  location: Location;
  locationUid: Scalars['String']['output'];
  owner: User;
  ownerUid: Scalars['String']['output'];
  preferences: Array<ServiceProviderPreference>;
  profile?: Maybe<Profile>;
  reviewCount: Scalars['Int']['output'];
  reviews: Array<Review>;
  serviceOfferingCategories: Array<ServiceOfferingCategory>;
  serviceOfferings: Array<ServiceOffering>;
  serviceType: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  appointments: Array<Appointment>;
  business?: Maybe<Business>;
  discoverableBounds: GeoBounds;
  extendedAddress?: Maybe<Scalars['String']['output']>;
  externalUid?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  formattedAddress: Scalars['String']['output'];
  geohash: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  owner: User;
  ownerUid: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  serviceAreas: Array<ServiceArea>;
  slug: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  subscriptions: Array<LocationSubscription>;
  subscriptionsCount: Scalars['Int']['output'];
  type: LocationType;
  uid: Scalars['String']['output'];
};


export type LocationAppointmentsArgs = {
  query?: InputMaybe<AppointmentQuery>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
};


export type LocationSubscriptionsArgs = {
  query?: InputMaybe<LocationSubscriptionQuery>;
};


export type LocationSubscriptionsCountArgs = {
  query?: InputMaybe<LocationSubscriptionQuery>;
};

export type LocationPolicy = {
  __typename?: 'LocationPolicy';
  externalUid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  policyType: LocationPolicyType;
  uid: Scalars['String']['output'];
  value: Scalars['String']['output'];
  valueType: LocationPolicyValueType;
};

export type LocationPolicyQuery = {
  pagination?: InputMaybe<V1Beta3_PaginationInput>;
  references?: InputMaybe<Array<V1Beta3_ReferenceMatch>>;
  types?: InputMaybe<Array<LocationPolicyValueType>>;
};

export enum LocationPolicyType {
  SubscriberAppointmentAutomaticApproval = 'SUBSCRIBER_APPOINTMENT_AUTOMATIC_APPROVAL',
  SubscriptionAutomaticApproval = 'SUBSCRIPTION_AUTOMATIC_APPROVAL'
}

export enum LocationPolicyValueType {
  Boolean = 'BOOLEAN'
}

export type LocationQuery = {
  businessUids?: InputMaybe<Array<Scalars['String']['input']>>;
  discoverableFromLat?: InputMaybe<Scalars['Float']['input']>;
  discoverableFromLng?: InputMaybe<Scalars['Float']['input']>;
  ownerUids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  rangeKms?: InputMaybe<Scalars['Int']['input']>;
  references?: InputMaybe<Array<V1Beta1_ReferenceInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<LocationType>>;
};

export type LocationSubscription = {
  __typename?: 'LocationSubscription';
  location: Location;
  locationUid: Scalars['String']['output'];
  owner: User;
  ownerUid: Scalars['String']['output'];
};

export type LocationSubscriptionQuery = {
  createdAtMax?: InputMaybe<Scalars['Int']['input']>;
  createdAtMin?: InputMaybe<Scalars['Int']['input']>;
  excludeOwn?: InputMaybe<Scalars['Boolean']['input']>;
  excludeTemporary?: InputMaybe<Scalars['Boolean']['input']>;
  locationUids?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  referenceMatches?: InputMaybe<Array<V1Beta3_ReferenceMatch>>;
};

export type LocationSubscriptionRequest = {
  __typename?: 'LocationSubscriptionRequest';
  locationSubscription: LocationSubscription;
  status: LocationSubscriptionRequestStatus;
  uid: Scalars['String']['output'];
};

export type LocationSubscriptionRequestQuery = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  references?: InputMaybe<Array<V1Beta3_ReferenceMatch>>;
  status?: InputMaybe<LocationSubscriptionRequestStatus>;
};

export type LocationSubscriptionRequestQueryResult = {
  __typename?: 'LocationSubscriptionRequestQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  locationSubscriptionRequests: Array<LocationSubscriptionRequest>;
};

export enum LocationSubscriptionRequestStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export enum LocationType {
  Business = 'BUSINESS',
  Individual = 'INDIVIDUAL',
  IndividualIndeterminate = 'INDIVIDUAL_INDETERMINATE',
  IndividualWork = 'INDIVIDUAL_WORK',
  Partner = 'PARTNER',
  ServiceProvider = 'SERVICE_PROVIDER',
  ServiceProviderRetail = 'SERVICE_PROVIDER_RETAIL'
}

export type LocationsQueryResult = {
  __typename?: 'LocationsQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  locations: Array<Location>;
};

export type Merchant = {
  __typename?: 'Merchant';
  currency: Scalars['String']['output'];
  isApproved: Scalars['Boolean']['output'];
  moblFeePercent: Scalars['Int']['output'];
  ownerUid: Scalars['String']['output'];
  payoutMethod?: Maybe<Scalars['String']['output']>;
  serviceType: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAppointment: Scalars['Boolean']['output'];
  acceptCustomerInvite: Scalars['Boolean']['output'];
  addBookingAttributes: Scalars['Boolean']['output'];
  archiveServiceProviderReminder: Scalars['Boolean']['output'];
  cancelAppointment: Scalars['Boolean']['output'];
  cancelAppointmentById: Scalars['Boolean']['output'];
  cancelBooking: Scalars['Boolean']['output'];
  cancelUserSubscription: Scalars['Boolean']['output'];
  completeAppointment: Scalars['Boolean']['output'];
  completeBooking: CompleteBookingResponse;
  confirmBooking: Scalars['Boolean']['output'];
  connectStripeAccount: Scalars['Boolean']['output'];
  createAppointmentCart: Array<Scalars['String']['output']>;
  createAppointmentChangeProposal: Scalars['String']['output'];
  createAppointmentForCustomer: Scalars['String']['output'];
  createAppointmentFromEventCart: CreateAppointmentFromEventCartResponse;
  createAppointmentPreferences: Array<Scalars['String']['output']>;
  createAppointmentRequestAndEagerBookingFromCarts: CreateAppointmentRequestAndEagerBookingFromCartsResponse;
  createAppointmentRequests: Array<CreateAppointmentRequestResponse>;
  createAppointments: Array<UidNonce>;
  createBookingCart: Array<Scalars['String']['output']>;
  createBookingDurationOverride: Scalars['String']['output'];
  createBookingForAppointmentFromCart: CreateBookingFromCartResponse;
  createBookingForCustomer: Scalars['String']['output'];
  createBookingFromCart: CreateBookingFromCartResponse;
  createBookingNote: Scalars['String']['output'];
  createBookings: Array<UidNonce>;
  createChatRooms: Array<Scalars['String']['output']>;
  createCustomLineItem: Scalars['ID']['output'];
  createCustomTaxRateLineItems: Scalars['Boolean']['output'];
  createCustomer: Scalars['String']['output'];
  createCustomerInputGroup: Scalars['Boolean']['output'];
  createCustomerInputs: CreateCustomerInputsResponse;
  createCustomerProfile: Scalars['String']['output'];
  createCustomerProfileField: Scalars['String']['output'];
  createCustomerProfileForServiceProvider: Scalars['String']['output'];
  createDropoffs: Scalars['Boolean']['output'];
  createEagerBookings: Array<CreatedEagerBooking>;
  createEventCart: Scalars['String']['output'];
  createEventOffering: Scalars['String']['output'];
  createFiles: Array<Scalars['String']['output']>;
  createGoogleCalendarAccess: Scalars['Boolean']['output'];
  createInsuranceClaimableServiceProvider: Scalars['Boolean']['output'];
  createLocation: CreateLocationResponse;
  createLocationForCustomer: Scalars['String']['output'];
  createLocationPolicies: Scalars['Boolean']['output'];
  createLocationSubscriptionRequests: CreateLocationSubscriptionRequestsResponse;
  createLocationSubscriptions: Scalars['Boolean']['output'];
  createLocations: CreateLocationsResponse;
  createNoCalendarAccess: Scalars['Boolean']['output'];
  createPayment: CreatePaymentResponse;
  createPeazyPluginInstallation: Scalars['String']['output'];
  createPeazyPluginListing: Scalars['String']['output'];
  createPeazyPluginVersion: Scalars['String']['output'];
  createProfile: Scalars['Boolean']['output'];
  createReceiptConfig: Scalars['String']['output'];
  createRecurringAppointments: Scalars['Boolean']['output'];
  createRedeemableRedemptions: Scalars['Boolean']['output'];
  createServiceAreas: Array<CreatedServiceArea>;
  createServiceOffering: Array<UidNonce>;
  createServiceOfferingCategories: Array<Scalars['String']['output']>;
  createServiceProvider: Scalars['String']['output'];
  createServiceProviderBreakCalendarEvent: Scalars['Boolean']['output'];
  createServiceProviderReminder: Scalars['String']['output'];
  createSiblingBookingDiscountRule: Scalars['Boolean']['output'];
  createSquareCardForCustomer: SquareCard;
  createSurveyResponses: Array<UidNonce>;
  createTerminalCheckout: Scalars['String']['output'];
  createTimeDurationBookedAtLocationDiscountRule: Scalars['Boolean']['output'];
  declineAppointment: Scalars['Boolean']['output'];
  deleteAppointmentCarts: Scalars['Boolean']['output'];
  deleteAppointmentChangeProposal: Scalars['Boolean']['output'];
  deleteAppointmentPreferences: Scalars['Boolean']['output'];
  deleteAppointmentRequests: Scalars['Boolean']['output'];
  deleteBookingCarts: Scalars['Boolean']['output'];
  deleteBookingDurationOverride: Scalars['Boolean']['output'];
  deleteBookingNote: Scalars['Boolean']['output'];
  deleteBookings: Scalars['Boolean']['output'];
  deleteCalendarAccess: Scalars['Boolean']['output'];
  deleteChatMessages: Scalars['Boolean']['output'];
  deleteChatRooms: Scalars['Boolean']['output'];
  deleteCustomLineItem: Scalars['Boolean']['output'];
  deleteCustomTaxRateLineItems: Scalars['Boolean']['output'];
  deleteCustomerInput: Scalars['Boolean']['output'];
  deleteCustomerInputGroup: Scalars['Boolean']['output'];
  deleteCustomerProfileField: Scalars['Boolean']['output'];
  deleteCustomerProfiles: Scalars['Boolean']['output'];
  deleteEagerBookings: Scalars['Boolean']['output'];
  deleteEmailTemplate: Scalars['Boolean']['output'];
  deleteEventOfferings: Scalars['Boolean']['output'];
  deleteFiles: Scalars['Boolean']['output'];
  deleteInsuranceClaimableServiceProviderByInternalUID: Scalars['Boolean']['output'];
  deleteLocation: Scalars['Boolean']['output'];
  deleteLocationSubscription: Scalars['Boolean']['output'];
  deleteLocationSubscriptionRequest: Scalars['Boolean']['output'];
  deletePeazyPluginInstallation: Scalars['Boolean']['output'];
  deletePeazyPluginListing: Scalars['Boolean']['output'];
  deleteReceiptConfig: Scalars['Boolean']['output'];
  deleteRecurringAppointment: Scalars['Boolean']['output'];
  deleteReview: Scalars['Boolean']['output'];
  deleteServiceAreas: Scalars['Boolean']['output'];
  deleteServiceOfferingCategories: Scalars['Boolean']['output'];
  deleteServiceOfferings: Scalars['Boolean']['output'];
  deleteServiceProviderReminder: Scalars['Boolean']['output'];
  deleteSurveyResponses: Scalars['Boolean']['output'];
  detachPaymentMethod: Scalars['Boolean']['output'];
  detachPaymentMethodForCustomer: Scalars['Boolean']['output'];
  disableSquareCardForCustomer: Scalars['Boolean']['output'];
  exchangeGoogleCalendarAccessCodeAndStoreToken: Array<Scalars['String']['output']>;
  exchangeSquareOAuthCode: Scalars['Boolean']['output'];
  getGoogleCalendarAccessAuthUrl: Scalars['String']['output'];
  getOrInitializeAppointmentCart: AppointmentCart;
  getOrInitializeBookingCart: BookingCart;
  getOrInitializeEventCart: EventCart;
  getResetPasswordLink: Scalars['String']['output'];
  getSetupIntentSecretForCustomer: Scalars['String']['output'];
  importSquareCustomer: Scalars['String']['output'];
  linkStripeSourceForCustomer: Scalars['Boolean']['output'];
  linkStripeSourceToIdentity: Scalars['Boolean']['output'];
  migrateAnonymousIdentity: Scalars['Boolean']['output'];
  noShowBooking: Scalars['Int']['output'];
  recordAtic: Scalars['Boolean']['output'];
  refreshSession: Scalars['Boolean']['output'];
  register: Scalars['Boolean']['output'];
  registerBookingIdForCustomer: Scalars['String']['output'];
  registerBusiness: Scalars['String']['output'];
  removeBookingAttributes: Scalars['Boolean']['output'];
  setBookingsIsInProgress: Scalars['Boolean']['output'];
  setDateAvailability: Scalars['Boolean']['output'];
  setDayOfWeekAvailability: Scalars['Boolean']['output'];
  setDefaultPaymentMethod: Scalars['Boolean']['output'];
  setDefaultPaymentMethodForCustomer: Scalars['Boolean']['output'];
  setEmailTemplate: Scalars['Boolean']['output'];
  setReviews: Scalars['Boolean']['output'];
  setRole: Scalars['Boolean']['output'];
  setServiceOfferingCustomerInputGroups: Scalars['Boolean']['output'];
  setServiceOfferingCustomerInputs: Scalars['Boolean']['output'];
  setServiceProviderPreference: Scalars['Boolean']['output'];
  setUserCountry: Scalars['Boolean']['output'];
  signin?: Maybe<SigninResponse>;
  signinPartner: Scalars['Boolean']['output'];
  signout: Scalars['Boolean']['output'];
  subscribeUserToProduct: SubscriptionResult;
  syncServiceProviderGoogleCalendar: Scalars['Boolean']['output'];
  updateAppointmentCart: Scalars['Boolean']['output'];
  updateAppointmentCartServiceAreaUid: Scalars['Boolean']['output'];
  updateAppointmentCartStartDateTime: Scalars['Boolean']['output'];
  updateAppointmentChangeProposal: Scalars['Boolean']['output'];
  updateAppointmentPreferences: Scalars['Boolean']['output'];
  updateAppointmentRequests: Scalars['Boolean']['output'];
  updateAppointmentServiceAreaUid: Scalars['Boolean']['output'];
  updateAppointmentStartDateTime: Scalars['Boolean']['output'];
  updateAppointments: Scalars['Boolean']['output'];
  updateBookingAttributes: Scalars['Boolean']['output'];
  updateBookingCart: Scalars['Boolean']['output'];
  updateBookingCartCustomerInputSelections: Scalars['Boolean']['output'];
  updateBookingCartCustomerProfileId: Scalars['Boolean']['output'];
  updateBookingCartRedeemableSecret: Scalars['Boolean']['output'];
  updateBookingCartServiceOfferingUid: Scalars['Boolean']['output'];
  updateBookingCartStartDateTime: Scalars['Boolean']['output'];
  updateBookingCartTipPercent: Scalars['Boolean']['output'];
  updateBookingCustomerInputSelections: Scalars['Boolean']['output'];
  updateBookingCustomerProfileId: Scalars['Boolean']['output'];
  updateBookingDurationOverride: Scalars['Boolean']['output'];
  updateBookingNote: Scalars['Boolean']['output'];
  updateBookingServiceOffering: Scalars['Boolean']['output'];
  updateBookingStartDateTime: Scalars['Boolean']['output'];
  updateBookings: Scalars['Boolean']['output'];
  updateBusinessName: Scalars['Boolean']['output'];
  updateCustomLineItem: Scalars['Boolean']['output'];
  updateCustomTaxRateLineItems: Scalars['Boolean']['output'];
  updateCustomerInput: UpdateCustomerInputResponse;
  updateCustomerInputGroup: Scalars['Boolean']['output'];
  updateCustomerProfile: Scalars['Boolean']['output'];
  updateCustomerProfileField: Scalars['Boolean']['output'];
  updateCustomerProfileForServiceProvider: Scalars['Boolean']['output'];
  updateCustomerProfileNotes: Scalars['Boolean']['output'];
  updateDropoffDateTime: Scalars['Boolean']['output'];
  updateEagerBookings: Scalars['Boolean']['output'];
  updateEventCart: Scalars['Boolean']['output'];
  updateEventOffering: Scalars['Boolean']['output'];
  updateFiles: Scalars['Boolean']['output'];
  updateInsuranceClaimableServiceProviderByInternalUID: Scalars['Boolean']['output'];
  updateLocationPolicies: Scalars['Boolean']['output'];
  updateLocationSubscriptionRequests: Scalars['Boolean']['output'];
  updateLocations: Scalars['Boolean']['output'];
  updatePeazyPluginInstallation: Scalars['Boolean']['output'];
  updatePeazyPluginListing: Scalars['Boolean']['output'];
  updateProfileByInternalUID: Scalars['Boolean']['output'];
  updateReceiptConfig: Scalars['Boolean']['output'];
  updateRecurringAppointments: Scalars['Boolean']['output'];
  updateServiceAreas: Array<Maybe<Scalars['String']['output']>>;
  updateServiceOffering: Scalars['Boolean']['output'];
  updateServiceOfferingCategories: Scalars['Boolean']['output'];
  updateServiceProviderReminder: Scalars['Boolean']['output'];
  updateSiblingBookingDiscountRule: Scalars['Boolean']['output'];
  updateSurveyResponses: Scalars['Boolean']['output'];
  updateTaxRateToggles: Scalars['Boolean']['output'];
  updateTimeDurationBookedAtLocationDiscountRule: Scalars['Boolean']['output'];
  updateUser: Scalars['Boolean']['output'];
  updateUserFullName: Scalars['Boolean']['output'];
  updateUserPhoneNumber: Scalars['Boolean']['output'];
  uploadFiles: Array<UploadedFile>;
  userAcceptMarketing: Scalars['Boolean']['output'];
};


export type MutationAcceptAppointmentArgs = {
  appointmentUid: Scalars['String']['input'];
};


export type MutationAcceptCustomerInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddBookingAttributesArgs = {
  bookingAttributes: Array<BookingAttributeInput>;
};


export type MutationArchiveServiceProviderReminderArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelAppointmentArgs = {
  appointmentUid: Scalars['String']['input'];
  cancelReason: Scalars['String']['input'];
};


export type MutationCancelAppointmentByIdArgs = {
  appointmentId: Scalars['String']['input'];
  cancelReason: Scalars['String']['input'];
};


export type MutationCancelBookingArgs = {
  bookingUid: Scalars['String']['input'];
  cancelReason: Scalars['String']['input'];
};


export type MutationCancelUserSubscriptionArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationCompleteAppointmentArgs = {
  appointmentId: Scalars['String']['input'];
};


export type MutationCompleteBookingArgs = {
  paymentGateway: PaymentGatewayType;
  uid: Scalars['String']['input'];
};


export type MutationConfirmBookingArgs = {
  bookingId: Scalars['String']['input'];
};


export type MutationConnectStripeAccountArgs = {
  code: Scalars['String']['input'];
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAppointmentCartArgs = {
  data: CreateAppointmentCartInput;
};


export type MutationCreateAppointmentChangeProposalArgs = {
  input: AppointmentChangeProposalInput;
};


export type MutationCreateAppointmentForCustomerArgs = {
  customerId: Scalars['String']['input'];
  data: CreateAppointmentInput;
};


export type MutationCreateAppointmentFromEventCartArgs = {
  eventCartId: Scalars['String']['input'];
  eventOfferingId: Scalars['String']['input'];
};


export type MutationCreateAppointmentPreferencesArgs = {
  data: Array<CreateAppointmentPreferenceInput>;
};


export type MutationCreateAppointmentRequestAndEagerBookingFromCartsArgs = {
  appointmentCartUid: Scalars['String']['input'];
  bookingCartUid: Scalars['String']['input'];
  locationUid: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationCreateAppointmentRequestsArgs = {
  data: Array<CreateAppointmentRequestInput>;
};


export type MutationCreateAppointmentsArgs = {
  data: Array<CreateAppointmentInput>;
};


export type MutationCreateBookingCartArgs = {
  data: CreateBookingCartInput;
};


export type MutationCreateBookingDurationOverrideArgs = {
  input: BookingDurationOverrideInput;
};


export type MutationCreateBookingForAppointmentFromCartArgs = {
  appointmentId: Scalars['String']['input'];
  bookingCartUid: Scalars['String']['input'];
};


export type MutationCreateBookingForCustomerArgs = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  data: CreateBookingInput;
};


export type MutationCreateBookingFromCartArgs = {
  bookingCartUid: Scalars['String']['input'];
};


export type MutationCreateBookingNoteArgs = {
  input: BookingNoteInput;
};


export type MutationCreateBookingsArgs = {
  data: Array<CreateBookingInput>;
};


export type MutationCreateChatRoomsArgs = {
  data: Array<CreateChatRoomInput>;
};


export type MutationCreateCustomLineItemArgs = {
  input: CustomLineItemInput;
};


export type MutationCreateCustomTaxRateLineItemsArgs = {
  customTaxRateLineItems: Array<CreateCustomTaxRateLineItemInput>;
};


export type MutationCreateCustomerArgs = {
  data: CreateCustomerInput;
};


export type MutationCreateCustomerInputGroupArgs = {
  data: CustomerInputGroupInput;
};


export type MutationCreateCustomerInputsArgs = {
  data: Array<CustomerInputInput>;
};


export type MutationCreateCustomerProfileArgs = {
  profile: CustomerProfileInput;
};


export type MutationCreateCustomerProfileFieldArgs = {
  field: CustomerProfileFieldInput;
};


export type MutationCreateCustomerProfileForServiceProviderArgs = {
  fieldValues: Array<CustomerProfileFieldValueInput>;
  serviceProviderId: Scalars['String']['input'];
};


export type MutationCreateDropoffsArgs = {
  data: Array<CreateDropoffInput>;
};


export type MutationCreateEagerBookingsArgs = {
  data: Array<CreateEagerBookingInput>;
};


export type MutationCreateEventCartArgs = {
  data: CreateEventCartInput;
};


export type MutationCreateEventOfferingArgs = {
  data: CreateEventOffering;
};


export type MutationCreateFilesArgs = {
  data: Array<CreateFileInput>;
};


export type MutationCreateGoogleCalendarAccessArgs = {
  code: Scalars['String']['input'];
};


export type MutationCreateInsuranceClaimableServiceProviderArgs = {
  data: InsuranceClaimableServiceProviderInput;
};


export type MutationCreateLocationArgs = {
  data: CreateLocationInput;
};


export type MutationCreateLocationForCustomerArgs = {
  customerId: Scalars['String']['input'];
  data: CreateLocationInput;
};


export type MutationCreateLocationPoliciesArgs = {
  data: Array<CreateLocationPolicyInput>;
};


export type MutationCreateLocationSubscriptionRequestsArgs = {
  data: Array<CreateLocationSubscriptionRequestInput>;
};


export type MutationCreateLocationSubscriptionsArgs = {
  data: Array<CreateLocationSubscriptionInput>;
};


export type MutationCreateLocationsArgs = {
  data: Array<CreateLocationInput>;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreatePeazyPluginInstallationArgs = {
  input: PeazyPluginInstallationInput;
};


export type MutationCreatePeazyPluginListingArgs = {
  input: PeazyPluginListingInput;
};


export type MutationCreatePeazyPluginVersionArgs = {
  input: PeazyPluginVersionInput;
};


export type MutationCreateProfileArgs = {
  profile: ProfileInput;
};


export type MutationCreateReceiptConfigArgs = {
  input: ReceiptConfigInput;
};


export type MutationCreateRecurringAppointmentsArgs = {
  data: Array<CreateRecurringAppointmentInput>;
};


export type MutationCreateRedeemableRedemptionsArgs = {
  data: Array<RedeemableRedemptionInput>;
};


export type MutationCreateServiceAreasArgs = {
  data: Array<CreateServiceAreaInput>;
};


export type MutationCreateServiceOfferingArgs = {
  data: CreateServiceOfferingInput;
};


export type MutationCreateServiceOfferingCategoriesArgs = {
  data: Array<CreateServiceOfferingCategoryInput>;
};


export type MutationCreateServiceProviderArgs = {
  businessName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  timezoneLocation: Scalars['String']['input'];
};


export type MutationCreateServiceProviderBreakCalendarEventArgs = {
  data: CalendarEventInput;
};


export type MutationCreateServiceProviderReminderArgs = {
  input: ServiceProviderReminderInput;
};


export type MutationCreateSiblingBookingDiscountRuleArgs = {
  data: CreateSiblingBookingDiscountRuleInput;
};


export type MutationCreateSquareCardForCustomerArgs = {
  customerId: Scalars['ID']['input'];
  sourceId: Scalars['String']['input'];
};


export type MutationCreateSurveyResponsesArgs = {
  data: Array<CreateSurveyResponseInput>;
};


export type MutationCreateTerminalCheckoutArgs = {
  bookingId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
};


export type MutationCreateTimeDurationBookedAtLocationDiscountRuleArgs = {
  data: CreateTimeDurationBookedAtLocationDiscountRuleInput;
};


export type MutationDeclineAppointmentArgs = {
  appointmentUid: Scalars['String']['input'];
  denialReason: Scalars['String']['input'];
};


export type MutationDeleteAppointmentCartsArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type MutationDeleteAppointmentChangeProposalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAppointmentPreferencesArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type MutationDeleteAppointmentRequestsArgs = {
  internalUids: Array<Scalars['String']['input']>;
};


export type MutationDeleteBookingCartsArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type MutationDeleteBookingDurationOverrideArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookingNoteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBookingsArgs = {
  cancelReason: Scalars['String']['input'];
  uids: Array<Scalars['String']['input']>;
};


export type MutationDeleteCalendarAccessArgs = {
  provider: CalendarProvider;
};


export type MutationDeleteChatMessagesArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type MutationDeleteChatRoomsArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type MutationDeleteCustomLineItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomTaxRateLineItemsArgs = {
  internalUids: Array<Scalars['String']['input']>;
};


export type MutationDeleteCustomerInputArgs = {
  customerInputUid: Scalars['String']['input'];
};


export type MutationDeleteCustomerInputGroupArgs = {
  customerInputGroupUid: Scalars['String']['input'];
};


export type MutationDeleteCustomerProfileFieldArgs = {
  customerProfileFieldId: Scalars['String']['input'];
};


export type MutationDeleteCustomerProfilesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteEagerBookingsArgs = {
  internalUids: Array<Scalars['String']['input']>;
};


export type MutationDeleteEmailTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationDeleteEventOfferingsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteFilesArgs = {
  internalUids: Array<Scalars['String']['input']>;
};


export type MutationDeleteInsuranceClaimableServiceProviderByInternalUidArgs = {
  internalUid: Scalars['String']['input'];
};


export type MutationDeleteLocationArgs = {
  locationUid: Scalars['String']['input'];
};


export type MutationDeleteLocationSubscriptionArgs = {
  locationUid: Scalars['String']['input'];
};


export type MutationDeleteLocationSubscriptionRequestArgs = {
  uid: Scalars['String']['input'];
};


export type MutationDeletePeazyPluginInstallationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePeazyPluginListingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReceiptConfigArgs = {
  configId: Scalars['String']['input'];
};


export type MutationDeleteRecurringAppointmentArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type MutationDeleteReviewArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type MutationDeleteServiceAreasArgs = {
  internalUids: Array<Scalars['String']['input']>;
};


export type MutationDeleteServiceOfferingCategoriesArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type MutationDeleteServiceOfferingsArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type MutationDeleteServiceProviderReminderArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSurveyResponsesArgs = {
  internalUids: Array<Scalars['String']['input']>;
};


export type MutationDetachPaymentMethodArgs = {
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
  methodId: Scalars['String']['input'];
};


export type MutationDetachPaymentMethodForCustomerArgs = {
  customerId: Scalars['String']['input'];
  methodId: Scalars['String']['input'];
};


export type MutationDisableSquareCardForCustomerArgs = {
  cardId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};


export type MutationExchangeGoogleCalendarAccessCodeAndStoreTokenArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationExchangeSquareOAuthCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationGetOrInitializeAppointmentCartArgs = {
  serviceProviderUid: Scalars['String']['input'];
};


export type MutationGetOrInitializeBookingCartArgs = {
  appointmentUid?: InputMaybe<Scalars['String']['input']>;
  serviceOfferingUid?: InputMaybe<Scalars['String']['input']>;
  serviceProviderUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetOrInitializeEventCartArgs = {
  locationUid: Scalars['String']['input'];
  serviceProviderId: Scalars['String']['input'];
};


export type MutationGetResetPasswordLinkArgs = {
  returnTo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetSetupIntentSecretForCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationImportSquareCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationLinkStripeSourceForCustomerArgs = {
  customerId: Scalars['String']['input'];
  stripeSourceToken: Scalars['String']['input'];
};


export type MutationLinkStripeSourceToIdentityArgs = {
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
  stripeSourceToken: Scalars['String']['input'];
};


export type MutationMigrateAnonymousIdentityArgs = {
  anonymousIdToken: Scalars['String']['input'];
  ownerIdToken: Scalars['String']['input'];
};


export type MutationNoShowBookingArgs = {
  uid: Scalars['String']['input'];
};


export type MutationRecordAticArgs = {
  metadata?: InputMaybe<AnalyticsEventMetadataInput>;
  type: AnalyticsEventType;
};


export type MutationRefreshSessionArgs = {
  idToken: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  accountType: Scalars['Int']['input'];
  businessInfo?: InputMaybe<BusinessRegistrationInfo>;
  country: Scalars['String']['input'];
  employeeInfo?: InputMaybe<EmployeeRegistrationInfo>;
  idToken: Scalars['String']['input'];
  referrer?: InputMaybe<Scalars['String']['input']>;
  serviceProviderInfo?: InputMaybe<ServiceProviderRegistrationInfo>;
  timezoneLocation: Scalars['String']['input'];
};


export type MutationRegisterBookingIdForCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationRegisterBusinessArgs = {
  business: BusinessInput;
  idToken: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  timezoneLocation: Scalars['String']['input'];
};


export type MutationRemoveBookingAttributesArgs = {
  bookingAttributeUids: Array<Scalars['String']['input']>;
};


export type MutationSetBookingsIsInProgressArgs = {
  bookingUids: Array<Scalars['String']['input']>;
};


export type MutationSetDateAvailabilityArgs = {
  data: Array<DateAvailabilityInput>;
};


export type MutationSetDayOfWeekAvailabilityArgs = {
  data: Array<DayOfWeekAvailabilityInput>;
};


export type MutationSetDefaultPaymentMethodArgs = {
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
  methodId: Scalars['String']['input'];
};


export type MutationSetDefaultPaymentMethodForCustomerArgs = {
  customerId: Scalars['String']['input'];
  methodId: Scalars['String']['input'];
};


export type MutationSetEmailTemplateArgs = {
  input: EmailTemplateInput;
};


export type MutationSetReviewsArgs = {
  data: Array<ReviewInput>;
};


export type MutationSetRoleArgs = {
  externalUid: Scalars['String']['input'];
  ownerUid: Scalars['String']['input'];
  role: RoleType;
};


export type MutationSetServiceOfferingCustomerInputGroupsArgs = {
  customerInputGroupUids: Array<Scalars['String']['input']>;
  serviceOfferingUid: Scalars['String']['input'];
};


export type MutationSetServiceOfferingCustomerInputsArgs = {
  customerInputUids: Array<Scalars['String']['input']>;
  serviceOfferingUid: Scalars['String']['input'];
};


export type MutationSetServiceProviderPreferenceArgs = {
  preference: ServiceProviderPreferenceInput;
};


export type MutationSetUserCountryArgs = {
  country: Scalars['String']['input'];
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSigninArgs = {
  createIfNotExists?: InputMaybe<Scalars['Boolean']['input']>;
  idToken: Scalars['String']['input'];
  timezoneLocation: Scalars['String']['input'];
};


export type MutationSigninPartnerArgs = {
  idToken: Scalars['String']['input'];
};


export type MutationSubscribeUserToProductArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationUpdateAppointmentCartArgs = {
  data: UpdateAppointmentCartInput;
};


export type MutationUpdateAppointmentCartServiceAreaUidArgs = {
  appointmentCartUid: Scalars['String']['input'];
  serviceAreaUid: Scalars['String']['input'];
};


export type MutationUpdateAppointmentCartStartDateTimeArgs = {
  appointmentCartUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
};


export type MutationUpdateAppointmentChangeProposalArgs = {
  id: Scalars['ID']['input'];
  input: AppointmentChangeProposalInput;
};


export type MutationUpdateAppointmentPreferencesArgs = {
  data: Array<UpdateAppointmentPreferenceInput>;
};


export type MutationUpdateAppointmentRequestsArgs = {
  data: Array<UpdateAppointmentRequestInput>;
};


export type MutationUpdateAppointmentServiceAreaUidArgs = {
  appointmentId: Scalars['String']['input'];
  serviceAreaUid: Scalars['String']['input'];
};


export type MutationUpdateAppointmentStartDateTimeArgs = {
  appointmentUid: Scalars['String']['input'];
  maxEndDateTime: Scalars['Int']['input'];
  startDateTime: Scalars['Int']['input'];
};


export type MutationUpdateAppointmentsArgs = {
  data: Array<UpdateAppointmentInput>;
};


export type MutationUpdateBookingAttributesArgs = {
  bookingAttributes: Array<UpdateBookingAttributeInput>;
};


export type MutationUpdateBookingCartArgs = {
  data: UpdateBookingCartInput;
};


export type MutationUpdateBookingCartCustomerInputSelectionsArgs = {
  bookingCartUid: Scalars['String']['input'];
  customerInputSelections?: InputMaybe<Array<CustomerInputSelectionInput>>;
};


export type MutationUpdateBookingCartCustomerProfileIdArgs = {
  bookingCartUid: Scalars['String']['input'];
  customerProfileId: Scalars['String']['input'];
};


export type MutationUpdateBookingCartRedeemableSecretArgs = {
  bookingCartUid: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


export type MutationUpdateBookingCartServiceOfferingUidArgs = {
  bookingCartUid: Scalars['String']['input'];
  serviceOfferingUid: Scalars['String']['input'];
};


export type MutationUpdateBookingCartStartDateTimeArgs = {
  bookingCartUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
};


export type MutationUpdateBookingCartTipPercentArgs = {
  bookingCartUid: Scalars['String']['input'];
  tipPercent: Scalars['Int']['input'];
};


export type MutationUpdateBookingCustomerInputSelectionsArgs = {
  bookingUid: Scalars['String']['input'];
  customerInputSelections?: InputMaybe<Array<CustomerInputSelectionInput>>;
};


export type MutationUpdateBookingCustomerProfileIdArgs = {
  bookingId: Scalars['String']['input'];
  customerProfileId: Scalars['String']['input'];
};


export type MutationUpdateBookingDurationOverrideArgs = {
  id: Scalars['ID']['input'];
  input: BookingDurationOverrideInput;
};


export type MutationUpdateBookingNoteArgs = {
  id: Scalars['String']['input'];
  input: BookingNoteInput;
};


export type MutationUpdateBookingServiceOfferingArgs = {
  bookingUid: Scalars['String']['input'];
  serviceOfferingUid: Scalars['String']['input'];
};


export type MutationUpdateBookingStartDateTimeArgs = {
  bookingUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
};


export type MutationUpdateBookingsArgs = {
  data: Array<UpdateBookingInput>;
};


export type MutationUpdateBusinessNameArgs = {
  name: Scalars['String']['input'];
};


export type MutationUpdateCustomLineItemArgs = {
  id: Scalars['ID']['input'];
  input: CustomLineItemInput;
};


export type MutationUpdateCustomTaxRateLineItemsArgs = {
  customTaxRateLineItems: Array<UpdateCustomTaxRateLineItemInput>;
};


export type MutationUpdateCustomerInputArgs = {
  data: UpdateCustomerInputInput;
};


export type MutationUpdateCustomerInputGroupArgs = {
  customerInputGroupUid: Scalars['String']['input'];
  data: CustomerInputGroupInput;
};


export type MutationUpdateCustomerProfileArgs = {
  customerProfileId: Scalars['String']['input'];
  profile: CustomerProfileInput;
};


export type MutationUpdateCustomerProfileFieldArgs = {
  customerProfileFieldId: Scalars['String']['input'];
  field: CustomerProfileFieldInput;
};


export type MutationUpdateCustomerProfileForServiceProviderArgs = {
  customerProfileId: Scalars['String']['input'];
  fieldValues: Array<CustomerProfileFieldValueInput>;
  serviceProviderId: Scalars['String']['input'];
};


export type MutationUpdateCustomerProfileNotesArgs = {
  customerProfileId: Scalars['String']['input'];
  notes: Array<CustomerProfileNoteInput>;
};


export type MutationUpdateDropoffDateTimeArgs = {
  dropoffDateTime: Scalars['Int']['input'];
  dropoffID: Scalars['String']['input'];
};


export type MutationUpdateEagerBookingsArgs = {
  data: Array<UpdateEagerBookingInput>;
};


export type MutationUpdateEventCartArgs = {
  data: UpdateEventCartInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateEventOfferingArgs = {
  data: UpdateEventOffering;
  id: Scalars['String']['input'];
};


export type MutationUpdateFilesArgs = {
  data: Array<UpdateFileInput>;
};


export type MutationUpdateInsuranceClaimableServiceProviderByInternalUidArgs = {
  data: InsuranceClaimableServiceProviderInput;
  internalUid: Scalars['String']['input'];
};


export type MutationUpdateLocationPoliciesArgs = {
  data: Array<UpdateLocationPolicyInput>;
};


export type MutationUpdateLocationSubscriptionRequestsArgs = {
  data: Array<UpdateLocationSubscriptionRequestInput>;
};


export type MutationUpdateLocationsArgs = {
  data: Array<UpdateLocationInput>;
};


export type MutationUpdatePeazyPluginInstallationArgs = {
  id: Scalars['ID']['input'];
  input: PeazyPluginInstallationInput;
};


export type MutationUpdatePeazyPluginListingArgs = {
  id: Scalars['ID']['input'];
  input: PeazyPluginListingInput;
};


export type MutationUpdateProfileByInternalUidArgs = {
  internalUid: Scalars['String']['input'];
  profile: ProfileInput;
};


export type MutationUpdateReceiptConfigArgs = {
  configId: Scalars['String']['input'];
  input: ReceiptConfigInput;
};


export type MutationUpdateRecurringAppointmentsArgs = {
  data: Array<UpdateRecurringAppointmentInput>;
};


export type MutationUpdateServiceAreasArgs = {
  data: Array<UpdateServiceAreaInput>;
};


export type MutationUpdateServiceOfferingArgs = {
  data: UpdateServiceOfferingInput;
};


export type MutationUpdateServiceOfferingCategoriesArgs = {
  data: Array<UpdateServiceOfferingCategoryInput>;
};


export type MutationUpdateServiceProviderReminderArgs = {
  id: Scalars['String']['input'];
  input: ServiceProviderReminderInput;
};


export type MutationUpdateSiblingBookingDiscountRuleArgs = {
  discountRule: UpdateSiblingBookingDiscountRuleInput;
  discountRuleID: Scalars['String']['input'];
};


export type MutationUpdateSurveyResponsesArgs = {
  data: Array<UpdateSurveyResponseInput>;
};


export type MutationUpdateTaxRateTogglesArgs = {
  taxRateToggles: Array<TaxRateToggleInput>;
};


export type MutationUpdateTimeDurationBookedAtLocationDiscountRuleArgs = {
  discountRule: UpdateTimeDurationBookedAtLocationDiscountRuleInput;
  discountRuleID: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};


export type MutationUpdateUserFullNameArgs = {
  fullName: Scalars['String']['input'];
};


export type MutationUpdateUserPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationUploadFilesArgs = {
  files: Array<Scalars['Upload']['input']>;
};

export type PartnerAttribution = {
  __typename?: 'PartnerAttribution';
  earnings: Scalars['Int']['output'];
  revenueSourceId: Scalars['String']['output'];
  revenueSourceType: Scalars['String']['output'];
};

export enum PaymentGatewayType {
  OffPlatform = 'OFF_PLATFORM',
  Square = 'SQUARE',
  Stripe = 'STRIPE'
}

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  id: Scalars['String']['output'];
  paymentMethod: PaymentMethod;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card: Card;
};

export type PaymentMethodsForCustomer = {
  __typename?: 'PaymentMethodsForCustomer';
  cards: Array<Card>;
  customerId: Scalars['String']['output'];
};

export type PeazyPluginHookScope = {
  __typename?: 'PeazyPluginHookScope';
  createdAt: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  permissionType: PeazyPluginHookScopePermissionType;
  type: PeazyPluginHookScopeType;
  updatedAt: Scalars['Int']['output'];
};

export enum PeazyPluginHookScopePermissionType {
  None = 'NONE',
  Read = 'READ',
  Readwrite = 'READWRITE'
}

export enum PeazyPluginHookScopeType {
  GetBaseAvailability = 'GET_BASE_AVAILABILITY'
}

export type PeazyPluginInstallation = {
  __typename?: 'PeazyPluginInstallation';
  configurationData: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  hookScopes: Array<Maybe<PeazyPluginHookScope>>;
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  pluginListing: PeazyPluginListing;
  pluginVersion: PeazyPluginVersion;
  serviceProvider: ServiceProvider;
  updatedAt: Scalars['Int']['output'];
};

export type PeazyPluginInstallationInput = {
  pluginListingID: Scalars['String']['input'];
  versionID: Scalars['String']['input'];
};

export type PeazyPluginListing = {
  __typename?: 'PeazyPluginListing';
  createdAt: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  developerID: Scalars['String']['output'];
  galleryFiles: Array<File>;
  iconURL: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  peazyPluginVersions: Array<PeazyPluginVersion>;
  repositoryURL: Scalars['String']['output'];
  status: PluginStatus;
  updatedAt: Scalars['Int']['output'];
  websiteURL: Scalars['String']['output'];
};

export type PeazyPluginListingInput = {
  description: Scalars['String']['input'];
  developerID: Scalars['String']['input'];
  galleryUrls: Array<InputMaybe<Scalars['String']['input']>>;
  iconURL: Scalars['String']['input'];
  name: Scalars['String']['input'];
  repositoryURL: Scalars['String']['input'];
  websiteURL: Scalars['String']['input'];
};

export type PeazyPluginVersion = {
  __typename?: 'PeazyPluginVersion';
  checksum: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  minimumPlatformVersion: Scalars['String']['output'];
  pluginListing: PeazyPluginListing;
  releaseNotes: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  versionNumber: Scalars['String']['output'];
};

export type PeazyPluginVersionInput = {
  checksum: Scalars['String']['input'];
  minimumPlatformVersion: Scalars['String']['input'];
  pluginListingID: Scalars['String']['input'];
  releaseNotes: Scalars['String']['input'];
  versionNumber: Scalars['String']['input'];
};

export type PhotoGallery = {
  __typename?: 'PhotoGallery';
  items: Array<PhotoGalleryItem>;
  uid: Scalars['String']['output'];
};

export type PhotoGalleryInput = {
  items: Array<PhotoGalleryItemInput>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoGalleryItem = {
  __typename?: 'PhotoGalleryItem';
  imageFile: File;
  index: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type PhotoGalleryItemInput = {
  imageFileUid: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export enum PluginStatus {
  Approved = 'APPROVED',
  Deprecated = 'DEPRECATED',
  Draft = 'DRAFT',
  PendingReview = 'PENDING_REVIEW',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED'
}

export type Profile = {
  __typename?: 'Profile';
  avatarImage?: Maybe<File>;
  bannerImage?: Maybe<File>;
  bannerImageMobile?: Maybe<File>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  emailThemeHex: Scalars['String']['output'];
  introVideoURL: Scalars['String']['output'];
  logoJpeg?: Maybe<File>;
  ownerUid: Scalars['String']['output'];
  photoGallery?: Maybe<PhotoGallery>;
  servicesCopy?: Maybe<Array<ServiceCopy>>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  socialLinks: Array<SocialLink>;
  taxIds: Array<TaxId>;
  uid: Scalars['String']['output'];
};

export type ProfileInput = {
  avatarImageFileUid?: InputMaybe<Scalars['String']['input']>;
  bannerImageFileUid?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  emailThemeHex: Scalars['String']['input'];
  introVideoURL: Scalars['String']['input'];
  logoJpegFileUid: Scalars['String']['input'];
  photoGallery?: InputMaybe<PhotoGalleryInput>;
  socialLinks: Array<SocialLinkInput>;
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['Boolean']['output']>;
  checkSessionValid: Scalars['String']['output'];
  getAliasByFrom?: Maybe<Alias>;
  getAliasesByExternalUid: Array<Alias>;
  getAllBusinesses: Array<Business>;
  getAppointment?: Maybe<Appointment>;
  getAppointmentByBookingUid: Appointment;
  getAppointmentById?: Maybe<Appointment>;
  getAppointmentCartByUID?: Maybe<AppointmentCart>;
  getAppointmentChangeProposalById: AppointmentChangeProposal;
  getAppointmentChangeProposalsByAppointmentId: Array<AppointmentChangeProposal>;
  getAppointmentRequests: Array<AppointmentRequest>;
  getAppointmentRequestsByExternalUid: Array<AppointmentRequest>;
  getAppointmentRequestsByLocationUids: Array<AppointmentRequest>;
  getAppointmentRequestsByOwnerUid: Array<AppointmentRequest>;
  getAppointments: Array<Appointment>;
  getAppointmentsForLocations: Array<Appointment>;
  getAppointmentsForLocationsCount: Scalars['Int']['output'];
  getAppointmentsForUser: Array<Appointment>;
  getBooking: Booking;
  getBookingAttributes: Array<BookingAttribute>;
  getBookingById?: Maybe<Booking>;
  getBookingCartByUID?: Maybe<BookingCart>;
  getBookingDurationOverrideById: BookingDurationOverride;
  getBookingDurationOverridesByBookingID: Array<BookingDurationOverride>;
  getBookingDurationOverridesByServiceProviderID: Array<BookingDurationOverride>;
  getBookingForAppointment?: Maybe<Booking>;
  getBookingNotes: Array<BookingNote>;
  getBookingPriceBreakdown: BookingPriceBreakdown;
  getBookingPriceBreakdownForBooking: BookingPriceBreakdown;
  getBookingsByAppointmentUids: Array<Maybe<BookingsForAppointment>>;
  getBusiness?: Maybe<Business>;
  getBusinessByAdminUid?: Maybe<Business>;
  getBusinessBySlug?: Maybe<Business>;
  getBusinessHasLinkedStripeSource: Scalars['Boolean']['output'];
  getCalendarAccess?: Maybe<Array<CalendarProvider>>;
  getConfirmedAppointments: Array<Appointment>;
  getConfirmedAppointmentsCount: Scalars['Int']['output'];
  getCustomLineItemById?: Maybe<CustomLineItem>;
  getCustomLineItemsByBookingId: Array<CustomLineItem>;
  getCustomTaxRateLineItems: Array<CustomTaxRateLineItem>;
  getCustomTaxRateLineItemsByInternalUid: Array<CustomTaxRateLineItem>;
  getCustomer?: Maybe<Customer>;
  getCustomerByUserId?: Maybe<Customer>;
  getCustomerInputGroupServiceOfferingLinks: Array<Scalars['String']['output']>;
  getCustomerInputGroups: Array<CustomerInputGroup>;
  getCustomerInputGroupsForCustomerInput: Array<CustomerInputGroup>;
  getCustomerInputServiceOfferings: Array<Scalars['String']['output']>;
  getCustomerInputs: Array<CustomerInput>;
  getCustomerInputsByUid: Array<CustomerInput>;
  getCustomerInviteByID: CustomerInvite;
  getCustomerProfile?: Maybe<CustomerProfile>;
  getCustomerProfileFieldsForServiceProvider: Array<CustomerProfileField>;
  getCustomerProfilesForCustomer: Array<CustomerProfile>;
  getDeviceCodes: GetDeviceCodesResponse;
  getDiscountRulesForServiceProvider: DiscountRuleSearchResult;
  getDiscountRulesProgress: Array<DiscountRuleWithProgress>;
  getDiscountRulesProgressWithBooking: Array<DiscountRuleWithProgress>;
  getDiscounts: Array<Discount>;
  getDiscountsForBookingUids: Array<Discount>;
  getDropoffsForCustomer: DropoffSearchResult;
  getDropoffsForServiceProvider: DropoffSearchResult;
  getEagerBookingsByExternalUids: Array<EagerBooking>;
  getEagerBookingsByOwnerUid: Array<EagerBooking>;
  getEmailTemplate?: Maybe<EmailTemplate>;
  getEmailTemplatesForServiceProvider: Array<EmailTemplate>;
  getEventOffering?: Maybe<EventOffering>;
  getEventOfferingsForServiceProvider: Array<EventOffering>;
  getExpectedEarningsForAppointments: Array<AppointmentExpectedEarnings>;
  getFiles: Array<File>;
  getFilesByExternalUid: Array<File>;
  getHasSquareLinked: Scalars['Boolean']['output'];
  getIdentity: Identity;
  getInsuranceClaimableServiceProviderByOwnerUID?: Maybe<InsuranceClaimableServiceProvider>;
  getIsAvailable: Array<GetIsAvailableResult>;
  getIsGoogleCalendarLinked: Scalars['Boolean']['output'];
  getLocation: Location;
  getLocationById?: Maybe<Location>;
  getLocationBySlugAndBusinessUid?: Maybe<Location>;
  getLocationSubscriptionForOwnerForLocation?: Maybe<LocationSubscription>;
  getLocationSubscriptions: Array<LocationSubscription>;
  getLocationSubscriptionsByExternalUid: Array<LocationSubscription>;
  getLocations: Array<Location>;
  getLocationsByUid: Array<Location>;
  getMerchant: Merchant;
  getMerchants: Array<Merchant>;
  getOptimalOpenTimeForServiceProviderForLatLng: Scalars['Int']['output'];
  getOptimalOpenTimeForServiceProviderForLocation: Scalars['Int']['output'];
  getPartnerAttributions: Array<PartnerAttribution>;
  getPartnerAttributionsCount: Scalars['Int']['output'];
  getPartnerCommissionPercent: Scalars['Int']['output'];
  getPartnerTotalAttributionEarnings: Scalars['Int']['output'];
  getPaymentMethods: Array<Card>;
  getPaymentMethodsForCustomer: Array<Card>;
  getPaymentMethodsForCustomers: Array<PaymentMethodsForCustomer>;
  getPeazyPluginInstallationById: PeazyPluginInstallation;
  getPeazyPluginInstallationsByServiceProviderID: Array<PeazyPluginInstallation>;
  getPeazyPluginListingById: PeazyPluginListing;
  getPeazyPluginListingRecommended: Array<Maybe<PeazyPluginListing>>;
  getPeazyPluginListingsByDeveloperID: Array<PeazyPluginListing>;
  getPeazyPluginVersionById: PeazyPluginVersion;
  getPeazyPluginVersionsByPluginListingID: Array<PeazyPluginVersion>;
  getPendingAppointments: Array<Appointment>;
  getPendingAppointmentsCount: Scalars['Int']['output'];
  getProductSubscriberCount: Scalars['Int']['output'];
  getProfileByOwnerUid?: Maybe<Profile>;
  getProfilesByOwnerUid: Array<Profile>;
  getPublicCustomerProfileFieldsForServiceProvider: Array<CustomerProfileField>;
  getReceiptConfigForServiceProvider?: Maybe<ReceiptConfig>;
  getServiceArea: ServiceArea;
  getServiceAreas: Array<ServiceArea>;
  getServiceAreasByLocationUid: Array<ServiceArea>;
  getServiceOffering: ServiceOffering;
  getServiceOfferingCustomerInputGroups: Array<CustomerInputGroup>;
  getServiceOfferingCustomerInputs: Array<CustomerInput>;
  getServiceOfferingsForServiceProvider: Array<ServiceOffering>;
  getServiceProvider: ServiceProvider;
  getServiceProviderBreakCalendarEvents: Array<CalendarEvent>;
  getServiceProviderById: ServiceProvider;
  getServiceProviderBySlug?: Maybe<ServiceProvider>;
  getServiceProviderCalendarEvents: Array<CalendarEvent>;
  getServiceProviderCalendarUnavailableDateTimeBoundsForAppointment: Array<UnavailableDatetime>;
  getServiceProviderCalendarUnavailableDateTimeBoundsForBooking: Array<UnavailableDatetime>;
  getServiceProviderDefaultDropoffDeltaDaysPreference: Scalars['Int']['output'];
  getServiceProviderIsDefaultDropoffDeltaBusinessDays: Scalars['Boolean']['output'];
  getServiceProviderPreferences: Array<ServiceProviderPreference>;
  getServiceProviderReminders: ServiceProviderReminderPage;
  getServiceProviderRetailLocations: Array<Location>;
  getServiceProviderSlugsForSitemap: Array<Scalars['String']['output']>;
  getServiceProviderTravelTimeForAppointment: Array<UnavailableDatetime>;
  getServiceProviderUid: Scalars['String']['output'];
  getSetupIntentSecret: Scalars['String']['output'];
  getSquareCardForCustomer?: Maybe<SquareCard>;
  getStripeBalance: StripeBalance;
  getStripeCustomer: StripeCustomer;
  getStripeCustomerForCustomer: StripeCustomer;
  getStripeLoginLink: Scalars['String']['output'];
  getTaxRateForServiceProvider: TaxRate;
  getTaxRateToggles: Array<TaxRateToggle>;
  getTerminalCheckout: TerminalCheckout;
  getThisCustomerForServiceProviderId?: Maybe<Customer>;
  getThisServiceProvider: ServiceProvider;
  getThisServiceProviderRetailLocations: Array<Location>;
  getThisUserLocations: Array<Location>;
  getTotalLiabilityValueForServiceProvider: Scalars['Int']['output'];
  getUpcomingBookings: Array<Booking>;
  getUser: User;
  getUserBookingsForAppointment: Array<Booking>;
  getUserSubscriptionStatus: SubscriptionStatus;
  getUsers: Array<User>;
  hasConnectedStripeAccount: Scalars['Boolean']['output'];
  identityHasLinkedStripeSource: Scalars['Boolean']['output'];
  isRedeemableRedeemable: Scalars['Boolean']['output'];
  listSquareCardsForCustomer: Array<SquareCard>;
  queryAppointmentOracle: Array<Appointment>;
  queryBookings: BookingQueryResult;
  queryBookingsCount: Scalars['Int']['output'];
  queryBusinesses: BusinessQueryResult;
  queryDateAvailability: DateAvailabilityQueryResult;
  queryDayOfWeekAvailability: DayOfWeekAvailabilityQueryResult;
  queryDiscounts: DiscountQueryResult;
  queryEagerBookings: Array<EagerBooking>;
  queryEventOfferings: EventOfferingQueryResult;
  queryLocationPolicies: Array<LocationPolicy>;
  queryLocationSubscriptionRequests: LocationSubscriptionRequestQueryResult;
  queryLocationSubscriptions: Array<LocationSubscription>;
  queryLocationSubscriptionsCount: Scalars['Int']['output'];
  queryLocations: LocationsQueryResult;
  queryRedeemableRedemption: RedeemableRedemptionQueryResult;
  queryRedeemables: RedeemableQueryResult;
  queryServiceOfferings: ServiceOfferingQueryResult;
  queryServiceProviderAppointments: Array<Appointment>;
  queryServiceProviders: ServiceProvidersQueryResult;
  querySurveyOptions: SurveyOptionQueryResult;
  querySurveyResponses: SurveyResponseQueryResult;
  querySurveys: SurveyQueryResult;
  searchAppointmentCarts: AppointmentCartQueryResult;
  searchAppointmentPreferences: AppointmentPreferenceQueryResult;
  searchAppointmentRequests: Array<AppointmentRequest>;
  searchBookingCarts: BookingCartQueryResult;
  searchChatMessages: ChatMessageQueryResult;
  searchChatRooms: ChatRoomQueryResult;
  searchCustomers: SearchCustomersResult;
  searchRecurringAppointments: RecurringAppointmentSearchResult;
  searchReviews: ReviewSearchResult;
  searchServiceOfferingCategories: ServiceOfferingCategoryQueryResult;
  searchServiceProviderBookings: Array<Booking>;
  searchServiceProviderBookingsCount: Scalars['Int']['output'];
  searchSquareCustomers: SearchCustomersResponse;
};


export type QueryGetAliasByFromArgs = {
  from: Scalars['String']['input'];
};


export type QueryGetAliasesByExternalUidArgs = {
  externalUid: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllBusinessesArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryGetAppointmentArgs = {
  appointmentUid: Scalars['String']['input'];
};


export type QueryGetAppointmentByBookingUidArgs = {
  bookingUid: Scalars['String']['input'];
};


export type QueryGetAppointmentByIdArgs = {
  appointmentId: Scalars['String']['input'];
};


export type QueryGetAppointmentCartByUidArgs = {
  uid: Scalars['String']['input'];
};


export type QueryGetAppointmentChangeProposalByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAppointmentChangeProposalsByAppointmentIdArgs = {
  appointmentId: Scalars['ID']['input'];
};


export type QueryGetAppointmentRequestsArgs = {
  internalUids: Array<Scalars['String']['input']>;
};


export type QueryGetAppointmentRequestsByExternalUidArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetAppointmentRequestsByLocationUidsArgs = {
  locationUids: Array<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetAppointmentRequestsByOwnerUidArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetAppointmentsArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type QueryGetAppointmentsForLocationsArgs = {
  locationUids: Array<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  query?: InputMaybe<AppointmentQuery>;
};


export type QueryGetAppointmentsForLocationsCountArgs = {
  locationUids: Array<Scalars['String']['input']>;
  query?: InputMaybe<AppointmentQuery>;
};


export type QueryGetAppointmentsForUserArgs = {
  query?: InputMaybe<AppointmentQuery>;
  userUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBookingArgs = {
  bookingUid: Scalars['String']['input'];
};


export type QueryGetBookingAttributesArgs = {
  bookingUid: Scalars['String']['input'];
};


export type QueryGetBookingByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetBookingCartByUidArgs = {
  uid: Scalars['String']['input'];
};


export type QueryGetBookingDurationOverrideByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBookingDurationOverridesByBookingIdArgs = {
  bookingID: Scalars['ID']['input'];
};


export type QueryGetBookingForAppointmentArgs = {
  appointmentUid: Scalars['String']['input'];
};


export type QueryGetBookingNotesArgs = {
  bookingId: Scalars['String']['input'];
};


export type QueryGetBookingPriceBreakdownArgs = {
  bookingSelections: BookingSelectionsInput;
  bookingUid?: InputMaybe<Scalars['String']['input']>;
  formattedAddress: Scalars['String']['input'];
};


export type QueryGetBookingPriceBreakdownForBookingArgs = {
  bookingUid: Scalars['String']['input'];
};


export type QueryGetBookingsByAppointmentUidsArgs = {
  appointmentUids: Array<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetBusinessArgs = {
  businessUid: Scalars['String']['input'];
};


export type QueryGetBusinessBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetCalendarAccessArgs = {
  ownerUid?: InputMaybe<Scalars['String']['input']>;
  providers: Array<CalendarProvider>;
};


export type QueryGetConfirmedAppointmentsArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetCustomLineItemByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCustomLineItemsByBookingIdArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryGetCustomTaxRateLineItemsByInternalUidArgs = {
  internalUids: Array<Scalars['String']['input']>;
};


export type QueryGetCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetCustomerByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetCustomerInputGroupServiceOfferingLinksArgs = {
  customerInputGroupUid: Scalars['String']['input'];
};


export type QueryGetCustomerInputGroupsForCustomerInputArgs = {
  customerInputUid: Scalars['String']['input'];
};


export type QueryGetCustomerInputServiceOfferingsArgs = {
  customerInputUid: Scalars['String']['input'];
};


export type QueryGetCustomerInputsByUidArgs = {
  customerInputUids: Array<Scalars['String']['input']>;
};


export type QueryGetCustomerInviteByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCustomerProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type QueryGetCustomerProfilesForCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetDiscountRulesForServiceProviderArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetDiscountRulesProgressArgs = {
  appointmentUID: Scalars['String']['input'];
};


export type QueryGetDiscountRulesProgressWithBookingArgs = {
  bookingSelections: BookingSelectionsInput;
  locationUid: Scalars['String']['input'];
  serviceProviderUid: Scalars['String']['input'];
  timezoneLocation: Scalars['String']['input'];
};


export type QueryGetDiscountsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDiscountsForBookingUidsArgs = {
  bookingUids: Array<Scalars['String']['input']>;
};


export type QueryGetDropoffsForCustomerArgs = {
  query: DropoffQuery;
};


export type QueryGetDropoffsForServiceProviderArgs = {
  query: DropoffQuery;
};


export type QueryGetEagerBookingsByExternalUidsArgs = {
  externalUids: Array<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetEagerBookingsByOwnerUidArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetEmailTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type QueryGetEventOfferingArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetEventOfferingsForServiceProviderArgs = {
  serviceProviderId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetExpectedEarningsForAppointmentsArgs = {
  appointmentUids: Array<Scalars['String']['input']>;
};


export type QueryGetFilesArgs = {
  internalUids: Array<Scalars['String']['input']>;
};


export type QueryGetFilesByExternalUidArgs = {
  externalUids: Array<Scalars['String']['input']>;
};


export type QueryGetIsAvailableArgs = {
  fromSeconds: Scalars['Int']['input'];
  ownerUids: Array<Scalars['String']['input']>;
  toSeconds: Scalars['Int']['input'];
};


export type QueryGetLocationArgs = {
  locationUid: Scalars['String']['input'];
};


export type QueryGetLocationByIdArgs = {
  locationId: Scalars['String']['input'];
};


export type QueryGetLocationBySlugAndBusinessUidArgs = {
  businessUid: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryGetLocationSubscriptionForOwnerForLocationArgs = {
  locationUid: Scalars['String']['input'];
};


export type QueryGetLocationSubscriptionsByExternalUidArgs = {
  externalUids: Array<Scalars['String']['input']>;
};


export type QueryGetLocationsByUidArgs = {
  locationUids: Array<Scalars['String']['input']>;
};


export type QueryGetMerchantArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMerchantsArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type QueryGetOptimalOpenTimeForServiceProviderForLatLngArgs = {
  dateUnix: Scalars['Int']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  serviceProviderUid: Scalars['String']['input'];
};


export type QueryGetOptimalOpenTimeForServiceProviderForLocationArgs = {
  dateUnix: Scalars['Int']['input'];
  locationId: Scalars['String']['input'];
  serviceProviderUid: Scalars['String']['input'];
};


export type QueryGetPartnerAttributionsArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetPaymentMethodsArgs = {
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPaymentMethodsForCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetPaymentMethodsForCustomersArgs = {
  customerIds: Array<Scalars['String']['input']>;
};


export type QueryGetPeazyPluginInstallationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPeazyPluginListingByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPeazyPluginListingRecommendedArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPeazyPluginListingsByDeveloperIdArgs = {
  developerID: Scalars['ID']['input'];
};


export type QueryGetPeazyPluginVersionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPeazyPluginVersionsByPluginListingIdArgs = {
  pluginListingID: Scalars['ID']['input'];
};


export type QueryGetPendingAppointmentsArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetProductSubscriberCountArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryGetProfileByOwnerUidArgs = {
  ownerUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProfilesByOwnerUidArgs = {
  ownerUids: Array<Scalars['String']['input']>;
};


export type QueryGetPublicCustomerProfileFieldsForServiceProviderArgs = {
  serviceProviderId: Scalars['String']['input'];
};


export type QueryGetServiceAreaArgs = {
  serviceAreaUid: Scalars['String']['input'];
};


export type QueryGetServiceAreasArgs = {
  internalUids: Array<Scalars['String']['input']>;
};


export type QueryGetServiceAreasByLocationUidArgs = {
  locationUids: Array<Scalars['String']['input']>;
};


export type QueryGetServiceOfferingArgs = {
  uid: Scalars['String']['input'];
};


export type QueryGetServiceOfferingCustomerInputGroupsArgs = {
  serviceOfferingUid: Scalars['String']['input'];
};


export type QueryGetServiceOfferingCustomerInputsArgs = {
  serviceOfferingUid: Scalars['String']['input'];
};


export type QueryGetServiceOfferingsForServiceProviderArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  serviceProviderUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetServiceProviderArgs = {
  ownerUid: Scalars['String']['input'];
};


export type QueryGetServiceProviderBreakCalendarEventsArgs = {
  query: CalendarEventQuery;
};


export type QueryGetServiceProviderByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetServiceProviderBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetServiceProviderCalendarEventsArgs = {
  query: CalendarEventQuery;
};


export type QueryGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentArgs = {
  excludeBookingUid?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['Int']['input'];
  locationUid: Scalars['String']['input'];
  serviceProviderUid: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};


export type QueryGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingArgs = {
  excludeBookingUid?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['Int']['input'];
  locationUid: Scalars['String']['input'];
  selectedServiceOfferingUid: Scalars['String']['input'];
  serviceProviderUid: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};


export type QueryGetServiceProviderDefaultDropoffDeltaDaysPreferenceArgs = {
  serviceProviderUserUid: Scalars['String']['input'];
};


export type QueryGetServiceProviderIsDefaultDropoffDeltaBusinessDaysArgs = {
  serviceProviderUserUid: Scalars['String']['input'];
};


export type QueryGetServiceProviderPreferencesArgs = {
  query: ServiceProviderPreferenceQuery;
};


export type QueryGetServiceProviderRemindersArgs = {
  query: ServiceProviderReminderQueryInput;
};


export type QueryGetServiceProviderRetailLocationsArgs = {
  serviceProviderId: Scalars['String']['input'];
};


export type QueryGetServiceProviderTravelTimeForAppointmentArgs = {
  duration: Scalars['Int']['input'];
  locationUid: Scalars['String']['input'];
  serviceProviderUid: Scalars['String']['input'];
  startDateTimes: Array<Scalars['Int']['input']>;
};


export type QueryGetServiceProviderUidArgs = {
  serviceProviderId: Scalars['String']['input'];
};


export type QueryGetSetupIntentSecretArgs = {
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSquareCardForCustomerArgs = {
  cardId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};


export type QueryGetStripeCustomerArgs = {
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStripeCustomerForCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetTaxRateTogglesArgs = {
  externalUids: Array<Scalars['String']['input']>;
};


export type QueryGetTerminalCheckoutArgs = {
  checkoutId: Scalars['String']['input'];
};


export type QueryGetThisCustomerForServiceProviderIdArgs = {
  serviceProviderId: Scalars['String']['input'];
};


export type QueryGetThisUserLocationsArgs = {
  types?: InputMaybe<Array<LocationType>>;
};


export type QueryGetTotalLiabilityValueForServiceProviderArgs = {
  serviceProviderId: Scalars['ID']['input'];
};


export type QueryGetUpcomingBookingsArgs = {
  page: Scalars['Int']['input'];
};


export type QueryGetUserArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserBookingsForAppointmentArgs = {
  appointmentUid: Scalars['String']['input'];
  ownerUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserSubscriptionStatusArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryGetUsersArgs = {
  uids: Array<Scalars['String']['input']>;
};


export type QueryIdentityHasLinkedStripeSourceArgs = {
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsRedeemableRedeemableArgs = {
  redeemAt: Scalars['Int']['input'];
  secret: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type QueryListSquareCardsForCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryQueryAppointmentOracleArgs = {
  query?: InputMaybe<AppointmentOracleQuery>;
};


export type QueryQueryBookingsArgs = {
  query: BookingQuery;
};


export type QueryQueryBookingsCountArgs = {
  query: BookingQuery;
};


export type QueryQueryBusinessesArgs = {
  query: BusinessQuery;
};


export type QueryQueryDateAvailabilityArgs = {
  query: DateAvailabilityQuery;
};


export type QueryQueryDayOfWeekAvailabilityArgs = {
  query: DayOfWeekAvailabilityQuery;
};


export type QueryQueryDiscountsArgs = {
  query: DiscountQuery;
};


export type QueryQueryEagerBookingsArgs = {
  query: EagerBookingQuery;
};


export type QueryQueryEventOfferingsArgs = {
  query: EventOfferingQuery;
};


export type QueryQueryLocationPoliciesArgs = {
  query: LocationPolicyQuery;
};


export type QueryQueryLocationSubscriptionRequestsArgs = {
  query: LocationSubscriptionRequestQuery;
};


export type QueryQueryLocationSubscriptionsArgs = {
  query: LocationSubscriptionQuery;
};


export type QueryQueryLocationSubscriptionsCountArgs = {
  query: LocationSubscriptionQuery;
};


export type QueryQueryLocationsArgs = {
  query: LocationQuery;
};


export type QueryQueryRedeemableRedemptionArgs = {
  query: RedeemableRedemptionQuery;
};


export type QueryQueryRedeemablesArgs = {
  query: RedeemableQuery;
};


export type QueryQueryServiceOfferingsArgs = {
  query: ServiceOfferingQuery;
};


export type QueryQueryServiceProviderAppointmentsArgs = {
  query: AppointmentQuery;
};


export type QueryQueryServiceProvidersArgs = {
  query: ServiceProviderQuery;
};


export type QueryQuerySurveyOptionsArgs = {
  query: SurveyOptionQuery;
};


export type QueryQuerySurveyResponsesArgs = {
  query: SurveyResponseQuery;
};


export type QueryQuerySurveysArgs = {
  query: SurveyQuery;
};


export type QuerySearchAppointmentCartsArgs = {
  query: AppointmentCartQuery;
};


export type QuerySearchAppointmentPreferencesArgs = {
  query: AppointmentPreferenceQuery;
};


export type QuerySearchAppointmentRequestsArgs = {
  query: AppointmentRequestQuery;
};


export type QuerySearchBookingCartsArgs = {
  query: BookingCartQuery;
};


export type QuerySearchChatMessagesArgs = {
  query: ChatMessageQuery;
};


export type QuerySearchChatRoomsArgs = {
  query: ChatRoomQuery;
};


export type QuerySearchCustomersArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchRecurringAppointmentsArgs = {
  query: RecurringAppointmentQuery;
};


export type QuerySearchReviewsArgs = {
  query: ReviewQuery;
};


export type QuerySearchServiceOfferingCategoriesArgs = {
  query: ServiceOfferingCategoryQuery;
};


export type QuerySearchServiceProviderBookingsArgs = {
  appointmentStatusQuery?: InputMaybe<AppointmentStatusQuery>;
  query: BookingQuery;
};


export type QuerySearchServiceProviderBookingsCountArgs = {
  appointmentStatusQuery?: InputMaybe<AppointmentStatusQuery>;
  query: BookingQuery;
};


export type QuerySearchSquareCustomersArgs = {
  query: Scalars['String']['input'];
};

export type ReceiptConfig = {
  __typename?: 'ReceiptConfig';
  createdAt: Scalars['Int']['output'];
  finePrint: Scalars['String']['output'];
  headerTextTemplate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  serviceProviderId: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ReceiptConfigInput = {
  finePrint: Scalars['String']['input'];
  headerTextTemplate: Scalars['String']['input'];
};

export type RecurringAppointment = {
  __typename?: 'RecurringAppointment';
  appointment: Appointment;
  createdAt: Scalars['Int']['output'];
  lastRecurrence: Scalars['Int']['output'];
  owner?: Maybe<User>;
  uid: Scalars['String']['output'];
};

export type RecurringAppointmentQuery = {
  internalUids?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerUids?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  serviceProviderUids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RecurringAppointmentSearchResult = {
  __typename?: 'RecurringAppointmentSearchResult';
  hasMoreResults: Scalars['Boolean']['output'];
  recurringAppointments: Array<RecurringAppointment>;
};

export type Redeemable = {
  __typename?: 'Redeemable';
  countRestrictions: Array<RedemptionCountRestriction>;
  op: RedemptionRestrictionOperation;
  referenceRestrictions: Array<RedemptionReferenceRestriction>;
  sideEffect?: Maybe<RedemptionMutateDiscountSideEffect>;
  timeBoundsRestriction: RedemptionTimeBoundsRestriction;
  uid: Scalars['String']['output'];
};

export type RedeemableQuery = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  references?: InputMaybe<Array<V1Beta1_ReferenceInput>>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type RedeemableQueryResult = {
  __typename?: 'RedeemableQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  redeemables: Array<Redeemable>;
};

export type RedeemableRedemption = {
  __typename?: 'RedeemableRedemption';
  bookingUid: Scalars['String']['output'];
  ownerUid: Scalars['String']['output'];
  redeemableUid: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type RedeemableRedemptionInput = {
  bookingUid: Scalars['String']['input'];
  redeemableReference: V1Beta3_SingleReferenceInput;
  secret: Scalars['String']['input'];
};

export type RedeemableRedemptionQuery = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  references?: InputMaybe<Array<V1Beta3_ReferenceMatch>>;
};

export type RedeemableRedemptionQueryResult = {
  __typename?: 'RedeemableRedemptionQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  redemptions: Array<RedeemableRedemption>;
};

export type RedemptionCountRestriction = {
  __typename?: 'RedemptionCountRestriction';
  max: Scalars['Int']['output'];
  type: RedemptionCountType;
};

export enum RedemptionCountType {
  Subject = 'SUBJECT',
  Total = 'TOTAL'
}

export type RedemptionMutateDiscountSideEffect = {
  __typename?: 'RedemptionMutateDiscountSideEffect';
  discount: Discount;
};

export type RedemptionReferenceRestriction = {
  __typename?: 'RedemptionReferenceRestriction';
  op: RedemptionRestrictionOperation;
  references: Array<V1Beta1_Reference>;
};

export enum RedemptionRestrictionOperation {
  And = 'AND',
  Or = 'OR'
}

export type RedemptionTimeBoundsRestriction = {
  __typename?: 'RedemptionTimeBoundsRestriction';
  timeUnixSecondsBounds: Bounds;
};

export enum ReferenceType {
  External = 'External',
  Internal = 'Internal',
  Owner = 'Owner'
}

export type Revenue = {
  __typename?: 'Revenue';
  note: Scalars['String']['output'];
  type: RevenueType;
  value: Scalars['Int']['output'];
};

export enum RevenueType {
  Location = 'LOCATION',
  Platform = 'PLATFORM',
  ServiceProvider = 'SERVICE_PROVIDER',
  StripeFee = 'STRIPE_FEE'
}

export type Review = {
  __typename?: 'Review';
  booking?: Maybe<Booking>;
  createdAt: Scalars['Int']['output'];
  externalAuthor?: Maybe<Scalars['String']['output']>;
  isExternal: Scalars['Boolean']['output'];
  isLike: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  owner?: Maybe<User>;
  rating: Scalars['Int']['output'];
  serviceProvider: LegacyServiceProvider;
  serviceProviderUid: Scalars['String']['output'];
  text: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type ReviewInput = {
  bookingUid?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  serviceProviderUid: Scalars['String']['input'];
  text: Scalars['String']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewQuery = {
  bookingUids?: InputMaybe<Array<Scalars['String']['input']>>;
  internalUids?: InputMaybe<Array<Scalars['String']['input']>>;
  isLike?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ownerUids?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  serviceProviderUids?: InputMaybe<Array<Scalars['String']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewSearchResult = {
  __typename?: 'ReviewSearchResult';
  hasMoreResults: Scalars['Boolean']['output'];
  reviews: Array<Review>;
};

export enum RoleType {
  Admin = 'ADMIN'
}

export type SearchCustomersResponse = {
  __typename?: 'SearchCustomersResponse';
  customers: Array<SquareCustomer>;
};

export type SearchCustomersResult = {
  __typename?: 'SearchCustomersResult';
  customers: Array<Customer>;
  hasMoreResults: Scalars['Boolean']['output'];
};

export type ServiceArea = {
  __typename?: 'ServiceArea';
  description: Scalars['String']['output'];
  externalUid: Scalars['String']['output'];
  files: Array<File>;
  location: Location;
  name: Scalars['String']['output'];
  size?: Maybe<ServiceAreaSize>;
  uid: Scalars['String']['output'];
};

export enum ServiceAreaSize {
  ExtraLarge = 'EXTRA_LARGE',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type ServiceCopy = {
  __typename?: 'ServiceCopy';
  price: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ServiceOffering = {
  __typename?: 'ServiceOffering';
  allowTip: Scalars['Boolean']['output'];
  basePrice: Scalars['Int']['output'];
  baseTime: Scalars['Int']['output'];
  customerInputGroups: Array<CustomerInputGroup>;
  customerInputs: Array<CustomerInput>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  isHidden: Scalars['Boolean']['output'];
  maxConcurrentBookings: Scalars['Int']['output'];
  ownerUid: Scalars['String']['output'];
  postServiceNote: Scalars['String']['output'];
  shortDesc?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ServiceOfferingType;
  uid: Scalars['String']['output'];
};

export type ServiceOfferingCategory = {
  __typename?: 'ServiceOfferingCategory';
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  owner: User;
  serviceOfferings: Array<ServiceOffering>;
  title: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type ServiceOfferingCategoryQuery = {
  ownerUids?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  serviceOfferingUids?: InputMaybe<Array<Scalars['String']['input']>>;
  uids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ServiceOfferingCategoryQueryResult = {
  __typename?: 'ServiceOfferingCategoryQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  serviceOfferingCategories: Array<ServiceOfferingCategory>;
};

export type ServiceOfferingQuery = {
  pagination?: InputMaybe<V1Beta3_PaginationInput>;
  referenceMatches?: InputMaybe<Array<V1Beta3_ReferenceMatch>>;
};

export type ServiceOfferingQueryResult = {
  __typename?: 'ServiceOfferingQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  serviceOfferings: Array<ServiceOffering>;
};

export enum ServiceOfferingType {
  PickupDropOff = 'PICKUP_DROP_OFF',
  ScheduledMulti = 'SCHEDULED_MULTI',
  ScheduledSingle = 'SCHEDULED_SINGLE'
}

export type ServiceProvider = {
  __typename?: 'ServiceProvider';
  averageRating: Scalars['Float']['output'];
  customers: Array<Customer>;
  customersCount: Scalars['Int']['output'];
  dateAvailability: Array<DateAvailability>;
  dayOfWeekAvailability: Array<DayOfWeekAvailability>;
  discountRules: Array<DiscountRule>;
  displayName: Scalars['String']['output'];
  eventOfferings: Array<EventOffering>;
  events: Array<CalendarEvent>;
  id: Scalars['String']['output'];
  insuranceInformation?: Maybe<InsuranceClaimableServiceProvider>;
  isApproved: Scalars['Boolean']['output'];
  isGoogleCalendarLinked: Scalars['Boolean']['output'];
  location: Location;
  ownerUid: Scalars['String']['output'];
  preferences: Array<ServiceProviderPreference>;
  profile?: Maybe<Profile>;
  reviewCount: Scalars['Int']['output'];
  reviews: Array<Review>;
  serviceOfferingCategories: Array<ServiceOfferingCategory>;
  serviceOfferings: Array<ServiceOffering>;
  serviceType: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  user: User;
};


export type ServiceProviderCustomersArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type ServiceProviderEventsArgs = {
  eventType?: InputMaybe<CalendarEventType>;
};


export type ServiceProviderServiceOfferingsArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceProviderLiability = {
  __typename?: 'ServiceProviderLiability';
  accountingRecordId: Scalars['ID']['output'];
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSettled: Scalars['Boolean']['output'];
  serviceProviderId: Scalars['ID']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ServiceProviderPreference = {
  __typename?: 'ServiceProviderPreference';
  id: Scalars['String']['output'];
  type: ServiceProviderPreferenceType;
  value: Scalars['String']['output'];
};

export type ServiceProviderPreferenceInput = {
  type: ServiceProviderPreferenceType;
  value: Scalars['String']['input'];
};

export type ServiceProviderPreferenceQuery = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  types: Array<ServiceProviderPreferenceType>;
};

export enum ServiceProviderPreferenceType {
  ServiceProviderPreferenceTypeDefaultDropoffClockTime = 'SERVICE_PROVIDER_PREFERENCE_TYPE_DEFAULT_DROPOFF_CLOCK_TIME',
  ServiceProviderPreferenceTypeDefaultDropoffDeltaDays = 'SERVICE_PROVIDER_PREFERENCE_TYPE_DEFAULT_DROPOFF_DELTA_DAYS',
  ServiceProviderPreferenceTypeIsDefaultDropoffDeltaBusinessDays = 'SERVICE_PROVIDER_PREFERENCE_TYPE_IS_DEFAULT_DROPOFF_DELTA_BUSINESS_DAYS',
  ServiceProviderPreferenceTypeUnspecified = 'SERVICE_PROVIDER_PREFERENCE_TYPE_UNSPECIFIED'
}

export type ServiceProviderQuery = {
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  serviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  timeUTCSecondsBounds?: InputMaybe<BoundsInput>;
};

export type ServiceProviderRegistrationInfo = {
  currency: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  utcOffset: Scalars['String']['input'];
};

export type ServiceProviderReminder = {
  __typename?: 'ServiceProviderReminder';
  customer: Customer;
  customerID: Scalars['String']['output'];
  dateTime: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  isSent: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  serviceOfferingUID: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ServiceProviderReminderInput = {
  customerID: Scalars['String']['input'];
  dateTime: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  serviceOfferingUID: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type ServiceProviderReminderPage = {
  __typename?: 'ServiceProviderReminderPage';
  hasNextPage: Scalars['Boolean']['output'];
  reminders: Array<ServiceProviderReminder>;
};

export type ServiceProviderReminderQueryInput = {
  maxDateTime: Scalars['Int']['input'];
  minDateTime: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProvidersQueryResult = {
  __typename?: 'ServiceProvidersQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  serviceProviders: Array<ServiceProvider>;
};

export type SiblingBookingTriggerCondition = {
  __typename?: 'SiblingBookingTriggerCondition';
  ignoreServiceOfferingUids: Array<Scalars['String']['output']>;
  requireBookingCount: Scalars['Int']['output'];
};

export type SiblingBookingTriggerConditionInput = {
  ignoreServiceOfferingUids: Array<Scalars['String']['input']>;
  requireBookingCount: Scalars['Int']['input'];
};

export type SigninResponse = {
  __typename?: 'SigninResponse';
  isNewUser: Scalars['Boolean']['output'];
  jwt: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  user: User;
};

export type SocialLink = {
  __typename?: 'SocialLink';
  platform: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SocialLinkInput = {
  platform: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SquareCard = {
  __typename?: 'SquareCard';
  cardBrand: Scalars['String']['output'];
  cardholderName: Scalars['String']['output'];
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
};

export type SquareCustomer = {
  __typename?: 'SquareCustomer';
  emailAddress: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type StripeAmount = {
  __typename?: 'StripeAmount';
  currency: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type StripeBalance = {
  __typename?: 'StripeBalance';
  available: Array<StripeAmount>;
  pending: Array<StripeAmount>;
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  currency: Scalars['String']['output'];
  defaultPaymentMethodId: Scalars['String']['output'];
  defaultSource: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type SubscriptionResult = {
  __typename?: 'SubscriptionResult';
  subscriptionId: Scalars['ID']['output'];
};

export type SubscriptionStatus = {
  __typename?: 'SubscriptionStatus';
  isSubscribed: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type Survey = {
  __typename?: 'Survey';
  description: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  ownerRef: V1Beta3_SingleReference;
  title: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type SurveyOption = {
  __typename?: 'SurveyOption';
  surveyRef: V1Beta1_Reference;
  uid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SurveyOptionQuery = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  references: Array<V1Beta1_ReferenceInput>;
};

export type SurveyOptionQueryResult = {
  __typename?: 'SurveyOptionQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  surveys: Array<SurveyOption>;
};

export type SurveyQuery = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  references: Array<V1Beta1_ReferenceInput>;
};

export type SurveyQueryResult = {
  __typename?: 'SurveyQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  surveys: Array<Survey>;
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  ownerRef: V1Beta3_SingleReference;
  surveyOptionRef: V1Beta3_SingleReference;
  uid: Scalars['String']['output'];
};

export type SurveyResponseQuery = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  references: Array<V1Beta1_ReferenceInput>;
};

export type SurveyResponseQueryResult = {
  __typename?: 'SurveyResponseQueryResult';
  hasMoreResults: Scalars['Boolean']['output'];
  surveys: Array<SurveyResponse>;
};

export type TaxAmount = {
  __typename?: 'TaxAmount';
  taxAmountBreakdown: Array<TaxAmountLineItem>;
  totalTaxAmount: Scalars['Int']['output'];
};

export type TaxAmountLineItem = {
  __typename?: 'TaxAmountLineItem';
  taxAmount: Scalars['Int']['output'];
  taxRateLineItem: TaxRateLineItem;
};

export type TaxId = {
  __typename?: 'TaxID';
  type: TaxIdType;
  value: Scalars['String']['output'];
};

export enum TaxIdType {
  TaxIdTypeCanadaGst = 'TAX_ID_TYPE_CANADA_GST',
  TaxIdTypeUnspecified = 'TAX_ID_TYPE_UNSPECIFIED'
}

export type TaxRate = {
  __typename?: 'TaxRate';
  lineItems: Array<TaxRateLineItem>;
  taxSalesMicroPercent: Scalars['Int']['output'];
};

export type TaxRateLineItem = {
  __typename?: 'TaxRateLineItem';
  microPercent: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TaxRateToggle = {
  __typename?: 'TaxRateToggle';
  disabledTaxRateLineItems: Array<Scalars['String']['output']>;
  enabledTaxRateLineItemUids: Array<Scalars['String']['output']>;
  externalUid: Scalars['String']['output'];
};

export type TaxRateToggleInput = {
  disabledTaxRateLineItems: Array<Scalars['String']['input']>;
  enabledTaxRateLineItemUids: Array<Scalars['String']['input']>;
  externalUid: Scalars['String']['input'];
};

export enum TemplateTopicType {
  CustomerAppointmentCancelled = 'CUSTOMER_APPOINTMENT_CANCELLED',
  CustomerAppointmentConfirmed = 'CUSTOMER_APPOINTMENT_CONFIRMED',
  CustomerAppointmentCreated = 'CUSTOMER_APPOINTMENT_CREATED',
  CustomerAppointmentDenied = 'CUSTOMER_APPOINTMENT_DENIED',
  CustomerAppointmentRequestCreated = 'CUSTOMER_APPOINTMENT_REQUEST_CREATED',
  CustomerAppointmentRequestDenied = 'CUSTOMER_APPOINTMENT_REQUEST_DENIED',
  CustomerBookingCancelled = 'CUSTOMER_BOOKING_CANCELLED',
  CustomerBookingCompleted = 'CUSTOMER_BOOKING_COMPLETED',
  CustomerBookingCreated = 'CUSTOMER_BOOKING_CREATED',
  CustomerBookingCreatedByServiceProvider = 'CUSTOMER_BOOKING_CREATED_BY_SERVICE_PROVIDER',
  CustomerBookingReminder = 'CUSTOMER_BOOKING_REMINDER',
  CustomerNotifyDropoffCreatedCustomer = 'CUSTOMER_NOTIFY_DROPOFF_CREATED_CUSTOMER',
  CustomerNotifyUpcomingAppointments = 'CUSTOMER_NOTIFY_UPCOMING_APPOINTMENTS',
  LocationOwnerAppointmentRequestCreated = 'LOCATION_OWNER_APPOINTMENT_REQUEST_CREATED',
  LocationSubscriberAppointmentConfirmed = 'LOCATION_SUBSCRIBER_APPOINTMENT_CONFIRMED',
  NearbyUserAppointmentConfirmed = 'NEARBY_USER_APPOINTMENT_CONFIRMED',
  ServiceProviderAppointmentCancelled = 'SERVICE_PROVIDER_APPOINTMENT_CANCELLED',
  ServiceProviderAppointmentConfirmed = 'SERVICE_PROVIDER_APPOINTMENT_CONFIRMED',
  ServiceProviderAppointmentCreatedByCustomer = 'SERVICE_PROVIDER_APPOINTMENT_CREATED_BY_CUSTOMER',
  ServiceProviderAppointmentCreatedByLocationOwner = 'SERVICE_PROVIDER_APPOINTMENT_CREATED_BY_LOCATION_OWNER',
  ServiceProviderAppointmentPendingReminder = 'SERVICE_PROVIDER_APPOINTMENT_PENDING_REMINDER',
  ServiceProviderBookingCancelled = 'SERVICE_PROVIDER_BOOKING_CANCELLED',
  ServiceProviderBookingCompleted = 'SERVICE_PROVIDER_BOOKING_COMPLETED',
  ServiceProviderBookingCreated = 'SERVICE_PROVIDER_BOOKING_CREATED'
}

export type TerminalCheckout = {
  __typename?: 'TerminalCheckout';
  amountMoney: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type TimeDurationBookedAtLocationTriggerCondition = {
  __typename?: 'TimeDurationBookedAtLocationTriggerCondition';
  ignoreServiceOfferingUids: Array<Scalars['String']['output']>;
  requireDurationBookedSeconds: Scalars['Int']['output'];
};

export type TimeDurationBookedAtLocationTriggerConditionInput = {
  ignoreServiceOfferingUids: Array<Scalars['String']['input']>;
  requireDurationBookedSeconds: Scalars['Int']['input'];
};

export type UidNonce = {
  __typename?: 'UidNonce';
  nonce: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type UnavailableDatetime = {
  __typename?: 'UnavailableDatetime';
  endDateTime: Scalars['Int']['output'];
  startDateTime: Scalars['Int']['output'];
};

export type UpdateAppointmentCartInput = {
  appointmentSelections: AppointmentSelectionsInput;
  uid: Scalars['String']['input'];
};

export type UpdateAppointmentInput = {
  cancelledByUid?: InputMaybe<Scalars['String']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  isCancelled: Scalars['Boolean']['input'];
  isConfirmed: Scalars['Boolean']['input'];
  isDenied: Scalars['Boolean']['input'];
  locationUid: Scalars['String']['input'];
  maxEndDateTime: Scalars['Int']['input'];
  serviceAreaUid?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['Int']['input'];
  uid: Scalars['String']['input'];
};

export type UpdateAppointmentPreferenceInput = {
  type: AppointmentPreferenceType;
  uid: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateAppointmentRequestInput = {
  denialReason: Scalars['String']['input'];
  externalUid: Scalars['String']['input'];
  locationUid: Scalars['String']['input'];
  minEndDateTime: Scalars['Int']['input'];
  serviceAreaUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
  status: AppointmentRequestStatus;
  uid: Scalars['String']['input'];
};

export type UpdateBookingAttributeInput = {
  bookingUid: Scalars['String']['input'];
  description: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  type: BookingAttributeType;
  uid: Scalars['String']['input'];
};

export type UpdateBookingCartInput = {
  bookingSelections: BookingSelectionsInput;
  redeemableSecret?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};

export type UpdateBookingInput = {
  customerInputGroupSelections?: InputMaybe<Array<Array<CustomerInputGroupSelectionsInput>>>;
  customerInputSelections?: InputMaybe<Array<CustomerInputSelectionInput>>;
  isCancelled: Scalars['Boolean']['input'];
  profileId: Scalars['String']['input'];
  serviceOfferingUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
  tipPercent: Scalars['Int']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomTaxRateLineItemInput = {
  microPercent: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};

export type UpdateCustomerInputInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<UpdateCustomerInputOptionInput>>;
  required: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  type: CustomerInputType;
  uid: Scalars['String']['input'];
  unitPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCustomerInputOptionInput = {
  duration: Scalars['Int']['input'];
  nonce?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type UpdateCustomerInputOptionResponse = {
  __typename?: 'UpdateCustomerInputOptionResponse';
  customerInputOptionUid: Scalars['String']['output'];
  nonce?: Maybe<Scalars['String']['output']>;
};

export type UpdateCustomerInputResponse = {
  __typename?: 'UpdateCustomerInputResponse';
  options: Array<UpdateCustomerInputOptionResponse>;
};

export type UpdateEagerBookingInput = {
  booking: UpdateBookingInput;
  uid: Scalars['String']['input'];
};

export type UpdateEventCartInput = {
  enabledServiceOfferingUids: Array<Scalars['String']['input']>;
  eventEndDateTime?: InputMaybe<Scalars['Int']['input']>;
  isCoveredByBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  locationUid: Scalars['String']['input'];
  note: Scalars['String']['input'];
  serviceAreaUid?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['Int']['input'];
};

export type UpdateEventOffering = {
  baseDuration: Scalars['Int']['input'];
  basePrice: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  isPublished: Scalars['Boolean']['input'];
  maxBookings: Scalars['Int']['input'];
  serviceOfferingUids: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: EventOfferingType;
};

export type UpdateFileInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};

export type UpdateLocationInput = {
  extendedAddress?: InputMaybe<Scalars['String']['input']>;
  externalUid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  type: LocationType;
  uid: Scalars['String']['input'];
};

export type UpdateLocationPolicyInput = {
  name: Scalars['String']['input'];
  uid: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateLocationSubscriptionInput = {
  locationUid: Scalars['String']['input'];
};

export type UpdateLocationSubscriptionRequestInput = {
  locationSubscription: UpdateLocationSubscriptionInput;
  status: LocationSubscriptionRequestStatus;
  uid: Scalars['String']['input'];
};

export type UpdateRecurringAppointmentInput = {
  appointment: CreateAppointmentInput;
  recurrenceRule: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};

export type UpdateServiceAreaInput = {
  description: Scalars['String']['input'];
  externalUid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size?: InputMaybe<ServiceAreaSize>;
  uid: Scalars['String']['input'];
};

export type UpdateServiceOfferingCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  serviceOfferingUids: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};

export type UpdateServiceOfferingInput = {
  allowTip: Scalars['Boolean']['input'];
  basePrice: Scalars['Int']['input'];
  baseTime: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isHidden: Scalars['Boolean']['input'];
  maxConcurrentBookings: Scalars['Int']['input'];
  postServiceNote: Scalars['String']['input'];
  shortDesc?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: ServiceOfferingType;
  uid: Scalars['String']['input'];
};

export type UpdateSiblingBookingDiscountRuleInput = {
  discountType: DiscountType;
  discountValue: Scalars['Int']['input'];
  isDisabled: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  triggerCondition: SiblingBookingTriggerConditionInput;
};

export type UpdateSurveyResponseInput = {
  ownerRef: V1Beta3_SingleReferenceInput;
  surveyOptionRef: V1Beta3_SingleReferenceInput;
  uid: Scalars['String']['input'];
};

export type UpdateTimeDurationBookedAtLocationDiscountRuleInput = {
  discountType: DiscountType;
  discountValue: Scalars['Int']['input'];
  isDisabled: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  triggerCondition: TimeDurationBookedAtLocationTriggerConditionInput;
};

export type UpdateUserInput = {
  country: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};

export type UploadedFile = {
  __typename?: 'UploadedFile';
  objectName: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
};

export type UploadedFileInput = {
  objectName: Scalars['String']['input'];
  publicUrl: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  accountType: Scalars['Int']['output'];
  business?: Maybe<Business>;
  country: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isTemporary: Scalars['Boolean']['output'];
  locations: Array<Location>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  timezoneLocation: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type V1Beta1_Reference = {
  __typename?: 'V1Beta1_Reference';
  referenceIds: Array<Scalars['String']['output']>;
  referenceType: ReferenceType;
};

export type V1Beta1_ReferenceInput = {
  referenceIds: Array<Scalars['String']['input']>;
  referenceType: ReferenceType;
};

export type V1Beta3_LabelledSingleReferenceInput = {
  label: Scalars['String']['input'];
  reference: V1Beta3_SingleReferenceInput;
};

export type V1Beta3_PaginationInput = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type V1Beta3_ReferenceMatch = {
  ids: Array<Scalars['String']['input']>;
  match_type: V1Beta3_ReferenceMatchType;
  type: ReferenceType;
};

export enum V1Beta3_ReferenceMatchType {
  All = 'All',
  Any = 'Any'
}

export type V1Beta3_SingleReference = {
  __typename?: 'V1Beta3_SingleReference';
  id: Scalars['String']['output'];
  type: ReferenceType;
};

export type V1Beta3_SingleReferenceInput = {
  id: Scalars['String']['input'];
  type: ReferenceType;
};

export enum VisibilityLevel {
  LoggedIn = 'LOGGED_IN',
  Public = 'PUBLIC'
}

export type AcceptCustomerInviteMutationVariables = Exact<{
  customerInviteId: Scalars['ID']['input'];
}>;


export type AcceptCustomerInviteMutation = { __typename?: 'Mutation', acceptCustomerInvite: boolean };

export type AppointmentCartFieldsFragment = { __typename?: 'AppointmentCart', uid: string, serviceProviderUid: string, appointmentSelections: { __typename?: 'AppointmentSelections', startDateTime: number, serviceProviderOwnerUid: string, locationUid: string, serviceAreaUid?: string | null } };

export type V2Gateway_SearchAppointmentCartsQueryVariables = Exact<{
  query: AppointmentCartQuery;
}>;


export type V2Gateway_SearchAppointmentCartsQuery = { __typename?: 'Query', searchAppointmentCarts: { __typename?: 'AppointmentCartQueryResult', appointmentCarts: Array<{ __typename?: 'AppointmentCart', uid: string, serviceProviderUid: string, appointmentSelections: { __typename?: 'AppointmentSelections', startDateTime: number, serviceProviderOwnerUid: string, locationUid: string, serviceAreaUid?: string | null } }> } };

export type V2Gateway_CreateAppointmentCartMutationVariables = Exact<{
  data: CreateAppointmentCartInput;
}>;


export type V2Gateway_CreateAppointmentCartMutation = { __typename?: 'Mutation', createAppointmentCart: Array<string> };

export type V2Gateway_UpdateAppointmentCartMutationVariables = Exact<{
  data: UpdateAppointmentCartInput;
}>;


export type V2Gateway_UpdateAppointmentCartMutation = { __typename?: 'Mutation', updateAppointmentCart: boolean };

export type V2Gateway_DeleteAppointmentCartsMutationVariables = Exact<{
  uids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_DeleteAppointmentCartsMutation = { __typename?: 'Mutation', deleteAppointmentCarts: boolean };

export type V2Gateway_GetOrInitializeAppointmentCartMutationVariables = Exact<{
  serviceProviderUid: Scalars['String']['input'];
}>;


export type V2Gateway_GetOrInitializeAppointmentCartMutation = { __typename?: 'Mutation', getOrInitializeAppointmentCart: { __typename?: 'AppointmentCart', uid: string, serviceProviderUid: string, appointmentSelections: { __typename?: 'AppointmentSelections', startDateTime: number, serviceProviderOwnerUid: string, locationUid: string, serviceAreaUid?: string | null } } };

export type GetAppointmentCartByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type GetAppointmentCartByUidQuery = { __typename?: 'Query', getAppointmentCartByUID?: { __typename?: 'AppointmentCart', uid: string, serviceProviderUid: string, appointmentSelections: { __typename?: 'AppointmentSelections', startDateTime: number, serviceProviderOwnerUid: string, locationUid: string, serviceAreaUid?: string | null } } | null };

export type V2Gateway_CreateAppointmentPreferencesMutationVariables = Exact<{
  data: Array<CreateAppointmentPreferenceInput> | CreateAppointmentPreferenceInput;
}>;


export type V2Gateway_CreateAppointmentPreferencesMutation = { __typename?: 'Mutation', createAppointmentPreferences: Array<string> };

export type V2Gateway_UpdateAppointmentPreferencesMutationVariables = Exact<{
  data: Array<UpdateAppointmentPreferenceInput> | UpdateAppointmentPreferenceInput;
}>;


export type V2Gateway_UpdateAppointmentPreferencesMutation = { __typename?: 'Mutation', updateAppointmentPreferences: boolean };

export type V2Gateway_AcceptAppointmentMutationVariables = Exact<{
  appointmentUid: Scalars['String']['input'];
}>;


export type V2Gateway_AcceptAppointmentMutation = { __typename?: 'Mutation', acceptAppointment: boolean };

export type V2Gateway_QueryServiceProviderAppointmentsQueryVariables = Exact<{
  appointmentQuery: AppointmentQuery;
  bookingStatusQuery?: InputMaybe<BookingStatusQuery>;
}>;


export type V2Gateway_QueryServiceProviderAppointmentsQuery = { __typename?: 'Query', queryServiceProviderAppointments: Array<{ __typename?: 'Appointment', location: { __typename?: 'Location', id: string, type: LocationType, name: string, formattedAddress: string }, serviceArea?: { __typename?: 'ServiceArea', name: string, uid: string, description: string, externalUid: string, files: Array<{ __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } }> } | null, bookings: Array<{ __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string }, accountingRecord?: { __typename?: 'AccountingRecord', total: number, tipAmount: number, subTotal: number, totalTaxAmount: number, revenues: Array<{ __typename?: 'Revenue', type: RevenueType, value: number }>, lineItems: Array<{ __typename?: 'DetailedPrice', displayName: string, discountedPrice: number }> } | null }> }> };

export type GetAppointmentWithPreferencesQueryVariables = Exact<{
  appointmentUid: Scalars['String']['input'];
  bookingSelections?: InputMaybe<BookingSelectionsInput>;
}>;


export type GetAppointmentWithPreferencesQuery = { __typename?: 'Query', getAppointment?: { __typename?: 'Appointment', eventEndDateTime?: number | null, startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, discountRuleProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, priority: number, discountValue: number, discountType: DiscountType, requireDurationBookedSeconds: number, requireBookingCount: number } }>, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string, uid: string }>, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, slug: string, displayName: string, isApproved: boolean, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, user: { __typename?: 'User', id: string, fullName: string, timezoneLocation: string, country: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> }, expectedEarnings?: { __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', externalUid: string, value: number }> } | null, discounts: Array<{ __typename?: 'Discount', type: DiscountType, value: number }>, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, bookings: Array<{ __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } }>, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null } | null };

export type V2Gateway_DeclineAppointmentMutationVariables = Exact<{
  appointmentUid: Scalars['String']['input'];
  denialReason: Scalars['String']['input'];
}>;


export type V2Gateway_DeclineAppointmentMutation = { __typename?: 'Mutation', declineAppointment: boolean };

export type V2Gateway_CancelAppointmentMutationVariables = Exact<{
  appointmentUid: Scalars['String']['input'];
  cancelReason: Scalars['String']['input'];
}>;


export type V2Gateway_CancelAppointmentMutation = { __typename?: 'Mutation', cancelAppointment: boolean };

export type V2Gateway_CreateAppointmentsMutationVariables = Exact<{
  data: Array<CreateAppointmentInput> | CreateAppointmentInput;
}>;


export type V2Gateway_CreateAppointmentsMutation = { __typename?: 'Mutation', createAppointments: Array<{ __typename?: 'UidNonce', uid: string, nonce: string }> };

export type V2Gateway_UpdateAppointmentsMutationVariables = Exact<{
  data: Array<UpdateAppointmentInput> | UpdateAppointmentInput;
}>;


export type V2Gateway_UpdateAppointmentsMutation = { __typename?: 'Mutation', updateAppointments: boolean };

export type V2Gateway_GetIsAvailableQueryVariables = Exact<{
  fromSeconds: Scalars['Int']['input'];
  toSeconds: Scalars['Int']['input'];
  ownerUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetIsAvailableQuery = { __typename?: 'Query', getIsAvailable: Array<{ __typename?: 'GetIsAvailableResult', ownerUid: string, isAvailable: boolean }> };

export type V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryVariables = Exact<{
  appointmentUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;


export type V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery = { __typename?: 'Query', getBookingsByAppointmentUids: Array<{ __typename?: 'BookingsForAppointment', appointmentUid: string, incompleteBookings: Array<{ __typename?: 'Booking', startDateTime: number, endDateTime: number, uid: string }> } | null> };

export type ArchiveServiceProviderReminderMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveServiceProviderReminderMutation = { __typename?: 'Mutation', archiveServiceProviderReminder: boolean };

export type BookingCartFieldsFragment = { __typename?: 'BookingCart', uid: string, serviceProviderUid: string, redeemableSecret?: string | null, appointmentUid?: string | null, ownerUid: string, appointment?: { __typename?: 'Appointment', id: string, uid: string, locationUid: string } | null, bookingSelections: { __typename?: 'BookingSelections', appointmentUid: string, startDateTime: number, tipPercent: number, serviceOfferingUid: string, customerProfileId: string, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', customerInputUids: Array<string>, optionValues: Array<string>, level: number }>> | null }, redeemable?: { __typename?: 'Redeemable', sideEffect?: { __typename?: 'RedemptionMutateDiscountSideEffect', discount: { __typename?: 'Discount', value: number, type: DiscountType, isStackable: boolean } } | null } | null };

export type V2Gateway_SearchBookingCartsQueryVariables = Exact<{
  query: BookingCartQuery;
}>;


export type V2Gateway_SearchBookingCartsQuery = { __typename?: 'Query', searchBookingCarts: { __typename?: 'BookingCartQueryResult', bookingCarts: Array<{ __typename?: 'BookingCart', uid: string, serviceProviderUid: string, redeemableSecret?: string | null, appointmentUid?: string | null, ownerUid: string, appointment?: { __typename?: 'Appointment', id: string, uid: string, locationUid: string } | null, bookingSelections: { __typename?: 'BookingSelections', appointmentUid: string, startDateTime: number, tipPercent: number, serviceOfferingUid: string, customerProfileId: string, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', customerInputUids: Array<string>, optionValues: Array<string>, level: number }>> | null }, redeemable?: { __typename?: 'Redeemable', sideEffect?: { __typename?: 'RedemptionMutateDiscountSideEffect', discount: { __typename?: 'Discount', value: number, type: DiscountType, isStackable: boolean } } | null } | null }> } };

export type V2Gateway_CreateBookingCartMutationVariables = Exact<{
  data: CreateBookingCartInput;
}>;


export type V2Gateway_CreateBookingCartMutation = { __typename?: 'Mutation', createBookingCart: Array<string> };

export type V2Gateway_UpdateBookingCartMutationVariables = Exact<{
  data: UpdateBookingCartInput;
}>;


export type V2Gateway_UpdateBookingCartMutation = { __typename?: 'Mutation', updateBookingCart: boolean };

export type V2Gateway_DeleteBookingCartsMutationVariables = Exact<{
  uids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_DeleteBookingCartsMutation = { __typename?: 'Mutation', deleteBookingCarts: boolean };

export type V2Gateway_GetOrInitializeBookingCartMutationVariables = Exact<{
  serviceProviderUid?: InputMaybe<Scalars['String']['input']>;
  appointmentUid?: InputMaybe<Scalars['String']['input']>;
  serviceOfferingUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type V2Gateway_GetOrInitializeBookingCartMutation = { __typename?: 'Mutation', getOrInitializeBookingCart: { __typename?: 'BookingCart', uid: string, serviceProviderUid: string, redeemableSecret?: string | null, appointmentUid?: string | null, ownerUid: string, appointment?: { __typename?: 'Appointment', id: string, uid: string, locationUid: string } | null, bookingSelections: { __typename?: 'BookingSelections', appointmentUid: string, startDateTime: number, tipPercent: number, serviceOfferingUid: string, customerProfileId: string, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', customerInputUids: Array<string>, optionValues: Array<string>, level: number }>> | null }, redeemable?: { __typename?: 'Redeemable', sideEffect?: { __typename?: 'RedemptionMutateDiscountSideEffect', discount: { __typename?: 'Discount', value: number, type: DiscountType, isStackable: boolean } } | null } | null } };

export type V2Gateway_GetBookingCartByUidQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type V2Gateway_GetBookingCartByUidQuery = { __typename?: 'Query', getBookingCartByUID?: { __typename?: 'BookingCart', uid: string, serviceProviderUid: string, redeemableSecret?: string | null, appointmentUid?: string | null, ownerUid: string, appointment?: { __typename?: 'Appointment', id: string, uid: string, locationUid: string } | null, bookingSelections: { __typename?: 'BookingSelections', appointmentUid: string, startDateTime: number, tipPercent: number, serviceOfferingUid: string, customerProfileId: string, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', customerInputUids: Array<string>, optionValues: Array<string>, level: number }>> | null }, redeemable?: { __typename?: 'Redeemable', sideEffect?: { __typename?: 'RedemptionMutateDiscountSideEffect', discount: { __typename?: 'Discount', value: number, type: DiscountType, isStackable: boolean } } | null } | null } | null };

export type GetBookingNotesQueryVariables = Exact<{
  bookingId: Scalars['String']['input'];
}>;


export type GetBookingNotesQuery = { __typename?: 'Query', getBookingNotes: Array<{ __typename?: 'BookingNote', id: string, title: string, text: string, createdAt: number, updatedAt: number, bookingId: string }> };

export type CreateBookingNoteMutationVariables = Exact<{
  input: BookingNoteInput;
}>;


export type CreateBookingNoteMutation = { __typename?: 'Mutation', createBookingNote: string };

export type UpdateBookingNoteMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: BookingNoteInput;
}>;


export type UpdateBookingNoteMutation = { __typename?: 'Mutation', updateBookingNote: boolean };

export type DeleteBookingNoteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteBookingNoteMutation = { __typename?: 'Mutation', deleteBookingNote: boolean };

export type V2Gateway_SearchServiceProviderBookingsQueryVariables = Exact<{
  bookingQuery: BookingQuery;
  appointmentStatusQuery: AppointmentStatusQuery;
}>;


export type V2Gateway_SearchServiceProviderBookingsQuery = { __typename?: 'Query', searchServiceProviderBookings: Array<{ __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, isNoShow: boolean, isCancelled: boolean, appointment: { __typename?: 'Appointment', uid: string, location: { __typename?: 'Location', id: string, type: LocationType, name: string, formattedAddress: string, streetAddress: string }, serviceArea?: { __typename?: 'ServiceArea', name: string, uid: string, description: string, externalUid: string, files: Array<{ __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null }, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string }, accountingRecord?: { __typename?: 'AccountingRecord', total: number, tipAmount: number, subTotal: number, totalTaxAmount: number, revenues: Array<{ __typename?: 'Revenue', type: RevenueType, value: number }>, lineItems: Array<{ __typename?: 'DetailedPrice', displayName: string, discountedPrice: number }> } | null }> };

export type V2Gateway_SearchServiceProviderBookingsCountQueryVariables = Exact<{
  bookingQuery: BookingQuery;
  appointmentStatusQuery: AppointmentStatusQuery;
}>;


export type V2Gateway_SearchServiceProviderBookingsCountQuery = { __typename?: 'Query', searchServiceProviderBookingsCount: number };

export type BusinessQueryServiceProvidersQueryVariables = Exact<{
  query: ServiceProviderQuery;
}>;


export type BusinessQueryServiceProvidersQuery = { __typename?: 'Query', queryServiceProviders: { __typename?: 'ServiceProvidersQueryResult', hasMoreResults: boolean, serviceProviders: Array<{ __typename?: 'ServiceProvider', isApproved: boolean, serviceType: string, displayName: string, averageRating: number, reviewCount: number, id: string, slug: string, user: { __typename?: 'User', id: string }, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, type: ServiceOfferingType }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, location: { __typename?: 'Location', id: string, phoneNumber: string }, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, discountRules: Array<{ __typename?: 'DiscountRule', id: string, isDisabled: boolean, label: string, discountValue: number, discountType: DiscountType, priority: number, triggerCondition: { __typename?: 'DiscountRuleTriggerCondition', siblingBookingTriggerCondition?: { __typename?: 'SiblingBookingTriggerCondition', requireBookingCount: number, ignoreServiceOfferingUids: Array<string> } | null, timeDurationBookedAtLocationTriggerCondition?: { __typename?: 'TimeDurationBookedAtLocationTriggerCondition', requireDurationBookedSeconds: number, ignoreServiceOfferingUids: Array<string> } | null } }> }> } };

export type CancelAppointmentByIdMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  cancelReason: Scalars['String']['input'];
}>;


export type CancelAppointmentByIdMutation = { __typename?: 'Mutation', cancelAppointmentById: boolean };

export type CancelUserSubscriptionMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type CancelUserSubscriptionMutation = { __typename?: 'Mutation', cancelUserSubscription: boolean };

export type V2Gateway_SearchChatMessagesQueryVariables = Exact<{
  query: ChatMessageQuery;
}>;


export type V2Gateway_SearchChatMessagesQuery = { __typename?: 'Query', searchChatMessages: { __typename?: 'ChatMessageQueryResult', messages: Array<{ __typename?: 'ChatMessage', uid: string, text: string, createdAt: number, roomUid: string }> } };

export type V2Gateway_SearchChatRoomsQueryVariables = Exact<{
  query: ChatRoomQuery;
}>;


export type V2Gateway_SearchChatRoomsQuery = { __typename?: 'Query', searchChatRooms: { __typename?: 'ChatRoomQueryResult', rooms: Array<{ __typename?: 'ChatRoom', uid: string, participants: Array<{ __typename?: 'User', uid: string, fullName: string }> }> } };

export type V2Gateway_CreateChatRoomsMutationVariables = Exact<{
  data: Array<CreateChatRoomInput> | CreateChatRoomInput;
}>;


export type V2Gateway_CreateChatRoomsMutation = { __typename?: 'Mutation', createChatRooms: Array<string> };

export type ConfirmBookingMutationVariables = Exact<{
  bookingId: Scalars['String']['input'];
}>;


export type ConfirmBookingMutation = { __typename?: 'Mutation', confirmBooking: boolean };

export type CreateAppointmentForCustomerMutationVariables = Exact<{
  data: CreateAppointmentInput;
  customerId: Scalars['String']['input'];
}>;


export type CreateAppointmentForCustomerMutation = { __typename?: 'Mutation', createAppointmentForCustomer: string };

export type CreateAppointmentFromEventCartMutationVariables = Exact<{
  eventCartId: Scalars['String']['input'];
  eventOfferingId: Scalars['String']['input'];
}>;


export type CreateAppointmentFromEventCartMutation = { __typename?: 'Mutation', createAppointmentFromEventCart: { __typename?: 'CreateAppointmentFromEventCartResponse', appointmentId: string } };

export type CreateBookingForCustomerMutationVariables = Exact<{
  data: CreateBookingInput;
  customerId: Scalars['String']['input'];
  bookingId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateBookingForCustomerMutation = { __typename?: 'Mutation', createBookingForCustomer: string };

export type CreateBookingForAppointmentFromCartMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  bookingCartUid: Scalars['String']['input'];
}>;


export type CreateBookingForAppointmentFromCartMutation = { __typename?: 'Mutation', createBookingForAppointmentFromCart: { __typename?: 'CreateBookingFromCartResponse', booking: { __typename?: 'Booking', uid: string, appointment: { __typename?: 'Appointment', uid: string, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string }, location: { __typename?: 'Location', id: string, uid: string } } } } };

export type CreateCustomLineItemMutationVariables = Exact<{
  input: CustomLineItemInput;
}>;


export type CreateCustomLineItemMutation = { __typename?: 'Mutation', createCustomLineItem: string };

export type CreateCustomerProfileFieldMutationVariables = Exact<{
  field: CustomerProfileFieldInput;
}>;


export type CreateCustomerProfileFieldMutation = { __typename?: 'Mutation', createCustomerProfileField: string };

export type CreateCustomerProfileForServiceProviderMutationVariables = Exact<{
  serviceProviderId: Scalars['String']['input'];
  fieldValues: Array<CustomerProfileFieldValueInput> | CustomerProfileFieldValueInput;
}>;


export type CreateCustomerProfileForServiceProviderMutation = { __typename?: 'Mutation', createCustomerProfileForServiceProvider: string };

export type CreateCustomerProfileMutationVariables = Exact<{
  profile: CustomerProfileInput;
}>;


export type CreateCustomerProfileMutation = { __typename?: 'Mutation', createCustomerProfile: string };

export type CreateCustomerMutationVariables = Exact<{
  data: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: string };

export type CreateSiblingBookingDiscountRuleMutationVariables = Exact<{
  data: CreateSiblingBookingDiscountRuleInput;
}>;


export type CreateSiblingBookingDiscountRuleMutation = { __typename?: 'Mutation', createSiblingBookingDiscountRule: boolean };

export type CreateTimeDurationBookedAtLocationDiscountRuleMutationVariables = Exact<{
  data: CreateTimeDurationBookedAtLocationDiscountRuleInput;
}>;


export type CreateTimeDurationBookedAtLocationDiscountRuleMutation = { __typename?: 'Mutation', createTimeDurationBookedAtLocationDiscountRule: boolean };

export type V2Gateway_CreateDropoffsMutationVariables = Exact<{
  data: Array<CreateDropoffInput> | CreateDropoffInput;
}>;


export type V2Gateway_CreateDropoffsMutation = { __typename?: 'Mutation', createDropoffs: boolean };

export type CreateEventOfferingMutationVariables = Exact<{
  data: CreateEventOffering;
}>;


export type CreateEventOfferingMutation = { __typename?: 'Mutation', createEventOffering: string };

export type CreateLocationForCustomerMutationVariables = Exact<{
  data: CreateLocationInput;
  customerId: Scalars['String']['input'];
}>;


export type CreateLocationForCustomerMutation = { __typename?: 'Mutation', createLocationForCustomer: string };

export type CreateLocationMutationVariables = Exact<{
  data: CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'CreateLocationResponse', location: { __typename?: 'Location', uid: string, id: string, latitude: number, longitude: number } } };

export type CreatePeazyPluginInstallationMutationVariables = Exact<{
  data: PeazyPluginInstallationInput;
}>;


export type CreatePeazyPluginInstallationMutation = { __typename?: 'Mutation', createPeazyPluginInstallation: string };

export type CreateReceiptConfigMutationVariables = Exact<{
  input: ReceiptConfigInput;
}>;


export type CreateReceiptConfigMutation = { __typename?: 'Mutation', createReceiptConfig: string };

export type CreateServiceProviderBreakCalendarEventMutationVariables = Exact<{
  data: CalendarEventInput;
}>;


export type CreateServiceProviderBreakCalendarEventMutation = { __typename?: 'Mutation', createServiceProviderBreakCalendarEvent: boolean };

export type CreateServiceProviderReminderMutationVariables = Exact<{
  input: ServiceProviderReminderInput;
}>;


export type CreateServiceProviderReminderMutation = { __typename?: 'Mutation', createServiceProviderReminder: string };

export type CreateSquareCardForCustomerMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  sourceId: Scalars['String']['input'];
}>;


export type CreateSquareCardForCustomerMutation = { __typename?: 'Mutation', createSquareCardForCustomer: { __typename?: 'SquareCard', id: string, cardBrand: string, last4: string, expMonth: string, expYear: string, cardholderName: string } };

export type V2Gateway_GetLocationSubscriptionsByExternalUidQueryVariables = Exact<{
  externalUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetLocationSubscriptionsByExternalUidQuery = { __typename?: 'Query', getLocationSubscriptionsByExternalUid: Array<{ __typename?: 'LocationSubscription', locationUid: string, ownerUid: string }> };

export type DeleteCustomLineItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomLineItemMutation = { __typename?: 'Mutation', deleteCustomLineItem: boolean };

export type DeleteCustomerProfileFieldMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCustomerProfileFieldMutation = { __typename?: 'Mutation', deleteCustomerProfileField: boolean };

export type DeleteCustomerProfileMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteCustomerProfileMutation = { __typename?: 'Mutation', deleteCustomerProfiles: boolean };

export type DeleteEmailTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteEmailTemplateMutation = { __typename?: 'Mutation', deleteEmailTemplate: boolean };

export type DetachPaymentMethodForCustomerMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  methodId: Scalars['String']['input'];
}>;


export type DetachPaymentMethodForCustomerMutation = { __typename?: 'Mutation', detachPaymentMethodForCustomer: boolean };

export type DisableSquareCardForCustomerMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
}>;


export type DisableSquareCardForCustomerMutation = { __typename?: 'Mutation', disableSquareCardForCustomer: boolean };

export type DropoffBookingAppointmentLocationFieldsFragment = { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null };

export type DropoffFieldsFragment = { __typename?: 'Dropoff', dropoffDateTime: number, booking: { __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType }, appointment: { __typename?: 'Appointment', uid: string, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string } | null, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null } }, customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null } } } };

export type V2Gateway_GetDropoffsForServiceProviderQueryVariables = Exact<{
  query: DropoffQuery;
}>;


export type V2Gateway_GetDropoffsForServiceProviderQuery = { __typename?: 'Query', getDropoffsForServiceProvider: { __typename?: 'DropoffSearchResult', dropoffs: Array<{ __typename?: 'Dropoff', dropoffDateTime: number, booking: { __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType }, appointment: { __typename?: 'Appointment', uid: string, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string } | null, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null } }, customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null } } } }> } };

export type V2Gateway_GetDropoffsForCustomerQueryVariables = Exact<{
  query: DropoffQuery;
}>;


export type V2Gateway_GetDropoffsForCustomerQuery = { __typename?: 'Query', getDropoffsForCustomer: { __typename?: 'DropoffSearchResult', dropoffs: Array<{ __typename?: 'Dropoff', dropoffDateTime: number, booking: { __typename?: 'Booking', isInProgress: boolean, uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, ownerUid: string, price: number, appointment: { __typename?: 'Appointment', uid: string, id: string, isConfirmed: boolean, startDateTime: number, maxEndDateTime: number, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, bookingsWithSiblings: Array<{ __typename?: 'Booking', uid: string, owner: { __typename?: 'User', fullName: string } }>, discountRuleProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, discountValue: number, discountType: DiscountType, priority: number, requireDurationBookedSeconds: number, requireBookingCount: number } }>, location: { __typename?: 'Location', id: string, uid: string, streetAddress: string, name: string, type: LocationType, phoneNumber: string, formattedAddress: string, extendedAddress?: string | null, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, serviceProvider: { __typename?: 'ServiceProvider', serviceType: string, ownerUid: string, displayName: string, slug: string, reviewCount: number, averageRating: number, profile?: { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string }>, reviews: Array<{ __typename?: 'Review', uid: string, isLike: boolean }> } }, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, shortDesc?: string | null, basePrice: number, baseTime: number }, customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null } } } }> } };

export type V2Gateway_EditAppointmentStartDateTimeMutationVariables = Exact<{
  appointmentUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
  maxEndDateTime: Scalars['Int']['input'];
}>;


export type V2Gateway_EditAppointmentStartDateTimeMutation = { __typename?: 'Mutation', updateAppointmentStartDateTime: boolean };

export type V2Gateway_EditBookingMutationVariables = Exact<{
  bookingUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
  serviceOfferingUid: Scalars['String']['input'];
  customerInputSelections: Array<CustomerInputSelectionInput> | CustomerInputSelectionInput;
}>;


export type V2Gateway_EditBookingMutation = { __typename?: 'Mutation', updateBookingStartDateTime: boolean, updateBookingCustomerInputSelections: boolean, updateBookingServiceOffering: boolean };

export type ExchangeSquareOAuthCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ExchangeSquareOAuthCodeMutation = { __typename?: 'Mutation', exchangeSquareOAuthCode: boolean };

export type AppointmentBookingFieldsFragment = { __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } };

export type AppointmentFieldsExtendedFragment = { __typename?: 'Appointment', startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, expectedEarnings?: { __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', externalUid: string, value: number }> } | null, discounts: Array<{ __typename?: 'Discount', type: DiscountType, value: number }>, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, slug: string }, bookings: Array<{ __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } }>, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string, uid: string }> };

export type ServiceProviderFullFragment = { __typename?: 'LegacyServiceProvider', fullName: string, displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, profile?: { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, owner: { __typename?: 'User', fullName: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> };

export type ServiceProviderFullNewFragment = { __typename?: 'ServiceProvider', displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, slug: string, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, user: { __typename?: 'User', id: string, fullName: string, timezoneLocation: string, country: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> };

export type GetAllBusinessWithLocationSlugsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type GetAllBusinessWithLocationSlugsQuery = { __typename?: 'Query', getAllBusinesses: Array<{ __typename?: 'Business', slug: string, locations: Array<{ __typename?: 'Location', id: string, slug: string }> }> };

export type GetAppointmentByIdForAppointmentDetailsPageQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type GetAppointmentByIdForAppointmentDetailsPageQuery = { __typename?: 'Query', getAppointmentById?: { __typename?: 'Appointment', uid: string, locationUid: string, userUid: string, isCoveredByBusiness?: boolean | null, startDateTime: number, serviceAreaUid?: string | null, serviceProvider: { __typename?: 'ServiceProvider', displayName: string, serviceType: string, slug: string, user: { __typename?: 'User', emailAddress: string }, location: { __typename?: 'Location', id: string, phoneNumber: string }, profile?: { __typename?: 'Profile', avatarImage?: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null } | null, insuranceInformation?: { __typename?: 'InsuranceClaimableServiceProvider', titlePrefix?: string | null, titleSuffix?: string | null } | null }, location: { __typename?: 'Location', id: string, serviceAreas: Array<{ __typename?: 'ServiceArea', name: string, description: string, uid: string, files: Array<{ __typename?: 'File', label?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } }> }> }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, files: Array<{ __typename?: 'File', label?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } }> } | null, bookingsWithSiblings: Array<{ __typename?: 'Booking', startDateTime: number, endDateTime: number, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', title: string }, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInput: { __typename?: 'CustomerInput', title: string }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', value: string }> }> | null }> } | null };

export type GetAppointmentByIdWithLocationQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type GetAppointmentByIdWithLocationQuery = { __typename?: 'Query', getAppointmentById?: { __typename?: 'Appointment', uid: string, userUid: string, startDateTime: number, location: { __typename?: 'Location', id: string, type: LocationType, latitude: number, longitude: number } } | null };

export type GetAppointmentByIdWithPreferencesQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  bookingSelections?: InputMaybe<BookingSelectionsInput>;
}>;


export type GetAppointmentByIdWithPreferencesQuery = { __typename?: 'Query', getAppointmentById?: { __typename?: 'Appointment', eventEndDateTime?: number | null, startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, eventOffering?: { __typename?: 'EventOffering', id: string, title: string, description: string, baseDuration: number, type: EventOfferingType, serviceOfferingUids: Array<string>, attendanceServiceOfferingUid: string, maxBookings: number } | null, discountRuleProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, priority: number, discountValue: number, discountType: DiscountType, requireDurationBookedSeconds: number, requireBookingCount: number } }>, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string, uid: string }>, serviceProvider: { __typename?: 'ServiceProvider', id: string, ownerUid: string, serviceType: string, slug: string, displayName: string, isApproved: boolean, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', title: string, uid: string, required: boolean, type: CustomerInputType, index?: number | null, unitPrice?: number | null, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, user: { __typename?: 'User', id: string, fullName: string, timezoneLocation: string, country: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> }, expectedEarnings?: { __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', externalUid: string, value: number }> } | null, discounts: Array<{ __typename?: 'Discount', type: DiscountType, value: number }>, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, bookings: Array<{ __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } }>, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null } | null };

export type GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  bookingSelections?: InputMaybe<BookingSelectionsInput>;
}>;


export type GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery = { __typename?: 'Query', getAppointmentById?: { __typename?: 'Appointment', eventEndDateTime?: number | null, startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, eventOffering?: { __typename?: 'EventOffering', id: string, title: string, description: string, baseDuration: number, type: EventOfferingType, serviceOfferingUids: Array<string>, maxBookings: number } | null, discountRuleProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, priority: number, discountValue: number, discountType: DiscountType, requireDurationBookedSeconds: number, requireBookingCount: number } }>, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string, uid: string }>, serviceProvider: { __typename?: 'ServiceProvider', serviceType: string, id: string, displayName: string, averageRating: number, reviewCount: number, ownerUid: string, slug: string, reviews: Array<{ __typename?: 'Review', uid: string, createdAt: number, isLike: boolean, rating: number, text: string, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, user: { __typename?: 'User', id: string, uid: string, emailAddress: string }, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, discountRules: Array<{ __typename?: 'DiscountRule', id: string, isDisabled: boolean, label: string, discountValue: number, discountType: DiscountType, priority: number, triggerCondition: { __typename?: 'DiscountRuleTriggerCondition', siblingBookingTriggerCondition?: { __typename?: 'SiblingBookingTriggerCondition', requireBookingCount: number, ignoreServiceOfferingUids: Array<string> } | null, timeDurationBookedAtLocationTriggerCondition?: { __typename?: 'TimeDurationBookedAtLocationTriggerCondition', requireDurationBookedSeconds: number, ignoreServiceOfferingUids: Array<string> } | null } }>, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }>, location: { __typename?: 'Location', id: string, formattedAddress: string, phoneNumber: string, discoverableBounds: { __typename?: 'GeoBounds', min: { __typename?: 'GeoPoint', lat: number, lng: number }, max: { __typename?: 'GeoPoint', lat: number, lng: number } } } }, expectedEarnings?: { __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', externalUid: string, value: number }> } | null, discounts: Array<{ __typename?: 'Discount', type: DiscountType, value: number }>, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, bookings: Array<{ __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } }>, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null } | null };

export type GetAppointmentByIdQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type GetAppointmentByIdQuery = { __typename?: 'Query', getAppointmentById?: { __typename?: 'Appointment', id: string, uid: string, locationUid: string, userUid: string, startDateTime: number, isCoveredByBusiness?: boolean | null, isConfirmed: boolean, serviceAreaUid?: string | null } | null };

export type GetAppointmentForBusinessEventConfirmationPageQueryVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type GetAppointmentForBusinessEventConfirmationPageQuery = { __typename?: 'Query', getAppointmentById?: { __typename?: 'Appointment', uid: string, startDateTime: number, serviceProvider: { __typename?: 'ServiceProvider', serviceType: string, discountRules: Array<{ __typename?: 'DiscountRule', id: string }> }, location: { __typename?: 'Location', id: string, formattedAddress: string, extendedAddress?: string | null } } | null };

export type GetAppointmentsForServiceProviderScheduleBoundryQueryVariables = Exact<{
  userUid?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<AppointmentQuery>;
}>;


export type GetAppointmentsForServiceProviderScheduleBoundryQuery = { __typename?: 'Query', getAppointmentsForUser: Array<{ __typename?: 'Appointment', eventEndDateTime?: number | null, startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, eventOffering?: { __typename?: 'EventOffering', type: EventOfferingType, title: string, baseDuration: number } | null, bookings: Array<{ __typename?: 'Booking', id: string, customerProfileId: string, uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, dropoff?: { __typename?: 'Dropoff', id: string, dropoffDateTime: number, status: DropoffStatus } | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } }>, expectedEarnings?: { __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', externalUid: string, value: number }> } | null, discounts: Array<{ __typename?: 'Discount', type: DiscountType, value: number }>, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, slug: string }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string, uid: string }> }> };

export type GetAppointmentsForUserQueryVariables = Exact<{
  userUid?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<AppointmentQuery>;
}>;


export type GetAppointmentsForUserQuery = { __typename?: 'Query', getAppointmentsForUser: Array<{ __typename?: 'Appointment', eventEndDateTime?: number | null, startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, eventOffering?: { __typename?: 'EventOffering', type: EventOfferingType, title: string, baseDuration: number } | null, bookings: Array<{ __typename?: 'Booking', id: string, customerProfileId: string, uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, dropoff?: { __typename?: 'Dropoff', id: string, dropoffDateTime: number, status: DropoffStatus } | null, customer: { __typename?: 'Customer', id: string, profiles: Array<{ __typename?: 'CustomerProfile', id: string, customerID: string, label: string, fieldValues: Array<{ __typename?: 'CustomerProfileFieldValue', customerProfileFieldID: string, value: string }>, notes: Array<{ __typename?: 'CustomerProfileNote', id: string, text: string, title: string, createdAt: number }> }>, user: { __typename?: 'User', id: string, fullName: string, emailAddress: string, phoneNumber?: string | null } }, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } }>, expectedEarnings?: { __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', externalUid: string, value: number }> } | null, discounts: Array<{ __typename?: 'Discount', type: DiscountType, value: number }>, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, slug: string }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string, uid: string }> }> };

export type GetBookingByIdWithUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBookingByIdWithUserQuery = { __typename?: 'Query', getBookingById?: { __typename?: 'Booking', owner: { __typename?: 'User', emailAddress: string } } | null };

export type GetBookingForAppointmentQueryVariables = Exact<{
  appointmentUid: Scalars['String']['input'];
}>;


export type GetBookingForAppointmentQuery = { __typename?: 'Query', getBookingForAppointment?: { __typename?: 'Booking', uid: string } | null };

export type GetBookingForConfirmPageQueryVariables = Exact<{
  bookingId: Scalars['String']['input'];
}>;


export type GetBookingForConfirmPageQuery = { __typename?: 'Query', getBookingById?: { __typename?: 'Booking', owner: { __typename?: 'User', emailAddress: string } } | null };

export type GetBookingForCustomerBookingDetailsQueryVariables = Exact<{
  bookingUid: Scalars['String']['input'];
}>;


export type GetBookingForCustomerBookingDetailsQuery = { __typename?: 'Query', getBooking: { __typename?: 'Booking', uid: string, startDateTime: number, serviceOfferingUid: string, ownerUid: string, appointmentUid: string, tipPercent: number, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, customerInputs: Array<{ __typename?: 'CustomerInput', unitPrice?: number | null, title: string, type: CustomerInputType, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> }, appointment: { __typename?: 'Appointment', userUid: string, isCoveredByBusiness?: boolean | null, location: { __typename?: 'Location', id: string, streetAddress: string, formattedAddress: string }, serviceProvider: { __typename?: 'ServiceProvider', displayName: string, serviceType: string, slug: string, profile?: { __typename?: 'Profile', avatarImage?: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null } | null } } } };

export type GetBookingForEditBookingPageQueryVariables = Exact<{
  bookingUid: Scalars['String']['input'];
}>;


export type GetBookingForEditBookingPageQuery = { __typename?: 'Query', getBooking: { __typename?: 'Booking', uid: string, startDateTime: number, serviceOfferingUid: string, ownerUid: string, appointmentUid: string, isInProgress: boolean, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, shortDesc?: string | null, basePrice: number, baseTime: number, allowTip: boolean, type: ServiceOfferingType, maxConcurrentBookings: number, ownerUid: string, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, title: string, type: CustomerInputType, required: boolean, description?: string | null, unitPrice?: number | null, index?: number | null, options: Array<{ __typename?: 'CustomerInputOption', value: string, duration: number, price: number, uid: string }> }> }, owner: { __typename?: 'User', uid: string, fullName: string, emailAddress: string }, appointment: { __typename?: 'Appointment', userUid: string, startDateTime: number, locationUid: string, location: { __typename?: 'Location', id: string, type: LocationType }, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, displayName: string, profile?: { __typename?: 'Profile', displayName: string } | null, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, shortDesc?: string | null, basePrice: number, baseTime: number, allowTip: boolean, type: ServiceOfferingType, maxConcurrentBookings: number, ownerUid: string, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, title: string, type: CustomerInputType, required: boolean, description?: string | null, unitPrice?: number | null, index?: number | null, options: Array<{ __typename?: 'CustomerInputOption', value: string, duration: number, price: number, uid: string }> }> }>, dateAvailability: Array<{ __typename?: 'DateAvailability', date: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }> }, bookings: Array<{ __typename?: 'Booking', id: string, uid: string }> }, dropoff?: { __typename?: 'Dropoff', id: string, dropoffDateTime: number } | null } };

export type GetBookingForOrderDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBookingForOrderDetailsQuery = { __typename?: 'Query', getBookingById?: { __typename?: 'Booking', uid: string, id: string, startDateTime: number, endDateTime: number, isComplete: boolean, appointment: { __typename?: 'Appointment', uid: string, location: { __typename?: 'Location', id: string, streetAddress: string, formattedAddress: string }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, files: Array<{ __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } }> } | null }, owner: { __typename?: 'User', emailAddress: string, fullName: string, phoneNumber?: string | null }, accountingRecord?: { __typename?: 'AccountingRecord', uid: string, tipAmount: number, subTotal: number, totalTaxAmount: number, total: number, lineItems: Array<{ __typename?: 'DetailedPrice', displayName: string, discountedPrice: number }> } | null } | null };

export type GetBookingPriceBreakdownForBookingQueryVariables = Exact<{
  bookingUid: Scalars['String']['input'];
}>;


export type GetBookingPriceBreakdownForBookingQuery = { __typename?: 'Query', getBookingPriceBreakdownForBooking: { __typename?: 'BookingPriceBreakdown', total: number, subTotal: number, discountedSubTotal: number, taxAmount: number, tipAmount: number, customerInputs: Array<{ __typename?: 'CustomerInputPriceBreakdown', displayName: string, selectedOptions: Array<{ __typename?: 'DetailedPrice', discountedPrice: number, basePrice: number, displayName: string }> }>, serviceOffering: { __typename?: 'DetailedPrice', displayName: string, discountedPrice: number, basePrice: number }, discountsApplied: Array<{ __typename?: 'DiscountApplied', displayName: string, amountDiscounted: number }>, customLineItems: Array<{ __typename?: 'DetailedPrice', displayName: string, discountedPrice: number }> } };

export type GetBookingPriceBreakdownQueryVariables = Exact<{
  bookingSelections: BookingSelectionsInput;
  formattedAddress: Scalars['String']['input'];
  bookingUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBookingPriceBreakdownQuery = { __typename?: 'Query', getBookingPriceBreakdown: { __typename?: 'BookingPriceBreakdown', total: number, subTotal: number, discountedSubTotal: number, taxAmount: number } };

export type GetBookingWithAccountingRecordQueryVariables = Exact<{
  bookingUid: Scalars['String']['input'];
}>;


export type GetBookingWithAccountingRecordQuery = { __typename?: 'Query', getBooking: { __typename?: 'Booking', uid: string, startDateTime: number, serviceOfferingUid: string, ownerUid: string, appointmentUid: string, tipPercent: number, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, customerInputs: Array<{ __typename?: 'CustomerInput', unitPrice?: number | null, title: string, type: CustomerInputType, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> }, accountingRecord?: { __typename?: 'AccountingRecord', total: number, subTotal: number, tipAmount: number, totalTaxAmount: number, discountedAmount: number, stripePaymentIntent: { __typename?: 'PaymentIntent', paymentMethod: { __typename?: 'PaymentMethod', card: { __typename?: 'Card', brand: string, lastFour: string } } } } | null, appointment: { __typename?: 'Appointment', userUid: string, isCoveredByBusiness?: boolean | null, location: { __typename?: 'Location', id: string, streetAddress: string }, serviceProvider: { __typename?: 'ServiceProvider', displayName: string, serviceType: string, slug: string, profile?: { __typename?: 'Profile', avatarImage?: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null } | null } } } };

export type GetBookingQueryVariables = Exact<{
  bookingUid: Scalars['String']['input'];
}>;


export type GetBookingQuery = { __typename?: 'Query', getBooking: { __typename?: 'Booking', uid: string, startDateTime: number, serviceOfferingUid: string, ownerUid: string, appointmentUid: string, isInProgress: boolean, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, shortDesc?: string | null, basePrice: number, baseTime: number, allowTip: boolean, type: ServiceOfferingType, maxConcurrentBookings: number, ownerUid: string, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, title: string, type: CustomerInputType, required: boolean, description?: string | null, unitPrice?: number | null, index?: number | null, options: Array<{ __typename?: 'CustomerInputOption', value: string, duration: number, price: number, uid: string }> }> }, owner: { __typename?: 'User', uid: string, fullName: string, emailAddress: string }, appointment: { __typename?: 'Appointment', userUid: string, startDateTime: number, locationUid: string, location: { __typename?: 'Location', id: string, type: LocationType }, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, displayName: string, profile?: { __typename?: 'Profile', displayName: string } | null, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, shortDesc?: string | null, basePrice: number, baseTime: number, allowTip: boolean, type: ServiceOfferingType, maxConcurrentBookings: number, ownerUid: string, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, title: string, type: CustomerInputType, required: boolean, description?: string | null, unitPrice?: number | null, index?: number | null, options: Array<{ __typename?: 'CustomerInputOption', value: string, duration: number, price: number, uid: string }> }> }>, dateAvailability: Array<{ __typename?: 'DateAvailability', date: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }> } }, dropoff?: { __typename?: 'Dropoff', id: string, dropoffDateTime: number } | null } };

export type GetBusinessActivityByAdminUidQueryVariables = Exact<{
  appointmentQuery: AppointmentQuery;
  locationSubscriptionQuery: LocationSubscriptionQuery;
}>;


export type GetBusinessActivityByAdminUidQuery = { __typename?: 'Query', getBusinessByAdminUid?: { __typename?: 'Business', name: string, locations: Array<{ __typename?: 'Location', id: string, uid: string, subscriptionsCount: number, appointments: Array<{ __typename?: 'Appointment', uid: string, bookingsWithSiblings: Array<{ __typename?: 'Booking', uid: string }> }> }> } | null };

export type GetBusinessByAdminUidForBusinessIndexPageQueryVariables = Exact<{
  appointmentQuery: AppointmentQuery;
}>;


export type GetBusinessByAdminUidForBusinessIndexPageQuery = { __typename?: 'Query', getBusinessByAdminUid?: { __typename?: 'Business', name: string, uid: string, locations: Array<{ __typename?: 'Location', id: string, uid: string, name: string, formattedAddress: string, appointments: Array<{ __typename?: 'Appointment', locationUid: string, isConfirmed: boolean, startDateTime: number, maxEndDateTime: number, uid: string, id: string, bookingsWithSiblings: Array<{ __typename?: 'Booking', uid: string, owner: { __typename?: 'User', fullName: string } }>, discountRuleProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, discountValue: number, discountType: DiscountType, priority: number, requireDurationBookedSeconds: number, requireBookingCount: number } }>, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, displayName: string, averageRating: number, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, index?: number | null }>, reviews: Array<{ __typename?: 'Review', isLike: boolean, isVerified: boolean }>, profile?: { __typename?: 'Profile', displayName: string, avatarImage?: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', items: Array<{ __typename?: 'PhotoGalleryItem', index: number, imageFile: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } }> } | null } | null, insuranceInformation?: { __typename?: 'InsuranceClaimableServiceProvider', titlePrefix?: string | null, titleSuffix?: string | null } | null }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string }> }> }> } | null };

export type GetBusinessByAdminUidQueryVariables = Exact<{
  appointmentQuery: AppointmentQuery;
}>;


export type GetBusinessByAdminUidQuery = { __typename?: 'Query', getBusinessByAdminUid?: { __typename?: 'Business', name: string, uid: string, slug: string, locations: Array<{ __typename?: 'Location', id: string, uid: string, name: string, formattedAddress: string, appointments: Array<{ __typename?: 'Appointment', id: string, startDateTime: number, locationUid: string, isConfirmed: boolean, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string } | null, bookingsWithSiblings: Array<{ __typename?: 'Booking', uid: string }>, serviceProvider: { __typename?: 'ServiceProvider', displayName: string, serviceType: string } }> }> } | null };

export type GetBusinessBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  minStartDateTime: Scalars['Int']['input'];
}>;


export type GetBusinessBySlugQuery = { __typename?: 'Query', getBusinessBySlug?: { __typename?: 'Business', name: string, uid: string, slug: string, locations: Array<{ __typename?: 'Location', id: string, uid: string, name: string, formattedAddress: string, streetAddress: string, slug: string, extendedAddress?: string | null, phoneNumber: string, type: LocationType, ownerUid: string, externalUid?: string | null, files: Array<{ __typename?: 'File', uid: string, index?: number | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } }>, appointments: Array<{ __typename?: 'Appointment', startDateTime: number, maxEndDateTime: number, uid: string, id: string, isCoveredByBusiness?: boolean | null, bookingsWithSiblings: Array<{ __typename?: 'Booking', uid: string, owner: { __typename?: 'User', fullName: string } }>, discountRuleProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, discountValue: number, discountType: DiscountType, priority: number, requireDurationBookedSeconds: number, requireBookingCount: number } }>, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, displayName: string, averageRating: number, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, index?: number | null }>, reviews: Array<{ __typename?: 'Review', isLike: boolean, isVerified: boolean }>, profile?: { __typename?: 'Profile', displayName: string, avatarImage?: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', items: Array<{ __typename?: 'PhotoGalleryItem', index: number, imageFile: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } }> } | null } | null, insuranceInformation?: { __typename?: 'InsuranceClaimableServiceProvider', titlePrefix?: string | null, titleSuffix?: string | null } | null }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string }>, eventOffering?: { __typename?: 'EventOffering', id: string, title: string, description: string, type: EventOfferingType, baseDuration: number, maxBookings: number, attendanceServiceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number } } | null }> }> } | null };

export type GetBusinessHasLinkedStripeSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessHasLinkedStripeSourceQuery = { __typename?: 'Query', getBusinessHasLinkedStripeSource: boolean };

export type GetBusinessLocationsByAdminUidQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessLocationsByAdminUidQuery = { __typename?: 'Query', getBusinessByAdminUid?: { __typename?: 'Business', uid: string, name: string, locations: Array<{ __typename?: 'Location', id: string, uid: string, latitude: number, longitude: number, streetAddress: string, name: string }> } | null };

export type GetBusinessUidByAdminUidQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessUidByAdminUidQuery = { __typename?: 'Query', getBusinessByAdminUid?: { __typename?: 'Business', uid: string, name: string } | null };

export type V2Gateway_GetBusinessQueryVariables = Exact<{
  businessUid: Scalars['String']['input'];
}>;


export type V2Gateway_GetBusinessQuery = { __typename?: 'Query', getBusiness?: { __typename?: 'Business', uid: string } | null };

export type GetCustomLineItemsByBookingIdQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type GetCustomLineItemsByBookingIdQuery = { __typename?: 'Query', getCustomLineItemsByBookingId: Array<{ __typename?: 'CustomLineItem', id: string, name: string, description?: string | null, price: number, durationMinutes: number, taxRateToggle?: { __typename?: 'TaxRateToggle', disabledTaxRateLineItems: Array<string> } | null }> };

export type GetCustomerBookingsQueryVariables = Exact<{
  query: BookingQuery;
}>;


export type GetCustomerBookingsQuery = { __typename?: 'Query', queryBookings: { __typename?: 'BookingQueryResult', bookings: Array<{ __typename?: 'Booking', isInProgress: boolean, startDateTime: number, endDateTime: number, uid: string, ownerUid: string, tipPercent: number, price: number, appointment: { __typename?: 'Appointment', uid: string, id: string, isConfirmed: boolean, startDateTime: number, maxEndDateTime: number, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, bookingsWithSiblings: Array<{ __typename?: 'Booking', uid: string, owner: { __typename?: 'User', fullName: string } }>, discountRuleProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, discountValue: number, discountType: DiscountType, priority: number, requireDurationBookedSeconds: number, requireBookingCount: number } }>, location: { __typename?: 'Location', uid: string, id: string, streetAddress: string, name: string, type: LocationType, phoneNumber: string, formattedAddress: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null } }, serviceProvider: { __typename?: 'ServiceProvider', serviceType: string, ownerUid: string, displayName: string, slug: string, reviewCount: number, averageRating: number, profile?: { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string }>, reviews: Array<{ __typename?: 'Review', uid: string, isLike: boolean }> } }, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', customerInputUids: Array<string>, optionValues: Array<string>, level: number }>> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, shortDesc?: string | null, basePrice: number, baseTime: number, type: ServiceOfferingType } }> } };

export type GetCustomerByUserIdForBookingDetailsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetCustomerByUserIdForBookingDetailsQuery = { __typename?: 'Query', getCustomerByUserId?: { __typename?: 'Customer', id: string, profiles: Array<{ __typename?: 'CustomerProfile', id: string, customerID: string, label: string, fieldValues: Array<{ __typename?: 'CustomerProfileFieldValue', customerProfileFieldID: string, value: string }>, notes: Array<{ __typename?: 'CustomerProfileNote', id: string, text: string, title: string, createdAt: number }> }> } | null };

export type GetCustomerByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetCustomerByUserIdQuery = { __typename?: 'Query', getCustomerByUserId?: { __typename?: 'Customer', id: string } | null };

export type GetCustomerForCustomerDetailsQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  remindersMinDateTime: Scalars['Int']['input'];
  remindersMaxDateTime: Scalars['Int']['input'];
}>;


export type GetCustomerForCustomerDetailsQuery = { __typename?: 'Query', getCustomer?: { __typename?: 'Customer', id: string, user: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null, locations: Array<{ __typename?: 'Location', id: string, streetAddress: string }> }, profiles: Array<{ __typename?: 'CustomerProfile', id: string, label: string, fieldValues: Array<{ __typename?: 'CustomerProfileFieldValue', customerProfileFieldID: string, value: string }>, notes: Array<{ __typename?: 'CustomerProfileNote', id: string, text: string, title: string, createdAt: number }> }>, reminders: { __typename?: 'ServiceProviderReminderPage', hasNextPage: boolean, reminders: Array<{ __typename?: 'ServiceProviderReminder', id: string, label: string, text: string, dateTime: number, customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', fullName: string } } }> }, bookings: Array<{ __typename?: 'Booking', uid: string, id: string, startDateTime: number, customerProfileId: string, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string }, review?: { __typename?: 'Review', uid: string, rating: number, createdAt: number, text: string } | null }> } | null };

export type GetCustomerProfileFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerProfileFieldsQuery = { __typename?: 'Query', getCustomerProfileFieldsForServiceProvider: Array<{ __typename?: 'CustomerProfileField', id: string, title: string, description: string, serviceProviderId: string, type: CustomerProfileFieldType, index: number, options: Array<{ __typename?: 'CustomerProfileFieldOption', id: string, value: string }> }> };

export type GetCustomerProfilesQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerProfilesQuery = { __typename?: 'Query', getCustomerProfilesForCustomer: Array<{ __typename?: 'CustomerProfile', id: string, customerID: string, label: string, fieldValues: Array<{ __typename?: 'CustomerProfileFieldValue', customerProfileFieldID: string, value: string }>, notes: Array<{ __typename?: 'CustomerProfileNote', id: string, text: string, title: string, createdAt: number }> }> };

export type GetCustomerQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerQuery = { __typename?: 'Query', getCustomer?: { __typename?: 'Customer', id: string, user: { __typename?: 'User', fullName: string, locations: Array<{ __typename?: 'Location', id: string, uid: string, placeId: string, formattedAddress: string, name: string }> } } | null };

export type GetPaymentMethodsForCustomersQueryVariables = Exact<{
  customerIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetPaymentMethodsForCustomersQuery = { __typename?: 'Query', getPaymentMethodsForCustomers: Array<{ __typename?: 'PaymentMethodsForCustomer', customerId: string, cards: Array<{ __typename?: 'Card', expMonth: number, expYear: number }> }> };

export type GetDiscountRulesForServiceProviderQueryVariables = Exact<{
  includeDisabled: Scalars['Boolean']['input'];
}>;


export type GetDiscountRulesForServiceProviderQuery = { __typename?: 'Query', getDiscountRulesForServiceProvider: { __typename?: 'DiscountRuleSearchResult', hasMoreResults: boolean, discountRules: Array<{ __typename?: 'DiscountRule', id: string, isDisabled: boolean, label: string, discountValue: number, discountType: DiscountType, priority: number, triggerCondition: { __typename?: 'DiscountRuleTriggerCondition', siblingBookingTriggerCondition?: { __typename?: 'SiblingBookingTriggerCondition', requireBookingCount: number, ignoreServiceOfferingUids: Array<string> } | null, timeDurationBookedAtLocationTriggerCondition?: { __typename?: 'TimeDurationBookedAtLocationTriggerCondition', requireDurationBookedSeconds: number, ignoreServiceOfferingUids: Array<string> } | null } }> } };

export type GetDiscountRulesProgressQueryVariables = Exact<{
  appointmentUID: Scalars['String']['input'];
}>;


export type GetDiscountRulesProgressQuery = { __typename?: 'Query', getDiscountRulesProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, discountValue: number, discountType: DiscountType, priority: number, requireDurationBookedSeconds: number, requireBookingCount: number } }> };

export type GetDropoffsForServiceProviderCalendarQueryVariables = Exact<{
  query: DropoffQuery;
}>;


export type GetDropoffsForServiceProviderCalendarQuery = { __typename?: 'Query', getDropoffsForServiceProvider: { __typename?: 'DropoffSearchResult', dropoffs: Array<{ __typename?: 'Dropoff', id: string, dropoffDateTime: number, booking: { __typename?: 'Booking', id: string, uid: string, customerProfileId: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType }, appointment: { __typename?: 'Appointment', uid: string, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string } | null, location: { __typename?: 'Location', id: string, streetAddress: string, type: LocationType, name: string } }, customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, profiles: Array<{ __typename?: 'CustomerProfile', id: string, customerID: string, label: string, fieldValues: Array<{ __typename?: 'CustomerProfileFieldValue', customerProfileFieldID: string, value: string }>, notes: Array<{ __typename?: 'CustomerProfileNote', id: string, text: string, title: string, createdAt: number }> }> } } }> } };

export type GetDropoffsForServiceProviderWithServiceAreaFilesQueryVariables = Exact<{
  query: DropoffQuery;
}>;


export type GetDropoffsForServiceProviderWithServiceAreaFilesQuery = { __typename?: 'Query', getDropoffsForServiceProvider: { __typename?: 'DropoffSearchResult', dropoffs: Array<{ __typename?: 'Dropoff', dropoffDateTime: number, status: DropoffStatus, booking: { __typename?: 'Booking', id: string, uid: string, customerProfileId: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType }, appointment: { __typename?: 'Appointment', uid: string, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, files: Array<{ __typename?: 'File', uid: string, index?: number | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null } }, customer: { __typename?: 'Customer', id: string, profiles: Array<{ __typename?: 'CustomerProfile', id: string, customerID: string, label: string, fieldValues: Array<{ __typename?: 'CustomerProfileFieldValue', customerProfileFieldID: string, value: string }>, notes: Array<{ __typename?: 'CustomerProfileNote', id: string, text: string, title: string, createdAt: number }> }>, user: { __typename?: 'User', id: string, fullName: string, emailAddress: string } } } }> } };

export type GetEmailTemplateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetEmailTemplateQuery = { __typename?: 'Query', getEmailTemplate?: { __typename?: 'EmailTemplate', id: string, templateType: TemplateTopicType, serviceProviderId: string, subject: string, htmlBody: string, mjmlJson: string } | null };

export type GetEmailTemplatesForServiceProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailTemplatesForServiceProviderQuery = { __typename?: 'Query', getEmailTemplatesForServiceProvider: Array<{ __typename?: 'EmailTemplate', id: string, templateType: TemplateTopicType, serviceProviderId: string, subject: string, htmlBody: string, mjmlJson: string }> };

export type GetEventOfferingQueryVariables = Exact<{
  eventOfferingId: Scalars['String']['input'];
}>;


export type GetEventOfferingQuery = { __typename?: 'Query', getEventOffering?: { __typename?: 'EventOffering', id: string, title: string, description: string, basePrice: number, baseDuration: number, type: EventOfferingType, maxBookings: number, serviceProviderId: string, index?: number | null, serviceOfferingUids: Array<string> } | null };

export type GetEventOfferingsForServiceProviderQueryVariables = Exact<{
  serviceProviderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEventOfferingsForServiceProviderQuery = { __typename?: 'Query', getEventOfferingsForServiceProvider: Array<{ __typename?: 'EventOffering', id: string, title: string, description: string, basePrice: number, baseDuration: number, type: EventOfferingType, maxBookings: number, serviceProviderId: string, index?: number | null, serviceOfferingUids: Array<string>, isPublished: boolean }> };

export type GetHasSquareLinkedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHasSquareLinkedQuery = { __typename?: 'Query', getHasSquareLinked: boolean };

export type GetIsGoogleCalendarLinkedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsGoogleCalendarLinkedQuery = { __typename?: 'Query', getIsGoogleCalendarLinked: boolean };

export type GetLocationByIdQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
}>;


export type GetLocationByIdQuery = { __typename?: 'Query', getLocationById?: { __typename?: 'Location', uid: string, id: string, formattedAddress: string, phoneNumber: string, streetAddress: string, placeId: string, type: LocationType, latitude: number, longitude: number, name: string } | null };

export type GetLocationBySlugAndBusinessUidQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  businessUid: Scalars['String']['input'];
  minStartDateTime: Scalars['Int']['input'];
}>;


export type GetLocationBySlugAndBusinessUidQuery = { __typename?: 'Query', getLocationBySlugAndBusinessUid?: { __typename?: 'Location', id: string, formattedAddress: string, name: string, externalUid?: string | null, ownerUid: string, type: LocationType, phoneNumber: string, uid: string, slug: string, files: Array<{ __typename?: 'File', uid: string, index?: number | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } }>, appointments: Array<{ __typename?: 'Appointment', startDateTime: number, maxEndDateTime: number, uid: string, id: string, isCoveredByBusiness?: boolean | null, bookingsWithSiblings: Array<{ __typename?: 'Booking', uid: string, owner: { __typename?: 'User', fullName: string } }>, discountRuleProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, discountValue: number, discountType: DiscountType, priority: number, requireDurationBookedSeconds: number, requireBookingCount: number } }>, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, displayName: string, averageRating: number, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, index?: number | null }>, reviews: Array<{ __typename?: 'Review', isLike: boolean, isVerified: boolean }>, profile?: { __typename?: 'Profile', displayName: string, avatarImage?: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', items: Array<{ __typename?: 'PhotoGalleryItem', index: number, imageFile: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } }> } | null } | null, insuranceInformation?: { __typename?: 'InsuranceClaimableServiceProvider', titlePrefix?: string | null, titleSuffix?: string | null } | null }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string }>, eventOffering?: { __typename?: 'EventOffering', id: string, title: string, description: string, type: EventOfferingType, baseDuration: number, maxBookings: number, attendanceServiceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number } } | null }> } | null };

export type GetLocationSubscriptionsWithUpcomingAppointmentsQueryVariables = Exact<{
  min: Scalars['Int']['input'];
  serviceType: Scalars['String']['input'];
}>;


export type GetLocationSubscriptionsWithUpcomingAppointmentsQuery = { __typename?: 'Query', getLocationSubscriptions: Array<{ __typename?: 'LocationSubscription', location: { __typename?: 'Location', id: string, name: string, extendedAddress?: string | null, formattedAddress: string, uid: string, appointments: Array<{ __typename?: 'Appointment', startDateTime: number, id: string, bookingsWithSiblings: Array<{ __typename?: 'Booking', uid: string, owner: { __typename?: 'User', fullName: string } }>, serviceProvider: { __typename?: 'ServiceProvider', displayName: string, serviceType: string }, discountRuleProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, discountValue: number, discountType: DiscountType, priority: number, requireDurationBookedSeconds: number, requireBookingCount: number } }> }> } }> };

export type GetLocationsForNavQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsForNavQuery = { __typename?: 'Query', getLocations: Array<{ __typename?: 'Location', id: string, streetAddress: string, placeId: string, latitude: number, longitude: number }>, getLocationSubscriptions: Array<{ __typename?: 'LocationSubscription', location: { __typename?: 'Location', id: string, streetAddress: string, placeId: string, latitude: number, longitude: number } }> };

export type GetOptimalOpenTimeForServiceProviderForLatLngQueryVariables = Exact<{
  dateUnix: Scalars['Int']['input'];
  serviceProviderUid: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
}>;


export type GetOptimalOpenTimeForServiceProviderForLatLngQuery = { __typename?: 'Query', getOptimalOpenTimeForServiceProviderForLatLng: number };

export type GetOptimalOpenTimeForServiceProviderForLocationQueryVariables = Exact<{
  dateUnix: Scalars['Int']['input'];
  serviceProviderUid: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
}>;


export type GetOptimalOpenTimeForServiceProviderForLocationQuery = { __typename?: 'Query', getOptimalOpenTimeForServiceProviderForLocation: number };

export type GetOrInitializeEventCartMutationVariables = Exact<{
  serviceProviderId: Scalars['String']['input'];
  locationUid: Scalars['String']['input'];
}>;


export type GetOrInitializeEventCartMutation = { __typename?: 'Mutation', getOrInitializeEventCart: { __typename?: 'EventCart', id: string, startDateTime: number, eventEndDateTime?: number | null, enabledServiceOfferingUids: Array<string>, note: string, serviceAreaUid?: string | null, isCoveredByBusiness?: boolean | null, locationUid: string, serviceProvider: { __typename?: 'ServiceProvider', displayName: string, ownerUid: string, serviceType: string, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, type: ServiceOfferingType }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, dateAvailability: Array<{ __typename?: 'DateAvailability', date: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }> }, enabledServiceOfferings: Array<{ __typename?: 'ServiceOffering', title: string, basePrice: number, baseTime: number, uid: string }> } };

export type GetPaymentMethodsForCustomerQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetPaymentMethodsForCustomerQuery = { __typename?: 'Query', getPaymentMethodsForCustomer: Array<{ __typename?: 'Card', brand: string, lastFour: string, expMonth: number, expYear: number, id: string }> };

export type GetPeazyPluginInstallationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPeazyPluginInstallationQuery = { __typename?: 'Query', getPeazyPluginInstallationById: { __typename?: 'PeazyPluginInstallation', id: string, isDisabled: boolean, createdAt: number, updatedAt: number, configurationData: string, pluginListing: { __typename?: 'PeazyPluginListing', id: string, name: string, description: string, iconURL: string } } };

export type GetPublicCustomerProfileFieldsQueryVariables = Exact<{
  serviceProviderId: Scalars['String']['input'];
}>;


export type GetPublicCustomerProfileFieldsQuery = { __typename?: 'Query', getPublicCustomerProfileFieldsForServiceProvider: Array<{ __typename?: 'CustomerProfileField', id: string, title: string, description: string, serviceProviderId: string, type: CustomerProfileFieldType, options: Array<{ __typename?: 'CustomerProfileFieldOption', id: string, value: string }> }> };

export type GetReceiptConfigForServiceProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReceiptConfigForServiceProviderQuery = { __typename?: 'Query', getReceiptConfigForServiceProvider?: { __typename?: 'ReceiptConfig', id: string, serviceProviderId: string, headerTextTemplate: string, finePrint: string, createdAt: number, updatedAt: number } | null };

export type GetResetPasswordLinkMutationVariables = Exact<{
  returnTo: Scalars['String']['input'];
}>;


export type GetResetPasswordLinkMutation = { __typename?: 'Mutation', getResetPasswordLink: string };

export type GetServiceAreaQueryVariables = Exact<{
  serviceAreaUid: Scalars['String']['input'];
}>;


export type GetServiceAreaQuery = { __typename?: 'Query', getServiceArea: { __typename?: 'ServiceArea', uid: string, name: string, description: string, files: Array<{ __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } }> } };

export type GetServiceAreasByLocationUidWithFilesQueryVariables = Exact<{
  locationUid: Scalars['String']['input'];
}>;


export type GetServiceAreasByLocationUidWithFilesQuery = { __typename?: 'Query', getServiceAreasByLocationUid: Array<{ __typename?: 'ServiceArea', name: string, description: string, uid: string, files: Array<{ __typename?: 'File', label?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } }> }> };

export type GetServiceAreasQueryVariables = Exact<{
  uids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetServiceAreasQuery = { __typename?: 'Query', getServiceAreas: Array<{ __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> }> };

export type GetServiceAreasByLocationUidQueryVariables = Exact<{
  locationUid: Scalars['String']['input'];
}>;


export type GetServiceAreasByLocationUidQuery = { __typename?: 'Query', getServiceAreasByLocationUid: Array<{ __typename?: 'ServiceArea', uid: string, name: string }> };

export type GetServiceOfferingsAndEventOfferingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceOfferingsAndEventOfferingsQuery = { __typename?: 'Query', getThisServiceProvider: { __typename?: 'ServiceProvider', eventOfferings: Array<{ __typename?: 'EventOffering', id: string, title: string, description: string, basePrice: number, baseDuration: number, type: EventOfferingType, maxBookings: number, serviceProviderId: string, index?: number | null, serviceOfferingUids: Array<string>, isPublished: boolean }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', title: string, uid: string }> } };

export type GetServiceOfferingsForServiceProviderQueryVariables = Exact<{
  serviceProviderUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetServiceOfferingsForServiceProviderQuery = { __typename?: 'Query', getServiceOfferingsForServiceProvider: Array<{ __typename?: 'ServiceOffering', title: string, imageUrl?: string | null, basePrice: number, baseTime: number, uid: string, shortDesc?: string | null, type: ServiceOfferingType, maxConcurrentBookings: number, allowTip: boolean, index?: number | null, postServiceNote: string, isHidden: boolean }> };

export type GetAppointmentsForServiceProviderAtSelectedLocationQueryVariables = Exact<{
  userUid?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<AppointmentQuery>;
}>;


export type GetAppointmentsForServiceProviderAtSelectedLocationQuery = { __typename?: 'Query', getAppointmentsForUser: Array<{ __typename?: 'Appointment', id: string, uid: string, startDateTime: number, location: { __typename?: 'Location', uid: string, id: string, placeId: string } }> };

export type GetServiceProviderAppointmentsCountQueryVariables = Exact<{
  userUid: Scalars['String']['input'];
  query?: InputMaybe<AppointmentQuery>;
}>;


export type GetServiceProviderAppointmentsCountQuery = { __typename?: 'Query', getAppointmentsForUser: Array<{ __typename?: 'Appointment', uid: string }> };

export type GetServiceProviderByIdWithPreferencesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetServiceProviderByIdWithPreferencesQuery = { __typename?: 'Query', getServiceProviderById: { __typename?: 'ServiceProvider', serviceType: string, id: string, displayName: string, averageRating: number, reviewCount: number, reviews: Array<{ __typename?: 'Review', uid: string, createdAt: number, isLike: boolean, text: string, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, user: { __typename?: 'User', id: string, uid: string }, profile?: { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, type: ServiceOfferingType }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }>, location: { __typename?: 'Location', id: string, formattedAddress: string, phoneNumber: string, discoverableBounds: { __typename?: 'GeoBounds', min: { __typename?: 'GeoPoint', lat: number, lng: number }, max: { __typename?: 'GeoPoint', lat: number, lng: number } } } } };

export type GetServiceProviderByIdQueryVariables = Exact<{
  serviceProviderId: Scalars['String']['input'];
}>;


export type GetServiceProviderByIdQuery = { __typename?: 'Query', getServiceProviderById: { __typename?: 'ServiceProvider', id: string, serviceType: string, displayName: string, averageRating: number, reviewCount: number, reviews: Array<{ __typename?: 'Review', uid: string, createdAt: number, isLike: boolean, text: string, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, user: { __typename?: 'User', id: string }, profile?: { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, type: ServiceOfferingType }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, location: { __typename?: 'Location', id: string, phoneNumber: string, discoverableBounds: { __typename?: 'GeoBounds', min: { __typename?: 'GeoPoint', lat: number, lng: number }, max: { __typename?: 'GeoPoint', lat: number, lng: number } } } } };

export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery = { __typename?: 'Query', getServiceProviderBySlug?: { __typename?: 'ServiceProvider', slug: string, serviceType: string, id: string, displayName: string, averageRating: number, reviewCount: number, eventOfferings: Array<{ __typename?: 'EventOffering', id: string, title: string, description: string, basePrice: number, baseDuration: number, type: EventOfferingType, maxBookings: number, serviceProviderId: string, index?: number | null, serviceOfferingUids: Array<string>, isPublished: boolean }>, reviews: Array<{ __typename?: 'Review', uid: string, createdAt: number, isLike: boolean, rating: number, text: string, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, user: { __typename?: 'User', id: string, uid: string, emailAddress: string, timezoneLocation: string }, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, type: ServiceOfferingType }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, discountRules: Array<{ __typename?: 'DiscountRule', id: string, isDisabled: boolean, label: string, discountValue: number, discountType: DiscountType, priority: number, triggerCondition: { __typename?: 'DiscountRuleTriggerCondition', siblingBookingTriggerCondition?: { __typename?: 'SiblingBookingTriggerCondition', requireBookingCount: number, ignoreServiceOfferingUids: Array<string> } | null, timeDurationBookedAtLocationTriggerCondition?: { __typename?: 'TimeDurationBookedAtLocationTriggerCondition', requireDurationBookedSeconds: number, ignoreServiceOfferingUids: Array<string> } | null } }>, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }>, location: { __typename?: 'Location', id: string, formattedAddress: string, phoneNumber: string, discoverableBounds: { __typename?: 'GeoBounds', min: { __typename?: 'GeoPoint', lat: number, lng: number }, max: { __typename?: 'GeoPoint', lat: number, lng: number } } } } | null };

export type ServiceProviderBySlugWithDiscountRulesAndPreferencesFragment = { __typename?: 'ServiceProvider', slug: string, serviceType: string, id: string, displayName: string, averageRating: number, reviewCount: number, reviews: Array<{ __typename?: 'Review', uid: string, createdAt: number, isLike: boolean, rating: number, text: string, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, user: { __typename?: 'User', id: string, uid: string, emailAddress: string, timezoneLocation: string }, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, type: ServiceOfferingType }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, discountRules: Array<{ __typename?: 'DiscountRule', id: string, isDisabled: boolean, label: string, discountValue: number, discountType: DiscountType, priority: number, triggerCondition: { __typename?: 'DiscountRuleTriggerCondition', siblingBookingTriggerCondition?: { __typename?: 'SiblingBookingTriggerCondition', requireBookingCount: number, ignoreServiceOfferingUids: Array<string> } | null, timeDurationBookedAtLocationTriggerCondition?: { __typename?: 'TimeDurationBookedAtLocationTriggerCondition', requireDurationBookedSeconds: number, ignoreServiceOfferingUids: Array<string> } | null } }>, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }>, location: { __typename?: 'Location', id: string, formattedAddress: string, phoneNumber: string, discoverableBounds: { __typename?: 'GeoBounds', min: { __typename?: 'GeoPoint', lat: number, lng: number }, max: { __typename?: 'GeoPoint', lat: number, lng: number } } } };

export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery = { __typename?: 'Query', getServiceProviderBySlug?: { __typename?: 'ServiceProvider', slug: string, serviceType: string, id: string, displayName: string, averageRating: number, reviewCount: number, reviews: Array<{ __typename?: 'Review', uid: string, createdAt: number, isLike: boolean, rating: number, text: string, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, user: { __typename?: 'User', id: string, uid: string, emailAddress: string, timezoneLocation: string }, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, type: ServiceOfferingType }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, discountRules: Array<{ __typename?: 'DiscountRule', id: string, isDisabled: boolean, label: string, discountValue: number, discountType: DiscountType, priority: number, triggerCondition: { __typename?: 'DiscountRuleTriggerCondition', siblingBookingTriggerCondition?: { __typename?: 'SiblingBookingTriggerCondition', requireBookingCount: number, ignoreServiceOfferingUids: Array<string> } | null, timeDurationBookedAtLocationTriggerCondition?: { __typename?: 'TimeDurationBookedAtLocationTriggerCondition', requireDurationBookedSeconds: number, ignoreServiceOfferingUids: Array<string> } | null } }>, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }>, location: { __typename?: 'Location', id: string, formattedAddress: string, phoneNumber: string, discoverableBounds: { __typename?: 'GeoBounds', min: { __typename?: 'GeoPoint', lat: number, lng: number }, max: { __typename?: 'GeoPoint', lat: number, lng: number } } } } | null };

export type GetServiceProviderBySlugQueryVariables = Exact<{
  serviceProviderSlug: Scalars['String']['input'];
}>;


export type GetServiceProviderBySlugQuery = { __typename?: 'Query', getServiceProviderBySlug?: { __typename?: 'ServiceProvider', serviceType: string, displayName: string, averageRating: number, reviewCount: number, reviews: Array<{ __typename?: 'Review', uid: string, createdAt: number, isLike: boolean, text: string, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, user: { __typename?: 'User', id: string }, profile?: { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, type: ServiceOfferingType }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, location: { __typename?: 'Location', id: string, phoneNumber: string } } | null };

export type GetServiceProviderCalendarEventsQueryVariables = Exact<{
  query: CalendarEventQuery;
}>;


export type GetServiceProviderCalendarEventsQuery = { __typename?: 'Query', getServiceProviderCalendarEvents: Array<{ __typename?: 'CalendarEvent', id: string, title: string, description: string, startDateTime: number, endDateTime: number, eventType: CalendarEventType }> };

export type GetServiceProviderBreakCalendarEventsQueryVariables = Exact<{
  query: CalendarEventQuery;
}>;


export type GetServiceProviderBreakCalendarEventsQuery = { __typename?: 'Query', getServiceProviderBreakCalendarEvents: Array<{ __typename?: 'CalendarEvent', id: string, title: string, description: string, startDateTime: number, endDateTime: number, eventType: CalendarEventType }> };

export type GetServiceProviderCompletableAppointmentsQueryVariables = Exact<{
  query?: InputMaybe<AppointmentQuery>;
}>;


export type GetServiceProviderCompletableAppointmentsQuery = { __typename?: 'Query', getAppointmentsForUser: Array<{ __typename?: 'Appointment', startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, eventEndDateTime?: number | null, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, bookings: Array<{ __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, id: string, customerProfileId: string, dropoff?: { __typename?: 'Dropoff', id: string, dropoffDateTime: number, status: DropoffStatus } | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType }, customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, profiles: Array<{ __typename?: 'CustomerProfile', id: string, customerID: string, label: string, fieldValues: Array<{ __typename?: 'CustomerProfileFieldValue', customerProfileFieldID: string, value: string }>, notes: Array<{ __typename?: 'CustomerProfileNote', id: string, text: string, title: string, createdAt: number }> }> } }> }> };

export type GetServiceProviderDefaultDropoffDeltaPreferencesQueryVariables = Exact<{
  serviceProviderUserUid: Scalars['String']['input'];
}>;


export type GetServiceProviderDefaultDropoffDeltaPreferencesQuery = { __typename?: 'Query', getServiceProviderDefaultDropoffDeltaDaysPreference: number, getServiceProviderIsDefaultDropoffDeltaBusinessDays: boolean };

export type GetServiceProviderForOnboardingFlowQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceProviderForOnboardingFlowQuery = { __typename?: 'Query', getThisServiceProvider: { __typename?: 'ServiceProvider', id: string, isGoogleCalendarLinked: boolean, displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, slug: string, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, isHidden: boolean, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, user: { __typename?: 'User', emailAddress: string, fullName: string, id: string, timezoneLocation: string, country: string }, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> } };

export type GetServiceProviderForServiceProviderDashboardServiceOfferingFieldsFragment = { __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, title: string, description?: string | null, type: CustomerInputType, required: boolean, index?: number | null, unitPrice?: number | null, options: Array<{ __typename?: 'CustomerInputOption', price: number, duration: number, value: string, uid: string }> }> };

export type GetServiceProviderForServiceProviderDashboardQueryVariables = Exact<{
  eventType?: InputMaybe<CalendarEventType>;
}>;


export type GetServiceProviderForServiceProviderDashboardQuery = { __typename?: 'Query', getThisServiceProvider: { __typename?: 'ServiceProvider', isGoogleCalendarLinked: boolean, displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, slug: string, user: { __typename?: 'User', id: string, fullName: string, country: string, timezoneLocation: string }, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, dateAvailability: Array<{ __typename?: 'DateAvailability', date: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, events: Array<{ __typename?: 'CalendarEvent', startDateTime: number, endDateTime: number, title: string, description: string, externalCalendarEventId?: string | null, id: string }>, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> } };

export type GetServiceProviderForShareButtonQueryVariables = Exact<{
  serviceProviderUserUid: Scalars['String']['input'];
}>;


export type GetServiceProviderForShareButtonQuery = { __typename?: 'Query', getServiceProvider: { __typename?: 'ServiceProvider', id: string, serviceType: string, slug: string } };

export type GetServiceProviderLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceProviderLocationsQuery = { __typename?: 'Query', getThisUserLocations: Array<{ __typename?: 'Location', uid: string, id: string, streetAddress: string, formattedAddress: string, name: string, type: LocationType, placeId: string, phoneNumber: string, extendedAddress?: string | null }> };

export type ReminderFieldsFragment = { __typename?: 'ServiceProviderReminder', id: string, label: string, text: string, dateTime: number, customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', fullName: string } } };

export type GetServiceProviderRemindersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  minDateTime: Scalars['Int']['input'];
  maxDateTime: Scalars['Int']['input'];
}>;


export type GetServiceProviderRemindersQuery = { __typename?: 'Query', getServiceProviderReminders: { __typename?: 'ServiceProviderReminderPage', hasNextPage: boolean, reminders: Array<{ __typename?: 'ServiceProviderReminder', id: string, label: string, text: string, dateTime: number, customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', fullName: string } } }> } };

export type GetServiceProviderRetailLocationsQueryVariables = Exact<{
  serviceProviderId: Scalars['String']['input'];
}>;


export type GetServiceProviderRetailLocationsQuery = { __typename?: 'Query', getServiceProviderRetailLocations: Array<{ __typename?: 'Location', uid: string, id: string, streetAddress: string, formattedAddress: string, name: string, type: LocationType, placeId: string, phoneNumber: string, extendedAddress?: string | null, latitude: number, longitude: number }> };

export type GetServiceProviderSlugsForSitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceProviderSlugsForSitemapQuery = { __typename?: 'Query', getServiceProviderSlugsForSitemap: Array<string> };

export type GetServiceProviderUidFromIdQueryVariables = Exact<{
  serviceProviderId: Scalars['String']['input'];
}>;


export type GetServiceProviderUidFromIdQuery = { __typename?: 'Query', getServiceProviderUid: string };

export type GetServiceProviderWithAvailabilityAndLocationQueryVariables = Exact<{
  ownerUid: Scalars['String']['input'];
}>;


export type GetServiceProviderWithAvailabilityAndLocationQuery = { __typename?: 'Query', getServiceProvider: { __typename?: 'ServiceProvider', id: string, displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, slug: string, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, dateAvailability: Array<{ __typename?: 'DateAvailability', date: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, location: { __typename?: 'Location', id: string, uid: string, discoverableBounds: { __typename?: 'GeoBounds', min: { __typename?: 'GeoPoint', lat: number, lng: number }, max: { __typename?: 'GeoPoint', lat: number, lng: number } } }, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, user: { __typename?: 'User', id: string, fullName: string, timezoneLocation: string, country: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> } };

export type GetServiceProviderWithAvailabilityDropoffsEventsQueryVariables = Exact<{
  eventType?: InputMaybe<CalendarEventType>;
}>;


export type GetServiceProviderWithAvailabilityDropoffsEventsQuery = { __typename?: 'Query', getThisServiceProvider: { __typename?: 'ServiceProvider', isGoogleCalendarLinked: boolean, displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, slug: string, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, dateAvailability: Array<{ __typename?: 'DateAvailability', date: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, events: Array<{ __typename?: 'CalendarEvent', startDateTime: number, endDateTime: number, title: string, description: string, externalCalendarEventId?: string | null, id: string }>, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, user: { __typename?: 'User', id: string, fullName: string, timezoneLocation: string, country: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> } };

export type GetServiceProviderWithDiscountRulesQueryVariables = Exact<{
  serviceProviderUid: Scalars['String']['input'];
}>;


export type GetServiceProviderWithDiscountRulesQuery = { __typename?: 'Query', getServiceProvider: { __typename?: 'ServiceProvider', displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, slug: string, location: { __typename?: 'Location', id: string, discoverableBounds: { __typename?: 'GeoBounds', min: { __typename?: 'GeoPoint', lat: number, lng: number }, max: { __typename?: 'GeoPoint', lat: number, lng: number } } }, discountRules: Array<{ __typename?: 'DiscountRule', id: string, isDisabled: boolean, label: string, discountValue: number, discountType: DiscountType, priority: number, triggerCondition: { __typename?: 'DiscountRuleTriggerCondition', siblingBookingTriggerCondition?: { __typename?: 'SiblingBookingTriggerCondition', requireBookingCount: number, ignoreServiceOfferingUids: Array<string> } | null, timeDurationBookedAtLocationTriggerCondition?: { __typename?: 'TimeDurationBookedAtLocationTriggerCondition', requireDurationBookedSeconds: number, ignoreServiceOfferingUids: Array<string> } | null } }>, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, user: { __typename?: 'User', id: string, fullName: string, timezoneLocation: string, country: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> } };

export type GetSetupIntentSecretForCustomerMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetSetupIntentSecretForCustomerMutation = { __typename?: 'Mutation', getSetupIntentSecretForCustomer: string };

export type GetSquareCardForCustomerQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  cardId: Scalars['ID']['input'];
}>;


export type GetSquareCardForCustomerQuery = { __typename?: 'Query', getSquareCardForCustomer?: { __typename?: 'SquareCard', id: string, cardBrand: string, last4: string, expMonth: string, expYear: string, cardholderName: string } | null };

export type GetStripeCustomerForCustomerQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetStripeCustomerForCustomerQuery = { __typename?: 'Query', getStripeCustomerForCustomer: { __typename?: 'StripeCustomer', defaultSource: string, defaultPaymentMethodId: string } };

export type GetThisCustomerQueryVariables = Exact<{
  serviceProviderId: Scalars['String']['input'];
}>;


export type GetThisCustomerQuery = { __typename?: 'Query', getThisCustomerForServiceProviderId?: { __typename?: 'Customer', id: string, profiles: Array<{ __typename?: 'CustomerProfile', id: string, customerID: string, label: string, fieldValues: Array<{ __typename?: 'CustomerProfileFieldValue', customerProfileFieldID: string, value: string }>, notes: Array<{ __typename?: 'CustomerProfileNote', id: string, text: string, title: string }> }> } | null };

export type GetThisServiceProviderCustomersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type GetThisServiceProviderCustomersQuery = { __typename?: 'Query', getThisServiceProvider: { __typename?: 'ServiceProvider', customersCount: number, customers: Array<{ __typename?: 'Customer', id: string, user: { __typename?: 'User', uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null } }>, user: { __typename?: 'User', country: string } } };

export type GetThisServiceProviderRetailLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetThisServiceProviderRetailLocationsQuery = { __typename?: 'Query', getThisServiceProviderRetailLocations: Array<{ __typename?: 'Location', uid: string, id: string, streetAddress: string, formattedAddress: string, name: string, type: LocationType, placeId: string, phoneNumber: string, extendedAddress?: string | null, latitude: number, longitude: number }> };

export type GetThisServiceProviderWithServiceOfferingsAndProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetThisServiceProviderWithServiceOfferingsAndProfileQuery = { __typename?: 'Query', getThisServiceProvider: { __typename?: 'ServiceProvider', id: string, displayName: string, slug: string, serviceType: string, profile?: { __typename?: 'Profile', avatarImage?: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', items: Array<{ __typename?: 'PhotoGalleryItem', index: number, imageFile: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } }> } | null } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', title: string, basePrice: number, shortDesc?: string | null, baseTime: number, imageUrl?: string | null, uid: string, type: ServiceOfferingType, allowTip: boolean, maxConcurrentBookings: number, index?: number | null, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }> }> } };

export type GetThisServiceProviderWithServiceOfferingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetThisServiceProviderWithServiceOfferingsQuery = { __typename?: 'Query', getThisServiceProvider: { __typename?: 'ServiceProvider', id: string, serviceOfferings: Array<{ __typename?: 'ServiceOffering', title: string, basePrice: number, shortDesc?: string | null, baseTime: number, imageUrl?: string | null, uid: string, type: ServiceOfferingType, allowTip: boolean, maxConcurrentBookings: number, index?: number | null, postServiceNote: string, isHidden: boolean, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }> }> } };

export type GetTravelTimesQueryVariables = Exact<{
  serviceProviderUid: Scalars['String']['input'];
  locationUid: Scalars['String']['input'];
  startDateTimes: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
}>;


export type GetTravelTimesQuery = { __typename?: 'Query', getServiceProviderTravelTimeForAppointment: Array<{ __typename?: 'UnavailableDatetime', startDateTime: number, endDateTime: number }> };

export type GetUserSubscriptionStatusQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetUserSubscriptionStatusQuery = { __typename?: 'Query', getUserSubscriptionStatus: { __typename?: 'SubscriptionStatus', isSubscribed: boolean, status: string } };

export type GetUserWithBusinessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWithBusinessQuery = { __typename?: 'Query', getUser: { __typename?: 'User', business?: { __typename?: 'Business', uid: string, locations: Array<{ __typename?: 'Location', id: string, uid: string }> } | null } };

export type GetUserWithLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWithLocationsQuery = { __typename?: 'Query', getUser: { __typename?: 'User', isTemporary: boolean, uid: string, locations: Array<{ __typename?: 'Location', uid: string, id: string, streetAddress: string, placeId: string, latitude: number, longitude: number, type: LocationType }> } };

export type ExchangeGoogleCalendarAccessCodeAndStoreTokenMutationVariables = Exact<{
  accessCode: Scalars['String']['input'];
}>;


export type ExchangeGoogleCalendarAccessCodeAndStoreTokenMutation = { __typename?: 'Mutation', exchangeGoogleCalendarAccessCodeAndStoreToken: Array<string> };

export type V2Gateway_GetIdentityHasLinkedStripeSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetIdentityHasLinkedStripeSourceQuery = { __typename?: 'Query', identityHasLinkedStripeSource: boolean };

export type V2Gateway_MigrateAnonymousIdentityMutationVariables = Exact<{
  anonymousIdToken: Scalars['String']['input'];
  ownerIdToken: Scalars['String']['input'];
}>;


export type V2Gateway_MigrateAnonymousIdentityMutation = { __typename?: 'Mutation', migrateAnonymousIdentity: boolean };

export type ImportSquareCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ImportSquareCustomerMutation = { __typename?: 'Mutation', importSquareCustomer: string };

export type ListSquareCardsForCustomerQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type ListSquareCardsForCustomerQuery = { __typename?: 'Query', listSquareCardsForCustomer: Array<{ __typename?: 'SquareCard', id: string, cardBrand: string, last4: string, expMonth: string, expYear: string, cardholderName: string }> };

export type GetLocationSubscriptionForOwnerForLocationQueryVariables = Exact<{
  locationUid: Scalars['String']['input'];
}>;


export type GetLocationSubscriptionForOwnerForLocationQuery = { __typename?: 'Query', getLocationSubscriptionForOwnerForLocation?: { __typename?: 'LocationSubscription', locationUid: string, ownerUid: string } | null };

export type QueryLocationSubscriptionsQueryVariables = Exact<{
  query: LocationSubscriptionQuery;
}>;


export type QueryLocationSubscriptionsQuery = { __typename?: 'Query', queryLocationSubscriptions: Array<{ __typename?: 'LocationSubscription', location: { __typename?: 'Location', id: string, uid: string, name: string, formattedAddress: string }, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null, uid: string } }> };

export type QueryLocationSubscriptionsCountQueryVariables = Exact<{
  query: LocationSubscriptionQuery;
}>;


export type QueryLocationSubscriptionsCountQuery = { __typename?: 'Query', queryLocationSubscriptionsCount: number };

export type RecordAticMutationVariables = Exact<{
  type: AnalyticsEventType;
  metadata?: InputMaybe<AnalyticsEventMetadataInput>;
}>;


export type RecordAticMutation = { __typename?: 'Mutation', recordAtic: boolean };

export type RefreshSessionMutationVariables = Exact<{
  idToken: Scalars['String']['input'];
}>;


export type RefreshSessionMutation = { __typename?: 'Mutation', refreshSession: boolean };

export type RegisterBookingIdForCustomerMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type RegisterBookingIdForCustomerMutation = { __typename?: 'Mutation', registerBookingIdForCustomer: string };

export type RegisterBusinessMutationVariables = Exact<{
  idToken: Scalars['String']['input'];
  timezoneLocation: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  business: BusinessInput;
}>;


export type RegisterBusinessMutation = { __typename?: 'Mutation', registerBusiness: string };

export type RegisterServiceProviderMutationVariables = Exact<{
  idToken: Scalars['String']['input'];
  country: Scalars['String']['input'];
  timezoneLocation: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
}>;


export type RegisterServiceProviderMutation = { __typename?: 'Mutation', createServiceProvider: string };

export type SearchCustomersQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchCustomersQuery = { __typename?: 'Query', searchCustomers: { __typename?: 'SearchCustomersResult', hasMoreResults: boolean, customers: Array<{ __typename?: 'Customer', id: string, user: { __typename?: 'User', uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null } }> } };

export type ServiceOfferingWithCustomerInputsFragment = { __typename?: 'ServiceOffering', uid: string, title: string, shortDesc?: string | null, basePrice: number, baseTime: number, allowTip: boolean, type: ServiceOfferingType, maxConcurrentBookings: number, ownerUid: string, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, title: string, type: CustomerInputType, required: boolean, description?: string | null, unitPrice?: number | null, index?: number | null, options: Array<{ __typename?: 'CustomerInputOption', value: string, duration: number, price: number, uid: string }> }> };

export type V2Gateway_GetServiceOfferingWithCustomerInputsQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type V2Gateway_GetServiceOfferingWithCustomerInputsQuery = { __typename?: 'Query', getServiceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, shortDesc?: string | null, basePrice: number, baseTime: number, allowTip: boolean, type: ServiceOfferingType, maxConcurrentBookings: number, ownerUid: string, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, title: string, type: CustomerInputType, required: boolean, description?: string | null, unitPrice?: number | null, index?: number | null, options: Array<{ __typename?: 'CustomerInputOption', value: string, duration: number, price: number, uid: string }> }> } };

export type GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryVariables = Exact<{
  serviceProviderUid: Scalars['String']['input'];
  locationUid: Scalars['String']['input'];
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
  excludeBookingUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery = { __typename?: 'Query', getServiceProviderCalendarUnavailableDateTimeBoundsForAppointment: Array<{ __typename?: 'UnavailableDatetime', startDateTime: number, endDateTime: number }> };

export type GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryVariables = Exact<{
  serviceProviderUid: Scalars['String']['input'];
  locationUid: Scalars['String']['input'];
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
  excludeBookingUid?: InputMaybe<Scalars['String']['input']>;
  selectedServiceOfferingUid: Scalars['String']['input'];
}>;


export type GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery = { __typename?: 'Query', getServiceProviderCalendarUnavailableDateTimeBoundsForBooking: Array<{ __typename?: 'UnavailableDatetime', startDateTime: number, endDateTime: number }> };

export type V2Gateway_CancelBookingMutationVariables = Exact<{
  bookingUid: Scalars['String']['input'];
  cancelReason: Scalars['String']['input'];
}>;


export type V2Gateway_CancelBookingMutation = { __typename?: 'Mutation', cancelBooking: boolean };

export type GetServiceProviderQueryVariables = Exact<{
  ownerUid: Scalars['String']['input'];
}>;


export type GetServiceProviderQuery = { __typename?: 'Query', getServiceProvider: { __typename?: 'ServiceProvider', reviewCount: number, averageRating: number, displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, slug: string, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, location: { __typename?: 'Location', id: string, phoneNumber: string, discoverableBounds: { __typename?: 'GeoBounds', min: { __typename?: 'GeoPoint', lat: number, lng: number }, max: { __typename?: 'GeoPoint', lat: number, lng: number } } }, user: { __typename?: 'User', emailAddress: string, fullName: string, id: string, timezoneLocation: string, country: string }, profile?: { __typename?: 'Profile', introVideoURL: string, emailThemeHex: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> } };

export type GetServiceProviderWithAvailabilityQueryVariables = Exact<{
  ownerUid: Scalars['String']['input'];
}>;


export type GetServiceProviderWithAvailabilityQuery = { __typename?: 'Query', getServiceProvider: { __typename?: 'ServiceProvider', isGoogleCalendarLinked: boolean, displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, slug: string, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, dateAvailability: Array<{ __typename?: 'DateAvailability', date: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, user: { __typename?: 'User', id: string, fullName: string, timezoneLocation: string, country: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> } };

export type V2Gateway_SetBookingsIsInProgressMutationVariables = Exact<{
  bookingUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_SetBookingsIsInProgressMutation = { __typename?: 'Mutation', setBookingsIsInProgress: boolean };

export type SetDefaultPaymentMethodForCustomerMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  methodId: Scalars['String']['input'];
}>;


export type SetDefaultPaymentMethodForCustomerMutation = { __typename?: 'Mutation', setDefaultPaymentMethodForCustomer: boolean };

export type SetEmailTemplateMutationVariables = Exact<{
  input: EmailTemplateInput;
}>;


export type SetEmailTemplateMutation = { __typename?: 'Mutation', setEmailTemplate: boolean };

export type SquareCreateTerminalCheckoutMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  bookingId: Scalars['String']['input'];
}>;


export type SquareCreateTerminalCheckoutMutation = { __typename?: 'Mutation', createTerminalCheckout: string };

export type SquareGetDeviceCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type SquareGetDeviceCodesQuery = { __typename?: 'Query', getDeviceCodes: { __typename?: 'GetDeviceCodesResponse', deviceCodes: Array<{ __typename?: 'DeviceCode', name?: string | null, code: string, deviceId: string }> } };

export type SquareGetTerminalCheckoutQueryVariables = Exact<{
  checkoutId: Scalars['String']['input'];
}>;


export type SquareGetTerminalCheckoutQuery = { __typename?: 'Query', getTerminalCheckout: { __typename?: 'TerminalCheckout', status: string } };

export type SquareSearchCustomersQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SquareSearchCustomersQuery = { __typename?: 'Query', searchSquareCustomers: { __typename?: 'SearchCustomersResponse', customers: Array<{ __typename?: 'SquareCustomer', id: string, givenName: string, familyName: string, emailAddress: string }> } };

export type V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutationVariables = Exact<{
  timezone: Scalars['String']['input'];
  locationUid: Scalars['String']['input'];
  appointmentCartUid: Scalars['String']['input'];
  bookingCartUid: Scalars['String']['input'];
}>;


export type V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation = { __typename?: 'Mutation', createAppointmentRequestAndEagerBookingFromCarts: { __typename?: 'CreateAppointmentRequestAndEagerBookingFromCartsResponse', appointmentRequest: { __typename?: 'AppointmentRequest', uid: string, serviceProvider: { __typename?: 'LegacyServiceProvider', ownerUid: string } }, appointment?: { __typename?: 'Appointment', id: string, uid: string, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string } } | null, booking?: { __typename?: 'Booking', uid: string } | null, eagerBooking?: { __typename?: 'EagerBooking', uid: string } | null } };

export type V2Gateway_CreateBookingFromCartMutationVariables = Exact<{
  bookingCartUid: Scalars['String']['input'];
}>;


export type V2Gateway_CreateBookingFromCartMutation = { __typename?: 'Mutation', createBookingFromCart: { __typename?: 'CreateBookingFromCartResponse', booking: { __typename?: 'Booking', uid: string, appointment: { __typename?: 'Appointment', uid: string, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string }, location: { __typename?: 'Location', id: string, uid: string } } } } };

export type SubscribeUserToProductMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type SubscribeUserToProductMutation = { __typename?: 'Mutation', subscribeUserToProduct: { __typename?: 'SubscriptionResult', subscriptionId: string } };

export type SyncServiceProviderGoogleCalendarMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncServiceProviderGoogleCalendarMutation = { __typename?: 'Mutation', syncServiceProviderGoogleCalendar: boolean };

export type UpdateAppointmentCartServiceAreaUidMutationVariables = Exact<{
  appointmentCartUid: Scalars['String']['input'];
  serviceAreaUid: Scalars['String']['input'];
}>;


export type UpdateAppointmentCartServiceAreaUidMutation = { __typename?: 'Mutation', updateAppointmentCartServiceAreaUid: boolean };

export type UpdateAppointmentCartStartDateTimeMutationVariables = Exact<{
  appointmentCartUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
}>;


export type UpdateAppointmentCartStartDateTimeMutation = { __typename?: 'Mutation', updateAppointmentCartStartDateTime: boolean };

export type UpdateAppointmentServiceAreaUidMutationVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  serviceAreaUid: Scalars['String']['input'];
}>;


export type UpdateAppointmentServiceAreaUidMutation = { __typename?: 'Mutation', updateAppointmentServiceAreaUid: boolean };

export type UpdateBookingCartCustomerProfileIdMutationVariables = Exact<{
  bookingCartUid: Scalars['String']['input'];
  customerProfileId: Scalars['String']['input'];
}>;


export type UpdateBookingCartCustomerProfileIdMutation = { __typename?: 'Mutation', updateBookingCartCustomerProfileId: boolean };

export type UpdateBookingCartCustomerInputSelectionsMutationVariables = Exact<{
  bookingCartUid: Scalars['String']['input'];
  customerInputSelections: Array<CustomerInputSelectionInput> | CustomerInputSelectionInput;
}>;


export type UpdateBookingCartCustomerInputSelectionsMutation = { __typename?: 'Mutation', updateBookingCartCustomerInputSelections: boolean };

export type UpdateBookingCartRedeemableSecretMutationVariables = Exact<{
  bookingCartUid: Scalars['String']['input'];
  secret: Scalars['String']['input'];
}>;


export type UpdateBookingCartRedeemableSecretMutation = { __typename?: 'Mutation', updateBookingCartRedeemableSecret: boolean };

export type UpdateBookingCartServiceOfferingUidMutationVariables = Exact<{
  bookingCartUid: Scalars['String']['input'];
  serviceOfferingUid: Scalars['String']['input'];
}>;


export type UpdateBookingCartServiceOfferingUidMutation = { __typename?: 'Mutation', updateBookingCartServiceOfferingUid: boolean };

export type UpdateBookingCartStartDateTimeMutationVariables = Exact<{
  bookingCartUid: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
}>;


export type UpdateBookingCartStartDateTimeMutation = { __typename?: 'Mutation', updateBookingCartStartDateTime: boolean };

export type UpdateBookingCartTipPercentMutationVariables = Exact<{
  bookingCartUid: Scalars['String']['input'];
  tipPercent: Scalars['Int']['input'];
}>;


export type UpdateBookingCartTipPercentMutation = { __typename?: 'Mutation', updateBookingCartTipPercent: boolean };

export type UpdateBookingCustomerProfileIdMutationVariables = Exact<{
  bookingId: Scalars['String']['input'];
  customerProfileId: Scalars['String']['input'];
}>;


export type UpdateBookingCustomerProfileIdMutation = { __typename?: 'Mutation', updateBookingCustomerProfileId: boolean };

export type UpdateBusinessNameMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type UpdateBusinessNameMutation = { __typename?: 'Mutation', updateBusinessName: boolean };

export type UpdateCustomLineItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CustomLineItemInput;
}>;


export type UpdateCustomLineItemMutation = { __typename?: 'Mutation', updateCustomLineItem: boolean };

export type UpdateCustomerProfileFieldMutationVariables = Exact<{
  id: Scalars['String']['input'];
  field: CustomerProfileFieldInput;
}>;


export type UpdateCustomerProfileFieldMutation = { __typename?: 'Mutation', updateCustomerProfileField: boolean };

export type UpdateCustomerProfileForServiceProviderMutationVariables = Exact<{
  serviceProviderId: Scalars['String']['input'];
  customerProfileId: Scalars['String']['input'];
  fieldValues: Array<CustomerProfileFieldValueInput> | CustomerProfileFieldValueInput;
}>;


export type UpdateCustomerProfileForServiceProviderMutation = { __typename?: 'Mutation', updateCustomerProfileForServiceProvider: boolean };

export type UpdateCustomerProfileNotesMutationVariables = Exact<{
  id: Scalars['String']['input'];
  notes: Array<CustomerProfileNoteInput> | CustomerProfileNoteInput;
}>;


export type UpdateCustomerProfileNotesMutation = { __typename?: 'Mutation', updateCustomerProfileNotes: boolean };

export type UpdateCustomerProfileMutationVariables = Exact<{
  id: Scalars['String']['input'];
  profile: CustomerProfileInput;
}>;


export type UpdateCustomerProfileMutation = { __typename?: 'Mutation', updateCustomerProfile: boolean };

export type UpdateSiblingBookingDiscountRuleMutationVariables = Exact<{
  discountRuleID: Scalars['String']['input'];
  discountRule: UpdateSiblingBookingDiscountRuleInput;
}>;


export type UpdateSiblingBookingDiscountRuleMutation = { __typename?: 'Mutation', updateSiblingBookingDiscountRule: boolean };

export type UpdateTimeDurationBookedAtLocationDiscountRuleMutationVariables = Exact<{
  discountRuleID: Scalars['String']['input'];
  discountRule: UpdateTimeDurationBookedAtLocationDiscountRuleInput;
}>;


export type UpdateTimeDurationBookedAtLocationDiscountRuleMutation = { __typename?: 'Mutation', updateTimeDurationBookedAtLocationDiscountRule: boolean };

export type UpdateDropoffDateTimeMutationVariables = Exact<{
  dropoffID: Scalars['String']['input'];
  dropoffDateTime: Scalars['Int']['input'];
}>;


export type UpdateDropoffDateTimeMutation = { __typename?: 'Mutation', updateDropoffDateTime: boolean };

export type UpdateEventCartMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateEventCartInput;
}>;


export type UpdateEventCartMutation = { __typename?: 'Mutation', updateEventCart: boolean };

export type UpdateEventOfferingMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateEventOffering;
}>;


export type UpdateEventOfferingMutation = { __typename?: 'Mutation', updateEventOffering: boolean };

export type UpdateLocationMutationVariables = Exact<{
  data: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocations: boolean };

export type UpdateReceiptConfigMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ReceiptConfigInput;
}>;


export type UpdateReceiptConfigMutation = { __typename?: 'Mutation', updateReceiptConfig: boolean };

export type UpdateServiceProviderReminderMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ServiceProviderReminderInput;
}>;


export type UpdateServiceProviderReminderMutation = { __typename?: 'Mutation', updateServiceProviderReminder: boolean };

export type V2Gateway_UpdateUserPhoneNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type V2Gateway_UpdateUserPhoneNumberMutation = { __typename?: 'Mutation', updateUserPhoneNumber: boolean };

export type V2Gateway_UpdateUserFullNameMutationVariables = Exact<{
  fullName: Scalars['String']['input'];
}>;


export type V2Gateway_UpdateUserFullNameMutation = { __typename?: 'Mutation', updateUserFullName: boolean };

export type V2Gateway_GetAliasByFromQueryVariables = Exact<{
  from: Scalars['String']['input'];
}>;


export type V2Gateway_GetAliasByFromQuery = { __typename?: 'Query', getAliasByFrom?: { __typename?: 'Alias', to: string } | null };

export type V2Gateway_GetCustomerInputsForServiceOfferingQueryVariables = Exact<{
  serviceOfferingUid: Scalars['String']['input'];
}>;


export type V2Gateway_GetCustomerInputsForServiceOfferingQuery = { __typename?: 'Query', getServiceOfferingCustomerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string, title: string, index?: number | null, dependencies: Array<{ __typename?: 'DependencyTreeLevelNode', dependencyCustomerInputUid: string, level: number, dependentTriggerValues: Array<{ __typename?: 'DependentInputTriggerValues', dependentCustomerInputUid: string, triggerValues: Array<string> }> }> }>, getServiceOfferingCustomerInputs: Array<{ __typename?: 'CustomerInput', uid: string, title: string, index?: number | null, description?: string | null, type: CustomerInputType, required: boolean, unitPrice?: number | null, options: Array<{ __typename?: 'CustomerInputOption', price: number, duration: number, uid: string, value: string }> }> };

export type V2Gateway_QueryLocationsQueryVariables = Exact<{
  query: LocationQuery;
}>;


export type V2Gateway_QueryLocationsQuery = { __typename?: 'Query', queryLocations: { __typename?: 'LocationsQueryResult', hasMoreResults: boolean, locations: Array<{ __typename?: 'Location', uid: string, id: string, formattedAddress: string, streetAddress: string, phoneNumber: string, name: string, ownerUid: string, latitude: number, longitude: number, placeId: string, type: LocationType, extendedAddress?: string | null, slug: string, serviceAreas: Array<{ __typename?: 'ServiceArea', uid: string }>, business?: { __typename?: 'Business', slug: string } | null }> } };

export type V2Gateway_GetMerchantsQueryVariables = Exact<{
  uids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetMerchantsQuery = { __typename?: 'Query', getMerchants: Array<{ __typename?: 'Merchant', serviceType: string, ownerUid: string }> };

export type GetUsersQueryVariables = Exact<{
  uids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: Array<{ __typename?: 'User', fullName: string, uid: string, emailAddress: string }> };

export type AppointmentRequestFieldsFragment = { __typename?: 'AppointmentRequest', uid: string, locationUid: string, denialReason: string, status: AppointmentRequestStatus, timezoneLocation: string, startDateTime: number, externalUid: string, ownerUid: string, serviceAreaUid: string, minEndDateTime: number, serviceProvider: { __typename?: 'LegacyServiceProvider', ownerUid: string, serviceType: string }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', label?: string | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null };

export type GetAppointmentRequestsByOwnerUidQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentRequestsByOwnerUidQuery = { __typename?: 'Query', getAppointmentRequestsByOwnerUid: Array<{ __typename?: 'AppointmentRequest', uid: string, locationUid: string, denialReason: string, status: AppointmentRequestStatus, timezoneLocation: string, startDateTime: number, externalUid: string, ownerUid: string, serviceAreaUid: string, minEndDateTime: number, serviceProvider: { __typename?: 'LegacyServiceProvider', ownerUid: string, serviceType: string }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', label?: string | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null }> };

export type GetAppointmentRequestsByExternalUidQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentRequestsByExternalUidQuery = { __typename?: 'Query', getAppointmentRequestsByExternalUid: Array<{ __typename?: 'AppointmentRequest', uid: string, locationUid: string, denialReason: string, status: AppointmentRequestStatus, timezoneLocation: string, startDateTime: number, externalUid: string, ownerUid: string, serviceAreaUid: string, minEndDateTime: number, serviceProvider: { __typename?: 'LegacyServiceProvider', ownerUid: string, serviceType: string }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', label?: string | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null }> };

export type GetAppointmentRequestsByLocationUidsQueryVariables = Exact<{
  locationUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAppointmentRequestsByLocationUidsQuery = { __typename?: 'Query', getAppointmentRequestsByLocationUids: Array<{ __typename?: 'AppointmentRequest', uid: string, locationUid: string, denialReason: string, status: AppointmentRequestStatus, timezoneLocation: string, startDateTime: number, externalUid: string, ownerUid: string, serviceAreaUid: string, minEndDateTime: number, serviceProvider: { __typename?: 'LegacyServiceProvider', ownerUid: string, serviceType: string }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', label?: string | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null }> };

export type V2Gateway_UpdateAppointmentRequestsMutationVariables = Exact<{
  data: Array<UpdateAppointmentRequestInput> | UpdateAppointmentRequestInput;
}>;


export type V2Gateway_UpdateAppointmentRequestsMutation = { __typename?: 'Mutation', updateAppointmentRequests: boolean };

export type V2Gateway_CreateAppointmentRequestsMutationVariables = Exact<{
  data: Array<CreateAppointmentRequestInput> | CreateAppointmentRequestInput;
}>;


export type V2Gateway_CreateAppointmentRequestsMutation = { __typename?: 'Mutation', createAppointmentRequests: Array<{ __typename?: 'CreateAppointmentRequestResponse', appointmentRequestUid: string, nonce?: string | null, appointmentUid?: string | null }> };

export type V2Gateway_DeleteAppointmentRequestsMutationVariables = Exact<{
  appointmentRequestUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_DeleteAppointmentRequestsMutation = { __typename?: 'Mutation', deleteAppointmentRequests: boolean };

export type V2Gateway_UpdateBookingAttributesMutationVariables = Exact<{
  bookingAttributes: Array<UpdateBookingAttributeInput> | UpdateBookingAttributeInput;
}>;


export type V2Gateway_UpdateBookingAttributesMutation = { __typename?: 'Mutation', updateBookingAttributes: boolean };

export type V2Gateway_RemoveBookingAttributesMutationVariables = Exact<{
  bookingAttributeUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_RemoveBookingAttributesMutation = { __typename?: 'Mutation', removeBookingAttributes: boolean };

export type V2Gateway_GetCustomTaxRateLineItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetCustomTaxRateLineItemsQuery = { __typename?: 'Query', getCustomTaxRateLineItems: Array<{ __typename?: 'CustomTaxRateLineItem', microPercent: number, name: string, uid: string }> };

export type V2Gateway_UpdateCustomTaxRateLineItemsMutationVariables = Exact<{
  customTaxRateLineItems: Array<UpdateCustomTaxRateLineItemInput> | UpdateCustomTaxRateLineItemInput;
}>;


export type V2Gateway_UpdateCustomTaxRateLineItemsMutation = { __typename?: 'Mutation', updateCustomTaxRateLineItems: boolean };

export type V2Gateway_CreateCustomTaxRateLineItemsMutationVariables = Exact<{
  customTaxRateLineItems: Array<CreateCustomTaxRateLineItemInput> | CreateCustomTaxRateLineItemInput;
}>;


export type V2Gateway_CreateCustomTaxRateLineItemsMutation = { __typename?: 'Mutation', createCustomTaxRateLineItems: boolean };

export type V2Gateway_DeleteCustomTaxRateLineItemsMutationVariables = Exact<{
  internalUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_DeleteCustomTaxRateLineItemsMutation = { __typename?: 'Mutation', deleteCustomTaxRateLineItems: boolean };

export type EagerBookingFieldsFragment = { __typename?: 'EagerBooking', uid: string, externalUid: string, ownerUid: string, quotedDuration: number, uidForBooking: string, appointmentRequest: { __typename?: 'AppointmentRequest', uid: string, startDateTime: number, minEndDateTime: number, serviceAreaUid: string, serviceProvider: { __typename?: 'LegacyServiceProvider', ownerUid: string }, location: { __typename?: 'Location', id: string, uid: string } }, booking: { __typename?: 'BookingSelections', tipPercent: number, startDateTime: number, serviceOfferingUid: string, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, type: ServiceOfferingType, maxConcurrentBookings: number, baseTime: number, title: string } } };

export type V2Gateway_QueryEagerBookingsQueryVariables = Exact<{
  query: EagerBookingQuery;
}>;


export type V2Gateway_QueryEagerBookingsQuery = { __typename?: 'Query', queryEagerBookings: Array<{ __typename?: 'EagerBooking', uid: string, externalUid: string, ownerUid: string, quotedDuration: number, uidForBooking: string, appointmentRequest: { __typename?: 'AppointmentRequest', uid: string, startDateTime: number, minEndDateTime: number, serviceAreaUid: string, serviceProvider: { __typename?: 'LegacyServiceProvider', ownerUid: string }, location: { __typename?: 'Location', id: string, uid: string } }, booking: { __typename?: 'BookingSelections', tipPercent: number, startDateTime: number, serviceOfferingUid: string, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, type: ServiceOfferingType, maxConcurrentBookings: number, baseTime: number, title: string } } }> };

export type V2Gateway_UpdateEagerBookingsMutationVariables = Exact<{
  data: Array<UpdateEagerBookingInput> | UpdateEagerBookingInput;
}>;


export type V2Gateway_UpdateEagerBookingsMutation = { __typename?: 'Mutation', updateEagerBookings: boolean };

export type V2Gateway_CreateEagerBookingsMutationVariables = Exact<{
  data: Array<CreateEagerBookingInput> | CreateEagerBookingInput;
}>;


export type V2Gateway_CreateEagerBookingsMutation = { __typename?: 'Mutation', createEagerBookings: Array<{ __typename?: 'CreatedEagerBooking', eagerBookingUid: string, bookingUid: string }> };

export type V2Gateway_DeleteEagerBookingsMutationVariables = Exact<{
  eagerBookingUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_DeleteEagerBookingsMutation = { __typename?: 'Mutation', deleteEagerBookings: boolean };

export type V2Gateway_GetFilesQueryVariables = Exact<{
  externalUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetFilesQuery = { __typename?: 'Query', getFilesByExternalUid: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, index?: number | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } }> };

export type V2Gateway_UpdateFilesMutationVariables = Exact<{
  data: Array<UpdateFileInput> | UpdateFileInput;
}>;


export type V2Gateway_UpdateFilesMutation = { __typename?: 'Mutation', updateFiles: boolean };

export type V2Gateway_CreateFilesMutationVariables = Exact<{
  data: Array<CreateFileInput> | CreateFileInput;
}>;


export type V2Gateway_CreateFilesMutation = { __typename?: 'Mutation', createFiles: Array<string> };

export type V2Gateway_DeleteFilesMutationVariables = Exact<{
  internalUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_DeleteFilesMutation = { __typename?: 'Mutation', deleteFiles: boolean };

export type V2Gateway_UploadFilesMutationVariables = Exact<{
  files: Array<Scalars['Upload']['input']> | Scalars['Upload']['input'];
}>;


export type V2Gateway_UploadFilesMutation = { __typename?: 'Mutation', uploadFiles: Array<{ __typename?: 'UploadedFile', publicUrl: string, objectName: string }> };

export type V2Gateway_GetInsuranceClaimableServiceProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetInsuranceClaimableServiceProviderQuery = { __typename?: 'Query', getInsuranceClaimableServiceProviderByOwnerUID?: { __typename?: 'InsuranceClaimableServiceProvider', licenseId?: string | null, titlePrefix?: string | null, titleSuffix?: string | null, uid: string } | null };

export type V2Gateway_CreateInsuranceClaimableServiceProviderMutationVariables = Exact<{
  data: InsuranceClaimableServiceProviderInput;
}>;


export type V2Gateway_CreateInsuranceClaimableServiceProviderMutation = { __typename?: 'Mutation', createInsuranceClaimableServiceProvider: boolean };

export type V2Gateway_UpdateInsuranceClaimableServiceProviderMutationVariables = Exact<{
  internalUid: Scalars['String']['input'];
  data: InsuranceClaimableServiceProviderInput;
}>;


export type V2Gateway_UpdateInsuranceClaimableServiceProviderMutation = { __typename?: 'Mutation', updateInsuranceClaimableServiceProviderByInternalUID: boolean };

export type V2Gateway_DeleteInsuranceClaimableServiceProviderMutationVariables = Exact<{
  internalUid: Scalars['String']['input'];
}>;


export type V2Gateway_DeleteInsuranceClaimableServiceProviderMutation = { __typename?: 'Mutation', deleteInsuranceClaimableServiceProviderByInternalUID: boolean };

export type LocationPolicyFieldsFragment = { __typename?: 'LocationPolicy', uid: string, valueType: LocationPolicyValueType, policyType: LocationPolicyType, name: string, value: string, externalUid: string };

export type V2Gateway_QueryLocationPoliciesQueryVariables = Exact<{
  query: LocationPolicyQuery;
}>;


export type V2Gateway_QueryLocationPoliciesQuery = { __typename?: 'Query', queryLocationPolicies: Array<{ __typename?: 'LocationPolicy', uid: string, valueType: LocationPolicyValueType, policyType: LocationPolicyType, name: string, value: string, externalUid: string }> };

export type V2Gateway_UpdateLocationPoliciesMutationVariables = Exact<{
  data: Array<UpdateLocationPolicyInput> | UpdateLocationPolicyInput;
}>;


export type V2Gateway_UpdateLocationPoliciesMutation = { __typename?: 'Mutation', updateLocationPolicies: boolean };

export type V2Gateway_CreateLocationPoliciesMutationVariables = Exact<{
  data: Array<CreateLocationPolicyInput> | CreateLocationPolicyInput;
}>;


export type V2Gateway_CreateLocationPoliciesMutation = { __typename?: 'Mutation', createLocationPolicies: boolean };

export type V2Gateway_UpdateLocationSubscriptionRequestsMutationVariables = Exact<{
  data: Array<UpdateLocationSubscriptionRequestInput> | UpdateLocationSubscriptionRequestInput;
}>;


export type V2Gateway_UpdateLocationSubscriptionRequestsMutation = { __typename?: 'Mutation', updateLocationSubscriptionRequests: boolean };

export type V2Gateway_QueryLocationSubscriptionRequestsQueryVariables = Exact<{
  query: LocationSubscriptionRequestQuery;
}>;


export type V2Gateway_QueryLocationSubscriptionRequestsQuery = { __typename?: 'Query', queryLocationSubscriptionRequests: { __typename?: 'LocationSubscriptionRequestQueryResult', hasMoreResults: boolean, locationSubscriptionRequests: Array<{ __typename?: 'LocationSubscriptionRequest', uid: string, locationSubscription: { __typename?: 'LocationSubscription', locationUid: string, ownerUid: string } }> } };

export type V2Gateway_CreateLocationSubscriptionRequestsMutationVariables = Exact<{
  data: Array<CreateLocationSubscriptionRequestInput> | CreateLocationSubscriptionRequestInput;
}>;


export type V2Gateway_CreateLocationSubscriptionRequestsMutation = { __typename?: 'Mutation', createLocationSubscriptionRequests: { __typename?: 'CreateLocationSubscriptionRequestsResponse', internalUids: Array<string> } };

export type V2Gateway_DeleteLocationSubscriptionRequestMutationVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type V2Gateway_DeleteLocationSubscriptionRequestMutation = { __typename?: 'Mutation', deleteLocationSubscriptionRequest: boolean };

export type DeleteLocationSubscriptionMutationVariables = Exact<{
  locationUid: Scalars['String']['input'];
}>;


export type DeleteLocationSubscriptionMutation = { __typename?: 'Mutation', deleteLocationSubscription: boolean };

export type V2Gateway_CreateLocationsMutationVariables = Exact<{
  data: Array<CreateLocationInput> | CreateLocationInput;
}>;


export type V2Gateway_CreateLocationsMutation = { __typename?: 'Mutation', createLocations: { __typename?: 'CreateLocationsResponse', internalUids: Array<string> } };

export type V2Gateway_UpdateLocationsMutationVariables = Exact<{
  data: Array<UpdateLocationInput> | UpdateLocationInput;
}>;


export type V2Gateway_UpdateLocationsMutation = { __typename?: 'Mutation', updateLocations: boolean };

export type V2Gateway_DeleteLocationMutationVariables = Exact<{
  locationUid: Scalars['String']['input'];
}>;


export type V2Gateway_DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation: boolean };

export type V2Gateway_GetProfileQueryVariables = Exact<{
  ownerUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type V2Gateway_GetProfileQuery = { __typename?: 'Query', getProfileByOwnerUid?: { __typename?: 'Profile', displayName: string, description: string, uid: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', index: number, uid: string, imageFile: { __typename?: 'File', uid: string, label?: string | null, index?: number | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null } | null };

export type V2Gateway_UpdateProfileMutationVariables = Exact<{
  profileUid: Scalars['String']['input'];
  profile: ProfileInput;
}>;


export type V2Gateway_UpdateProfileMutation = { __typename?: 'Mutation', updateProfileByInternalUID: boolean };

export type V2Gateway_CreateProfileMutationVariables = Exact<{
  profile: ProfileInput;
}>;


export type V2Gateway_CreateProfileMutation = { __typename?: 'Mutation', createProfile: boolean };

export type V2Gateway_GetServiceAreasQueryVariables = Exact<{
  internalUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetServiceAreasQuery = { __typename?: 'Query', getServiceAreas: Array<{ __typename?: 'ServiceArea', uid: string, externalUid: string, size?: ServiceAreaSize | null, name: string, description: string, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> }> };

export type V2Gateway_UpdateServiceAreasMutationVariables = Exact<{
  data: Array<UpdateServiceAreaInput> | UpdateServiceAreaInput;
}>;


export type V2Gateway_UpdateServiceAreasMutation = { __typename?: 'Mutation', updateServiceAreas: Array<string | null> };

export type V2Gateway_CreateServiceAreasMutationVariables = Exact<{
  data: Array<CreateServiceAreaInput> | CreateServiceAreaInput;
}>;


export type V2Gateway_CreateServiceAreasMutation = { __typename?: 'Mutation', createServiceAreas: Array<{ __typename?: 'CreatedServiceArea', uid?: string | null, nonce?: string | null }> };

export type V2Gateway_DeleteServiceAreasMutationVariables = Exact<{
  internalUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_DeleteServiceAreasMutation = { __typename?: 'Mutation', deleteServiceAreas: boolean };

export type V2Gateway_GetTaxRateTogglesQueryVariables = Exact<{
  externalUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetTaxRateTogglesQuery = { __typename?: 'Query', getTaxRateToggles: Array<{ __typename?: 'TaxRateToggle', enabledTaxRateLineItemUids: Array<string>, disabledTaxRateLineItems: Array<string>, externalUid: string }> };

export type V2Gateway_UpdateTaxRateTogglesMutationVariables = Exact<{
  taxRateToggles: Array<TaxRateToggleInput> | TaxRateToggleInput;
}>;


export type V2Gateway_UpdateTaxRateTogglesMutation = { __typename?: 'Mutation', updateTaxRateToggles: boolean };

export type V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryVariables = Exact<{
  internalUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery = { __typename?: 'Query', getCustomTaxRateLineItemsByInternalUid: Array<{ __typename?: 'CustomTaxRateLineItem', microPercent: number, name: string, uid: string }> };

export type V2Gateway_GetTaxRateForServiceProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetTaxRateForServiceProviderQuery = { __typename?: 'Query', getTaxRateForServiceProvider: { __typename?: 'TaxRate', lineItems: Array<{ __typename?: 'TaxRateLineItem', microPercent: number, name: string }> } };

export type V2Gateway_GetServiceOfferingForBookingQueryVariables = Exact<{
  query: ServiceOfferingQuery;
}>;


export type V2Gateway_GetServiceOfferingForBookingQuery = { __typename?: 'Query', queryServiceOfferings: { __typename?: 'ServiceOfferingQueryResult', serviceOfferings: Array<{ __typename?: 'ServiceOffering', title: string }> } };

export type BookingApi_CompleteBookingMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  paymentGateway: PaymentGatewayType;
}>;


export type BookingApi_CompleteBookingMutation = { __typename?: 'Mutation', completeBooking: { __typename?: 'CompleteBookingResponse', isSuccess: boolean, error?: string | null } };

export type V2Gateway_UpdateBookingsMutationVariables = Exact<{
  data: Array<UpdateBookingInput> | UpdateBookingInput;
}>;


export type V2Gateway_UpdateBookingsMutation = { __typename?: 'Mutation', updateBookings: boolean };

export type BookingApi_NoShowBookingMutationVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type BookingApi_NoShowBookingMutation = { __typename?: 'Mutation', noShowBooking: number };

export type GetAppointmentForAppointmentDetailsQueryVariables = Exact<{
  appointmentUid: Scalars['String']['input'];
}>;


export type GetAppointmentForAppointmentDetailsQuery = { __typename?: 'Query', getAppointment?: { __typename?: 'Appointment', startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, bookings: Array<{ __typename?: 'Booking', id: string, customerProfileId: string, isNoShow: boolean, uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, dropoff?: { __typename?: 'Dropoff', dropoffDateTime: number } | null, discounts: Array<{ __typename?: 'Discount', uid: string, value: number, name: string, type: DiscountType, isStackable: boolean, change: { __typename?: 'DiscountValueChange', type: DiscountValueChangeType, isCoveredByLocation: boolean, isCoveredByPlatform: boolean } }>, customer: { __typename?: 'Customer', user: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null } }, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } }>, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, slug: string, displayName: string, isApproved: boolean, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, dateAvailability: Array<{ __typename?: 'DateAvailability', date: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, user: { __typename?: 'User', id: string, fullName: string, timezoneLocation: string, country: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> }, expectedEarnings?: { __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', externalUid: string, value: number }> } | null, discounts: Array<{ __typename?: 'Discount', type: DiscountType, value: number }>, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string, uid: string }> } | null };

export type V2Gateway_GetMerchantForAppointmentDetailsQueryVariables = Exact<{
  merchantUid: Scalars['String']['input'];
}>;


export type V2Gateway_GetMerchantForAppointmentDetailsQuery = { __typename?: 'Query', getMerchant: { __typename?: 'Merchant', serviceType: string } };

export type ProfileFragmentFragment = { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> };

export type V2Gateway_QueryServiceProvidersQueryVariables = Exact<{
  query: ServiceProviderQuery;
}>;


export type V2Gateway_QueryServiceProvidersQuery = { __typename?: 'Query', queryServiceProviders: { __typename?: 'ServiceProvidersQueryResult', hasMoreResults: boolean, serviceProviders: Array<{ __typename?: 'ServiceProvider', displayName: string, ownerUid: string, id: string, slug: string, serviceType: string, isApproved: boolean, averageRating: number, reviewCount: number, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, createdAt: number, isExternal: boolean, externalAuthor?: string | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, type: ServiceOfferingType }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType }> }>, user: { __typename?: 'User', id: string }, location: { __typename?: 'Location', id: string, phoneNumber: string }, dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }>, discountRules: Array<{ __typename?: 'DiscountRule', id: string, isDisabled: boolean, label: string, discountValue: number, discountType: DiscountType, priority: number, triggerCondition: { __typename?: 'DiscountRuleTriggerCondition', siblingBookingTriggerCondition?: { __typename?: 'SiblingBookingTriggerCondition', requireBookingCount: number, ignoreServiceOfferingUids: Array<string> } | null, timeDurationBookedAtLocationTriggerCondition?: { __typename?: 'TimeDurationBookedAtLocationTriggerCondition', requireDurationBookedSeconds: number, ignoreServiceOfferingUids: Array<string> } | null } }> }> } };

export type V2Gateway_GetProfilesQueryVariables = Exact<{
  ownerUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetProfilesQuery = { __typename?: 'Query', getProfilesByOwnerUid: Array<{ __typename?: 'Profile', emailThemeHex: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> }> };

export type DayOfWeekAvailabilityFieldsFragment = { __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } };

export type V2Gateway_QueryDayOfWeekAvailabilityQueryVariables = Exact<{
  query: DayOfWeekAvailabilityQuery;
}>;


export type V2Gateway_QueryDayOfWeekAvailabilityQuery = { __typename?: 'Query', queryDayOfWeekAvailability: { __typename?: 'DayOfWeekAvailabilityQueryResult', dayOfWeekAvailability: Array<{ __typename?: 'DayOfWeekAvailability', dayOfWeek: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }> } };

export type DateAvailabilityFieldsFragment = { __typename?: 'DateAvailability', date: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } };

export type V2Gateway_QueryDateAvailabilityQueryVariables = Exact<{
  query: DateAvailabilityQuery;
}>;


export type V2Gateway_QueryDateAvailabilityQuery = { __typename?: 'Query', queryDateAvailability: { __typename?: 'DateAvailabilityQueryResult', dateAvailability: Array<{ __typename?: 'DateAvailability', date: number, timezone: string, ownerUid: string, availability: { __typename?: 'Availability', timeUtcSecondsBounds: Array<{ __typename?: 'Bounds', min?: number | null, max?: number | null }> } }> } };

export type V2Gateway_SigninMutationVariables = Exact<{
  idToken: Scalars['String']['input'];
  timezoneLocation: Scalars['String']['input'];
  createIfNotExists: Scalars['Boolean']['input'];
}>;


export type V2Gateway_SigninMutation = { __typename?: 'Mutation', signin?: { __typename?: 'SigninResponse', isNewUser: boolean, jwt: string, user: { __typename?: 'User', emailAddress: string, fullName: string, accountType: number, uid: string, country: string } } | null };

export type V2Gateway_SignoutMutationVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_SignoutMutation = { __typename?: 'Mutation', signout: boolean };

export type V2Gateway_CheckSessionValidQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_CheckSessionValidQuery = { __typename?: 'Query', checkSessionValid: string };

export type BalanceFieldsFragment = { __typename?: 'StripeAmount', currency: string, value: number };

export type V2Gateway_GetStripeBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetStripeBalanceQuery = { __typename?: 'Query', getStripeBalance: { __typename?: 'StripeBalance', available: Array<{ __typename?: 'StripeAmount', currency: string, value: number }>, pending: Array<{ __typename?: 'StripeAmount', currency: string, value: number }> } };

export type V2Gateway_GetStripeLoginLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetStripeLoginLinkQuery = { __typename?: 'Query', getStripeLoginLink: string };

export type V2Gateway_GetPaymentMethodsQueryVariables = Exact<{
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type V2Gateway_GetPaymentMethodsQuery = { __typename?: 'Query', getPaymentMethods: Array<{ __typename?: 'Card', brand: string, lastFour: string, expMonth: number, expYear: number, id: string }>, getStripeCustomer: { __typename?: 'StripeCustomer', defaultSource: string, defaultPaymentMethodId: string } };

export type V2Gateway_GetSetupIntentSecretQueryVariables = Exact<{
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type V2Gateway_GetSetupIntentSecretQuery = { __typename?: 'Query', getSetupIntentSecret: string };

export type V2Gateway_DetachPaymentMethodMutationVariables = Exact<{
  methodId: Scalars['String']['input'];
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type V2Gateway_DetachPaymentMethodMutation = { __typename?: 'Mutation', detachPaymentMethod: boolean };

export type V2Gateway_SetDefaultPaymentMethodMutationVariables = Exact<{
  methodId: Scalars['String']['input'];
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type V2Gateway_SetDefaultPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod: boolean };

export type GetAppointmentsQueryVariables = Exact<{
  confirmedAppointmentsPage: Scalars['Int']['input'];
  pendingAppointmentsPage: Scalars['Int']['input'];
}>;


export type GetAppointmentsQuery = { __typename?: 'Query', getConfirmedAppointmentsCount: number, getPendingAppointmentsCount: number, getConfirmedAppointments: Array<{ __typename?: 'Appointment', startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, expectedEarnings?: { __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', externalUid: string, value: number }> } | null, discounts: Array<{ __typename?: 'Discount', type: DiscountType, value: number }>, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, slug: string }, bookings: Array<{ __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } }>, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string, uid: string }> }>, getPendingAppointments: Array<{ __typename?: 'Appointment', startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, expectedEarnings?: { __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', externalUid: string, value: number }> } | null, discounts: Array<{ __typename?: 'Discount', type: DiscountType, value: number }>, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, slug: string }, bookings: Array<{ __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } }>, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string, uid: string }> }> };

export type GetAppointmentsForLocationsQueryVariables = Exact<{
  locationUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  page: Scalars['Int']['input'];
  query?: InputMaybe<AppointmentQuery>;
}>;


export type GetAppointmentsForLocationsQuery = { __typename?: 'Query', getAppointmentsForLocationsCount: number, getAppointmentsForLocations: Array<{ __typename?: 'Appointment', startDateTime: number, ownerUid: string, userUid: string, locationUid: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCoveredByBusiness?: boolean | null, bookingsWithSiblings: Array<{ __typename?: 'Booking', uid: string, owner: { __typename?: 'User', fullName: string } }>, discountRuleProgress: Array<{ __typename?: 'DiscountRuleWithProgress', progressPercent: number, discountRule: { __typename?: 'DiscountRuleWithProgressDiscountRule', label: string, discountValue: number, discountType: DiscountType, priority: number, requireDurationBookedSeconds: number, requireBookingCount: number } }>, location: { __typename?: 'Location', id: string, uid: string, streetAddress: string, name: string, type: LocationType, phoneNumber: string, placeId: string }, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, slug: string, displayName: string, averageRating: number, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, index?: number | null }>, reviews: Array<{ __typename?: 'Review', isLike: boolean, isVerified: boolean }>, profile?: { __typename?: 'Profile', displayName: string, avatarImage?: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null } | null }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string }>, bookings: Array<{ __typename?: 'Booking', uid: string, ownerUid: string }> }> };

export type V2Gateway_GetServiceOfferingsForServiceProviderQueryVariables = Exact<{
  query: ServiceOfferingQuery;
}>;


export type V2Gateway_GetServiceOfferingsForServiceProviderQuery = { __typename?: 'Query', queryServiceOfferings: { __typename?: 'ServiceOfferingQueryResult', hasMoreResults: boolean, serviceOfferings: Array<{ __typename?: 'ServiceOffering', title: string, basePrice: number, shortDesc?: string | null, baseTime: number, imageUrl?: string | null, uid: string, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, index?: number | null }> } };

export type V2Gateway_GetBookingAttributesQueryVariables = Exact<{
  bookingUid: Scalars['String']['input'];
}>;


export type V2Gateway_GetBookingAttributesQuery = { __typename?: 'Query', getBookingAttributes: Array<{ __typename?: 'BookingAttribute', uid: string, price: number, duration: number, description: string, type: BookingAttributeType, bookingUid: string }> };

export type V2Gateway_AddBookingAttributesMutationVariables = Exact<{
  bookingAttributes: Array<BookingAttributeInput> | BookingAttributeInput;
}>;


export type V2Gateway_AddBookingAttributesMutation = { __typename?: 'Mutation', addBookingAttributes: boolean };

export type V2Gateway_QueryDiscountsQueryVariables = Exact<{
  query: DiscountQuery;
}>;


export type V2Gateway_QueryDiscountsQuery = { __typename?: 'Query', queryDiscounts: { __typename?: 'DiscountQueryResult', discounts: Array<{ __typename?: 'Discount', uid: string, value: number, name: string, type: DiscountType, isStackable: boolean, booking?: { __typename?: 'Booking', uid: string } | null, change: { __typename?: 'DiscountValueChange', type: DiscountValueChangeType, isCoveredByLocation: boolean, isCoveredByPlatform: boolean } }> } };

export type GetAppointmentQueryVariables = Exact<{
  appointmentUid: Scalars['String']['input'];
}>;


export type GetAppointmentQuery = { __typename?: 'Query', getAppointment?: { __typename?: 'Appointment', isCoveredByBusiness?: boolean | null, userUid: string, uid: string, id: string, locationUid: string, ownerUid: string, startDateTime: number, maxEndDateTime: number, isCancelled: boolean, isConfirmed: boolean, eventEndDateTime?: number | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string }>, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, location: { __typename?: 'Location', id: string, uid: string, name: string, formattedAddress: string, phoneNumber: string, type: LocationType, latitude: number, longitude: number, ownerUid: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null } }, serviceProvider: { __typename?: 'ServiceProvider', displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, slug: string, profile?: { __typename?: 'Profile', introVideoURL: string, uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }>, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, postServiceNote: string, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, user: { __typename?: 'User', id: string, fullName: string, timezoneLocation: string, country: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> } } | null };

export type V2Gateway_GetMerchantQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type V2Gateway_GetMerchantQuery = { __typename?: 'Query', getMerchant: { __typename?: 'Merchant', serviceType: string } };

export type GetUserBookingsForAppointmentQueryVariables = Exact<{
  appointmentUid: Scalars['String']['input'];
  ownerUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserBookingsForAppointmentQuery = { __typename?: 'Query', getUserBookingsForAppointment: Array<{ __typename?: 'Booking', uid: string, ownerUid: string, price: number, tipPercent: number, earnings?: number | null, serviceOfferingUid: string, isComplete: boolean, startDateTime: number, endDateTime: number, appointmentUid: string, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string> }>> | null }> };

export type GetAppointmentRequestsQueryVariables = Exact<{
  internalUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAppointmentRequestsQuery = { __typename?: 'Query', getAppointmentRequests: Array<{ __typename?: 'AppointmentRequest', locationUid: string, externalUid: string, ownerUid: string, startDateTime: number, uid: string, minEndDateTime: number, status: AppointmentRequestStatus, appointmentUid?: string | null, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string } | null, location: { __typename?: 'Location', id: string, uid: string, name: string, formattedAddress: string, phoneNumber: string, type: LocationType, latitude: number, longitude: number, ownerUid: string, placeId: string }, serviceProvider: { __typename?: 'LegacyServiceProvider', fullName: string, displayName: string, ownerUid: string, serviceType: string, isApproved: boolean, profile?: { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> } | null, reviews: Array<{ __typename?: 'Review', uid: string, text: string, isLike: boolean, createdAt: number, isExternal: boolean, externalAuthor?: string | null, owner?: { __typename?: 'User', fullName: string } | null }>, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, basePrice: number, baseTime: number, title: string, shortDesc?: string | null, allowTip: boolean, maxConcurrentBookings: number, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }>, serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }>, owner: { __typename?: 'User', fullName: string }, preferences: Array<{ __typename?: 'ServiceProviderPreference', id: string, type: ServiceProviderPreferenceType, value: string }> } }> };

export type V2Gateway_GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetLocationsQuery = { __typename?: 'Query', getLocations: Array<{ __typename?: 'Location', uid: string, name: string, id: string, formattedAddress: string, streetAddress: string, phoneNumber: string, placeId: string, type: LocationType, latitude: number, longitude: number, extendedAddress?: string | null, slug: string, serviceAreas: Array<{ __typename?: 'ServiceArea', uid: string }>, business?: { __typename?: 'Business', slug: string } | null }> };

export type V2Gateway_GetCalendarAccessQueryVariables = Exact<{
  providers: Array<CalendarProvider> | CalendarProvider;
  ownerUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type V2Gateway_GetCalendarAccessQuery = { __typename?: 'Query', getCalendarAccess?: Array<CalendarProvider> | null };

export type V2Gateway_GetDiscountsForBookingUidsQueryVariables = Exact<{
  bookingUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetDiscountsForBookingUidsQuery = { __typename?: 'Query', getDiscountsForBookingUids: Array<{ __typename?: 'Discount', value: number, type: DiscountType, name: string, isStackable: boolean, booking?: { __typename?: 'Booking', uid: string } | null, change: { __typename?: 'DiscountValueChange', type: DiscountValueChangeType, isCoveredByPlatform: boolean, isCoveredByLocation: boolean } }> };

export type BookingFieldsFragment = { __typename?: 'Booking', uid: string, ownerUid: string, tipPercent: number, earnings?: number | null, serviceOfferingUid: string, isComplete: boolean, appointmentUid: string, startDateTime: number, endDateTime: number, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string> }>> | null };

export type V2Gateway_GetUpcomingBookingsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
}>;


export type V2Gateway_GetUpcomingBookingsQuery = { __typename?: 'Query', getUpcomingBookings: Array<{ __typename?: 'Booking', uid: string, ownerUid: string, tipPercent: number, earnings?: number | null, serviceOfferingUid: string, isComplete: boolean, appointmentUid: string, startDateTime: number, endDateTime: number, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string> }>> | null }> };

export type V2Gateway_GetBookingsByAppointmentUidsQueryVariables = Exact<{
  appointmentUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;


export type V2Gateway_GetBookingsByAppointmentUidsQuery = { __typename?: 'Query', getBookingsByAppointmentUids: Array<{ __typename?: 'BookingsForAppointment', completeBookings: Array<{ __typename?: 'Booking', uid: string, ownerUid: string, tipPercent: number, earnings?: number | null, serviceOfferingUid: string, isComplete: boolean, appointmentUid: string, startDateTime: number, endDateTime: number, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string> }>> | null }>, incompleteBookings: Array<{ __typename?: 'Booking', uid: string, ownerUid: string, tipPercent: number, earnings?: number | null, serviceOfferingUid: string, isComplete: boolean, appointmentUid: string, startDateTime: number, endDateTime: number, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string> }>> | null }> } | null> };

export type V2Gateway_GetExpectedEarningsQueryVariables = Exact<{
  appointmentUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetExpectedEarningsQuery = { __typename?: 'Query', getExpectedEarningsForAppointments: Array<{ __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', value: number, externalUid: string }> }> };

export type V2Gateway_GetFilesByExternalUidsQueryVariables = Exact<{
  externalUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetFilesByExternalUidsQuery = { __typename?: 'Query', getFilesByExternalUid: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, index?: number | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } }> };

export type CustomerInputFieldsFragment = { __typename?: 'CustomerInput', uid: string, title: string, index?: number | null, description?: string | null, type: CustomerInputType, required: boolean, unitPrice?: number | null, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> };

export type CustomerInputGroupFieldsFragment = { __typename?: 'CustomerInputGroup', uid: string, title: string, index?: number | null, dependencies: Array<{ __typename?: 'DependencyTreeLevelNode', level: number, dependencyCustomerInputUid: string, dependentTriggerValues: Array<{ __typename?: 'DependentInputTriggerValues', triggerValues: Array<string>, dependentCustomerInputUid: string }> }> };

export type V2Gateway_GetCustomerInputsQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetCustomerInputsQuery = { __typename?: 'Query', getCustomerInputs: Array<{ __typename?: 'CustomerInput', uid: string, title: string, index?: number | null, description?: string | null, type: CustomerInputType, required: boolean, unitPrice?: number | null, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }> };

export type V2Gateway_GetServiceOfferingCustomerInputGroupsQueryVariables = Exact<{
  serviceOfferingUid: Scalars['String']['input'];
}>;


export type V2Gateway_GetServiceOfferingCustomerInputGroupsQuery = { __typename?: 'Query', getServiceOfferingCustomerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string, title: string, index?: number | null, dependencies: Array<{ __typename?: 'DependencyTreeLevelNode', level: number, dependencyCustomerInputUid: string, dependentTriggerValues: Array<{ __typename?: 'DependentInputTriggerValues', triggerValues: Array<string>, dependentCustomerInputUid: string }> }> }> };

export type V2Gateway_GetCustomerInputsByUidQueryVariables = Exact<{
  customerInputUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetCustomerInputsByUidQuery = { __typename?: 'Query', getCustomerInputsByUid: Array<{ __typename?: 'CustomerInput', uid: string, title: string, index?: number | null, description?: string | null, type: CustomerInputType, required: boolean, unitPrice?: number | null, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }> };

export type V2Gateway_GetCustomerInputGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetCustomerInputGroupsQuery = { __typename?: 'Query', getCustomerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string, title: string, index?: number | null, dependencies: Array<{ __typename?: 'DependencyTreeLevelNode', level: number, dependencyCustomerInputUid: string, dependentTriggerValues: Array<{ __typename?: 'DependentInputTriggerValues', triggerValues: Array<string>, dependentCustomerInputUid: string }> }> }> };

export type V2Gateway_CreateCustomerInputsMutationVariables = Exact<{
  data: Array<CustomerInputInput> | CustomerInputInput;
}>;


export type V2Gateway_CreateCustomerInputsMutation = { __typename?: 'Mutation', createCustomerInputs: { __typename?: 'CreateCustomerInputsResponse', customerInputs: Array<{ __typename?: 'CreateCustomerInputResponse', customerInputUid: string, options: Array<{ __typename?: 'CreateCustomerInputOptionResponse', customerInputOptionUid: string, nonce?: string | null }> }> } };

export type V2Gateway_UpdateCustomerInputMutationVariables = Exact<{
  data: UpdateCustomerInputInput;
}>;


export type V2Gateway_UpdateCustomerInputMutation = { __typename?: 'Mutation', updateCustomerInput: { __typename?: 'UpdateCustomerInputResponse', options: Array<{ __typename?: 'UpdateCustomerInputOptionResponse', customerInputOptionUid: string, nonce?: string | null }> } };

export type V2Gateway_DeleteCustomerInputsMutationVariables = Exact<{
  customerInputUid: Scalars['String']['input'];
}>;


export type V2Gateway_DeleteCustomerInputsMutation = { __typename?: 'Mutation', deleteCustomerInput: boolean };

export type V2Gateway_SetServiceOfferingCustomerInputGroupsMutationVariables = Exact<{
  serviceOfferingUid: Scalars['String']['input'];
  customerInputGroupUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_SetServiceOfferingCustomerInputGroupsMutation = { __typename?: 'Mutation', setServiceOfferingCustomerInputGroups: boolean };

export type V2Gateway_GetFullMerchantQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetFullMerchantQuery = { __typename?: 'Query', getMerchant: { __typename?: 'Merchant', serviceType: string, isApproved: boolean, currency: string } };

export type V2Gateway_PartnerContextQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_PartnerContextQuery = { __typename?: 'Query', checkSessionValid: string, hasConnectedStripeAccount: boolean };

export type V2Gateway_GetServiceAreasForLocationsQueryVariables = Exact<{
  locationUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetServiceAreasForLocationsQuery = { __typename?: 'Query', getServiceAreasByLocationUid: Array<{ __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } }> }> };

export type V2Gateway_HasConnectedStripeAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_HasConnectedStripeAccountQuery = { __typename?: 'Query', hasConnectedStripeAccount: boolean };

export type DeepBookingFieldsFragment = { __typename?: 'Booking', startDateTime: number, endDateTime: number, uid: string, ownerUid: string, tipPercent: number, price: number, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', customerInputUids: Array<string>, optionValues: Array<string>, level: number }>> | null, appointment: { __typename?: 'Appointment', uid: string, isConfirmed: boolean, startDateTime: number, maxEndDateTime: number, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string } | null, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, streetAddress: string, name: string, type: LocationType, phoneNumber: string }, serviceProvider: { __typename?: 'ServiceProvider', serviceType: string, ownerUid: string, displayName: string, profile?: { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> } | null } }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, shortDesc?: string | null, basePrice: number, baseTime: number, type: ServiceOfferingType } };

export type QueryBookingsQueryVariables = Exact<{
  query: BookingQuery;
}>;


export type QueryBookingsQuery = { __typename?: 'Query', queryBookings: { __typename?: 'BookingQueryResult', bookings: Array<{ __typename?: 'Booking', isInProgress: boolean, startDateTime: number, endDateTime: number, uid: string, ownerUid: string, tipPercent: number, price: number, appointment: { __typename?: 'Appointment', uid: string, id: string, isConfirmed: boolean, startDateTime: number, maxEndDateTime: number, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, location: { __typename?: 'Location', uid: string, id: string, streetAddress: string, name: string, type: LocationType, phoneNumber: string, formattedAddress: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null } }, serviceProvider: { __typename?: 'ServiceProvider', serviceType: string, ownerUid: string, displayName: string, slug: string, profile?: { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> } | null } }, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', customerInputUids: Array<string>, optionValues: Array<string>, level: number }>> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, shortDesc?: string | null, basePrice: number, baseTime: number, type: ServiceOfferingType } }> } };

export type V2Gateway_QueryRecentBookingsQueryVariables = Exact<{
  query: BookingQuery;
}>;


export type V2Gateway_QueryRecentBookingsQuery = { __typename?: 'Query', queryBookings: { __typename?: 'BookingQueryResult', bookings: Array<{ __typename?: 'Booking', startDateTime: number, endDateTime: number, uid: string, ownerUid: string, tipPercent: number, price: number, accountingRecord?: { __typename?: 'AccountingRecord', total: number } | null, appointment: { __typename?: 'Appointment', uid: string, isConfirmed: boolean, startDateTime: number, maxEndDateTime: number, serviceProvider: { __typename?: 'ServiceProvider', serviceType: string, ownerUid: string, displayName: string, slug: string, reviewCount: number, averageRating: number, profile?: { __typename?: 'Profile', uid: string, displayName: string, description: string, skills?: Array<string> | null, ownerUid: string, introVideoURL: string, avatarImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, logoJpeg?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, bannerImage?: { __typename?: 'File', uid: string, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null, photoGallery?: { __typename?: 'PhotoGallery', uid: string, items: Array<{ __typename?: 'PhotoGalleryItem', label?: string | null, index: number, uid: string, imageFile: { __typename?: 'File', index?: number | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } } }> } | null, servicesCopy?: Array<{ __typename?: 'ServiceCopy', title: string, price: number }> | null, socialLinks: Array<{ __typename?: 'SocialLink', platform: string, url: string }> } | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string }>, reviews: Array<{ __typename?: 'Review', uid: string, isLike: boolean }> }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string } | null, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, streetAddress: string, name: string, type: LocationType, phoneNumber: string } }, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string }> | null, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', customerInputUids: Array<string>, optionValues: Array<string>, level: number }>> | null, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, shortDesc?: string | null, basePrice: number, baseTime: number, type: ServiceOfferingType } }> } };

export type QueryBookingsCountQueryVariables = Exact<{
  query: BookingQuery;
}>;


export type QueryBookingsCountQuery = { __typename?: 'Query', queryBookingsCount: number };

export type V2Gateway_QueryServiceOfferingsQueryVariables = Exact<{
  query: ServiceOfferingQuery;
}>;


export type V2Gateway_QueryServiceOfferingsQuery = { __typename?: 'Query', queryServiceOfferings: { __typename?: 'ServiceOfferingQueryResult', hasMoreResults: boolean, serviceOfferings: Array<{ __typename?: 'ServiceOffering', title: string, imageUrl?: string | null, basePrice: number, baseTime: number, uid: string, shortDesc?: string | null, type: ServiceOfferingType, maxConcurrentBookings: number, allowTip: boolean, index?: number | null, postServiceNote: string }> } };

export type V2Gateway_QueryLocationSubscriptionsQueryVariables = Exact<{
  query: LocationSubscriptionQuery;
}>;


export type V2Gateway_QueryLocationSubscriptionsQuery = { __typename?: 'Query', queryLocationSubscriptions: Array<{ __typename?: 'LocationSubscription', locationUid: string, ownerUid: string, location: { __typename?: 'Location', uid: string, id: string, name: string, formattedAddress: string, streetAddress: string, type: LocationType, latitude: number, longitude: number, placeId: string, phoneNumber: string, ownerUid: string, slug: string }, owner: { __typename?: 'User', isTemporary: boolean } }> };

export type V2Gateway_QueryBusinessesQueryVariables = Exact<{
  query: BusinessQuery;
}>;


export type V2Gateway_QueryBusinessesQuery = { __typename?: 'Query', queryBusinesses: { __typename?: 'BusinessQueryResult', businesses: Array<{ __typename?: 'Business', name: string, uid: string, locations: Array<{ __typename?: 'Location', id: string, uid: string, name: string, formattedAddress: string }> }> } };

export type V2Gateway_QueryAppointmentOracleQueryVariables = Exact<{
  query: AppointmentOracleQuery;
}>;


export type V2Gateway_QueryAppointmentOracleQuery = { __typename?: 'Query', queryAppointmentOracle: Array<{ __typename?: 'Appointment', startDateTime: number, isConfirmed: boolean, isCoveredByBusiness?: boolean | null, uid: string, id: string, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, displayName: string, serviceType: string, profile?: { __typename?: 'Profile', displayName: string } | null }, location: { __typename?: 'Location', id: string, uid: string } }> };

export type V2Gateway_SearchReviewsQueryVariables = Exact<{
  query: ReviewQuery;
}>;


export type V2Gateway_SearchReviewsQuery = { __typename?: 'Query', searchReviews: { __typename?: 'ReviewSearchResult', reviews: Array<{ __typename?: 'Review', uid: string, text: string, rating: number, createdAt: number, isExternal: boolean, externalAuthor?: string | null, serviceProvider: { __typename?: 'LegacyServiceProvider', ownerUid: string }, owner?: { __typename?: 'User', fullName: string } | null, booking?: { __typename?: 'Booking', uid: string } | null }> } };

export type V2Gateway_SearchAppointmentRequestsQueryVariables = Exact<{
  query: AppointmentRequestQuery;
}>;


export type V2Gateway_SearchAppointmentRequestsQuery = { __typename?: 'Query', searchAppointmentRequests: Array<{ __typename?: 'AppointmentRequest', uid: string, locationUid: string, denialReason: string, status: AppointmentRequestStatus, timezoneLocation: string, startDateTime: number, externalUid: string, ownerUid: string, serviceAreaUid: string, minEndDateTime: number, serviceProvider: { __typename?: 'LegacyServiceProvider', ownerUid: string, serviceType: string }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', label?: string | null, uid: string, externalUid?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null }> };

export type V1Gateway_RegisterUserMutationVariables = Exact<{
  accountType: Scalars['Int']['input'];
  country: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
  timezoneLocation: Scalars['String']['input'];
  businessInfo?: InputMaybe<BusinessRegistrationInfo>;
  serviceProviderInfo?: InputMaybe<ServiceProviderRegistrationInfo>;
  employeeInfo?: InputMaybe<EmployeeRegistrationInfo>;
  referrer?: InputMaybe<Scalars['String']['input']>;
}>;


export type V1Gateway_RegisterUserMutation = { __typename?: 'Mutation', register: boolean };

export type ServiceOfferingCategoryFieldsFragment = { __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> };

export type V2Gateway_SearchServiceOfferingCategoriesQueryVariables = Exact<{
  query: ServiceOfferingCategoryQuery;
}>;


export type V2Gateway_SearchServiceOfferingCategoriesQuery = { __typename?: 'Query', searchServiceOfferingCategories: { __typename?: 'ServiceOfferingCategoryQueryResult', serviceOfferingCategories: Array<{ __typename?: 'ServiceOfferingCategory', uid: string, title: string, description?: string | null, index?: number | null, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, basePrice: number, baseTime: number, index?: number | null, type: ServiceOfferingType, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }>, customerInputGroups: Array<{ __typename?: 'CustomerInputGroup', uid: string }> }> }> } };

export type CreateAppointmentChangeProposalMutationVariables = Exact<{
  input: AppointmentChangeProposalInput;
}>;


export type CreateAppointmentChangeProposalMutation = { __typename?: 'Mutation', createAppointmentChangeProposal: string };

export type UpdateAppointmentChangeProposalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AppointmentChangeProposalInput;
}>;


export type UpdateAppointmentChangeProposalMutation = { __typename?: 'Mutation', updateAppointmentChangeProposal: boolean };

export type DeleteAppointmentChangeProposalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAppointmentChangeProposalMutation = { __typename?: 'Mutation', deleteAppointmentChangeProposal: boolean };

export type GetAppointmentChangeProposalByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppointmentChangeProposalByIdQuery = { __typename?: 'Query', getAppointmentChangeProposalById: { __typename?: 'AppointmentChangeProposal', id: string, appointmentId: string, ownerUserUID: string, startDateTime: number, createdAt: number, updatedAt: number, status: AppointmentChangeProposalStatus, message: string } };

export type GetAppointmentChangeProposalsByAppointmentIdQueryVariables = Exact<{
  appointmentId: Scalars['ID']['input'];
}>;


export type GetAppointmentChangeProposalsByAppointmentIdQuery = { __typename?: 'Query', getAppointmentChangeProposalsByAppointmentId: Array<{ __typename?: 'AppointmentChangeProposal', id: string, appointmentId: string, ownerUserUID: string, startDateTime: number, createdAt: number, updatedAt: number, status: AppointmentChangeProposalStatus, message: string }> };

export type V2Gateway_CreateBookingsMutationVariables = Exact<{
  data: Array<CreateBookingInput> | CreateBookingInput;
}>;


export type V2Gateway_CreateBookingsMutation = { __typename?: 'Mutation', createBookings: Array<{ __typename?: 'UidNonce', uid: string, nonce: string }> };

export type V2Gateway_CreateRedeemableRedemptionsMutationVariables = Exact<{
  data: Array<RedeemableRedemptionInput> | RedeemableRedemptionInput;
}>;


export type V2Gateway_CreateRedeemableRedemptionsMutation = { __typename?: 'Mutation', createRedeemableRedemptions: boolean };

export type V2Gateway_QueryRedeemablesQueryVariables = Exact<{
  query: RedeemableQuery;
}>;


export type V2Gateway_QueryRedeemablesQuery = { __typename?: 'Query', queryRedeemables: { __typename?: 'RedeemableQueryResult', redeemables: Array<{ __typename?: 'Redeemable', uid: string, sideEffect?: { __typename?: 'RedemptionMutateDiscountSideEffect', discount: { __typename?: 'Discount', uid: string, value: number, name: string, type: DiscountType, isStackable: boolean, change: { __typename?: 'DiscountValueChange', type: DiscountValueChangeType, isCoveredByPlatform: boolean, isCoveredByLocation: boolean } } } | null }> } };

export type V2Gateway_IsRedeemableRedeemableQueryVariables = Exact<{
  uid: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  redeemAt: Scalars['Int']['input'];
}>;


export type V2Gateway_IsRedeemableRedeemableQuery = { __typename?: 'Query', isRedeemableRedeemable: boolean };

export type V2Gateway_GetServiceOfferingQueryVariables = Exact<{
  query: ServiceOfferingQuery;
}>;


export type V2Gateway_GetServiceOfferingQuery = { __typename?: 'Query', queryServiceOfferings: { __typename?: 'ServiceOfferingQueryResult', hasMoreResults: boolean, serviceOfferings: Array<{ __typename?: 'ServiceOffering', title: string, imageUrl?: string | null }> } };

export type V2Gateway_DeleteBookingsMutationVariables = Exact<{
  uids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  cancelReason: Scalars['String']['input'];
}>;


export type V2Gateway_DeleteBookingsMutation = { __typename?: 'Mutation', deleteBookings: boolean };

export type V2Gateway_GetLocationSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetLocationSubscriptionsQuery = { __typename?: 'Query', getLocationSubscriptions: Array<{ __typename?: 'LocationSubscription', locationUid: string, location: { __typename?: 'Location', id: string, name: string, formattedAddress: string, streetAddress: string, uid: string, latitude: number, longitude: number, ownerUid: string, type: LocationType, slug: string } }> };

export type V2Gateway_CreateLocationSubscriptionsMutationVariables = Exact<{
  data: Array<CreateLocationSubscriptionInput> | CreateLocationSubscriptionInput;
}>;


export type V2Gateway_CreateLocationSubscriptionsMutation = { __typename?: 'Mutation', createLocationSubscriptions: boolean };

export type V2Gateway_SetUserCountryMutationVariables = Exact<{
  country: Scalars['String']['input'];
  masqueradeAsUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type V2Gateway_SetUserCountryMutation = { __typename?: 'Mutation', setUserCountry: boolean };

export type V2Gateway_GetLocationsByUidQueryVariables = Exact<{
  locationUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_GetLocationsByUidQuery = { __typename?: 'Query', getLocationsByUid: Array<{ __typename?: 'Location', name: string, id: string, formattedAddress: string, streetAddress: string, uid: string, latitude: number, longitude: number, ownerUid: string, type: LocationType, slug: string, business?: { __typename?: 'Business', slug: string } | null }> };

export type GetAppointmentByBookingUidQueryVariables = Exact<{
  bookingUid: Scalars['String']['input'];
}>;


export type GetAppointmentByBookingUidQuery = { __typename?: 'Query', getAppointmentByBookingUid: { __typename?: 'Appointment', uid: string, locationUid: string, userUid: string, ownerUid: string, startDateTime: number, maxEndDateTime: number, bookings: Array<{ __typename?: 'Booking', isComplete: boolean, uid: string }> } };

export type GetAppointmentsByInternalUidQueryVariables = Exact<{
  uids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAppointmentsByInternalUidQuery = { __typename?: 'Query', getAppointments: Array<{ __typename?: 'Appointment', startDateTime: number, maxEndDateTime: number, ownerUid: string, userUid: string, locationUid: string, denialReason?: string | null, timezoneLocation: string, uid: string, id: string, serviceAreaUid?: string | null, isConfirmed: boolean, isCancelled: boolean, isCoveredByBusiness?: boolean | null, isComplete: boolean, expectedEarnings?: { __typename?: 'AppointmentExpectedEarnings', expectedEarnings: { __typename?: 'ExpectedEarnings', value: number, externalUid: string }, bookingsExpectedEarnings: Array<{ __typename?: 'ExpectedEarnings', externalUid: string, value: number }> } | null, discounts: Array<{ __typename?: 'Discount', type: DiscountType, value: number }>, location: { __typename?: 'Location', id: string, uid: string, formattedAddress: string, name: string, type: LocationType, extendedAddress?: string | null, streetAddress: string, phoneNumber: string, placeId: string, owner: { __typename?: 'User', fullName: string, emailAddress: string, phoneNumber?: string | null }, business?: { __typename?: 'Business', uid: string, name: string, website?: string | null } | null }, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, slug: string }, bookings: Array<{ __typename?: 'Booking', uid: string, startDateTime: number, endDateTime: number, isComplete: boolean, tipPercent: number, appointmentUid: string, isInProgress: boolean, customerInputGroupSelections?: Array<Array<{ __typename?: 'CustomerInputGroupSelectionsV2', level: number, customerInputUids: Array<string>, optionValues: Array<string>, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string, type: CustomerInputType, title: string, ownerUid: string, required: boolean, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }>, selectedOptions: Array<Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }>> }>> | null, customerInputSelections?: Array<{ __typename?: 'CustomerInputSelection', customerInputUid: string, optionValue: string, customerInput: { __typename?: 'CustomerInput', type: CustomerInputType, title: string, ownerUid: string, required: boolean, uid: string, options: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, duration: number, price: number }> }, selectedOptions: Array<{ __typename?: 'CustomerInputOption', uid: string, value: string, price: number, duration: number }> }> | null, owner: { __typename?: 'User', id: string, uid: string, fullName: string, emailAddress: string, phoneNumber?: string | null }, serviceOffering: { __typename?: 'ServiceOffering', uid: string, title: string, type: ServiceOfferingType, postServiceNote: string } }>, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, size?: ServiceAreaSize | null, files: Array<{ __typename?: 'File', uid: string, externalUid?: string | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', objectName: string, publicUrl: string } }> } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string, uid: string }> }> };

export type V2Gateway_SetReviewsMutationVariables = Exact<{
  data: Array<ReviewInput> | ReviewInput;
}>;


export type V2Gateway_SetReviewsMutation = { __typename?: 'Mutation', setReviews: boolean };

export type V2Gateway_GetPartnerAttributionsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
}>;


export type V2Gateway_GetPartnerAttributionsQuery = { __typename?: 'Query', getPartnerAttributionsCount: number, getPartnerTotalAttributionEarnings: number, getPartnerAttributions: Array<{ __typename?: 'PartnerAttribution', earnings: number }> };

export type V2Gateway_SigninPartnerMutationVariables = Exact<{
  idToken: Scalars['String']['input'];
}>;


export type V2Gateway_SigninPartnerMutation = { __typename?: 'Mutation', signinPartner: boolean };

export type ConnectStripeAccountMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ConnectStripeAccountMutation = { __typename?: 'Mutation', connectStripeAccount: boolean };

export type V2Gateway_GetIdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetIdentityQuery = { __typename?: 'Query', getIdentity: { __typename?: 'Identity', uid: string, emailAddress: string, fullName: string, providerId: string } };

export type GetUserQueryVariables = Exact<{
  uid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'User', uid: string, accountType: number, fullName: string, country: string, emailAddress: string, phoneNumber?: string | null, isTemporary: boolean } };

export type V2Gateway_CreateNoCalendarAccessMutationVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_CreateNoCalendarAccessMutation = { __typename?: 'Mutation', createNoCalendarAccess: boolean };

export type V2Gateway_CreateGoogleCalendarAccessMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type V2Gateway_CreateGoogleCalendarAccessMutation = { __typename?: 'Mutation', createGoogleCalendarAccess: boolean };

export type V2Gateway_SetDefaultAvailabilityMutationVariables = Exact<{
  data: Array<DayOfWeekAvailabilityInput> | DayOfWeekAvailabilityInput;
}>;


export type V2Gateway_SetDefaultAvailabilityMutation = { __typename?: 'Mutation', setDayOfWeekAvailability: boolean };

export type V2Gateway_SetDateAvailabilityMutationVariables = Exact<{
  data: Array<DateAvailabilityInput> | DateAvailabilityInput;
}>;


export type V2Gateway_SetDateAvailabilityMutation = { __typename?: 'Mutation', setDateAvailability: boolean };

export type V2Gateway_GetMerchantForPayoutSetupQueryVariables = Exact<{ [key: string]: never; }>;


export type V2Gateway_GetMerchantForPayoutSetupQuery = { __typename?: 'Query', hasConnectedStripeAccount: boolean, getMerchant: { __typename?: 'Merchant', payoutMethod?: string | null, moblFeePercent: number } };

export type V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryVariables = Exact<{
  customerInputGroupUid: Scalars['String']['input'];
}>;


export type V2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery = { __typename?: 'Query', getCustomerInputGroupServiceOfferingLinks: Array<string> };

export type V2Gateway_CreateCustomerInputGroupMutationVariables = Exact<{
  data: CustomerInputGroupInput;
}>;


export type V2Gateway_CreateCustomerInputGroupMutation = { __typename?: 'Mutation', createCustomerInputGroup: boolean };

export type V2Gateway_UpdateCustomerInputGroupMutationVariables = Exact<{
  customerInputGroupUid: Scalars['String']['input'];
  data: CustomerInputGroupInput;
}>;


export type V2Gateway_UpdateCustomerInputGroupMutation = { __typename?: 'Mutation', updateCustomerInputGroup: boolean };

export type V2Gateway_DeleteCustomerInputGroupMutationVariables = Exact<{
  customerInputGroupUid: Scalars['String']['input'];
}>;


export type V2Gateway_DeleteCustomerInputGroupMutation = { __typename?: 'Mutation', deleteCustomerInputGroup: boolean };

export type V2Gateway_CreateServiceOfferingCategoriesMutationVariables = Exact<{
  data: Array<CreateServiceOfferingCategoryInput> | CreateServiceOfferingCategoryInput;
}>;


export type V2Gateway_CreateServiceOfferingCategoriesMutation = { __typename?: 'Mutation', createServiceOfferingCategories: Array<string> };

export type V2Gateway_UpdateServiceOfferingCategoriesMutationVariables = Exact<{
  data: Array<UpdateServiceOfferingCategoryInput> | UpdateServiceOfferingCategoryInput;
}>;


export type V2Gateway_UpdateServiceOfferingCategoriesMutation = { __typename?: 'Mutation', updateServiceOfferingCategories: boolean };

export type V2Gateway_DeleteServiceOfferingCategoriesMutationVariables = Exact<{
  uids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_DeleteServiceOfferingCategoriesMutation = { __typename?: 'Mutation', deleteServiceOfferingCategories: boolean };

export type V2Gateway_GetServiceOfferingCustomerInputsQueryVariables = Exact<{
  serviceOfferingUid: Scalars['String']['input'];
}>;


export type V2Gateway_GetServiceOfferingCustomerInputsQuery = { __typename?: 'Query', getServiceOfferingCustomerInputs: Array<{ __typename?: 'CustomerInput', uid: string, title: string }> };

export type V2Gateway_SetServiceOfferingCustomerInputsMutationVariables = Exact<{
  serviceOfferingUid: Scalars['String']['input'];
  customerInputUids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_SetServiceOfferingCustomerInputsMutation = { __typename?: 'Mutation', setServiceOfferingCustomerInputs: boolean };

export type V2Gateway_CreateServiceOfferingMutationVariables = Exact<{
  data: CreateServiceOfferingInput;
}>;


export type V2Gateway_CreateServiceOfferingMutation = { __typename?: 'Mutation', createServiceOffering: Array<{ __typename?: 'UidNonce', uid: string }> };

export type V2Gateway_UpdateServiceOfferingMutationVariables = Exact<{
  data: UpdateServiceOfferingInput;
}>;


export type V2Gateway_UpdateServiceOfferingMutation = { __typename?: 'Mutation', updateServiceOffering: boolean };

export type V2Gateway_GetServiceOfferingsQueryVariables = Exact<{
  query: ServiceOfferingQuery;
}>;


export type V2Gateway_GetServiceOfferingsQuery = { __typename?: 'Query', queryServiceOfferings: { __typename?: 'ServiceOfferingQueryResult', hasMoreResults: boolean, serviceOfferings: Array<{ __typename?: 'ServiceOffering', title: string, basePrice: number, shortDesc?: string | null, baseTime: number, imageUrl?: string | null, uid: string, type: ServiceOfferingType, allowTip: boolean, maxConcurrentBookings: number, index?: number | null, postServiceNote: string, isHidden: boolean, customerInputs: Array<{ __typename?: 'CustomerInput', uid: string }> }> } };

export type V2Gateway_DeleteServiceOfferingsMutationVariables = Exact<{
  uids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type V2Gateway_DeleteServiceOfferingsMutation = { __typename?: 'Mutation', deleteServiceOfferings: boolean };

export type V2Gateway_GetLocationQueryVariables = Exact<{
  locationUid: Scalars['String']['input'];
}>;


export type V2Gateway_GetLocationQuery = { __typename?: 'Query', getLocation: { __typename?: 'Location', uid: string, id: string, name: string, streetAddress: string, formattedAddress: string, phoneNumber: string, type: LocationType, extendedAddress?: string | null, latitude: number, longitude: number, ownerUid: string, placeId: string, slug: string, serviceAreas: Array<{ __typename?: 'ServiceArea', uid: string, name: string, description: string, externalUid: string, files: Array<{ __typename?: 'File', uid: string, index?: number | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } }> }>, business?: { __typename?: 'Business', slug: string, uid: string } | null, files: Array<{ __typename?: 'File', uid: string, index?: number | null, label?: string | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } }> } };

export type V2Gateway_GetLocationWithConfirmedAppointmentsQueryVariables = Exact<{
  locationUid: Scalars['String']['input'];
  minStartTime: Scalars['Int']['input'];
}>;


export type V2Gateway_GetLocationWithConfirmedAppointmentsQuery = { __typename?: 'Query', getLocation: { __typename?: 'Location', formattedAddress: string, name: string, externalUid?: string | null, ownerUid: string, type: LocationType, phoneNumber: string, uid: string, id: string, files: Array<{ __typename?: 'File', uid: string, index?: number | null, uploadedFile: { __typename?: 'UploadedFile', publicUrl: string, objectName: string } }>, appointments: Array<{ __typename?: 'Appointment', startDateTime: number, maxEndDateTime: number, uid: string, id: string, serviceProvider: { __typename?: 'ServiceProvider', ownerUid: string, serviceType: string, displayName: string, serviceOfferings: Array<{ __typename?: 'ServiceOffering', uid: string, title: string, index?: number | null }>, reviews: Array<{ __typename?: 'Review', isLike: boolean, isVerified: boolean }>, profile?: { __typename?: 'Profile', displayName: string, avatarImage?: { __typename?: 'File', uploadedFile: { __typename?: 'UploadedFile', publicUrl: string } } | null } | null, insuranceInformation?: { __typename?: 'InsuranceClaimableServiceProvider', titlePrefix?: string | null, titleSuffix?: string | null } | null }, serviceArea?: { __typename?: 'ServiceArea', uid: string, name: string } | null, preferences: Array<{ __typename?: 'AppointmentPreference', type: AppointmentPreferenceType, value: string }> }> } };

export const AppointmentCartFieldsFragmentDoc = gql`
    fragment appointmentCartFields on AppointmentCart {
  uid
  serviceProviderUid
  appointmentSelections {
    startDateTime
    serviceProviderOwnerUid
    locationUid
    serviceAreaUid
    startDateTime
  }
}
    `;
export const BookingCartFieldsFragmentDoc = gql`
    fragment bookingCartFields on BookingCart {
  uid
  serviceProviderUid
  redeemableSecret
  appointmentUid
  appointment {
    id
    uid
    locationUid
  }
  ownerUid
  bookingSelections {
    appointmentUid
    startDateTime
    tipPercent
    serviceOfferingUid
    customerProfileId
    customerInputSelections {
      customerInputUid
      optionValue
    }
    customerInputGroupSelections {
      customerInputUids
      optionValues
      level
    }
  }
  redeemable {
    sideEffect {
      discount {
        value
        type
        isStackable
      }
    }
  }
}
    `;
export const DropoffBookingAppointmentLocationFieldsFragmentDoc = gql`
    fragment dropoffBookingAppointmentLocationFields on Location {
  id
  uid
  formattedAddress
  name
  type
  extendedAddress
  streetAddress
  phoneNumber
  placeId
  owner {
    fullName
    emailAddress
    phoneNumber
  }
  business {
    uid
    name
    website
  }
}
    `;
export const DropoffFieldsFragmentDoc = gql`
    fragment dropoffFields on Dropoff {
  dropoffDateTime
  booking {
    uid
    startDateTime
    endDateTime
    isComplete
    tipPercent
    appointmentUid
    isInProgress
    customerInputGroupSelections {
      level
      customerInputUids
      optionValues
      customerInputs {
        uid
        type
        title
        ownerUid
        required
        options {
          uid
          value
          price
          duration
        }
      }
      selectedOptions {
        uid
        value
        price
        duration
      }
    }
    customerInputSelections {
      customerInputUid
      optionValue
      customerInput {
        type
        title
        ownerUid
        required
        uid
        options {
          uid
          value
          duration
          price
        }
      }
      selectedOptions {
        uid
        value
        price
        duration
      }
    }
    serviceOffering {
      uid
      title
      type
    }
    appointment {
      uid
      serviceArea {
        uid
        name
      }
      location {
        ...dropoffBookingAppointmentLocationFields
      }
    }
    customer {
      id
      user {
        id
        uid
        fullName
        emailAddress
        phoneNumber
      }
    }
  }
}
    ${DropoffBookingAppointmentLocationFieldsFragmentDoc}`;
export const AppointmentBookingFieldsFragmentDoc = gql`
    fragment appointmentBookingFields on Booking {
  uid
  startDateTime
  endDateTime
  isComplete
  tipPercent
  appointmentUid
  isInProgress
  customerInputGroupSelections {
    level
    customerInputUids
    optionValues
    customerInputs {
      uid
      type
      title
      ownerUid
      required
      options {
        uid
        value
        price
        duration
      }
    }
    selectedOptions {
      uid
      value
      price
      duration
    }
  }
  customerInputSelections {
    customerInputUid
    optionValue
    customerInput {
      type
      title
      ownerUid
      required
      uid
      options {
        uid
        value
        duration
        price
      }
    }
    selectedOptions {
      uid
      value
      price
      duration
    }
  }
  owner {
    id
    uid
    fullName
    emailAddress
    phoneNumber
  }
  serviceOffering {
    uid
    title
    type
    postServiceNote
  }
}
    `;
export const AppointmentFieldsExtendedFragmentDoc = gql`
    fragment appointmentFieldsExtended on Appointment {
  startDateTime
  maxEndDateTime
  ownerUid
  userUid
  locationUid
  denialReason
  timezoneLocation
  uid
  id
  serviceAreaUid
  isConfirmed
  isCancelled
  isCoveredByBusiness
  isComplete
  expectedEarnings {
    expectedEarnings {
      value
      externalUid
    }
    bookingsExpectedEarnings {
      externalUid
      value
    }
  }
  discounts {
    type
    value
  }
  location {
    id
    uid
    formattedAddress
    name
    type
    extendedAddress
    streetAddress
    phoneNumber
    placeId
    owner {
      fullName
      emailAddress
      phoneNumber
    }
    business {
      uid
      name
      website
    }
  }
  serviceProvider {
    ownerUid
    serviceType
    slug
  }
  bookings(statusQuery: {cancelledStatus: NOT_CANCELLED}) {
    ...appointmentBookingFields
  }
  serviceArea {
    uid
    name
    description
    externalUid
    size
    files {
      uid
      externalUid
      label
      uploadedFile {
        objectName
        publicUrl
      }
    }
  }
  preferences {
    type
    value
    uid
  }
}
    ${AppointmentBookingFieldsFragmentDoc}`;
export const ProfileFragmentFragmentDoc = gql`
    fragment profileFragment on Profile {
  uid
  displayName
  description
  skills
  avatarImage {
    uid
    uploadedFile {
      publicUrl
    }
  }
  logoJpeg {
    uid
    uploadedFile {
      publicUrl
    }
  }
  bannerImage {
    uid
    uploadedFile {
      publicUrl
    }
  }
  photoGallery {
    uid
    items {
      label
      index
      uid
      imageFile {
        index
        uid
        externalUid
        uploadedFile {
          publicUrl
          objectName
        }
      }
    }
  }
  ownerUid
  servicesCopy {
    title
    price
  }
  socialLinks {
    platform
    url
  }
  introVideoURL
}
    `;
export const ServiceOfferingCategoryFieldsFragmentDoc = gql`
    fragment serviceOfferingCategoryFields on ServiceOfferingCategory {
  uid
  title
  description
  index
  serviceOfferings {
    uid
    title
    basePrice
    baseTime
    index
    type
    customerInputs {
      uid
    }
    customerInputGroups {
      uid
    }
  }
}
    `;
export const ServiceProviderFullFragmentDoc = gql`
    fragment serviceProviderFull on LegacyServiceProvider {
  fullName
  displayName
  ownerUid
  serviceType
  isApproved
  profile {
    ...profileFragment
  }
  reviews {
    uid
    text
    isLike
    createdAt
    isExternal
    externalAuthor
    owner {
      fullName
    }
  }
  serviceOfferings {
    uid
    basePrice
    baseTime
    title
    shortDesc
    allowTip
    maxConcurrentBookings
    type
    customerInputs {
      uid
    }
    customerInputGroups {
      uid
    }
  }
  serviceOfferingCategories {
    ...serviceOfferingCategoryFields
  }
  owner {
    fullName
  }
  preferences {
    id
    type
    value
  }
}
    ${ProfileFragmentFragmentDoc}
${ServiceOfferingCategoryFieldsFragmentDoc}`;
export const ServiceProviderFullNewFragmentDoc = gql`
    fragment serviceProviderFullNew on ServiceProvider {
  displayName
  ownerUid
  serviceType
  isApproved
  slug
  profile {
    ...profileFragment
    socialLinks {
      platform
      url
    }
    introVideoURL
  }
  reviews {
    uid
    text
    isLike
    rating
    createdAt
    isExternal
    externalAuthor
    owner {
      fullName
    }
  }
  serviceOfferings {
    uid
    basePrice
    baseTime
    title
    shortDesc
    allowTip
    maxConcurrentBookings
    type
    postServiceNote
    customerInputs {
      uid
    }
    customerInputGroups {
      uid
    }
  }
  serviceOfferingCategories {
    ...serviceOfferingCategoryFields
  }
  user {
    id
    fullName
    timezoneLocation
    country
  }
  preferences {
    id
    type
    value
  }
}
    ${ProfileFragmentFragmentDoc}
${ServiceOfferingCategoryFieldsFragmentDoc}`;
export const ServiceProviderBySlugWithDiscountRulesAndPreferencesFragmentDoc = gql`
    fragment serviceProviderBySlugWithDiscountRulesAndPreferences on ServiceProvider {
  slug
  serviceType
  id
  displayName
  averageRating
  reviewCount
  reviews {
    uid
    createdAt
    isLike
    rating
    text
    owner {
      fullName
    }
    isExternal
    externalAuthor
  }
  user {
    id
    uid
    emailAddress
    timezoneLocation
  }
  profile {
    ...profileFragment
    introVideoURL
    socialLinks {
      platform
      url
    }
    servicesCopy {
      title
      price
    }
  }
  serviceOfferings {
    uid
    basePrice
    baseTime
    title
    type
  }
  serviceOfferingCategories {
    ...serviceOfferingCategoryFields
  }
  dayOfWeekAvailability {
    dayOfWeek
    availability {
      timeUtcSecondsBounds {
        min
        max
      }
    }
  }
  discountRules {
    id
    isDisabled
    label
    triggerCondition {
      siblingBookingTriggerCondition {
        requireBookingCount
        ignoreServiceOfferingUids
      }
      timeDurationBookedAtLocationTriggerCondition {
        requireDurationBookedSeconds
        ignoreServiceOfferingUids
      }
    }
    discountValue
    discountType
    priority
  }
  preferences {
    id
    type
    value
  }
  location {
    id
    formattedAddress
    phoneNumber
    discoverableBounds {
      min {
        lat
        lng
      }
      max {
        lat
        lng
      }
    }
  }
}
    ${ProfileFragmentFragmentDoc}
${ServiceOfferingCategoryFieldsFragmentDoc}`;
export const GetServiceProviderForServiceProviderDashboardServiceOfferingFieldsFragmentDoc = gql`
    fragment getServiceProviderForServiceProviderDashboardServiceOfferingFields on ServiceOffering {
  uid
  basePrice
  baseTime
  title
  shortDesc
  allowTip
  maxConcurrentBookings
  type
  customerInputs {
    uid
    title
    description
    type
    required
    index
    unitPrice
    options {
      price
      duration
      value
      uid
    }
  }
}
    `;
export const ReminderFieldsFragmentDoc = gql`
    fragment reminderFields on ServiceProviderReminder {
  id
  label
  text
  dateTime
  customer {
    id
    user {
      fullName
    }
  }
}
    `;
export const ServiceOfferingWithCustomerInputsFragmentDoc = gql`
    fragment serviceOfferingWithCustomerInputs on ServiceOffering {
  uid
  title
  shortDesc
  basePrice
  baseTime
  allowTip
  type
  maxConcurrentBookings
  ownerUid
  postServiceNote
  customerInputs {
    uid
    title
    type
    required
    description
    unitPrice
    index
    options {
      value
      duration
      price
      uid
    }
  }
}
    `;
export const AppointmentRequestFieldsFragmentDoc = gql`
    fragment appointmentRequestFields on AppointmentRequest {
  uid
  locationUid
  denialReason
  status
  timezoneLocation
  startDateTime
  externalUid
  ownerUid
  serviceAreaUid
  minEndDateTime
  serviceProvider {
    ownerUid
    serviceType
  }
  serviceArea {
    uid
    name
    description
    externalUid
    size
    files {
      label
      uid
      externalUid
      uploadedFile {
        objectName
        publicUrl
      }
    }
  }
}
    `;
export const EagerBookingFieldsFragmentDoc = gql`
    fragment eagerBookingFields on EagerBooking {
  uid
  externalUid
  ownerUid
  appointmentRequest {
    uid
    startDateTime
    minEndDateTime
    serviceAreaUid
    serviceProvider {
      ownerUid
    }
    location {
      id
      uid
    }
  }
  quotedDuration
  uidForBooking
  booking {
    customerInputSelections {
      customerInputUid
      optionValue
      customerInput {
        type
        title
        ownerUid
        required
        uid
        options {
          uid
          value
          duration
          price
        }
      }
      selectedOptions {
        uid
        value
        price
        duration
      }
    }
    customerInputGroupSelections {
      level
      customerInputUids
      optionValues
      customerInputs {
        uid
        type
        title
        ownerUid
        required
        options {
          uid
          value
          price
          duration
        }
      }
      selectedOptions {
        uid
        value
        price
        duration
      }
    }
    tipPercent
    startDateTime
    serviceOfferingUid
    serviceOffering {
      uid
      type
      maxConcurrentBookings
      baseTime
      title
    }
  }
}
    `;
export const LocationPolicyFieldsFragmentDoc = gql`
    fragment locationPolicyFields on LocationPolicy {
  uid
  valueType
  policyType
  name
  value
  externalUid
}
    `;
export const DayOfWeekAvailabilityFieldsFragmentDoc = gql`
    fragment dayOfWeekAvailabilityFields on DayOfWeekAvailability {
  dayOfWeek
  timezone
  ownerUid
  availability {
    timeUtcSecondsBounds {
      min
      max
    }
  }
}
    `;
export const DateAvailabilityFieldsFragmentDoc = gql`
    fragment dateAvailabilityFields on DateAvailability {
  date
  timezone
  ownerUid
  availability {
    timeUtcSecondsBounds {
      min
      max
    }
  }
}
    `;
export const BalanceFieldsFragmentDoc = gql`
    fragment balanceFields on StripeAmount {
  currency
  value
}
    `;
export const BookingFieldsFragmentDoc = gql`
    fragment bookingFields on Booking {
  uid
  ownerUid
  tipPercent
  earnings
  serviceOfferingUid
  isComplete
  customerInputSelections {
    customerInputUid
    optionValue
  }
  customerInputGroupSelections {
    level
    customerInputUids
    optionValues
  }
  appointmentUid
  startDateTime
  endDateTime
}
    `;
export const CustomerInputFieldsFragmentDoc = gql`
    fragment customerInputFields on CustomerInput {
  uid
  title
  index
  description
  type
  required
  unitPrice
  options {
    uid
    value
    duration
    price
  }
}
    `;
export const CustomerInputGroupFieldsFragmentDoc = gql`
    fragment customerInputGroupFields on CustomerInputGroup {
  uid
  dependencies {
    dependentTriggerValues {
      triggerValues
      dependentCustomerInputUid
    }
    level
    dependencyCustomerInputUid
  }
  title
  index
}
    `;
export const DeepBookingFieldsFragmentDoc = gql`
    fragment deepBookingFields on Booking {
  startDateTime
  endDateTime
  uid
  ownerUid
  tipPercent
  price
  customerInputSelections {
    customerInputUid
    optionValue
  }
  customerInputGroupSelections {
    customerInputUids
    optionValues
    level
  }
  appointment {
    uid
    isConfirmed
    serviceArea {
      uid
      name
      description
    }
    startDateTime
    maxEndDateTime
    location {
      id
      uid
      formattedAddress
      streetAddress
      name
      type
      phoneNumber
    }
    serviceProvider {
      serviceType
      ownerUid
      displayName
      profile {
        ...profileFragment
      }
    }
  }
  serviceOffering {
    uid
    title
    shortDesc
    basePrice
    baseTime
    type
  }
}
    ${ProfileFragmentFragmentDoc}`;
export const AcceptCustomerInviteDocument = gql`
    mutation AcceptCustomerInvite($customerInviteId: ID!) {
  acceptCustomerInvite(id: $customerInviteId)
}
    `;
export type AcceptCustomerInviteMutationFn = Apollo.MutationFunction<AcceptCustomerInviteMutation, AcceptCustomerInviteMutationVariables>;

/**
 * __useAcceptCustomerInviteMutation__
 *
 * To run a mutation, you first call `useAcceptCustomerInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCustomerInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCustomerInviteMutation, { data, loading, error }] = useAcceptCustomerInviteMutation({
 *   variables: {
 *      customerInviteId: // value for 'customerInviteId'
 *   },
 * });
 */
export function useAcceptCustomerInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptCustomerInviteMutation, AcceptCustomerInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptCustomerInviteMutation, AcceptCustomerInviteMutationVariables>(AcceptCustomerInviteDocument, options);
      }
export type AcceptCustomerInviteMutationHookResult = ReturnType<typeof useAcceptCustomerInviteMutation>;
export type AcceptCustomerInviteMutationResult = Apollo.MutationResult<AcceptCustomerInviteMutation>;
export type AcceptCustomerInviteMutationOptions = Apollo.BaseMutationOptions<AcceptCustomerInviteMutation, AcceptCustomerInviteMutationVariables>;
export const V2Gateway_SearchAppointmentCartsDocument = gql`
    query V2Gateway_SearchAppointmentCarts($query: AppointmentCartQuery!) {
  searchAppointmentCarts(query: $query) {
    appointmentCarts {
      ...appointmentCartFields
    }
  }
}
    ${AppointmentCartFieldsFragmentDoc}`;

/**
 * __useV2Gateway_SearchAppointmentCartsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_SearchAppointmentCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SearchAppointmentCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_SearchAppointmentCartsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_SearchAppointmentCartsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_SearchAppointmentCartsQuery, V2Gateway_SearchAppointmentCartsQueryVariables> & ({ variables: V2Gateway_SearchAppointmentCartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_SearchAppointmentCartsQuery, V2Gateway_SearchAppointmentCartsQueryVariables>(V2Gateway_SearchAppointmentCartsDocument, options);
      }
export function useV2Gateway_SearchAppointmentCartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_SearchAppointmentCartsQuery, V2Gateway_SearchAppointmentCartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_SearchAppointmentCartsQuery, V2Gateway_SearchAppointmentCartsQueryVariables>(V2Gateway_SearchAppointmentCartsDocument, options);
        }
export function useV2Gateway_SearchAppointmentCartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_SearchAppointmentCartsQuery, V2Gateway_SearchAppointmentCartsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_SearchAppointmentCartsQuery, V2Gateway_SearchAppointmentCartsQueryVariables>(V2Gateway_SearchAppointmentCartsDocument, options);
        }
export type V2Gateway_SearchAppointmentCartsQueryHookResult = ReturnType<typeof useV2Gateway_SearchAppointmentCartsQuery>;
export type V2Gateway_SearchAppointmentCartsLazyQueryHookResult = ReturnType<typeof useV2Gateway_SearchAppointmentCartsLazyQuery>;
export type V2Gateway_SearchAppointmentCartsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_SearchAppointmentCartsSuspenseQuery>;
export type V2Gateway_SearchAppointmentCartsQueryResult = Apollo.QueryResult<V2Gateway_SearchAppointmentCartsQuery, V2Gateway_SearchAppointmentCartsQueryVariables>;
export const V2Gateway_CreateAppointmentCartDocument = gql`
    mutation V2Gateway_CreateAppointmentCart($data: CreateAppointmentCartInput!) {
  createAppointmentCart(data: $data)
}
    `;
export type V2Gateway_CreateAppointmentCartMutationFn = Apollo.MutationFunction<V2Gateway_CreateAppointmentCartMutation, V2Gateway_CreateAppointmentCartMutationVariables>;

/**
 * __useV2Gateway_CreateAppointmentCartMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateAppointmentCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateAppointmentCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateAppointmentCartMutation, { data, loading, error }] = useV2Gateway_CreateAppointmentCartMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateAppointmentCartMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateAppointmentCartMutation, V2Gateway_CreateAppointmentCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateAppointmentCartMutation, V2Gateway_CreateAppointmentCartMutationVariables>(V2Gateway_CreateAppointmentCartDocument, options);
      }
export type V2Gateway_CreateAppointmentCartMutationHookResult = ReturnType<typeof useV2Gateway_CreateAppointmentCartMutation>;
export type V2Gateway_CreateAppointmentCartMutationResult = Apollo.MutationResult<V2Gateway_CreateAppointmentCartMutation>;
export type V2Gateway_CreateAppointmentCartMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateAppointmentCartMutation, V2Gateway_CreateAppointmentCartMutationVariables>;
export const V2Gateway_UpdateAppointmentCartDocument = gql`
    mutation V2Gateway_UpdateAppointmentCart($data: UpdateAppointmentCartInput!) {
  updateAppointmentCart(data: $data)
}
    `;
export type V2Gateway_UpdateAppointmentCartMutationFn = Apollo.MutationFunction<V2Gateway_UpdateAppointmentCartMutation, V2Gateway_UpdateAppointmentCartMutationVariables>;

/**
 * __useV2Gateway_UpdateAppointmentCartMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateAppointmentCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateAppointmentCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateAppointmentCartMutation, { data, loading, error }] = useV2Gateway_UpdateAppointmentCartMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateAppointmentCartMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateAppointmentCartMutation, V2Gateway_UpdateAppointmentCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateAppointmentCartMutation, V2Gateway_UpdateAppointmentCartMutationVariables>(V2Gateway_UpdateAppointmentCartDocument, options);
      }
export type V2Gateway_UpdateAppointmentCartMutationHookResult = ReturnType<typeof useV2Gateway_UpdateAppointmentCartMutation>;
export type V2Gateway_UpdateAppointmentCartMutationResult = Apollo.MutationResult<V2Gateway_UpdateAppointmentCartMutation>;
export type V2Gateway_UpdateAppointmentCartMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateAppointmentCartMutation, V2Gateway_UpdateAppointmentCartMutationVariables>;
export const V2Gateway_DeleteAppointmentCartsDocument = gql`
    mutation V2Gateway_DeleteAppointmentCarts($uids: [String!]!) {
  deleteAppointmentCarts(uids: $uids)
}
    `;
export type V2Gateway_DeleteAppointmentCartsMutationFn = Apollo.MutationFunction<V2Gateway_DeleteAppointmentCartsMutation, V2Gateway_DeleteAppointmentCartsMutationVariables>;

/**
 * __useV2Gateway_DeleteAppointmentCartsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteAppointmentCartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteAppointmentCartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteAppointmentCartsMutation, { data, loading, error }] = useV2Gateway_DeleteAppointmentCartsMutation({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useV2Gateway_DeleteAppointmentCartsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteAppointmentCartsMutation, V2Gateway_DeleteAppointmentCartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteAppointmentCartsMutation, V2Gateway_DeleteAppointmentCartsMutationVariables>(V2Gateway_DeleteAppointmentCartsDocument, options);
      }
export type V2Gateway_DeleteAppointmentCartsMutationHookResult = ReturnType<typeof useV2Gateway_DeleteAppointmentCartsMutation>;
export type V2Gateway_DeleteAppointmentCartsMutationResult = Apollo.MutationResult<V2Gateway_DeleteAppointmentCartsMutation>;
export type V2Gateway_DeleteAppointmentCartsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteAppointmentCartsMutation, V2Gateway_DeleteAppointmentCartsMutationVariables>;
export const V2Gateway_GetOrInitializeAppointmentCartDocument = gql`
    mutation V2Gateway_GetOrInitializeAppointmentCart($serviceProviderUid: String!) {
  getOrInitializeAppointmentCart(serviceProviderUid: $serviceProviderUid) {
    ...appointmentCartFields
  }
}
    ${AppointmentCartFieldsFragmentDoc}`;
export type V2Gateway_GetOrInitializeAppointmentCartMutationFn = Apollo.MutationFunction<V2Gateway_GetOrInitializeAppointmentCartMutation, V2Gateway_GetOrInitializeAppointmentCartMutationVariables>;

/**
 * __useV2Gateway_GetOrInitializeAppointmentCartMutation__
 *
 * To run a mutation, you first call `useV2Gateway_GetOrInitializeAppointmentCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetOrInitializeAppointmentCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayGetOrInitializeAppointmentCartMutation, { data, loading, error }] = useV2Gateway_GetOrInitializeAppointmentCartMutation({
 *   variables: {
 *      serviceProviderUid: // value for 'serviceProviderUid'
 *   },
 * });
 */
export function useV2Gateway_GetOrInitializeAppointmentCartMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_GetOrInitializeAppointmentCartMutation, V2Gateway_GetOrInitializeAppointmentCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_GetOrInitializeAppointmentCartMutation, V2Gateway_GetOrInitializeAppointmentCartMutationVariables>(V2Gateway_GetOrInitializeAppointmentCartDocument, options);
      }
export type V2Gateway_GetOrInitializeAppointmentCartMutationHookResult = ReturnType<typeof useV2Gateway_GetOrInitializeAppointmentCartMutation>;
export type V2Gateway_GetOrInitializeAppointmentCartMutationResult = Apollo.MutationResult<V2Gateway_GetOrInitializeAppointmentCartMutation>;
export type V2Gateway_GetOrInitializeAppointmentCartMutationOptions = Apollo.BaseMutationOptions<V2Gateway_GetOrInitializeAppointmentCartMutation, V2Gateway_GetOrInitializeAppointmentCartMutationVariables>;
export const GetAppointmentCartByUidDocument = gql`
    query GetAppointmentCartByUID($uid: String!) {
  getAppointmentCartByUID(uid: $uid) {
    ...appointmentCartFields
  }
}
    ${AppointmentCartFieldsFragmentDoc}`;

/**
 * __useGetAppointmentCartByUidQuery__
 *
 * To run a query within a React component, call `useGetAppointmentCartByUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentCartByUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentCartByUidQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAppointmentCartByUidQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentCartByUidQuery, GetAppointmentCartByUidQueryVariables> & ({ variables: GetAppointmentCartByUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentCartByUidQuery, GetAppointmentCartByUidQueryVariables>(GetAppointmentCartByUidDocument, options);
      }
export function useGetAppointmentCartByUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentCartByUidQuery, GetAppointmentCartByUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentCartByUidQuery, GetAppointmentCartByUidQueryVariables>(GetAppointmentCartByUidDocument, options);
        }
export function useGetAppointmentCartByUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentCartByUidQuery, GetAppointmentCartByUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentCartByUidQuery, GetAppointmentCartByUidQueryVariables>(GetAppointmentCartByUidDocument, options);
        }
export type GetAppointmentCartByUidQueryHookResult = ReturnType<typeof useGetAppointmentCartByUidQuery>;
export type GetAppointmentCartByUidLazyQueryHookResult = ReturnType<typeof useGetAppointmentCartByUidLazyQuery>;
export type GetAppointmentCartByUidSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentCartByUidSuspenseQuery>;
export type GetAppointmentCartByUidQueryResult = Apollo.QueryResult<GetAppointmentCartByUidQuery, GetAppointmentCartByUidQueryVariables>;
export const V2Gateway_CreateAppointmentPreferencesDocument = gql`
    mutation V2Gateway_CreateAppointmentPreferences($data: [CreateAppointmentPreferenceInput!]!) {
  createAppointmentPreferences(data: $data)
}
    `;
export type V2Gateway_CreateAppointmentPreferencesMutationFn = Apollo.MutationFunction<V2Gateway_CreateAppointmentPreferencesMutation, V2Gateway_CreateAppointmentPreferencesMutationVariables>;

/**
 * __useV2Gateway_CreateAppointmentPreferencesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateAppointmentPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateAppointmentPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateAppointmentPreferencesMutation, { data, loading, error }] = useV2Gateway_CreateAppointmentPreferencesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateAppointmentPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateAppointmentPreferencesMutation, V2Gateway_CreateAppointmentPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateAppointmentPreferencesMutation, V2Gateway_CreateAppointmentPreferencesMutationVariables>(V2Gateway_CreateAppointmentPreferencesDocument, options);
      }
export type V2Gateway_CreateAppointmentPreferencesMutationHookResult = ReturnType<typeof useV2Gateway_CreateAppointmentPreferencesMutation>;
export type V2Gateway_CreateAppointmentPreferencesMutationResult = Apollo.MutationResult<V2Gateway_CreateAppointmentPreferencesMutation>;
export type V2Gateway_CreateAppointmentPreferencesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateAppointmentPreferencesMutation, V2Gateway_CreateAppointmentPreferencesMutationVariables>;
export const V2Gateway_UpdateAppointmentPreferencesDocument = gql`
    mutation V2Gateway_UpdateAppointmentPreferences($data: [UpdateAppointmentPreferenceInput!]!) {
  updateAppointmentPreferences(data: $data)
}
    `;
export type V2Gateway_UpdateAppointmentPreferencesMutationFn = Apollo.MutationFunction<V2Gateway_UpdateAppointmentPreferencesMutation, V2Gateway_UpdateAppointmentPreferencesMutationVariables>;

/**
 * __useV2Gateway_UpdateAppointmentPreferencesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateAppointmentPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateAppointmentPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateAppointmentPreferencesMutation, { data, loading, error }] = useV2Gateway_UpdateAppointmentPreferencesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateAppointmentPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateAppointmentPreferencesMutation, V2Gateway_UpdateAppointmentPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateAppointmentPreferencesMutation, V2Gateway_UpdateAppointmentPreferencesMutationVariables>(V2Gateway_UpdateAppointmentPreferencesDocument, options);
      }
export type V2Gateway_UpdateAppointmentPreferencesMutationHookResult = ReturnType<typeof useV2Gateway_UpdateAppointmentPreferencesMutation>;
export type V2Gateway_UpdateAppointmentPreferencesMutationResult = Apollo.MutationResult<V2Gateway_UpdateAppointmentPreferencesMutation>;
export type V2Gateway_UpdateAppointmentPreferencesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateAppointmentPreferencesMutation, V2Gateway_UpdateAppointmentPreferencesMutationVariables>;
export const V2Gateway_AcceptAppointmentDocument = gql`
    mutation V2Gateway_AcceptAppointment($appointmentUid: String!) {
  acceptAppointment(appointmentUid: $appointmentUid)
}
    `;
export type V2Gateway_AcceptAppointmentMutationFn = Apollo.MutationFunction<V2Gateway_AcceptAppointmentMutation, V2Gateway_AcceptAppointmentMutationVariables>;

/**
 * __useV2Gateway_AcceptAppointmentMutation__
 *
 * To run a mutation, you first call `useV2Gateway_AcceptAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_AcceptAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayAcceptAppointmentMutation, { data, loading, error }] = useV2Gateway_AcceptAppointmentMutation({
 *   variables: {
 *      appointmentUid: // value for 'appointmentUid'
 *   },
 * });
 */
export function useV2Gateway_AcceptAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_AcceptAppointmentMutation, V2Gateway_AcceptAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_AcceptAppointmentMutation, V2Gateway_AcceptAppointmentMutationVariables>(V2Gateway_AcceptAppointmentDocument, options);
      }
export type V2Gateway_AcceptAppointmentMutationHookResult = ReturnType<typeof useV2Gateway_AcceptAppointmentMutation>;
export type V2Gateway_AcceptAppointmentMutationResult = Apollo.MutationResult<V2Gateway_AcceptAppointmentMutation>;
export type V2Gateway_AcceptAppointmentMutationOptions = Apollo.BaseMutationOptions<V2Gateway_AcceptAppointmentMutation, V2Gateway_AcceptAppointmentMutationVariables>;
export const V2Gateway_QueryServiceProviderAppointmentsDocument = gql`
    query V2Gateway_QueryServiceProviderAppointments($appointmentQuery: AppointmentQuery!, $bookingStatusQuery: BookingStatusQuery) {
  queryServiceProviderAppointments(query: $appointmentQuery) {
    location {
      id
      type
      name
      formattedAddress
    }
    serviceArea {
      name
      uid
      description
      externalUid
      files {
        uid
        uploadedFile {
          publicUrl
        }
      }
    }
    bookings(statusQuery: $bookingStatusQuery) {
      uid
      startDateTime
      endDateTime
      customerInputGroupSelections {
        level
        customerInputUids
        optionValues
        customerInputs {
          uid
          type
          title
          ownerUid
          required
          options {
            uid
            value
            price
            duration
          }
        }
        selectedOptions {
          uid
          value
          price
          duration
        }
      }
      customerInputSelections {
        customerInputUid
        optionValue
        customerInput {
          type
          title
          ownerUid
          required
          uid
          options {
            uid
            value
            duration
            price
          }
        }
        selectedOptions {
          uid
          value
          price
          duration
        }
      }
      owner {
        uid
        fullName
        emailAddress
        phoneNumber
      }
      serviceOffering {
        uid
        title
      }
      accountingRecord {
        total
        tipAmount
        subTotal
        totalTaxAmount
        revenues {
          type
          value
        }
        lineItems {
          displayName
          discountedPrice
        }
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_QueryServiceProviderAppointmentsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryServiceProviderAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryServiceProviderAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryServiceProviderAppointmentsQuery({
 *   variables: {
 *      appointmentQuery: // value for 'appointmentQuery'
 *      bookingStatusQuery: // value for 'bookingStatusQuery'
 *   },
 * });
 */
export function useV2Gateway_QueryServiceProviderAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryServiceProviderAppointmentsQuery, V2Gateway_QueryServiceProviderAppointmentsQueryVariables> & ({ variables: V2Gateway_QueryServiceProviderAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryServiceProviderAppointmentsQuery, V2Gateway_QueryServiceProviderAppointmentsQueryVariables>(V2Gateway_QueryServiceProviderAppointmentsDocument, options);
      }
export function useV2Gateway_QueryServiceProviderAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryServiceProviderAppointmentsQuery, V2Gateway_QueryServiceProviderAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryServiceProviderAppointmentsQuery, V2Gateway_QueryServiceProviderAppointmentsQueryVariables>(V2Gateway_QueryServiceProviderAppointmentsDocument, options);
        }
export function useV2Gateway_QueryServiceProviderAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryServiceProviderAppointmentsQuery, V2Gateway_QueryServiceProviderAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryServiceProviderAppointmentsQuery, V2Gateway_QueryServiceProviderAppointmentsQueryVariables>(V2Gateway_QueryServiceProviderAppointmentsDocument, options);
        }
export type V2Gateway_QueryServiceProviderAppointmentsQueryHookResult = ReturnType<typeof useV2Gateway_QueryServiceProviderAppointmentsQuery>;
export type V2Gateway_QueryServiceProviderAppointmentsLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryServiceProviderAppointmentsLazyQuery>;
export type V2Gateway_QueryServiceProviderAppointmentsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryServiceProviderAppointmentsSuspenseQuery>;
export type V2Gateway_QueryServiceProviderAppointmentsQueryResult = Apollo.QueryResult<V2Gateway_QueryServiceProviderAppointmentsQuery, V2Gateway_QueryServiceProviderAppointmentsQueryVariables>;
export const GetAppointmentWithPreferencesDocument = gql`
    query GetAppointmentWithPreferences($appointmentUid: String!, $bookingSelections: BookingSelectionsInput) {
  getAppointment(appointmentUid: $appointmentUid) {
    ...appointmentFieldsExtended
    eventEndDateTime
    discountRuleProgress(bookingSelections: $bookingSelections) {
      progressPercent
      discountRule {
        label
        priority
        discountValue
        discountType
        priority
        requireDurationBookedSeconds
        requireBookingCount
      }
    }
    preferences {
      type
      value
    }
    serviceProvider {
      ...serviceProviderFullNew
    }
  }
}
    ${AppointmentFieldsExtendedFragmentDoc}
${ServiceProviderFullNewFragmentDoc}`;

/**
 * __useGetAppointmentWithPreferencesQuery__
 *
 * To run a query within a React component, call `useGetAppointmentWithPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentWithPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentWithPreferencesQuery({
 *   variables: {
 *      appointmentUid: // value for 'appointmentUid'
 *      bookingSelections: // value for 'bookingSelections'
 *   },
 * });
 */
export function useGetAppointmentWithPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentWithPreferencesQuery, GetAppointmentWithPreferencesQueryVariables> & ({ variables: GetAppointmentWithPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentWithPreferencesQuery, GetAppointmentWithPreferencesQueryVariables>(GetAppointmentWithPreferencesDocument, options);
      }
export function useGetAppointmentWithPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentWithPreferencesQuery, GetAppointmentWithPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentWithPreferencesQuery, GetAppointmentWithPreferencesQueryVariables>(GetAppointmentWithPreferencesDocument, options);
        }
export function useGetAppointmentWithPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentWithPreferencesQuery, GetAppointmentWithPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentWithPreferencesQuery, GetAppointmentWithPreferencesQueryVariables>(GetAppointmentWithPreferencesDocument, options);
        }
export type GetAppointmentWithPreferencesQueryHookResult = ReturnType<typeof useGetAppointmentWithPreferencesQuery>;
export type GetAppointmentWithPreferencesLazyQueryHookResult = ReturnType<typeof useGetAppointmentWithPreferencesLazyQuery>;
export type GetAppointmentWithPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentWithPreferencesSuspenseQuery>;
export type GetAppointmentWithPreferencesQueryResult = Apollo.QueryResult<GetAppointmentWithPreferencesQuery, GetAppointmentWithPreferencesQueryVariables>;
export const V2Gateway_DeclineAppointmentDocument = gql`
    mutation V2Gateway_DeclineAppointment($appointmentUid: String!, $denialReason: String!) {
  declineAppointment(appointmentUid: $appointmentUid, denialReason: $denialReason)
}
    `;
export type V2Gateway_DeclineAppointmentMutationFn = Apollo.MutationFunction<V2Gateway_DeclineAppointmentMutation, V2Gateway_DeclineAppointmentMutationVariables>;

/**
 * __useV2Gateway_DeclineAppointmentMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeclineAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeclineAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeclineAppointmentMutation, { data, loading, error }] = useV2Gateway_DeclineAppointmentMutation({
 *   variables: {
 *      appointmentUid: // value for 'appointmentUid'
 *      denialReason: // value for 'denialReason'
 *   },
 * });
 */
export function useV2Gateway_DeclineAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeclineAppointmentMutation, V2Gateway_DeclineAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeclineAppointmentMutation, V2Gateway_DeclineAppointmentMutationVariables>(V2Gateway_DeclineAppointmentDocument, options);
      }
export type V2Gateway_DeclineAppointmentMutationHookResult = ReturnType<typeof useV2Gateway_DeclineAppointmentMutation>;
export type V2Gateway_DeclineAppointmentMutationResult = Apollo.MutationResult<V2Gateway_DeclineAppointmentMutation>;
export type V2Gateway_DeclineAppointmentMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeclineAppointmentMutation, V2Gateway_DeclineAppointmentMutationVariables>;
export const V2Gateway_CancelAppointmentDocument = gql`
    mutation V2Gateway_CancelAppointment($appointmentUid: String!, $cancelReason: String!) {
  cancelAppointment(appointmentUid: $appointmentUid, cancelReason: $cancelReason)
}
    `;
export type V2Gateway_CancelAppointmentMutationFn = Apollo.MutationFunction<V2Gateway_CancelAppointmentMutation, V2Gateway_CancelAppointmentMutationVariables>;

/**
 * __useV2Gateway_CancelAppointmentMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCancelAppointmentMutation, { data, loading, error }] = useV2Gateway_CancelAppointmentMutation({
 *   variables: {
 *      appointmentUid: // value for 'appointmentUid'
 *      cancelReason: // value for 'cancelReason'
 *   },
 * });
 */
export function useV2Gateway_CancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CancelAppointmentMutation, V2Gateway_CancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CancelAppointmentMutation, V2Gateway_CancelAppointmentMutationVariables>(V2Gateway_CancelAppointmentDocument, options);
      }
export type V2Gateway_CancelAppointmentMutationHookResult = ReturnType<typeof useV2Gateway_CancelAppointmentMutation>;
export type V2Gateway_CancelAppointmentMutationResult = Apollo.MutationResult<V2Gateway_CancelAppointmentMutation>;
export type V2Gateway_CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CancelAppointmentMutation, V2Gateway_CancelAppointmentMutationVariables>;
export const V2Gateway_CreateAppointmentsDocument = gql`
    mutation V2Gateway_CreateAppointments($data: [CreateAppointmentInput!]!) {
  createAppointments(data: $data) {
    uid
    nonce
  }
}
    `;
export type V2Gateway_CreateAppointmentsMutationFn = Apollo.MutationFunction<V2Gateway_CreateAppointmentsMutation, V2Gateway_CreateAppointmentsMutationVariables>;

/**
 * __useV2Gateway_CreateAppointmentsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateAppointmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateAppointmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateAppointmentsMutation, { data, loading, error }] = useV2Gateway_CreateAppointmentsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateAppointmentsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateAppointmentsMutation, V2Gateway_CreateAppointmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateAppointmentsMutation, V2Gateway_CreateAppointmentsMutationVariables>(V2Gateway_CreateAppointmentsDocument, options);
      }
export type V2Gateway_CreateAppointmentsMutationHookResult = ReturnType<typeof useV2Gateway_CreateAppointmentsMutation>;
export type V2Gateway_CreateAppointmentsMutationResult = Apollo.MutationResult<V2Gateway_CreateAppointmentsMutation>;
export type V2Gateway_CreateAppointmentsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateAppointmentsMutation, V2Gateway_CreateAppointmentsMutationVariables>;
export const V2Gateway_UpdateAppointmentsDocument = gql`
    mutation V2Gateway_UpdateAppointments($data: [UpdateAppointmentInput!]!) {
  updateAppointments(data: $data)
}
    `;
export type V2Gateway_UpdateAppointmentsMutationFn = Apollo.MutationFunction<V2Gateway_UpdateAppointmentsMutation, V2Gateway_UpdateAppointmentsMutationVariables>;

/**
 * __useV2Gateway_UpdateAppointmentsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateAppointmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateAppointmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateAppointmentsMutation, { data, loading, error }] = useV2Gateway_UpdateAppointmentsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateAppointmentsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateAppointmentsMutation, V2Gateway_UpdateAppointmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateAppointmentsMutation, V2Gateway_UpdateAppointmentsMutationVariables>(V2Gateway_UpdateAppointmentsDocument, options);
      }
export type V2Gateway_UpdateAppointmentsMutationHookResult = ReturnType<typeof useV2Gateway_UpdateAppointmentsMutation>;
export type V2Gateway_UpdateAppointmentsMutationResult = Apollo.MutationResult<V2Gateway_UpdateAppointmentsMutation>;
export type V2Gateway_UpdateAppointmentsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateAppointmentsMutation, V2Gateway_UpdateAppointmentsMutationVariables>;
export const V2Gateway_GetIsAvailableDocument = gql`
    query V2Gateway_GetIsAvailable($fromSeconds: Int!, $toSeconds: Int!, $ownerUids: [String!]!) {
  getIsAvailable(
    fromSeconds: $fromSeconds
    toSeconds: $toSeconds
    ownerUids: $ownerUids
  ) {
    ownerUid
    isAvailable
  }
}
    `;

/**
 * __useV2Gateway_GetIsAvailableQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetIsAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetIsAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetIsAvailableQuery({
 *   variables: {
 *      fromSeconds: // value for 'fromSeconds'
 *      toSeconds: // value for 'toSeconds'
 *      ownerUids: // value for 'ownerUids'
 *   },
 * });
 */
export function useV2Gateway_GetIsAvailableQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetIsAvailableQuery, V2Gateway_GetIsAvailableQueryVariables> & ({ variables: V2Gateway_GetIsAvailableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetIsAvailableQuery, V2Gateway_GetIsAvailableQueryVariables>(V2Gateway_GetIsAvailableDocument, options);
      }
export function useV2Gateway_GetIsAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetIsAvailableQuery, V2Gateway_GetIsAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetIsAvailableQuery, V2Gateway_GetIsAvailableQueryVariables>(V2Gateway_GetIsAvailableDocument, options);
        }
export function useV2Gateway_GetIsAvailableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetIsAvailableQuery, V2Gateway_GetIsAvailableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetIsAvailableQuery, V2Gateway_GetIsAvailableQueryVariables>(V2Gateway_GetIsAvailableDocument, options);
        }
export type V2Gateway_GetIsAvailableQueryHookResult = ReturnType<typeof useV2Gateway_GetIsAvailableQuery>;
export type V2Gateway_GetIsAvailableLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetIsAvailableLazyQuery>;
export type V2Gateway_GetIsAvailableSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetIsAvailableSuspenseQuery>;
export type V2Gateway_GetIsAvailableQueryResult = Apollo.QueryResult<V2Gateway_GetIsAvailableQuery, V2Gateway_GetIsAvailableQueryVariables>;
export const V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsDocument = gql`
    query V2Gateway_AppointmentForm_GetBookingsByAppointmentUids($appointmentUids: [String!]!, $page: Int!) {
  getBookingsByAppointmentUids(appointmentUids: $appointmentUids, page: $page) {
    appointmentUid
    incompleteBookings {
      startDateTime
      endDateTime
      uid
    }
  }
}
    `;

/**
 * __useV2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery({
 *   variables: {
 *      appointmentUids: // value for 'appointmentUids'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useV2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery, V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryVariables> & ({ variables: V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery, V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryVariables>(V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsDocument, options);
      }
export function useV2Gateway_AppointmentForm_GetBookingsByAppointmentUidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery, V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery, V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryVariables>(V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsDocument, options);
        }
export function useV2Gateway_AppointmentForm_GetBookingsByAppointmentUidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery, V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery, V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryVariables>(V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsDocument, options);
        }
export type V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryHookResult = ReturnType<typeof useV2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery>;
export type V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsLazyQueryHookResult = ReturnType<typeof useV2Gateway_AppointmentForm_GetBookingsByAppointmentUidsLazyQuery>;
export type V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_AppointmentForm_GetBookingsByAppointmentUidsSuspenseQuery>;
export type V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryResult = Apollo.QueryResult<V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQuery, V2Gateway_AppointmentForm_GetBookingsByAppointmentUidsQueryVariables>;
export const ArchiveServiceProviderReminderDocument = gql`
    mutation ArchiveServiceProviderReminder($id: String!) {
  archiveServiceProviderReminder(id: $id)
}
    `;
export type ArchiveServiceProviderReminderMutationFn = Apollo.MutationFunction<ArchiveServiceProviderReminderMutation, ArchiveServiceProviderReminderMutationVariables>;

/**
 * __useArchiveServiceProviderReminderMutation__
 *
 * To run a mutation, you first call `useArchiveServiceProviderReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveServiceProviderReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveServiceProviderReminderMutation, { data, loading, error }] = useArchiveServiceProviderReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveServiceProviderReminderMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveServiceProviderReminderMutation, ArchiveServiceProviderReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveServiceProviderReminderMutation, ArchiveServiceProviderReminderMutationVariables>(ArchiveServiceProviderReminderDocument, options);
      }
export type ArchiveServiceProviderReminderMutationHookResult = ReturnType<typeof useArchiveServiceProviderReminderMutation>;
export type ArchiveServiceProviderReminderMutationResult = Apollo.MutationResult<ArchiveServiceProviderReminderMutation>;
export type ArchiveServiceProviderReminderMutationOptions = Apollo.BaseMutationOptions<ArchiveServiceProviderReminderMutation, ArchiveServiceProviderReminderMutationVariables>;
export const V2Gateway_SearchBookingCartsDocument = gql`
    query V2Gateway_SearchBookingCarts($query: BookingCartQuery!) {
  searchBookingCarts(query: $query) {
    bookingCarts {
      ...bookingCartFields
    }
  }
}
    ${BookingCartFieldsFragmentDoc}`;

/**
 * __useV2Gateway_SearchBookingCartsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_SearchBookingCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SearchBookingCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_SearchBookingCartsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_SearchBookingCartsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_SearchBookingCartsQuery, V2Gateway_SearchBookingCartsQueryVariables> & ({ variables: V2Gateway_SearchBookingCartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_SearchBookingCartsQuery, V2Gateway_SearchBookingCartsQueryVariables>(V2Gateway_SearchBookingCartsDocument, options);
      }
export function useV2Gateway_SearchBookingCartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_SearchBookingCartsQuery, V2Gateway_SearchBookingCartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_SearchBookingCartsQuery, V2Gateway_SearchBookingCartsQueryVariables>(V2Gateway_SearchBookingCartsDocument, options);
        }
export function useV2Gateway_SearchBookingCartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_SearchBookingCartsQuery, V2Gateway_SearchBookingCartsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_SearchBookingCartsQuery, V2Gateway_SearchBookingCartsQueryVariables>(V2Gateway_SearchBookingCartsDocument, options);
        }
export type V2Gateway_SearchBookingCartsQueryHookResult = ReturnType<typeof useV2Gateway_SearchBookingCartsQuery>;
export type V2Gateway_SearchBookingCartsLazyQueryHookResult = ReturnType<typeof useV2Gateway_SearchBookingCartsLazyQuery>;
export type V2Gateway_SearchBookingCartsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_SearchBookingCartsSuspenseQuery>;
export type V2Gateway_SearchBookingCartsQueryResult = Apollo.QueryResult<V2Gateway_SearchBookingCartsQuery, V2Gateway_SearchBookingCartsQueryVariables>;
export const V2Gateway_CreateBookingCartDocument = gql`
    mutation V2Gateway_CreateBookingCart($data: CreateBookingCartInput!) {
  createBookingCart(data: $data)
}
    `;
export type V2Gateway_CreateBookingCartMutationFn = Apollo.MutationFunction<V2Gateway_CreateBookingCartMutation, V2Gateway_CreateBookingCartMutationVariables>;

/**
 * __useV2Gateway_CreateBookingCartMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateBookingCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateBookingCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateBookingCartMutation, { data, loading, error }] = useV2Gateway_CreateBookingCartMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateBookingCartMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateBookingCartMutation, V2Gateway_CreateBookingCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateBookingCartMutation, V2Gateway_CreateBookingCartMutationVariables>(V2Gateway_CreateBookingCartDocument, options);
      }
export type V2Gateway_CreateBookingCartMutationHookResult = ReturnType<typeof useV2Gateway_CreateBookingCartMutation>;
export type V2Gateway_CreateBookingCartMutationResult = Apollo.MutationResult<V2Gateway_CreateBookingCartMutation>;
export type V2Gateway_CreateBookingCartMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateBookingCartMutation, V2Gateway_CreateBookingCartMutationVariables>;
export const V2Gateway_UpdateBookingCartDocument = gql`
    mutation V2Gateway_UpdateBookingCart($data: UpdateBookingCartInput!) {
  updateBookingCart(data: $data)
}
    `;
export type V2Gateway_UpdateBookingCartMutationFn = Apollo.MutationFunction<V2Gateway_UpdateBookingCartMutation, V2Gateway_UpdateBookingCartMutationVariables>;

/**
 * __useV2Gateway_UpdateBookingCartMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateBookingCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateBookingCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateBookingCartMutation, { data, loading, error }] = useV2Gateway_UpdateBookingCartMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateBookingCartMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateBookingCartMutation, V2Gateway_UpdateBookingCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateBookingCartMutation, V2Gateway_UpdateBookingCartMutationVariables>(V2Gateway_UpdateBookingCartDocument, options);
      }
export type V2Gateway_UpdateBookingCartMutationHookResult = ReturnType<typeof useV2Gateway_UpdateBookingCartMutation>;
export type V2Gateway_UpdateBookingCartMutationResult = Apollo.MutationResult<V2Gateway_UpdateBookingCartMutation>;
export type V2Gateway_UpdateBookingCartMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateBookingCartMutation, V2Gateway_UpdateBookingCartMutationVariables>;
export const V2Gateway_DeleteBookingCartsDocument = gql`
    mutation V2Gateway_DeleteBookingCarts($uids: [String!]!) {
  deleteBookingCarts(uids: $uids)
}
    `;
export type V2Gateway_DeleteBookingCartsMutationFn = Apollo.MutationFunction<V2Gateway_DeleteBookingCartsMutation, V2Gateway_DeleteBookingCartsMutationVariables>;

/**
 * __useV2Gateway_DeleteBookingCartsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteBookingCartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteBookingCartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteBookingCartsMutation, { data, loading, error }] = useV2Gateway_DeleteBookingCartsMutation({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useV2Gateway_DeleteBookingCartsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteBookingCartsMutation, V2Gateway_DeleteBookingCartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteBookingCartsMutation, V2Gateway_DeleteBookingCartsMutationVariables>(V2Gateway_DeleteBookingCartsDocument, options);
      }
export type V2Gateway_DeleteBookingCartsMutationHookResult = ReturnType<typeof useV2Gateway_DeleteBookingCartsMutation>;
export type V2Gateway_DeleteBookingCartsMutationResult = Apollo.MutationResult<V2Gateway_DeleteBookingCartsMutation>;
export type V2Gateway_DeleteBookingCartsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteBookingCartsMutation, V2Gateway_DeleteBookingCartsMutationVariables>;
export const V2Gateway_GetOrInitializeBookingCartDocument = gql`
    mutation V2Gateway_GetOrInitializeBookingCart($serviceProviderUid: String, $appointmentUid: String, $serviceOfferingUid: String) {
  getOrInitializeBookingCart(
    serviceProviderUid: $serviceProviderUid
    appointmentUid: $appointmentUid
    serviceOfferingUid: $serviceOfferingUid
  ) {
    ...bookingCartFields
  }
}
    ${BookingCartFieldsFragmentDoc}`;
export type V2Gateway_GetOrInitializeBookingCartMutationFn = Apollo.MutationFunction<V2Gateway_GetOrInitializeBookingCartMutation, V2Gateway_GetOrInitializeBookingCartMutationVariables>;

/**
 * __useV2Gateway_GetOrInitializeBookingCartMutation__
 *
 * To run a mutation, you first call `useV2Gateway_GetOrInitializeBookingCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetOrInitializeBookingCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayGetOrInitializeBookingCartMutation, { data, loading, error }] = useV2Gateway_GetOrInitializeBookingCartMutation({
 *   variables: {
 *      serviceProviderUid: // value for 'serviceProviderUid'
 *      appointmentUid: // value for 'appointmentUid'
 *      serviceOfferingUid: // value for 'serviceOfferingUid'
 *   },
 * });
 */
export function useV2Gateway_GetOrInitializeBookingCartMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_GetOrInitializeBookingCartMutation, V2Gateway_GetOrInitializeBookingCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_GetOrInitializeBookingCartMutation, V2Gateway_GetOrInitializeBookingCartMutationVariables>(V2Gateway_GetOrInitializeBookingCartDocument, options);
      }
export type V2Gateway_GetOrInitializeBookingCartMutationHookResult = ReturnType<typeof useV2Gateway_GetOrInitializeBookingCartMutation>;
export type V2Gateway_GetOrInitializeBookingCartMutationResult = Apollo.MutationResult<V2Gateway_GetOrInitializeBookingCartMutation>;
export type V2Gateway_GetOrInitializeBookingCartMutationOptions = Apollo.BaseMutationOptions<V2Gateway_GetOrInitializeBookingCartMutation, V2Gateway_GetOrInitializeBookingCartMutationVariables>;
export const V2Gateway_GetBookingCartByUidDocument = gql`
    query V2Gateway_GetBookingCartByUID($uid: String!) {
  getBookingCartByUID(uid: $uid) {
    ...bookingCartFields
  }
}
    ${BookingCartFieldsFragmentDoc}`;

/**
 * __useV2Gateway_GetBookingCartByUidQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetBookingCartByUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetBookingCartByUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetBookingCartByUidQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useV2Gateway_GetBookingCartByUidQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetBookingCartByUidQuery, V2Gateway_GetBookingCartByUidQueryVariables> & ({ variables: V2Gateway_GetBookingCartByUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetBookingCartByUidQuery, V2Gateway_GetBookingCartByUidQueryVariables>(V2Gateway_GetBookingCartByUidDocument, options);
      }
export function useV2Gateway_GetBookingCartByUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetBookingCartByUidQuery, V2Gateway_GetBookingCartByUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetBookingCartByUidQuery, V2Gateway_GetBookingCartByUidQueryVariables>(V2Gateway_GetBookingCartByUidDocument, options);
        }
export function useV2Gateway_GetBookingCartByUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetBookingCartByUidQuery, V2Gateway_GetBookingCartByUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetBookingCartByUidQuery, V2Gateway_GetBookingCartByUidQueryVariables>(V2Gateway_GetBookingCartByUidDocument, options);
        }
export type V2Gateway_GetBookingCartByUidQueryHookResult = ReturnType<typeof useV2Gateway_GetBookingCartByUidQuery>;
export type V2Gateway_GetBookingCartByUidLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetBookingCartByUidLazyQuery>;
export type V2Gateway_GetBookingCartByUidSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetBookingCartByUidSuspenseQuery>;
export type V2Gateway_GetBookingCartByUidQueryResult = Apollo.QueryResult<V2Gateway_GetBookingCartByUidQuery, V2Gateway_GetBookingCartByUidQueryVariables>;
export const GetBookingNotesDocument = gql`
    query GetBookingNotes($bookingId: String!) {
  getBookingNotes(bookingId: $bookingId) {
    id
    title
    text
    createdAt
    updatedAt
    bookingId
  }
}
    `;

/**
 * __useGetBookingNotesQuery__
 *
 * To run a query within a React component, call `useGetBookingNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingNotesQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingNotesQuery(baseOptions: Apollo.QueryHookOptions<GetBookingNotesQuery, GetBookingNotesQueryVariables> & ({ variables: GetBookingNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingNotesQuery, GetBookingNotesQueryVariables>(GetBookingNotesDocument, options);
      }
export function useGetBookingNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingNotesQuery, GetBookingNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingNotesQuery, GetBookingNotesQueryVariables>(GetBookingNotesDocument, options);
        }
export function useGetBookingNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingNotesQuery, GetBookingNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingNotesQuery, GetBookingNotesQueryVariables>(GetBookingNotesDocument, options);
        }
export type GetBookingNotesQueryHookResult = ReturnType<typeof useGetBookingNotesQuery>;
export type GetBookingNotesLazyQueryHookResult = ReturnType<typeof useGetBookingNotesLazyQuery>;
export type GetBookingNotesSuspenseQueryHookResult = ReturnType<typeof useGetBookingNotesSuspenseQuery>;
export type GetBookingNotesQueryResult = Apollo.QueryResult<GetBookingNotesQuery, GetBookingNotesQueryVariables>;
export const CreateBookingNoteDocument = gql`
    mutation CreateBookingNote($input: BookingNoteInput!) {
  createBookingNote(input: $input)
}
    `;
export type CreateBookingNoteMutationFn = Apollo.MutationFunction<CreateBookingNoteMutation, CreateBookingNoteMutationVariables>;

/**
 * __useCreateBookingNoteMutation__
 *
 * To run a mutation, you first call `useCreateBookingNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingNoteMutation, { data, loading, error }] = useCreateBookingNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookingNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingNoteMutation, CreateBookingNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingNoteMutation, CreateBookingNoteMutationVariables>(CreateBookingNoteDocument, options);
      }
export type CreateBookingNoteMutationHookResult = ReturnType<typeof useCreateBookingNoteMutation>;
export type CreateBookingNoteMutationResult = Apollo.MutationResult<CreateBookingNoteMutation>;
export type CreateBookingNoteMutationOptions = Apollo.BaseMutationOptions<CreateBookingNoteMutation, CreateBookingNoteMutationVariables>;
export const UpdateBookingNoteDocument = gql`
    mutation UpdateBookingNote($id: String!, $input: BookingNoteInput!) {
  updateBookingNote(id: $id, input: $input)
}
    `;
export type UpdateBookingNoteMutationFn = Apollo.MutationFunction<UpdateBookingNoteMutation, UpdateBookingNoteMutationVariables>;

/**
 * __useUpdateBookingNoteMutation__
 *
 * To run a mutation, you first call `useUpdateBookingNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingNoteMutation, { data, loading, error }] = useUpdateBookingNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingNoteMutation, UpdateBookingNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingNoteMutation, UpdateBookingNoteMutationVariables>(UpdateBookingNoteDocument, options);
      }
export type UpdateBookingNoteMutationHookResult = ReturnType<typeof useUpdateBookingNoteMutation>;
export type UpdateBookingNoteMutationResult = Apollo.MutationResult<UpdateBookingNoteMutation>;
export type UpdateBookingNoteMutationOptions = Apollo.BaseMutationOptions<UpdateBookingNoteMutation, UpdateBookingNoteMutationVariables>;
export const DeleteBookingNoteDocument = gql`
    mutation DeleteBookingNote($id: String!) {
  deleteBookingNote(id: $id)
}
    `;
export type DeleteBookingNoteMutationFn = Apollo.MutationFunction<DeleteBookingNoteMutation, DeleteBookingNoteMutationVariables>;

/**
 * __useDeleteBookingNoteMutation__
 *
 * To run a mutation, you first call `useDeleteBookingNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingNoteMutation, { data, loading, error }] = useDeleteBookingNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBookingNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookingNoteMutation, DeleteBookingNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookingNoteMutation, DeleteBookingNoteMutationVariables>(DeleteBookingNoteDocument, options);
      }
export type DeleteBookingNoteMutationHookResult = ReturnType<typeof useDeleteBookingNoteMutation>;
export type DeleteBookingNoteMutationResult = Apollo.MutationResult<DeleteBookingNoteMutation>;
export type DeleteBookingNoteMutationOptions = Apollo.BaseMutationOptions<DeleteBookingNoteMutation, DeleteBookingNoteMutationVariables>;
export const V2Gateway_SearchServiceProviderBookingsDocument = gql`
    query V2Gateway_SearchServiceProviderBookings($bookingQuery: BookingQuery!, $appointmentStatusQuery: AppointmentStatusQuery!) {
  searchServiceProviderBookings(
    query: $bookingQuery
    appointmentStatusQuery: $appointmentStatusQuery
  ) {
    uid
    startDateTime
    endDateTime
    isComplete
    isNoShow
    isCancelled
    appointment {
      uid
      location {
        id
        type
        name
        formattedAddress
        streetAddress
      }
      serviceArea {
        name
        uid
        description
        externalUid
        files {
          uid
          uploadedFile {
            objectName
            publicUrl
          }
        }
      }
    }
    customerInputGroupSelections {
      level
      customerInputUids
      optionValues
      customerInputs {
        uid
        type
        title
        ownerUid
        required
        options {
          uid
          value
          price
          duration
        }
      }
      selectedOptions {
        uid
        value
        price
        duration
      }
    }
    customerInputSelections {
      customerInputUid
      optionValue
      customerInput {
        type
        title
        ownerUid
        required
        uid
        options {
          uid
          value
          duration
          price
        }
      }
      selectedOptions {
        uid
        value
        price
        duration
      }
    }
    owner {
      uid
      fullName
      emailAddress
      phoneNumber
    }
    serviceOffering {
      uid
      title
    }
    accountingRecord {
      total
      tipAmount
      subTotal
      totalTaxAmount
      revenues {
        type
        value
      }
      lineItems {
        displayName
        discountedPrice
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_SearchServiceProviderBookingsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_SearchServiceProviderBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SearchServiceProviderBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_SearchServiceProviderBookingsQuery({
 *   variables: {
 *      bookingQuery: // value for 'bookingQuery'
 *      appointmentStatusQuery: // value for 'appointmentStatusQuery'
 *   },
 * });
 */
export function useV2Gateway_SearchServiceProviderBookingsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_SearchServiceProviderBookingsQuery, V2Gateway_SearchServiceProviderBookingsQueryVariables> & ({ variables: V2Gateway_SearchServiceProviderBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_SearchServiceProviderBookingsQuery, V2Gateway_SearchServiceProviderBookingsQueryVariables>(V2Gateway_SearchServiceProviderBookingsDocument, options);
      }
export function useV2Gateway_SearchServiceProviderBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_SearchServiceProviderBookingsQuery, V2Gateway_SearchServiceProviderBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_SearchServiceProviderBookingsQuery, V2Gateway_SearchServiceProviderBookingsQueryVariables>(V2Gateway_SearchServiceProviderBookingsDocument, options);
        }
export function useV2Gateway_SearchServiceProviderBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_SearchServiceProviderBookingsQuery, V2Gateway_SearchServiceProviderBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_SearchServiceProviderBookingsQuery, V2Gateway_SearchServiceProviderBookingsQueryVariables>(V2Gateway_SearchServiceProviderBookingsDocument, options);
        }
export type V2Gateway_SearchServiceProviderBookingsQueryHookResult = ReturnType<typeof useV2Gateway_SearchServiceProviderBookingsQuery>;
export type V2Gateway_SearchServiceProviderBookingsLazyQueryHookResult = ReturnType<typeof useV2Gateway_SearchServiceProviderBookingsLazyQuery>;
export type V2Gateway_SearchServiceProviderBookingsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_SearchServiceProviderBookingsSuspenseQuery>;
export type V2Gateway_SearchServiceProviderBookingsQueryResult = Apollo.QueryResult<V2Gateway_SearchServiceProviderBookingsQuery, V2Gateway_SearchServiceProviderBookingsQueryVariables>;
export const V2Gateway_SearchServiceProviderBookingsCountDocument = gql`
    query V2Gateway_SearchServiceProviderBookingsCount($bookingQuery: BookingQuery!, $appointmentStatusQuery: AppointmentStatusQuery!) {
  searchServiceProviderBookingsCount(
    query: $bookingQuery
    appointmentStatusQuery: $appointmentStatusQuery
  )
}
    `;

/**
 * __useV2Gateway_SearchServiceProviderBookingsCountQuery__
 *
 * To run a query within a React component, call `useV2Gateway_SearchServiceProviderBookingsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SearchServiceProviderBookingsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_SearchServiceProviderBookingsCountQuery({
 *   variables: {
 *      bookingQuery: // value for 'bookingQuery'
 *      appointmentStatusQuery: // value for 'appointmentStatusQuery'
 *   },
 * });
 */
export function useV2Gateway_SearchServiceProviderBookingsCountQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_SearchServiceProviderBookingsCountQuery, V2Gateway_SearchServiceProviderBookingsCountQueryVariables> & ({ variables: V2Gateway_SearchServiceProviderBookingsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_SearchServiceProviderBookingsCountQuery, V2Gateway_SearchServiceProviderBookingsCountQueryVariables>(V2Gateway_SearchServiceProviderBookingsCountDocument, options);
      }
export function useV2Gateway_SearchServiceProviderBookingsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_SearchServiceProviderBookingsCountQuery, V2Gateway_SearchServiceProviderBookingsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_SearchServiceProviderBookingsCountQuery, V2Gateway_SearchServiceProviderBookingsCountQueryVariables>(V2Gateway_SearchServiceProviderBookingsCountDocument, options);
        }
export function useV2Gateway_SearchServiceProviderBookingsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_SearchServiceProviderBookingsCountQuery, V2Gateway_SearchServiceProviderBookingsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_SearchServiceProviderBookingsCountQuery, V2Gateway_SearchServiceProviderBookingsCountQueryVariables>(V2Gateway_SearchServiceProviderBookingsCountDocument, options);
        }
export type V2Gateway_SearchServiceProviderBookingsCountQueryHookResult = ReturnType<typeof useV2Gateway_SearchServiceProviderBookingsCountQuery>;
export type V2Gateway_SearchServiceProviderBookingsCountLazyQueryHookResult = ReturnType<typeof useV2Gateway_SearchServiceProviderBookingsCountLazyQuery>;
export type V2Gateway_SearchServiceProviderBookingsCountSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_SearchServiceProviderBookingsCountSuspenseQuery>;
export type V2Gateway_SearchServiceProviderBookingsCountQueryResult = Apollo.QueryResult<V2Gateway_SearchServiceProviderBookingsCountQuery, V2Gateway_SearchServiceProviderBookingsCountQueryVariables>;
export const BusinessQueryServiceProvidersDocument = gql`
    query BusinessQueryServiceProviders($query: ServiceProviderQuery!) {
  queryServiceProviders(query: $query) {
    hasMoreResults
    serviceProviders {
      isApproved
      serviceType
      displayName
      averageRating
      reviewCount
      id
      slug
      user {
        id
      }
      profile {
        ...profileFragment
        socialLinks {
          platform
          url
        }
        introVideoURL
      }
      serviceOfferings {
        uid
        basePrice
        baseTime
        title
        type
      }
      serviceOfferingCategories {
        ...serviceOfferingCategoryFields
      }
      location {
        id
        phoneNumber
      }
      dayOfWeekAvailability {
        dayOfWeek
        availability {
          timeUtcSecondsBounds {
            min
            max
          }
        }
      }
      discountRules {
        id
        isDisabled
        label
        triggerCondition {
          siblingBookingTriggerCondition {
            requireBookingCount
            ignoreServiceOfferingUids
          }
          timeDurationBookedAtLocationTriggerCondition {
            requireDurationBookedSeconds
            ignoreServiceOfferingUids
          }
        }
        discountValue
        discountType
        priority
      }
    }
  }
}
    ${ProfileFragmentFragmentDoc}
${ServiceOfferingCategoryFieldsFragmentDoc}`;

/**
 * __useBusinessQueryServiceProvidersQuery__
 *
 * To run a query within a React component, call `useBusinessQueryServiceProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessQueryServiceProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessQueryServiceProvidersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useBusinessQueryServiceProvidersQuery(baseOptions: Apollo.QueryHookOptions<BusinessQueryServiceProvidersQuery, BusinessQueryServiceProvidersQueryVariables> & ({ variables: BusinessQueryServiceProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessQueryServiceProvidersQuery, BusinessQueryServiceProvidersQueryVariables>(BusinessQueryServiceProvidersDocument, options);
      }
export function useBusinessQueryServiceProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessQueryServiceProvidersQuery, BusinessQueryServiceProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessQueryServiceProvidersQuery, BusinessQueryServiceProvidersQueryVariables>(BusinessQueryServiceProvidersDocument, options);
        }
export function useBusinessQueryServiceProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessQueryServiceProvidersQuery, BusinessQueryServiceProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessQueryServiceProvidersQuery, BusinessQueryServiceProvidersQueryVariables>(BusinessQueryServiceProvidersDocument, options);
        }
export type BusinessQueryServiceProvidersQueryHookResult = ReturnType<typeof useBusinessQueryServiceProvidersQuery>;
export type BusinessQueryServiceProvidersLazyQueryHookResult = ReturnType<typeof useBusinessQueryServiceProvidersLazyQuery>;
export type BusinessQueryServiceProvidersSuspenseQueryHookResult = ReturnType<typeof useBusinessQueryServiceProvidersSuspenseQuery>;
export type BusinessQueryServiceProvidersQueryResult = Apollo.QueryResult<BusinessQueryServiceProvidersQuery, BusinessQueryServiceProvidersQueryVariables>;
export const CancelAppointmentByIdDocument = gql`
    mutation CancelAppointmentById($appointmentId: String!, $cancelReason: String!) {
  cancelAppointmentById(
    appointmentId: $appointmentId
    cancelReason: $cancelReason
  )
}
    `;
export type CancelAppointmentByIdMutationFn = Apollo.MutationFunction<CancelAppointmentByIdMutation, CancelAppointmentByIdMutationVariables>;

/**
 * __useCancelAppointmentByIdMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentByIdMutation, { data, loading, error }] = useCancelAppointmentByIdMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      cancelReason: // value for 'cancelReason'
 *   },
 * });
 */
export function useCancelAppointmentByIdMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentByIdMutation, CancelAppointmentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentByIdMutation, CancelAppointmentByIdMutationVariables>(CancelAppointmentByIdDocument, options);
      }
export type CancelAppointmentByIdMutationHookResult = ReturnType<typeof useCancelAppointmentByIdMutation>;
export type CancelAppointmentByIdMutationResult = Apollo.MutationResult<CancelAppointmentByIdMutation>;
export type CancelAppointmentByIdMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentByIdMutation, CancelAppointmentByIdMutationVariables>;
export const CancelUserSubscriptionDocument = gql`
    mutation CancelUserSubscription($productId: ID!) {
  cancelUserSubscription(productId: $productId)
}
    `;
export type CancelUserSubscriptionMutationFn = Apollo.MutationFunction<CancelUserSubscriptionMutation, CancelUserSubscriptionMutationVariables>;

/**
 * __useCancelUserSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelUserSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUserSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUserSubscriptionMutation, { data, loading, error }] = useCancelUserSubscriptionMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useCancelUserSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelUserSubscriptionMutation, CancelUserSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelUserSubscriptionMutation, CancelUserSubscriptionMutationVariables>(CancelUserSubscriptionDocument, options);
      }
export type CancelUserSubscriptionMutationHookResult = ReturnType<typeof useCancelUserSubscriptionMutation>;
export type CancelUserSubscriptionMutationResult = Apollo.MutationResult<CancelUserSubscriptionMutation>;
export type CancelUserSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelUserSubscriptionMutation, CancelUserSubscriptionMutationVariables>;
export const V2Gateway_SearchChatMessagesDocument = gql`
    query V2Gateway_SearchChatMessages($query: ChatMessageQuery!) {
  searchChatMessages(query: $query) {
    messages {
      uid
      text
      createdAt
      roomUid
    }
  }
}
    `;

/**
 * __useV2Gateway_SearchChatMessagesQuery__
 *
 * To run a query within a React component, call `useV2Gateway_SearchChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SearchChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_SearchChatMessagesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_SearchChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_SearchChatMessagesQuery, V2Gateway_SearchChatMessagesQueryVariables> & ({ variables: V2Gateway_SearchChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_SearchChatMessagesQuery, V2Gateway_SearchChatMessagesQueryVariables>(V2Gateway_SearchChatMessagesDocument, options);
      }
export function useV2Gateway_SearchChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_SearchChatMessagesQuery, V2Gateway_SearchChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_SearchChatMessagesQuery, V2Gateway_SearchChatMessagesQueryVariables>(V2Gateway_SearchChatMessagesDocument, options);
        }
export function useV2Gateway_SearchChatMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_SearchChatMessagesQuery, V2Gateway_SearchChatMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_SearchChatMessagesQuery, V2Gateway_SearchChatMessagesQueryVariables>(V2Gateway_SearchChatMessagesDocument, options);
        }
export type V2Gateway_SearchChatMessagesQueryHookResult = ReturnType<typeof useV2Gateway_SearchChatMessagesQuery>;
export type V2Gateway_SearchChatMessagesLazyQueryHookResult = ReturnType<typeof useV2Gateway_SearchChatMessagesLazyQuery>;
export type V2Gateway_SearchChatMessagesSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_SearchChatMessagesSuspenseQuery>;
export type V2Gateway_SearchChatMessagesQueryResult = Apollo.QueryResult<V2Gateway_SearchChatMessagesQuery, V2Gateway_SearchChatMessagesQueryVariables>;
export const V2Gateway_SearchChatRoomsDocument = gql`
    query V2Gateway_SearchChatRooms($query: ChatRoomQuery!) {
  searchChatRooms(query: $query) {
    rooms {
      uid
      participants {
        uid
        fullName
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_SearchChatRoomsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_SearchChatRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SearchChatRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_SearchChatRoomsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_SearchChatRoomsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_SearchChatRoomsQuery, V2Gateway_SearchChatRoomsQueryVariables> & ({ variables: V2Gateway_SearchChatRoomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_SearchChatRoomsQuery, V2Gateway_SearchChatRoomsQueryVariables>(V2Gateway_SearchChatRoomsDocument, options);
      }
export function useV2Gateway_SearchChatRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_SearchChatRoomsQuery, V2Gateway_SearchChatRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_SearchChatRoomsQuery, V2Gateway_SearchChatRoomsQueryVariables>(V2Gateway_SearchChatRoomsDocument, options);
        }
export function useV2Gateway_SearchChatRoomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_SearchChatRoomsQuery, V2Gateway_SearchChatRoomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_SearchChatRoomsQuery, V2Gateway_SearchChatRoomsQueryVariables>(V2Gateway_SearchChatRoomsDocument, options);
        }
export type V2Gateway_SearchChatRoomsQueryHookResult = ReturnType<typeof useV2Gateway_SearchChatRoomsQuery>;
export type V2Gateway_SearchChatRoomsLazyQueryHookResult = ReturnType<typeof useV2Gateway_SearchChatRoomsLazyQuery>;
export type V2Gateway_SearchChatRoomsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_SearchChatRoomsSuspenseQuery>;
export type V2Gateway_SearchChatRoomsQueryResult = Apollo.QueryResult<V2Gateway_SearchChatRoomsQuery, V2Gateway_SearchChatRoomsQueryVariables>;
export const V2Gateway_CreateChatRoomsDocument = gql`
    mutation V2Gateway_CreateChatRooms($data: [CreateChatRoomInput!]!) {
  createChatRooms(data: $data)
}
    `;
export type V2Gateway_CreateChatRoomsMutationFn = Apollo.MutationFunction<V2Gateway_CreateChatRoomsMutation, V2Gateway_CreateChatRoomsMutationVariables>;

/**
 * __useV2Gateway_CreateChatRoomsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateChatRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateChatRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateChatRoomsMutation, { data, loading, error }] = useV2Gateway_CreateChatRoomsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateChatRoomsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateChatRoomsMutation, V2Gateway_CreateChatRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateChatRoomsMutation, V2Gateway_CreateChatRoomsMutationVariables>(V2Gateway_CreateChatRoomsDocument, options);
      }
export type V2Gateway_CreateChatRoomsMutationHookResult = ReturnType<typeof useV2Gateway_CreateChatRoomsMutation>;
export type V2Gateway_CreateChatRoomsMutationResult = Apollo.MutationResult<V2Gateway_CreateChatRoomsMutation>;
export type V2Gateway_CreateChatRoomsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateChatRoomsMutation, V2Gateway_CreateChatRoomsMutationVariables>;
export const ConfirmBookingDocument = gql`
    mutation ConfirmBooking($bookingId: String!) {
  confirmBooking(bookingId: $bookingId)
}
    `;
export type ConfirmBookingMutationFn = Apollo.MutationFunction<ConfirmBookingMutation, ConfirmBookingMutationVariables>;

/**
 * __useConfirmBookingMutation__
 *
 * To run a mutation, you first call `useConfirmBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBookingMutation, { data, loading, error }] = useConfirmBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useConfirmBookingMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmBookingMutation, ConfirmBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmBookingMutation, ConfirmBookingMutationVariables>(ConfirmBookingDocument, options);
      }
export type ConfirmBookingMutationHookResult = ReturnType<typeof useConfirmBookingMutation>;
export type ConfirmBookingMutationResult = Apollo.MutationResult<ConfirmBookingMutation>;
export type ConfirmBookingMutationOptions = Apollo.BaseMutationOptions<ConfirmBookingMutation, ConfirmBookingMutationVariables>;
export const CreateAppointmentForCustomerDocument = gql`
    mutation CreateAppointmentForCustomer($data: CreateAppointmentInput!, $customerId: String!) {
  createAppointmentForCustomer(data: $data, customerId: $customerId)
}
    `;
export type CreateAppointmentForCustomerMutationFn = Apollo.MutationFunction<CreateAppointmentForCustomerMutation, CreateAppointmentForCustomerMutationVariables>;

/**
 * __useCreateAppointmentForCustomerMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentForCustomerMutation, { data, loading, error }] = useCreateAppointmentForCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCreateAppointmentForCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentForCustomerMutation, CreateAppointmentForCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentForCustomerMutation, CreateAppointmentForCustomerMutationVariables>(CreateAppointmentForCustomerDocument, options);
      }
export type CreateAppointmentForCustomerMutationHookResult = ReturnType<typeof useCreateAppointmentForCustomerMutation>;
export type CreateAppointmentForCustomerMutationResult = Apollo.MutationResult<CreateAppointmentForCustomerMutation>;
export type CreateAppointmentForCustomerMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentForCustomerMutation, CreateAppointmentForCustomerMutationVariables>;
export const CreateAppointmentFromEventCartDocument = gql`
    mutation CreateAppointmentFromEventCart($eventCartId: String!, $eventOfferingId: String!) {
  createAppointmentFromEventCart(
    eventCartId: $eventCartId
    eventOfferingId: $eventOfferingId
  ) {
    appointmentId
  }
}
    `;
export type CreateAppointmentFromEventCartMutationFn = Apollo.MutationFunction<CreateAppointmentFromEventCartMutation, CreateAppointmentFromEventCartMutationVariables>;

/**
 * __useCreateAppointmentFromEventCartMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentFromEventCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentFromEventCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentFromEventCartMutation, { data, loading, error }] = useCreateAppointmentFromEventCartMutation({
 *   variables: {
 *      eventCartId: // value for 'eventCartId'
 *      eventOfferingId: // value for 'eventOfferingId'
 *   },
 * });
 */
export function useCreateAppointmentFromEventCartMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentFromEventCartMutation, CreateAppointmentFromEventCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentFromEventCartMutation, CreateAppointmentFromEventCartMutationVariables>(CreateAppointmentFromEventCartDocument, options);
      }
export type CreateAppointmentFromEventCartMutationHookResult = ReturnType<typeof useCreateAppointmentFromEventCartMutation>;
export type CreateAppointmentFromEventCartMutationResult = Apollo.MutationResult<CreateAppointmentFromEventCartMutation>;
export type CreateAppointmentFromEventCartMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentFromEventCartMutation, CreateAppointmentFromEventCartMutationVariables>;
export const CreateBookingForCustomerDocument = gql`
    mutation CreateBookingForCustomer($data: CreateBookingInput!, $customerId: String!, $bookingId: String) {
  createBookingForCustomer(
    data: $data
    customerId: $customerId
    bookingId: $bookingId
  )
}
    `;
export type CreateBookingForCustomerMutationFn = Apollo.MutationFunction<CreateBookingForCustomerMutation, CreateBookingForCustomerMutationVariables>;

/**
 * __useCreateBookingForCustomerMutation__
 *
 * To run a mutation, you first call `useCreateBookingForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingForCustomerMutation, { data, loading, error }] = useCreateBookingForCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *      customerId: // value for 'customerId'
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useCreateBookingForCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingForCustomerMutation, CreateBookingForCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingForCustomerMutation, CreateBookingForCustomerMutationVariables>(CreateBookingForCustomerDocument, options);
      }
export type CreateBookingForCustomerMutationHookResult = ReturnType<typeof useCreateBookingForCustomerMutation>;
export type CreateBookingForCustomerMutationResult = Apollo.MutationResult<CreateBookingForCustomerMutation>;
export type CreateBookingForCustomerMutationOptions = Apollo.BaseMutationOptions<CreateBookingForCustomerMutation, CreateBookingForCustomerMutationVariables>;
export const CreateBookingForAppointmentFromCartDocument = gql`
    mutation CreateBookingForAppointmentFromCart($appointmentId: String!, $bookingCartUid: String!) {
  createBookingForAppointmentFromCart(
    appointmentId: $appointmentId
    bookingCartUid: $bookingCartUid
  ) {
    booking {
      uid
      appointment {
        uid
        serviceProvider {
          ownerUid
        }
        location {
          id
          uid
        }
      }
    }
  }
}
    `;
export type CreateBookingForAppointmentFromCartMutationFn = Apollo.MutationFunction<CreateBookingForAppointmentFromCartMutation, CreateBookingForAppointmentFromCartMutationVariables>;

/**
 * __useCreateBookingForAppointmentFromCartMutation__
 *
 * To run a mutation, you first call `useCreateBookingForAppointmentFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingForAppointmentFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingForAppointmentFromCartMutation, { data, loading, error }] = useCreateBookingForAppointmentFromCartMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      bookingCartUid: // value for 'bookingCartUid'
 *   },
 * });
 */
export function useCreateBookingForAppointmentFromCartMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingForAppointmentFromCartMutation, CreateBookingForAppointmentFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingForAppointmentFromCartMutation, CreateBookingForAppointmentFromCartMutationVariables>(CreateBookingForAppointmentFromCartDocument, options);
      }
export type CreateBookingForAppointmentFromCartMutationHookResult = ReturnType<typeof useCreateBookingForAppointmentFromCartMutation>;
export type CreateBookingForAppointmentFromCartMutationResult = Apollo.MutationResult<CreateBookingForAppointmentFromCartMutation>;
export type CreateBookingForAppointmentFromCartMutationOptions = Apollo.BaseMutationOptions<CreateBookingForAppointmentFromCartMutation, CreateBookingForAppointmentFromCartMutationVariables>;
export const CreateCustomLineItemDocument = gql`
    mutation CreateCustomLineItem($input: CustomLineItemInput!) {
  createCustomLineItem(input: $input)
}
    `;
export type CreateCustomLineItemMutationFn = Apollo.MutationFunction<CreateCustomLineItemMutation, CreateCustomLineItemMutationVariables>;

/**
 * __useCreateCustomLineItemMutation__
 *
 * To run a mutation, you first call `useCreateCustomLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomLineItemMutation, { data, loading, error }] = useCreateCustomLineItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomLineItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomLineItemMutation, CreateCustomLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomLineItemMutation, CreateCustomLineItemMutationVariables>(CreateCustomLineItemDocument, options);
      }
export type CreateCustomLineItemMutationHookResult = ReturnType<typeof useCreateCustomLineItemMutation>;
export type CreateCustomLineItemMutationResult = Apollo.MutationResult<CreateCustomLineItemMutation>;
export type CreateCustomLineItemMutationOptions = Apollo.BaseMutationOptions<CreateCustomLineItemMutation, CreateCustomLineItemMutationVariables>;
export const CreateCustomerProfileFieldDocument = gql`
    mutation CreateCustomerProfileField($field: CustomerProfileFieldInput!) {
  createCustomerProfileField(field: $field)
}
    `;
export type CreateCustomerProfileFieldMutationFn = Apollo.MutationFunction<CreateCustomerProfileFieldMutation, CreateCustomerProfileFieldMutationVariables>;

/**
 * __useCreateCustomerProfileFieldMutation__
 *
 * To run a mutation, you first call `useCreateCustomerProfileFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerProfileFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerProfileFieldMutation, { data, loading, error }] = useCreateCustomerProfileFieldMutation({
 *   variables: {
 *      field: // value for 'field'
 *   },
 * });
 */
export function useCreateCustomerProfileFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerProfileFieldMutation, CreateCustomerProfileFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerProfileFieldMutation, CreateCustomerProfileFieldMutationVariables>(CreateCustomerProfileFieldDocument, options);
      }
export type CreateCustomerProfileFieldMutationHookResult = ReturnType<typeof useCreateCustomerProfileFieldMutation>;
export type CreateCustomerProfileFieldMutationResult = Apollo.MutationResult<CreateCustomerProfileFieldMutation>;
export type CreateCustomerProfileFieldMutationOptions = Apollo.BaseMutationOptions<CreateCustomerProfileFieldMutation, CreateCustomerProfileFieldMutationVariables>;
export const CreateCustomerProfileForServiceProviderDocument = gql`
    mutation CreateCustomerProfileForServiceProvider($serviceProviderId: String!, $fieldValues: [CustomerProfileFieldValueInput!]!) {
  createCustomerProfileForServiceProvider(
    serviceProviderId: $serviceProviderId
    fieldValues: $fieldValues
  )
}
    `;
export type CreateCustomerProfileForServiceProviderMutationFn = Apollo.MutationFunction<CreateCustomerProfileForServiceProviderMutation, CreateCustomerProfileForServiceProviderMutationVariables>;

/**
 * __useCreateCustomerProfileForServiceProviderMutation__
 *
 * To run a mutation, you first call `useCreateCustomerProfileForServiceProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerProfileForServiceProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerProfileForServiceProviderMutation, { data, loading, error }] = useCreateCustomerProfileForServiceProviderMutation({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *      fieldValues: // value for 'fieldValues'
 *   },
 * });
 */
export function useCreateCustomerProfileForServiceProviderMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerProfileForServiceProviderMutation, CreateCustomerProfileForServiceProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerProfileForServiceProviderMutation, CreateCustomerProfileForServiceProviderMutationVariables>(CreateCustomerProfileForServiceProviderDocument, options);
      }
export type CreateCustomerProfileForServiceProviderMutationHookResult = ReturnType<typeof useCreateCustomerProfileForServiceProviderMutation>;
export type CreateCustomerProfileForServiceProviderMutationResult = Apollo.MutationResult<CreateCustomerProfileForServiceProviderMutation>;
export type CreateCustomerProfileForServiceProviderMutationOptions = Apollo.BaseMutationOptions<CreateCustomerProfileForServiceProviderMutation, CreateCustomerProfileForServiceProviderMutationVariables>;
export const CreateCustomerProfileDocument = gql`
    mutation CreateCustomerProfile($profile: CustomerProfileInput!) {
  createCustomerProfile(profile: $profile)
}
    `;
export type CreateCustomerProfileMutationFn = Apollo.MutationFunction<CreateCustomerProfileMutation, CreateCustomerProfileMutationVariables>;

/**
 * __useCreateCustomerProfileMutation__
 *
 * To run a mutation, you first call `useCreateCustomerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerProfileMutation, { data, loading, error }] = useCreateCustomerProfileMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useCreateCustomerProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerProfileMutation, CreateCustomerProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerProfileMutation, CreateCustomerProfileMutationVariables>(CreateCustomerProfileDocument, options);
      }
export type CreateCustomerProfileMutationHookResult = ReturnType<typeof useCreateCustomerProfileMutation>;
export type CreateCustomerProfileMutationResult = Apollo.MutationResult<CreateCustomerProfileMutation>;
export type CreateCustomerProfileMutationOptions = Apollo.BaseMutationOptions<CreateCustomerProfileMutation, CreateCustomerProfileMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($data: CreateCustomerInput!) {
  createCustomer(data: $data)
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreateSiblingBookingDiscountRuleDocument = gql`
    mutation CreateSiblingBookingDiscountRule($data: CreateSiblingBookingDiscountRuleInput!) {
  createSiblingBookingDiscountRule(data: $data)
}
    `;
export type CreateSiblingBookingDiscountRuleMutationFn = Apollo.MutationFunction<CreateSiblingBookingDiscountRuleMutation, CreateSiblingBookingDiscountRuleMutationVariables>;

/**
 * __useCreateSiblingBookingDiscountRuleMutation__
 *
 * To run a mutation, you first call `useCreateSiblingBookingDiscountRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiblingBookingDiscountRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiblingBookingDiscountRuleMutation, { data, loading, error }] = useCreateSiblingBookingDiscountRuleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSiblingBookingDiscountRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSiblingBookingDiscountRuleMutation, CreateSiblingBookingDiscountRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSiblingBookingDiscountRuleMutation, CreateSiblingBookingDiscountRuleMutationVariables>(CreateSiblingBookingDiscountRuleDocument, options);
      }
export type CreateSiblingBookingDiscountRuleMutationHookResult = ReturnType<typeof useCreateSiblingBookingDiscountRuleMutation>;
export type CreateSiblingBookingDiscountRuleMutationResult = Apollo.MutationResult<CreateSiblingBookingDiscountRuleMutation>;
export type CreateSiblingBookingDiscountRuleMutationOptions = Apollo.BaseMutationOptions<CreateSiblingBookingDiscountRuleMutation, CreateSiblingBookingDiscountRuleMutationVariables>;
export const CreateTimeDurationBookedAtLocationDiscountRuleDocument = gql`
    mutation CreateTimeDurationBookedAtLocationDiscountRule($data: CreateTimeDurationBookedAtLocationDiscountRuleInput!) {
  createTimeDurationBookedAtLocationDiscountRule(data: $data)
}
    `;
export type CreateTimeDurationBookedAtLocationDiscountRuleMutationFn = Apollo.MutationFunction<CreateTimeDurationBookedAtLocationDiscountRuleMutation, CreateTimeDurationBookedAtLocationDiscountRuleMutationVariables>;

/**
 * __useCreateTimeDurationBookedAtLocationDiscountRuleMutation__
 *
 * To run a mutation, you first call `useCreateTimeDurationBookedAtLocationDiscountRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeDurationBookedAtLocationDiscountRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeDurationBookedAtLocationDiscountRuleMutation, { data, loading, error }] = useCreateTimeDurationBookedAtLocationDiscountRuleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTimeDurationBookedAtLocationDiscountRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeDurationBookedAtLocationDiscountRuleMutation, CreateTimeDurationBookedAtLocationDiscountRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeDurationBookedAtLocationDiscountRuleMutation, CreateTimeDurationBookedAtLocationDiscountRuleMutationVariables>(CreateTimeDurationBookedAtLocationDiscountRuleDocument, options);
      }
export type CreateTimeDurationBookedAtLocationDiscountRuleMutationHookResult = ReturnType<typeof useCreateTimeDurationBookedAtLocationDiscountRuleMutation>;
export type CreateTimeDurationBookedAtLocationDiscountRuleMutationResult = Apollo.MutationResult<CreateTimeDurationBookedAtLocationDiscountRuleMutation>;
export type CreateTimeDurationBookedAtLocationDiscountRuleMutationOptions = Apollo.BaseMutationOptions<CreateTimeDurationBookedAtLocationDiscountRuleMutation, CreateTimeDurationBookedAtLocationDiscountRuleMutationVariables>;
export const V2Gateway_CreateDropoffsDocument = gql`
    mutation V2Gateway_CreateDropoffs($data: [CreateDropoffInput!]!) {
  createDropoffs(data: $data)
}
    `;
export type V2Gateway_CreateDropoffsMutationFn = Apollo.MutationFunction<V2Gateway_CreateDropoffsMutation, V2Gateway_CreateDropoffsMutationVariables>;

/**
 * __useV2Gateway_CreateDropoffsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateDropoffsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateDropoffsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateDropoffsMutation, { data, loading, error }] = useV2Gateway_CreateDropoffsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateDropoffsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateDropoffsMutation, V2Gateway_CreateDropoffsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateDropoffsMutation, V2Gateway_CreateDropoffsMutationVariables>(V2Gateway_CreateDropoffsDocument, options);
      }
export type V2Gateway_CreateDropoffsMutationHookResult = ReturnType<typeof useV2Gateway_CreateDropoffsMutation>;
export type V2Gateway_CreateDropoffsMutationResult = Apollo.MutationResult<V2Gateway_CreateDropoffsMutation>;
export type V2Gateway_CreateDropoffsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateDropoffsMutation, V2Gateway_CreateDropoffsMutationVariables>;
export const CreateEventOfferingDocument = gql`
    mutation CreateEventOffering($data: CreateEventOffering!) {
  createEventOffering(data: $data)
}
    `;
export type CreateEventOfferingMutationFn = Apollo.MutationFunction<CreateEventOfferingMutation, CreateEventOfferingMutationVariables>;

/**
 * __useCreateEventOfferingMutation__
 *
 * To run a mutation, you first call `useCreateEventOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventOfferingMutation, { data, loading, error }] = useCreateEventOfferingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEventOfferingMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventOfferingMutation, CreateEventOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventOfferingMutation, CreateEventOfferingMutationVariables>(CreateEventOfferingDocument, options);
      }
export type CreateEventOfferingMutationHookResult = ReturnType<typeof useCreateEventOfferingMutation>;
export type CreateEventOfferingMutationResult = Apollo.MutationResult<CreateEventOfferingMutation>;
export type CreateEventOfferingMutationOptions = Apollo.BaseMutationOptions<CreateEventOfferingMutation, CreateEventOfferingMutationVariables>;
export const CreateLocationForCustomerDocument = gql`
    mutation CreateLocationForCustomer($data: CreateLocationInput!, $customerId: String!) {
  createLocationForCustomer(customerId: $customerId, data: $data)
}
    `;
export type CreateLocationForCustomerMutationFn = Apollo.MutationFunction<CreateLocationForCustomerMutation, CreateLocationForCustomerMutationVariables>;

/**
 * __useCreateLocationForCustomerMutation__
 *
 * To run a mutation, you first call `useCreateLocationForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationForCustomerMutation, { data, loading, error }] = useCreateLocationForCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCreateLocationForCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationForCustomerMutation, CreateLocationForCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationForCustomerMutation, CreateLocationForCustomerMutationVariables>(CreateLocationForCustomerDocument, options);
      }
export type CreateLocationForCustomerMutationHookResult = ReturnType<typeof useCreateLocationForCustomerMutation>;
export type CreateLocationForCustomerMutationResult = Apollo.MutationResult<CreateLocationForCustomerMutation>;
export type CreateLocationForCustomerMutationOptions = Apollo.BaseMutationOptions<CreateLocationForCustomerMutation, CreateLocationForCustomerMutationVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($data: CreateLocationInput!) {
  createLocation(data: $data) {
    location {
      uid
      id
      latitude
      longitude
    }
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const CreatePeazyPluginInstallationDocument = gql`
    mutation CreatePeazyPluginInstallation($data: PeazyPluginInstallationInput!) {
  createPeazyPluginInstallation(input: $data)
}
    `;
export type CreatePeazyPluginInstallationMutationFn = Apollo.MutationFunction<CreatePeazyPluginInstallationMutation, CreatePeazyPluginInstallationMutationVariables>;

/**
 * __useCreatePeazyPluginInstallationMutation__
 *
 * To run a mutation, you first call `useCreatePeazyPluginInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePeazyPluginInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPeazyPluginInstallationMutation, { data, loading, error }] = useCreatePeazyPluginInstallationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePeazyPluginInstallationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePeazyPluginInstallationMutation, CreatePeazyPluginInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePeazyPluginInstallationMutation, CreatePeazyPluginInstallationMutationVariables>(CreatePeazyPluginInstallationDocument, options);
      }
export type CreatePeazyPluginInstallationMutationHookResult = ReturnType<typeof useCreatePeazyPluginInstallationMutation>;
export type CreatePeazyPluginInstallationMutationResult = Apollo.MutationResult<CreatePeazyPluginInstallationMutation>;
export type CreatePeazyPluginInstallationMutationOptions = Apollo.BaseMutationOptions<CreatePeazyPluginInstallationMutation, CreatePeazyPluginInstallationMutationVariables>;
export const CreateReceiptConfigDocument = gql`
    mutation CreateReceiptConfig($input: ReceiptConfigInput!) {
  createReceiptConfig(input: $input)
}
    `;
export type CreateReceiptConfigMutationFn = Apollo.MutationFunction<CreateReceiptConfigMutation, CreateReceiptConfigMutationVariables>;

/**
 * __useCreateReceiptConfigMutation__
 *
 * To run a mutation, you first call `useCreateReceiptConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReceiptConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReceiptConfigMutation, { data, loading, error }] = useCreateReceiptConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReceiptConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateReceiptConfigMutation, CreateReceiptConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReceiptConfigMutation, CreateReceiptConfigMutationVariables>(CreateReceiptConfigDocument, options);
      }
export type CreateReceiptConfigMutationHookResult = ReturnType<typeof useCreateReceiptConfigMutation>;
export type CreateReceiptConfigMutationResult = Apollo.MutationResult<CreateReceiptConfigMutation>;
export type CreateReceiptConfigMutationOptions = Apollo.BaseMutationOptions<CreateReceiptConfigMutation, CreateReceiptConfigMutationVariables>;
export const CreateServiceProviderBreakCalendarEventDocument = gql`
    mutation CreateServiceProviderBreakCalendarEvent($data: CalendarEventInput!) {
  createServiceProviderBreakCalendarEvent(data: $data)
}
    `;
export type CreateServiceProviderBreakCalendarEventMutationFn = Apollo.MutationFunction<CreateServiceProviderBreakCalendarEventMutation, CreateServiceProviderBreakCalendarEventMutationVariables>;

/**
 * __useCreateServiceProviderBreakCalendarEventMutation__
 *
 * To run a mutation, you first call `useCreateServiceProviderBreakCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceProviderBreakCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceProviderBreakCalendarEventMutation, { data, loading, error }] = useCreateServiceProviderBreakCalendarEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateServiceProviderBreakCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceProviderBreakCalendarEventMutation, CreateServiceProviderBreakCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceProviderBreakCalendarEventMutation, CreateServiceProviderBreakCalendarEventMutationVariables>(CreateServiceProviderBreakCalendarEventDocument, options);
      }
export type CreateServiceProviderBreakCalendarEventMutationHookResult = ReturnType<typeof useCreateServiceProviderBreakCalendarEventMutation>;
export type CreateServiceProviderBreakCalendarEventMutationResult = Apollo.MutationResult<CreateServiceProviderBreakCalendarEventMutation>;
export type CreateServiceProviderBreakCalendarEventMutationOptions = Apollo.BaseMutationOptions<CreateServiceProviderBreakCalendarEventMutation, CreateServiceProviderBreakCalendarEventMutationVariables>;
export const CreateServiceProviderReminderDocument = gql`
    mutation CreateServiceProviderReminder($input: ServiceProviderReminderInput!) {
  createServiceProviderReminder(input: $input)
}
    `;
export type CreateServiceProviderReminderMutationFn = Apollo.MutationFunction<CreateServiceProviderReminderMutation, CreateServiceProviderReminderMutationVariables>;

/**
 * __useCreateServiceProviderReminderMutation__
 *
 * To run a mutation, you first call `useCreateServiceProviderReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceProviderReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceProviderReminderMutation, { data, loading, error }] = useCreateServiceProviderReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceProviderReminderMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceProviderReminderMutation, CreateServiceProviderReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceProviderReminderMutation, CreateServiceProviderReminderMutationVariables>(CreateServiceProviderReminderDocument, options);
      }
export type CreateServiceProviderReminderMutationHookResult = ReturnType<typeof useCreateServiceProviderReminderMutation>;
export type CreateServiceProviderReminderMutationResult = Apollo.MutationResult<CreateServiceProviderReminderMutation>;
export type CreateServiceProviderReminderMutationOptions = Apollo.BaseMutationOptions<CreateServiceProviderReminderMutation, CreateServiceProviderReminderMutationVariables>;
export const CreateSquareCardForCustomerDocument = gql`
    mutation CreateSquareCardForCustomer($customerId: ID!, $sourceId: String!) {
  createSquareCardForCustomer(customerId: $customerId, sourceId: $sourceId) {
    id
    cardBrand
    last4
    expMonth
    expYear
    cardholderName
  }
}
    `;
export type CreateSquareCardForCustomerMutationFn = Apollo.MutationFunction<CreateSquareCardForCustomerMutation, CreateSquareCardForCustomerMutationVariables>;

/**
 * __useCreateSquareCardForCustomerMutation__
 *
 * To run a mutation, you first call `useCreateSquareCardForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSquareCardForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSquareCardForCustomerMutation, { data, loading, error }] = useCreateSquareCardForCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      sourceId: // value for 'sourceId'
 *   },
 * });
 */
export function useCreateSquareCardForCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateSquareCardForCustomerMutation, CreateSquareCardForCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSquareCardForCustomerMutation, CreateSquareCardForCustomerMutationVariables>(CreateSquareCardForCustomerDocument, options);
      }
export type CreateSquareCardForCustomerMutationHookResult = ReturnType<typeof useCreateSquareCardForCustomerMutation>;
export type CreateSquareCardForCustomerMutationResult = Apollo.MutationResult<CreateSquareCardForCustomerMutation>;
export type CreateSquareCardForCustomerMutationOptions = Apollo.BaseMutationOptions<CreateSquareCardForCustomerMutation, CreateSquareCardForCustomerMutationVariables>;
export const V2Gateway_GetLocationSubscriptionsByExternalUidDocument = gql`
    query V2Gateway_GetLocationSubscriptionsByExternalUid($externalUids: [String!]!) {
  getLocationSubscriptionsByExternalUid(externalUids: $externalUids) {
    locationUid
    ownerUid
  }
}
    `;

/**
 * __useV2Gateway_GetLocationSubscriptionsByExternalUidQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetLocationSubscriptionsByExternalUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetLocationSubscriptionsByExternalUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetLocationSubscriptionsByExternalUidQuery({
 *   variables: {
 *      externalUids: // value for 'externalUids'
 *   },
 * });
 */
export function useV2Gateway_GetLocationSubscriptionsByExternalUidQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetLocationSubscriptionsByExternalUidQuery, V2Gateway_GetLocationSubscriptionsByExternalUidQueryVariables> & ({ variables: V2Gateway_GetLocationSubscriptionsByExternalUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetLocationSubscriptionsByExternalUidQuery, V2Gateway_GetLocationSubscriptionsByExternalUidQueryVariables>(V2Gateway_GetLocationSubscriptionsByExternalUidDocument, options);
      }
export function useV2Gateway_GetLocationSubscriptionsByExternalUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetLocationSubscriptionsByExternalUidQuery, V2Gateway_GetLocationSubscriptionsByExternalUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetLocationSubscriptionsByExternalUidQuery, V2Gateway_GetLocationSubscriptionsByExternalUidQueryVariables>(V2Gateway_GetLocationSubscriptionsByExternalUidDocument, options);
        }
export function useV2Gateway_GetLocationSubscriptionsByExternalUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetLocationSubscriptionsByExternalUidQuery, V2Gateway_GetLocationSubscriptionsByExternalUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetLocationSubscriptionsByExternalUidQuery, V2Gateway_GetLocationSubscriptionsByExternalUidQueryVariables>(V2Gateway_GetLocationSubscriptionsByExternalUidDocument, options);
        }
export type V2Gateway_GetLocationSubscriptionsByExternalUidQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationSubscriptionsByExternalUidQuery>;
export type V2Gateway_GetLocationSubscriptionsByExternalUidLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationSubscriptionsByExternalUidLazyQuery>;
export type V2Gateway_GetLocationSubscriptionsByExternalUidSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationSubscriptionsByExternalUidSuspenseQuery>;
export type V2Gateway_GetLocationSubscriptionsByExternalUidQueryResult = Apollo.QueryResult<V2Gateway_GetLocationSubscriptionsByExternalUidQuery, V2Gateway_GetLocationSubscriptionsByExternalUidQueryVariables>;
export const DeleteCustomLineItemDocument = gql`
    mutation DeleteCustomLineItem($id: ID!) {
  deleteCustomLineItem(id: $id)
}
    `;
export type DeleteCustomLineItemMutationFn = Apollo.MutationFunction<DeleteCustomLineItemMutation, DeleteCustomLineItemMutationVariables>;

/**
 * __useDeleteCustomLineItemMutation__
 *
 * To run a mutation, you first call `useDeleteCustomLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomLineItemMutation, { data, loading, error }] = useDeleteCustomLineItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomLineItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomLineItemMutation, DeleteCustomLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomLineItemMutation, DeleteCustomLineItemMutationVariables>(DeleteCustomLineItemDocument, options);
      }
export type DeleteCustomLineItemMutationHookResult = ReturnType<typeof useDeleteCustomLineItemMutation>;
export type DeleteCustomLineItemMutationResult = Apollo.MutationResult<DeleteCustomLineItemMutation>;
export type DeleteCustomLineItemMutationOptions = Apollo.BaseMutationOptions<DeleteCustomLineItemMutation, DeleteCustomLineItemMutationVariables>;
export const DeleteCustomerProfileFieldDocument = gql`
    mutation DeleteCustomerProfileField($id: String!) {
  deleteCustomerProfileField(customerProfileFieldId: $id)
}
    `;
export type DeleteCustomerProfileFieldMutationFn = Apollo.MutationFunction<DeleteCustomerProfileFieldMutation, DeleteCustomerProfileFieldMutationVariables>;

/**
 * __useDeleteCustomerProfileFieldMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerProfileFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerProfileFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerProfileFieldMutation, { data, loading, error }] = useDeleteCustomerProfileFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerProfileFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerProfileFieldMutation, DeleteCustomerProfileFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerProfileFieldMutation, DeleteCustomerProfileFieldMutationVariables>(DeleteCustomerProfileFieldDocument, options);
      }
export type DeleteCustomerProfileFieldMutationHookResult = ReturnType<typeof useDeleteCustomerProfileFieldMutation>;
export type DeleteCustomerProfileFieldMutationResult = Apollo.MutationResult<DeleteCustomerProfileFieldMutation>;
export type DeleteCustomerProfileFieldMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerProfileFieldMutation, DeleteCustomerProfileFieldMutationVariables>;
export const DeleteCustomerProfileDocument = gql`
    mutation DeleteCustomerProfile($ids: [String!]!) {
  deleteCustomerProfiles(ids: $ids)
}
    `;
export type DeleteCustomerProfileMutationFn = Apollo.MutationFunction<DeleteCustomerProfileMutation, DeleteCustomerProfileMutationVariables>;

/**
 * __useDeleteCustomerProfileMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerProfileMutation, { data, loading, error }] = useDeleteCustomerProfileMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCustomerProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerProfileMutation, DeleteCustomerProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerProfileMutation, DeleteCustomerProfileMutationVariables>(DeleteCustomerProfileDocument, options);
      }
export type DeleteCustomerProfileMutationHookResult = ReturnType<typeof useDeleteCustomerProfileMutation>;
export type DeleteCustomerProfileMutationResult = Apollo.MutationResult<DeleteCustomerProfileMutation>;
export type DeleteCustomerProfileMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerProfileMutation, DeleteCustomerProfileMutationVariables>;
export const DeleteEmailTemplateDocument = gql`
    mutation DeleteEmailTemplate($id: String!) {
  deleteEmailTemplate(templateId: $id)
}
    `;
export type DeleteEmailTemplateMutationFn = Apollo.MutationFunction<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;

/**
 * __useDeleteEmailTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailTemplateMutation, { data, loading, error }] = useDeleteEmailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>(DeleteEmailTemplateDocument, options);
      }
export type DeleteEmailTemplateMutationHookResult = ReturnType<typeof useDeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationResult = Apollo.MutationResult<DeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;
export const DetachPaymentMethodForCustomerDocument = gql`
    mutation DetachPaymentMethodForCustomer($customerId: String!, $methodId: String!) {
  detachPaymentMethodForCustomer(customerId: $customerId, methodId: $methodId)
}
    `;
export type DetachPaymentMethodForCustomerMutationFn = Apollo.MutationFunction<DetachPaymentMethodForCustomerMutation, DetachPaymentMethodForCustomerMutationVariables>;

/**
 * __useDetachPaymentMethodForCustomerMutation__
 *
 * To run a mutation, you first call `useDetachPaymentMethodForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachPaymentMethodForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachPaymentMethodForCustomerMutation, { data, loading, error }] = useDetachPaymentMethodForCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      methodId: // value for 'methodId'
 *   },
 * });
 */
export function useDetachPaymentMethodForCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DetachPaymentMethodForCustomerMutation, DetachPaymentMethodForCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachPaymentMethodForCustomerMutation, DetachPaymentMethodForCustomerMutationVariables>(DetachPaymentMethodForCustomerDocument, options);
      }
export type DetachPaymentMethodForCustomerMutationHookResult = ReturnType<typeof useDetachPaymentMethodForCustomerMutation>;
export type DetachPaymentMethodForCustomerMutationResult = Apollo.MutationResult<DetachPaymentMethodForCustomerMutation>;
export type DetachPaymentMethodForCustomerMutationOptions = Apollo.BaseMutationOptions<DetachPaymentMethodForCustomerMutation, DetachPaymentMethodForCustomerMutationVariables>;
export const DisableSquareCardForCustomerDocument = gql`
    mutation DisableSquareCardForCustomer($customerId: ID!, $cardId: ID!) {
  disableSquareCardForCustomer(customerId: $customerId, cardId: $cardId)
}
    `;
export type DisableSquareCardForCustomerMutationFn = Apollo.MutationFunction<DisableSquareCardForCustomerMutation, DisableSquareCardForCustomerMutationVariables>;

/**
 * __useDisableSquareCardForCustomerMutation__
 *
 * To run a mutation, you first call `useDisableSquareCardForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSquareCardForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSquareCardForCustomerMutation, { data, loading, error }] = useDisableSquareCardForCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useDisableSquareCardForCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DisableSquareCardForCustomerMutation, DisableSquareCardForCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableSquareCardForCustomerMutation, DisableSquareCardForCustomerMutationVariables>(DisableSquareCardForCustomerDocument, options);
      }
export type DisableSquareCardForCustomerMutationHookResult = ReturnType<typeof useDisableSquareCardForCustomerMutation>;
export type DisableSquareCardForCustomerMutationResult = Apollo.MutationResult<DisableSquareCardForCustomerMutation>;
export type DisableSquareCardForCustomerMutationOptions = Apollo.BaseMutationOptions<DisableSquareCardForCustomerMutation, DisableSquareCardForCustomerMutationVariables>;
export const V2Gateway_GetDropoffsForServiceProviderDocument = gql`
    query V2Gateway_GetDropoffsForServiceProvider($query: DropoffQuery!) {
  getDropoffsForServiceProvider(query: $query) {
    dropoffs {
      ...dropoffFields
    }
  }
}
    ${DropoffFieldsFragmentDoc}`;

/**
 * __useV2Gateway_GetDropoffsForServiceProviderQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetDropoffsForServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetDropoffsForServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetDropoffsForServiceProviderQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_GetDropoffsForServiceProviderQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetDropoffsForServiceProviderQuery, V2Gateway_GetDropoffsForServiceProviderQueryVariables> & ({ variables: V2Gateway_GetDropoffsForServiceProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetDropoffsForServiceProviderQuery, V2Gateway_GetDropoffsForServiceProviderQueryVariables>(V2Gateway_GetDropoffsForServiceProviderDocument, options);
      }
export function useV2Gateway_GetDropoffsForServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetDropoffsForServiceProviderQuery, V2Gateway_GetDropoffsForServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetDropoffsForServiceProviderQuery, V2Gateway_GetDropoffsForServiceProviderQueryVariables>(V2Gateway_GetDropoffsForServiceProviderDocument, options);
        }
export function useV2Gateway_GetDropoffsForServiceProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetDropoffsForServiceProviderQuery, V2Gateway_GetDropoffsForServiceProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetDropoffsForServiceProviderQuery, V2Gateway_GetDropoffsForServiceProviderQueryVariables>(V2Gateway_GetDropoffsForServiceProviderDocument, options);
        }
export type V2Gateway_GetDropoffsForServiceProviderQueryHookResult = ReturnType<typeof useV2Gateway_GetDropoffsForServiceProviderQuery>;
export type V2Gateway_GetDropoffsForServiceProviderLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetDropoffsForServiceProviderLazyQuery>;
export type V2Gateway_GetDropoffsForServiceProviderSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetDropoffsForServiceProviderSuspenseQuery>;
export type V2Gateway_GetDropoffsForServiceProviderQueryResult = Apollo.QueryResult<V2Gateway_GetDropoffsForServiceProviderQuery, V2Gateway_GetDropoffsForServiceProviderQueryVariables>;
export const V2Gateway_GetDropoffsForCustomerDocument = gql`
    query V2Gateway_GetDropoffsForCustomer($query: DropoffQuery!) {
  getDropoffsForCustomer(query: $query) {
    dropoffs {
      ...dropoffFields
      booking {
        isInProgress
        ...deepBookingFields
        appointment {
          uid
          id
          isConfirmed
          serviceArea {
            uid
            name
            description
            externalUid
            files {
              uid
              externalUid
              label
              uploadedFile {
                objectName
                publicUrl
              }
            }
          }
          startDateTime
          maxEndDateTime
          bookingsWithSiblings {
            uid
            owner {
              fullName
            }
          }
          discountRuleProgress {
            progressPercent
            discountRule {
              label
              discountValue
              discountType
              priority
              requireDurationBookedSeconds
              requireBookingCount
            }
          }
          location {
            id
            uid
            streetAddress
            name
            type
            phoneNumber
            owner {
              fullName
              emailAddress
              phoneNumber
            }
          }
          serviceProvider {
            serviceType
            ownerUid
            displayName
            slug
            profile {
              ...profileFragment
            }
            serviceOfferings {
              uid
              title
            }
            reviewCount
            averageRating
            reviews {
              uid
              isLike
            }
          }
        }
      }
    }
  }
}
    ${DropoffFieldsFragmentDoc}
${DeepBookingFieldsFragmentDoc}
${ProfileFragmentFragmentDoc}`;

/**
 * __useV2Gateway_GetDropoffsForCustomerQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetDropoffsForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetDropoffsForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetDropoffsForCustomerQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_GetDropoffsForCustomerQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetDropoffsForCustomerQuery, V2Gateway_GetDropoffsForCustomerQueryVariables> & ({ variables: V2Gateway_GetDropoffsForCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetDropoffsForCustomerQuery, V2Gateway_GetDropoffsForCustomerQueryVariables>(V2Gateway_GetDropoffsForCustomerDocument, options);
      }
export function useV2Gateway_GetDropoffsForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetDropoffsForCustomerQuery, V2Gateway_GetDropoffsForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetDropoffsForCustomerQuery, V2Gateway_GetDropoffsForCustomerQueryVariables>(V2Gateway_GetDropoffsForCustomerDocument, options);
        }
export function useV2Gateway_GetDropoffsForCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetDropoffsForCustomerQuery, V2Gateway_GetDropoffsForCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetDropoffsForCustomerQuery, V2Gateway_GetDropoffsForCustomerQueryVariables>(V2Gateway_GetDropoffsForCustomerDocument, options);
        }
export type V2Gateway_GetDropoffsForCustomerQueryHookResult = ReturnType<typeof useV2Gateway_GetDropoffsForCustomerQuery>;
export type V2Gateway_GetDropoffsForCustomerLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetDropoffsForCustomerLazyQuery>;
export type V2Gateway_GetDropoffsForCustomerSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetDropoffsForCustomerSuspenseQuery>;
export type V2Gateway_GetDropoffsForCustomerQueryResult = Apollo.QueryResult<V2Gateway_GetDropoffsForCustomerQuery, V2Gateway_GetDropoffsForCustomerQueryVariables>;
export const V2Gateway_EditAppointmentStartDateTimeDocument = gql`
    mutation V2Gateway_EditAppointmentStartDateTime($appointmentUid: String!, $startDateTime: Int!, $maxEndDateTime: Int!) {
  updateAppointmentStartDateTime(
    appointmentUid: $appointmentUid
    startDateTime: $startDateTime
    maxEndDateTime: $maxEndDateTime
  )
}
    `;
export type V2Gateway_EditAppointmentStartDateTimeMutationFn = Apollo.MutationFunction<V2Gateway_EditAppointmentStartDateTimeMutation, V2Gateway_EditAppointmentStartDateTimeMutationVariables>;

/**
 * __useV2Gateway_EditAppointmentStartDateTimeMutation__
 *
 * To run a mutation, you first call `useV2Gateway_EditAppointmentStartDateTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_EditAppointmentStartDateTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayEditAppointmentStartDateTimeMutation, { data, loading, error }] = useV2Gateway_EditAppointmentStartDateTimeMutation({
 *   variables: {
 *      appointmentUid: // value for 'appointmentUid'
 *      startDateTime: // value for 'startDateTime'
 *      maxEndDateTime: // value for 'maxEndDateTime'
 *   },
 * });
 */
export function useV2Gateway_EditAppointmentStartDateTimeMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_EditAppointmentStartDateTimeMutation, V2Gateway_EditAppointmentStartDateTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_EditAppointmentStartDateTimeMutation, V2Gateway_EditAppointmentStartDateTimeMutationVariables>(V2Gateway_EditAppointmentStartDateTimeDocument, options);
      }
export type V2Gateway_EditAppointmentStartDateTimeMutationHookResult = ReturnType<typeof useV2Gateway_EditAppointmentStartDateTimeMutation>;
export type V2Gateway_EditAppointmentStartDateTimeMutationResult = Apollo.MutationResult<V2Gateway_EditAppointmentStartDateTimeMutation>;
export type V2Gateway_EditAppointmentStartDateTimeMutationOptions = Apollo.BaseMutationOptions<V2Gateway_EditAppointmentStartDateTimeMutation, V2Gateway_EditAppointmentStartDateTimeMutationVariables>;
export const V2Gateway_EditBookingDocument = gql`
    mutation V2Gateway_EditBooking($bookingUid: String!, $startDateTime: Int!, $serviceOfferingUid: String!, $customerInputSelections: [CustomerInputSelectionInput!]!) {
  updateBookingStartDateTime(
    bookingUid: $bookingUid
    startDateTime: $startDateTime
  )
  updateBookingCustomerInputSelections(
    bookingUid: $bookingUid
    customerInputSelections: $customerInputSelections
  )
  updateBookingServiceOffering(
    bookingUid: $bookingUid
    serviceOfferingUid: $serviceOfferingUid
  )
}
    `;
export type V2Gateway_EditBookingMutationFn = Apollo.MutationFunction<V2Gateway_EditBookingMutation, V2Gateway_EditBookingMutationVariables>;

/**
 * __useV2Gateway_EditBookingMutation__
 *
 * To run a mutation, you first call `useV2Gateway_EditBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_EditBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayEditBookingMutation, { data, loading, error }] = useV2Gateway_EditBookingMutation({
 *   variables: {
 *      bookingUid: // value for 'bookingUid'
 *      startDateTime: // value for 'startDateTime'
 *      serviceOfferingUid: // value for 'serviceOfferingUid'
 *      customerInputSelections: // value for 'customerInputSelections'
 *   },
 * });
 */
export function useV2Gateway_EditBookingMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_EditBookingMutation, V2Gateway_EditBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_EditBookingMutation, V2Gateway_EditBookingMutationVariables>(V2Gateway_EditBookingDocument, options);
      }
export type V2Gateway_EditBookingMutationHookResult = ReturnType<typeof useV2Gateway_EditBookingMutation>;
export type V2Gateway_EditBookingMutationResult = Apollo.MutationResult<V2Gateway_EditBookingMutation>;
export type V2Gateway_EditBookingMutationOptions = Apollo.BaseMutationOptions<V2Gateway_EditBookingMutation, V2Gateway_EditBookingMutationVariables>;
export const ExchangeSquareOAuthCodeDocument = gql`
    mutation ExchangeSquareOAuthCode($code: String!) {
  exchangeSquareOAuthCode(code: $code)
}
    `;
export type ExchangeSquareOAuthCodeMutationFn = Apollo.MutationFunction<ExchangeSquareOAuthCodeMutation, ExchangeSquareOAuthCodeMutationVariables>;

/**
 * __useExchangeSquareOAuthCodeMutation__
 *
 * To run a mutation, you first call `useExchangeSquareOAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeSquareOAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeSquareOAuthCodeMutation, { data, loading, error }] = useExchangeSquareOAuthCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useExchangeSquareOAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeSquareOAuthCodeMutation, ExchangeSquareOAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeSquareOAuthCodeMutation, ExchangeSquareOAuthCodeMutationVariables>(ExchangeSquareOAuthCodeDocument, options);
      }
export type ExchangeSquareOAuthCodeMutationHookResult = ReturnType<typeof useExchangeSquareOAuthCodeMutation>;
export type ExchangeSquareOAuthCodeMutationResult = Apollo.MutationResult<ExchangeSquareOAuthCodeMutation>;
export type ExchangeSquareOAuthCodeMutationOptions = Apollo.BaseMutationOptions<ExchangeSquareOAuthCodeMutation, ExchangeSquareOAuthCodeMutationVariables>;
export const GetAllBusinessWithLocationSlugsDocument = gql`
    query GetAllBusinessWithLocationSlugs($page: Int!, $pageSize: Int!) {
  getAllBusinesses(page: $page, pageSize: $pageSize) {
    slug
    locations {
      id
      slug
    }
  }
}
    `;

/**
 * __useGetAllBusinessWithLocationSlugsQuery__
 *
 * To run a query within a React component, call `useGetAllBusinessWithLocationSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBusinessWithLocationSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBusinessWithLocationSlugsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetAllBusinessWithLocationSlugsQuery(baseOptions: Apollo.QueryHookOptions<GetAllBusinessWithLocationSlugsQuery, GetAllBusinessWithLocationSlugsQueryVariables> & ({ variables: GetAllBusinessWithLocationSlugsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBusinessWithLocationSlugsQuery, GetAllBusinessWithLocationSlugsQueryVariables>(GetAllBusinessWithLocationSlugsDocument, options);
      }
export function useGetAllBusinessWithLocationSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBusinessWithLocationSlugsQuery, GetAllBusinessWithLocationSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBusinessWithLocationSlugsQuery, GetAllBusinessWithLocationSlugsQueryVariables>(GetAllBusinessWithLocationSlugsDocument, options);
        }
export function useGetAllBusinessWithLocationSlugsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllBusinessWithLocationSlugsQuery, GetAllBusinessWithLocationSlugsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllBusinessWithLocationSlugsQuery, GetAllBusinessWithLocationSlugsQueryVariables>(GetAllBusinessWithLocationSlugsDocument, options);
        }
export type GetAllBusinessWithLocationSlugsQueryHookResult = ReturnType<typeof useGetAllBusinessWithLocationSlugsQuery>;
export type GetAllBusinessWithLocationSlugsLazyQueryHookResult = ReturnType<typeof useGetAllBusinessWithLocationSlugsLazyQuery>;
export type GetAllBusinessWithLocationSlugsSuspenseQueryHookResult = ReturnType<typeof useGetAllBusinessWithLocationSlugsSuspenseQuery>;
export type GetAllBusinessWithLocationSlugsQueryResult = Apollo.QueryResult<GetAllBusinessWithLocationSlugsQuery, GetAllBusinessWithLocationSlugsQueryVariables>;
export const GetAppointmentByIdForAppointmentDetailsPageDocument = gql`
    query GetAppointmentByIdForAppointmentDetailsPage($appointmentId: String!) {
  getAppointmentById(appointmentId: $appointmentId) {
    uid
    locationUid
    userUid
    isCoveredByBusiness
    startDateTime
    serviceAreaUid
    serviceProvider {
      displayName
      serviceType
      slug
      user {
        emailAddress
      }
      location {
        id
        phoneNumber
      }
      profile {
        avatarImage {
          uploadedFile {
            publicUrl
          }
        }
      }
      insuranceInformation {
        titlePrefix
        titleSuffix
      }
    }
    location {
      id
      serviceAreas {
        name
        description
        uid
        files {
          label
          uploadedFile {
            publicUrl
          }
        }
      }
    }
    serviceArea {
      uid
      name
      description
      files {
        label
        uploadedFile {
          publicUrl
        }
      }
    }
    bookingsWithSiblings {
      startDateTime
      endDateTime
      owner {
        fullName
        emailAddress
        phoneNumber
      }
      serviceOffering {
        title
      }
      customerInputSelections {
        customerInput {
          title
        }
        selectedOptions {
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetAppointmentByIdForAppointmentDetailsPageQuery__
 *
 * To run a query within a React component, call `useGetAppointmentByIdForAppointmentDetailsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentByIdForAppointmentDetailsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentByIdForAppointmentDetailsPageQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentByIdForAppointmentDetailsPageQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentByIdForAppointmentDetailsPageQuery, GetAppointmentByIdForAppointmentDetailsPageQueryVariables> & ({ variables: GetAppointmentByIdForAppointmentDetailsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentByIdForAppointmentDetailsPageQuery, GetAppointmentByIdForAppointmentDetailsPageQueryVariables>(GetAppointmentByIdForAppointmentDetailsPageDocument, options);
      }
export function useGetAppointmentByIdForAppointmentDetailsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentByIdForAppointmentDetailsPageQuery, GetAppointmentByIdForAppointmentDetailsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentByIdForAppointmentDetailsPageQuery, GetAppointmentByIdForAppointmentDetailsPageQueryVariables>(GetAppointmentByIdForAppointmentDetailsPageDocument, options);
        }
export function useGetAppointmentByIdForAppointmentDetailsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentByIdForAppointmentDetailsPageQuery, GetAppointmentByIdForAppointmentDetailsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentByIdForAppointmentDetailsPageQuery, GetAppointmentByIdForAppointmentDetailsPageQueryVariables>(GetAppointmentByIdForAppointmentDetailsPageDocument, options);
        }
export type GetAppointmentByIdForAppointmentDetailsPageQueryHookResult = ReturnType<typeof useGetAppointmentByIdForAppointmentDetailsPageQuery>;
export type GetAppointmentByIdForAppointmentDetailsPageLazyQueryHookResult = ReturnType<typeof useGetAppointmentByIdForAppointmentDetailsPageLazyQuery>;
export type GetAppointmentByIdForAppointmentDetailsPageSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentByIdForAppointmentDetailsPageSuspenseQuery>;
export type GetAppointmentByIdForAppointmentDetailsPageQueryResult = Apollo.QueryResult<GetAppointmentByIdForAppointmentDetailsPageQuery, GetAppointmentByIdForAppointmentDetailsPageQueryVariables>;
export const GetAppointmentByIdWithLocationDocument = gql`
    query GetAppointmentByIdWithLocation($appointmentId: String!) {
  getAppointmentById(appointmentId: $appointmentId) {
    uid
    userUid
    startDateTime
    location {
      id
      type
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetAppointmentByIdWithLocationQuery__
 *
 * To run a query within a React component, call `useGetAppointmentByIdWithLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentByIdWithLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentByIdWithLocationQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentByIdWithLocationQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentByIdWithLocationQuery, GetAppointmentByIdWithLocationQueryVariables> & ({ variables: GetAppointmentByIdWithLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentByIdWithLocationQuery, GetAppointmentByIdWithLocationQueryVariables>(GetAppointmentByIdWithLocationDocument, options);
      }
export function useGetAppointmentByIdWithLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentByIdWithLocationQuery, GetAppointmentByIdWithLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentByIdWithLocationQuery, GetAppointmentByIdWithLocationQueryVariables>(GetAppointmentByIdWithLocationDocument, options);
        }
export function useGetAppointmentByIdWithLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentByIdWithLocationQuery, GetAppointmentByIdWithLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentByIdWithLocationQuery, GetAppointmentByIdWithLocationQueryVariables>(GetAppointmentByIdWithLocationDocument, options);
        }
export type GetAppointmentByIdWithLocationQueryHookResult = ReturnType<typeof useGetAppointmentByIdWithLocationQuery>;
export type GetAppointmentByIdWithLocationLazyQueryHookResult = ReturnType<typeof useGetAppointmentByIdWithLocationLazyQuery>;
export type GetAppointmentByIdWithLocationSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentByIdWithLocationSuspenseQuery>;
export type GetAppointmentByIdWithLocationQueryResult = Apollo.QueryResult<GetAppointmentByIdWithLocationQuery, GetAppointmentByIdWithLocationQueryVariables>;
export const GetAppointmentByIdWithPreferencesDocument = gql`
    query GetAppointmentByIdWithPreferences($appointmentId: String!, $bookingSelections: BookingSelectionsInput) {
  getAppointmentById(appointmentId: $appointmentId) {
    ...appointmentFieldsExtended
    eventEndDateTime
    eventOffering {
      id
      title
      description
      baseDuration
      type
      serviceOfferingUids
      attendanceServiceOfferingUid
      maxBookings
    }
    discountRuleProgress(bookingSelections: $bookingSelections) {
      progressPercent
      discountRule {
        label
        priority
        discountValue
        discountType
        priority
        requireDurationBookedSeconds
        requireBookingCount
      }
    }
    preferences {
      type
      value
    }
    serviceProvider {
      id
      ...serviceProviderFullNew
      serviceOfferings {
        uid
        basePrice
        baseTime
        title
        shortDesc
        allowTip
        maxConcurrentBookings
        type
        customerInputs {
          title
          uid
          required
          type
          index
          unitPrice
          options {
            uid
            value
            price
            duration
          }
        }
      }
    }
  }
}
    ${AppointmentFieldsExtendedFragmentDoc}
${ServiceProviderFullNewFragmentDoc}`;

/**
 * __useGetAppointmentByIdWithPreferencesQuery__
 *
 * To run a query within a React component, call `useGetAppointmentByIdWithPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentByIdWithPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentByIdWithPreferencesQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      bookingSelections: // value for 'bookingSelections'
 *   },
 * });
 */
export function useGetAppointmentByIdWithPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentByIdWithPreferencesQuery, GetAppointmentByIdWithPreferencesQueryVariables> & ({ variables: GetAppointmentByIdWithPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentByIdWithPreferencesQuery, GetAppointmentByIdWithPreferencesQueryVariables>(GetAppointmentByIdWithPreferencesDocument, options);
      }
export function useGetAppointmentByIdWithPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentByIdWithPreferencesQuery, GetAppointmentByIdWithPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentByIdWithPreferencesQuery, GetAppointmentByIdWithPreferencesQueryVariables>(GetAppointmentByIdWithPreferencesDocument, options);
        }
export function useGetAppointmentByIdWithPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentByIdWithPreferencesQuery, GetAppointmentByIdWithPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentByIdWithPreferencesQuery, GetAppointmentByIdWithPreferencesQueryVariables>(GetAppointmentByIdWithPreferencesDocument, options);
        }
export type GetAppointmentByIdWithPreferencesQueryHookResult = ReturnType<typeof useGetAppointmentByIdWithPreferencesQuery>;
export type GetAppointmentByIdWithPreferencesLazyQueryHookResult = ReturnType<typeof useGetAppointmentByIdWithPreferencesLazyQuery>;
export type GetAppointmentByIdWithPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentByIdWithPreferencesSuspenseQuery>;
export type GetAppointmentByIdWithPreferencesQueryResult = Apollo.QueryResult<GetAppointmentByIdWithPreferencesQuery, GetAppointmentByIdWithPreferencesQueryVariables>;
export const GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesDocument = gql`
    query GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferences($appointmentId: String!, $bookingSelections: BookingSelectionsInput) {
  getAppointmentById(appointmentId: $appointmentId) {
    ...appointmentFieldsExtended
    eventOffering {
      id
      title
      description
      baseDuration
      type
      serviceOfferingUids
      maxBookings
    }
    eventEndDateTime
    discountRuleProgress(bookingSelections: $bookingSelections) {
      progressPercent
      discountRule {
        label
        priority
        discountValue
        discountType
        priority
        requireDurationBookedSeconds
        requireBookingCount
      }
    }
    preferences {
      type
      value
    }
    serviceProvider {
      serviceType
      id
      displayName
      averageRating
      reviewCount
      reviews {
        uid
        createdAt
        isLike
        rating
        text
        owner {
          fullName
        }
        isExternal
        externalAuthor
      }
      user {
        id
        uid
        emailAddress
      }
      profile {
        ...profileFragment
        socialLinks {
          platform
          url
        }
        introVideoURL
      }
      serviceOfferings {
        uid
        basePrice
        baseTime
        title
        type
        customerInputs {
          uid
        }
      }
      serviceOfferingCategories {
        ...serviceOfferingCategoryFields
      }
      dayOfWeekAvailability {
        dayOfWeek
        availability {
          timeUtcSecondsBounds {
            min
            max
          }
        }
      }
      discountRules {
        id
        isDisabled
        label
        triggerCondition {
          siblingBookingTriggerCondition {
            requireBookingCount
            ignoreServiceOfferingUids
          }
          timeDurationBookedAtLocationTriggerCondition {
            requireDurationBookedSeconds
            ignoreServiceOfferingUids
          }
        }
        discountValue
        discountType
        priority
      }
      preferences {
        id
        type
        value
      }
      location {
        id
        formattedAddress
        phoneNumber
        discoverableBounds {
          min {
            lat
            lng
          }
          max {
            lat
            lng
          }
        }
      }
    }
  }
}
    ${AppointmentFieldsExtendedFragmentDoc}
${ProfileFragmentFragmentDoc}
${ServiceOfferingCategoryFieldsFragmentDoc}`;

/**
 * __useGetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery__
 *
 * To run a query within a React component, call `useGetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      bookingSelections: // value for 'bookingSelections'
 *   },
 * });
 */
export function useGetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery, GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryVariables> & ({ variables: GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery, GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryVariables>(GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesDocument, options);
      }
export function useGetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery, GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery, GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryVariables>(GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesDocument, options);
        }
export function useGetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery, GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery, GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryVariables>(GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesDocument, options);
        }
export type GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryHookResult = ReturnType<typeof useGetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery>;
export type GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesLazyQueryHookResult = ReturnType<typeof useGetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesLazyQuery>;
export type GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesSuspenseQuery>;
export type GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryResult = Apollo.QueryResult<GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQuery, GetAppointmentByIdWithServiceProviderDiscountRulesAndPreferencesQueryVariables>;
export const GetAppointmentByIdDocument = gql`
    query GetAppointmentById($appointmentId: String!) {
  getAppointmentById(appointmentId: $appointmentId) {
    id
    uid
    locationUid
    userUid
    startDateTime
    isCoveredByBusiness
    isConfirmed
    serviceAreaUid
  }
}
    `;

/**
 * __useGetAppointmentByIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentByIdQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables> & ({ variables: GetAppointmentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>(GetAppointmentByIdDocument, options);
      }
export function useGetAppointmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>(GetAppointmentByIdDocument, options);
        }
export function useGetAppointmentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>(GetAppointmentByIdDocument, options);
        }
export type GetAppointmentByIdQueryHookResult = ReturnType<typeof useGetAppointmentByIdQuery>;
export type GetAppointmentByIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentByIdLazyQuery>;
export type GetAppointmentByIdSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentByIdSuspenseQuery>;
export type GetAppointmentByIdQueryResult = Apollo.QueryResult<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>;
export const GetAppointmentForBusinessEventConfirmationPageDocument = gql`
    query GetAppointmentForBusinessEventConfirmationPage($appointmentId: String!) {
  getAppointmentById(appointmentId: $appointmentId) {
    uid
    startDateTime
    serviceProvider {
      serviceType
      discountRules {
        id
      }
    }
    location {
      id
      formattedAddress
      extendedAddress
    }
  }
}
    `;

/**
 * __useGetAppointmentForBusinessEventConfirmationPageQuery__
 *
 * To run a query within a React component, call `useGetAppointmentForBusinessEventConfirmationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentForBusinessEventConfirmationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentForBusinessEventConfirmationPageQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentForBusinessEventConfirmationPageQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentForBusinessEventConfirmationPageQuery, GetAppointmentForBusinessEventConfirmationPageQueryVariables> & ({ variables: GetAppointmentForBusinessEventConfirmationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentForBusinessEventConfirmationPageQuery, GetAppointmentForBusinessEventConfirmationPageQueryVariables>(GetAppointmentForBusinessEventConfirmationPageDocument, options);
      }
export function useGetAppointmentForBusinessEventConfirmationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentForBusinessEventConfirmationPageQuery, GetAppointmentForBusinessEventConfirmationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentForBusinessEventConfirmationPageQuery, GetAppointmentForBusinessEventConfirmationPageQueryVariables>(GetAppointmentForBusinessEventConfirmationPageDocument, options);
        }
export function useGetAppointmentForBusinessEventConfirmationPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentForBusinessEventConfirmationPageQuery, GetAppointmentForBusinessEventConfirmationPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentForBusinessEventConfirmationPageQuery, GetAppointmentForBusinessEventConfirmationPageQueryVariables>(GetAppointmentForBusinessEventConfirmationPageDocument, options);
        }
export type GetAppointmentForBusinessEventConfirmationPageQueryHookResult = ReturnType<typeof useGetAppointmentForBusinessEventConfirmationPageQuery>;
export type GetAppointmentForBusinessEventConfirmationPageLazyQueryHookResult = ReturnType<typeof useGetAppointmentForBusinessEventConfirmationPageLazyQuery>;
export type GetAppointmentForBusinessEventConfirmationPageSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentForBusinessEventConfirmationPageSuspenseQuery>;
export type GetAppointmentForBusinessEventConfirmationPageQueryResult = Apollo.QueryResult<GetAppointmentForBusinessEventConfirmationPageQuery, GetAppointmentForBusinessEventConfirmationPageQueryVariables>;
export const GetAppointmentsForServiceProviderScheduleBoundryDocument = gql`
    query GetAppointmentsForServiceProviderScheduleBoundry($userUid: String, $query: AppointmentQuery) {
  getAppointmentsForUser(userUid: $userUid, query: $query) {
    ...appointmentFieldsExtended
    eventEndDateTime
    eventOffering {
      type
      title
      baseDuration
    }
    bookings(statusQuery: {cancelledStatus: NOT_CANCELLED}) {
      ...appointmentBookingFields
      id
      customerProfileId
      dropoff {
        id
        dropoffDateTime
        status
      }
    }
  }
}
    ${AppointmentFieldsExtendedFragmentDoc}
${AppointmentBookingFieldsFragmentDoc}`;

/**
 * __useGetAppointmentsForServiceProviderScheduleBoundryQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsForServiceProviderScheduleBoundryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsForServiceProviderScheduleBoundryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsForServiceProviderScheduleBoundryQuery({
 *   variables: {
 *      userUid: // value for 'userUid'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAppointmentsForServiceProviderScheduleBoundryQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsForServiceProviderScheduleBoundryQuery, GetAppointmentsForServiceProviderScheduleBoundryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsForServiceProviderScheduleBoundryQuery, GetAppointmentsForServiceProviderScheduleBoundryQueryVariables>(GetAppointmentsForServiceProviderScheduleBoundryDocument, options);
      }
export function useGetAppointmentsForServiceProviderScheduleBoundryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsForServiceProviderScheduleBoundryQuery, GetAppointmentsForServiceProviderScheduleBoundryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsForServiceProviderScheduleBoundryQuery, GetAppointmentsForServiceProviderScheduleBoundryQueryVariables>(GetAppointmentsForServiceProviderScheduleBoundryDocument, options);
        }
export function useGetAppointmentsForServiceProviderScheduleBoundrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentsForServiceProviderScheduleBoundryQuery, GetAppointmentsForServiceProviderScheduleBoundryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsForServiceProviderScheduleBoundryQuery, GetAppointmentsForServiceProviderScheduleBoundryQueryVariables>(GetAppointmentsForServiceProviderScheduleBoundryDocument, options);
        }
export type GetAppointmentsForServiceProviderScheduleBoundryQueryHookResult = ReturnType<typeof useGetAppointmentsForServiceProviderScheduleBoundryQuery>;
export type GetAppointmentsForServiceProviderScheduleBoundryLazyQueryHookResult = ReturnType<typeof useGetAppointmentsForServiceProviderScheduleBoundryLazyQuery>;
export type GetAppointmentsForServiceProviderScheduleBoundrySuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsForServiceProviderScheduleBoundrySuspenseQuery>;
export type GetAppointmentsForServiceProviderScheduleBoundryQueryResult = Apollo.QueryResult<GetAppointmentsForServiceProviderScheduleBoundryQuery, GetAppointmentsForServiceProviderScheduleBoundryQueryVariables>;
export const GetAppointmentsForUserDocument = gql`
    query GetAppointmentsForUser($userUid: String, $query: AppointmentQuery) {
  getAppointmentsForUser(userUid: $userUid, query: $query) {
    ...appointmentFieldsExtended
    eventEndDateTime
    eventOffering {
      type
      title
      baseDuration
    }
    bookings(statusQuery: {cancelledStatus: NOT_CANCELLED}) {
      ...appointmentBookingFields
      id
      customerProfileId
      dropoff {
        id
        dropoffDateTime
        status
      }
      customer {
        id
        profiles {
          id
          customerID
          fieldValues {
            customerProfileFieldID
            value
          }
          notes {
            id
            text
            title
            createdAt
          }
          label
        }
        user {
          id
          fullName
          emailAddress
          phoneNumber
        }
      }
    }
  }
}
    ${AppointmentFieldsExtendedFragmentDoc}
${AppointmentBookingFieldsFragmentDoc}`;

/**
 * __useGetAppointmentsForUserQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsForUserQuery({
 *   variables: {
 *      userUid: // value for 'userUid'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAppointmentsForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsForUserQuery, GetAppointmentsForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsForUserQuery, GetAppointmentsForUserQueryVariables>(GetAppointmentsForUserDocument, options);
      }
export function useGetAppointmentsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsForUserQuery, GetAppointmentsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsForUserQuery, GetAppointmentsForUserQueryVariables>(GetAppointmentsForUserDocument, options);
        }
export function useGetAppointmentsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentsForUserQuery, GetAppointmentsForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsForUserQuery, GetAppointmentsForUserQueryVariables>(GetAppointmentsForUserDocument, options);
        }
export type GetAppointmentsForUserQueryHookResult = ReturnType<typeof useGetAppointmentsForUserQuery>;
export type GetAppointmentsForUserLazyQueryHookResult = ReturnType<typeof useGetAppointmentsForUserLazyQuery>;
export type GetAppointmentsForUserSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsForUserSuspenseQuery>;
export type GetAppointmentsForUserQueryResult = Apollo.QueryResult<GetAppointmentsForUserQuery, GetAppointmentsForUserQueryVariables>;
export const GetBookingByIdWithUserDocument = gql`
    query GetBookingByIdWithUser($id: String!) {
  getBookingById(id: $id) {
    owner {
      emailAddress
    }
  }
}
    `;

/**
 * __useGetBookingByIdWithUserQuery__
 *
 * To run a query within a React component, call `useGetBookingByIdWithUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingByIdWithUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingByIdWithUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingByIdWithUserQuery(baseOptions: Apollo.QueryHookOptions<GetBookingByIdWithUserQuery, GetBookingByIdWithUserQueryVariables> & ({ variables: GetBookingByIdWithUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingByIdWithUserQuery, GetBookingByIdWithUserQueryVariables>(GetBookingByIdWithUserDocument, options);
      }
export function useGetBookingByIdWithUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingByIdWithUserQuery, GetBookingByIdWithUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingByIdWithUserQuery, GetBookingByIdWithUserQueryVariables>(GetBookingByIdWithUserDocument, options);
        }
export function useGetBookingByIdWithUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingByIdWithUserQuery, GetBookingByIdWithUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingByIdWithUserQuery, GetBookingByIdWithUserQueryVariables>(GetBookingByIdWithUserDocument, options);
        }
export type GetBookingByIdWithUserQueryHookResult = ReturnType<typeof useGetBookingByIdWithUserQuery>;
export type GetBookingByIdWithUserLazyQueryHookResult = ReturnType<typeof useGetBookingByIdWithUserLazyQuery>;
export type GetBookingByIdWithUserSuspenseQueryHookResult = ReturnType<typeof useGetBookingByIdWithUserSuspenseQuery>;
export type GetBookingByIdWithUserQueryResult = Apollo.QueryResult<GetBookingByIdWithUserQuery, GetBookingByIdWithUserQueryVariables>;
export const GetBookingForAppointmentDocument = gql`
    query GetBookingForAppointment($appointmentUid: String!) {
  getBookingForAppointment(appointmentUid: $appointmentUid) {
    uid
  }
}
    `;

/**
 * __useGetBookingForAppointmentQuery__
 *
 * To run a query within a React component, call `useGetBookingForAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingForAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingForAppointmentQuery({
 *   variables: {
 *      appointmentUid: // value for 'appointmentUid'
 *   },
 * });
 */
export function useGetBookingForAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetBookingForAppointmentQuery, GetBookingForAppointmentQueryVariables> & ({ variables: GetBookingForAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingForAppointmentQuery, GetBookingForAppointmentQueryVariables>(GetBookingForAppointmentDocument, options);
      }
export function useGetBookingForAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingForAppointmentQuery, GetBookingForAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingForAppointmentQuery, GetBookingForAppointmentQueryVariables>(GetBookingForAppointmentDocument, options);
        }
export function useGetBookingForAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingForAppointmentQuery, GetBookingForAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingForAppointmentQuery, GetBookingForAppointmentQueryVariables>(GetBookingForAppointmentDocument, options);
        }
export type GetBookingForAppointmentQueryHookResult = ReturnType<typeof useGetBookingForAppointmentQuery>;
export type GetBookingForAppointmentLazyQueryHookResult = ReturnType<typeof useGetBookingForAppointmentLazyQuery>;
export type GetBookingForAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetBookingForAppointmentSuspenseQuery>;
export type GetBookingForAppointmentQueryResult = Apollo.QueryResult<GetBookingForAppointmentQuery, GetBookingForAppointmentQueryVariables>;
export const GetBookingForConfirmPageDocument = gql`
    query GetBookingForConfirmPage($bookingId: String!) {
  getBookingById(id: $bookingId) {
    owner {
      emailAddress
    }
  }
}
    `;

/**
 * __useGetBookingForConfirmPageQuery__
 *
 * To run a query within a React component, call `useGetBookingForConfirmPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingForConfirmPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingForConfirmPageQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingForConfirmPageQuery(baseOptions: Apollo.QueryHookOptions<GetBookingForConfirmPageQuery, GetBookingForConfirmPageQueryVariables> & ({ variables: GetBookingForConfirmPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingForConfirmPageQuery, GetBookingForConfirmPageQueryVariables>(GetBookingForConfirmPageDocument, options);
      }
export function useGetBookingForConfirmPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingForConfirmPageQuery, GetBookingForConfirmPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingForConfirmPageQuery, GetBookingForConfirmPageQueryVariables>(GetBookingForConfirmPageDocument, options);
        }
export function useGetBookingForConfirmPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingForConfirmPageQuery, GetBookingForConfirmPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingForConfirmPageQuery, GetBookingForConfirmPageQueryVariables>(GetBookingForConfirmPageDocument, options);
        }
export type GetBookingForConfirmPageQueryHookResult = ReturnType<typeof useGetBookingForConfirmPageQuery>;
export type GetBookingForConfirmPageLazyQueryHookResult = ReturnType<typeof useGetBookingForConfirmPageLazyQuery>;
export type GetBookingForConfirmPageSuspenseQueryHookResult = ReturnType<typeof useGetBookingForConfirmPageSuspenseQuery>;
export type GetBookingForConfirmPageQueryResult = Apollo.QueryResult<GetBookingForConfirmPageQuery, GetBookingForConfirmPageQueryVariables>;
export const GetBookingForCustomerBookingDetailsDocument = gql`
    query GetBookingForCustomerBookingDetails($bookingUid: String!) {
  getBooking(bookingUid: $bookingUid) {
    uid
    startDateTime
    serviceOfferingUid
    ownerUid
    appointmentUid
    tipPercent
    customerInputSelections {
      customerInputUid
      optionValue
    }
    serviceOffering {
      uid
      title
      basePrice
      baseTime
      customerInputs {
        unitPrice
        title
        type
        uid
        options {
          uid
          value
          price
          duration
        }
      }
    }
    appointment {
      userUid
      isCoveredByBusiness
      location {
        id
        streetAddress
        formattedAddress
      }
      serviceProvider {
        displayName
        serviceType
        slug
        profile {
          avatarImage {
            uploadedFile {
              publicUrl
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookingForCustomerBookingDetailsQuery__
 *
 * To run a query within a React component, call `useGetBookingForCustomerBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingForCustomerBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingForCustomerBookingDetailsQuery({
 *   variables: {
 *      bookingUid: // value for 'bookingUid'
 *   },
 * });
 */
export function useGetBookingForCustomerBookingDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingForCustomerBookingDetailsQuery, GetBookingForCustomerBookingDetailsQueryVariables> & ({ variables: GetBookingForCustomerBookingDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingForCustomerBookingDetailsQuery, GetBookingForCustomerBookingDetailsQueryVariables>(GetBookingForCustomerBookingDetailsDocument, options);
      }
export function useGetBookingForCustomerBookingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingForCustomerBookingDetailsQuery, GetBookingForCustomerBookingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingForCustomerBookingDetailsQuery, GetBookingForCustomerBookingDetailsQueryVariables>(GetBookingForCustomerBookingDetailsDocument, options);
        }
export function useGetBookingForCustomerBookingDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingForCustomerBookingDetailsQuery, GetBookingForCustomerBookingDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingForCustomerBookingDetailsQuery, GetBookingForCustomerBookingDetailsQueryVariables>(GetBookingForCustomerBookingDetailsDocument, options);
        }
export type GetBookingForCustomerBookingDetailsQueryHookResult = ReturnType<typeof useGetBookingForCustomerBookingDetailsQuery>;
export type GetBookingForCustomerBookingDetailsLazyQueryHookResult = ReturnType<typeof useGetBookingForCustomerBookingDetailsLazyQuery>;
export type GetBookingForCustomerBookingDetailsSuspenseQueryHookResult = ReturnType<typeof useGetBookingForCustomerBookingDetailsSuspenseQuery>;
export type GetBookingForCustomerBookingDetailsQueryResult = Apollo.QueryResult<GetBookingForCustomerBookingDetailsQuery, GetBookingForCustomerBookingDetailsQueryVariables>;
export const GetBookingForEditBookingPageDocument = gql`
    query GetBookingForEditBookingPage($bookingUid: String!) {
  getBooking(bookingUid: $bookingUid) {
    uid
    startDateTime
    serviceOfferingUid
    ownerUid
    appointmentUid
    isInProgress
    customerInputSelections {
      customerInputUid
      optionValue
    }
    serviceOffering {
      ...serviceOfferingWithCustomerInputs
    }
    owner {
      uid
      fullName
      emailAddress
    }
    appointment {
      userUid
      startDateTime
      locationUid
      location {
        id
        type
      }
      serviceProvider {
        ownerUid
        displayName
        profile {
          displayName
        }
        serviceOfferingCategories {
          ...serviceOfferingCategoryFields
        }
        serviceOfferings {
          ...serviceOfferingWithCustomerInputs
        }
        dateAvailability {
          ...dateAvailabilityFields
        }
        dayOfWeekAvailability {
          ...dayOfWeekAvailabilityFields
        }
      }
      bookings(statusQuery: {cancelledStatus: NOT_CANCELLED}) {
        id
        uid
      }
    }
    dropoff {
      id
      dropoffDateTime
    }
  }
}
    ${ServiceOfferingWithCustomerInputsFragmentDoc}
${ServiceOfferingCategoryFieldsFragmentDoc}
${DateAvailabilityFieldsFragmentDoc}
${DayOfWeekAvailabilityFieldsFragmentDoc}`;

/**
 * __useGetBookingForEditBookingPageQuery__
 *
 * To run a query within a React component, call `useGetBookingForEditBookingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingForEditBookingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingForEditBookingPageQuery({
 *   variables: {
 *      bookingUid: // value for 'bookingUid'
 *   },
 * });
 */
export function useGetBookingForEditBookingPageQuery(baseOptions: Apollo.QueryHookOptions<GetBookingForEditBookingPageQuery, GetBookingForEditBookingPageQueryVariables> & ({ variables: GetBookingForEditBookingPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingForEditBookingPageQuery, GetBookingForEditBookingPageQueryVariables>(GetBookingForEditBookingPageDocument, options);
      }
export function useGetBookingForEditBookingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingForEditBookingPageQuery, GetBookingForEditBookingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingForEditBookingPageQuery, GetBookingForEditBookingPageQueryVariables>(GetBookingForEditBookingPageDocument, options);
        }
export function useGetBookingForEditBookingPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingForEditBookingPageQuery, GetBookingForEditBookingPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingForEditBookingPageQuery, GetBookingForEditBookingPageQueryVariables>(GetBookingForEditBookingPageDocument, options);
        }
export type GetBookingForEditBookingPageQueryHookResult = ReturnType<typeof useGetBookingForEditBookingPageQuery>;
export type GetBookingForEditBookingPageLazyQueryHookResult = ReturnType<typeof useGetBookingForEditBookingPageLazyQuery>;
export type GetBookingForEditBookingPageSuspenseQueryHookResult = ReturnType<typeof useGetBookingForEditBookingPageSuspenseQuery>;
export type GetBookingForEditBookingPageQueryResult = Apollo.QueryResult<GetBookingForEditBookingPageQuery, GetBookingForEditBookingPageQueryVariables>;
export const GetBookingForOrderDetailsDocument = gql`
    query GetBookingForOrderDetails($id: String!) {
  getBookingById(id: $id) {
    uid
    id
    startDateTime
    endDateTime
    isComplete
    appointment {
      uid
      location {
        id
        streetAddress
        formattedAddress
      }
      serviceArea {
        uid
        name
        description
        files {
          uploadedFile {
            publicUrl
          }
        }
      }
    }
    owner {
      emailAddress
      fullName
      phoneNumber
    }
    accountingRecord {
      uid
      tipAmount
      subTotal
      totalTaxAmount
      total
      lineItems {
        displayName
        discountedPrice
      }
    }
  }
}
    `;

/**
 * __useGetBookingForOrderDetailsQuery__
 *
 * To run a query within a React component, call `useGetBookingForOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingForOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingForOrderDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingForOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetBookingForOrderDetailsQuery, GetBookingForOrderDetailsQueryVariables> & ({ variables: GetBookingForOrderDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingForOrderDetailsQuery, GetBookingForOrderDetailsQueryVariables>(GetBookingForOrderDetailsDocument, options);
      }
export function useGetBookingForOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingForOrderDetailsQuery, GetBookingForOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingForOrderDetailsQuery, GetBookingForOrderDetailsQueryVariables>(GetBookingForOrderDetailsDocument, options);
        }
export function useGetBookingForOrderDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingForOrderDetailsQuery, GetBookingForOrderDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingForOrderDetailsQuery, GetBookingForOrderDetailsQueryVariables>(GetBookingForOrderDetailsDocument, options);
        }
export type GetBookingForOrderDetailsQueryHookResult = ReturnType<typeof useGetBookingForOrderDetailsQuery>;
export type GetBookingForOrderDetailsLazyQueryHookResult = ReturnType<typeof useGetBookingForOrderDetailsLazyQuery>;
export type GetBookingForOrderDetailsSuspenseQueryHookResult = ReturnType<typeof useGetBookingForOrderDetailsSuspenseQuery>;
export type GetBookingForOrderDetailsQueryResult = Apollo.QueryResult<GetBookingForOrderDetailsQuery, GetBookingForOrderDetailsQueryVariables>;
export const GetBookingPriceBreakdownForBookingDocument = gql`
    query GetBookingPriceBreakdownForBooking($bookingUid: String!) {
  getBookingPriceBreakdownForBooking(bookingUid: $bookingUid) {
    total
    subTotal
    discountedSubTotal
    taxAmount
    tipAmount
    customerInputs {
      displayName
      selectedOptions {
        discountedPrice
        basePrice
        displayName
      }
    }
    serviceOffering {
      displayName
      discountedPrice
      basePrice
    }
    discountsApplied {
      displayName
      amountDiscounted
    }
    customLineItems {
      displayName
      discountedPrice
    }
  }
}
    `;

/**
 * __useGetBookingPriceBreakdownForBookingQuery__
 *
 * To run a query within a React component, call `useGetBookingPriceBreakdownForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingPriceBreakdownForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingPriceBreakdownForBookingQuery({
 *   variables: {
 *      bookingUid: // value for 'bookingUid'
 *   },
 * });
 */
export function useGetBookingPriceBreakdownForBookingQuery(baseOptions: Apollo.QueryHookOptions<GetBookingPriceBreakdownForBookingQuery, GetBookingPriceBreakdownForBookingQueryVariables> & ({ variables: GetBookingPriceBreakdownForBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingPriceBreakdownForBookingQuery, GetBookingPriceBreakdownForBookingQueryVariables>(GetBookingPriceBreakdownForBookingDocument, options);
      }
export function useGetBookingPriceBreakdownForBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingPriceBreakdownForBookingQuery, GetBookingPriceBreakdownForBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingPriceBreakdownForBookingQuery, GetBookingPriceBreakdownForBookingQueryVariables>(GetBookingPriceBreakdownForBookingDocument, options);
        }
export function useGetBookingPriceBreakdownForBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingPriceBreakdownForBookingQuery, GetBookingPriceBreakdownForBookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingPriceBreakdownForBookingQuery, GetBookingPriceBreakdownForBookingQueryVariables>(GetBookingPriceBreakdownForBookingDocument, options);
        }
export type GetBookingPriceBreakdownForBookingQueryHookResult = ReturnType<typeof useGetBookingPriceBreakdownForBookingQuery>;
export type GetBookingPriceBreakdownForBookingLazyQueryHookResult = ReturnType<typeof useGetBookingPriceBreakdownForBookingLazyQuery>;
export type GetBookingPriceBreakdownForBookingSuspenseQueryHookResult = ReturnType<typeof useGetBookingPriceBreakdownForBookingSuspenseQuery>;
export type GetBookingPriceBreakdownForBookingQueryResult = Apollo.QueryResult<GetBookingPriceBreakdownForBookingQuery, GetBookingPriceBreakdownForBookingQueryVariables>;
export const GetBookingPriceBreakdownDocument = gql`
    query GetBookingPriceBreakdown($bookingSelections: BookingSelectionsInput!, $formattedAddress: String!, $bookingUid: String) {
  getBookingPriceBreakdown(
    bookingSelections: $bookingSelections
    formattedAddress: $formattedAddress
    bookingUid: $bookingUid
  ) {
    total
    subTotal
    discountedSubTotal
    taxAmount
  }
}
    `;

/**
 * __useGetBookingPriceBreakdownQuery__
 *
 * To run a query within a React component, call `useGetBookingPriceBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingPriceBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingPriceBreakdownQuery({
 *   variables: {
 *      bookingSelections: // value for 'bookingSelections'
 *      formattedAddress: // value for 'formattedAddress'
 *      bookingUid: // value for 'bookingUid'
 *   },
 * });
 */
export function useGetBookingPriceBreakdownQuery(baseOptions: Apollo.QueryHookOptions<GetBookingPriceBreakdownQuery, GetBookingPriceBreakdownQueryVariables> & ({ variables: GetBookingPriceBreakdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingPriceBreakdownQuery, GetBookingPriceBreakdownQueryVariables>(GetBookingPriceBreakdownDocument, options);
      }
export function useGetBookingPriceBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingPriceBreakdownQuery, GetBookingPriceBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingPriceBreakdownQuery, GetBookingPriceBreakdownQueryVariables>(GetBookingPriceBreakdownDocument, options);
        }
export function useGetBookingPriceBreakdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingPriceBreakdownQuery, GetBookingPriceBreakdownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingPriceBreakdownQuery, GetBookingPriceBreakdownQueryVariables>(GetBookingPriceBreakdownDocument, options);
        }
export type GetBookingPriceBreakdownQueryHookResult = ReturnType<typeof useGetBookingPriceBreakdownQuery>;
export type GetBookingPriceBreakdownLazyQueryHookResult = ReturnType<typeof useGetBookingPriceBreakdownLazyQuery>;
export type GetBookingPriceBreakdownSuspenseQueryHookResult = ReturnType<typeof useGetBookingPriceBreakdownSuspenseQuery>;
export type GetBookingPriceBreakdownQueryResult = Apollo.QueryResult<GetBookingPriceBreakdownQuery, GetBookingPriceBreakdownQueryVariables>;
export const GetBookingWithAccountingRecordDocument = gql`
    query GetBookingWithAccountingRecord($bookingUid: String!) {
  getBooking(bookingUid: $bookingUid) {
    uid
    startDateTime
    serviceOfferingUid
    ownerUid
    appointmentUid
    tipPercent
    customerInputSelections {
      customerInputUid
      optionValue
    }
    serviceOffering {
      uid
      title
      basePrice
      baseTime
      customerInputs {
        unitPrice
        title
        type
        uid
        options {
          uid
          value
          price
          duration
        }
      }
    }
    accountingRecord {
      total
      subTotal
      tipAmount
      totalTaxAmount
      discountedAmount
      stripePaymentIntent {
        paymentMethod {
          card {
            brand
            lastFour
          }
        }
      }
    }
    appointment {
      userUid
      isCoveredByBusiness
      location {
        id
        streetAddress
      }
      serviceProvider {
        displayName
        serviceType
        slug
        profile {
          avatarImage {
            uploadedFile {
              publicUrl
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookingWithAccountingRecordQuery__
 *
 * To run a query within a React component, call `useGetBookingWithAccountingRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingWithAccountingRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingWithAccountingRecordQuery({
 *   variables: {
 *      bookingUid: // value for 'bookingUid'
 *   },
 * });
 */
export function useGetBookingWithAccountingRecordQuery(baseOptions: Apollo.QueryHookOptions<GetBookingWithAccountingRecordQuery, GetBookingWithAccountingRecordQueryVariables> & ({ variables: GetBookingWithAccountingRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingWithAccountingRecordQuery, GetBookingWithAccountingRecordQueryVariables>(GetBookingWithAccountingRecordDocument, options);
      }
export function useGetBookingWithAccountingRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingWithAccountingRecordQuery, GetBookingWithAccountingRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingWithAccountingRecordQuery, GetBookingWithAccountingRecordQueryVariables>(GetBookingWithAccountingRecordDocument, options);
        }
export function useGetBookingWithAccountingRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingWithAccountingRecordQuery, GetBookingWithAccountingRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingWithAccountingRecordQuery, GetBookingWithAccountingRecordQueryVariables>(GetBookingWithAccountingRecordDocument, options);
        }
export type GetBookingWithAccountingRecordQueryHookResult = ReturnType<typeof useGetBookingWithAccountingRecordQuery>;
export type GetBookingWithAccountingRecordLazyQueryHookResult = ReturnType<typeof useGetBookingWithAccountingRecordLazyQuery>;
export type GetBookingWithAccountingRecordSuspenseQueryHookResult = ReturnType<typeof useGetBookingWithAccountingRecordSuspenseQuery>;
export type GetBookingWithAccountingRecordQueryResult = Apollo.QueryResult<GetBookingWithAccountingRecordQuery, GetBookingWithAccountingRecordQueryVariables>;
export const GetBookingDocument = gql`
    query GetBooking($bookingUid: String!) {
  getBooking(bookingUid: $bookingUid) {
    uid
    startDateTime
    serviceOfferingUid
    ownerUid
    appointmentUid
    isInProgress
    customerInputSelections {
      customerInputUid
      optionValue
    }
    serviceOffering {
      ...serviceOfferingWithCustomerInputs
    }
    owner {
      uid
      fullName
      emailAddress
    }
    appointment {
      userUid
      startDateTime
      locationUid
      location {
        id
        type
      }
      serviceProvider {
        ownerUid
        displayName
        profile {
          displayName
        }
        serviceOfferingCategories {
          ...serviceOfferingCategoryFields
        }
        serviceOfferings {
          ...serviceOfferingWithCustomerInputs
        }
        dateAvailability {
          ...dateAvailabilityFields
        }
        dayOfWeekAvailability {
          ...dayOfWeekAvailabilityFields
        }
      }
    }
    dropoff {
      id
      dropoffDateTime
    }
  }
}
    ${ServiceOfferingWithCustomerInputsFragmentDoc}
${ServiceOfferingCategoryFieldsFragmentDoc}
${DateAvailabilityFieldsFragmentDoc}
${DayOfWeekAvailabilityFieldsFragmentDoc}`;

/**
 * __useGetBookingQuery__
 *
 * To run a query within a React component, call `useGetBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingQuery({
 *   variables: {
 *      bookingUid: // value for 'bookingUid'
 *   },
 * });
 */
export function useGetBookingQuery(baseOptions: Apollo.QueryHookOptions<GetBookingQuery, GetBookingQueryVariables> & ({ variables: GetBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
      }
export function useGetBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
        }
export function useGetBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookingQuery, GetBookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingQuery, GetBookingQueryVariables>(GetBookingDocument, options);
        }
export type GetBookingQueryHookResult = ReturnType<typeof useGetBookingQuery>;
export type GetBookingLazyQueryHookResult = ReturnType<typeof useGetBookingLazyQuery>;
export type GetBookingSuspenseQueryHookResult = ReturnType<typeof useGetBookingSuspenseQuery>;
export type GetBookingQueryResult = Apollo.QueryResult<GetBookingQuery, GetBookingQueryVariables>;
export const GetBusinessActivityByAdminUidDocument = gql`
    query GetBusinessActivityByAdminUid($appointmentQuery: AppointmentQuery!, $locationSubscriptionQuery: LocationSubscriptionQuery!) {
  getBusinessByAdminUid {
    name
    locations {
      id
      uid
      subscriptionsCount(query: $locationSubscriptionQuery)
      appointments(query: $appointmentQuery) {
        uid
        bookingsWithSiblings {
          uid
        }
      }
    }
  }
}
    `;

/**
 * __useGetBusinessActivityByAdminUidQuery__
 *
 * To run a query within a React component, call `useGetBusinessActivityByAdminUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessActivityByAdminUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessActivityByAdminUidQuery({
 *   variables: {
 *      appointmentQuery: // value for 'appointmentQuery'
 *      locationSubscriptionQuery: // value for 'locationSubscriptionQuery'
 *   },
 * });
 */
export function useGetBusinessActivityByAdminUidQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessActivityByAdminUidQuery, GetBusinessActivityByAdminUidQueryVariables> & ({ variables: GetBusinessActivityByAdminUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessActivityByAdminUidQuery, GetBusinessActivityByAdminUidQueryVariables>(GetBusinessActivityByAdminUidDocument, options);
      }
export function useGetBusinessActivityByAdminUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessActivityByAdminUidQuery, GetBusinessActivityByAdminUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessActivityByAdminUidQuery, GetBusinessActivityByAdminUidQueryVariables>(GetBusinessActivityByAdminUidDocument, options);
        }
export function useGetBusinessActivityByAdminUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessActivityByAdminUidQuery, GetBusinessActivityByAdminUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessActivityByAdminUidQuery, GetBusinessActivityByAdminUidQueryVariables>(GetBusinessActivityByAdminUidDocument, options);
        }
export type GetBusinessActivityByAdminUidQueryHookResult = ReturnType<typeof useGetBusinessActivityByAdminUidQuery>;
export type GetBusinessActivityByAdminUidLazyQueryHookResult = ReturnType<typeof useGetBusinessActivityByAdminUidLazyQuery>;
export type GetBusinessActivityByAdminUidSuspenseQueryHookResult = ReturnType<typeof useGetBusinessActivityByAdminUidSuspenseQuery>;
export type GetBusinessActivityByAdminUidQueryResult = Apollo.QueryResult<GetBusinessActivityByAdminUidQuery, GetBusinessActivityByAdminUidQueryVariables>;
export const GetBusinessByAdminUidForBusinessIndexPageDocument = gql`
    query GetBusinessByAdminUidForBusinessIndexPage($appointmentQuery: AppointmentQuery!) {
  getBusinessByAdminUid {
    name
    uid
    locations {
      id
      uid
      name
      formattedAddress
      appointments(query: $appointmentQuery) {
        locationUid
        isConfirmed
        startDateTime
        maxEndDateTime
        uid
        id
        bookingsWithSiblings {
          uid
          owner {
            fullName
          }
        }
        discountRuleProgress {
          progressPercent
          discountRule {
            label
            discountValue
            discountType
            priority
            requireDurationBookedSeconds
            requireBookingCount
          }
        }
        serviceProvider {
          ownerUid
          serviceType
          displayName
          averageRating
          serviceOfferings {
            uid
            title
            index
          }
          reviews {
            isLike
            isVerified
          }
          profile {
            displayName
            avatarImage {
              uploadedFile {
                publicUrl
              }
            }
            photoGallery {
              items {
                index
                imageFile {
                  uploadedFile {
                    publicUrl
                  }
                }
              }
            }
          }
          insuranceInformation {
            titlePrefix
            titleSuffix
          }
        }
        serviceArea {
          uid
          name
        }
        preferences {
          type
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetBusinessByAdminUidForBusinessIndexPageQuery__
 *
 * To run a query within a React component, call `useGetBusinessByAdminUidForBusinessIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessByAdminUidForBusinessIndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessByAdminUidForBusinessIndexPageQuery({
 *   variables: {
 *      appointmentQuery: // value for 'appointmentQuery'
 *   },
 * });
 */
export function useGetBusinessByAdminUidForBusinessIndexPageQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessByAdminUidForBusinessIndexPageQuery, GetBusinessByAdminUidForBusinessIndexPageQueryVariables> & ({ variables: GetBusinessByAdminUidForBusinessIndexPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessByAdminUidForBusinessIndexPageQuery, GetBusinessByAdminUidForBusinessIndexPageQueryVariables>(GetBusinessByAdminUidForBusinessIndexPageDocument, options);
      }
export function useGetBusinessByAdminUidForBusinessIndexPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessByAdminUidForBusinessIndexPageQuery, GetBusinessByAdminUidForBusinessIndexPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessByAdminUidForBusinessIndexPageQuery, GetBusinessByAdminUidForBusinessIndexPageQueryVariables>(GetBusinessByAdminUidForBusinessIndexPageDocument, options);
        }
export function useGetBusinessByAdminUidForBusinessIndexPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessByAdminUidForBusinessIndexPageQuery, GetBusinessByAdminUidForBusinessIndexPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessByAdminUidForBusinessIndexPageQuery, GetBusinessByAdminUidForBusinessIndexPageQueryVariables>(GetBusinessByAdminUidForBusinessIndexPageDocument, options);
        }
export type GetBusinessByAdminUidForBusinessIndexPageQueryHookResult = ReturnType<typeof useGetBusinessByAdminUidForBusinessIndexPageQuery>;
export type GetBusinessByAdminUidForBusinessIndexPageLazyQueryHookResult = ReturnType<typeof useGetBusinessByAdminUidForBusinessIndexPageLazyQuery>;
export type GetBusinessByAdminUidForBusinessIndexPageSuspenseQueryHookResult = ReturnType<typeof useGetBusinessByAdminUidForBusinessIndexPageSuspenseQuery>;
export type GetBusinessByAdminUidForBusinessIndexPageQueryResult = Apollo.QueryResult<GetBusinessByAdminUidForBusinessIndexPageQuery, GetBusinessByAdminUidForBusinessIndexPageQueryVariables>;
export const GetBusinessByAdminUidDocument = gql`
    query GetBusinessByAdminUid($appointmentQuery: AppointmentQuery!) {
  getBusinessByAdminUid {
    name
    uid
    slug
    locations {
      id
      uid
      name
      formattedAddress
      appointments(query: $appointmentQuery) {
        id
        startDateTime
        locationUid
        serviceArea {
          uid
          name
        }
        isConfirmed
        bookingsWithSiblings {
          uid
        }
        serviceProvider {
          displayName
          serviceType
        }
      }
    }
  }
}
    `;

/**
 * __useGetBusinessByAdminUidQuery__
 *
 * To run a query within a React component, call `useGetBusinessByAdminUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessByAdminUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessByAdminUidQuery({
 *   variables: {
 *      appointmentQuery: // value for 'appointmentQuery'
 *   },
 * });
 */
export function useGetBusinessByAdminUidQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessByAdminUidQuery, GetBusinessByAdminUidQueryVariables> & ({ variables: GetBusinessByAdminUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessByAdminUidQuery, GetBusinessByAdminUidQueryVariables>(GetBusinessByAdminUidDocument, options);
      }
export function useGetBusinessByAdminUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessByAdminUidQuery, GetBusinessByAdminUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessByAdminUidQuery, GetBusinessByAdminUidQueryVariables>(GetBusinessByAdminUidDocument, options);
        }
export function useGetBusinessByAdminUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessByAdminUidQuery, GetBusinessByAdminUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessByAdminUidQuery, GetBusinessByAdminUidQueryVariables>(GetBusinessByAdminUidDocument, options);
        }
export type GetBusinessByAdminUidQueryHookResult = ReturnType<typeof useGetBusinessByAdminUidQuery>;
export type GetBusinessByAdminUidLazyQueryHookResult = ReturnType<typeof useGetBusinessByAdminUidLazyQuery>;
export type GetBusinessByAdminUidSuspenseQueryHookResult = ReturnType<typeof useGetBusinessByAdminUidSuspenseQuery>;
export type GetBusinessByAdminUidQueryResult = Apollo.QueryResult<GetBusinessByAdminUidQuery, GetBusinessByAdminUidQueryVariables>;
export const GetBusinessBySlugDocument = gql`
    query GetBusinessBySlug($slug: String!, $minStartDateTime: Int!) {
  getBusinessBySlug(slug: $slug) {
    name
    uid
    slug
    locations {
      id
      uid
      name
      formattedAddress
      streetAddress
      slug
      extendedAddress
      phoneNumber
      type
      ownerUid
      externalUid
      files {
        uid
        index
        uploadedFile {
          publicUrl
          objectName
        }
      }
      appointments(
        query: {confirmedStatus: CONFIRMED, cancelledStatus: NOT_CANCELLED, completeStatus: INCOMPLETE, timeUtcSecondsBounds: {min: $minStartDateTime}}
      ) {
        startDateTime
        maxEndDateTime
        uid
        id
        isCoveredByBusiness
        bookingsWithSiblings {
          uid
          owner {
            fullName
          }
        }
        discountRuleProgress {
          progressPercent
          discountRule {
            label
            discountValue
            discountType
            priority
            requireDurationBookedSeconds
            requireBookingCount
          }
        }
        serviceProvider {
          ownerUid
          serviceType
          displayName
          averageRating
          serviceOfferings {
            uid
            title
            index
          }
          reviews {
            isLike
            isVerified
          }
          profile {
            displayName
            avatarImage {
              uploadedFile {
                publicUrl
              }
            }
            photoGallery {
              items {
                index
                imageFile {
                  uploadedFile {
                    publicUrl
                  }
                }
              }
            }
          }
          insuranceInformation {
            titlePrefix
            titleSuffix
          }
        }
        serviceArea {
          uid
          name
        }
        preferences {
          type
          value
        }
        eventOffering {
          id
          title
          description
          type
          baseDuration
          maxBookings
          attendanceServiceOffering {
            uid
            title
            basePrice
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBusinessBySlugQuery__
 *
 * To run a query within a React component, call `useGetBusinessBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      minStartDateTime: // value for 'minStartDateTime'
 *   },
 * });
 */
export function useGetBusinessBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessBySlugQuery, GetBusinessBySlugQueryVariables> & ({ variables: GetBusinessBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessBySlugQuery, GetBusinessBySlugQueryVariables>(GetBusinessBySlugDocument, options);
      }
export function useGetBusinessBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessBySlugQuery, GetBusinessBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessBySlugQuery, GetBusinessBySlugQueryVariables>(GetBusinessBySlugDocument, options);
        }
export function useGetBusinessBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessBySlugQuery, GetBusinessBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessBySlugQuery, GetBusinessBySlugQueryVariables>(GetBusinessBySlugDocument, options);
        }
export type GetBusinessBySlugQueryHookResult = ReturnType<typeof useGetBusinessBySlugQuery>;
export type GetBusinessBySlugLazyQueryHookResult = ReturnType<typeof useGetBusinessBySlugLazyQuery>;
export type GetBusinessBySlugSuspenseQueryHookResult = ReturnType<typeof useGetBusinessBySlugSuspenseQuery>;
export type GetBusinessBySlugQueryResult = Apollo.QueryResult<GetBusinessBySlugQuery, GetBusinessBySlugQueryVariables>;
export const GetBusinessHasLinkedStripeSourceDocument = gql`
    query GetBusinessHasLinkedStripeSource {
  getBusinessHasLinkedStripeSource
}
    `;

/**
 * __useGetBusinessHasLinkedStripeSourceQuery__
 *
 * To run a query within a React component, call `useGetBusinessHasLinkedStripeSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessHasLinkedStripeSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessHasLinkedStripeSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessHasLinkedStripeSourceQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessHasLinkedStripeSourceQuery, GetBusinessHasLinkedStripeSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessHasLinkedStripeSourceQuery, GetBusinessHasLinkedStripeSourceQueryVariables>(GetBusinessHasLinkedStripeSourceDocument, options);
      }
export function useGetBusinessHasLinkedStripeSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessHasLinkedStripeSourceQuery, GetBusinessHasLinkedStripeSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessHasLinkedStripeSourceQuery, GetBusinessHasLinkedStripeSourceQueryVariables>(GetBusinessHasLinkedStripeSourceDocument, options);
        }
export function useGetBusinessHasLinkedStripeSourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessHasLinkedStripeSourceQuery, GetBusinessHasLinkedStripeSourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessHasLinkedStripeSourceQuery, GetBusinessHasLinkedStripeSourceQueryVariables>(GetBusinessHasLinkedStripeSourceDocument, options);
        }
export type GetBusinessHasLinkedStripeSourceQueryHookResult = ReturnType<typeof useGetBusinessHasLinkedStripeSourceQuery>;
export type GetBusinessHasLinkedStripeSourceLazyQueryHookResult = ReturnType<typeof useGetBusinessHasLinkedStripeSourceLazyQuery>;
export type GetBusinessHasLinkedStripeSourceSuspenseQueryHookResult = ReturnType<typeof useGetBusinessHasLinkedStripeSourceSuspenseQuery>;
export type GetBusinessHasLinkedStripeSourceQueryResult = Apollo.QueryResult<GetBusinessHasLinkedStripeSourceQuery, GetBusinessHasLinkedStripeSourceQueryVariables>;
export const GetBusinessLocationsByAdminUidDocument = gql`
    query GetBusinessLocationsByAdminUid {
  getBusinessByAdminUid {
    uid
    name
    locations {
      id
      uid
      latitude
      longitude
      streetAddress
      name
    }
  }
}
    `;

/**
 * __useGetBusinessLocationsByAdminUidQuery__
 *
 * To run a query within a React component, call `useGetBusinessLocationsByAdminUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessLocationsByAdminUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessLocationsByAdminUidQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessLocationsByAdminUidQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessLocationsByAdminUidQuery, GetBusinessLocationsByAdminUidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessLocationsByAdminUidQuery, GetBusinessLocationsByAdminUidQueryVariables>(GetBusinessLocationsByAdminUidDocument, options);
      }
export function useGetBusinessLocationsByAdminUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessLocationsByAdminUidQuery, GetBusinessLocationsByAdminUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessLocationsByAdminUidQuery, GetBusinessLocationsByAdminUidQueryVariables>(GetBusinessLocationsByAdminUidDocument, options);
        }
export function useGetBusinessLocationsByAdminUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessLocationsByAdminUidQuery, GetBusinessLocationsByAdminUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessLocationsByAdminUidQuery, GetBusinessLocationsByAdminUidQueryVariables>(GetBusinessLocationsByAdminUidDocument, options);
        }
export type GetBusinessLocationsByAdminUidQueryHookResult = ReturnType<typeof useGetBusinessLocationsByAdminUidQuery>;
export type GetBusinessLocationsByAdminUidLazyQueryHookResult = ReturnType<typeof useGetBusinessLocationsByAdminUidLazyQuery>;
export type GetBusinessLocationsByAdminUidSuspenseQueryHookResult = ReturnType<typeof useGetBusinessLocationsByAdminUidSuspenseQuery>;
export type GetBusinessLocationsByAdminUidQueryResult = Apollo.QueryResult<GetBusinessLocationsByAdminUidQuery, GetBusinessLocationsByAdminUidQueryVariables>;
export const GetBusinessUidByAdminUidDocument = gql`
    query GetBusinessUidByAdminUid {
  getBusinessByAdminUid {
    uid
    name
  }
}
    `;

/**
 * __useGetBusinessUidByAdminUidQuery__
 *
 * To run a query within a React component, call `useGetBusinessUidByAdminUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUidByAdminUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUidByAdminUidQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessUidByAdminUidQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessUidByAdminUidQuery, GetBusinessUidByAdminUidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUidByAdminUidQuery, GetBusinessUidByAdminUidQueryVariables>(GetBusinessUidByAdminUidDocument, options);
      }
export function useGetBusinessUidByAdminUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUidByAdminUidQuery, GetBusinessUidByAdminUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUidByAdminUidQuery, GetBusinessUidByAdminUidQueryVariables>(GetBusinessUidByAdminUidDocument, options);
        }
export function useGetBusinessUidByAdminUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessUidByAdminUidQuery, GetBusinessUidByAdminUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessUidByAdminUidQuery, GetBusinessUidByAdminUidQueryVariables>(GetBusinessUidByAdminUidDocument, options);
        }
export type GetBusinessUidByAdminUidQueryHookResult = ReturnType<typeof useGetBusinessUidByAdminUidQuery>;
export type GetBusinessUidByAdminUidLazyQueryHookResult = ReturnType<typeof useGetBusinessUidByAdminUidLazyQuery>;
export type GetBusinessUidByAdminUidSuspenseQueryHookResult = ReturnType<typeof useGetBusinessUidByAdminUidSuspenseQuery>;
export type GetBusinessUidByAdminUidQueryResult = Apollo.QueryResult<GetBusinessUidByAdminUidQuery, GetBusinessUidByAdminUidQueryVariables>;
export const V2Gateway_GetBusinessDocument = gql`
    query V2Gateway_GetBusiness($businessUid: String!) {
  getBusiness(businessUid: $businessUid) {
    uid
  }
}
    `;

/**
 * __useV2Gateway_GetBusinessQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetBusinessQuery({
 *   variables: {
 *      businessUid: // value for 'businessUid'
 *   },
 * });
 */
export function useV2Gateway_GetBusinessQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetBusinessQuery, V2Gateway_GetBusinessQueryVariables> & ({ variables: V2Gateway_GetBusinessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetBusinessQuery, V2Gateway_GetBusinessQueryVariables>(V2Gateway_GetBusinessDocument, options);
      }
export function useV2Gateway_GetBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetBusinessQuery, V2Gateway_GetBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetBusinessQuery, V2Gateway_GetBusinessQueryVariables>(V2Gateway_GetBusinessDocument, options);
        }
export function useV2Gateway_GetBusinessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetBusinessQuery, V2Gateway_GetBusinessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetBusinessQuery, V2Gateway_GetBusinessQueryVariables>(V2Gateway_GetBusinessDocument, options);
        }
export type V2Gateway_GetBusinessQueryHookResult = ReturnType<typeof useV2Gateway_GetBusinessQuery>;
export type V2Gateway_GetBusinessLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetBusinessLazyQuery>;
export type V2Gateway_GetBusinessSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetBusinessSuspenseQuery>;
export type V2Gateway_GetBusinessQueryResult = Apollo.QueryResult<V2Gateway_GetBusinessQuery, V2Gateway_GetBusinessQueryVariables>;
export const GetCustomLineItemsByBookingIdDocument = gql`
    query GetCustomLineItemsByBookingId($bookingId: ID!) {
  getCustomLineItemsByBookingId(bookingId: $bookingId) {
    id
    name
    description
    price
    durationMinutes
    taxRateToggle {
      disabledTaxRateLineItems
    }
  }
}
    `;

/**
 * __useGetCustomLineItemsByBookingIdQuery__
 *
 * To run a query within a React component, call `useGetCustomLineItemsByBookingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomLineItemsByBookingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomLineItemsByBookingIdQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetCustomLineItemsByBookingIdQuery(baseOptions: Apollo.QueryHookOptions<GetCustomLineItemsByBookingIdQuery, GetCustomLineItemsByBookingIdQueryVariables> & ({ variables: GetCustomLineItemsByBookingIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomLineItemsByBookingIdQuery, GetCustomLineItemsByBookingIdQueryVariables>(GetCustomLineItemsByBookingIdDocument, options);
      }
export function useGetCustomLineItemsByBookingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomLineItemsByBookingIdQuery, GetCustomLineItemsByBookingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomLineItemsByBookingIdQuery, GetCustomLineItemsByBookingIdQueryVariables>(GetCustomLineItemsByBookingIdDocument, options);
        }
export function useGetCustomLineItemsByBookingIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomLineItemsByBookingIdQuery, GetCustomLineItemsByBookingIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomLineItemsByBookingIdQuery, GetCustomLineItemsByBookingIdQueryVariables>(GetCustomLineItemsByBookingIdDocument, options);
        }
export type GetCustomLineItemsByBookingIdQueryHookResult = ReturnType<typeof useGetCustomLineItemsByBookingIdQuery>;
export type GetCustomLineItemsByBookingIdLazyQueryHookResult = ReturnType<typeof useGetCustomLineItemsByBookingIdLazyQuery>;
export type GetCustomLineItemsByBookingIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomLineItemsByBookingIdSuspenseQuery>;
export type GetCustomLineItemsByBookingIdQueryResult = Apollo.QueryResult<GetCustomLineItemsByBookingIdQuery, GetCustomLineItemsByBookingIdQueryVariables>;
export const GetCustomerBookingsDocument = gql`
    query GetCustomerBookings($query: BookingQuery!) {
  queryBookings(query: $query) {
    bookings {
      isInProgress
      ...deepBookingFields
      appointment {
        uid
        id
        isConfirmed
        serviceArea {
          uid
          name
          description
          externalUid
          files {
            uid
            externalUid
            label
            uploadedFile {
              objectName
              publicUrl
            }
          }
        }
        startDateTime
        maxEndDateTime
        bookingsWithSiblings {
          uid
          owner {
            fullName
          }
        }
        discountRuleProgress {
          progressPercent
          discountRule {
            label
            discountValue
            discountType
            priority
            requireDurationBookedSeconds
            requireBookingCount
          }
        }
        location {
          uid
          id
          streetAddress
          name
          type
          phoneNumber
          owner {
            fullName
            emailAddress
            phoneNumber
          }
        }
        serviceProvider {
          serviceType
          ownerUid
          displayName
          slug
          profile {
            ...profileFragment
          }
          serviceOfferings {
            uid
            title
          }
          reviewCount
          averageRating
          reviews {
            uid
            isLike
          }
        }
      }
    }
  }
}
    ${DeepBookingFieldsFragmentDoc}
${ProfileFragmentFragmentDoc}`;

/**
 * __useGetCustomerBookingsQuery__
 *
 * To run a query within a React component, call `useGetCustomerBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerBookingsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetCustomerBookingsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerBookingsQuery, GetCustomerBookingsQueryVariables> & ({ variables: GetCustomerBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerBookingsQuery, GetCustomerBookingsQueryVariables>(GetCustomerBookingsDocument, options);
      }
export function useGetCustomerBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerBookingsQuery, GetCustomerBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerBookingsQuery, GetCustomerBookingsQueryVariables>(GetCustomerBookingsDocument, options);
        }
export function useGetCustomerBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerBookingsQuery, GetCustomerBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerBookingsQuery, GetCustomerBookingsQueryVariables>(GetCustomerBookingsDocument, options);
        }
export type GetCustomerBookingsQueryHookResult = ReturnType<typeof useGetCustomerBookingsQuery>;
export type GetCustomerBookingsLazyQueryHookResult = ReturnType<typeof useGetCustomerBookingsLazyQuery>;
export type GetCustomerBookingsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerBookingsSuspenseQuery>;
export type GetCustomerBookingsQueryResult = Apollo.QueryResult<GetCustomerBookingsQuery, GetCustomerBookingsQueryVariables>;
export const GetCustomerByUserIdForBookingDetailsDocument = gql`
    query GetCustomerByUserIdForBookingDetails($userId: String!) {
  getCustomerByUserId(userId: $userId) {
    id
    profiles {
      id
      customerID
      fieldValues {
        customerProfileFieldID
        value
      }
      notes {
        id
        text
        title
        createdAt
      }
      label
    }
  }
}
    `;

/**
 * __useGetCustomerByUserIdForBookingDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomerByUserIdForBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerByUserIdForBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerByUserIdForBookingDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCustomerByUserIdForBookingDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerByUserIdForBookingDetailsQuery, GetCustomerByUserIdForBookingDetailsQueryVariables> & ({ variables: GetCustomerByUserIdForBookingDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerByUserIdForBookingDetailsQuery, GetCustomerByUserIdForBookingDetailsQueryVariables>(GetCustomerByUserIdForBookingDetailsDocument, options);
      }
export function useGetCustomerByUserIdForBookingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerByUserIdForBookingDetailsQuery, GetCustomerByUserIdForBookingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerByUserIdForBookingDetailsQuery, GetCustomerByUserIdForBookingDetailsQueryVariables>(GetCustomerByUserIdForBookingDetailsDocument, options);
        }
export function useGetCustomerByUserIdForBookingDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerByUserIdForBookingDetailsQuery, GetCustomerByUserIdForBookingDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerByUserIdForBookingDetailsQuery, GetCustomerByUserIdForBookingDetailsQueryVariables>(GetCustomerByUserIdForBookingDetailsDocument, options);
        }
export type GetCustomerByUserIdForBookingDetailsQueryHookResult = ReturnType<typeof useGetCustomerByUserIdForBookingDetailsQuery>;
export type GetCustomerByUserIdForBookingDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomerByUserIdForBookingDetailsLazyQuery>;
export type GetCustomerByUserIdForBookingDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerByUserIdForBookingDetailsSuspenseQuery>;
export type GetCustomerByUserIdForBookingDetailsQueryResult = Apollo.QueryResult<GetCustomerByUserIdForBookingDetailsQuery, GetCustomerByUserIdForBookingDetailsQueryVariables>;
export const GetCustomerByUserIdDocument = gql`
    query GetCustomerByUserId($userId: String!) {
  getCustomerByUserId(userId: $userId) {
    id
  }
}
    `;

/**
 * __useGetCustomerByUserIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCustomerByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerByUserIdQuery, GetCustomerByUserIdQueryVariables> & ({ variables: GetCustomerByUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerByUserIdQuery, GetCustomerByUserIdQueryVariables>(GetCustomerByUserIdDocument, options);
      }
export function useGetCustomerByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerByUserIdQuery, GetCustomerByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerByUserIdQuery, GetCustomerByUserIdQueryVariables>(GetCustomerByUserIdDocument, options);
        }
export function useGetCustomerByUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerByUserIdQuery, GetCustomerByUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerByUserIdQuery, GetCustomerByUserIdQueryVariables>(GetCustomerByUserIdDocument, options);
        }
export type GetCustomerByUserIdQueryHookResult = ReturnType<typeof useGetCustomerByUserIdQuery>;
export type GetCustomerByUserIdLazyQueryHookResult = ReturnType<typeof useGetCustomerByUserIdLazyQuery>;
export type GetCustomerByUserIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomerByUserIdSuspenseQuery>;
export type GetCustomerByUserIdQueryResult = Apollo.QueryResult<GetCustomerByUserIdQuery, GetCustomerByUserIdQueryVariables>;
export const GetCustomerForCustomerDetailsDocument = gql`
    query GetCustomerForCustomerDetails($customerId: String!, $remindersMinDateTime: Int!, $remindersMaxDateTime: Int!) {
  getCustomer(customerId: $customerId) {
    id
    user {
      fullName
      emailAddress
      phoneNumber
      locations {
        id
        streetAddress
      }
    }
    profiles {
      id
      label
      fieldValues {
        customerProfileFieldID
        value
      }
      notes {
        id
        text
        title
        createdAt
      }
    }
    reminders(
      minDateTime: $remindersMinDateTime
      maxDateTime: $remindersMaxDateTime
    ) {
      reminders {
        ...reminderFields
      }
      hasNextPage
    }
    bookings(pageSize: 5) {
      uid
      id
      startDateTime
      customerProfileId
      serviceOffering {
        uid
        title
      }
      review {
        uid
        rating
        createdAt
        text
      }
    }
  }
}
    ${ReminderFieldsFragmentDoc}`;

/**
 * __useGetCustomerForCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomerForCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerForCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerForCustomerDetailsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      remindersMinDateTime: // value for 'remindersMinDateTime'
 *      remindersMaxDateTime: // value for 'remindersMaxDateTime'
 *   },
 * });
 */
export function useGetCustomerForCustomerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerForCustomerDetailsQuery, GetCustomerForCustomerDetailsQueryVariables> & ({ variables: GetCustomerForCustomerDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerForCustomerDetailsQuery, GetCustomerForCustomerDetailsQueryVariables>(GetCustomerForCustomerDetailsDocument, options);
      }
export function useGetCustomerForCustomerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerForCustomerDetailsQuery, GetCustomerForCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerForCustomerDetailsQuery, GetCustomerForCustomerDetailsQueryVariables>(GetCustomerForCustomerDetailsDocument, options);
        }
export function useGetCustomerForCustomerDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerForCustomerDetailsQuery, GetCustomerForCustomerDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerForCustomerDetailsQuery, GetCustomerForCustomerDetailsQueryVariables>(GetCustomerForCustomerDetailsDocument, options);
        }
export type GetCustomerForCustomerDetailsQueryHookResult = ReturnType<typeof useGetCustomerForCustomerDetailsQuery>;
export type GetCustomerForCustomerDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomerForCustomerDetailsLazyQuery>;
export type GetCustomerForCustomerDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerForCustomerDetailsSuspenseQuery>;
export type GetCustomerForCustomerDetailsQueryResult = Apollo.QueryResult<GetCustomerForCustomerDetailsQuery, GetCustomerForCustomerDetailsQueryVariables>;
export const GetCustomerProfileFieldsDocument = gql`
    query GetCustomerProfileFields {
  getCustomerProfileFieldsForServiceProvider {
    id
    title
    description
    serviceProviderId
    type
    index
    options {
      id
      value
    }
  }
}
    `;

/**
 * __useGetCustomerProfileFieldsQuery__
 *
 * To run a query within a React component, call `useGetCustomerProfileFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerProfileFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerProfileFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerProfileFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerProfileFieldsQuery, GetCustomerProfileFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerProfileFieldsQuery, GetCustomerProfileFieldsQueryVariables>(GetCustomerProfileFieldsDocument, options);
      }
export function useGetCustomerProfileFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerProfileFieldsQuery, GetCustomerProfileFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerProfileFieldsQuery, GetCustomerProfileFieldsQueryVariables>(GetCustomerProfileFieldsDocument, options);
        }
export function useGetCustomerProfileFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerProfileFieldsQuery, GetCustomerProfileFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerProfileFieldsQuery, GetCustomerProfileFieldsQueryVariables>(GetCustomerProfileFieldsDocument, options);
        }
export type GetCustomerProfileFieldsQueryHookResult = ReturnType<typeof useGetCustomerProfileFieldsQuery>;
export type GetCustomerProfileFieldsLazyQueryHookResult = ReturnType<typeof useGetCustomerProfileFieldsLazyQuery>;
export type GetCustomerProfileFieldsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerProfileFieldsSuspenseQuery>;
export type GetCustomerProfileFieldsQueryResult = Apollo.QueryResult<GetCustomerProfileFieldsQuery, GetCustomerProfileFieldsQueryVariables>;
export const GetCustomerProfilesDocument = gql`
    query GetCustomerProfiles($customerId: String!) {
  getCustomerProfilesForCustomer(customerId: $customerId) {
    id
    customerID
    fieldValues {
      customerProfileFieldID
      value
    }
    notes {
      id
      text
      title
      createdAt
    }
    label
  }
}
    `;

/**
 * __useGetCustomerProfilesQuery__
 *
 * To run a query within a React component, call `useGetCustomerProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerProfilesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerProfilesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerProfilesQuery, GetCustomerProfilesQueryVariables> & ({ variables: GetCustomerProfilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerProfilesQuery, GetCustomerProfilesQueryVariables>(GetCustomerProfilesDocument, options);
      }
export function useGetCustomerProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerProfilesQuery, GetCustomerProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerProfilesQuery, GetCustomerProfilesQueryVariables>(GetCustomerProfilesDocument, options);
        }
export function useGetCustomerProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerProfilesQuery, GetCustomerProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerProfilesQuery, GetCustomerProfilesQueryVariables>(GetCustomerProfilesDocument, options);
        }
export type GetCustomerProfilesQueryHookResult = ReturnType<typeof useGetCustomerProfilesQuery>;
export type GetCustomerProfilesLazyQueryHookResult = ReturnType<typeof useGetCustomerProfilesLazyQuery>;
export type GetCustomerProfilesSuspenseQueryHookResult = ReturnType<typeof useGetCustomerProfilesSuspenseQuery>;
export type GetCustomerProfilesQueryResult = Apollo.QueryResult<GetCustomerProfilesQuery, GetCustomerProfilesQueryVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($customerId: String!) {
  getCustomer(customerId: $customerId) {
    id
    user {
      fullName
      locations {
        id
        uid
        placeId
        formattedAddress
        name
      }
    }
  }
}
    `;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables> & ({ variables: GetCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetPaymentMethodsForCustomersDocument = gql`
    query GetPaymentMethodsForCustomers($customerIds: [String!]!) {
  getPaymentMethodsForCustomers(customerIds: $customerIds) {
    customerId
    cards {
      expMonth
      expYear
    }
  }
}
    `;

/**
 * __useGetPaymentMethodsForCustomersQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsForCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsForCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsForCustomersQuery({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *   },
 * });
 */
export function useGetPaymentMethodsForCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodsForCustomersQuery, GetPaymentMethodsForCustomersQueryVariables> & ({ variables: GetPaymentMethodsForCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsForCustomersQuery, GetPaymentMethodsForCustomersQueryVariables>(GetPaymentMethodsForCustomersDocument, options);
      }
export function useGetPaymentMethodsForCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsForCustomersQuery, GetPaymentMethodsForCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsForCustomersQuery, GetPaymentMethodsForCustomersQueryVariables>(GetPaymentMethodsForCustomersDocument, options);
        }
export function useGetPaymentMethodsForCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsForCustomersQuery, GetPaymentMethodsForCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsForCustomersQuery, GetPaymentMethodsForCustomersQueryVariables>(GetPaymentMethodsForCustomersDocument, options);
        }
export type GetPaymentMethodsForCustomersQueryHookResult = ReturnType<typeof useGetPaymentMethodsForCustomersQuery>;
export type GetPaymentMethodsForCustomersLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsForCustomersLazyQuery>;
export type GetPaymentMethodsForCustomersSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsForCustomersSuspenseQuery>;
export type GetPaymentMethodsForCustomersQueryResult = Apollo.QueryResult<GetPaymentMethodsForCustomersQuery, GetPaymentMethodsForCustomersQueryVariables>;
export const GetDiscountRulesForServiceProviderDocument = gql`
    query GetDiscountRulesForServiceProvider($includeDisabled: Boolean!) {
  getDiscountRulesForServiceProvider(includeDisabled: $includeDisabled) {
    discountRules {
      id
      isDisabled
      label
      triggerCondition {
        siblingBookingTriggerCondition {
          requireBookingCount
          ignoreServiceOfferingUids
        }
        timeDurationBookedAtLocationTriggerCondition {
          requireDurationBookedSeconds
          ignoreServiceOfferingUids
        }
      }
      discountValue
      discountType
      priority
    }
    hasMoreResults
  }
}
    `;

/**
 * __useGetDiscountRulesForServiceProviderQuery__
 *
 * To run a query within a React component, call `useGetDiscountRulesForServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountRulesForServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountRulesForServiceProviderQuery({
 *   variables: {
 *      includeDisabled: // value for 'includeDisabled'
 *   },
 * });
 */
export function useGetDiscountRulesForServiceProviderQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountRulesForServiceProviderQuery, GetDiscountRulesForServiceProviderQueryVariables> & ({ variables: GetDiscountRulesForServiceProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountRulesForServiceProviderQuery, GetDiscountRulesForServiceProviderQueryVariables>(GetDiscountRulesForServiceProviderDocument, options);
      }
export function useGetDiscountRulesForServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountRulesForServiceProviderQuery, GetDiscountRulesForServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountRulesForServiceProviderQuery, GetDiscountRulesForServiceProviderQueryVariables>(GetDiscountRulesForServiceProviderDocument, options);
        }
export function useGetDiscountRulesForServiceProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscountRulesForServiceProviderQuery, GetDiscountRulesForServiceProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiscountRulesForServiceProviderQuery, GetDiscountRulesForServiceProviderQueryVariables>(GetDiscountRulesForServiceProviderDocument, options);
        }
export type GetDiscountRulesForServiceProviderQueryHookResult = ReturnType<typeof useGetDiscountRulesForServiceProviderQuery>;
export type GetDiscountRulesForServiceProviderLazyQueryHookResult = ReturnType<typeof useGetDiscountRulesForServiceProviderLazyQuery>;
export type GetDiscountRulesForServiceProviderSuspenseQueryHookResult = ReturnType<typeof useGetDiscountRulesForServiceProviderSuspenseQuery>;
export type GetDiscountRulesForServiceProviderQueryResult = Apollo.QueryResult<GetDiscountRulesForServiceProviderQuery, GetDiscountRulesForServiceProviderQueryVariables>;
export const GetDiscountRulesProgressDocument = gql`
    query GetDiscountRulesProgress($appointmentUID: String!) {
  getDiscountRulesProgress(appointmentUID: $appointmentUID) {
    progressPercent
    discountRule {
      label
      discountValue
      discountType
      priority
      requireDurationBookedSeconds
      requireBookingCount
    }
  }
}
    `;

/**
 * __useGetDiscountRulesProgressQuery__
 *
 * To run a query within a React component, call `useGetDiscountRulesProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountRulesProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountRulesProgressQuery({
 *   variables: {
 *      appointmentUID: // value for 'appointmentUID'
 *   },
 * });
 */
export function useGetDiscountRulesProgressQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountRulesProgressQuery, GetDiscountRulesProgressQueryVariables> & ({ variables: GetDiscountRulesProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountRulesProgressQuery, GetDiscountRulesProgressQueryVariables>(GetDiscountRulesProgressDocument, options);
      }
export function useGetDiscountRulesProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountRulesProgressQuery, GetDiscountRulesProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountRulesProgressQuery, GetDiscountRulesProgressQueryVariables>(GetDiscountRulesProgressDocument, options);
        }
export function useGetDiscountRulesProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiscountRulesProgressQuery, GetDiscountRulesProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiscountRulesProgressQuery, GetDiscountRulesProgressQueryVariables>(GetDiscountRulesProgressDocument, options);
        }
export type GetDiscountRulesProgressQueryHookResult = ReturnType<typeof useGetDiscountRulesProgressQuery>;
export type GetDiscountRulesProgressLazyQueryHookResult = ReturnType<typeof useGetDiscountRulesProgressLazyQuery>;
export type GetDiscountRulesProgressSuspenseQueryHookResult = ReturnType<typeof useGetDiscountRulesProgressSuspenseQuery>;
export type GetDiscountRulesProgressQueryResult = Apollo.QueryResult<GetDiscountRulesProgressQuery, GetDiscountRulesProgressQueryVariables>;
export const GetDropoffsForServiceProviderCalendarDocument = gql`
    query GetDropoffsForServiceProviderCalendar($query: DropoffQuery!) {
  getDropoffsForServiceProvider(query: $query) {
    dropoffs {
      id
      dropoffDateTime
      booking {
        id
        uid
        customerProfileId
        startDateTime
        endDateTime
        isComplete
        tipPercent
        appointmentUid
        isInProgress
        serviceOffering {
          uid
          title
          type
        }
        appointment {
          uid
          serviceArea {
            uid
            name
          }
          location {
            id
            streetAddress
            type
            name
          }
        }
        customer {
          id
          user {
            id
            uid
            fullName
            emailAddress
            phoneNumber
          }
          profiles {
            id
            customerID
            fieldValues {
              customerProfileFieldID
              value
            }
            notes {
              id
              text
              title
              createdAt
            }
            label
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDropoffsForServiceProviderCalendarQuery__
 *
 * To run a query within a React component, call `useGetDropoffsForServiceProviderCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDropoffsForServiceProviderCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDropoffsForServiceProviderCalendarQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetDropoffsForServiceProviderCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetDropoffsForServiceProviderCalendarQuery, GetDropoffsForServiceProviderCalendarQueryVariables> & ({ variables: GetDropoffsForServiceProviderCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDropoffsForServiceProviderCalendarQuery, GetDropoffsForServiceProviderCalendarQueryVariables>(GetDropoffsForServiceProviderCalendarDocument, options);
      }
export function useGetDropoffsForServiceProviderCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDropoffsForServiceProviderCalendarQuery, GetDropoffsForServiceProviderCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDropoffsForServiceProviderCalendarQuery, GetDropoffsForServiceProviderCalendarQueryVariables>(GetDropoffsForServiceProviderCalendarDocument, options);
        }
export function useGetDropoffsForServiceProviderCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDropoffsForServiceProviderCalendarQuery, GetDropoffsForServiceProviderCalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDropoffsForServiceProviderCalendarQuery, GetDropoffsForServiceProviderCalendarQueryVariables>(GetDropoffsForServiceProviderCalendarDocument, options);
        }
export type GetDropoffsForServiceProviderCalendarQueryHookResult = ReturnType<typeof useGetDropoffsForServiceProviderCalendarQuery>;
export type GetDropoffsForServiceProviderCalendarLazyQueryHookResult = ReturnType<typeof useGetDropoffsForServiceProviderCalendarLazyQuery>;
export type GetDropoffsForServiceProviderCalendarSuspenseQueryHookResult = ReturnType<typeof useGetDropoffsForServiceProviderCalendarSuspenseQuery>;
export type GetDropoffsForServiceProviderCalendarQueryResult = Apollo.QueryResult<GetDropoffsForServiceProviderCalendarQuery, GetDropoffsForServiceProviderCalendarQueryVariables>;
export const GetDropoffsForServiceProviderWithServiceAreaFilesDocument = gql`
    query GetDropoffsForServiceProviderWithServiceAreaFiles($query: DropoffQuery!) {
  getDropoffsForServiceProvider(query: $query) {
    dropoffs {
      dropoffDateTime
      status
      booking {
        id
        uid
        customerProfileId
        startDateTime
        endDateTime
        isComplete
        tipPercent
        appointmentUid
        isInProgress
        customerInputGroupSelections {
          level
          customerInputUids
          optionValues
          customerInputs {
            uid
            type
            title
            ownerUid
            required
            options {
              uid
              value
              price
              duration
            }
          }
          selectedOptions {
            uid
            value
            price
            duration
          }
        }
        customerInputSelections {
          customerInputUid
          optionValue
          customerInput {
            type
            title
            ownerUid
            required
            uid
            options {
              uid
              value
              duration
              price
            }
          }
          selectedOptions {
            uid
            value
            price
            duration
          }
        }
        owner {
          id
          uid
          fullName
          emailAddress
          phoneNumber
        }
        serviceOffering {
          uid
          title
          type
        }
        appointment {
          uid
          serviceArea {
            uid
            name
            description
            files {
              uid
              index
              label
              uploadedFile {
                objectName
                publicUrl
              }
            }
          }
          location {
            ...dropoffBookingAppointmentLocationFields
          }
        }
        customer {
          id
          profiles {
            id
            customerID
            fieldValues {
              customerProfileFieldID
              value
            }
            notes {
              id
              text
              title
              createdAt
            }
            label
          }
          user {
            id
            fullName
            emailAddress
          }
        }
      }
    }
  }
}
    ${DropoffBookingAppointmentLocationFieldsFragmentDoc}`;

/**
 * __useGetDropoffsForServiceProviderWithServiceAreaFilesQuery__
 *
 * To run a query within a React component, call `useGetDropoffsForServiceProviderWithServiceAreaFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDropoffsForServiceProviderWithServiceAreaFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDropoffsForServiceProviderWithServiceAreaFilesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetDropoffsForServiceProviderWithServiceAreaFilesQuery(baseOptions: Apollo.QueryHookOptions<GetDropoffsForServiceProviderWithServiceAreaFilesQuery, GetDropoffsForServiceProviderWithServiceAreaFilesQueryVariables> & ({ variables: GetDropoffsForServiceProviderWithServiceAreaFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDropoffsForServiceProviderWithServiceAreaFilesQuery, GetDropoffsForServiceProviderWithServiceAreaFilesQueryVariables>(GetDropoffsForServiceProviderWithServiceAreaFilesDocument, options);
      }
export function useGetDropoffsForServiceProviderWithServiceAreaFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDropoffsForServiceProviderWithServiceAreaFilesQuery, GetDropoffsForServiceProviderWithServiceAreaFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDropoffsForServiceProviderWithServiceAreaFilesQuery, GetDropoffsForServiceProviderWithServiceAreaFilesQueryVariables>(GetDropoffsForServiceProviderWithServiceAreaFilesDocument, options);
        }
export function useGetDropoffsForServiceProviderWithServiceAreaFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDropoffsForServiceProviderWithServiceAreaFilesQuery, GetDropoffsForServiceProviderWithServiceAreaFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDropoffsForServiceProviderWithServiceAreaFilesQuery, GetDropoffsForServiceProviderWithServiceAreaFilesQueryVariables>(GetDropoffsForServiceProviderWithServiceAreaFilesDocument, options);
        }
export type GetDropoffsForServiceProviderWithServiceAreaFilesQueryHookResult = ReturnType<typeof useGetDropoffsForServiceProviderWithServiceAreaFilesQuery>;
export type GetDropoffsForServiceProviderWithServiceAreaFilesLazyQueryHookResult = ReturnType<typeof useGetDropoffsForServiceProviderWithServiceAreaFilesLazyQuery>;
export type GetDropoffsForServiceProviderWithServiceAreaFilesSuspenseQueryHookResult = ReturnType<typeof useGetDropoffsForServiceProviderWithServiceAreaFilesSuspenseQuery>;
export type GetDropoffsForServiceProviderWithServiceAreaFilesQueryResult = Apollo.QueryResult<GetDropoffsForServiceProviderWithServiceAreaFilesQuery, GetDropoffsForServiceProviderWithServiceAreaFilesQueryVariables>;
export const GetEmailTemplateDocument = gql`
    query GetEmailTemplate($id: String!) {
  getEmailTemplate(templateId: $id) {
    id
    templateType
    serviceProviderId
    subject
    htmlBody
    mjmlJson
  }
}
    `;

/**
 * __useGetEmailTemplateQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables> & ({ variables: GetEmailTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
      }
export function useGetEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
        }
export function useGetEmailTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
        }
export type GetEmailTemplateQueryHookResult = ReturnType<typeof useGetEmailTemplateQuery>;
export type GetEmailTemplateLazyQueryHookResult = ReturnType<typeof useGetEmailTemplateLazyQuery>;
export type GetEmailTemplateSuspenseQueryHookResult = ReturnType<typeof useGetEmailTemplateSuspenseQuery>;
export type GetEmailTemplateQueryResult = Apollo.QueryResult<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>;
export const GetEmailTemplatesForServiceProviderDocument = gql`
    query GetEmailTemplatesForServiceProvider {
  getEmailTemplatesForServiceProvider {
    id
    templateType
    serviceProviderId
    subject
    htmlBody
    mjmlJson
  }
}
    `;

/**
 * __useGetEmailTemplatesForServiceProviderQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplatesForServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplatesForServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplatesForServiceProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailTemplatesForServiceProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailTemplatesForServiceProviderQuery, GetEmailTemplatesForServiceProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplatesForServiceProviderQuery, GetEmailTemplatesForServiceProviderQueryVariables>(GetEmailTemplatesForServiceProviderDocument, options);
      }
export function useGetEmailTemplatesForServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplatesForServiceProviderQuery, GetEmailTemplatesForServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplatesForServiceProviderQuery, GetEmailTemplatesForServiceProviderQueryVariables>(GetEmailTemplatesForServiceProviderDocument, options);
        }
export function useGetEmailTemplatesForServiceProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailTemplatesForServiceProviderQuery, GetEmailTemplatesForServiceProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailTemplatesForServiceProviderQuery, GetEmailTemplatesForServiceProviderQueryVariables>(GetEmailTemplatesForServiceProviderDocument, options);
        }
export type GetEmailTemplatesForServiceProviderQueryHookResult = ReturnType<typeof useGetEmailTemplatesForServiceProviderQuery>;
export type GetEmailTemplatesForServiceProviderLazyQueryHookResult = ReturnType<typeof useGetEmailTemplatesForServiceProviderLazyQuery>;
export type GetEmailTemplatesForServiceProviderSuspenseQueryHookResult = ReturnType<typeof useGetEmailTemplatesForServiceProviderSuspenseQuery>;
export type GetEmailTemplatesForServiceProviderQueryResult = Apollo.QueryResult<GetEmailTemplatesForServiceProviderQuery, GetEmailTemplatesForServiceProviderQueryVariables>;
export const GetEventOfferingDocument = gql`
    query GetEventOffering($eventOfferingId: String!) {
  getEventOffering(id: $eventOfferingId) {
    id
    title
    description
    basePrice
    baseDuration
    type
    maxBookings
    serviceProviderId
    index
    serviceOfferingUids
  }
}
    `;

/**
 * __useGetEventOfferingQuery__
 *
 * To run a query within a React component, call `useGetEventOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventOfferingQuery({
 *   variables: {
 *      eventOfferingId: // value for 'eventOfferingId'
 *   },
 * });
 */
export function useGetEventOfferingQuery(baseOptions: Apollo.QueryHookOptions<GetEventOfferingQuery, GetEventOfferingQueryVariables> & ({ variables: GetEventOfferingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventOfferingQuery, GetEventOfferingQueryVariables>(GetEventOfferingDocument, options);
      }
export function useGetEventOfferingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventOfferingQuery, GetEventOfferingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventOfferingQuery, GetEventOfferingQueryVariables>(GetEventOfferingDocument, options);
        }
export function useGetEventOfferingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventOfferingQuery, GetEventOfferingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventOfferingQuery, GetEventOfferingQueryVariables>(GetEventOfferingDocument, options);
        }
export type GetEventOfferingQueryHookResult = ReturnType<typeof useGetEventOfferingQuery>;
export type GetEventOfferingLazyQueryHookResult = ReturnType<typeof useGetEventOfferingLazyQuery>;
export type GetEventOfferingSuspenseQueryHookResult = ReturnType<typeof useGetEventOfferingSuspenseQuery>;
export type GetEventOfferingQueryResult = Apollo.QueryResult<GetEventOfferingQuery, GetEventOfferingQueryVariables>;
export const GetEventOfferingsForServiceProviderDocument = gql`
    query GetEventOfferingsForServiceProvider($serviceProviderId: String) {
  getEventOfferingsForServiceProvider(serviceProviderId: $serviceProviderId) {
    id
    title
    description
    basePrice
    baseDuration
    type
    maxBookings
    serviceProviderId
    index
    serviceOfferingUids
    isPublished
  }
}
    `;

/**
 * __useGetEventOfferingsForServiceProviderQuery__
 *
 * To run a query within a React component, call `useGetEventOfferingsForServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventOfferingsForServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventOfferingsForServiceProviderQuery({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *   },
 * });
 */
export function useGetEventOfferingsForServiceProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetEventOfferingsForServiceProviderQuery, GetEventOfferingsForServiceProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventOfferingsForServiceProviderQuery, GetEventOfferingsForServiceProviderQueryVariables>(GetEventOfferingsForServiceProviderDocument, options);
      }
export function useGetEventOfferingsForServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventOfferingsForServiceProviderQuery, GetEventOfferingsForServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventOfferingsForServiceProviderQuery, GetEventOfferingsForServiceProviderQueryVariables>(GetEventOfferingsForServiceProviderDocument, options);
        }
export function useGetEventOfferingsForServiceProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventOfferingsForServiceProviderQuery, GetEventOfferingsForServiceProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventOfferingsForServiceProviderQuery, GetEventOfferingsForServiceProviderQueryVariables>(GetEventOfferingsForServiceProviderDocument, options);
        }
export type GetEventOfferingsForServiceProviderQueryHookResult = ReturnType<typeof useGetEventOfferingsForServiceProviderQuery>;
export type GetEventOfferingsForServiceProviderLazyQueryHookResult = ReturnType<typeof useGetEventOfferingsForServiceProviderLazyQuery>;
export type GetEventOfferingsForServiceProviderSuspenseQueryHookResult = ReturnType<typeof useGetEventOfferingsForServiceProviderSuspenseQuery>;
export type GetEventOfferingsForServiceProviderQueryResult = Apollo.QueryResult<GetEventOfferingsForServiceProviderQuery, GetEventOfferingsForServiceProviderQueryVariables>;
export const GetHasSquareLinkedDocument = gql`
    query GetHasSquareLinked {
  getHasSquareLinked
}
    `;

/**
 * __useGetHasSquareLinkedQuery__
 *
 * To run a query within a React component, call `useGetHasSquareLinkedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasSquareLinkedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasSquareLinkedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHasSquareLinkedQuery(baseOptions?: Apollo.QueryHookOptions<GetHasSquareLinkedQuery, GetHasSquareLinkedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHasSquareLinkedQuery, GetHasSquareLinkedQueryVariables>(GetHasSquareLinkedDocument, options);
      }
export function useGetHasSquareLinkedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHasSquareLinkedQuery, GetHasSquareLinkedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHasSquareLinkedQuery, GetHasSquareLinkedQueryVariables>(GetHasSquareLinkedDocument, options);
        }
export function useGetHasSquareLinkedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHasSquareLinkedQuery, GetHasSquareLinkedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHasSquareLinkedQuery, GetHasSquareLinkedQueryVariables>(GetHasSquareLinkedDocument, options);
        }
export type GetHasSquareLinkedQueryHookResult = ReturnType<typeof useGetHasSquareLinkedQuery>;
export type GetHasSquareLinkedLazyQueryHookResult = ReturnType<typeof useGetHasSquareLinkedLazyQuery>;
export type GetHasSquareLinkedSuspenseQueryHookResult = ReturnType<typeof useGetHasSquareLinkedSuspenseQuery>;
export type GetHasSquareLinkedQueryResult = Apollo.QueryResult<GetHasSquareLinkedQuery, GetHasSquareLinkedQueryVariables>;
export const GetIsGoogleCalendarLinkedDocument = gql`
    query GetIsGoogleCalendarLinked {
  getIsGoogleCalendarLinked
}
    `;

/**
 * __useGetIsGoogleCalendarLinkedQuery__
 *
 * To run a query within a React component, call `useGetIsGoogleCalendarLinkedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsGoogleCalendarLinkedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsGoogleCalendarLinkedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsGoogleCalendarLinkedQuery(baseOptions?: Apollo.QueryHookOptions<GetIsGoogleCalendarLinkedQuery, GetIsGoogleCalendarLinkedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsGoogleCalendarLinkedQuery, GetIsGoogleCalendarLinkedQueryVariables>(GetIsGoogleCalendarLinkedDocument, options);
      }
export function useGetIsGoogleCalendarLinkedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsGoogleCalendarLinkedQuery, GetIsGoogleCalendarLinkedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsGoogleCalendarLinkedQuery, GetIsGoogleCalendarLinkedQueryVariables>(GetIsGoogleCalendarLinkedDocument, options);
        }
export function useGetIsGoogleCalendarLinkedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsGoogleCalendarLinkedQuery, GetIsGoogleCalendarLinkedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsGoogleCalendarLinkedQuery, GetIsGoogleCalendarLinkedQueryVariables>(GetIsGoogleCalendarLinkedDocument, options);
        }
export type GetIsGoogleCalendarLinkedQueryHookResult = ReturnType<typeof useGetIsGoogleCalendarLinkedQuery>;
export type GetIsGoogleCalendarLinkedLazyQueryHookResult = ReturnType<typeof useGetIsGoogleCalendarLinkedLazyQuery>;
export type GetIsGoogleCalendarLinkedSuspenseQueryHookResult = ReturnType<typeof useGetIsGoogleCalendarLinkedSuspenseQuery>;
export type GetIsGoogleCalendarLinkedQueryResult = Apollo.QueryResult<GetIsGoogleCalendarLinkedQuery, GetIsGoogleCalendarLinkedQueryVariables>;
export const GetLocationByIdDocument = gql`
    query GetLocationById($locationId: String!) {
  getLocationById(locationId: $locationId) {
    uid
    id
    formattedAddress
    phoneNumber
    streetAddress
    placeId
    type
    latitude
    longitude
    name
  }
}
    `;

/**
 * __useGetLocationByIdQuery__
 *
 * To run a query within a React component, call `useGetLocationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationByIdQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables> & ({ variables: GetLocationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationByIdQuery, GetLocationByIdQueryVariables>(GetLocationByIdDocument, options);
      }
export function useGetLocationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationByIdQuery, GetLocationByIdQueryVariables>(GetLocationByIdDocument, options);
        }
export function useGetLocationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationByIdQuery, GetLocationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationByIdQuery, GetLocationByIdQueryVariables>(GetLocationByIdDocument, options);
        }
export type GetLocationByIdQueryHookResult = ReturnType<typeof useGetLocationByIdQuery>;
export type GetLocationByIdLazyQueryHookResult = ReturnType<typeof useGetLocationByIdLazyQuery>;
export type GetLocationByIdSuspenseQueryHookResult = ReturnType<typeof useGetLocationByIdSuspenseQuery>;
export type GetLocationByIdQueryResult = Apollo.QueryResult<GetLocationByIdQuery, GetLocationByIdQueryVariables>;
export const GetLocationBySlugAndBusinessUidDocument = gql`
    query GetLocationBySlugAndBusinessUid($slug: String!, $businessUid: String!, $minStartDateTime: Int!) {
  getLocationBySlugAndBusinessUid(slug: $slug, businessUid: $businessUid) {
    id
    formattedAddress
    name
    externalUid
    ownerUid
    type
    phoneNumber
    uid
    slug
    files {
      uid
      index
      uploadedFile {
        publicUrl
        objectName
      }
    }
    appointments(
      query: {confirmedStatus: CONFIRMED, cancelledStatus: NOT_CANCELLED, completeStatus: INCOMPLETE, timeUtcSecondsBounds: {min: $minStartDateTime}}
    ) {
      startDateTime
      maxEndDateTime
      uid
      id
      isCoveredByBusiness
      bookingsWithSiblings {
        uid
        owner {
          fullName
        }
      }
      discountRuleProgress {
        progressPercent
        discountRule {
          label
          discountValue
          discountType
          priority
          requireDurationBookedSeconds
          requireBookingCount
        }
      }
      serviceProvider {
        ownerUid
        serviceType
        displayName
        averageRating
        serviceOfferings {
          uid
          title
          index
        }
        reviews {
          isLike
          isVerified
        }
        profile {
          displayName
          avatarImage {
            uploadedFile {
              publicUrl
            }
          }
          photoGallery {
            items {
              index
              imageFile {
                uploadedFile {
                  publicUrl
                }
              }
            }
          }
        }
        insuranceInformation {
          titlePrefix
          titleSuffix
        }
      }
      serviceArea {
        uid
        name
      }
      preferences {
        type
        value
      }
      eventOffering {
        id
        title
        description
        type
        baseDuration
        maxBookings
        attendanceServiceOffering {
          uid
          title
          basePrice
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocationBySlugAndBusinessUidQuery__
 *
 * To run a query within a React component, call `useGetLocationBySlugAndBusinessUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationBySlugAndBusinessUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationBySlugAndBusinessUidQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      businessUid: // value for 'businessUid'
 *      minStartDateTime: // value for 'minStartDateTime'
 *   },
 * });
 */
export function useGetLocationBySlugAndBusinessUidQuery(baseOptions: Apollo.QueryHookOptions<GetLocationBySlugAndBusinessUidQuery, GetLocationBySlugAndBusinessUidQueryVariables> & ({ variables: GetLocationBySlugAndBusinessUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationBySlugAndBusinessUidQuery, GetLocationBySlugAndBusinessUidQueryVariables>(GetLocationBySlugAndBusinessUidDocument, options);
      }
export function useGetLocationBySlugAndBusinessUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationBySlugAndBusinessUidQuery, GetLocationBySlugAndBusinessUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationBySlugAndBusinessUidQuery, GetLocationBySlugAndBusinessUidQueryVariables>(GetLocationBySlugAndBusinessUidDocument, options);
        }
export function useGetLocationBySlugAndBusinessUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationBySlugAndBusinessUidQuery, GetLocationBySlugAndBusinessUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationBySlugAndBusinessUidQuery, GetLocationBySlugAndBusinessUidQueryVariables>(GetLocationBySlugAndBusinessUidDocument, options);
        }
export type GetLocationBySlugAndBusinessUidQueryHookResult = ReturnType<typeof useGetLocationBySlugAndBusinessUidQuery>;
export type GetLocationBySlugAndBusinessUidLazyQueryHookResult = ReturnType<typeof useGetLocationBySlugAndBusinessUidLazyQuery>;
export type GetLocationBySlugAndBusinessUidSuspenseQueryHookResult = ReturnType<typeof useGetLocationBySlugAndBusinessUidSuspenseQuery>;
export type GetLocationBySlugAndBusinessUidQueryResult = Apollo.QueryResult<GetLocationBySlugAndBusinessUidQuery, GetLocationBySlugAndBusinessUidQueryVariables>;
export const GetLocationSubscriptionsWithUpcomingAppointmentsDocument = gql`
    query GetLocationSubscriptionsWithUpcomingAppointments($min: Int!, $serviceType: String!) {
  getLocationSubscriptions {
    location {
      id
      name
      extendedAddress
      formattedAddress
      uid
      appointments(
        query: {timeUtcSecondsBounds: {min: $min}}
        serviceType: $serviceType
      ) {
        startDateTime
        id
        bookingsWithSiblings {
          uid
          owner {
            fullName
          }
        }
        serviceProvider {
          displayName
          serviceType
        }
        discountRuleProgress {
          progressPercent
          discountRule {
            label
            discountValue
            discountType
            priority
            requireDurationBookedSeconds
            requireBookingCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocationSubscriptionsWithUpcomingAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetLocationSubscriptionsWithUpcomingAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationSubscriptionsWithUpcomingAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationSubscriptionsWithUpcomingAppointmentsQuery({
 *   variables: {
 *      min: // value for 'min'
 *      serviceType: // value for 'serviceType'
 *   },
 * });
 */
export function useGetLocationSubscriptionsWithUpcomingAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationSubscriptionsWithUpcomingAppointmentsQuery, GetLocationSubscriptionsWithUpcomingAppointmentsQueryVariables> & ({ variables: GetLocationSubscriptionsWithUpcomingAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationSubscriptionsWithUpcomingAppointmentsQuery, GetLocationSubscriptionsWithUpcomingAppointmentsQueryVariables>(GetLocationSubscriptionsWithUpcomingAppointmentsDocument, options);
      }
export function useGetLocationSubscriptionsWithUpcomingAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationSubscriptionsWithUpcomingAppointmentsQuery, GetLocationSubscriptionsWithUpcomingAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationSubscriptionsWithUpcomingAppointmentsQuery, GetLocationSubscriptionsWithUpcomingAppointmentsQueryVariables>(GetLocationSubscriptionsWithUpcomingAppointmentsDocument, options);
        }
export function useGetLocationSubscriptionsWithUpcomingAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationSubscriptionsWithUpcomingAppointmentsQuery, GetLocationSubscriptionsWithUpcomingAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationSubscriptionsWithUpcomingAppointmentsQuery, GetLocationSubscriptionsWithUpcomingAppointmentsQueryVariables>(GetLocationSubscriptionsWithUpcomingAppointmentsDocument, options);
        }
export type GetLocationSubscriptionsWithUpcomingAppointmentsQueryHookResult = ReturnType<typeof useGetLocationSubscriptionsWithUpcomingAppointmentsQuery>;
export type GetLocationSubscriptionsWithUpcomingAppointmentsLazyQueryHookResult = ReturnType<typeof useGetLocationSubscriptionsWithUpcomingAppointmentsLazyQuery>;
export type GetLocationSubscriptionsWithUpcomingAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetLocationSubscriptionsWithUpcomingAppointmentsSuspenseQuery>;
export type GetLocationSubscriptionsWithUpcomingAppointmentsQueryResult = Apollo.QueryResult<GetLocationSubscriptionsWithUpcomingAppointmentsQuery, GetLocationSubscriptionsWithUpcomingAppointmentsQueryVariables>;
export const GetLocationsForNavDocument = gql`
    query GetLocationsForNav {
  getLocations {
    id
    streetAddress
    placeId
    latitude
    longitude
  }
  getLocationSubscriptions {
    location {
      id
      streetAddress
      placeId
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetLocationsForNavQuery__
 *
 * To run a query within a React component, call `useGetLocationsForNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsForNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsForNavQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsForNavQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsForNavQuery, GetLocationsForNavQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsForNavQuery, GetLocationsForNavQueryVariables>(GetLocationsForNavDocument, options);
      }
export function useGetLocationsForNavLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsForNavQuery, GetLocationsForNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsForNavQuery, GetLocationsForNavQueryVariables>(GetLocationsForNavDocument, options);
        }
export function useGetLocationsForNavSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationsForNavQuery, GetLocationsForNavQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationsForNavQuery, GetLocationsForNavQueryVariables>(GetLocationsForNavDocument, options);
        }
export type GetLocationsForNavQueryHookResult = ReturnType<typeof useGetLocationsForNavQuery>;
export type GetLocationsForNavLazyQueryHookResult = ReturnType<typeof useGetLocationsForNavLazyQuery>;
export type GetLocationsForNavSuspenseQueryHookResult = ReturnType<typeof useGetLocationsForNavSuspenseQuery>;
export type GetLocationsForNavQueryResult = Apollo.QueryResult<GetLocationsForNavQuery, GetLocationsForNavQueryVariables>;
export const GetOptimalOpenTimeForServiceProviderForLatLngDocument = gql`
    query GetOptimalOpenTimeForServiceProviderForLatLng($dateUnix: Int!, $serviceProviderUid: String!, $lat: Float!, $lng: Float!) {
  getOptimalOpenTimeForServiceProviderForLatLng(
    dateUnix: $dateUnix
    serviceProviderUid: $serviceProviderUid
    lat: $lat
    lng: $lng
  )
}
    `;

/**
 * __useGetOptimalOpenTimeForServiceProviderForLatLngQuery__
 *
 * To run a query within a React component, call `useGetOptimalOpenTimeForServiceProviderForLatLngQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptimalOpenTimeForServiceProviderForLatLngQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptimalOpenTimeForServiceProviderForLatLngQuery({
 *   variables: {
 *      dateUnix: // value for 'dateUnix'
 *      serviceProviderUid: // value for 'serviceProviderUid'
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *   },
 * });
 */
export function useGetOptimalOpenTimeForServiceProviderForLatLngQuery(baseOptions: Apollo.QueryHookOptions<GetOptimalOpenTimeForServiceProviderForLatLngQuery, GetOptimalOpenTimeForServiceProviderForLatLngQueryVariables> & ({ variables: GetOptimalOpenTimeForServiceProviderForLatLngQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptimalOpenTimeForServiceProviderForLatLngQuery, GetOptimalOpenTimeForServiceProviderForLatLngQueryVariables>(GetOptimalOpenTimeForServiceProviderForLatLngDocument, options);
      }
export function useGetOptimalOpenTimeForServiceProviderForLatLngLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOptimalOpenTimeForServiceProviderForLatLngQuery, GetOptimalOpenTimeForServiceProviderForLatLngQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptimalOpenTimeForServiceProviderForLatLngQuery, GetOptimalOpenTimeForServiceProviderForLatLngQueryVariables>(GetOptimalOpenTimeForServiceProviderForLatLngDocument, options);
        }
export function useGetOptimalOpenTimeForServiceProviderForLatLngSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOptimalOpenTimeForServiceProviderForLatLngQuery, GetOptimalOpenTimeForServiceProviderForLatLngQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOptimalOpenTimeForServiceProviderForLatLngQuery, GetOptimalOpenTimeForServiceProviderForLatLngQueryVariables>(GetOptimalOpenTimeForServiceProviderForLatLngDocument, options);
        }
export type GetOptimalOpenTimeForServiceProviderForLatLngQueryHookResult = ReturnType<typeof useGetOptimalOpenTimeForServiceProviderForLatLngQuery>;
export type GetOptimalOpenTimeForServiceProviderForLatLngLazyQueryHookResult = ReturnType<typeof useGetOptimalOpenTimeForServiceProviderForLatLngLazyQuery>;
export type GetOptimalOpenTimeForServiceProviderForLatLngSuspenseQueryHookResult = ReturnType<typeof useGetOptimalOpenTimeForServiceProviderForLatLngSuspenseQuery>;
export type GetOptimalOpenTimeForServiceProviderForLatLngQueryResult = Apollo.QueryResult<GetOptimalOpenTimeForServiceProviderForLatLngQuery, GetOptimalOpenTimeForServiceProviderForLatLngQueryVariables>;
export const GetOptimalOpenTimeForServiceProviderForLocationDocument = gql`
    query GetOptimalOpenTimeForServiceProviderForLocation($dateUnix: Int!, $serviceProviderUid: String!, $locationId: String!) {
  getOptimalOpenTimeForServiceProviderForLocation(
    dateUnix: $dateUnix
    serviceProviderUid: $serviceProviderUid
    locationId: $locationId
  )
}
    `;

/**
 * __useGetOptimalOpenTimeForServiceProviderForLocationQuery__
 *
 * To run a query within a React component, call `useGetOptimalOpenTimeForServiceProviderForLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptimalOpenTimeForServiceProviderForLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptimalOpenTimeForServiceProviderForLocationQuery({
 *   variables: {
 *      dateUnix: // value for 'dateUnix'
 *      serviceProviderUid: // value for 'serviceProviderUid'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetOptimalOpenTimeForServiceProviderForLocationQuery(baseOptions: Apollo.QueryHookOptions<GetOptimalOpenTimeForServiceProviderForLocationQuery, GetOptimalOpenTimeForServiceProviderForLocationQueryVariables> & ({ variables: GetOptimalOpenTimeForServiceProviderForLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptimalOpenTimeForServiceProviderForLocationQuery, GetOptimalOpenTimeForServiceProviderForLocationQueryVariables>(GetOptimalOpenTimeForServiceProviderForLocationDocument, options);
      }
export function useGetOptimalOpenTimeForServiceProviderForLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOptimalOpenTimeForServiceProviderForLocationQuery, GetOptimalOpenTimeForServiceProviderForLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptimalOpenTimeForServiceProviderForLocationQuery, GetOptimalOpenTimeForServiceProviderForLocationQueryVariables>(GetOptimalOpenTimeForServiceProviderForLocationDocument, options);
        }
export function useGetOptimalOpenTimeForServiceProviderForLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOptimalOpenTimeForServiceProviderForLocationQuery, GetOptimalOpenTimeForServiceProviderForLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOptimalOpenTimeForServiceProviderForLocationQuery, GetOptimalOpenTimeForServiceProviderForLocationQueryVariables>(GetOptimalOpenTimeForServiceProviderForLocationDocument, options);
        }
export type GetOptimalOpenTimeForServiceProviderForLocationQueryHookResult = ReturnType<typeof useGetOptimalOpenTimeForServiceProviderForLocationQuery>;
export type GetOptimalOpenTimeForServiceProviderForLocationLazyQueryHookResult = ReturnType<typeof useGetOptimalOpenTimeForServiceProviderForLocationLazyQuery>;
export type GetOptimalOpenTimeForServiceProviderForLocationSuspenseQueryHookResult = ReturnType<typeof useGetOptimalOpenTimeForServiceProviderForLocationSuspenseQuery>;
export type GetOptimalOpenTimeForServiceProviderForLocationQueryResult = Apollo.QueryResult<GetOptimalOpenTimeForServiceProviderForLocationQuery, GetOptimalOpenTimeForServiceProviderForLocationQueryVariables>;
export const GetOrInitializeEventCartDocument = gql`
    mutation GetOrInitializeEventCart($serviceProviderId: String!, $locationUid: String!) {
  getOrInitializeEventCart(
    serviceProviderId: $serviceProviderId
    locationUid: $locationUid
  ) {
    id
    startDateTime
    eventEndDateTime
    enabledServiceOfferingUids
    note
    serviceAreaUid
    isCoveredByBusiness
    locationUid
    serviceProvider {
      displayName
      ownerUid
      serviceType
      serviceOfferings {
        uid
        basePrice
        baseTime
        title
        type
      }
      serviceOfferingCategories {
        ...serviceOfferingCategoryFields
      }
      dateAvailability {
        date
        timezone
        ownerUid
        availability {
          timeUtcSecondsBounds {
            min
            max
          }
        }
      }
      dayOfWeekAvailability {
        dayOfWeek
        timezone
        ownerUid
        availability {
          timeUtcSecondsBounds {
            min
            max
          }
        }
      }
    }
    enabledServiceOfferings {
      title
      basePrice
      baseTime
      uid
    }
  }
}
    ${ServiceOfferingCategoryFieldsFragmentDoc}`;
export type GetOrInitializeEventCartMutationFn = Apollo.MutationFunction<GetOrInitializeEventCartMutation, GetOrInitializeEventCartMutationVariables>;

/**
 * __useGetOrInitializeEventCartMutation__
 *
 * To run a mutation, you first call `useGetOrInitializeEventCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrInitializeEventCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrInitializeEventCartMutation, { data, loading, error }] = useGetOrInitializeEventCartMutation({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *      locationUid: // value for 'locationUid'
 *   },
 * });
 */
export function useGetOrInitializeEventCartMutation(baseOptions?: Apollo.MutationHookOptions<GetOrInitializeEventCartMutation, GetOrInitializeEventCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrInitializeEventCartMutation, GetOrInitializeEventCartMutationVariables>(GetOrInitializeEventCartDocument, options);
      }
export type GetOrInitializeEventCartMutationHookResult = ReturnType<typeof useGetOrInitializeEventCartMutation>;
export type GetOrInitializeEventCartMutationResult = Apollo.MutationResult<GetOrInitializeEventCartMutation>;
export type GetOrInitializeEventCartMutationOptions = Apollo.BaseMutationOptions<GetOrInitializeEventCartMutation, GetOrInitializeEventCartMutationVariables>;
export const GetPaymentMethodsForCustomerDocument = gql`
    query GetPaymentMethodsForCustomer($customerId: String!) {
  getPaymentMethodsForCustomer(customerId: $customerId) {
    brand
    lastFour
    expMonth
    expYear
    id
  }
}
    `;

/**
 * __useGetPaymentMethodsForCustomerQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsForCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPaymentMethodsForCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodsForCustomerQuery, GetPaymentMethodsForCustomerQueryVariables> & ({ variables: GetPaymentMethodsForCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsForCustomerQuery, GetPaymentMethodsForCustomerQueryVariables>(GetPaymentMethodsForCustomerDocument, options);
      }
export function useGetPaymentMethodsForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsForCustomerQuery, GetPaymentMethodsForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsForCustomerQuery, GetPaymentMethodsForCustomerQueryVariables>(GetPaymentMethodsForCustomerDocument, options);
        }
export function useGetPaymentMethodsForCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsForCustomerQuery, GetPaymentMethodsForCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsForCustomerQuery, GetPaymentMethodsForCustomerQueryVariables>(GetPaymentMethodsForCustomerDocument, options);
        }
export type GetPaymentMethodsForCustomerQueryHookResult = ReturnType<typeof useGetPaymentMethodsForCustomerQuery>;
export type GetPaymentMethodsForCustomerLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsForCustomerLazyQuery>;
export type GetPaymentMethodsForCustomerSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsForCustomerSuspenseQuery>;
export type GetPaymentMethodsForCustomerQueryResult = Apollo.QueryResult<GetPaymentMethodsForCustomerQuery, GetPaymentMethodsForCustomerQueryVariables>;
export const GetPeazyPluginInstallationDocument = gql`
    query GetPeazyPluginInstallation($id: ID!) {
  getPeazyPluginInstallationById(id: $id) {
    id
    pluginListing {
      id
      name
      description
      iconURL
    }
    isDisabled
    createdAt
    updatedAt
    configurationData
  }
}
    `;

/**
 * __useGetPeazyPluginInstallationQuery__
 *
 * To run a query within a React component, call `useGetPeazyPluginInstallationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeazyPluginInstallationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeazyPluginInstallationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPeazyPluginInstallationQuery(baseOptions: Apollo.QueryHookOptions<GetPeazyPluginInstallationQuery, GetPeazyPluginInstallationQueryVariables> & ({ variables: GetPeazyPluginInstallationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPeazyPluginInstallationQuery, GetPeazyPluginInstallationQueryVariables>(GetPeazyPluginInstallationDocument, options);
      }
export function useGetPeazyPluginInstallationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPeazyPluginInstallationQuery, GetPeazyPluginInstallationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPeazyPluginInstallationQuery, GetPeazyPluginInstallationQueryVariables>(GetPeazyPluginInstallationDocument, options);
        }
export function useGetPeazyPluginInstallationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPeazyPluginInstallationQuery, GetPeazyPluginInstallationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPeazyPluginInstallationQuery, GetPeazyPluginInstallationQueryVariables>(GetPeazyPluginInstallationDocument, options);
        }
export type GetPeazyPluginInstallationQueryHookResult = ReturnType<typeof useGetPeazyPluginInstallationQuery>;
export type GetPeazyPluginInstallationLazyQueryHookResult = ReturnType<typeof useGetPeazyPluginInstallationLazyQuery>;
export type GetPeazyPluginInstallationSuspenseQueryHookResult = ReturnType<typeof useGetPeazyPluginInstallationSuspenseQuery>;
export type GetPeazyPluginInstallationQueryResult = Apollo.QueryResult<GetPeazyPluginInstallationQuery, GetPeazyPluginInstallationQueryVariables>;
export const GetPublicCustomerProfileFieldsDocument = gql`
    query GetPublicCustomerProfileFields($serviceProviderId: String!) {
  getPublicCustomerProfileFieldsForServiceProvider(
    serviceProviderId: $serviceProviderId
  ) {
    id
    title
    description
    serviceProviderId
    type
    options {
      id
      value
    }
  }
}
    `;

/**
 * __useGetPublicCustomerProfileFieldsQuery__
 *
 * To run a query within a React component, call `useGetPublicCustomerProfileFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicCustomerProfileFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicCustomerProfileFieldsQuery({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *   },
 * });
 */
export function useGetPublicCustomerProfileFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetPublicCustomerProfileFieldsQuery, GetPublicCustomerProfileFieldsQueryVariables> & ({ variables: GetPublicCustomerProfileFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicCustomerProfileFieldsQuery, GetPublicCustomerProfileFieldsQueryVariables>(GetPublicCustomerProfileFieldsDocument, options);
      }
export function useGetPublicCustomerProfileFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicCustomerProfileFieldsQuery, GetPublicCustomerProfileFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicCustomerProfileFieldsQuery, GetPublicCustomerProfileFieldsQueryVariables>(GetPublicCustomerProfileFieldsDocument, options);
        }
export function useGetPublicCustomerProfileFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicCustomerProfileFieldsQuery, GetPublicCustomerProfileFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicCustomerProfileFieldsQuery, GetPublicCustomerProfileFieldsQueryVariables>(GetPublicCustomerProfileFieldsDocument, options);
        }
export type GetPublicCustomerProfileFieldsQueryHookResult = ReturnType<typeof useGetPublicCustomerProfileFieldsQuery>;
export type GetPublicCustomerProfileFieldsLazyQueryHookResult = ReturnType<typeof useGetPublicCustomerProfileFieldsLazyQuery>;
export type GetPublicCustomerProfileFieldsSuspenseQueryHookResult = ReturnType<typeof useGetPublicCustomerProfileFieldsSuspenseQuery>;
export type GetPublicCustomerProfileFieldsQueryResult = Apollo.QueryResult<GetPublicCustomerProfileFieldsQuery, GetPublicCustomerProfileFieldsQueryVariables>;
export const GetReceiptConfigForServiceProviderDocument = gql`
    query GetReceiptConfigForServiceProvider {
  getReceiptConfigForServiceProvider {
    id
    serviceProviderId
    headerTextTemplate
    finePrint
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetReceiptConfigForServiceProviderQuery__
 *
 * To run a query within a React component, call `useGetReceiptConfigForServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptConfigForServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptConfigForServiceProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReceiptConfigForServiceProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetReceiptConfigForServiceProviderQuery, GetReceiptConfigForServiceProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiptConfigForServiceProviderQuery, GetReceiptConfigForServiceProviderQueryVariables>(GetReceiptConfigForServiceProviderDocument, options);
      }
export function useGetReceiptConfigForServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptConfigForServiceProviderQuery, GetReceiptConfigForServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiptConfigForServiceProviderQuery, GetReceiptConfigForServiceProviderQueryVariables>(GetReceiptConfigForServiceProviderDocument, options);
        }
export function useGetReceiptConfigForServiceProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReceiptConfigForServiceProviderQuery, GetReceiptConfigForServiceProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReceiptConfigForServiceProviderQuery, GetReceiptConfigForServiceProviderQueryVariables>(GetReceiptConfigForServiceProviderDocument, options);
        }
export type GetReceiptConfigForServiceProviderQueryHookResult = ReturnType<typeof useGetReceiptConfigForServiceProviderQuery>;
export type GetReceiptConfigForServiceProviderLazyQueryHookResult = ReturnType<typeof useGetReceiptConfigForServiceProviderLazyQuery>;
export type GetReceiptConfigForServiceProviderSuspenseQueryHookResult = ReturnType<typeof useGetReceiptConfigForServiceProviderSuspenseQuery>;
export type GetReceiptConfigForServiceProviderQueryResult = Apollo.QueryResult<GetReceiptConfigForServiceProviderQuery, GetReceiptConfigForServiceProviderQueryVariables>;
export const GetResetPasswordLinkDocument = gql`
    mutation GetResetPasswordLink($returnTo: String!) {
  getResetPasswordLink(returnTo: $returnTo)
}
    `;
export type GetResetPasswordLinkMutationFn = Apollo.MutationFunction<GetResetPasswordLinkMutation, GetResetPasswordLinkMutationVariables>;

/**
 * __useGetResetPasswordLinkMutation__
 *
 * To run a mutation, you first call `useGetResetPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetResetPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getResetPasswordLinkMutation, { data, loading, error }] = useGetResetPasswordLinkMutation({
 *   variables: {
 *      returnTo: // value for 'returnTo'
 *   },
 * });
 */
export function useGetResetPasswordLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetResetPasswordLinkMutation, GetResetPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetResetPasswordLinkMutation, GetResetPasswordLinkMutationVariables>(GetResetPasswordLinkDocument, options);
      }
export type GetResetPasswordLinkMutationHookResult = ReturnType<typeof useGetResetPasswordLinkMutation>;
export type GetResetPasswordLinkMutationResult = Apollo.MutationResult<GetResetPasswordLinkMutation>;
export type GetResetPasswordLinkMutationOptions = Apollo.BaseMutationOptions<GetResetPasswordLinkMutation, GetResetPasswordLinkMutationVariables>;
export const GetServiceAreaDocument = gql`
    query GetServiceArea($serviceAreaUid: String!) {
  getServiceArea(serviceAreaUid: $serviceAreaUid) {
    uid
    name
    description
    files {
      uploadedFile {
        publicUrl
      }
    }
  }
}
    `;

/**
 * __useGetServiceAreaQuery__
 *
 * To run a query within a React component, call `useGetServiceAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceAreaQuery({
 *   variables: {
 *      serviceAreaUid: // value for 'serviceAreaUid'
 *   },
 * });
 */
export function useGetServiceAreaQuery(baseOptions: Apollo.QueryHookOptions<GetServiceAreaQuery, GetServiceAreaQueryVariables> & ({ variables: GetServiceAreaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceAreaQuery, GetServiceAreaQueryVariables>(GetServiceAreaDocument, options);
      }
export function useGetServiceAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceAreaQuery, GetServiceAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceAreaQuery, GetServiceAreaQueryVariables>(GetServiceAreaDocument, options);
        }
export function useGetServiceAreaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceAreaQuery, GetServiceAreaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceAreaQuery, GetServiceAreaQueryVariables>(GetServiceAreaDocument, options);
        }
export type GetServiceAreaQueryHookResult = ReturnType<typeof useGetServiceAreaQuery>;
export type GetServiceAreaLazyQueryHookResult = ReturnType<typeof useGetServiceAreaLazyQuery>;
export type GetServiceAreaSuspenseQueryHookResult = ReturnType<typeof useGetServiceAreaSuspenseQuery>;
export type GetServiceAreaQueryResult = Apollo.QueryResult<GetServiceAreaQuery, GetServiceAreaQueryVariables>;
export const GetServiceAreasByLocationUidWithFilesDocument = gql`
    query GetServiceAreasByLocationUidWithFiles($locationUid: String!) {
  getServiceAreasByLocationUid(locationUids: [$locationUid]) {
    name
    description
    uid
    files {
      label
      uploadedFile {
        publicUrl
      }
    }
  }
}
    `;

/**
 * __useGetServiceAreasByLocationUidWithFilesQuery__
 *
 * To run a query within a React component, call `useGetServiceAreasByLocationUidWithFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceAreasByLocationUidWithFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceAreasByLocationUidWithFilesQuery({
 *   variables: {
 *      locationUid: // value for 'locationUid'
 *   },
 * });
 */
export function useGetServiceAreasByLocationUidWithFilesQuery(baseOptions: Apollo.QueryHookOptions<GetServiceAreasByLocationUidWithFilesQuery, GetServiceAreasByLocationUidWithFilesQueryVariables> & ({ variables: GetServiceAreasByLocationUidWithFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceAreasByLocationUidWithFilesQuery, GetServiceAreasByLocationUidWithFilesQueryVariables>(GetServiceAreasByLocationUidWithFilesDocument, options);
      }
export function useGetServiceAreasByLocationUidWithFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceAreasByLocationUidWithFilesQuery, GetServiceAreasByLocationUidWithFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceAreasByLocationUidWithFilesQuery, GetServiceAreasByLocationUidWithFilesQueryVariables>(GetServiceAreasByLocationUidWithFilesDocument, options);
        }
export function useGetServiceAreasByLocationUidWithFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceAreasByLocationUidWithFilesQuery, GetServiceAreasByLocationUidWithFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceAreasByLocationUidWithFilesQuery, GetServiceAreasByLocationUidWithFilesQueryVariables>(GetServiceAreasByLocationUidWithFilesDocument, options);
        }
export type GetServiceAreasByLocationUidWithFilesQueryHookResult = ReturnType<typeof useGetServiceAreasByLocationUidWithFilesQuery>;
export type GetServiceAreasByLocationUidWithFilesLazyQueryHookResult = ReturnType<typeof useGetServiceAreasByLocationUidWithFilesLazyQuery>;
export type GetServiceAreasByLocationUidWithFilesSuspenseQueryHookResult = ReturnType<typeof useGetServiceAreasByLocationUidWithFilesSuspenseQuery>;
export type GetServiceAreasByLocationUidWithFilesQueryResult = Apollo.QueryResult<GetServiceAreasByLocationUidWithFilesQuery, GetServiceAreasByLocationUidWithFilesQueryVariables>;
export const GetServiceAreasDocument = gql`
    query GetServiceAreas($uids: [String!]!) {
  getServiceAreas(internalUids: $uids) {
    uid
    name
    description
    externalUid
    size
    files {
      uid
      externalUid
      label
      uploadedFile {
        objectName
        publicUrl
      }
    }
  }
}
    `;

/**
 * __useGetServiceAreasQuery__
 *
 * To run a query within a React component, call `useGetServiceAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceAreasQuery({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useGetServiceAreasQuery(baseOptions: Apollo.QueryHookOptions<GetServiceAreasQuery, GetServiceAreasQueryVariables> & ({ variables: GetServiceAreasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceAreasQuery, GetServiceAreasQueryVariables>(GetServiceAreasDocument, options);
      }
export function useGetServiceAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceAreasQuery, GetServiceAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceAreasQuery, GetServiceAreasQueryVariables>(GetServiceAreasDocument, options);
        }
export function useGetServiceAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceAreasQuery, GetServiceAreasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceAreasQuery, GetServiceAreasQueryVariables>(GetServiceAreasDocument, options);
        }
export type GetServiceAreasQueryHookResult = ReturnType<typeof useGetServiceAreasQuery>;
export type GetServiceAreasLazyQueryHookResult = ReturnType<typeof useGetServiceAreasLazyQuery>;
export type GetServiceAreasSuspenseQueryHookResult = ReturnType<typeof useGetServiceAreasSuspenseQuery>;
export type GetServiceAreasQueryResult = Apollo.QueryResult<GetServiceAreasQuery, GetServiceAreasQueryVariables>;
export const GetServiceAreasByLocationUidDocument = gql`
    query GetServiceAreasByLocationUid($locationUid: String!) {
  getServiceAreasByLocationUid(locationUids: [$locationUid]) {
    uid
    name
  }
}
    `;

/**
 * __useGetServiceAreasByLocationUidQuery__
 *
 * To run a query within a React component, call `useGetServiceAreasByLocationUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceAreasByLocationUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceAreasByLocationUidQuery({
 *   variables: {
 *      locationUid: // value for 'locationUid'
 *   },
 * });
 */
export function useGetServiceAreasByLocationUidQuery(baseOptions: Apollo.QueryHookOptions<GetServiceAreasByLocationUidQuery, GetServiceAreasByLocationUidQueryVariables> & ({ variables: GetServiceAreasByLocationUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceAreasByLocationUidQuery, GetServiceAreasByLocationUidQueryVariables>(GetServiceAreasByLocationUidDocument, options);
      }
export function useGetServiceAreasByLocationUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceAreasByLocationUidQuery, GetServiceAreasByLocationUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceAreasByLocationUidQuery, GetServiceAreasByLocationUidQueryVariables>(GetServiceAreasByLocationUidDocument, options);
        }
export function useGetServiceAreasByLocationUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceAreasByLocationUidQuery, GetServiceAreasByLocationUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceAreasByLocationUidQuery, GetServiceAreasByLocationUidQueryVariables>(GetServiceAreasByLocationUidDocument, options);
        }
export type GetServiceAreasByLocationUidQueryHookResult = ReturnType<typeof useGetServiceAreasByLocationUidQuery>;
export type GetServiceAreasByLocationUidLazyQueryHookResult = ReturnType<typeof useGetServiceAreasByLocationUidLazyQuery>;
export type GetServiceAreasByLocationUidSuspenseQueryHookResult = ReturnType<typeof useGetServiceAreasByLocationUidSuspenseQuery>;
export type GetServiceAreasByLocationUidQueryResult = Apollo.QueryResult<GetServiceAreasByLocationUidQuery, GetServiceAreasByLocationUidQueryVariables>;
export const GetServiceOfferingsAndEventOfferingsDocument = gql`
    query GetServiceOfferingsAndEventOfferings {
  getThisServiceProvider {
    eventOfferings {
      id
      title
      description
      basePrice
      baseDuration
      type
      maxBookings
      serviceProviderId
      index
      serviceOfferingUids
      isPublished
    }
    serviceOfferings {
      title
      uid
    }
  }
}
    `;

/**
 * __useGetServiceOfferingsAndEventOfferingsQuery__
 *
 * To run a query within a React component, call `useGetServiceOfferingsAndEventOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceOfferingsAndEventOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceOfferingsAndEventOfferingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiceOfferingsAndEventOfferingsQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceOfferingsAndEventOfferingsQuery, GetServiceOfferingsAndEventOfferingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceOfferingsAndEventOfferingsQuery, GetServiceOfferingsAndEventOfferingsQueryVariables>(GetServiceOfferingsAndEventOfferingsDocument, options);
      }
export function useGetServiceOfferingsAndEventOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceOfferingsAndEventOfferingsQuery, GetServiceOfferingsAndEventOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceOfferingsAndEventOfferingsQuery, GetServiceOfferingsAndEventOfferingsQueryVariables>(GetServiceOfferingsAndEventOfferingsDocument, options);
        }
export function useGetServiceOfferingsAndEventOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOfferingsAndEventOfferingsQuery, GetServiceOfferingsAndEventOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceOfferingsAndEventOfferingsQuery, GetServiceOfferingsAndEventOfferingsQueryVariables>(GetServiceOfferingsAndEventOfferingsDocument, options);
        }
export type GetServiceOfferingsAndEventOfferingsQueryHookResult = ReturnType<typeof useGetServiceOfferingsAndEventOfferingsQuery>;
export type GetServiceOfferingsAndEventOfferingsLazyQueryHookResult = ReturnType<typeof useGetServiceOfferingsAndEventOfferingsLazyQuery>;
export type GetServiceOfferingsAndEventOfferingsSuspenseQueryHookResult = ReturnType<typeof useGetServiceOfferingsAndEventOfferingsSuspenseQuery>;
export type GetServiceOfferingsAndEventOfferingsQueryResult = Apollo.QueryResult<GetServiceOfferingsAndEventOfferingsQuery, GetServiceOfferingsAndEventOfferingsQueryVariables>;
export const GetServiceOfferingsForServiceProviderDocument = gql`
    query GetServiceOfferingsForServiceProvider($serviceProviderUid: String) {
  getServiceOfferingsForServiceProvider(serviceProviderUid: $serviceProviderUid) {
    title
    imageUrl
    basePrice
    baseTime
    uid
    shortDesc
    type
    maxConcurrentBookings
    allowTip
    index
    postServiceNote
    isHidden
  }
}
    `;

/**
 * __useGetServiceOfferingsForServiceProviderQuery__
 *
 * To run a query within a React component, call `useGetServiceOfferingsForServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceOfferingsForServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceOfferingsForServiceProviderQuery({
 *   variables: {
 *      serviceProviderUid: // value for 'serviceProviderUid'
 *   },
 * });
 */
export function useGetServiceOfferingsForServiceProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceOfferingsForServiceProviderQuery, GetServiceOfferingsForServiceProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceOfferingsForServiceProviderQuery, GetServiceOfferingsForServiceProviderQueryVariables>(GetServiceOfferingsForServiceProviderDocument, options);
      }
export function useGetServiceOfferingsForServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceOfferingsForServiceProviderQuery, GetServiceOfferingsForServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceOfferingsForServiceProviderQuery, GetServiceOfferingsForServiceProviderQueryVariables>(GetServiceOfferingsForServiceProviderDocument, options);
        }
export function useGetServiceOfferingsForServiceProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceOfferingsForServiceProviderQuery, GetServiceOfferingsForServiceProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceOfferingsForServiceProviderQuery, GetServiceOfferingsForServiceProviderQueryVariables>(GetServiceOfferingsForServiceProviderDocument, options);
        }
export type GetServiceOfferingsForServiceProviderQueryHookResult = ReturnType<typeof useGetServiceOfferingsForServiceProviderQuery>;
export type GetServiceOfferingsForServiceProviderLazyQueryHookResult = ReturnType<typeof useGetServiceOfferingsForServiceProviderLazyQuery>;
export type GetServiceOfferingsForServiceProviderSuspenseQueryHookResult = ReturnType<typeof useGetServiceOfferingsForServiceProviderSuspenseQuery>;
export type GetServiceOfferingsForServiceProviderQueryResult = Apollo.QueryResult<GetServiceOfferingsForServiceProviderQuery, GetServiceOfferingsForServiceProviderQueryVariables>;
export const GetAppointmentsForServiceProviderAtSelectedLocationDocument = gql`
    query GetAppointmentsForServiceProviderAtSelectedLocation($userUid: String, $query: AppointmentQuery) {
  getAppointmentsForUser(userUid: $userUid, query: $query) {
    id
    uid
    startDateTime
    location {
      uid
      id
      placeId
    }
  }
}
    `;

/**
 * __useGetAppointmentsForServiceProviderAtSelectedLocationQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsForServiceProviderAtSelectedLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsForServiceProviderAtSelectedLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsForServiceProviderAtSelectedLocationQuery({
 *   variables: {
 *      userUid: // value for 'userUid'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAppointmentsForServiceProviderAtSelectedLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsForServiceProviderAtSelectedLocationQuery, GetAppointmentsForServiceProviderAtSelectedLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsForServiceProviderAtSelectedLocationQuery, GetAppointmentsForServiceProviderAtSelectedLocationQueryVariables>(GetAppointmentsForServiceProviderAtSelectedLocationDocument, options);
      }
export function useGetAppointmentsForServiceProviderAtSelectedLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsForServiceProviderAtSelectedLocationQuery, GetAppointmentsForServiceProviderAtSelectedLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsForServiceProviderAtSelectedLocationQuery, GetAppointmentsForServiceProviderAtSelectedLocationQueryVariables>(GetAppointmentsForServiceProviderAtSelectedLocationDocument, options);
        }
export function useGetAppointmentsForServiceProviderAtSelectedLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentsForServiceProviderAtSelectedLocationQuery, GetAppointmentsForServiceProviderAtSelectedLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsForServiceProviderAtSelectedLocationQuery, GetAppointmentsForServiceProviderAtSelectedLocationQueryVariables>(GetAppointmentsForServiceProviderAtSelectedLocationDocument, options);
        }
export type GetAppointmentsForServiceProviderAtSelectedLocationQueryHookResult = ReturnType<typeof useGetAppointmentsForServiceProviderAtSelectedLocationQuery>;
export type GetAppointmentsForServiceProviderAtSelectedLocationLazyQueryHookResult = ReturnType<typeof useGetAppointmentsForServiceProviderAtSelectedLocationLazyQuery>;
export type GetAppointmentsForServiceProviderAtSelectedLocationSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsForServiceProviderAtSelectedLocationSuspenseQuery>;
export type GetAppointmentsForServiceProviderAtSelectedLocationQueryResult = Apollo.QueryResult<GetAppointmentsForServiceProviderAtSelectedLocationQuery, GetAppointmentsForServiceProviderAtSelectedLocationQueryVariables>;
export const GetServiceProviderAppointmentsCountDocument = gql`
    query GetServiceProviderAppointmentsCount($userUid: String!, $query: AppointmentQuery) {
  getAppointmentsForUser(userUid: $userUid, query: $query) {
    uid
  }
}
    `;

/**
 * __useGetServiceProviderAppointmentsCountQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderAppointmentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderAppointmentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderAppointmentsCountQuery({
 *   variables: {
 *      userUid: // value for 'userUid'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetServiceProviderAppointmentsCountQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderAppointmentsCountQuery, GetServiceProviderAppointmentsCountQueryVariables> & ({ variables: GetServiceProviderAppointmentsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderAppointmentsCountQuery, GetServiceProviderAppointmentsCountQueryVariables>(GetServiceProviderAppointmentsCountDocument, options);
      }
export function useGetServiceProviderAppointmentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderAppointmentsCountQuery, GetServiceProviderAppointmentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderAppointmentsCountQuery, GetServiceProviderAppointmentsCountQueryVariables>(GetServiceProviderAppointmentsCountDocument, options);
        }
export function useGetServiceProviderAppointmentsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderAppointmentsCountQuery, GetServiceProviderAppointmentsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderAppointmentsCountQuery, GetServiceProviderAppointmentsCountQueryVariables>(GetServiceProviderAppointmentsCountDocument, options);
        }
export type GetServiceProviderAppointmentsCountQueryHookResult = ReturnType<typeof useGetServiceProviderAppointmentsCountQuery>;
export type GetServiceProviderAppointmentsCountLazyQueryHookResult = ReturnType<typeof useGetServiceProviderAppointmentsCountLazyQuery>;
export type GetServiceProviderAppointmentsCountSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderAppointmentsCountSuspenseQuery>;
export type GetServiceProviderAppointmentsCountQueryResult = Apollo.QueryResult<GetServiceProviderAppointmentsCountQuery, GetServiceProviderAppointmentsCountQueryVariables>;
export const GetServiceProviderByIdWithPreferencesDocument = gql`
    query GetServiceProviderByIdWithPreferences($id: String!) {
  getServiceProviderById(id: $id) {
    serviceType
    id
    displayName
    averageRating
    reviewCount
    reviews {
      uid
      createdAt
      isLike
      text
      owner {
        fullName
      }
      isExternal
      externalAuthor
    }
    user {
      id
      uid
    }
    profile {
      ...profileFragment
    }
    serviceOfferings {
      uid
      basePrice
      baseTime
      title
      type
    }
    serviceOfferingCategories {
      ...serviceOfferingCategoryFields
    }
    dayOfWeekAvailability {
      dayOfWeek
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    preferences {
      id
      type
      value
    }
    location {
      id
      formattedAddress
      phoneNumber
      discoverableBounds {
        min {
          lat
          lng
        }
        max {
          lat
          lng
        }
      }
    }
  }
}
    ${ProfileFragmentFragmentDoc}
${ServiceOfferingCategoryFieldsFragmentDoc}`;

/**
 * __useGetServiceProviderByIdWithPreferencesQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderByIdWithPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderByIdWithPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderByIdWithPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceProviderByIdWithPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderByIdWithPreferencesQuery, GetServiceProviderByIdWithPreferencesQueryVariables> & ({ variables: GetServiceProviderByIdWithPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderByIdWithPreferencesQuery, GetServiceProviderByIdWithPreferencesQueryVariables>(GetServiceProviderByIdWithPreferencesDocument, options);
      }
export function useGetServiceProviderByIdWithPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderByIdWithPreferencesQuery, GetServiceProviderByIdWithPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderByIdWithPreferencesQuery, GetServiceProviderByIdWithPreferencesQueryVariables>(GetServiceProviderByIdWithPreferencesDocument, options);
        }
export function useGetServiceProviderByIdWithPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderByIdWithPreferencesQuery, GetServiceProviderByIdWithPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderByIdWithPreferencesQuery, GetServiceProviderByIdWithPreferencesQueryVariables>(GetServiceProviderByIdWithPreferencesDocument, options);
        }
export type GetServiceProviderByIdWithPreferencesQueryHookResult = ReturnType<typeof useGetServiceProviderByIdWithPreferencesQuery>;
export type GetServiceProviderByIdWithPreferencesLazyQueryHookResult = ReturnType<typeof useGetServiceProviderByIdWithPreferencesLazyQuery>;
export type GetServiceProviderByIdWithPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderByIdWithPreferencesSuspenseQuery>;
export type GetServiceProviderByIdWithPreferencesQueryResult = Apollo.QueryResult<GetServiceProviderByIdWithPreferencesQuery, GetServiceProviderByIdWithPreferencesQueryVariables>;
export const GetServiceProviderByIdDocument = gql`
    query GetServiceProviderById($serviceProviderId: String!) {
  getServiceProviderById(id: $serviceProviderId) {
    id
    serviceType
    displayName
    averageRating
    reviewCount
    reviews {
      uid
      createdAt
      isLike
      text
      owner {
        fullName
      }
      isExternal
      externalAuthor
    }
    user {
      id
    }
    profile {
      ...profileFragment
    }
    serviceOfferings {
      uid
      basePrice
      baseTime
      title
      type
    }
    serviceOfferingCategories {
      ...serviceOfferingCategoryFields
    }
    dayOfWeekAvailability {
      dayOfWeek
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    location {
      id
      phoneNumber
      discoverableBounds {
        min {
          lat
          lng
        }
        max {
          lat
          lng
        }
      }
    }
  }
}
    ${ProfileFragmentFragmentDoc}
${ServiceOfferingCategoryFieldsFragmentDoc}`;

/**
 * __useGetServiceProviderByIdQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderByIdQuery({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *   },
 * });
 */
export function useGetServiceProviderByIdQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderByIdQuery, GetServiceProviderByIdQueryVariables> & ({ variables: GetServiceProviderByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderByIdQuery, GetServiceProviderByIdQueryVariables>(GetServiceProviderByIdDocument, options);
      }
export function useGetServiceProviderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderByIdQuery, GetServiceProviderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderByIdQuery, GetServiceProviderByIdQueryVariables>(GetServiceProviderByIdDocument, options);
        }
export function useGetServiceProviderByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderByIdQuery, GetServiceProviderByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderByIdQuery, GetServiceProviderByIdQueryVariables>(GetServiceProviderByIdDocument, options);
        }
export type GetServiceProviderByIdQueryHookResult = ReturnType<typeof useGetServiceProviderByIdQuery>;
export type GetServiceProviderByIdLazyQueryHookResult = ReturnType<typeof useGetServiceProviderByIdLazyQuery>;
export type GetServiceProviderByIdSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderByIdSuspenseQuery>;
export type GetServiceProviderByIdQueryResult = Apollo.QueryResult<GetServiceProviderByIdQuery, GetServiceProviderByIdQueryVariables>;
export const GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsDocument = gql`
    query GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferings($slug: String!) {
  getServiceProviderBySlug(slug: $slug) {
    ...serviceProviderBySlugWithDiscountRulesAndPreferences
    eventOfferings {
      id
      title
      description
      basePrice
      baseDuration
      type
      maxBookings
      serviceProviderId
      index
      serviceOfferingUids
      isPublished
    }
  }
}
    ${ServiceProviderBySlugWithDiscountRulesAndPreferencesFragmentDoc}`;

/**
 * __useGetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryVariables> & ({ variables: GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryVariables>(GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsDocument, options);
      }
export function useGetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryVariables>(GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsDocument, options);
        }
export function useGetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryVariables>(GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsDocument, options);
        }
export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryHookResult = ReturnType<typeof useGetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery>;
export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsLazyQueryHookResult = ReturnType<typeof useGetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsLazyQuery>;
export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsSuspenseQuery>;
export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryResult = Apollo.QueryResult<GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesAndEventOfferingsQueryVariables>;
export const GetServiceProviderBySlugWithDiscountRulesAndPreferencesDocument = gql`
    query GetServiceProviderBySlugWithDiscountRulesAndPreferences($slug: String!) {
  getServiceProviderBySlug(slug: $slug) {
    ...serviceProviderBySlugWithDiscountRulesAndPreferences
  }
}
    ${ServiceProviderBySlugWithDiscountRulesAndPreferencesFragmentDoc}`;

/**
 * __useGetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryVariables> & ({ variables: GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryVariables>(GetServiceProviderBySlugWithDiscountRulesAndPreferencesDocument, options);
      }
export function useGetServiceProviderBySlugWithDiscountRulesAndPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryVariables>(GetServiceProviderBySlugWithDiscountRulesAndPreferencesDocument, options);
        }
export function useGetServiceProviderBySlugWithDiscountRulesAndPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryVariables>(GetServiceProviderBySlugWithDiscountRulesAndPreferencesDocument, options);
        }
export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryHookResult = ReturnType<typeof useGetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery>;
export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesLazyQueryHookResult = ReturnType<typeof useGetServiceProviderBySlugWithDiscountRulesAndPreferencesLazyQuery>;
export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderBySlugWithDiscountRulesAndPreferencesSuspenseQuery>;
export type GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryResult = Apollo.QueryResult<GetServiceProviderBySlugWithDiscountRulesAndPreferencesQuery, GetServiceProviderBySlugWithDiscountRulesAndPreferencesQueryVariables>;
export const GetServiceProviderBySlugDocument = gql`
    query GetServiceProviderBySlug($serviceProviderSlug: String!) {
  getServiceProviderBySlug(slug: $serviceProviderSlug) {
    serviceType
    displayName
    averageRating
    reviewCount
    reviews {
      uid
      createdAt
      isLike
      text
      owner {
        fullName
      }
      isExternal
      externalAuthor
    }
    user {
      id
    }
    profile {
      ...profileFragment
    }
    serviceOfferings {
      uid
      basePrice
      baseTime
      title
      type
    }
    serviceOfferingCategories {
      ...serviceOfferingCategoryFields
    }
    dayOfWeekAvailability {
      dayOfWeek
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    location {
      id
      phoneNumber
    }
  }
}
    ${ProfileFragmentFragmentDoc}
${ServiceOfferingCategoryFieldsFragmentDoc}`;

/**
 * __useGetServiceProviderBySlugQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderBySlugQuery({
 *   variables: {
 *      serviceProviderSlug: // value for 'serviceProviderSlug'
 *   },
 * });
 */
export function useGetServiceProviderBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderBySlugQuery, GetServiceProviderBySlugQueryVariables> & ({ variables: GetServiceProviderBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderBySlugQuery, GetServiceProviderBySlugQueryVariables>(GetServiceProviderBySlugDocument, options);
      }
export function useGetServiceProviderBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderBySlugQuery, GetServiceProviderBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderBySlugQuery, GetServiceProviderBySlugQueryVariables>(GetServiceProviderBySlugDocument, options);
        }
export function useGetServiceProviderBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderBySlugQuery, GetServiceProviderBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderBySlugQuery, GetServiceProviderBySlugQueryVariables>(GetServiceProviderBySlugDocument, options);
        }
export type GetServiceProviderBySlugQueryHookResult = ReturnType<typeof useGetServiceProviderBySlugQuery>;
export type GetServiceProviderBySlugLazyQueryHookResult = ReturnType<typeof useGetServiceProviderBySlugLazyQuery>;
export type GetServiceProviderBySlugSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderBySlugSuspenseQuery>;
export type GetServiceProviderBySlugQueryResult = Apollo.QueryResult<GetServiceProviderBySlugQuery, GetServiceProviderBySlugQueryVariables>;
export const GetServiceProviderCalendarEventsDocument = gql`
    query GetServiceProviderCalendarEvents($query: CalendarEventQuery!) {
  getServiceProviderCalendarEvents(query: $query) {
    id
    title
    description
    startDateTime
    endDateTime
    eventType
  }
}
    `;

/**
 * __useGetServiceProviderCalendarEventsQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderCalendarEventsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetServiceProviderCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderCalendarEventsQuery, GetServiceProviderCalendarEventsQueryVariables> & ({ variables: GetServiceProviderCalendarEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderCalendarEventsQuery, GetServiceProviderCalendarEventsQueryVariables>(GetServiceProviderCalendarEventsDocument, options);
      }
export function useGetServiceProviderCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderCalendarEventsQuery, GetServiceProviderCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderCalendarEventsQuery, GetServiceProviderCalendarEventsQueryVariables>(GetServiceProviderCalendarEventsDocument, options);
        }
export function useGetServiceProviderCalendarEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderCalendarEventsQuery, GetServiceProviderCalendarEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderCalendarEventsQuery, GetServiceProviderCalendarEventsQueryVariables>(GetServiceProviderCalendarEventsDocument, options);
        }
export type GetServiceProviderCalendarEventsQueryHookResult = ReturnType<typeof useGetServiceProviderCalendarEventsQuery>;
export type GetServiceProviderCalendarEventsLazyQueryHookResult = ReturnType<typeof useGetServiceProviderCalendarEventsLazyQuery>;
export type GetServiceProviderCalendarEventsSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderCalendarEventsSuspenseQuery>;
export type GetServiceProviderCalendarEventsQueryResult = Apollo.QueryResult<GetServiceProviderCalendarEventsQuery, GetServiceProviderCalendarEventsQueryVariables>;
export const GetServiceProviderBreakCalendarEventsDocument = gql`
    query GetServiceProviderBreakCalendarEvents($query: CalendarEventQuery!) {
  getServiceProviderBreakCalendarEvents(query: $query) {
    id
    title
    description
    startDateTime
    endDateTime
    eventType
  }
}
    `;

/**
 * __useGetServiceProviderBreakCalendarEventsQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderBreakCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderBreakCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderBreakCalendarEventsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetServiceProviderBreakCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderBreakCalendarEventsQuery, GetServiceProviderBreakCalendarEventsQueryVariables> & ({ variables: GetServiceProviderBreakCalendarEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderBreakCalendarEventsQuery, GetServiceProviderBreakCalendarEventsQueryVariables>(GetServiceProviderBreakCalendarEventsDocument, options);
      }
export function useGetServiceProviderBreakCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderBreakCalendarEventsQuery, GetServiceProviderBreakCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderBreakCalendarEventsQuery, GetServiceProviderBreakCalendarEventsQueryVariables>(GetServiceProviderBreakCalendarEventsDocument, options);
        }
export function useGetServiceProviderBreakCalendarEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderBreakCalendarEventsQuery, GetServiceProviderBreakCalendarEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderBreakCalendarEventsQuery, GetServiceProviderBreakCalendarEventsQueryVariables>(GetServiceProviderBreakCalendarEventsDocument, options);
        }
export type GetServiceProviderBreakCalendarEventsQueryHookResult = ReturnType<typeof useGetServiceProviderBreakCalendarEventsQuery>;
export type GetServiceProviderBreakCalendarEventsLazyQueryHookResult = ReturnType<typeof useGetServiceProviderBreakCalendarEventsLazyQuery>;
export type GetServiceProviderBreakCalendarEventsSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderBreakCalendarEventsSuspenseQuery>;
export type GetServiceProviderBreakCalendarEventsQueryResult = Apollo.QueryResult<GetServiceProviderBreakCalendarEventsQuery, GetServiceProviderBreakCalendarEventsQueryVariables>;
export const GetServiceProviderCompletableAppointmentsDocument = gql`
    query GetServiceProviderCompletableAppointments($query: AppointmentQuery) {
  getAppointmentsForUser(query: $query) {
    startDateTime
    maxEndDateTime
    ownerUid
    userUid
    locationUid
    denialReason
    timezoneLocation
    uid
    id
    serviceAreaUid
    isConfirmed
    isCancelled
    isCoveredByBusiness
    isComplete
    eventEndDateTime
    location {
      id
      uid
      formattedAddress
      name
      type
      extendedAddress
      streetAddress
      phoneNumber
      placeId
      owner {
        fullName
        emailAddress
        phoneNumber
      }
      business {
        uid
        name
        website
      }
    }
    bookings(statusQuery: {cancelledStatus: NOT_CANCELLED}) {
      uid
      startDateTime
      endDateTime
      isComplete
      tipPercent
      appointmentUid
      isInProgress
      id
      customerProfileId
      dropoff {
        id
        dropoffDateTime
        status
      }
      serviceOffering {
        uid
        title
        type
      }
      customer {
        id
        user {
          fullName
          emailAddress
          phoneNumber
        }
        profiles {
          id
          customerID
          fieldValues {
            customerProfileFieldID
            value
          }
          notes {
            id
            text
            title
            createdAt
          }
          label
        }
      }
    }
  }
}
    `;

/**
 * __useGetServiceProviderCompletableAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderCompletableAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderCompletableAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderCompletableAppointmentsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetServiceProviderCompletableAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceProviderCompletableAppointmentsQuery, GetServiceProviderCompletableAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderCompletableAppointmentsQuery, GetServiceProviderCompletableAppointmentsQueryVariables>(GetServiceProviderCompletableAppointmentsDocument, options);
      }
export function useGetServiceProviderCompletableAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderCompletableAppointmentsQuery, GetServiceProviderCompletableAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderCompletableAppointmentsQuery, GetServiceProviderCompletableAppointmentsQueryVariables>(GetServiceProviderCompletableAppointmentsDocument, options);
        }
export function useGetServiceProviderCompletableAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderCompletableAppointmentsQuery, GetServiceProviderCompletableAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderCompletableAppointmentsQuery, GetServiceProviderCompletableAppointmentsQueryVariables>(GetServiceProviderCompletableAppointmentsDocument, options);
        }
export type GetServiceProviderCompletableAppointmentsQueryHookResult = ReturnType<typeof useGetServiceProviderCompletableAppointmentsQuery>;
export type GetServiceProviderCompletableAppointmentsLazyQueryHookResult = ReturnType<typeof useGetServiceProviderCompletableAppointmentsLazyQuery>;
export type GetServiceProviderCompletableAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderCompletableAppointmentsSuspenseQuery>;
export type GetServiceProviderCompletableAppointmentsQueryResult = Apollo.QueryResult<GetServiceProviderCompletableAppointmentsQuery, GetServiceProviderCompletableAppointmentsQueryVariables>;
export const GetServiceProviderDefaultDropoffDeltaPreferencesDocument = gql`
    query GetServiceProviderDefaultDropoffDeltaPreferences($serviceProviderUserUid: String!) {
  getServiceProviderDefaultDropoffDeltaDaysPreference(
    serviceProviderUserUid: $serviceProviderUserUid
  )
  getServiceProviderIsDefaultDropoffDeltaBusinessDays(
    serviceProviderUserUid: $serviceProviderUserUid
  )
}
    `;

/**
 * __useGetServiceProviderDefaultDropoffDeltaPreferencesQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderDefaultDropoffDeltaPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderDefaultDropoffDeltaPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderDefaultDropoffDeltaPreferencesQuery({
 *   variables: {
 *      serviceProviderUserUid: // value for 'serviceProviderUserUid'
 *   },
 * });
 */
export function useGetServiceProviderDefaultDropoffDeltaPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderDefaultDropoffDeltaPreferencesQuery, GetServiceProviderDefaultDropoffDeltaPreferencesQueryVariables> & ({ variables: GetServiceProviderDefaultDropoffDeltaPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderDefaultDropoffDeltaPreferencesQuery, GetServiceProviderDefaultDropoffDeltaPreferencesQueryVariables>(GetServiceProviderDefaultDropoffDeltaPreferencesDocument, options);
      }
export function useGetServiceProviderDefaultDropoffDeltaPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderDefaultDropoffDeltaPreferencesQuery, GetServiceProviderDefaultDropoffDeltaPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderDefaultDropoffDeltaPreferencesQuery, GetServiceProviderDefaultDropoffDeltaPreferencesQueryVariables>(GetServiceProviderDefaultDropoffDeltaPreferencesDocument, options);
        }
export function useGetServiceProviderDefaultDropoffDeltaPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderDefaultDropoffDeltaPreferencesQuery, GetServiceProviderDefaultDropoffDeltaPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderDefaultDropoffDeltaPreferencesQuery, GetServiceProviderDefaultDropoffDeltaPreferencesQueryVariables>(GetServiceProviderDefaultDropoffDeltaPreferencesDocument, options);
        }
export type GetServiceProviderDefaultDropoffDeltaPreferencesQueryHookResult = ReturnType<typeof useGetServiceProviderDefaultDropoffDeltaPreferencesQuery>;
export type GetServiceProviderDefaultDropoffDeltaPreferencesLazyQueryHookResult = ReturnType<typeof useGetServiceProviderDefaultDropoffDeltaPreferencesLazyQuery>;
export type GetServiceProviderDefaultDropoffDeltaPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderDefaultDropoffDeltaPreferencesSuspenseQuery>;
export type GetServiceProviderDefaultDropoffDeltaPreferencesQueryResult = Apollo.QueryResult<GetServiceProviderDefaultDropoffDeltaPreferencesQuery, GetServiceProviderDefaultDropoffDeltaPreferencesQueryVariables>;
export const GetServiceProviderForOnboardingFlowDocument = gql`
    query GetServiceProviderForOnboardingFlow {
  getThisServiceProvider {
    ...serviceProviderFullNew
    serviceOfferings {
      uid
      basePrice
      baseTime
      title
      shortDesc
      allowTip
      maxConcurrentBookings
      type
      postServiceNote
      isHidden
      customerInputs {
        uid
      }
      customerInputGroups {
        uid
      }
    }
    id
    isGoogleCalendarLinked
    user {
      emailAddress
      fullName
    }
  }
}
    ${ServiceProviderFullNewFragmentDoc}`;

/**
 * __useGetServiceProviderForOnboardingFlowQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderForOnboardingFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderForOnboardingFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderForOnboardingFlowQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiceProviderForOnboardingFlowQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceProviderForOnboardingFlowQuery, GetServiceProviderForOnboardingFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderForOnboardingFlowQuery, GetServiceProviderForOnboardingFlowQueryVariables>(GetServiceProviderForOnboardingFlowDocument, options);
      }
export function useGetServiceProviderForOnboardingFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderForOnboardingFlowQuery, GetServiceProviderForOnboardingFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderForOnboardingFlowQuery, GetServiceProviderForOnboardingFlowQueryVariables>(GetServiceProviderForOnboardingFlowDocument, options);
        }
export function useGetServiceProviderForOnboardingFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderForOnboardingFlowQuery, GetServiceProviderForOnboardingFlowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderForOnboardingFlowQuery, GetServiceProviderForOnboardingFlowQueryVariables>(GetServiceProviderForOnboardingFlowDocument, options);
        }
export type GetServiceProviderForOnboardingFlowQueryHookResult = ReturnType<typeof useGetServiceProviderForOnboardingFlowQuery>;
export type GetServiceProviderForOnboardingFlowLazyQueryHookResult = ReturnType<typeof useGetServiceProviderForOnboardingFlowLazyQuery>;
export type GetServiceProviderForOnboardingFlowSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderForOnboardingFlowSuspenseQuery>;
export type GetServiceProviderForOnboardingFlowQueryResult = Apollo.QueryResult<GetServiceProviderForOnboardingFlowQuery, GetServiceProviderForOnboardingFlowQueryVariables>;
export const GetServiceProviderForServiceProviderDashboardDocument = gql`
    query GetServiceProviderForServiceProviderDashboard($eventType: CalendarEventType) {
  getThisServiceProvider {
    ...serviceProviderFullNew
    user {
      id
      fullName
      country
      timezoneLocation
    }
    isGoogleCalendarLinked
    dayOfWeekAvailability {
      dayOfWeek
      timezone
      ownerUid
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    dateAvailability {
      date
      timezone
      ownerUid
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    events(eventType: $eventType) {
      startDateTime
      endDateTime
      title
      description
      externalCalendarEventId
      id
    }
  }
}
    ${ServiceProviderFullNewFragmentDoc}`;

/**
 * __useGetServiceProviderForServiceProviderDashboardQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderForServiceProviderDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderForServiceProviderDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderForServiceProviderDashboardQuery({
 *   variables: {
 *      eventType: // value for 'eventType'
 *   },
 * });
 */
export function useGetServiceProviderForServiceProviderDashboardQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceProviderForServiceProviderDashboardQuery, GetServiceProviderForServiceProviderDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderForServiceProviderDashboardQuery, GetServiceProviderForServiceProviderDashboardQueryVariables>(GetServiceProviderForServiceProviderDashboardDocument, options);
      }
export function useGetServiceProviderForServiceProviderDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderForServiceProviderDashboardQuery, GetServiceProviderForServiceProviderDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderForServiceProviderDashboardQuery, GetServiceProviderForServiceProviderDashboardQueryVariables>(GetServiceProviderForServiceProviderDashboardDocument, options);
        }
export function useGetServiceProviderForServiceProviderDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderForServiceProviderDashboardQuery, GetServiceProviderForServiceProviderDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderForServiceProviderDashboardQuery, GetServiceProviderForServiceProviderDashboardQueryVariables>(GetServiceProviderForServiceProviderDashboardDocument, options);
        }
export type GetServiceProviderForServiceProviderDashboardQueryHookResult = ReturnType<typeof useGetServiceProviderForServiceProviderDashboardQuery>;
export type GetServiceProviderForServiceProviderDashboardLazyQueryHookResult = ReturnType<typeof useGetServiceProviderForServiceProviderDashboardLazyQuery>;
export type GetServiceProviderForServiceProviderDashboardSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderForServiceProviderDashboardSuspenseQuery>;
export type GetServiceProviderForServiceProviderDashboardQueryResult = Apollo.QueryResult<GetServiceProviderForServiceProviderDashboardQuery, GetServiceProviderForServiceProviderDashboardQueryVariables>;
export const GetServiceProviderForShareButtonDocument = gql`
    query GetServiceProviderForShareButton($serviceProviderUserUid: String!) {
  getServiceProvider(ownerUid: $serviceProviderUserUid) {
    id
    serviceType
    slug
  }
}
    `;

/**
 * __useGetServiceProviderForShareButtonQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderForShareButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderForShareButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderForShareButtonQuery({
 *   variables: {
 *      serviceProviderUserUid: // value for 'serviceProviderUserUid'
 *   },
 * });
 */
export function useGetServiceProviderForShareButtonQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderForShareButtonQuery, GetServiceProviderForShareButtonQueryVariables> & ({ variables: GetServiceProviderForShareButtonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderForShareButtonQuery, GetServiceProviderForShareButtonQueryVariables>(GetServiceProviderForShareButtonDocument, options);
      }
export function useGetServiceProviderForShareButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderForShareButtonQuery, GetServiceProviderForShareButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderForShareButtonQuery, GetServiceProviderForShareButtonQueryVariables>(GetServiceProviderForShareButtonDocument, options);
        }
export function useGetServiceProviderForShareButtonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderForShareButtonQuery, GetServiceProviderForShareButtonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderForShareButtonQuery, GetServiceProviderForShareButtonQueryVariables>(GetServiceProviderForShareButtonDocument, options);
        }
export type GetServiceProviderForShareButtonQueryHookResult = ReturnType<typeof useGetServiceProviderForShareButtonQuery>;
export type GetServiceProviderForShareButtonLazyQueryHookResult = ReturnType<typeof useGetServiceProviderForShareButtonLazyQuery>;
export type GetServiceProviderForShareButtonSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderForShareButtonSuspenseQuery>;
export type GetServiceProviderForShareButtonQueryResult = Apollo.QueryResult<GetServiceProviderForShareButtonQuery, GetServiceProviderForShareButtonQueryVariables>;
export const GetServiceProviderLocationsDocument = gql`
    query GetServiceProviderLocations {
  getThisUserLocations(types: [SERVICE_PROVIDER, SERVICE_PROVIDER_RETAIL]) {
    uid
    id
    streetAddress
    formattedAddress
    name
    type
    placeId
    phoneNumber
    extendedAddress
  }
}
    `;

/**
 * __useGetServiceProviderLocationsQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiceProviderLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceProviderLocationsQuery, GetServiceProviderLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderLocationsQuery, GetServiceProviderLocationsQueryVariables>(GetServiceProviderLocationsDocument, options);
      }
export function useGetServiceProviderLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderLocationsQuery, GetServiceProviderLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderLocationsQuery, GetServiceProviderLocationsQueryVariables>(GetServiceProviderLocationsDocument, options);
        }
export function useGetServiceProviderLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderLocationsQuery, GetServiceProviderLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderLocationsQuery, GetServiceProviderLocationsQueryVariables>(GetServiceProviderLocationsDocument, options);
        }
export type GetServiceProviderLocationsQueryHookResult = ReturnType<typeof useGetServiceProviderLocationsQuery>;
export type GetServiceProviderLocationsLazyQueryHookResult = ReturnType<typeof useGetServiceProviderLocationsLazyQuery>;
export type GetServiceProviderLocationsSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderLocationsSuspenseQuery>;
export type GetServiceProviderLocationsQueryResult = Apollo.QueryResult<GetServiceProviderLocationsQuery, GetServiceProviderLocationsQueryVariables>;
export const GetServiceProviderRemindersDocument = gql`
    query GetServiceProviderReminders($page: Int, $minDateTime: Int!, $maxDateTime: Int!) {
  getServiceProviderReminders(
    query: {page: $page, minDateTime: $minDateTime, maxDateTime: $maxDateTime}
  ) {
    reminders {
      ...reminderFields
    }
    hasNextPage
  }
}
    ${ReminderFieldsFragmentDoc}`;

/**
 * __useGetServiceProviderRemindersQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderRemindersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      minDateTime: // value for 'minDateTime'
 *      maxDateTime: // value for 'maxDateTime'
 *   },
 * });
 */
export function useGetServiceProviderRemindersQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderRemindersQuery, GetServiceProviderRemindersQueryVariables> & ({ variables: GetServiceProviderRemindersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderRemindersQuery, GetServiceProviderRemindersQueryVariables>(GetServiceProviderRemindersDocument, options);
      }
export function useGetServiceProviderRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderRemindersQuery, GetServiceProviderRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderRemindersQuery, GetServiceProviderRemindersQueryVariables>(GetServiceProviderRemindersDocument, options);
        }
export function useGetServiceProviderRemindersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderRemindersQuery, GetServiceProviderRemindersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderRemindersQuery, GetServiceProviderRemindersQueryVariables>(GetServiceProviderRemindersDocument, options);
        }
export type GetServiceProviderRemindersQueryHookResult = ReturnType<typeof useGetServiceProviderRemindersQuery>;
export type GetServiceProviderRemindersLazyQueryHookResult = ReturnType<typeof useGetServiceProviderRemindersLazyQuery>;
export type GetServiceProviderRemindersSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderRemindersSuspenseQuery>;
export type GetServiceProviderRemindersQueryResult = Apollo.QueryResult<GetServiceProviderRemindersQuery, GetServiceProviderRemindersQueryVariables>;
export const GetServiceProviderRetailLocationsDocument = gql`
    query GetServiceProviderRetailLocations($serviceProviderId: String!) {
  getServiceProviderRetailLocations(serviceProviderId: $serviceProviderId) {
    uid
    id
    streetAddress
    formattedAddress
    name
    type
    placeId
    phoneNumber
    extendedAddress
    latitude
    longitude
  }
}
    `;

/**
 * __useGetServiceProviderRetailLocationsQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderRetailLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderRetailLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderRetailLocationsQuery({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *   },
 * });
 */
export function useGetServiceProviderRetailLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderRetailLocationsQuery, GetServiceProviderRetailLocationsQueryVariables> & ({ variables: GetServiceProviderRetailLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderRetailLocationsQuery, GetServiceProviderRetailLocationsQueryVariables>(GetServiceProviderRetailLocationsDocument, options);
      }
export function useGetServiceProviderRetailLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderRetailLocationsQuery, GetServiceProviderRetailLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderRetailLocationsQuery, GetServiceProviderRetailLocationsQueryVariables>(GetServiceProviderRetailLocationsDocument, options);
        }
export function useGetServiceProviderRetailLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderRetailLocationsQuery, GetServiceProviderRetailLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderRetailLocationsQuery, GetServiceProviderRetailLocationsQueryVariables>(GetServiceProviderRetailLocationsDocument, options);
        }
export type GetServiceProviderRetailLocationsQueryHookResult = ReturnType<typeof useGetServiceProviderRetailLocationsQuery>;
export type GetServiceProviderRetailLocationsLazyQueryHookResult = ReturnType<typeof useGetServiceProviderRetailLocationsLazyQuery>;
export type GetServiceProviderRetailLocationsSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderRetailLocationsSuspenseQuery>;
export type GetServiceProviderRetailLocationsQueryResult = Apollo.QueryResult<GetServiceProviderRetailLocationsQuery, GetServiceProviderRetailLocationsQueryVariables>;
export const GetServiceProviderSlugsForSitemapDocument = gql`
    query GetServiceProviderSlugsForSitemap {
  getServiceProviderSlugsForSitemap
}
    `;

/**
 * __useGetServiceProviderSlugsForSitemapQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderSlugsForSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderSlugsForSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderSlugsForSitemapQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiceProviderSlugsForSitemapQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceProviderSlugsForSitemapQuery, GetServiceProviderSlugsForSitemapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderSlugsForSitemapQuery, GetServiceProviderSlugsForSitemapQueryVariables>(GetServiceProviderSlugsForSitemapDocument, options);
      }
export function useGetServiceProviderSlugsForSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderSlugsForSitemapQuery, GetServiceProviderSlugsForSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderSlugsForSitemapQuery, GetServiceProviderSlugsForSitemapQueryVariables>(GetServiceProviderSlugsForSitemapDocument, options);
        }
export function useGetServiceProviderSlugsForSitemapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderSlugsForSitemapQuery, GetServiceProviderSlugsForSitemapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderSlugsForSitemapQuery, GetServiceProviderSlugsForSitemapQueryVariables>(GetServiceProviderSlugsForSitemapDocument, options);
        }
export type GetServiceProviderSlugsForSitemapQueryHookResult = ReturnType<typeof useGetServiceProviderSlugsForSitemapQuery>;
export type GetServiceProviderSlugsForSitemapLazyQueryHookResult = ReturnType<typeof useGetServiceProviderSlugsForSitemapLazyQuery>;
export type GetServiceProviderSlugsForSitemapSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderSlugsForSitemapSuspenseQuery>;
export type GetServiceProviderSlugsForSitemapQueryResult = Apollo.QueryResult<GetServiceProviderSlugsForSitemapQuery, GetServiceProviderSlugsForSitemapQueryVariables>;
export const GetServiceProviderUidFromIdDocument = gql`
    query GetServiceProviderUidFromId($serviceProviderId: String!) {
  getServiceProviderUid(serviceProviderId: $serviceProviderId)
}
    `;

/**
 * __useGetServiceProviderUidFromIdQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderUidFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderUidFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderUidFromIdQuery({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *   },
 * });
 */
export function useGetServiceProviderUidFromIdQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderUidFromIdQuery, GetServiceProviderUidFromIdQueryVariables> & ({ variables: GetServiceProviderUidFromIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderUidFromIdQuery, GetServiceProviderUidFromIdQueryVariables>(GetServiceProviderUidFromIdDocument, options);
      }
export function useGetServiceProviderUidFromIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderUidFromIdQuery, GetServiceProviderUidFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderUidFromIdQuery, GetServiceProviderUidFromIdQueryVariables>(GetServiceProviderUidFromIdDocument, options);
        }
export function useGetServiceProviderUidFromIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderUidFromIdQuery, GetServiceProviderUidFromIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderUidFromIdQuery, GetServiceProviderUidFromIdQueryVariables>(GetServiceProviderUidFromIdDocument, options);
        }
export type GetServiceProviderUidFromIdQueryHookResult = ReturnType<typeof useGetServiceProviderUidFromIdQuery>;
export type GetServiceProviderUidFromIdLazyQueryHookResult = ReturnType<typeof useGetServiceProviderUidFromIdLazyQuery>;
export type GetServiceProviderUidFromIdSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderUidFromIdSuspenseQuery>;
export type GetServiceProviderUidFromIdQueryResult = Apollo.QueryResult<GetServiceProviderUidFromIdQuery, GetServiceProviderUidFromIdQueryVariables>;
export const GetServiceProviderWithAvailabilityAndLocationDocument = gql`
    query GetServiceProviderWithAvailabilityAndLocation($ownerUid: String!) {
  getServiceProvider(ownerUid: $ownerUid) {
    id
    ...serviceProviderFullNew
    dayOfWeekAvailability {
      dayOfWeek
      timezone
      ownerUid
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    dateAvailability {
      date
      timezone
      ownerUid
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    location {
      id
      uid
      discoverableBounds {
        min {
          lat
          lng
        }
        max {
          lat
          lng
        }
      }
    }
  }
}
    ${ServiceProviderFullNewFragmentDoc}`;

/**
 * __useGetServiceProviderWithAvailabilityAndLocationQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderWithAvailabilityAndLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderWithAvailabilityAndLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderWithAvailabilityAndLocationQuery({
 *   variables: {
 *      ownerUid: // value for 'ownerUid'
 *   },
 * });
 */
export function useGetServiceProviderWithAvailabilityAndLocationQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderWithAvailabilityAndLocationQuery, GetServiceProviderWithAvailabilityAndLocationQueryVariables> & ({ variables: GetServiceProviderWithAvailabilityAndLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderWithAvailabilityAndLocationQuery, GetServiceProviderWithAvailabilityAndLocationQueryVariables>(GetServiceProviderWithAvailabilityAndLocationDocument, options);
      }
export function useGetServiceProviderWithAvailabilityAndLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderWithAvailabilityAndLocationQuery, GetServiceProviderWithAvailabilityAndLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderWithAvailabilityAndLocationQuery, GetServiceProviderWithAvailabilityAndLocationQueryVariables>(GetServiceProviderWithAvailabilityAndLocationDocument, options);
        }
export function useGetServiceProviderWithAvailabilityAndLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderWithAvailabilityAndLocationQuery, GetServiceProviderWithAvailabilityAndLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderWithAvailabilityAndLocationQuery, GetServiceProviderWithAvailabilityAndLocationQueryVariables>(GetServiceProviderWithAvailabilityAndLocationDocument, options);
        }
export type GetServiceProviderWithAvailabilityAndLocationQueryHookResult = ReturnType<typeof useGetServiceProviderWithAvailabilityAndLocationQuery>;
export type GetServiceProviderWithAvailabilityAndLocationLazyQueryHookResult = ReturnType<typeof useGetServiceProviderWithAvailabilityAndLocationLazyQuery>;
export type GetServiceProviderWithAvailabilityAndLocationSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderWithAvailabilityAndLocationSuspenseQuery>;
export type GetServiceProviderWithAvailabilityAndLocationQueryResult = Apollo.QueryResult<GetServiceProviderWithAvailabilityAndLocationQuery, GetServiceProviderWithAvailabilityAndLocationQueryVariables>;
export const GetServiceProviderWithAvailabilityDropoffsEventsDocument = gql`
    query GetServiceProviderWithAvailabilityDropoffsEvents($eventType: CalendarEventType) {
  getThisServiceProvider {
    ...serviceProviderFullNew
    isGoogleCalendarLinked
    dayOfWeekAvailability {
      dayOfWeek
      timezone
      ownerUid
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    dateAvailability {
      date
      timezone
      ownerUid
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    events(eventType: $eventType) {
      startDateTime
      endDateTime
      title
      description
      externalCalendarEventId
      id
    }
  }
}
    ${ServiceProviderFullNewFragmentDoc}`;

/**
 * __useGetServiceProviderWithAvailabilityDropoffsEventsQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderWithAvailabilityDropoffsEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderWithAvailabilityDropoffsEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderWithAvailabilityDropoffsEventsQuery({
 *   variables: {
 *      eventType: // value for 'eventType'
 *   },
 * });
 */
export function useGetServiceProviderWithAvailabilityDropoffsEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceProviderWithAvailabilityDropoffsEventsQuery, GetServiceProviderWithAvailabilityDropoffsEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderWithAvailabilityDropoffsEventsQuery, GetServiceProviderWithAvailabilityDropoffsEventsQueryVariables>(GetServiceProviderWithAvailabilityDropoffsEventsDocument, options);
      }
export function useGetServiceProviderWithAvailabilityDropoffsEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderWithAvailabilityDropoffsEventsQuery, GetServiceProviderWithAvailabilityDropoffsEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderWithAvailabilityDropoffsEventsQuery, GetServiceProviderWithAvailabilityDropoffsEventsQueryVariables>(GetServiceProviderWithAvailabilityDropoffsEventsDocument, options);
        }
export function useGetServiceProviderWithAvailabilityDropoffsEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderWithAvailabilityDropoffsEventsQuery, GetServiceProviderWithAvailabilityDropoffsEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderWithAvailabilityDropoffsEventsQuery, GetServiceProviderWithAvailabilityDropoffsEventsQueryVariables>(GetServiceProviderWithAvailabilityDropoffsEventsDocument, options);
        }
export type GetServiceProviderWithAvailabilityDropoffsEventsQueryHookResult = ReturnType<typeof useGetServiceProviderWithAvailabilityDropoffsEventsQuery>;
export type GetServiceProviderWithAvailabilityDropoffsEventsLazyQueryHookResult = ReturnType<typeof useGetServiceProviderWithAvailabilityDropoffsEventsLazyQuery>;
export type GetServiceProviderWithAvailabilityDropoffsEventsSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderWithAvailabilityDropoffsEventsSuspenseQuery>;
export type GetServiceProviderWithAvailabilityDropoffsEventsQueryResult = Apollo.QueryResult<GetServiceProviderWithAvailabilityDropoffsEventsQuery, GetServiceProviderWithAvailabilityDropoffsEventsQueryVariables>;
export const GetServiceProviderWithDiscountRulesDocument = gql`
    query GetServiceProviderWithDiscountRules($serviceProviderUid: String!) {
  getServiceProvider(ownerUid: $serviceProviderUid) {
    ...serviceProviderFullNew
    location {
      id
      discoverableBounds {
        min {
          lat
          lng
        }
        max {
          lat
          lng
        }
      }
    }
    discountRules {
      id
      isDisabled
      label
      triggerCondition {
        siblingBookingTriggerCondition {
          requireBookingCount
          ignoreServiceOfferingUids
        }
        timeDurationBookedAtLocationTriggerCondition {
          requireDurationBookedSeconds
          ignoreServiceOfferingUids
        }
      }
      discountValue
      discountType
      priority
    }
  }
}
    ${ServiceProviderFullNewFragmentDoc}`;

/**
 * __useGetServiceProviderWithDiscountRulesQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderWithDiscountRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderWithDiscountRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderWithDiscountRulesQuery({
 *   variables: {
 *      serviceProviderUid: // value for 'serviceProviderUid'
 *   },
 * });
 */
export function useGetServiceProviderWithDiscountRulesQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderWithDiscountRulesQuery, GetServiceProviderWithDiscountRulesQueryVariables> & ({ variables: GetServiceProviderWithDiscountRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderWithDiscountRulesQuery, GetServiceProviderWithDiscountRulesQueryVariables>(GetServiceProviderWithDiscountRulesDocument, options);
      }
export function useGetServiceProviderWithDiscountRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderWithDiscountRulesQuery, GetServiceProviderWithDiscountRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderWithDiscountRulesQuery, GetServiceProviderWithDiscountRulesQueryVariables>(GetServiceProviderWithDiscountRulesDocument, options);
        }
export function useGetServiceProviderWithDiscountRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderWithDiscountRulesQuery, GetServiceProviderWithDiscountRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderWithDiscountRulesQuery, GetServiceProviderWithDiscountRulesQueryVariables>(GetServiceProviderWithDiscountRulesDocument, options);
        }
export type GetServiceProviderWithDiscountRulesQueryHookResult = ReturnType<typeof useGetServiceProviderWithDiscountRulesQuery>;
export type GetServiceProviderWithDiscountRulesLazyQueryHookResult = ReturnType<typeof useGetServiceProviderWithDiscountRulesLazyQuery>;
export type GetServiceProviderWithDiscountRulesSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderWithDiscountRulesSuspenseQuery>;
export type GetServiceProviderWithDiscountRulesQueryResult = Apollo.QueryResult<GetServiceProviderWithDiscountRulesQuery, GetServiceProviderWithDiscountRulesQueryVariables>;
export const GetSetupIntentSecretForCustomerDocument = gql`
    mutation GetSetupIntentSecretForCustomer($customerId: String!) {
  getSetupIntentSecretForCustomer(customerId: $customerId)
}
    `;
export type GetSetupIntentSecretForCustomerMutationFn = Apollo.MutationFunction<GetSetupIntentSecretForCustomerMutation, GetSetupIntentSecretForCustomerMutationVariables>;

/**
 * __useGetSetupIntentSecretForCustomerMutation__
 *
 * To run a mutation, you first call `useGetSetupIntentSecretForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSetupIntentSecretForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSetupIntentSecretForCustomerMutation, { data, loading, error }] = useGetSetupIntentSecretForCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetSetupIntentSecretForCustomerMutation(baseOptions?: Apollo.MutationHookOptions<GetSetupIntentSecretForCustomerMutation, GetSetupIntentSecretForCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetSetupIntentSecretForCustomerMutation, GetSetupIntentSecretForCustomerMutationVariables>(GetSetupIntentSecretForCustomerDocument, options);
      }
export type GetSetupIntentSecretForCustomerMutationHookResult = ReturnType<typeof useGetSetupIntentSecretForCustomerMutation>;
export type GetSetupIntentSecretForCustomerMutationResult = Apollo.MutationResult<GetSetupIntentSecretForCustomerMutation>;
export type GetSetupIntentSecretForCustomerMutationOptions = Apollo.BaseMutationOptions<GetSetupIntentSecretForCustomerMutation, GetSetupIntentSecretForCustomerMutationVariables>;
export const GetSquareCardForCustomerDocument = gql`
    query GetSquareCardForCustomer($customerId: ID!, $cardId: ID!) {
  getSquareCardForCustomer(customerId: $customerId, cardId: $cardId) {
    id
    cardBrand
    last4
    expMonth
    expYear
    cardholderName
  }
}
    `;

/**
 * __useGetSquareCardForCustomerQuery__
 *
 * To run a query within a React component, call `useGetSquareCardForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquareCardForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquareCardForCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useGetSquareCardForCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetSquareCardForCustomerQuery, GetSquareCardForCustomerQueryVariables> & ({ variables: GetSquareCardForCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSquareCardForCustomerQuery, GetSquareCardForCustomerQueryVariables>(GetSquareCardForCustomerDocument, options);
      }
export function useGetSquareCardForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSquareCardForCustomerQuery, GetSquareCardForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSquareCardForCustomerQuery, GetSquareCardForCustomerQueryVariables>(GetSquareCardForCustomerDocument, options);
        }
export function useGetSquareCardForCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSquareCardForCustomerQuery, GetSquareCardForCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSquareCardForCustomerQuery, GetSquareCardForCustomerQueryVariables>(GetSquareCardForCustomerDocument, options);
        }
export type GetSquareCardForCustomerQueryHookResult = ReturnType<typeof useGetSquareCardForCustomerQuery>;
export type GetSquareCardForCustomerLazyQueryHookResult = ReturnType<typeof useGetSquareCardForCustomerLazyQuery>;
export type GetSquareCardForCustomerSuspenseQueryHookResult = ReturnType<typeof useGetSquareCardForCustomerSuspenseQuery>;
export type GetSquareCardForCustomerQueryResult = Apollo.QueryResult<GetSquareCardForCustomerQuery, GetSquareCardForCustomerQueryVariables>;
export const GetStripeCustomerForCustomerDocument = gql`
    query GetStripeCustomerForCustomer($customerId: String!) {
  getStripeCustomerForCustomer(customerId: $customerId) {
    defaultSource
    defaultPaymentMethodId
  }
}
    `;

/**
 * __useGetStripeCustomerForCustomerQuery__
 *
 * To run a query within a React component, call `useGetStripeCustomerForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeCustomerForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeCustomerForCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetStripeCustomerForCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetStripeCustomerForCustomerQuery, GetStripeCustomerForCustomerQueryVariables> & ({ variables: GetStripeCustomerForCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeCustomerForCustomerQuery, GetStripeCustomerForCustomerQueryVariables>(GetStripeCustomerForCustomerDocument, options);
      }
export function useGetStripeCustomerForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeCustomerForCustomerQuery, GetStripeCustomerForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeCustomerForCustomerQuery, GetStripeCustomerForCustomerQueryVariables>(GetStripeCustomerForCustomerDocument, options);
        }
export function useGetStripeCustomerForCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStripeCustomerForCustomerQuery, GetStripeCustomerForCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStripeCustomerForCustomerQuery, GetStripeCustomerForCustomerQueryVariables>(GetStripeCustomerForCustomerDocument, options);
        }
export type GetStripeCustomerForCustomerQueryHookResult = ReturnType<typeof useGetStripeCustomerForCustomerQuery>;
export type GetStripeCustomerForCustomerLazyQueryHookResult = ReturnType<typeof useGetStripeCustomerForCustomerLazyQuery>;
export type GetStripeCustomerForCustomerSuspenseQueryHookResult = ReturnType<typeof useGetStripeCustomerForCustomerSuspenseQuery>;
export type GetStripeCustomerForCustomerQueryResult = Apollo.QueryResult<GetStripeCustomerForCustomerQuery, GetStripeCustomerForCustomerQueryVariables>;
export const GetThisCustomerDocument = gql`
    query GetThisCustomer($serviceProviderId: String!) {
  getThisCustomerForServiceProviderId(serviceProviderId: $serviceProviderId) {
    id
    profiles {
      id
      customerID
      fieldValues {
        customerProfileFieldID
        value
      }
      notes {
        id
        text
        title
      }
      label
    }
  }
}
    `;

/**
 * __useGetThisCustomerQuery__
 *
 * To run a query within a React component, call `useGetThisCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThisCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThisCustomerQuery({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *   },
 * });
 */
export function useGetThisCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetThisCustomerQuery, GetThisCustomerQueryVariables> & ({ variables: GetThisCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThisCustomerQuery, GetThisCustomerQueryVariables>(GetThisCustomerDocument, options);
      }
export function useGetThisCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThisCustomerQuery, GetThisCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThisCustomerQuery, GetThisCustomerQueryVariables>(GetThisCustomerDocument, options);
        }
export function useGetThisCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThisCustomerQuery, GetThisCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThisCustomerQuery, GetThisCustomerQueryVariables>(GetThisCustomerDocument, options);
        }
export type GetThisCustomerQueryHookResult = ReturnType<typeof useGetThisCustomerQuery>;
export type GetThisCustomerLazyQueryHookResult = ReturnType<typeof useGetThisCustomerLazyQuery>;
export type GetThisCustomerSuspenseQueryHookResult = ReturnType<typeof useGetThisCustomerSuspenseQuery>;
export type GetThisCustomerQueryResult = Apollo.QueryResult<GetThisCustomerQuery, GetThisCustomerQueryVariables>;
export const GetThisServiceProviderCustomersDocument = gql`
    query GetThisServiceProviderCustomers($page: Int!, $pageSize: Int!) {
  getThisServiceProvider {
    customersCount
    customers(page: $page, pageSize: $pageSize) {
      id
      user {
        uid
        fullName
        emailAddress
        phoneNumber
      }
    }
    user {
      country
    }
  }
}
    `;

/**
 * __useGetThisServiceProviderCustomersQuery__
 *
 * To run a query within a React component, call `useGetThisServiceProviderCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThisServiceProviderCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThisServiceProviderCustomersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetThisServiceProviderCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetThisServiceProviderCustomersQuery, GetThisServiceProviderCustomersQueryVariables> & ({ variables: GetThisServiceProviderCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThisServiceProviderCustomersQuery, GetThisServiceProviderCustomersQueryVariables>(GetThisServiceProviderCustomersDocument, options);
      }
export function useGetThisServiceProviderCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThisServiceProviderCustomersQuery, GetThisServiceProviderCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThisServiceProviderCustomersQuery, GetThisServiceProviderCustomersQueryVariables>(GetThisServiceProviderCustomersDocument, options);
        }
export function useGetThisServiceProviderCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThisServiceProviderCustomersQuery, GetThisServiceProviderCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThisServiceProviderCustomersQuery, GetThisServiceProviderCustomersQueryVariables>(GetThisServiceProviderCustomersDocument, options);
        }
export type GetThisServiceProviderCustomersQueryHookResult = ReturnType<typeof useGetThisServiceProviderCustomersQuery>;
export type GetThisServiceProviderCustomersLazyQueryHookResult = ReturnType<typeof useGetThisServiceProviderCustomersLazyQuery>;
export type GetThisServiceProviderCustomersSuspenseQueryHookResult = ReturnType<typeof useGetThisServiceProviderCustomersSuspenseQuery>;
export type GetThisServiceProviderCustomersQueryResult = Apollo.QueryResult<GetThisServiceProviderCustomersQuery, GetThisServiceProviderCustomersQueryVariables>;
export const GetThisServiceProviderRetailLocationsDocument = gql`
    query GetThisServiceProviderRetailLocations {
  getThisServiceProviderRetailLocations {
    uid
    id
    streetAddress
    formattedAddress
    name
    type
    placeId
    phoneNumber
    extendedAddress
    latitude
    longitude
  }
}
    `;

/**
 * __useGetThisServiceProviderRetailLocationsQuery__
 *
 * To run a query within a React component, call `useGetThisServiceProviderRetailLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThisServiceProviderRetailLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThisServiceProviderRetailLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThisServiceProviderRetailLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetThisServiceProviderRetailLocationsQuery, GetThisServiceProviderRetailLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThisServiceProviderRetailLocationsQuery, GetThisServiceProviderRetailLocationsQueryVariables>(GetThisServiceProviderRetailLocationsDocument, options);
      }
export function useGetThisServiceProviderRetailLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThisServiceProviderRetailLocationsQuery, GetThisServiceProviderRetailLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThisServiceProviderRetailLocationsQuery, GetThisServiceProviderRetailLocationsQueryVariables>(GetThisServiceProviderRetailLocationsDocument, options);
        }
export function useGetThisServiceProviderRetailLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThisServiceProviderRetailLocationsQuery, GetThisServiceProviderRetailLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThisServiceProviderRetailLocationsQuery, GetThisServiceProviderRetailLocationsQueryVariables>(GetThisServiceProviderRetailLocationsDocument, options);
        }
export type GetThisServiceProviderRetailLocationsQueryHookResult = ReturnType<typeof useGetThisServiceProviderRetailLocationsQuery>;
export type GetThisServiceProviderRetailLocationsLazyQueryHookResult = ReturnType<typeof useGetThisServiceProviderRetailLocationsLazyQuery>;
export type GetThisServiceProviderRetailLocationsSuspenseQueryHookResult = ReturnType<typeof useGetThisServiceProviderRetailLocationsSuspenseQuery>;
export type GetThisServiceProviderRetailLocationsQueryResult = Apollo.QueryResult<GetThisServiceProviderRetailLocationsQuery, GetThisServiceProviderRetailLocationsQueryVariables>;
export const GetThisServiceProviderWithServiceOfferingsAndProfileDocument = gql`
    query GetThisServiceProviderWithServiceOfferingsAndProfile {
  getThisServiceProvider {
    id
    displayName
    slug
    serviceType
    profile {
      avatarImage {
        uploadedFile {
          publicUrl
        }
      }
      photoGallery {
        items {
          index
          imageFile {
            uploadedFile {
              publicUrl
            }
          }
        }
      }
    }
    serviceOfferings {
      title
      basePrice
      shortDesc
      baseTime
      imageUrl
      uid
      type
      allowTip
      maxConcurrentBookings
      index
      postServiceNote
      customerInputs {
        uid
      }
    }
  }
}
    `;

/**
 * __useGetThisServiceProviderWithServiceOfferingsAndProfileQuery__
 *
 * To run a query within a React component, call `useGetThisServiceProviderWithServiceOfferingsAndProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThisServiceProviderWithServiceOfferingsAndProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThisServiceProviderWithServiceOfferingsAndProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThisServiceProviderWithServiceOfferingsAndProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetThisServiceProviderWithServiceOfferingsAndProfileQuery, GetThisServiceProviderWithServiceOfferingsAndProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThisServiceProviderWithServiceOfferingsAndProfileQuery, GetThisServiceProviderWithServiceOfferingsAndProfileQueryVariables>(GetThisServiceProviderWithServiceOfferingsAndProfileDocument, options);
      }
export function useGetThisServiceProviderWithServiceOfferingsAndProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThisServiceProviderWithServiceOfferingsAndProfileQuery, GetThisServiceProviderWithServiceOfferingsAndProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThisServiceProviderWithServiceOfferingsAndProfileQuery, GetThisServiceProviderWithServiceOfferingsAndProfileQueryVariables>(GetThisServiceProviderWithServiceOfferingsAndProfileDocument, options);
        }
export function useGetThisServiceProviderWithServiceOfferingsAndProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThisServiceProviderWithServiceOfferingsAndProfileQuery, GetThisServiceProviderWithServiceOfferingsAndProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThisServiceProviderWithServiceOfferingsAndProfileQuery, GetThisServiceProviderWithServiceOfferingsAndProfileQueryVariables>(GetThisServiceProviderWithServiceOfferingsAndProfileDocument, options);
        }
export type GetThisServiceProviderWithServiceOfferingsAndProfileQueryHookResult = ReturnType<typeof useGetThisServiceProviderWithServiceOfferingsAndProfileQuery>;
export type GetThisServiceProviderWithServiceOfferingsAndProfileLazyQueryHookResult = ReturnType<typeof useGetThisServiceProviderWithServiceOfferingsAndProfileLazyQuery>;
export type GetThisServiceProviderWithServiceOfferingsAndProfileSuspenseQueryHookResult = ReturnType<typeof useGetThisServiceProviderWithServiceOfferingsAndProfileSuspenseQuery>;
export type GetThisServiceProviderWithServiceOfferingsAndProfileQueryResult = Apollo.QueryResult<GetThisServiceProviderWithServiceOfferingsAndProfileQuery, GetThisServiceProviderWithServiceOfferingsAndProfileQueryVariables>;
export const GetThisServiceProviderWithServiceOfferingsDocument = gql`
    query GetThisServiceProviderWithServiceOfferings {
  getThisServiceProvider {
    id
    serviceOfferings {
      title
      basePrice
      shortDesc
      baseTime
      imageUrl
      uid
      type
      allowTip
      maxConcurrentBookings
      index
      postServiceNote
      isHidden
      customerInputs {
        uid
      }
    }
  }
}
    `;

/**
 * __useGetThisServiceProviderWithServiceOfferingsQuery__
 *
 * To run a query within a React component, call `useGetThisServiceProviderWithServiceOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThisServiceProviderWithServiceOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThisServiceProviderWithServiceOfferingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThisServiceProviderWithServiceOfferingsQuery(baseOptions?: Apollo.QueryHookOptions<GetThisServiceProviderWithServiceOfferingsQuery, GetThisServiceProviderWithServiceOfferingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThisServiceProviderWithServiceOfferingsQuery, GetThisServiceProviderWithServiceOfferingsQueryVariables>(GetThisServiceProviderWithServiceOfferingsDocument, options);
      }
export function useGetThisServiceProviderWithServiceOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThisServiceProviderWithServiceOfferingsQuery, GetThisServiceProviderWithServiceOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThisServiceProviderWithServiceOfferingsQuery, GetThisServiceProviderWithServiceOfferingsQueryVariables>(GetThisServiceProviderWithServiceOfferingsDocument, options);
        }
export function useGetThisServiceProviderWithServiceOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThisServiceProviderWithServiceOfferingsQuery, GetThisServiceProviderWithServiceOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThisServiceProviderWithServiceOfferingsQuery, GetThisServiceProviderWithServiceOfferingsQueryVariables>(GetThisServiceProviderWithServiceOfferingsDocument, options);
        }
export type GetThisServiceProviderWithServiceOfferingsQueryHookResult = ReturnType<typeof useGetThisServiceProviderWithServiceOfferingsQuery>;
export type GetThisServiceProviderWithServiceOfferingsLazyQueryHookResult = ReturnType<typeof useGetThisServiceProviderWithServiceOfferingsLazyQuery>;
export type GetThisServiceProviderWithServiceOfferingsSuspenseQueryHookResult = ReturnType<typeof useGetThisServiceProviderWithServiceOfferingsSuspenseQuery>;
export type GetThisServiceProviderWithServiceOfferingsQueryResult = Apollo.QueryResult<GetThisServiceProviderWithServiceOfferingsQuery, GetThisServiceProviderWithServiceOfferingsQueryVariables>;
export const GetTravelTimesDocument = gql`
    query GetTravelTimes($serviceProviderUid: String!, $locationUid: String!, $startDateTimes: [Int!]!, $duration: Int!) {
  getServiceProviderTravelTimeForAppointment(
    serviceProviderUid: $serviceProviderUid
    locationUid: $locationUid
    startDateTimes: $startDateTimes
    duration: $duration
  ) {
    startDateTime
    endDateTime
  }
}
    `;

/**
 * __useGetTravelTimesQuery__
 *
 * To run a query within a React component, call `useGetTravelTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTravelTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTravelTimesQuery({
 *   variables: {
 *      serviceProviderUid: // value for 'serviceProviderUid'
 *      locationUid: // value for 'locationUid'
 *      startDateTimes: // value for 'startDateTimes'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useGetTravelTimesQuery(baseOptions: Apollo.QueryHookOptions<GetTravelTimesQuery, GetTravelTimesQueryVariables> & ({ variables: GetTravelTimesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTravelTimesQuery, GetTravelTimesQueryVariables>(GetTravelTimesDocument, options);
      }
export function useGetTravelTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTravelTimesQuery, GetTravelTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTravelTimesQuery, GetTravelTimesQueryVariables>(GetTravelTimesDocument, options);
        }
export function useGetTravelTimesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTravelTimesQuery, GetTravelTimesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTravelTimesQuery, GetTravelTimesQueryVariables>(GetTravelTimesDocument, options);
        }
export type GetTravelTimesQueryHookResult = ReturnType<typeof useGetTravelTimesQuery>;
export type GetTravelTimesLazyQueryHookResult = ReturnType<typeof useGetTravelTimesLazyQuery>;
export type GetTravelTimesSuspenseQueryHookResult = ReturnType<typeof useGetTravelTimesSuspenseQuery>;
export type GetTravelTimesQueryResult = Apollo.QueryResult<GetTravelTimesQuery, GetTravelTimesQueryVariables>;
export const GetUserSubscriptionStatusDocument = gql`
    query GetUserSubscriptionStatus($productId: ID!) {
  getUserSubscriptionStatus(productId: $productId) {
    isSubscribed
    status
  }
}
    `;

/**
 * __useGetUserSubscriptionStatusQuery__
 *
 * To run a query within a React component, call `useGetUserSubscriptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSubscriptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSubscriptionStatusQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetUserSubscriptionStatusQuery(baseOptions: Apollo.QueryHookOptions<GetUserSubscriptionStatusQuery, GetUserSubscriptionStatusQueryVariables> & ({ variables: GetUserSubscriptionStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSubscriptionStatusQuery, GetUserSubscriptionStatusQueryVariables>(GetUserSubscriptionStatusDocument, options);
      }
export function useGetUserSubscriptionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSubscriptionStatusQuery, GetUserSubscriptionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSubscriptionStatusQuery, GetUserSubscriptionStatusQueryVariables>(GetUserSubscriptionStatusDocument, options);
        }
export function useGetUserSubscriptionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSubscriptionStatusQuery, GetUserSubscriptionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSubscriptionStatusQuery, GetUserSubscriptionStatusQueryVariables>(GetUserSubscriptionStatusDocument, options);
        }
export type GetUserSubscriptionStatusQueryHookResult = ReturnType<typeof useGetUserSubscriptionStatusQuery>;
export type GetUserSubscriptionStatusLazyQueryHookResult = ReturnType<typeof useGetUserSubscriptionStatusLazyQuery>;
export type GetUserSubscriptionStatusSuspenseQueryHookResult = ReturnType<typeof useGetUserSubscriptionStatusSuspenseQuery>;
export type GetUserSubscriptionStatusQueryResult = Apollo.QueryResult<GetUserSubscriptionStatusQuery, GetUserSubscriptionStatusQueryVariables>;
export const GetUserWithBusinessDocument = gql`
    query GetUserWithBusiness {
  getUser {
    business {
      uid
      locations {
        id
        uid
      }
    }
  }
}
    `;

/**
 * __useGetUserWithBusinessQuery__
 *
 * To run a query within a React component, call `useGetUserWithBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithBusinessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWithBusinessQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWithBusinessQuery, GetUserWithBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWithBusinessQuery, GetUserWithBusinessQueryVariables>(GetUserWithBusinessDocument, options);
      }
export function useGetUserWithBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWithBusinessQuery, GetUserWithBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWithBusinessQuery, GetUserWithBusinessQueryVariables>(GetUserWithBusinessDocument, options);
        }
export function useGetUserWithBusinessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserWithBusinessQuery, GetUserWithBusinessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserWithBusinessQuery, GetUserWithBusinessQueryVariables>(GetUserWithBusinessDocument, options);
        }
export type GetUserWithBusinessQueryHookResult = ReturnType<typeof useGetUserWithBusinessQuery>;
export type GetUserWithBusinessLazyQueryHookResult = ReturnType<typeof useGetUserWithBusinessLazyQuery>;
export type GetUserWithBusinessSuspenseQueryHookResult = ReturnType<typeof useGetUserWithBusinessSuspenseQuery>;
export type GetUserWithBusinessQueryResult = Apollo.QueryResult<GetUserWithBusinessQuery, GetUserWithBusinessQueryVariables>;
export const GetUserWithLocationsDocument = gql`
    query GetUserWithLocations {
  getUser {
    isTemporary
    uid
    locations {
      uid
      id
      streetAddress
      placeId
      latitude
      longitude
      type
    }
  }
}
    `;

/**
 * __useGetUserWithLocationsQuery__
 *
 * To run a query within a React component, call `useGetUserWithLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWithLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWithLocationsQuery, GetUserWithLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWithLocationsQuery, GetUserWithLocationsQueryVariables>(GetUserWithLocationsDocument, options);
      }
export function useGetUserWithLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWithLocationsQuery, GetUserWithLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWithLocationsQuery, GetUserWithLocationsQueryVariables>(GetUserWithLocationsDocument, options);
        }
export function useGetUserWithLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserWithLocationsQuery, GetUserWithLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserWithLocationsQuery, GetUserWithLocationsQueryVariables>(GetUserWithLocationsDocument, options);
        }
export type GetUserWithLocationsQueryHookResult = ReturnType<typeof useGetUserWithLocationsQuery>;
export type GetUserWithLocationsLazyQueryHookResult = ReturnType<typeof useGetUserWithLocationsLazyQuery>;
export type GetUserWithLocationsSuspenseQueryHookResult = ReturnType<typeof useGetUserWithLocationsSuspenseQuery>;
export type GetUserWithLocationsQueryResult = Apollo.QueryResult<GetUserWithLocationsQuery, GetUserWithLocationsQueryVariables>;
export const ExchangeGoogleCalendarAccessCodeAndStoreTokenDocument = gql`
    mutation ExchangeGoogleCalendarAccessCodeAndStoreToken($accessCode: String!) {
  exchangeGoogleCalendarAccessCodeAndStoreToken(accessCode: $accessCode)
}
    `;
export type ExchangeGoogleCalendarAccessCodeAndStoreTokenMutationFn = Apollo.MutationFunction<ExchangeGoogleCalendarAccessCodeAndStoreTokenMutation, ExchangeGoogleCalendarAccessCodeAndStoreTokenMutationVariables>;

/**
 * __useExchangeGoogleCalendarAccessCodeAndStoreTokenMutation__
 *
 * To run a mutation, you first call `useExchangeGoogleCalendarAccessCodeAndStoreTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeGoogleCalendarAccessCodeAndStoreTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeGoogleCalendarAccessCodeAndStoreTokenMutation, { data, loading, error }] = useExchangeGoogleCalendarAccessCodeAndStoreTokenMutation({
 *   variables: {
 *      accessCode: // value for 'accessCode'
 *   },
 * });
 */
export function useExchangeGoogleCalendarAccessCodeAndStoreTokenMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeGoogleCalendarAccessCodeAndStoreTokenMutation, ExchangeGoogleCalendarAccessCodeAndStoreTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeGoogleCalendarAccessCodeAndStoreTokenMutation, ExchangeGoogleCalendarAccessCodeAndStoreTokenMutationVariables>(ExchangeGoogleCalendarAccessCodeAndStoreTokenDocument, options);
      }
export type ExchangeGoogleCalendarAccessCodeAndStoreTokenMutationHookResult = ReturnType<typeof useExchangeGoogleCalendarAccessCodeAndStoreTokenMutation>;
export type ExchangeGoogleCalendarAccessCodeAndStoreTokenMutationResult = Apollo.MutationResult<ExchangeGoogleCalendarAccessCodeAndStoreTokenMutation>;
export type ExchangeGoogleCalendarAccessCodeAndStoreTokenMutationOptions = Apollo.BaseMutationOptions<ExchangeGoogleCalendarAccessCodeAndStoreTokenMutation, ExchangeGoogleCalendarAccessCodeAndStoreTokenMutationVariables>;
export const V2Gateway_GetIdentityHasLinkedStripeSourceDocument = gql`
    query V2Gateway_GetIdentityHasLinkedStripeSource {
  identityHasLinkedStripeSource
}
    `;

/**
 * __useV2Gateway_GetIdentityHasLinkedStripeSourceQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetIdentityHasLinkedStripeSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetIdentityHasLinkedStripeSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetIdentityHasLinkedStripeSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetIdentityHasLinkedStripeSourceQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetIdentityHasLinkedStripeSourceQuery, V2Gateway_GetIdentityHasLinkedStripeSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetIdentityHasLinkedStripeSourceQuery, V2Gateway_GetIdentityHasLinkedStripeSourceQueryVariables>(V2Gateway_GetIdentityHasLinkedStripeSourceDocument, options);
      }
export function useV2Gateway_GetIdentityHasLinkedStripeSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetIdentityHasLinkedStripeSourceQuery, V2Gateway_GetIdentityHasLinkedStripeSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetIdentityHasLinkedStripeSourceQuery, V2Gateway_GetIdentityHasLinkedStripeSourceQueryVariables>(V2Gateway_GetIdentityHasLinkedStripeSourceDocument, options);
        }
export function useV2Gateway_GetIdentityHasLinkedStripeSourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetIdentityHasLinkedStripeSourceQuery, V2Gateway_GetIdentityHasLinkedStripeSourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetIdentityHasLinkedStripeSourceQuery, V2Gateway_GetIdentityHasLinkedStripeSourceQueryVariables>(V2Gateway_GetIdentityHasLinkedStripeSourceDocument, options);
        }
export type V2Gateway_GetIdentityHasLinkedStripeSourceQueryHookResult = ReturnType<typeof useV2Gateway_GetIdentityHasLinkedStripeSourceQuery>;
export type V2Gateway_GetIdentityHasLinkedStripeSourceLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetIdentityHasLinkedStripeSourceLazyQuery>;
export type V2Gateway_GetIdentityHasLinkedStripeSourceSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetIdentityHasLinkedStripeSourceSuspenseQuery>;
export type V2Gateway_GetIdentityHasLinkedStripeSourceQueryResult = Apollo.QueryResult<V2Gateway_GetIdentityHasLinkedStripeSourceQuery, V2Gateway_GetIdentityHasLinkedStripeSourceQueryVariables>;
export const V2Gateway_MigrateAnonymousIdentityDocument = gql`
    mutation V2Gateway_MigrateAnonymousIdentity($anonymousIdToken: String!, $ownerIdToken: String!) {
  migrateAnonymousIdentity(
    anonymousIdToken: $anonymousIdToken
    ownerIdToken: $ownerIdToken
  )
}
    `;
export type V2Gateway_MigrateAnonymousIdentityMutationFn = Apollo.MutationFunction<V2Gateway_MigrateAnonymousIdentityMutation, V2Gateway_MigrateAnonymousIdentityMutationVariables>;

/**
 * __useV2Gateway_MigrateAnonymousIdentityMutation__
 *
 * To run a mutation, you first call `useV2Gateway_MigrateAnonymousIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_MigrateAnonymousIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayMigrateAnonymousIdentityMutation, { data, loading, error }] = useV2Gateway_MigrateAnonymousIdentityMutation({
 *   variables: {
 *      anonymousIdToken: // value for 'anonymousIdToken'
 *      ownerIdToken: // value for 'ownerIdToken'
 *   },
 * });
 */
export function useV2Gateway_MigrateAnonymousIdentityMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_MigrateAnonymousIdentityMutation, V2Gateway_MigrateAnonymousIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_MigrateAnonymousIdentityMutation, V2Gateway_MigrateAnonymousIdentityMutationVariables>(V2Gateway_MigrateAnonymousIdentityDocument, options);
      }
export type V2Gateway_MigrateAnonymousIdentityMutationHookResult = ReturnType<typeof useV2Gateway_MigrateAnonymousIdentityMutation>;
export type V2Gateway_MigrateAnonymousIdentityMutationResult = Apollo.MutationResult<V2Gateway_MigrateAnonymousIdentityMutation>;
export type V2Gateway_MigrateAnonymousIdentityMutationOptions = Apollo.BaseMutationOptions<V2Gateway_MigrateAnonymousIdentityMutation, V2Gateway_MigrateAnonymousIdentityMutationVariables>;
export const ImportSquareCustomerDocument = gql`
    mutation ImportSquareCustomer($id: String!) {
  importSquareCustomer(customerId: $id)
}
    `;
export type ImportSquareCustomerMutationFn = Apollo.MutationFunction<ImportSquareCustomerMutation, ImportSquareCustomerMutationVariables>;

/**
 * __useImportSquareCustomerMutation__
 *
 * To run a mutation, you first call `useImportSquareCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportSquareCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importSquareCustomerMutation, { data, loading, error }] = useImportSquareCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportSquareCustomerMutation(baseOptions?: Apollo.MutationHookOptions<ImportSquareCustomerMutation, ImportSquareCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportSquareCustomerMutation, ImportSquareCustomerMutationVariables>(ImportSquareCustomerDocument, options);
      }
export type ImportSquareCustomerMutationHookResult = ReturnType<typeof useImportSquareCustomerMutation>;
export type ImportSquareCustomerMutationResult = Apollo.MutationResult<ImportSquareCustomerMutation>;
export type ImportSquareCustomerMutationOptions = Apollo.BaseMutationOptions<ImportSquareCustomerMutation, ImportSquareCustomerMutationVariables>;
export const ListSquareCardsForCustomerDocument = gql`
    query ListSquareCardsForCustomer($customerId: ID!) {
  listSquareCardsForCustomer(customerId: $customerId) {
    id
    cardBrand
    last4
    expMonth
    expYear
    cardholderName
  }
}
    `;

/**
 * __useListSquareCardsForCustomerQuery__
 *
 * To run a query within a React component, call `useListSquareCardsForCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSquareCardsForCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSquareCardsForCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useListSquareCardsForCustomerQuery(baseOptions: Apollo.QueryHookOptions<ListSquareCardsForCustomerQuery, ListSquareCardsForCustomerQueryVariables> & ({ variables: ListSquareCardsForCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSquareCardsForCustomerQuery, ListSquareCardsForCustomerQueryVariables>(ListSquareCardsForCustomerDocument, options);
      }
export function useListSquareCardsForCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSquareCardsForCustomerQuery, ListSquareCardsForCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSquareCardsForCustomerQuery, ListSquareCardsForCustomerQueryVariables>(ListSquareCardsForCustomerDocument, options);
        }
export function useListSquareCardsForCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSquareCardsForCustomerQuery, ListSquareCardsForCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSquareCardsForCustomerQuery, ListSquareCardsForCustomerQueryVariables>(ListSquareCardsForCustomerDocument, options);
        }
export type ListSquareCardsForCustomerQueryHookResult = ReturnType<typeof useListSquareCardsForCustomerQuery>;
export type ListSquareCardsForCustomerLazyQueryHookResult = ReturnType<typeof useListSquareCardsForCustomerLazyQuery>;
export type ListSquareCardsForCustomerSuspenseQueryHookResult = ReturnType<typeof useListSquareCardsForCustomerSuspenseQuery>;
export type ListSquareCardsForCustomerQueryResult = Apollo.QueryResult<ListSquareCardsForCustomerQuery, ListSquareCardsForCustomerQueryVariables>;
export const GetLocationSubscriptionForOwnerForLocationDocument = gql`
    query GetLocationSubscriptionForOwnerForLocation($locationUid: String!) {
  getLocationSubscriptionForOwnerForLocation(locationUid: $locationUid) {
    locationUid
    ownerUid
  }
}
    `;

/**
 * __useGetLocationSubscriptionForOwnerForLocationQuery__
 *
 * To run a query within a React component, call `useGetLocationSubscriptionForOwnerForLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationSubscriptionForOwnerForLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationSubscriptionForOwnerForLocationQuery({
 *   variables: {
 *      locationUid: // value for 'locationUid'
 *   },
 * });
 */
export function useGetLocationSubscriptionForOwnerForLocationQuery(baseOptions: Apollo.QueryHookOptions<GetLocationSubscriptionForOwnerForLocationQuery, GetLocationSubscriptionForOwnerForLocationQueryVariables> & ({ variables: GetLocationSubscriptionForOwnerForLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationSubscriptionForOwnerForLocationQuery, GetLocationSubscriptionForOwnerForLocationQueryVariables>(GetLocationSubscriptionForOwnerForLocationDocument, options);
      }
export function useGetLocationSubscriptionForOwnerForLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationSubscriptionForOwnerForLocationQuery, GetLocationSubscriptionForOwnerForLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationSubscriptionForOwnerForLocationQuery, GetLocationSubscriptionForOwnerForLocationQueryVariables>(GetLocationSubscriptionForOwnerForLocationDocument, options);
        }
export function useGetLocationSubscriptionForOwnerForLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationSubscriptionForOwnerForLocationQuery, GetLocationSubscriptionForOwnerForLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationSubscriptionForOwnerForLocationQuery, GetLocationSubscriptionForOwnerForLocationQueryVariables>(GetLocationSubscriptionForOwnerForLocationDocument, options);
        }
export type GetLocationSubscriptionForOwnerForLocationQueryHookResult = ReturnType<typeof useGetLocationSubscriptionForOwnerForLocationQuery>;
export type GetLocationSubscriptionForOwnerForLocationLazyQueryHookResult = ReturnType<typeof useGetLocationSubscriptionForOwnerForLocationLazyQuery>;
export type GetLocationSubscriptionForOwnerForLocationSuspenseQueryHookResult = ReturnType<typeof useGetLocationSubscriptionForOwnerForLocationSuspenseQuery>;
export type GetLocationSubscriptionForOwnerForLocationQueryResult = Apollo.QueryResult<GetLocationSubscriptionForOwnerForLocationQuery, GetLocationSubscriptionForOwnerForLocationQueryVariables>;
export const QueryLocationSubscriptionsDocument = gql`
    query QueryLocationSubscriptions($query: LocationSubscriptionQuery!) {
  queryLocationSubscriptions(query: $query) {
    location {
      id
      uid
      name
      formattedAddress
    }
    owner {
      fullName
      emailAddress
      phoneNumber
      uid
    }
  }
}
    `;

/**
 * __useQueryLocationSubscriptionsQuery__
 *
 * To run a query within a React component, call `useQueryLocationSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryLocationSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryLocationSubscriptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useQueryLocationSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<QueryLocationSubscriptionsQuery, QueryLocationSubscriptionsQueryVariables> & ({ variables: QueryLocationSubscriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryLocationSubscriptionsQuery, QueryLocationSubscriptionsQueryVariables>(QueryLocationSubscriptionsDocument, options);
      }
export function useQueryLocationSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryLocationSubscriptionsQuery, QueryLocationSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryLocationSubscriptionsQuery, QueryLocationSubscriptionsQueryVariables>(QueryLocationSubscriptionsDocument, options);
        }
export function useQueryLocationSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryLocationSubscriptionsQuery, QueryLocationSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryLocationSubscriptionsQuery, QueryLocationSubscriptionsQueryVariables>(QueryLocationSubscriptionsDocument, options);
        }
export type QueryLocationSubscriptionsQueryHookResult = ReturnType<typeof useQueryLocationSubscriptionsQuery>;
export type QueryLocationSubscriptionsLazyQueryHookResult = ReturnType<typeof useQueryLocationSubscriptionsLazyQuery>;
export type QueryLocationSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useQueryLocationSubscriptionsSuspenseQuery>;
export type QueryLocationSubscriptionsQueryResult = Apollo.QueryResult<QueryLocationSubscriptionsQuery, QueryLocationSubscriptionsQueryVariables>;
export const QueryLocationSubscriptionsCountDocument = gql`
    query QueryLocationSubscriptionsCount($query: LocationSubscriptionQuery!) {
  queryLocationSubscriptionsCount(query: $query)
}
    `;

/**
 * __useQueryLocationSubscriptionsCountQuery__
 *
 * To run a query within a React component, call `useQueryLocationSubscriptionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryLocationSubscriptionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryLocationSubscriptionsCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useQueryLocationSubscriptionsCountQuery(baseOptions: Apollo.QueryHookOptions<QueryLocationSubscriptionsCountQuery, QueryLocationSubscriptionsCountQueryVariables> & ({ variables: QueryLocationSubscriptionsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryLocationSubscriptionsCountQuery, QueryLocationSubscriptionsCountQueryVariables>(QueryLocationSubscriptionsCountDocument, options);
      }
export function useQueryLocationSubscriptionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryLocationSubscriptionsCountQuery, QueryLocationSubscriptionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryLocationSubscriptionsCountQuery, QueryLocationSubscriptionsCountQueryVariables>(QueryLocationSubscriptionsCountDocument, options);
        }
export function useQueryLocationSubscriptionsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryLocationSubscriptionsCountQuery, QueryLocationSubscriptionsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryLocationSubscriptionsCountQuery, QueryLocationSubscriptionsCountQueryVariables>(QueryLocationSubscriptionsCountDocument, options);
        }
export type QueryLocationSubscriptionsCountQueryHookResult = ReturnType<typeof useQueryLocationSubscriptionsCountQuery>;
export type QueryLocationSubscriptionsCountLazyQueryHookResult = ReturnType<typeof useQueryLocationSubscriptionsCountLazyQuery>;
export type QueryLocationSubscriptionsCountSuspenseQueryHookResult = ReturnType<typeof useQueryLocationSubscriptionsCountSuspenseQuery>;
export type QueryLocationSubscriptionsCountQueryResult = Apollo.QueryResult<QueryLocationSubscriptionsCountQuery, QueryLocationSubscriptionsCountQueryVariables>;
export const RecordAticDocument = gql`
    mutation RecordAtic($type: AnalyticsEventType!, $metadata: AnalyticsEventMetadataInput) {
  recordAtic(type: $type, metadata: $metadata)
}
    `;
export type RecordAticMutationFn = Apollo.MutationFunction<RecordAticMutation, RecordAticMutationVariables>;

/**
 * __useRecordAticMutation__
 *
 * To run a mutation, you first call `useRecordAticMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordAticMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordAticMutation, { data, loading, error }] = useRecordAticMutation({
 *   variables: {
 *      type: // value for 'type'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useRecordAticMutation(baseOptions?: Apollo.MutationHookOptions<RecordAticMutation, RecordAticMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordAticMutation, RecordAticMutationVariables>(RecordAticDocument, options);
      }
export type RecordAticMutationHookResult = ReturnType<typeof useRecordAticMutation>;
export type RecordAticMutationResult = Apollo.MutationResult<RecordAticMutation>;
export type RecordAticMutationOptions = Apollo.BaseMutationOptions<RecordAticMutation, RecordAticMutationVariables>;
export const RefreshSessionDocument = gql`
    mutation RefreshSession($idToken: String!) {
  refreshSession(idToken: $idToken)
}
    `;
export type RefreshSessionMutationFn = Apollo.MutationFunction<RefreshSessionMutation, RefreshSessionMutationVariables>;

/**
 * __useRefreshSessionMutation__
 *
 * To run a mutation, you first call `useRefreshSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSessionMutation, { data, loading, error }] = useRefreshSessionMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *   },
 * });
 */
export function useRefreshSessionMutation(baseOptions?: Apollo.MutationHookOptions<RefreshSessionMutation, RefreshSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshSessionMutation, RefreshSessionMutationVariables>(RefreshSessionDocument, options);
      }
export type RefreshSessionMutationHookResult = ReturnType<typeof useRefreshSessionMutation>;
export type RefreshSessionMutationResult = Apollo.MutationResult<RefreshSessionMutation>;
export type RefreshSessionMutationOptions = Apollo.BaseMutationOptions<RefreshSessionMutation, RefreshSessionMutationVariables>;
export const RegisterBookingIdForCustomerDocument = gql`
    mutation RegisterBookingIdForCustomer($customerId: String!) {
  registerBookingIdForCustomer(customerId: $customerId)
}
    `;
export type RegisterBookingIdForCustomerMutationFn = Apollo.MutationFunction<RegisterBookingIdForCustomerMutation, RegisterBookingIdForCustomerMutationVariables>;

/**
 * __useRegisterBookingIdForCustomerMutation__
 *
 * To run a mutation, you first call `useRegisterBookingIdForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterBookingIdForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerBookingIdForCustomerMutation, { data, loading, error }] = useRegisterBookingIdForCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useRegisterBookingIdForCustomerMutation(baseOptions?: Apollo.MutationHookOptions<RegisterBookingIdForCustomerMutation, RegisterBookingIdForCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterBookingIdForCustomerMutation, RegisterBookingIdForCustomerMutationVariables>(RegisterBookingIdForCustomerDocument, options);
      }
export type RegisterBookingIdForCustomerMutationHookResult = ReturnType<typeof useRegisterBookingIdForCustomerMutation>;
export type RegisterBookingIdForCustomerMutationResult = Apollo.MutationResult<RegisterBookingIdForCustomerMutation>;
export type RegisterBookingIdForCustomerMutationOptions = Apollo.BaseMutationOptions<RegisterBookingIdForCustomerMutation, RegisterBookingIdForCustomerMutationVariables>;
export const RegisterBusinessDocument = gql`
    mutation RegisterBusiness($idToken: String!, $timezoneLocation: String!, $phoneNumber: String!, $business: BusinessInput!) {
  registerBusiness(
    idToken: $idToken
    timezoneLocation: $timezoneLocation
    phoneNumber: $phoneNumber
    business: $business
  )
}
    `;
export type RegisterBusinessMutationFn = Apollo.MutationFunction<RegisterBusinessMutation, RegisterBusinessMutationVariables>;

/**
 * __useRegisterBusinessMutation__
 *
 * To run a mutation, you first call `useRegisterBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerBusinessMutation, { data, loading, error }] = useRegisterBusinessMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *      timezoneLocation: // value for 'timezoneLocation'
 *      phoneNumber: // value for 'phoneNumber'
 *      business: // value for 'business'
 *   },
 * });
 */
export function useRegisterBusinessMutation(baseOptions?: Apollo.MutationHookOptions<RegisterBusinessMutation, RegisterBusinessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterBusinessMutation, RegisterBusinessMutationVariables>(RegisterBusinessDocument, options);
      }
export type RegisterBusinessMutationHookResult = ReturnType<typeof useRegisterBusinessMutation>;
export type RegisterBusinessMutationResult = Apollo.MutationResult<RegisterBusinessMutation>;
export type RegisterBusinessMutationOptions = Apollo.BaseMutationOptions<RegisterBusinessMutation, RegisterBusinessMutationVariables>;
export const RegisterServiceProviderDocument = gql`
    mutation RegisterServiceProvider($idToken: String!, $country: String!, $timezoneLocation: String!, $placeId: String!, $phoneNumber: String!, $serviceType: String!, $currency: String!, $businessName: String!) {
  createServiceProvider(
    idToken: $idToken
    country: $country
    timezoneLocation: $timezoneLocation
    placeId: $placeId
    phoneNumber: $phoneNumber
    serviceType: $serviceType
    currency: $currency
    businessName: $businessName
  )
}
    `;
export type RegisterServiceProviderMutationFn = Apollo.MutationFunction<RegisterServiceProviderMutation, RegisterServiceProviderMutationVariables>;

/**
 * __useRegisterServiceProviderMutation__
 *
 * To run a mutation, you first call `useRegisterServiceProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterServiceProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerServiceProviderMutation, { data, loading, error }] = useRegisterServiceProviderMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *      country: // value for 'country'
 *      timezoneLocation: // value for 'timezoneLocation'
 *      placeId: // value for 'placeId'
 *      phoneNumber: // value for 'phoneNumber'
 *      serviceType: // value for 'serviceType'
 *      currency: // value for 'currency'
 *      businessName: // value for 'businessName'
 *   },
 * });
 */
export function useRegisterServiceProviderMutation(baseOptions?: Apollo.MutationHookOptions<RegisterServiceProviderMutation, RegisterServiceProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterServiceProviderMutation, RegisterServiceProviderMutationVariables>(RegisterServiceProviderDocument, options);
      }
export type RegisterServiceProviderMutationHookResult = ReturnType<typeof useRegisterServiceProviderMutation>;
export type RegisterServiceProviderMutationResult = Apollo.MutationResult<RegisterServiceProviderMutation>;
export type RegisterServiceProviderMutationOptions = Apollo.BaseMutationOptions<RegisterServiceProviderMutation, RegisterServiceProviderMutationVariables>;
export const SearchCustomersDocument = gql`
    query SearchCustomers($query: String!) {
  searchCustomers(query: $query) {
    hasMoreResults
    customers {
      id
      user {
        uid
        fullName
        emailAddress
        phoneNumber
      }
    }
  }
}
    `;

/**
 * __useSearchCustomersQuery__
 *
 * To run a query within a React component, call `useSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchCustomersQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables> & ({ variables: SearchCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
      }
export function useSearchCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
        }
export function useSearchCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
        }
export type SearchCustomersQueryHookResult = ReturnType<typeof useSearchCustomersQuery>;
export type SearchCustomersLazyQueryHookResult = ReturnType<typeof useSearchCustomersLazyQuery>;
export type SearchCustomersSuspenseQueryHookResult = ReturnType<typeof useSearchCustomersSuspenseQuery>;
export type SearchCustomersQueryResult = Apollo.QueryResult<SearchCustomersQuery, SearchCustomersQueryVariables>;
export const V2Gateway_GetServiceOfferingWithCustomerInputsDocument = gql`
    query V2Gateway_GetServiceOfferingWithCustomerInputs($uid: String!) {
  getServiceOffering(uid: $uid) {
    ...serviceOfferingWithCustomerInputs
  }
}
    ${ServiceOfferingWithCustomerInputsFragmentDoc}`;

/**
 * __useV2Gateway_GetServiceOfferingWithCustomerInputsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetServiceOfferingWithCustomerInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetServiceOfferingWithCustomerInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetServiceOfferingWithCustomerInputsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useV2Gateway_GetServiceOfferingWithCustomerInputsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetServiceOfferingWithCustomerInputsQuery, V2Gateway_GetServiceOfferingWithCustomerInputsQueryVariables> & ({ variables: V2Gateway_GetServiceOfferingWithCustomerInputsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetServiceOfferingWithCustomerInputsQuery, V2Gateway_GetServiceOfferingWithCustomerInputsQueryVariables>(V2Gateway_GetServiceOfferingWithCustomerInputsDocument, options);
      }
export function useV2Gateway_GetServiceOfferingWithCustomerInputsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetServiceOfferingWithCustomerInputsQuery, V2Gateway_GetServiceOfferingWithCustomerInputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetServiceOfferingWithCustomerInputsQuery, V2Gateway_GetServiceOfferingWithCustomerInputsQueryVariables>(V2Gateway_GetServiceOfferingWithCustomerInputsDocument, options);
        }
export function useV2Gateway_GetServiceOfferingWithCustomerInputsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetServiceOfferingWithCustomerInputsQuery, V2Gateway_GetServiceOfferingWithCustomerInputsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetServiceOfferingWithCustomerInputsQuery, V2Gateway_GetServiceOfferingWithCustomerInputsQueryVariables>(V2Gateway_GetServiceOfferingWithCustomerInputsDocument, options);
        }
export type V2Gateway_GetServiceOfferingWithCustomerInputsQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingWithCustomerInputsQuery>;
export type V2Gateway_GetServiceOfferingWithCustomerInputsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingWithCustomerInputsLazyQuery>;
export type V2Gateway_GetServiceOfferingWithCustomerInputsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingWithCustomerInputsSuspenseQuery>;
export type V2Gateway_GetServiceOfferingWithCustomerInputsQueryResult = Apollo.QueryResult<V2Gateway_GetServiceOfferingWithCustomerInputsQuery, V2Gateway_GetServiceOfferingWithCustomerInputsQueryVariables>;
export const GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentDocument = gql`
    query GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointment($serviceProviderUid: String!, $locationUid: String!, $from: Int!, $to: Int!, $excludeBookingUid: String) {
  getServiceProviderCalendarUnavailableDateTimeBoundsForAppointment(
    serviceProviderUid: $serviceProviderUid
    locationUid: $locationUid
    from: $from
    to: $to
    excludeBookingUid: $excludeBookingUid
  ) {
    startDateTime
    endDateTime
  }
}
    `;

/**
 * __useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery({
 *   variables: {
 *      serviceProviderUid: // value for 'serviceProviderUid'
 *      locationUid: // value for 'locationUid'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      excludeBookingUid: // value for 'excludeBookingUid'
 *   },
 * });
 */
export function useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryVariables> & ({ variables: GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryVariables>(GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentDocument, options);
      }
export function useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryVariables>(GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentDocument, options);
        }
export function useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryVariables>(GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentDocument, options);
        }
export type GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryHookResult = ReturnType<typeof useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery>;
export type GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentLazyQueryHookResult = ReturnType<typeof useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentLazyQuery>;
export type GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentSuspenseQuery>;
export type GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryResult = Apollo.QueryResult<GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForAppointmentQueryVariables>;
export const GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingDocument = gql`
    query GetServiceProviderCalendarUnavailableDateTimeBoundsForBooking($serviceProviderUid: String!, $locationUid: String!, $from: Int!, $to: Int!, $excludeBookingUid: String, $selectedServiceOfferingUid: String!) {
  getServiceProviderCalendarUnavailableDateTimeBoundsForBooking(
    serviceProviderUid: $serviceProviderUid
    locationUid: $locationUid
    from: $from
    to: $to
    excludeBookingUid: $excludeBookingUid
    selectedServiceOfferingUid: $selectedServiceOfferingUid
  ) {
    startDateTime
    endDateTime
  }
}
    `;

/**
 * __useGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery({
 *   variables: {
 *      serviceProviderUid: // value for 'serviceProviderUid'
 *      locationUid: // value for 'locationUid'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      excludeBookingUid: // value for 'excludeBookingUid'
 *      selectedServiceOfferingUid: // value for 'selectedServiceOfferingUid'
 *   },
 * });
 */
export function useGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryVariables> & ({ variables: GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryVariables>(GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingDocument, options);
      }
export function useGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryVariables>(GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingDocument, options);
        }
export function useGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryVariables>(GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingDocument, options);
        }
export type GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryHookResult = ReturnType<typeof useGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery>;
export type GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingLazyQueryHookResult = ReturnType<typeof useGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingLazyQuery>;
export type GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderCalendarUnavailableDateTimeBoundsForBookingSuspenseQuery>;
export type GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryResult = Apollo.QueryResult<GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQuery, GetServiceProviderCalendarUnavailableDateTimeBoundsForBookingQueryVariables>;
export const V2Gateway_CancelBookingDocument = gql`
    mutation V2Gateway_CancelBooking($bookingUid: String!, $cancelReason: String!) {
  cancelBooking(bookingUid: $bookingUid, cancelReason: $cancelReason)
}
    `;
export type V2Gateway_CancelBookingMutationFn = Apollo.MutationFunction<V2Gateway_CancelBookingMutation, V2Gateway_CancelBookingMutationVariables>;

/**
 * __useV2Gateway_CancelBookingMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CancelBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CancelBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCancelBookingMutation, { data, loading, error }] = useV2Gateway_CancelBookingMutation({
 *   variables: {
 *      bookingUid: // value for 'bookingUid'
 *      cancelReason: // value for 'cancelReason'
 *   },
 * });
 */
export function useV2Gateway_CancelBookingMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CancelBookingMutation, V2Gateway_CancelBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CancelBookingMutation, V2Gateway_CancelBookingMutationVariables>(V2Gateway_CancelBookingDocument, options);
      }
export type V2Gateway_CancelBookingMutationHookResult = ReturnType<typeof useV2Gateway_CancelBookingMutation>;
export type V2Gateway_CancelBookingMutationResult = Apollo.MutationResult<V2Gateway_CancelBookingMutation>;
export type V2Gateway_CancelBookingMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CancelBookingMutation, V2Gateway_CancelBookingMutationVariables>;
export const GetServiceProviderDocument = gql`
    query GetServiceProvider($ownerUid: String!) {
  getServiceProvider(ownerUid: $ownerUid) {
    ...serviceProviderFullNew
    dayOfWeekAvailability {
      dayOfWeek
      timezone
      ownerUid
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    reviewCount
    averageRating
    location {
      id
      phoneNumber
      discoverableBounds {
        min {
          lat
          lng
        }
        max {
          lat
          lng
        }
      }
    }
    user {
      emailAddress
    }
    profile {
      ...profileFragment
      socialLinks {
        platform
        url
      }
      introVideoURL
      emailThemeHex
    }
  }
}
    ${ServiceProviderFullNewFragmentDoc}
${ProfileFragmentFragmentDoc}`;

/**
 * __useGetServiceProviderQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderQuery({
 *   variables: {
 *      ownerUid: // value for 'ownerUid'
 *   },
 * });
 */
export function useGetServiceProviderQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderQuery, GetServiceProviderQueryVariables> & ({ variables: GetServiceProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderQuery, GetServiceProviderQueryVariables>(GetServiceProviderDocument, options);
      }
export function useGetServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderQuery, GetServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderQuery, GetServiceProviderQueryVariables>(GetServiceProviderDocument, options);
        }
export function useGetServiceProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderQuery, GetServiceProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderQuery, GetServiceProviderQueryVariables>(GetServiceProviderDocument, options);
        }
export type GetServiceProviderQueryHookResult = ReturnType<typeof useGetServiceProviderQuery>;
export type GetServiceProviderLazyQueryHookResult = ReturnType<typeof useGetServiceProviderLazyQuery>;
export type GetServiceProviderSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderSuspenseQuery>;
export type GetServiceProviderQueryResult = Apollo.QueryResult<GetServiceProviderQuery, GetServiceProviderQueryVariables>;
export const GetServiceProviderWithAvailabilityDocument = gql`
    query GetServiceProviderWithAvailability($ownerUid: String!) {
  getServiceProvider(ownerUid: $ownerUid) {
    ...serviceProviderFullNew
    isGoogleCalendarLinked
    dayOfWeekAvailability {
      dayOfWeek
      timezone
      ownerUid
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
    dateAvailability {
      date
      timezone
      ownerUid
      availability {
        timeUtcSecondsBounds {
          min
          max
        }
      }
    }
  }
}
    ${ServiceProviderFullNewFragmentDoc}`;

/**
 * __useGetServiceProviderWithAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderWithAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderWithAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderWithAvailabilityQuery({
 *   variables: {
 *      ownerUid: // value for 'ownerUid'
 *   },
 * });
 */
export function useGetServiceProviderWithAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderWithAvailabilityQuery, GetServiceProviderWithAvailabilityQueryVariables> & ({ variables: GetServiceProviderWithAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderWithAvailabilityQuery, GetServiceProviderWithAvailabilityQueryVariables>(GetServiceProviderWithAvailabilityDocument, options);
      }
export function useGetServiceProviderWithAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderWithAvailabilityQuery, GetServiceProviderWithAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderWithAvailabilityQuery, GetServiceProviderWithAvailabilityQueryVariables>(GetServiceProviderWithAvailabilityDocument, options);
        }
export function useGetServiceProviderWithAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderWithAvailabilityQuery, GetServiceProviderWithAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderWithAvailabilityQuery, GetServiceProviderWithAvailabilityQueryVariables>(GetServiceProviderWithAvailabilityDocument, options);
        }
export type GetServiceProviderWithAvailabilityQueryHookResult = ReturnType<typeof useGetServiceProviderWithAvailabilityQuery>;
export type GetServiceProviderWithAvailabilityLazyQueryHookResult = ReturnType<typeof useGetServiceProviderWithAvailabilityLazyQuery>;
export type GetServiceProviderWithAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderWithAvailabilitySuspenseQuery>;
export type GetServiceProviderWithAvailabilityQueryResult = Apollo.QueryResult<GetServiceProviderWithAvailabilityQuery, GetServiceProviderWithAvailabilityQueryVariables>;
export const V2Gateway_SetBookingsIsInProgressDocument = gql`
    mutation V2Gateway_SetBookingsIsInProgress($bookingUids: [String!]!) {
  setBookingsIsInProgress(bookingUids: $bookingUids)
}
    `;
export type V2Gateway_SetBookingsIsInProgressMutationFn = Apollo.MutationFunction<V2Gateway_SetBookingsIsInProgressMutation, V2Gateway_SetBookingsIsInProgressMutationVariables>;

/**
 * __useV2Gateway_SetBookingsIsInProgressMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SetBookingsIsInProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SetBookingsIsInProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySetBookingsIsInProgressMutation, { data, loading, error }] = useV2Gateway_SetBookingsIsInProgressMutation({
 *   variables: {
 *      bookingUids: // value for 'bookingUids'
 *   },
 * });
 */
export function useV2Gateway_SetBookingsIsInProgressMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SetBookingsIsInProgressMutation, V2Gateway_SetBookingsIsInProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SetBookingsIsInProgressMutation, V2Gateway_SetBookingsIsInProgressMutationVariables>(V2Gateway_SetBookingsIsInProgressDocument, options);
      }
export type V2Gateway_SetBookingsIsInProgressMutationHookResult = ReturnType<typeof useV2Gateway_SetBookingsIsInProgressMutation>;
export type V2Gateway_SetBookingsIsInProgressMutationResult = Apollo.MutationResult<V2Gateway_SetBookingsIsInProgressMutation>;
export type V2Gateway_SetBookingsIsInProgressMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SetBookingsIsInProgressMutation, V2Gateway_SetBookingsIsInProgressMutationVariables>;
export const SetDefaultPaymentMethodForCustomerDocument = gql`
    mutation SetDefaultPaymentMethodForCustomer($customerId: String!, $methodId: String!) {
  setDefaultPaymentMethodForCustomer(customerId: $customerId, methodId: $methodId)
}
    `;
export type SetDefaultPaymentMethodForCustomerMutationFn = Apollo.MutationFunction<SetDefaultPaymentMethodForCustomerMutation, SetDefaultPaymentMethodForCustomerMutationVariables>;

/**
 * __useSetDefaultPaymentMethodForCustomerMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentMethodForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentMethodForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentMethodForCustomerMutation, { data, loading, error }] = useSetDefaultPaymentMethodForCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      methodId: // value for 'methodId'
 *   },
 * });
 */
export function useSetDefaultPaymentMethodForCustomerMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentMethodForCustomerMutation, SetDefaultPaymentMethodForCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentMethodForCustomerMutation, SetDefaultPaymentMethodForCustomerMutationVariables>(SetDefaultPaymentMethodForCustomerDocument, options);
      }
export type SetDefaultPaymentMethodForCustomerMutationHookResult = ReturnType<typeof useSetDefaultPaymentMethodForCustomerMutation>;
export type SetDefaultPaymentMethodForCustomerMutationResult = Apollo.MutationResult<SetDefaultPaymentMethodForCustomerMutation>;
export type SetDefaultPaymentMethodForCustomerMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentMethodForCustomerMutation, SetDefaultPaymentMethodForCustomerMutationVariables>;
export const SetEmailTemplateDocument = gql`
    mutation SetEmailTemplate($input: EmailTemplateInput!) {
  setEmailTemplate(input: $input)
}
    `;
export type SetEmailTemplateMutationFn = Apollo.MutationFunction<SetEmailTemplateMutation, SetEmailTemplateMutationVariables>;

/**
 * __useSetEmailTemplateMutation__
 *
 * To run a mutation, you first call `useSetEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEmailTemplateMutation, { data, loading, error }] = useSetEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SetEmailTemplateMutation, SetEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEmailTemplateMutation, SetEmailTemplateMutationVariables>(SetEmailTemplateDocument, options);
      }
export type SetEmailTemplateMutationHookResult = ReturnType<typeof useSetEmailTemplateMutation>;
export type SetEmailTemplateMutationResult = Apollo.MutationResult<SetEmailTemplateMutation>;
export type SetEmailTemplateMutationOptions = Apollo.BaseMutationOptions<SetEmailTemplateMutation, SetEmailTemplateMutationVariables>;
export const SquareCreateTerminalCheckoutDocument = gql`
    mutation SquareCreateTerminalCheckout($deviceId: String!, $bookingId: String!) {
  createTerminalCheckout(deviceId: $deviceId, bookingId: $bookingId)
}
    `;
export type SquareCreateTerminalCheckoutMutationFn = Apollo.MutationFunction<SquareCreateTerminalCheckoutMutation, SquareCreateTerminalCheckoutMutationVariables>;

/**
 * __useSquareCreateTerminalCheckoutMutation__
 *
 * To run a mutation, you first call `useSquareCreateTerminalCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSquareCreateTerminalCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [squareCreateTerminalCheckoutMutation, { data, loading, error }] = useSquareCreateTerminalCheckoutMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useSquareCreateTerminalCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<SquareCreateTerminalCheckoutMutation, SquareCreateTerminalCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SquareCreateTerminalCheckoutMutation, SquareCreateTerminalCheckoutMutationVariables>(SquareCreateTerminalCheckoutDocument, options);
      }
export type SquareCreateTerminalCheckoutMutationHookResult = ReturnType<typeof useSquareCreateTerminalCheckoutMutation>;
export type SquareCreateTerminalCheckoutMutationResult = Apollo.MutationResult<SquareCreateTerminalCheckoutMutation>;
export type SquareCreateTerminalCheckoutMutationOptions = Apollo.BaseMutationOptions<SquareCreateTerminalCheckoutMutation, SquareCreateTerminalCheckoutMutationVariables>;
export const SquareGetDeviceCodesDocument = gql`
    query SquareGetDeviceCodes {
  getDeviceCodes {
    deviceCodes {
      name
      code
      deviceId
    }
  }
}
    `;

/**
 * __useSquareGetDeviceCodesQuery__
 *
 * To run a query within a React component, call `useSquareGetDeviceCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquareGetDeviceCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquareGetDeviceCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSquareGetDeviceCodesQuery(baseOptions?: Apollo.QueryHookOptions<SquareGetDeviceCodesQuery, SquareGetDeviceCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquareGetDeviceCodesQuery, SquareGetDeviceCodesQueryVariables>(SquareGetDeviceCodesDocument, options);
      }
export function useSquareGetDeviceCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquareGetDeviceCodesQuery, SquareGetDeviceCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquareGetDeviceCodesQuery, SquareGetDeviceCodesQueryVariables>(SquareGetDeviceCodesDocument, options);
        }
export function useSquareGetDeviceCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquareGetDeviceCodesQuery, SquareGetDeviceCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquareGetDeviceCodesQuery, SquareGetDeviceCodesQueryVariables>(SquareGetDeviceCodesDocument, options);
        }
export type SquareGetDeviceCodesQueryHookResult = ReturnType<typeof useSquareGetDeviceCodesQuery>;
export type SquareGetDeviceCodesLazyQueryHookResult = ReturnType<typeof useSquareGetDeviceCodesLazyQuery>;
export type SquareGetDeviceCodesSuspenseQueryHookResult = ReturnType<typeof useSquareGetDeviceCodesSuspenseQuery>;
export type SquareGetDeviceCodesQueryResult = Apollo.QueryResult<SquareGetDeviceCodesQuery, SquareGetDeviceCodesQueryVariables>;
export const SquareGetTerminalCheckoutDocument = gql`
    query SquareGetTerminalCheckout($checkoutId: String!) {
  getTerminalCheckout(checkoutId: $checkoutId) {
    status
  }
}
    `;

/**
 * __useSquareGetTerminalCheckoutQuery__
 *
 * To run a query within a React component, call `useSquareGetTerminalCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquareGetTerminalCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquareGetTerminalCheckoutQuery({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *   },
 * });
 */
export function useSquareGetTerminalCheckoutQuery(baseOptions: Apollo.QueryHookOptions<SquareGetTerminalCheckoutQuery, SquareGetTerminalCheckoutQueryVariables> & ({ variables: SquareGetTerminalCheckoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquareGetTerminalCheckoutQuery, SquareGetTerminalCheckoutQueryVariables>(SquareGetTerminalCheckoutDocument, options);
      }
export function useSquareGetTerminalCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquareGetTerminalCheckoutQuery, SquareGetTerminalCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquareGetTerminalCheckoutQuery, SquareGetTerminalCheckoutQueryVariables>(SquareGetTerminalCheckoutDocument, options);
        }
export function useSquareGetTerminalCheckoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquareGetTerminalCheckoutQuery, SquareGetTerminalCheckoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquareGetTerminalCheckoutQuery, SquareGetTerminalCheckoutQueryVariables>(SquareGetTerminalCheckoutDocument, options);
        }
export type SquareGetTerminalCheckoutQueryHookResult = ReturnType<typeof useSquareGetTerminalCheckoutQuery>;
export type SquareGetTerminalCheckoutLazyQueryHookResult = ReturnType<typeof useSquareGetTerminalCheckoutLazyQuery>;
export type SquareGetTerminalCheckoutSuspenseQueryHookResult = ReturnType<typeof useSquareGetTerminalCheckoutSuspenseQuery>;
export type SquareGetTerminalCheckoutQueryResult = Apollo.QueryResult<SquareGetTerminalCheckoutQuery, SquareGetTerminalCheckoutQueryVariables>;
export const SquareSearchCustomersDocument = gql`
    query SquareSearchCustomers($query: String!) {
  searchSquareCustomers(query: $query) {
    customers {
      id
      givenName
      familyName
      emailAddress
    }
  }
}
    `;

/**
 * __useSquareSearchCustomersQuery__
 *
 * To run a query within a React component, call `useSquareSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSquareSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSquareSearchCustomersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSquareSearchCustomersQuery(baseOptions: Apollo.QueryHookOptions<SquareSearchCustomersQuery, SquareSearchCustomersQueryVariables> & ({ variables: SquareSearchCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SquareSearchCustomersQuery, SquareSearchCustomersQueryVariables>(SquareSearchCustomersDocument, options);
      }
export function useSquareSearchCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SquareSearchCustomersQuery, SquareSearchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SquareSearchCustomersQuery, SquareSearchCustomersQueryVariables>(SquareSearchCustomersDocument, options);
        }
export function useSquareSearchCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SquareSearchCustomersQuery, SquareSearchCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SquareSearchCustomersQuery, SquareSearchCustomersQueryVariables>(SquareSearchCustomersDocument, options);
        }
export type SquareSearchCustomersQueryHookResult = ReturnType<typeof useSquareSearchCustomersQuery>;
export type SquareSearchCustomersLazyQueryHookResult = ReturnType<typeof useSquareSearchCustomersLazyQuery>;
export type SquareSearchCustomersSuspenseQueryHookResult = ReturnType<typeof useSquareSearchCustomersSuspenseQuery>;
export type SquareSearchCustomersQueryResult = Apollo.QueryResult<SquareSearchCustomersQuery, SquareSearchCustomersQueryVariables>;
export const V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsDocument = gql`
    mutation V2Gateway_CreateAppointmentRequestAndEagerBookingFromCarts($timezone: String!, $locationUid: String!, $appointmentCartUid: String!, $bookingCartUid: String!) {
  createAppointmentRequestAndEagerBookingFromCarts(
    timezone: $timezone
    locationUid: $locationUid
    appointmentCartUid: $appointmentCartUid
    bookingCartUid: $bookingCartUid
  ) {
    appointmentRequest {
      uid
      serviceProvider {
        ownerUid
      }
    }
    appointment {
      id
      uid
      serviceProvider {
        ownerUid
      }
    }
    booking {
      uid
    }
    eagerBooking {
      uid
    }
  }
}
    `;
export type V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutationFn = Apollo.MutationFunction<V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation, V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutationVariables>;

/**
 * __useV2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateAppointmentRequestAndEagerBookingFromCartsMutation, { data, loading, error }] = useV2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation({
 *   variables: {
 *      timezone: // value for 'timezone'
 *      locationUid: // value for 'locationUid'
 *      appointmentCartUid: // value for 'appointmentCartUid'
 *      bookingCartUid: // value for 'bookingCartUid'
 *   },
 * });
 */
export function useV2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation, V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation, V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutationVariables>(V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsDocument, options);
      }
export type V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutationHookResult = ReturnType<typeof useV2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation>;
export type V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutationResult = Apollo.MutationResult<V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation>;
export type V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutation, V2Gateway_CreateAppointmentRequestAndEagerBookingFromCartsMutationVariables>;
export const V2Gateway_CreateBookingFromCartDocument = gql`
    mutation V2Gateway_CreateBookingFromCart($bookingCartUid: String!) {
  createBookingFromCart(bookingCartUid: $bookingCartUid) {
    booking {
      uid
      appointment {
        uid
        serviceProvider {
          ownerUid
        }
        location {
          id
          uid
        }
      }
    }
  }
}
    `;
export type V2Gateway_CreateBookingFromCartMutationFn = Apollo.MutationFunction<V2Gateway_CreateBookingFromCartMutation, V2Gateway_CreateBookingFromCartMutationVariables>;

/**
 * __useV2Gateway_CreateBookingFromCartMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateBookingFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateBookingFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateBookingFromCartMutation, { data, loading, error }] = useV2Gateway_CreateBookingFromCartMutation({
 *   variables: {
 *      bookingCartUid: // value for 'bookingCartUid'
 *   },
 * });
 */
export function useV2Gateway_CreateBookingFromCartMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateBookingFromCartMutation, V2Gateway_CreateBookingFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateBookingFromCartMutation, V2Gateway_CreateBookingFromCartMutationVariables>(V2Gateway_CreateBookingFromCartDocument, options);
      }
export type V2Gateway_CreateBookingFromCartMutationHookResult = ReturnType<typeof useV2Gateway_CreateBookingFromCartMutation>;
export type V2Gateway_CreateBookingFromCartMutationResult = Apollo.MutationResult<V2Gateway_CreateBookingFromCartMutation>;
export type V2Gateway_CreateBookingFromCartMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateBookingFromCartMutation, V2Gateway_CreateBookingFromCartMutationVariables>;
export const SubscribeUserToProductDocument = gql`
    mutation SubscribeUserToProduct($productId: ID!) {
  subscribeUserToProduct(productId: $productId) {
    subscriptionId
  }
}
    `;
export type SubscribeUserToProductMutationFn = Apollo.MutationFunction<SubscribeUserToProductMutation, SubscribeUserToProductMutationVariables>;

/**
 * __useSubscribeUserToProductMutation__
 *
 * To run a mutation, you first call `useSubscribeUserToProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeUserToProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeUserToProductMutation, { data, loading, error }] = useSubscribeUserToProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useSubscribeUserToProductMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeUserToProductMutation, SubscribeUserToProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeUserToProductMutation, SubscribeUserToProductMutationVariables>(SubscribeUserToProductDocument, options);
      }
export type SubscribeUserToProductMutationHookResult = ReturnType<typeof useSubscribeUserToProductMutation>;
export type SubscribeUserToProductMutationResult = Apollo.MutationResult<SubscribeUserToProductMutation>;
export type SubscribeUserToProductMutationOptions = Apollo.BaseMutationOptions<SubscribeUserToProductMutation, SubscribeUserToProductMutationVariables>;
export const SyncServiceProviderGoogleCalendarDocument = gql`
    mutation SyncServiceProviderGoogleCalendar {
  syncServiceProviderGoogleCalendar
}
    `;
export type SyncServiceProviderGoogleCalendarMutationFn = Apollo.MutationFunction<SyncServiceProviderGoogleCalendarMutation, SyncServiceProviderGoogleCalendarMutationVariables>;

/**
 * __useSyncServiceProviderGoogleCalendarMutation__
 *
 * To run a mutation, you first call `useSyncServiceProviderGoogleCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncServiceProviderGoogleCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncServiceProviderGoogleCalendarMutation, { data, loading, error }] = useSyncServiceProviderGoogleCalendarMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncServiceProviderGoogleCalendarMutation(baseOptions?: Apollo.MutationHookOptions<SyncServiceProviderGoogleCalendarMutation, SyncServiceProviderGoogleCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncServiceProviderGoogleCalendarMutation, SyncServiceProviderGoogleCalendarMutationVariables>(SyncServiceProviderGoogleCalendarDocument, options);
      }
export type SyncServiceProviderGoogleCalendarMutationHookResult = ReturnType<typeof useSyncServiceProviderGoogleCalendarMutation>;
export type SyncServiceProviderGoogleCalendarMutationResult = Apollo.MutationResult<SyncServiceProviderGoogleCalendarMutation>;
export type SyncServiceProviderGoogleCalendarMutationOptions = Apollo.BaseMutationOptions<SyncServiceProviderGoogleCalendarMutation, SyncServiceProviderGoogleCalendarMutationVariables>;
export const UpdateAppointmentCartServiceAreaUidDocument = gql`
    mutation UpdateAppointmentCartServiceAreaUid($appointmentCartUid: String!, $serviceAreaUid: String!) {
  updateAppointmentCartServiceAreaUid(
    appointmentCartUid: $appointmentCartUid
    serviceAreaUid: $serviceAreaUid
  )
}
    `;
export type UpdateAppointmentCartServiceAreaUidMutationFn = Apollo.MutationFunction<UpdateAppointmentCartServiceAreaUidMutation, UpdateAppointmentCartServiceAreaUidMutationVariables>;

/**
 * __useUpdateAppointmentCartServiceAreaUidMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentCartServiceAreaUidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentCartServiceAreaUidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentCartServiceAreaUidMutation, { data, loading, error }] = useUpdateAppointmentCartServiceAreaUidMutation({
 *   variables: {
 *      appointmentCartUid: // value for 'appointmentCartUid'
 *      serviceAreaUid: // value for 'serviceAreaUid'
 *   },
 * });
 */
export function useUpdateAppointmentCartServiceAreaUidMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentCartServiceAreaUidMutation, UpdateAppointmentCartServiceAreaUidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentCartServiceAreaUidMutation, UpdateAppointmentCartServiceAreaUidMutationVariables>(UpdateAppointmentCartServiceAreaUidDocument, options);
      }
export type UpdateAppointmentCartServiceAreaUidMutationHookResult = ReturnType<typeof useUpdateAppointmentCartServiceAreaUidMutation>;
export type UpdateAppointmentCartServiceAreaUidMutationResult = Apollo.MutationResult<UpdateAppointmentCartServiceAreaUidMutation>;
export type UpdateAppointmentCartServiceAreaUidMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentCartServiceAreaUidMutation, UpdateAppointmentCartServiceAreaUidMutationVariables>;
export const UpdateAppointmentCartStartDateTimeDocument = gql`
    mutation UpdateAppointmentCartStartDateTime($appointmentCartUid: String!, $startDateTime: Int!) {
  updateAppointmentCartStartDateTime(
    appointmentCartUid: $appointmentCartUid
    startDateTime: $startDateTime
  )
}
    `;
export type UpdateAppointmentCartStartDateTimeMutationFn = Apollo.MutationFunction<UpdateAppointmentCartStartDateTimeMutation, UpdateAppointmentCartStartDateTimeMutationVariables>;

/**
 * __useUpdateAppointmentCartStartDateTimeMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentCartStartDateTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentCartStartDateTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentCartStartDateTimeMutation, { data, loading, error }] = useUpdateAppointmentCartStartDateTimeMutation({
 *   variables: {
 *      appointmentCartUid: // value for 'appointmentCartUid'
 *      startDateTime: // value for 'startDateTime'
 *   },
 * });
 */
export function useUpdateAppointmentCartStartDateTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentCartStartDateTimeMutation, UpdateAppointmentCartStartDateTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentCartStartDateTimeMutation, UpdateAppointmentCartStartDateTimeMutationVariables>(UpdateAppointmentCartStartDateTimeDocument, options);
      }
export type UpdateAppointmentCartStartDateTimeMutationHookResult = ReturnType<typeof useUpdateAppointmentCartStartDateTimeMutation>;
export type UpdateAppointmentCartStartDateTimeMutationResult = Apollo.MutationResult<UpdateAppointmentCartStartDateTimeMutation>;
export type UpdateAppointmentCartStartDateTimeMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentCartStartDateTimeMutation, UpdateAppointmentCartStartDateTimeMutationVariables>;
export const UpdateAppointmentServiceAreaUidDocument = gql`
    mutation UpdateAppointmentServiceAreaUid($appointmentId: String!, $serviceAreaUid: String!) {
  updateAppointmentServiceAreaUid(
    appointmentId: $appointmentId
    serviceAreaUid: $serviceAreaUid
  )
}
    `;
export type UpdateAppointmentServiceAreaUidMutationFn = Apollo.MutationFunction<UpdateAppointmentServiceAreaUidMutation, UpdateAppointmentServiceAreaUidMutationVariables>;

/**
 * __useUpdateAppointmentServiceAreaUidMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentServiceAreaUidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentServiceAreaUidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentServiceAreaUidMutation, { data, loading, error }] = useUpdateAppointmentServiceAreaUidMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      serviceAreaUid: // value for 'serviceAreaUid'
 *   },
 * });
 */
export function useUpdateAppointmentServiceAreaUidMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentServiceAreaUidMutation, UpdateAppointmentServiceAreaUidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentServiceAreaUidMutation, UpdateAppointmentServiceAreaUidMutationVariables>(UpdateAppointmentServiceAreaUidDocument, options);
      }
export type UpdateAppointmentServiceAreaUidMutationHookResult = ReturnType<typeof useUpdateAppointmentServiceAreaUidMutation>;
export type UpdateAppointmentServiceAreaUidMutationResult = Apollo.MutationResult<UpdateAppointmentServiceAreaUidMutation>;
export type UpdateAppointmentServiceAreaUidMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentServiceAreaUidMutation, UpdateAppointmentServiceAreaUidMutationVariables>;
export const UpdateBookingCartCustomerProfileIdDocument = gql`
    mutation UpdateBookingCartCustomerProfileId($bookingCartUid: String!, $customerProfileId: String!) {
  updateBookingCartCustomerProfileId(
    bookingCartUid: $bookingCartUid
    customerProfileId: $customerProfileId
  )
}
    `;
export type UpdateBookingCartCustomerProfileIdMutationFn = Apollo.MutationFunction<UpdateBookingCartCustomerProfileIdMutation, UpdateBookingCartCustomerProfileIdMutationVariables>;

/**
 * __useUpdateBookingCartCustomerProfileIdMutation__
 *
 * To run a mutation, you first call `useUpdateBookingCartCustomerProfileIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingCartCustomerProfileIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingCartCustomerProfileIdMutation, { data, loading, error }] = useUpdateBookingCartCustomerProfileIdMutation({
 *   variables: {
 *      bookingCartUid: // value for 'bookingCartUid'
 *      customerProfileId: // value for 'customerProfileId'
 *   },
 * });
 */
export function useUpdateBookingCartCustomerProfileIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingCartCustomerProfileIdMutation, UpdateBookingCartCustomerProfileIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingCartCustomerProfileIdMutation, UpdateBookingCartCustomerProfileIdMutationVariables>(UpdateBookingCartCustomerProfileIdDocument, options);
      }
export type UpdateBookingCartCustomerProfileIdMutationHookResult = ReturnType<typeof useUpdateBookingCartCustomerProfileIdMutation>;
export type UpdateBookingCartCustomerProfileIdMutationResult = Apollo.MutationResult<UpdateBookingCartCustomerProfileIdMutation>;
export type UpdateBookingCartCustomerProfileIdMutationOptions = Apollo.BaseMutationOptions<UpdateBookingCartCustomerProfileIdMutation, UpdateBookingCartCustomerProfileIdMutationVariables>;
export const UpdateBookingCartCustomerInputSelectionsDocument = gql`
    mutation UpdateBookingCartCustomerInputSelections($bookingCartUid: String!, $customerInputSelections: [CustomerInputSelectionInput!]!) {
  updateBookingCartCustomerInputSelections(
    bookingCartUid: $bookingCartUid
    customerInputSelections: $customerInputSelections
  )
}
    `;
export type UpdateBookingCartCustomerInputSelectionsMutationFn = Apollo.MutationFunction<UpdateBookingCartCustomerInputSelectionsMutation, UpdateBookingCartCustomerInputSelectionsMutationVariables>;

/**
 * __useUpdateBookingCartCustomerInputSelectionsMutation__
 *
 * To run a mutation, you first call `useUpdateBookingCartCustomerInputSelectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingCartCustomerInputSelectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingCartCustomerInputSelectionsMutation, { data, loading, error }] = useUpdateBookingCartCustomerInputSelectionsMutation({
 *   variables: {
 *      bookingCartUid: // value for 'bookingCartUid'
 *      customerInputSelections: // value for 'customerInputSelections'
 *   },
 * });
 */
export function useUpdateBookingCartCustomerInputSelectionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingCartCustomerInputSelectionsMutation, UpdateBookingCartCustomerInputSelectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingCartCustomerInputSelectionsMutation, UpdateBookingCartCustomerInputSelectionsMutationVariables>(UpdateBookingCartCustomerInputSelectionsDocument, options);
      }
export type UpdateBookingCartCustomerInputSelectionsMutationHookResult = ReturnType<typeof useUpdateBookingCartCustomerInputSelectionsMutation>;
export type UpdateBookingCartCustomerInputSelectionsMutationResult = Apollo.MutationResult<UpdateBookingCartCustomerInputSelectionsMutation>;
export type UpdateBookingCartCustomerInputSelectionsMutationOptions = Apollo.BaseMutationOptions<UpdateBookingCartCustomerInputSelectionsMutation, UpdateBookingCartCustomerInputSelectionsMutationVariables>;
export const UpdateBookingCartRedeemableSecretDocument = gql`
    mutation UpdateBookingCartRedeemableSecret($bookingCartUid: String!, $secret: String!) {
  updateBookingCartRedeemableSecret(
    bookingCartUid: $bookingCartUid
    secret: $secret
  )
}
    `;
export type UpdateBookingCartRedeemableSecretMutationFn = Apollo.MutationFunction<UpdateBookingCartRedeemableSecretMutation, UpdateBookingCartRedeemableSecretMutationVariables>;

/**
 * __useUpdateBookingCartRedeemableSecretMutation__
 *
 * To run a mutation, you first call `useUpdateBookingCartRedeemableSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingCartRedeemableSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingCartRedeemableSecretMutation, { data, loading, error }] = useUpdateBookingCartRedeemableSecretMutation({
 *   variables: {
 *      bookingCartUid: // value for 'bookingCartUid'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useUpdateBookingCartRedeemableSecretMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingCartRedeemableSecretMutation, UpdateBookingCartRedeemableSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingCartRedeemableSecretMutation, UpdateBookingCartRedeemableSecretMutationVariables>(UpdateBookingCartRedeemableSecretDocument, options);
      }
export type UpdateBookingCartRedeemableSecretMutationHookResult = ReturnType<typeof useUpdateBookingCartRedeemableSecretMutation>;
export type UpdateBookingCartRedeemableSecretMutationResult = Apollo.MutationResult<UpdateBookingCartRedeemableSecretMutation>;
export type UpdateBookingCartRedeemableSecretMutationOptions = Apollo.BaseMutationOptions<UpdateBookingCartRedeemableSecretMutation, UpdateBookingCartRedeemableSecretMutationVariables>;
export const UpdateBookingCartServiceOfferingUidDocument = gql`
    mutation UpdateBookingCartServiceOfferingUid($bookingCartUid: String!, $serviceOfferingUid: String!) {
  updateBookingCartServiceOfferingUid(
    bookingCartUid: $bookingCartUid
    serviceOfferingUid: $serviceOfferingUid
  )
}
    `;
export type UpdateBookingCartServiceOfferingUidMutationFn = Apollo.MutationFunction<UpdateBookingCartServiceOfferingUidMutation, UpdateBookingCartServiceOfferingUidMutationVariables>;

/**
 * __useUpdateBookingCartServiceOfferingUidMutation__
 *
 * To run a mutation, you first call `useUpdateBookingCartServiceOfferingUidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingCartServiceOfferingUidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingCartServiceOfferingUidMutation, { data, loading, error }] = useUpdateBookingCartServiceOfferingUidMutation({
 *   variables: {
 *      bookingCartUid: // value for 'bookingCartUid'
 *      serviceOfferingUid: // value for 'serviceOfferingUid'
 *   },
 * });
 */
export function useUpdateBookingCartServiceOfferingUidMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingCartServiceOfferingUidMutation, UpdateBookingCartServiceOfferingUidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingCartServiceOfferingUidMutation, UpdateBookingCartServiceOfferingUidMutationVariables>(UpdateBookingCartServiceOfferingUidDocument, options);
      }
export type UpdateBookingCartServiceOfferingUidMutationHookResult = ReturnType<typeof useUpdateBookingCartServiceOfferingUidMutation>;
export type UpdateBookingCartServiceOfferingUidMutationResult = Apollo.MutationResult<UpdateBookingCartServiceOfferingUidMutation>;
export type UpdateBookingCartServiceOfferingUidMutationOptions = Apollo.BaseMutationOptions<UpdateBookingCartServiceOfferingUidMutation, UpdateBookingCartServiceOfferingUidMutationVariables>;
export const UpdateBookingCartStartDateTimeDocument = gql`
    mutation UpdateBookingCartStartDateTime($bookingCartUid: String!, $startDateTime: Int!) {
  updateBookingCartStartDateTime(
    bookingCartUid: $bookingCartUid
    startDateTime: $startDateTime
  )
}
    `;
export type UpdateBookingCartStartDateTimeMutationFn = Apollo.MutationFunction<UpdateBookingCartStartDateTimeMutation, UpdateBookingCartStartDateTimeMutationVariables>;

/**
 * __useUpdateBookingCartStartDateTimeMutation__
 *
 * To run a mutation, you first call `useUpdateBookingCartStartDateTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingCartStartDateTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingCartStartDateTimeMutation, { data, loading, error }] = useUpdateBookingCartStartDateTimeMutation({
 *   variables: {
 *      bookingCartUid: // value for 'bookingCartUid'
 *      startDateTime: // value for 'startDateTime'
 *   },
 * });
 */
export function useUpdateBookingCartStartDateTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingCartStartDateTimeMutation, UpdateBookingCartStartDateTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingCartStartDateTimeMutation, UpdateBookingCartStartDateTimeMutationVariables>(UpdateBookingCartStartDateTimeDocument, options);
      }
export type UpdateBookingCartStartDateTimeMutationHookResult = ReturnType<typeof useUpdateBookingCartStartDateTimeMutation>;
export type UpdateBookingCartStartDateTimeMutationResult = Apollo.MutationResult<UpdateBookingCartStartDateTimeMutation>;
export type UpdateBookingCartStartDateTimeMutationOptions = Apollo.BaseMutationOptions<UpdateBookingCartStartDateTimeMutation, UpdateBookingCartStartDateTimeMutationVariables>;
export const UpdateBookingCartTipPercentDocument = gql`
    mutation UpdateBookingCartTipPercent($bookingCartUid: String!, $tipPercent: Int!) {
  updateBookingCartTipPercent(
    bookingCartUid: $bookingCartUid
    tipPercent: $tipPercent
  )
}
    `;
export type UpdateBookingCartTipPercentMutationFn = Apollo.MutationFunction<UpdateBookingCartTipPercentMutation, UpdateBookingCartTipPercentMutationVariables>;

/**
 * __useUpdateBookingCartTipPercentMutation__
 *
 * To run a mutation, you first call `useUpdateBookingCartTipPercentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingCartTipPercentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingCartTipPercentMutation, { data, loading, error }] = useUpdateBookingCartTipPercentMutation({
 *   variables: {
 *      bookingCartUid: // value for 'bookingCartUid'
 *      tipPercent: // value for 'tipPercent'
 *   },
 * });
 */
export function useUpdateBookingCartTipPercentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingCartTipPercentMutation, UpdateBookingCartTipPercentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingCartTipPercentMutation, UpdateBookingCartTipPercentMutationVariables>(UpdateBookingCartTipPercentDocument, options);
      }
export type UpdateBookingCartTipPercentMutationHookResult = ReturnType<typeof useUpdateBookingCartTipPercentMutation>;
export type UpdateBookingCartTipPercentMutationResult = Apollo.MutationResult<UpdateBookingCartTipPercentMutation>;
export type UpdateBookingCartTipPercentMutationOptions = Apollo.BaseMutationOptions<UpdateBookingCartTipPercentMutation, UpdateBookingCartTipPercentMutationVariables>;
export const UpdateBookingCustomerProfileIdDocument = gql`
    mutation UpdateBookingCustomerProfileId($bookingId: String!, $customerProfileId: String!) {
  updateBookingCustomerProfileId(
    bookingId: $bookingId
    customerProfileId: $customerProfileId
  )
}
    `;
export type UpdateBookingCustomerProfileIdMutationFn = Apollo.MutationFunction<UpdateBookingCustomerProfileIdMutation, UpdateBookingCustomerProfileIdMutationVariables>;

/**
 * __useUpdateBookingCustomerProfileIdMutation__
 *
 * To run a mutation, you first call `useUpdateBookingCustomerProfileIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingCustomerProfileIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingCustomerProfileIdMutation, { data, loading, error }] = useUpdateBookingCustomerProfileIdMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      customerProfileId: // value for 'customerProfileId'
 *   },
 * });
 */
export function useUpdateBookingCustomerProfileIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingCustomerProfileIdMutation, UpdateBookingCustomerProfileIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingCustomerProfileIdMutation, UpdateBookingCustomerProfileIdMutationVariables>(UpdateBookingCustomerProfileIdDocument, options);
      }
export type UpdateBookingCustomerProfileIdMutationHookResult = ReturnType<typeof useUpdateBookingCustomerProfileIdMutation>;
export type UpdateBookingCustomerProfileIdMutationResult = Apollo.MutationResult<UpdateBookingCustomerProfileIdMutation>;
export type UpdateBookingCustomerProfileIdMutationOptions = Apollo.BaseMutationOptions<UpdateBookingCustomerProfileIdMutation, UpdateBookingCustomerProfileIdMutationVariables>;
export const UpdateBusinessNameDocument = gql`
    mutation UpdateBusinessName($name: String!) {
  updateBusinessName(name: $name)
}
    `;
export type UpdateBusinessNameMutationFn = Apollo.MutationFunction<UpdateBusinessNameMutation, UpdateBusinessNameMutationVariables>;

/**
 * __useUpdateBusinessNameMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessNameMutation, { data, loading, error }] = useUpdateBusinessNameMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateBusinessNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessNameMutation, UpdateBusinessNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessNameMutation, UpdateBusinessNameMutationVariables>(UpdateBusinessNameDocument, options);
      }
export type UpdateBusinessNameMutationHookResult = ReturnType<typeof useUpdateBusinessNameMutation>;
export type UpdateBusinessNameMutationResult = Apollo.MutationResult<UpdateBusinessNameMutation>;
export type UpdateBusinessNameMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessNameMutation, UpdateBusinessNameMutationVariables>;
export const UpdateCustomLineItemDocument = gql`
    mutation UpdateCustomLineItem($id: ID!, $input: CustomLineItemInput!) {
  updateCustomLineItem(id: $id, input: $input)
}
    `;
export type UpdateCustomLineItemMutationFn = Apollo.MutationFunction<UpdateCustomLineItemMutation, UpdateCustomLineItemMutationVariables>;

/**
 * __useUpdateCustomLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateCustomLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomLineItemMutation, { data, loading, error }] = useUpdateCustomLineItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomLineItemMutation, UpdateCustomLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomLineItemMutation, UpdateCustomLineItemMutationVariables>(UpdateCustomLineItemDocument, options);
      }
export type UpdateCustomLineItemMutationHookResult = ReturnType<typeof useUpdateCustomLineItemMutation>;
export type UpdateCustomLineItemMutationResult = Apollo.MutationResult<UpdateCustomLineItemMutation>;
export type UpdateCustomLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateCustomLineItemMutation, UpdateCustomLineItemMutationVariables>;
export const UpdateCustomerProfileFieldDocument = gql`
    mutation UpdateCustomerProfileField($id: String!, $field: CustomerProfileFieldInput!) {
  updateCustomerProfileField(customerProfileFieldId: $id, field: $field)
}
    `;
export type UpdateCustomerProfileFieldMutationFn = Apollo.MutationFunction<UpdateCustomerProfileFieldMutation, UpdateCustomerProfileFieldMutationVariables>;

/**
 * __useUpdateCustomerProfileFieldMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerProfileFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerProfileFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerProfileFieldMutation, { data, loading, error }] = useUpdateCustomerProfileFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      field: // value for 'field'
 *   },
 * });
 */
export function useUpdateCustomerProfileFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerProfileFieldMutation, UpdateCustomerProfileFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerProfileFieldMutation, UpdateCustomerProfileFieldMutationVariables>(UpdateCustomerProfileFieldDocument, options);
      }
export type UpdateCustomerProfileFieldMutationHookResult = ReturnType<typeof useUpdateCustomerProfileFieldMutation>;
export type UpdateCustomerProfileFieldMutationResult = Apollo.MutationResult<UpdateCustomerProfileFieldMutation>;
export type UpdateCustomerProfileFieldMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerProfileFieldMutation, UpdateCustomerProfileFieldMutationVariables>;
export const UpdateCustomerProfileForServiceProviderDocument = gql`
    mutation UpdateCustomerProfileForServiceProvider($serviceProviderId: String!, $customerProfileId: String!, $fieldValues: [CustomerProfileFieldValueInput!]!) {
  updateCustomerProfileForServiceProvider(
    serviceProviderId: $serviceProviderId
    customerProfileId: $customerProfileId
    fieldValues: $fieldValues
  )
}
    `;
export type UpdateCustomerProfileForServiceProviderMutationFn = Apollo.MutationFunction<UpdateCustomerProfileForServiceProviderMutation, UpdateCustomerProfileForServiceProviderMutationVariables>;

/**
 * __useUpdateCustomerProfileForServiceProviderMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerProfileForServiceProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerProfileForServiceProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerProfileForServiceProviderMutation, { data, loading, error }] = useUpdateCustomerProfileForServiceProviderMutation({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *      customerProfileId: // value for 'customerProfileId'
 *      fieldValues: // value for 'fieldValues'
 *   },
 * });
 */
export function useUpdateCustomerProfileForServiceProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerProfileForServiceProviderMutation, UpdateCustomerProfileForServiceProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerProfileForServiceProviderMutation, UpdateCustomerProfileForServiceProviderMutationVariables>(UpdateCustomerProfileForServiceProviderDocument, options);
      }
export type UpdateCustomerProfileForServiceProviderMutationHookResult = ReturnType<typeof useUpdateCustomerProfileForServiceProviderMutation>;
export type UpdateCustomerProfileForServiceProviderMutationResult = Apollo.MutationResult<UpdateCustomerProfileForServiceProviderMutation>;
export type UpdateCustomerProfileForServiceProviderMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerProfileForServiceProviderMutation, UpdateCustomerProfileForServiceProviderMutationVariables>;
export const UpdateCustomerProfileNotesDocument = gql`
    mutation UpdateCustomerProfileNotes($id: String!, $notes: [CustomerProfileNoteInput!]!) {
  updateCustomerProfileNotes(customerProfileId: $id, notes: $notes)
}
    `;
export type UpdateCustomerProfileNotesMutationFn = Apollo.MutationFunction<UpdateCustomerProfileNotesMutation, UpdateCustomerProfileNotesMutationVariables>;

/**
 * __useUpdateCustomerProfileNotesMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerProfileNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerProfileNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerProfileNotesMutation, { data, loading, error }] = useUpdateCustomerProfileNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateCustomerProfileNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerProfileNotesMutation, UpdateCustomerProfileNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerProfileNotesMutation, UpdateCustomerProfileNotesMutationVariables>(UpdateCustomerProfileNotesDocument, options);
      }
export type UpdateCustomerProfileNotesMutationHookResult = ReturnType<typeof useUpdateCustomerProfileNotesMutation>;
export type UpdateCustomerProfileNotesMutationResult = Apollo.MutationResult<UpdateCustomerProfileNotesMutation>;
export type UpdateCustomerProfileNotesMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerProfileNotesMutation, UpdateCustomerProfileNotesMutationVariables>;
export const UpdateCustomerProfileDocument = gql`
    mutation UpdateCustomerProfile($id: String!, $profile: CustomerProfileInput!) {
  updateCustomerProfile(customerProfileId: $id, profile: $profile)
}
    `;
export type UpdateCustomerProfileMutationFn = Apollo.MutationFunction<UpdateCustomerProfileMutation, UpdateCustomerProfileMutationVariables>;

/**
 * __useUpdateCustomerProfileMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerProfileMutation, { data, loading, error }] = useUpdateCustomerProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useUpdateCustomerProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerProfileMutation, UpdateCustomerProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerProfileMutation, UpdateCustomerProfileMutationVariables>(UpdateCustomerProfileDocument, options);
      }
export type UpdateCustomerProfileMutationHookResult = ReturnType<typeof useUpdateCustomerProfileMutation>;
export type UpdateCustomerProfileMutationResult = Apollo.MutationResult<UpdateCustomerProfileMutation>;
export type UpdateCustomerProfileMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerProfileMutation, UpdateCustomerProfileMutationVariables>;
export const UpdateSiblingBookingDiscountRuleDocument = gql`
    mutation UpdateSiblingBookingDiscountRule($discountRuleID: String!, $discountRule: UpdateSiblingBookingDiscountRuleInput!) {
  updateSiblingBookingDiscountRule(
    discountRuleID: $discountRuleID
    discountRule: $discountRule
  )
}
    `;
export type UpdateSiblingBookingDiscountRuleMutationFn = Apollo.MutationFunction<UpdateSiblingBookingDiscountRuleMutation, UpdateSiblingBookingDiscountRuleMutationVariables>;

/**
 * __useUpdateSiblingBookingDiscountRuleMutation__
 *
 * To run a mutation, you first call `useUpdateSiblingBookingDiscountRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiblingBookingDiscountRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiblingBookingDiscountRuleMutation, { data, loading, error }] = useUpdateSiblingBookingDiscountRuleMutation({
 *   variables: {
 *      discountRuleID: // value for 'discountRuleID'
 *      discountRule: // value for 'discountRule'
 *   },
 * });
 */
export function useUpdateSiblingBookingDiscountRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiblingBookingDiscountRuleMutation, UpdateSiblingBookingDiscountRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiblingBookingDiscountRuleMutation, UpdateSiblingBookingDiscountRuleMutationVariables>(UpdateSiblingBookingDiscountRuleDocument, options);
      }
export type UpdateSiblingBookingDiscountRuleMutationHookResult = ReturnType<typeof useUpdateSiblingBookingDiscountRuleMutation>;
export type UpdateSiblingBookingDiscountRuleMutationResult = Apollo.MutationResult<UpdateSiblingBookingDiscountRuleMutation>;
export type UpdateSiblingBookingDiscountRuleMutationOptions = Apollo.BaseMutationOptions<UpdateSiblingBookingDiscountRuleMutation, UpdateSiblingBookingDiscountRuleMutationVariables>;
export const UpdateTimeDurationBookedAtLocationDiscountRuleDocument = gql`
    mutation UpdateTimeDurationBookedAtLocationDiscountRule($discountRuleID: String!, $discountRule: UpdateTimeDurationBookedAtLocationDiscountRuleInput!) {
  updateTimeDurationBookedAtLocationDiscountRule(
    discountRuleID: $discountRuleID
    discountRule: $discountRule
  )
}
    `;
export type UpdateTimeDurationBookedAtLocationDiscountRuleMutationFn = Apollo.MutationFunction<UpdateTimeDurationBookedAtLocationDiscountRuleMutation, UpdateTimeDurationBookedAtLocationDiscountRuleMutationVariables>;

/**
 * __useUpdateTimeDurationBookedAtLocationDiscountRuleMutation__
 *
 * To run a mutation, you first call `useUpdateTimeDurationBookedAtLocationDiscountRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeDurationBookedAtLocationDiscountRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeDurationBookedAtLocationDiscountRuleMutation, { data, loading, error }] = useUpdateTimeDurationBookedAtLocationDiscountRuleMutation({
 *   variables: {
 *      discountRuleID: // value for 'discountRuleID'
 *      discountRule: // value for 'discountRule'
 *   },
 * });
 */
export function useUpdateTimeDurationBookedAtLocationDiscountRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeDurationBookedAtLocationDiscountRuleMutation, UpdateTimeDurationBookedAtLocationDiscountRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeDurationBookedAtLocationDiscountRuleMutation, UpdateTimeDurationBookedAtLocationDiscountRuleMutationVariables>(UpdateTimeDurationBookedAtLocationDiscountRuleDocument, options);
      }
export type UpdateTimeDurationBookedAtLocationDiscountRuleMutationHookResult = ReturnType<typeof useUpdateTimeDurationBookedAtLocationDiscountRuleMutation>;
export type UpdateTimeDurationBookedAtLocationDiscountRuleMutationResult = Apollo.MutationResult<UpdateTimeDurationBookedAtLocationDiscountRuleMutation>;
export type UpdateTimeDurationBookedAtLocationDiscountRuleMutationOptions = Apollo.BaseMutationOptions<UpdateTimeDurationBookedAtLocationDiscountRuleMutation, UpdateTimeDurationBookedAtLocationDiscountRuleMutationVariables>;
export const UpdateDropoffDateTimeDocument = gql`
    mutation UpdateDropoffDateTime($dropoffID: String!, $dropoffDateTime: Int!) {
  updateDropoffDateTime(dropoffID: $dropoffID, dropoffDateTime: $dropoffDateTime)
}
    `;
export type UpdateDropoffDateTimeMutationFn = Apollo.MutationFunction<UpdateDropoffDateTimeMutation, UpdateDropoffDateTimeMutationVariables>;

/**
 * __useUpdateDropoffDateTimeMutation__
 *
 * To run a mutation, you first call `useUpdateDropoffDateTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDropoffDateTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDropoffDateTimeMutation, { data, loading, error }] = useUpdateDropoffDateTimeMutation({
 *   variables: {
 *      dropoffID: // value for 'dropoffID'
 *      dropoffDateTime: // value for 'dropoffDateTime'
 *   },
 * });
 */
export function useUpdateDropoffDateTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDropoffDateTimeMutation, UpdateDropoffDateTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDropoffDateTimeMutation, UpdateDropoffDateTimeMutationVariables>(UpdateDropoffDateTimeDocument, options);
      }
export type UpdateDropoffDateTimeMutationHookResult = ReturnType<typeof useUpdateDropoffDateTimeMutation>;
export type UpdateDropoffDateTimeMutationResult = Apollo.MutationResult<UpdateDropoffDateTimeMutation>;
export type UpdateDropoffDateTimeMutationOptions = Apollo.BaseMutationOptions<UpdateDropoffDateTimeMutation, UpdateDropoffDateTimeMutationVariables>;
export const UpdateEventCartDocument = gql`
    mutation UpdateEventCart($id: String!, $data: UpdateEventCartInput!) {
  updateEventCart(id: $id, data: $data)
}
    `;
export type UpdateEventCartMutationFn = Apollo.MutationFunction<UpdateEventCartMutation, UpdateEventCartMutationVariables>;

/**
 * __useUpdateEventCartMutation__
 *
 * To run a mutation, you first call `useUpdateEventCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventCartMutation, { data, loading, error }] = useUpdateEventCartMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEventCartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventCartMutation, UpdateEventCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventCartMutation, UpdateEventCartMutationVariables>(UpdateEventCartDocument, options);
      }
export type UpdateEventCartMutationHookResult = ReturnType<typeof useUpdateEventCartMutation>;
export type UpdateEventCartMutationResult = Apollo.MutationResult<UpdateEventCartMutation>;
export type UpdateEventCartMutationOptions = Apollo.BaseMutationOptions<UpdateEventCartMutation, UpdateEventCartMutationVariables>;
export const UpdateEventOfferingDocument = gql`
    mutation UpdateEventOffering($id: String!, $data: UpdateEventOffering!) {
  updateEventOffering(data: $data, id: $id)
}
    `;
export type UpdateEventOfferingMutationFn = Apollo.MutationFunction<UpdateEventOfferingMutation, UpdateEventOfferingMutationVariables>;

/**
 * __useUpdateEventOfferingMutation__
 *
 * To run a mutation, you first call `useUpdateEventOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventOfferingMutation, { data, loading, error }] = useUpdateEventOfferingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEventOfferingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventOfferingMutation, UpdateEventOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventOfferingMutation, UpdateEventOfferingMutationVariables>(UpdateEventOfferingDocument, options);
      }
export type UpdateEventOfferingMutationHookResult = ReturnType<typeof useUpdateEventOfferingMutation>;
export type UpdateEventOfferingMutationResult = Apollo.MutationResult<UpdateEventOfferingMutation>;
export type UpdateEventOfferingMutationOptions = Apollo.BaseMutationOptions<UpdateEventOfferingMutation, UpdateEventOfferingMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($data: UpdateLocationInput!) {
  updateLocations(data: [$data])
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const UpdateReceiptConfigDocument = gql`
    mutation UpdateReceiptConfig($id: String!, $input: ReceiptConfigInput!) {
  updateReceiptConfig(configId: $id, input: $input)
}
    `;
export type UpdateReceiptConfigMutationFn = Apollo.MutationFunction<UpdateReceiptConfigMutation, UpdateReceiptConfigMutationVariables>;

/**
 * __useUpdateReceiptConfigMutation__
 *
 * To run a mutation, you first call `useUpdateReceiptConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReceiptConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReceiptConfigMutation, { data, loading, error }] = useUpdateReceiptConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReceiptConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReceiptConfigMutation, UpdateReceiptConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReceiptConfigMutation, UpdateReceiptConfigMutationVariables>(UpdateReceiptConfigDocument, options);
      }
export type UpdateReceiptConfigMutationHookResult = ReturnType<typeof useUpdateReceiptConfigMutation>;
export type UpdateReceiptConfigMutationResult = Apollo.MutationResult<UpdateReceiptConfigMutation>;
export type UpdateReceiptConfigMutationOptions = Apollo.BaseMutationOptions<UpdateReceiptConfigMutation, UpdateReceiptConfigMutationVariables>;
export const UpdateServiceProviderReminderDocument = gql`
    mutation UpdateServiceProviderReminder($id: String!, $input: ServiceProviderReminderInput!) {
  updateServiceProviderReminder(id: $id, input: $input)
}
    `;
export type UpdateServiceProviderReminderMutationFn = Apollo.MutationFunction<UpdateServiceProviderReminderMutation, UpdateServiceProviderReminderMutationVariables>;

/**
 * __useUpdateServiceProviderReminderMutation__
 *
 * To run a mutation, you first call `useUpdateServiceProviderReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceProviderReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceProviderReminderMutation, { data, loading, error }] = useUpdateServiceProviderReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceProviderReminderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceProviderReminderMutation, UpdateServiceProviderReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceProviderReminderMutation, UpdateServiceProviderReminderMutationVariables>(UpdateServiceProviderReminderDocument, options);
      }
export type UpdateServiceProviderReminderMutationHookResult = ReturnType<typeof useUpdateServiceProviderReminderMutation>;
export type UpdateServiceProviderReminderMutationResult = Apollo.MutationResult<UpdateServiceProviderReminderMutation>;
export type UpdateServiceProviderReminderMutationOptions = Apollo.BaseMutationOptions<UpdateServiceProviderReminderMutation, UpdateServiceProviderReminderMutationVariables>;
export const V2Gateway_UpdateUserPhoneNumberDocument = gql`
    mutation V2Gateway_UpdateUserPhoneNumber($phoneNumber: String!) {
  updateUserPhoneNumber(phoneNumber: $phoneNumber)
}
    `;
export type V2Gateway_UpdateUserPhoneNumberMutationFn = Apollo.MutationFunction<V2Gateway_UpdateUserPhoneNumberMutation, V2Gateway_UpdateUserPhoneNumberMutationVariables>;

/**
 * __useV2Gateway_UpdateUserPhoneNumberMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateUserPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateUserPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateUserPhoneNumberMutation, { data, loading, error }] = useV2Gateway_UpdateUserPhoneNumberMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useV2Gateway_UpdateUserPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateUserPhoneNumberMutation, V2Gateway_UpdateUserPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateUserPhoneNumberMutation, V2Gateway_UpdateUserPhoneNumberMutationVariables>(V2Gateway_UpdateUserPhoneNumberDocument, options);
      }
export type V2Gateway_UpdateUserPhoneNumberMutationHookResult = ReturnType<typeof useV2Gateway_UpdateUserPhoneNumberMutation>;
export type V2Gateway_UpdateUserPhoneNumberMutationResult = Apollo.MutationResult<V2Gateway_UpdateUserPhoneNumberMutation>;
export type V2Gateway_UpdateUserPhoneNumberMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateUserPhoneNumberMutation, V2Gateway_UpdateUserPhoneNumberMutationVariables>;
export const V2Gateway_UpdateUserFullNameDocument = gql`
    mutation V2Gateway_UpdateUserFullName($fullName: String!) {
  updateUserFullName(fullName: $fullName)
}
    `;
export type V2Gateway_UpdateUserFullNameMutationFn = Apollo.MutationFunction<V2Gateway_UpdateUserFullNameMutation, V2Gateway_UpdateUserFullNameMutationVariables>;

/**
 * __useV2Gateway_UpdateUserFullNameMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateUserFullNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateUserFullNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateUserFullNameMutation, { data, loading, error }] = useV2Gateway_UpdateUserFullNameMutation({
 *   variables: {
 *      fullName: // value for 'fullName'
 *   },
 * });
 */
export function useV2Gateway_UpdateUserFullNameMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateUserFullNameMutation, V2Gateway_UpdateUserFullNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateUserFullNameMutation, V2Gateway_UpdateUserFullNameMutationVariables>(V2Gateway_UpdateUserFullNameDocument, options);
      }
export type V2Gateway_UpdateUserFullNameMutationHookResult = ReturnType<typeof useV2Gateway_UpdateUserFullNameMutation>;
export type V2Gateway_UpdateUserFullNameMutationResult = Apollo.MutationResult<V2Gateway_UpdateUserFullNameMutation>;
export type V2Gateway_UpdateUserFullNameMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateUserFullNameMutation, V2Gateway_UpdateUserFullNameMutationVariables>;
export const V2Gateway_GetAliasByFromDocument = gql`
    query V2Gateway_GetAliasByFrom($from: String!) {
  getAliasByFrom(from: $from) {
    to
  }
}
    `;

/**
 * __useV2Gateway_GetAliasByFromQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetAliasByFromQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetAliasByFromQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetAliasByFromQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useV2Gateway_GetAliasByFromQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetAliasByFromQuery, V2Gateway_GetAliasByFromQueryVariables> & ({ variables: V2Gateway_GetAliasByFromQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetAliasByFromQuery, V2Gateway_GetAliasByFromQueryVariables>(V2Gateway_GetAliasByFromDocument, options);
      }
export function useV2Gateway_GetAliasByFromLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetAliasByFromQuery, V2Gateway_GetAliasByFromQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetAliasByFromQuery, V2Gateway_GetAliasByFromQueryVariables>(V2Gateway_GetAliasByFromDocument, options);
        }
export function useV2Gateway_GetAliasByFromSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetAliasByFromQuery, V2Gateway_GetAliasByFromQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetAliasByFromQuery, V2Gateway_GetAliasByFromQueryVariables>(V2Gateway_GetAliasByFromDocument, options);
        }
export type V2Gateway_GetAliasByFromQueryHookResult = ReturnType<typeof useV2Gateway_GetAliasByFromQuery>;
export type V2Gateway_GetAliasByFromLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetAliasByFromLazyQuery>;
export type V2Gateway_GetAliasByFromSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetAliasByFromSuspenseQuery>;
export type V2Gateway_GetAliasByFromQueryResult = Apollo.QueryResult<V2Gateway_GetAliasByFromQuery, V2Gateway_GetAliasByFromQueryVariables>;
export const V2Gateway_GetCustomerInputsForServiceOfferingDocument = gql`
    query V2Gateway_GetCustomerInputsForServiceOffering($serviceOfferingUid: String!) {
  getServiceOfferingCustomerInputGroups(serviceOfferingUid: $serviceOfferingUid) {
    uid
    title
    index
    dependencies {
      dependencyCustomerInputUid
      level
      dependentTriggerValues {
        dependentCustomerInputUid
        triggerValues
      }
    }
  }
  getServiceOfferingCustomerInputs(serviceOfferingUid: $serviceOfferingUid) {
    uid
    title
    index
    description
    type
    required
    unitPrice
    options {
      price
      duration
      uid
      value
    }
  }
}
    `;

/**
 * __useV2Gateway_GetCustomerInputsForServiceOfferingQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetCustomerInputsForServiceOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetCustomerInputsForServiceOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetCustomerInputsForServiceOfferingQuery({
 *   variables: {
 *      serviceOfferingUid: // value for 'serviceOfferingUid'
 *   },
 * });
 */
export function useV2Gateway_GetCustomerInputsForServiceOfferingQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetCustomerInputsForServiceOfferingQuery, V2Gateway_GetCustomerInputsForServiceOfferingQueryVariables> & ({ variables: V2Gateway_GetCustomerInputsForServiceOfferingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetCustomerInputsForServiceOfferingQuery, V2Gateway_GetCustomerInputsForServiceOfferingQueryVariables>(V2Gateway_GetCustomerInputsForServiceOfferingDocument, options);
      }
export function useV2Gateway_GetCustomerInputsForServiceOfferingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetCustomerInputsForServiceOfferingQuery, V2Gateway_GetCustomerInputsForServiceOfferingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetCustomerInputsForServiceOfferingQuery, V2Gateway_GetCustomerInputsForServiceOfferingQueryVariables>(V2Gateway_GetCustomerInputsForServiceOfferingDocument, options);
        }
export function useV2Gateway_GetCustomerInputsForServiceOfferingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetCustomerInputsForServiceOfferingQuery, V2Gateway_GetCustomerInputsForServiceOfferingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetCustomerInputsForServiceOfferingQuery, V2Gateway_GetCustomerInputsForServiceOfferingQueryVariables>(V2Gateway_GetCustomerInputsForServiceOfferingDocument, options);
        }
export type V2Gateway_GetCustomerInputsForServiceOfferingQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputsForServiceOfferingQuery>;
export type V2Gateway_GetCustomerInputsForServiceOfferingLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputsForServiceOfferingLazyQuery>;
export type V2Gateway_GetCustomerInputsForServiceOfferingSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputsForServiceOfferingSuspenseQuery>;
export type V2Gateway_GetCustomerInputsForServiceOfferingQueryResult = Apollo.QueryResult<V2Gateway_GetCustomerInputsForServiceOfferingQuery, V2Gateway_GetCustomerInputsForServiceOfferingQueryVariables>;
export const V2Gateway_QueryLocationsDocument = gql`
    query V2Gateway_QueryLocations($query: LocationQuery!) {
  queryLocations(query: $query) {
    hasMoreResults
    locations {
      uid
      id
      formattedAddress
      streetAddress
      phoneNumber
      name
      ownerUid
      latitude
      longitude
      placeId
      type
      phoneNumber
      extendedAddress
      serviceAreas {
        uid
      }
      slug
      business {
        slug
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_QueryLocationsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryLocationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryLocationsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryLocationsQuery, V2Gateway_QueryLocationsQueryVariables> & ({ variables: V2Gateway_QueryLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryLocationsQuery, V2Gateway_QueryLocationsQueryVariables>(V2Gateway_QueryLocationsDocument, options);
      }
export function useV2Gateway_QueryLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryLocationsQuery, V2Gateway_QueryLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryLocationsQuery, V2Gateway_QueryLocationsQueryVariables>(V2Gateway_QueryLocationsDocument, options);
        }
export function useV2Gateway_QueryLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryLocationsQuery, V2Gateway_QueryLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryLocationsQuery, V2Gateway_QueryLocationsQueryVariables>(V2Gateway_QueryLocationsDocument, options);
        }
export type V2Gateway_QueryLocationsQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationsQuery>;
export type V2Gateway_QueryLocationsLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationsLazyQuery>;
export type V2Gateway_QueryLocationsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationsSuspenseQuery>;
export type V2Gateway_QueryLocationsQueryResult = Apollo.QueryResult<V2Gateway_QueryLocationsQuery, V2Gateway_QueryLocationsQueryVariables>;
export const V2Gateway_GetMerchantsDocument = gql`
    query V2Gateway_GetMerchants($uids: [String!]!) {
  getMerchants(uids: $uids) {
    serviceType
    ownerUid
  }
}
    `;

/**
 * __useV2Gateway_GetMerchantsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetMerchantsQuery({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useV2Gateway_GetMerchantsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetMerchantsQuery, V2Gateway_GetMerchantsQueryVariables> & ({ variables: V2Gateway_GetMerchantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetMerchantsQuery, V2Gateway_GetMerchantsQueryVariables>(V2Gateway_GetMerchantsDocument, options);
      }
export function useV2Gateway_GetMerchantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetMerchantsQuery, V2Gateway_GetMerchantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetMerchantsQuery, V2Gateway_GetMerchantsQueryVariables>(V2Gateway_GetMerchantsDocument, options);
        }
export function useV2Gateway_GetMerchantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetMerchantsQuery, V2Gateway_GetMerchantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetMerchantsQuery, V2Gateway_GetMerchantsQueryVariables>(V2Gateway_GetMerchantsDocument, options);
        }
export type V2Gateway_GetMerchantsQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantsQuery>;
export type V2Gateway_GetMerchantsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantsLazyQuery>;
export type V2Gateway_GetMerchantsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantsSuspenseQuery>;
export type V2Gateway_GetMerchantsQueryResult = Apollo.QueryResult<V2Gateway_GetMerchantsQuery, V2Gateway_GetMerchantsQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($uids: [String!]!) {
  getUsers(uids: $uids) {
    fullName
    uid
    emailAddress
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables> & ({ variables: GetUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetAppointmentRequestsByOwnerUidDocument = gql`
    query GetAppointmentRequestsByOwnerUid {
  getAppointmentRequestsByOwnerUid(page: 1) {
    ...appointmentRequestFields
  }
}
    ${AppointmentRequestFieldsFragmentDoc}`;

/**
 * __useGetAppointmentRequestsByOwnerUidQuery__
 *
 * To run a query within a React component, call `useGetAppointmentRequestsByOwnerUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentRequestsByOwnerUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentRequestsByOwnerUidQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentRequestsByOwnerUidQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentRequestsByOwnerUidQuery, GetAppointmentRequestsByOwnerUidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentRequestsByOwnerUidQuery, GetAppointmentRequestsByOwnerUidQueryVariables>(GetAppointmentRequestsByOwnerUidDocument, options);
      }
export function useGetAppointmentRequestsByOwnerUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentRequestsByOwnerUidQuery, GetAppointmentRequestsByOwnerUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentRequestsByOwnerUidQuery, GetAppointmentRequestsByOwnerUidQueryVariables>(GetAppointmentRequestsByOwnerUidDocument, options);
        }
export function useGetAppointmentRequestsByOwnerUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentRequestsByOwnerUidQuery, GetAppointmentRequestsByOwnerUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentRequestsByOwnerUidQuery, GetAppointmentRequestsByOwnerUidQueryVariables>(GetAppointmentRequestsByOwnerUidDocument, options);
        }
export type GetAppointmentRequestsByOwnerUidQueryHookResult = ReturnType<typeof useGetAppointmentRequestsByOwnerUidQuery>;
export type GetAppointmentRequestsByOwnerUidLazyQueryHookResult = ReturnType<typeof useGetAppointmentRequestsByOwnerUidLazyQuery>;
export type GetAppointmentRequestsByOwnerUidSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentRequestsByOwnerUidSuspenseQuery>;
export type GetAppointmentRequestsByOwnerUidQueryResult = Apollo.QueryResult<GetAppointmentRequestsByOwnerUidQuery, GetAppointmentRequestsByOwnerUidQueryVariables>;
export const GetAppointmentRequestsByExternalUidDocument = gql`
    query GetAppointmentRequestsByExternalUid {
  getAppointmentRequestsByExternalUid(page: 1) {
    ...appointmentRequestFields
  }
}
    ${AppointmentRequestFieldsFragmentDoc}`;

/**
 * __useGetAppointmentRequestsByExternalUidQuery__
 *
 * To run a query within a React component, call `useGetAppointmentRequestsByExternalUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentRequestsByExternalUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentRequestsByExternalUidQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentRequestsByExternalUidQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentRequestsByExternalUidQuery, GetAppointmentRequestsByExternalUidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentRequestsByExternalUidQuery, GetAppointmentRequestsByExternalUidQueryVariables>(GetAppointmentRequestsByExternalUidDocument, options);
      }
export function useGetAppointmentRequestsByExternalUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentRequestsByExternalUidQuery, GetAppointmentRequestsByExternalUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentRequestsByExternalUidQuery, GetAppointmentRequestsByExternalUidQueryVariables>(GetAppointmentRequestsByExternalUidDocument, options);
        }
export function useGetAppointmentRequestsByExternalUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentRequestsByExternalUidQuery, GetAppointmentRequestsByExternalUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentRequestsByExternalUidQuery, GetAppointmentRequestsByExternalUidQueryVariables>(GetAppointmentRequestsByExternalUidDocument, options);
        }
export type GetAppointmentRequestsByExternalUidQueryHookResult = ReturnType<typeof useGetAppointmentRequestsByExternalUidQuery>;
export type GetAppointmentRequestsByExternalUidLazyQueryHookResult = ReturnType<typeof useGetAppointmentRequestsByExternalUidLazyQuery>;
export type GetAppointmentRequestsByExternalUidSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentRequestsByExternalUidSuspenseQuery>;
export type GetAppointmentRequestsByExternalUidQueryResult = Apollo.QueryResult<GetAppointmentRequestsByExternalUidQuery, GetAppointmentRequestsByExternalUidQueryVariables>;
export const GetAppointmentRequestsByLocationUidsDocument = gql`
    query GetAppointmentRequestsByLocationUids($locationUids: [String!]!) {
  getAppointmentRequestsByLocationUids(locationUids: $locationUids, page: 1) {
    ...appointmentRequestFields
  }
}
    ${AppointmentRequestFieldsFragmentDoc}`;

/**
 * __useGetAppointmentRequestsByLocationUidsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentRequestsByLocationUidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentRequestsByLocationUidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentRequestsByLocationUidsQuery({
 *   variables: {
 *      locationUids: // value for 'locationUids'
 *   },
 * });
 */
export function useGetAppointmentRequestsByLocationUidsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentRequestsByLocationUidsQuery, GetAppointmentRequestsByLocationUidsQueryVariables> & ({ variables: GetAppointmentRequestsByLocationUidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentRequestsByLocationUidsQuery, GetAppointmentRequestsByLocationUidsQueryVariables>(GetAppointmentRequestsByLocationUidsDocument, options);
      }
export function useGetAppointmentRequestsByLocationUidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentRequestsByLocationUidsQuery, GetAppointmentRequestsByLocationUidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentRequestsByLocationUidsQuery, GetAppointmentRequestsByLocationUidsQueryVariables>(GetAppointmentRequestsByLocationUidsDocument, options);
        }
export function useGetAppointmentRequestsByLocationUidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentRequestsByLocationUidsQuery, GetAppointmentRequestsByLocationUidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentRequestsByLocationUidsQuery, GetAppointmentRequestsByLocationUidsQueryVariables>(GetAppointmentRequestsByLocationUidsDocument, options);
        }
export type GetAppointmentRequestsByLocationUidsQueryHookResult = ReturnType<typeof useGetAppointmentRequestsByLocationUidsQuery>;
export type GetAppointmentRequestsByLocationUidsLazyQueryHookResult = ReturnType<typeof useGetAppointmentRequestsByLocationUidsLazyQuery>;
export type GetAppointmentRequestsByLocationUidsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentRequestsByLocationUidsSuspenseQuery>;
export type GetAppointmentRequestsByLocationUidsQueryResult = Apollo.QueryResult<GetAppointmentRequestsByLocationUidsQuery, GetAppointmentRequestsByLocationUidsQueryVariables>;
export const V2Gateway_UpdateAppointmentRequestsDocument = gql`
    mutation V2Gateway_UpdateAppointmentRequests($data: [UpdateAppointmentRequestInput!]!) {
  updateAppointmentRequests(data: $data)
}
    `;
export type V2Gateway_UpdateAppointmentRequestsMutationFn = Apollo.MutationFunction<V2Gateway_UpdateAppointmentRequestsMutation, V2Gateway_UpdateAppointmentRequestsMutationVariables>;

/**
 * __useV2Gateway_UpdateAppointmentRequestsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateAppointmentRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateAppointmentRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateAppointmentRequestsMutation, { data, loading, error }] = useV2Gateway_UpdateAppointmentRequestsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateAppointmentRequestsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateAppointmentRequestsMutation, V2Gateway_UpdateAppointmentRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateAppointmentRequestsMutation, V2Gateway_UpdateAppointmentRequestsMutationVariables>(V2Gateway_UpdateAppointmentRequestsDocument, options);
      }
export type V2Gateway_UpdateAppointmentRequestsMutationHookResult = ReturnType<typeof useV2Gateway_UpdateAppointmentRequestsMutation>;
export type V2Gateway_UpdateAppointmentRequestsMutationResult = Apollo.MutationResult<V2Gateway_UpdateAppointmentRequestsMutation>;
export type V2Gateway_UpdateAppointmentRequestsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateAppointmentRequestsMutation, V2Gateway_UpdateAppointmentRequestsMutationVariables>;
export const V2Gateway_CreateAppointmentRequestsDocument = gql`
    mutation V2Gateway_CreateAppointmentRequests($data: [CreateAppointmentRequestInput!]!) {
  createAppointmentRequests(data: $data) {
    appointmentRequestUid
    nonce
    appointmentUid
  }
}
    `;
export type V2Gateway_CreateAppointmentRequestsMutationFn = Apollo.MutationFunction<V2Gateway_CreateAppointmentRequestsMutation, V2Gateway_CreateAppointmentRequestsMutationVariables>;

/**
 * __useV2Gateway_CreateAppointmentRequestsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateAppointmentRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateAppointmentRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateAppointmentRequestsMutation, { data, loading, error }] = useV2Gateway_CreateAppointmentRequestsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateAppointmentRequestsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateAppointmentRequestsMutation, V2Gateway_CreateAppointmentRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateAppointmentRequestsMutation, V2Gateway_CreateAppointmentRequestsMutationVariables>(V2Gateway_CreateAppointmentRequestsDocument, options);
      }
export type V2Gateway_CreateAppointmentRequestsMutationHookResult = ReturnType<typeof useV2Gateway_CreateAppointmentRequestsMutation>;
export type V2Gateway_CreateAppointmentRequestsMutationResult = Apollo.MutationResult<V2Gateway_CreateAppointmentRequestsMutation>;
export type V2Gateway_CreateAppointmentRequestsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateAppointmentRequestsMutation, V2Gateway_CreateAppointmentRequestsMutationVariables>;
export const V2Gateway_DeleteAppointmentRequestsDocument = gql`
    mutation V2Gateway_DeleteAppointmentRequests($appointmentRequestUids: [String!]!) {
  deleteAppointmentRequests(internalUids: $appointmentRequestUids)
}
    `;
export type V2Gateway_DeleteAppointmentRequestsMutationFn = Apollo.MutationFunction<V2Gateway_DeleteAppointmentRequestsMutation, V2Gateway_DeleteAppointmentRequestsMutationVariables>;

/**
 * __useV2Gateway_DeleteAppointmentRequestsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteAppointmentRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteAppointmentRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteAppointmentRequestsMutation, { data, loading, error }] = useV2Gateway_DeleteAppointmentRequestsMutation({
 *   variables: {
 *      appointmentRequestUids: // value for 'appointmentRequestUids'
 *   },
 * });
 */
export function useV2Gateway_DeleteAppointmentRequestsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteAppointmentRequestsMutation, V2Gateway_DeleteAppointmentRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteAppointmentRequestsMutation, V2Gateway_DeleteAppointmentRequestsMutationVariables>(V2Gateway_DeleteAppointmentRequestsDocument, options);
      }
export type V2Gateway_DeleteAppointmentRequestsMutationHookResult = ReturnType<typeof useV2Gateway_DeleteAppointmentRequestsMutation>;
export type V2Gateway_DeleteAppointmentRequestsMutationResult = Apollo.MutationResult<V2Gateway_DeleteAppointmentRequestsMutation>;
export type V2Gateway_DeleteAppointmentRequestsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteAppointmentRequestsMutation, V2Gateway_DeleteAppointmentRequestsMutationVariables>;
export const V2Gateway_UpdateBookingAttributesDocument = gql`
    mutation V2Gateway_UpdateBookingAttributes($bookingAttributes: [UpdateBookingAttributeInput!]!) {
  updateBookingAttributes(bookingAttributes: $bookingAttributes)
}
    `;
export type V2Gateway_UpdateBookingAttributesMutationFn = Apollo.MutationFunction<V2Gateway_UpdateBookingAttributesMutation, V2Gateway_UpdateBookingAttributesMutationVariables>;

/**
 * __useV2Gateway_UpdateBookingAttributesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateBookingAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateBookingAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateBookingAttributesMutation, { data, loading, error }] = useV2Gateway_UpdateBookingAttributesMutation({
 *   variables: {
 *      bookingAttributes: // value for 'bookingAttributes'
 *   },
 * });
 */
export function useV2Gateway_UpdateBookingAttributesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateBookingAttributesMutation, V2Gateway_UpdateBookingAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateBookingAttributesMutation, V2Gateway_UpdateBookingAttributesMutationVariables>(V2Gateway_UpdateBookingAttributesDocument, options);
      }
export type V2Gateway_UpdateBookingAttributesMutationHookResult = ReturnType<typeof useV2Gateway_UpdateBookingAttributesMutation>;
export type V2Gateway_UpdateBookingAttributesMutationResult = Apollo.MutationResult<V2Gateway_UpdateBookingAttributesMutation>;
export type V2Gateway_UpdateBookingAttributesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateBookingAttributesMutation, V2Gateway_UpdateBookingAttributesMutationVariables>;
export const V2Gateway_RemoveBookingAttributesDocument = gql`
    mutation V2Gateway_RemoveBookingAttributes($bookingAttributeUids: [String!]!) {
  removeBookingAttributes(bookingAttributeUids: $bookingAttributeUids)
}
    `;
export type V2Gateway_RemoveBookingAttributesMutationFn = Apollo.MutationFunction<V2Gateway_RemoveBookingAttributesMutation, V2Gateway_RemoveBookingAttributesMutationVariables>;

/**
 * __useV2Gateway_RemoveBookingAttributesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_RemoveBookingAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_RemoveBookingAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayRemoveBookingAttributesMutation, { data, loading, error }] = useV2Gateway_RemoveBookingAttributesMutation({
 *   variables: {
 *      bookingAttributeUids: // value for 'bookingAttributeUids'
 *   },
 * });
 */
export function useV2Gateway_RemoveBookingAttributesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_RemoveBookingAttributesMutation, V2Gateway_RemoveBookingAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_RemoveBookingAttributesMutation, V2Gateway_RemoveBookingAttributesMutationVariables>(V2Gateway_RemoveBookingAttributesDocument, options);
      }
export type V2Gateway_RemoveBookingAttributesMutationHookResult = ReturnType<typeof useV2Gateway_RemoveBookingAttributesMutation>;
export type V2Gateway_RemoveBookingAttributesMutationResult = Apollo.MutationResult<V2Gateway_RemoveBookingAttributesMutation>;
export type V2Gateway_RemoveBookingAttributesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_RemoveBookingAttributesMutation, V2Gateway_RemoveBookingAttributesMutationVariables>;
export const V2Gateway_GetCustomTaxRateLineItemsDocument = gql`
    query V2Gateway_GetCustomTaxRateLineItems {
  getCustomTaxRateLineItems {
    microPercent
    name
    uid
  }
}
    `;

/**
 * __useV2Gateway_GetCustomTaxRateLineItemsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetCustomTaxRateLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetCustomTaxRateLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetCustomTaxRateLineItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetCustomTaxRateLineItemsQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetCustomTaxRateLineItemsQuery, V2Gateway_GetCustomTaxRateLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetCustomTaxRateLineItemsQuery, V2Gateway_GetCustomTaxRateLineItemsQueryVariables>(V2Gateway_GetCustomTaxRateLineItemsDocument, options);
      }
export function useV2Gateway_GetCustomTaxRateLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetCustomTaxRateLineItemsQuery, V2Gateway_GetCustomTaxRateLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetCustomTaxRateLineItemsQuery, V2Gateway_GetCustomTaxRateLineItemsQueryVariables>(V2Gateway_GetCustomTaxRateLineItemsDocument, options);
        }
export function useV2Gateway_GetCustomTaxRateLineItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetCustomTaxRateLineItemsQuery, V2Gateway_GetCustomTaxRateLineItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetCustomTaxRateLineItemsQuery, V2Gateway_GetCustomTaxRateLineItemsQueryVariables>(V2Gateway_GetCustomTaxRateLineItemsDocument, options);
        }
export type V2Gateway_GetCustomTaxRateLineItemsQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomTaxRateLineItemsQuery>;
export type V2Gateway_GetCustomTaxRateLineItemsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomTaxRateLineItemsLazyQuery>;
export type V2Gateway_GetCustomTaxRateLineItemsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomTaxRateLineItemsSuspenseQuery>;
export type V2Gateway_GetCustomTaxRateLineItemsQueryResult = Apollo.QueryResult<V2Gateway_GetCustomTaxRateLineItemsQuery, V2Gateway_GetCustomTaxRateLineItemsQueryVariables>;
export const V2Gateway_UpdateCustomTaxRateLineItemsDocument = gql`
    mutation V2Gateway_UpdateCustomTaxRateLineItems($customTaxRateLineItems: [UpdateCustomTaxRateLineItemInput!]!) {
  updateCustomTaxRateLineItems(customTaxRateLineItems: $customTaxRateLineItems)
}
    `;
export type V2Gateway_UpdateCustomTaxRateLineItemsMutationFn = Apollo.MutationFunction<V2Gateway_UpdateCustomTaxRateLineItemsMutation, V2Gateway_UpdateCustomTaxRateLineItemsMutationVariables>;

/**
 * __useV2Gateway_UpdateCustomTaxRateLineItemsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateCustomTaxRateLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateCustomTaxRateLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateCustomTaxRateLineItemsMutation, { data, loading, error }] = useV2Gateway_UpdateCustomTaxRateLineItemsMutation({
 *   variables: {
 *      customTaxRateLineItems: // value for 'customTaxRateLineItems'
 *   },
 * });
 */
export function useV2Gateway_UpdateCustomTaxRateLineItemsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateCustomTaxRateLineItemsMutation, V2Gateway_UpdateCustomTaxRateLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateCustomTaxRateLineItemsMutation, V2Gateway_UpdateCustomTaxRateLineItemsMutationVariables>(V2Gateway_UpdateCustomTaxRateLineItemsDocument, options);
      }
export type V2Gateway_UpdateCustomTaxRateLineItemsMutationHookResult = ReturnType<typeof useV2Gateway_UpdateCustomTaxRateLineItemsMutation>;
export type V2Gateway_UpdateCustomTaxRateLineItemsMutationResult = Apollo.MutationResult<V2Gateway_UpdateCustomTaxRateLineItemsMutation>;
export type V2Gateway_UpdateCustomTaxRateLineItemsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateCustomTaxRateLineItemsMutation, V2Gateway_UpdateCustomTaxRateLineItemsMutationVariables>;
export const V2Gateway_CreateCustomTaxRateLineItemsDocument = gql`
    mutation V2Gateway_CreateCustomTaxRateLineItems($customTaxRateLineItems: [CreateCustomTaxRateLineItemInput!]!) {
  createCustomTaxRateLineItems(customTaxRateLineItems: $customTaxRateLineItems)
}
    `;
export type V2Gateway_CreateCustomTaxRateLineItemsMutationFn = Apollo.MutationFunction<V2Gateway_CreateCustomTaxRateLineItemsMutation, V2Gateway_CreateCustomTaxRateLineItemsMutationVariables>;

/**
 * __useV2Gateway_CreateCustomTaxRateLineItemsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateCustomTaxRateLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateCustomTaxRateLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateCustomTaxRateLineItemsMutation, { data, loading, error }] = useV2Gateway_CreateCustomTaxRateLineItemsMutation({
 *   variables: {
 *      customTaxRateLineItems: // value for 'customTaxRateLineItems'
 *   },
 * });
 */
export function useV2Gateway_CreateCustomTaxRateLineItemsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateCustomTaxRateLineItemsMutation, V2Gateway_CreateCustomTaxRateLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateCustomTaxRateLineItemsMutation, V2Gateway_CreateCustomTaxRateLineItemsMutationVariables>(V2Gateway_CreateCustomTaxRateLineItemsDocument, options);
      }
export type V2Gateway_CreateCustomTaxRateLineItemsMutationHookResult = ReturnType<typeof useV2Gateway_CreateCustomTaxRateLineItemsMutation>;
export type V2Gateway_CreateCustomTaxRateLineItemsMutationResult = Apollo.MutationResult<V2Gateway_CreateCustomTaxRateLineItemsMutation>;
export type V2Gateway_CreateCustomTaxRateLineItemsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateCustomTaxRateLineItemsMutation, V2Gateway_CreateCustomTaxRateLineItemsMutationVariables>;
export const V2Gateway_DeleteCustomTaxRateLineItemsDocument = gql`
    mutation V2Gateway_DeleteCustomTaxRateLineItems($internalUids: [String!]!) {
  deleteCustomTaxRateLineItems(internalUids: $internalUids)
}
    `;
export type V2Gateway_DeleteCustomTaxRateLineItemsMutationFn = Apollo.MutationFunction<V2Gateway_DeleteCustomTaxRateLineItemsMutation, V2Gateway_DeleteCustomTaxRateLineItemsMutationVariables>;

/**
 * __useV2Gateway_DeleteCustomTaxRateLineItemsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteCustomTaxRateLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteCustomTaxRateLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteCustomTaxRateLineItemsMutation, { data, loading, error }] = useV2Gateway_DeleteCustomTaxRateLineItemsMutation({
 *   variables: {
 *      internalUids: // value for 'internalUids'
 *   },
 * });
 */
export function useV2Gateway_DeleteCustomTaxRateLineItemsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteCustomTaxRateLineItemsMutation, V2Gateway_DeleteCustomTaxRateLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteCustomTaxRateLineItemsMutation, V2Gateway_DeleteCustomTaxRateLineItemsMutationVariables>(V2Gateway_DeleteCustomTaxRateLineItemsDocument, options);
      }
export type V2Gateway_DeleteCustomTaxRateLineItemsMutationHookResult = ReturnType<typeof useV2Gateway_DeleteCustomTaxRateLineItemsMutation>;
export type V2Gateway_DeleteCustomTaxRateLineItemsMutationResult = Apollo.MutationResult<V2Gateway_DeleteCustomTaxRateLineItemsMutation>;
export type V2Gateway_DeleteCustomTaxRateLineItemsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteCustomTaxRateLineItemsMutation, V2Gateway_DeleteCustomTaxRateLineItemsMutationVariables>;
export const V2Gateway_QueryEagerBookingsDocument = gql`
    query V2Gateway_QueryEagerBookings($query: EagerBookingQuery!) {
  queryEagerBookings(query: $query) {
    ...eagerBookingFields
  }
}
    ${EagerBookingFieldsFragmentDoc}`;

/**
 * __useV2Gateway_QueryEagerBookingsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryEagerBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryEagerBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryEagerBookingsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryEagerBookingsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryEagerBookingsQuery, V2Gateway_QueryEagerBookingsQueryVariables> & ({ variables: V2Gateway_QueryEagerBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryEagerBookingsQuery, V2Gateway_QueryEagerBookingsQueryVariables>(V2Gateway_QueryEagerBookingsDocument, options);
      }
export function useV2Gateway_QueryEagerBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryEagerBookingsQuery, V2Gateway_QueryEagerBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryEagerBookingsQuery, V2Gateway_QueryEagerBookingsQueryVariables>(V2Gateway_QueryEagerBookingsDocument, options);
        }
export function useV2Gateway_QueryEagerBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryEagerBookingsQuery, V2Gateway_QueryEagerBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryEagerBookingsQuery, V2Gateway_QueryEagerBookingsQueryVariables>(V2Gateway_QueryEagerBookingsDocument, options);
        }
export type V2Gateway_QueryEagerBookingsQueryHookResult = ReturnType<typeof useV2Gateway_QueryEagerBookingsQuery>;
export type V2Gateway_QueryEagerBookingsLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryEagerBookingsLazyQuery>;
export type V2Gateway_QueryEagerBookingsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryEagerBookingsSuspenseQuery>;
export type V2Gateway_QueryEagerBookingsQueryResult = Apollo.QueryResult<V2Gateway_QueryEagerBookingsQuery, V2Gateway_QueryEagerBookingsQueryVariables>;
export const V2Gateway_UpdateEagerBookingsDocument = gql`
    mutation V2Gateway_UpdateEagerBookings($data: [UpdateEagerBookingInput!]!) {
  updateEagerBookings(data: $data)
}
    `;
export type V2Gateway_UpdateEagerBookingsMutationFn = Apollo.MutationFunction<V2Gateway_UpdateEagerBookingsMutation, V2Gateway_UpdateEagerBookingsMutationVariables>;

/**
 * __useV2Gateway_UpdateEagerBookingsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateEagerBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateEagerBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateEagerBookingsMutation, { data, loading, error }] = useV2Gateway_UpdateEagerBookingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateEagerBookingsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateEagerBookingsMutation, V2Gateway_UpdateEagerBookingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateEagerBookingsMutation, V2Gateway_UpdateEagerBookingsMutationVariables>(V2Gateway_UpdateEagerBookingsDocument, options);
      }
export type V2Gateway_UpdateEagerBookingsMutationHookResult = ReturnType<typeof useV2Gateway_UpdateEagerBookingsMutation>;
export type V2Gateway_UpdateEagerBookingsMutationResult = Apollo.MutationResult<V2Gateway_UpdateEagerBookingsMutation>;
export type V2Gateway_UpdateEagerBookingsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateEagerBookingsMutation, V2Gateway_UpdateEagerBookingsMutationVariables>;
export const V2Gateway_CreateEagerBookingsDocument = gql`
    mutation V2Gateway_CreateEagerBookings($data: [CreateEagerBookingInput!]!) {
  createEagerBookings(data: $data) {
    eagerBookingUid
    bookingUid
  }
}
    `;
export type V2Gateway_CreateEagerBookingsMutationFn = Apollo.MutationFunction<V2Gateway_CreateEagerBookingsMutation, V2Gateway_CreateEagerBookingsMutationVariables>;

/**
 * __useV2Gateway_CreateEagerBookingsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateEagerBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateEagerBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateEagerBookingsMutation, { data, loading, error }] = useV2Gateway_CreateEagerBookingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateEagerBookingsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateEagerBookingsMutation, V2Gateway_CreateEagerBookingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateEagerBookingsMutation, V2Gateway_CreateEagerBookingsMutationVariables>(V2Gateway_CreateEagerBookingsDocument, options);
      }
export type V2Gateway_CreateEagerBookingsMutationHookResult = ReturnType<typeof useV2Gateway_CreateEagerBookingsMutation>;
export type V2Gateway_CreateEagerBookingsMutationResult = Apollo.MutationResult<V2Gateway_CreateEagerBookingsMutation>;
export type V2Gateway_CreateEagerBookingsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateEagerBookingsMutation, V2Gateway_CreateEagerBookingsMutationVariables>;
export const V2Gateway_DeleteEagerBookingsDocument = gql`
    mutation V2Gateway_DeleteEagerBookings($eagerBookingUids: [String!]!) {
  deleteEagerBookings(internalUids: $eagerBookingUids)
}
    `;
export type V2Gateway_DeleteEagerBookingsMutationFn = Apollo.MutationFunction<V2Gateway_DeleteEagerBookingsMutation, V2Gateway_DeleteEagerBookingsMutationVariables>;

/**
 * __useV2Gateway_DeleteEagerBookingsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteEagerBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteEagerBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteEagerBookingsMutation, { data, loading, error }] = useV2Gateway_DeleteEagerBookingsMutation({
 *   variables: {
 *      eagerBookingUids: // value for 'eagerBookingUids'
 *   },
 * });
 */
export function useV2Gateway_DeleteEagerBookingsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteEagerBookingsMutation, V2Gateway_DeleteEagerBookingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteEagerBookingsMutation, V2Gateway_DeleteEagerBookingsMutationVariables>(V2Gateway_DeleteEagerBookingsDocument, options);
      }
export type V2Gateway_DeleteEagerBookingsMutationHookResult = ReturnType<typeof useV2Gateway_DeleteEagerBookingsMutation>;
export type V2Gateway_DeleteEagerBookingsMutationResult = Apollo.MutationResult<V2Gateway_DeleteEagerBookingsMutation>;
export type V2Gateway_DeleteEagerBookingsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteEagerBookingsMutation, V2Gateway_DeleteEagerBookingsMutationVariables>;
export const V2Gateway_GetFilesDocument = gql`
    query V2Gateway_GetFiles($externalUids: [String!]!) {
  getFilesByExternalUid(externalUids: $externalUids) {
    uid
    externalUid
    index
    label
    uploadedFile {
      publicUrl
      objectName
    }
  }
}
    `;

/**
 * __useV2Gateway_GetFilesQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetFilesQuery({
 *   variables: {
 *      externalUids: // value for 'externalUids'
 *   },
 * });
 */
export function useV2Gateway_GetFilesQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetFilesQuery, V2Gateway_GetFilesQueryVariables> & ({ variables: V2Gateway_GetFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetFilesQuery, V2Gateway_GetFilesQueryVariables>(V2Gateway_GetFilesDocument, options);
      }
export function useV2Gateway_GetFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetFilesQuery, V2Gateway_GetFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetFilesQuery, V2Gateway_GetFilesQueryVariables>(V2Gateway_GetFilesDocument, options);
        }
export function useV2Gateway_GetFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetFilesQuery, V2Gateway_GetFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetFilesQuery, V2Gateway_GetFilesQueryVariables>(V2Gateway_GetFilesDocument, options);
        }
export type V2Gateway_GetFilesQueryHookResult = ReturnType<typeof useV2Gateway_GetFilesQuery>;
export type V2Gateway_GetFilesLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetFilesLazyQuery>;
export type V2Gateway_GetFilesSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetFilesSuspenseQuery>;
export type V2Gateway_GetFilesQueryResult = Apollo.QueryResult<V2Gateway_GetFilesQuery, V2Gateway_GetFilesQueryVariables>;
export const V2Gateway_UpdateFilesDocument = gql`
    mutation V2Gateway_UpdateFiles($data: [UpdateFileInput!]!) {
  updateFiles(data: $data)
}
    `;
export type V2Gateway_UpdateFilesMutationFn = Apollo.MutationFunction<V2Gateway_UpdateFilesMutation, V2Gateway_UpdateFilesMutationVariables>;

/**
 * __useV2Gateway_UpdateFilesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateFilesMutation, { data, loading, error }] = useV2Gateway_UpdateFilesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateFilesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateFilesMutation, V2Gateway_UpdateFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateFilesMutation, V2Gateway_UpdateFilesMutationVariables>(V2Gateway_UpdateFilesDocument, options);
      }
export type V2Gateway_UpdateFilesMutationHookResult = ReturnType<typeof useV2Gateway_UpdateFilesMutation>;
export type V2Gateway_UpdateFilesMutationResult = Apollo.MutationResult<V2Gateway_UpdateFilesMutation>;
export type V2Gateway_UpdateFilesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateFilesMutation, V2Gateway_UpdateFilesMutationVariables>;
export const V2Gateway_CreateFilesDocument = gql`
    mutation V2Gateway_CreateFiles($data: [CreateFileInput!]!) {
  createFiles(data: $data)
}
    `;
export type V2Gateway_CreateFilesMutationFn = Apollo.MutationFunction<V2Gateway_CreateFilesMutation, V2Gateway_CreateFilesMutationVariables>;

/**
 * __useV2Gateway_CreateFilesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateFilesMutation, { data, loading, error }] = useV2Gateway_CreateFilesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateFilesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateFilesMutation, V2Gateway_CreateFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateFilesMutation, V2Gateway_CreateFilesMutationVariables>(V2Gateway_CreateFilesDocument, options);
      }
export type V2Gateway_CreateFilesMutationHookResult = ReturnType<typeof useV2Gateway_CreateFilesMutation>;
export type V2Gateway_CreateFilesMutationResult = Apollo.MutationResult<V2Gateway_CreateFilesMutation>;
export type V2Gateway_CreateFilesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateFilesMutation, V2Gateway_CreateFilesMutationVariables>;
export const V2Gateway_DeleteFilesDocument = gql`
    mutation V2Gateway_DeleteFiles($internalUids: [String!]!) {
  deleteFiles(internalUids: $internalUids)
}
    `;
export type V2Gateway_DeleteFilesMutationFn = Apollo.MutationFunction<V2Gateway_DeleteFilesMutation, V2Gateway_DeleteFilesMutationVariables>;

/**
 * __useV2Gateway_DeleteFilesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteFilesMutation, { data, loading, error }] = useV2Gateway_DeleteFilesMutation({
 *   variables: {
 *      internalUids: // value for 'internalUids'
 *   },
 * });
 */
export function useV2Gateway_DeleteFilesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteFilesMutation, V2Gateway_DeleteFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteFilesMutation, V2Gateway_DeleteFilesMutationVariables>(V2Gateway_DeleteFilesDocument, options);
      }
export type V2Gateway_DeleteFilesMutationHookResult = ReturnType<typeof useV2Gateway_DeleteFilesMutation>;
export type V2Gateway_DeleteFilesMutationResult = Apollo.MutationResult<V2Gateway_DeleteFilesMutation>;
export type V2Gateway_DeleteFilesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteFilesMutation, V2Gateway_DeleteFilesMutationVariables>;
export const V2Gateway_UploadFilesDocument = gql`
    mutation V2Gateway_UploadFiles($files: [Upload!]!) {
  uploadFiles(files: $files) {
    publicUrl
    objectName
  }
}
    `;
export type V2Gateway_UploadFilesMutationFn = Apollo.MutationFunction<V2Gateway_UploadFilesMutation, V2Gateway_UploadFilesMutationVariables>;

/**
 * __useV2Gateway_UploadFilesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UploadFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UploadFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUploadFilesMutation, { data, loading, error }] = useV2Gateway_UploadFilesMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useV2Gateway_UploadFilesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UploadFilesMutation, V2Gateway_UploadFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UploadFilesMutation, V2Gateway_UploadFilesMutationVariables>(V2Gateway_UploadFilesDocument, options);
      }
export type V2Gateway_UploadFilesMutationHookResult = ReturnType<typeof useV2Gateway_UploadFilesMutation>;
export type V2Gateway_UploadFilesMutationResult = Apollo.MutationResult<V2Gateway_UploadFilesMutation>;
export type V2Gateway_UploadFilesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UploadFilesMutation, V2Gateway_UploadFilesMutationVariables>;
export const V2Gateway_GetInsuranceClaimableServiceProviderDocument = gql`
    query V2Gateway_GetInsuranceClaimableServiceProvider {
  getInsuranceClaimableServiceProviderByOwnerUID {
    licenseId
    titlePrefix
    titleSuffix
    uid
  }
}
    `;

/**
 * __useV2Gateway_GetInsuranceClaimableServiceProviderQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetInsuranceClaimableServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetInsuranceClaimableServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetInsuranceClaimableServiceProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetInsuranceClaimableServiceProviderQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetInsuranceClaimableServiceProviderQuery, V2Gateway_GetInsuranceClaimableServiceProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetInsuranceClaimableServiceProviderQuery, V2Gateway_GetInsuranceClaimableServiceProviderQueryVariables>(V2Gateway_GetInsuranceClaimableServiceProviderDocument, options);
      }
export function useV2Gateway_GetInsuranceClaimableServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetInsuranceClaimableServiceProviderQuery, V2Gateway_GetInsuranceClaimableServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetInsuranceClaimableServiceProviderQuery, V2Gateway_GetInsuranceClaimableServiceProviderQueryVariables>(V2Gateway_GetInsuranceClaimableServiceProviderDocument, options);
        }
export function useV2Gateway_GetInsuranceClaimableServiceProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetInsuranceClaimableServiceProviderQuery, V2Gateway_GetInsuranceClaimableServiceProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetInsuranceClaimableServiceProviderQuery, V2Gateway_GetInsuranceClaimableServiceProviderQueryVariables>(V2Gateway_GetInsuranceClaimableServiceProviderDocument, options);
        }
export type V2Gateway_GetInsuranceClaimableServiceProviderQueryHookResult = ReturnType<typeof useV2Gateway_GetInsuranceClaimableServiceProviderQuery>;
export type V2Gateway_GetInsuranceClaimableServiceProviderLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetInsuranceClaimableServiceProviderLazyQuery>;
export type V2Gateway_GetInsuranceClaimableServiceProviderSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetInsuranceClaimableServiceProviderSuspenseQuery>;
export type V2Gateway_GetInsuranceClaimableServiceProviderQueryResult = Apollo.QueryResult<V2Gateway_GetInsuranceClaimableServiceProviderQuery, V2Gateway_GetInsuranceClaimableServiceProviderQueryVariables>;
export const V2Gateway_CreateInsuranceClaimableServiceProviderDocument = gql`
    mutation V2Gateway_CreateInsuranceClaimableServiceProvider($data: InsuranceClaimableServiceProviderInput!) {
  createInsuranceClaimableServiceProvider(data: $data)
}
    `;
export type V2Gateway_CreateInsuranceClaimableServiceProviderMutationFn = Apollo.MutationFunction<V2Gateway_CreateInsuranceClaimableServiceProviderMutation, V2Gateway_CreateInsuranceClaimableServiceProviderMutationVariables>;

/**
 * __useV2Gateway_CreateInsuranceClaimableServiceProviderMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateInsuranceClaimableServiceProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateInsuranceClaimableServiceProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateInsuranceClaimableServiceProviderMutation, { data, loading, error }] = useV2Gateway_CreateInsuranceClaimableServiceProviderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateInsuranceClaimableServiceProviderMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateInsuranceClaimableServiceProviderMutation, V2Gateway_CreateInsuranceClaimableServiceProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateInsuranceClaimableServiceProviderMutation, V2Gateway_CreateInsuranceClaimableServiceProviderMutationVariables>(V2Gateway_CreateInsuranceClaimableServiceProviderDocument, options);
      }
export type V2Gateway_CreateInsuranceClaimableServiceProviderMutationHookResult = ReturnType<typeof useV2Gateway_CreateInsuranceClaimableServiceProviderMutation>;
export type V2Gateway_CreateInsuranceClaimableServiceProviderMutationResult = Apollo.MutationResult<V2Gateway_CreateInsuranceClaimableServiceProviderMutation>;
export type V2Gateway_CreateInsuranceClaimableServiceProviderMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateInsuranceClaimableServiceProviderMutation, V2Gateway_CreateInsuranceClaimableServiceProviderMutationVariables>;
export const V2Gateway_UpdateInsuranceClaimableServiceProviderDocument = gql`
    mutation V2Gateway_UpdateInsuranceClaimableServiceProvider($internalUid: String!, $data: InsuranceClaimableServiceProviderInput!) {
  updateInsuranceClaimableServiceProviderByInternalUID(
    internalUid: $internalUid
    data: $data
  )
}
    `;
export type V2Gateway_UpdateInsuranceClaimableServiceProviderMutationFn = Apollo.MutationFunction<V2Gateway_UpdateInsuranceClaimableServiceProviderMutation, V2Gateway_UpdateInsuranceClaimableServiceProviderMutationVariables>;

/**
 * __useV2Gateway_UpdateInsuranceClaimableServiceProviderMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateInsuranceClaimableServiceProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateInsuranceClaimableServiceProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateInsuranceClaimableServiceProviderMutation, { data, loading, error }] = useV2Gateway_UpdateInsuranceClaimableServiceProviderMutation({
 *   variables: {
 *      internalUid: // value for 'internalUid'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateInsuranceClaimableServiceProviderMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateInsuranceClaimableServiceProviderMutation, V2Gateway_UpdateInsuranceClaimableServiceProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateInsuranceClaimableServiceProviderMutation, V2Gateway_UpdateInsuranceClaimableServiceProviderMutationVariables>(V2Gateway_UpdateInsuranceClaimableServiceProviderDocument, options);
      }
export type V2Gateway_UpdateInsuranceClaimableServiceProviderMutationHookResult = ReturnType<typeof useV2Gateway_UpdateInsuranceClaimableServiceProviderMutation>;
export type V2Gateway_UpdateInsuranceClaimableServiceProviderMutationResult = Apollo.MutationResult<V2Gateway_UpdateInsuranceClaimableServiceProviderMutation>;
export type V2Gateway_UpdateInsuranceClaimableServiceProviderMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateInsuranceClaimableServiceProviderMutation, V2Gateway_UpdateInsuranceClaimableServiceProviderMutationVariables>;
export const V2Gateway_DeleteInsuranceClaimableServiceProviderDocument = gql`
    mutation V2Gateway_DeleteInsuranceClaimableServiceProvider($internalUid: String!) {
  deleteInsuranceClaimableServiceProviderByInternalUID(internalUid: $internalUid)
}
    `;
export type V2Gateway_DeleteInsuranceClaimableServiceProviderMutationFn = Apollo.MutationFunction<V2Gateway_DeleteInsuranceClaimableServiceProviderMutation, V2Gateway_DeleteInsuranceClaimableServiceProviderMutationVariables>;

/**
 * __useV2Gateway_DeleteInsuranceClaimableServiceProviderMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteInsuranceClaimableServiceProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteInsuranceClaimableServiceProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteInsuranceClaimableServiceProviderMutation, { data, loading, error }] = useV2Gateway_DeleteInsuranceClaimableServiceProviderMutation({
 *   variables: {
 *      internalUid: // value for 'internalUid'
 *   },
 * });
 */
export function useV2Gateway_DeleteInsuranceClaimableServiceProviderMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteInsuranceClaimableServiceProviderMutation, V2Gateway_DeleteInsuranceClaimableServiceProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteInsuranceClaimableServiceProviderMutation, V2Gateway_DeleteInsuranceClaimableServiceProviderMutationVariables>(V2Gateway_DeleteInsuranceClaimableServiceProviderDocument, options);
      }
export type V2Gateway_DeleteInsuranceClaimableServiceProviderMutationHookResult = ReturnType<typeof useV2Gateway_DeleteInsuranceClaimableServiceProviderMutation>;
export type V2Gateway_DeleteInsuranceClaimableServiceProviderMutationResult = Apollo.MutationResult<V2Gateway_DeleteInsuranceClaimableServiceProviderMutation>;
export type V2Gateway_DeleteInsuranceClaimableServiceProviderMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteInsuranceClaimableServiceProviderMutation, V2Gateway_DeleteInsuranceClaimableServiceProviderMutationVariables>;
export const V2Gateway_QueryLocationPoliciesDocument = gql`
    query V2Gateway_QueryLocationPolicies($query: LocationPolicyQuery!) {
  queryLocationPolicies(query: $query) {
    ...locationPolicyFields
  }
}
    ${LocationPolicyFieldsFragmentDoc}`;

/**
 * __useV2Gateway_QueryLocationPoliciesQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryLocationPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryLocationPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryLocationPoliciesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryLocationPoliciesQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryLocationPoliciesQuery, V2Gateway_QueryLocationPoliciesQueryVariables> & ({ variables: V2Gateway_QueryLocationPoliciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryLocationPoliciesQuery, V2Gateway_QueryLocationPoliciesQueryVariables>(V2Gateway_QueryLocationPoliciesDocument, options);
      }
export function useV2Gateway_QueryLocationPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryLocationPoliciesQuery, V2Gateway_QueryLocationPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryLocationPoliciesQuery, V2Gateway_QueryLocationPoliciesQueryVariables>(V2Gateway_QueryLocationPoliciesDocument, options);
        }
export function useV2Gateway_QueryLocationPoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryLocationPoliciesQuery, V2Gateway_QueryLocationPoliciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryLocationPoliciesQuery, V2Gateway_QueryLocationPoliciesQueryVariables>(V2Gateway_QueryLocationPoliciesDocument, options);
        }
export type V2Gateway_QueryLocationPoliciesQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationPoliciesQuery>;
export type V2Gateway_QueryLocationPoliciesLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationPoliciesLazyQuery>;
export type V2Gateway_QueryLocationPoliciesSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationPoliciesSuspenseQuery>;
export type V2Gateway_QueryLocationPoliciesQueryResult = Apollo.QueryResult<V2Gateway_QueryLocationPoliciesQuery, V2Gateway_QueryLocationPoliciesQueryVariables>;
export const V2Gateway_UpdateLocationPoliciesDocument = gql`
    mutation V2Gateway_UpdateLocationPolicies($data: [UpdateLocationPolicyInput!]!) {
  updateLocationPolicies(data: $data)
}
    `;
export type V2Gateway_UpdateLocationPoliciesMutationFn = Apollo.MutationFunction<V2Gateway_UpdateLocationPoliciesMutation, V2Gateway_UpdateLocationPoliciesMutationVariables>;

/**
 * __useV2Gateway_UpdateLocationPoliciesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateLocationPoliciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateLocationPoliciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateLocationPoliciesMutation, { data, loading, error }] = useV2Gateway_UpdateLocationPoliciesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateLocationPoliciesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateLocationPoliciesMutation, V2Gateway_UpdateLocationPoliciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateLocationPoliciesMutation, V2Gateway_UpdateLocationPoliciesMutationVariables>(V2Gateway_UpdateLocationPoliciesDocument, options);
      }
export type V2Gateway_UpdateLocationPoliciesMutationHookResult = ReturnType<typeof useV2Gateway_UpdateLocationPoliciesMutation>;
export type V2Gateway_UpdateLocationPoliciesMutationResult = Apollo.MutationResult<V2Gateway_UpdateLocationPoliciesMutation>;
export type V2Gateway_UpdateLocationPoliciesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateLocationPoliciesMutation, V2Gateway_UpdateLocationPoliciesMutationVariables>;
export const V2Gateway_CreateLocationPoliciesDocument = gql`
    mutation V2Gateway_CreateLocationPolicies($data: [CreateLocationPolicyInput!]!) {
  createLocationPolicies(data: $data)
}
    `;
export type V2Gateway_CreateLocationPoliciesMutationFn = Apollo.MutationFunction<V2Gateway_CreateLocationPoliciesMutation, V2Gateway_CreateLocationPoliciesMutationVariables>;

/**
 * __useV2Gateway_CreateLocationPoliciesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateLocationPoliciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateLocationPoliciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateLocationPoliciesMutation, { data, loading, error }] = useV2Gateway_CreateLocationPoliciesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateLocationPoliciesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateLocationPoliciesMutation, V2Gateway_CreateLocationPoliciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateLocationPoliciesMutation, V2Gateway_CreateLocationPoliciesMutationVariables>(V2Gateway_CreateLocationPoliciesDocument, options);
      }
export type V2Gateway_CreateLocationPoliciesMutationHookResult = ReturnType<typeof useV2Gateway_CreateLocationPoliciesMutation>;
export type V2Gateway_CreateLocationPoliciesMutationResult = Apollo.MutationResult<V2Gateway_CreateLocationPoliciesMutation>;
export type V2Gateway_CreateLocationPoliciesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateLocationPoliciesMutation, V2Gateway_CreateLocationPoliciesMutationVariables>;
export const V2Gateway_UpdateLocationSubscriptionRequestsDocument = gql`
    mutation V2Gateway_UpdateLocationSubscriptionRequests($data: [UpdateLocationSubscriptionRequestInput!]!) {
  updateLocationSubscriptionRequests(data: $data)
}
    `;
export type V2Gateway_UpdateLocationSubscriptionRequestsMutationFn = Apollo.MutationFunction<V2Gateway_UpdateLocationSubscriptionRequestsMutation, V2Gateway_UpdateLocationSubscriptionRequestsMutationVariables>;

/**
 * __useV2Gateway_UpdateLocationSubscriptionRequestsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateLocationSubscriptionRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateLocationSubscriptionRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateLocationSubscriptionRequestsMutation, { data, loading, error }] = useV2Gateway_UpdateLocationSubscriptionRequestsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateLocationSubscriptionRequestsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateLocationSubscriptionRequestsMutation, V2Gateway_UpdateLocationSubscriptionRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateLocationSubscriptionRequestsMutation, V2Gateway_UpdateLocationSubscriptionRequestsMutationVariables>(V2Gateway_UpdateLocationSubscriptionRequestsDocument, options);
      }
export type V2Gateway_UpdateLocationSubscriptionRequestsMutationHookResult = ReturnType<typeof useV2Gateway_UpdateLocationSubscriptionRequestsMutation>;
export type V2Gateway_UpdateLocationSubscriptionRequestsMutationResult = Apollo.MutationResult<V2Gateway_UpdateLocationSubscriptionRequestsMutation>;
export type V2Gateway_UpdateLocationSubscriptionRequestsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateLocationSubscriptionRequestsMutation, V2Gateway_UpdateLocationSubscriptionRequestsMutationVariables>;
export const V2Gateway_QueryLocationSubscriptionRequestsDocument = gql`
    query V2Gateway_QueryLocationSubscriptionRequests($query: LocationSubscriptionRequestQuery!) {
  queryLocationSubscriptionRequests(query: $query) {
    locationSubscriptionRequests {
      uid
      locationSubscription {
        locationUid
        ownerUid
      }
    }
    hasMoreResults
  }
}
    `;

/**
 * __useV2Gateway_QueryLocationSubscriptionRequestsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryLocationSubscriptionRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryLocationSubscriptionRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryLocationSubscriptionRequestsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryLocationSubscriptionRequestsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryLocationSubscriptionRequestsQuery, V2Gateway_QueryLocationSubscriptionRequestsQueryVariables> & ({ variables: V2Gateway_QueryLocationSubscriptionRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryLocationSubscriptionRequestsQuery, V2Gateway_QueryLocationSubscriptionRequestsQueryVariables>(V2Gateway_QueryLocationSubscriptionRequestsDocument, options);
      }
export function useV2Gateway_QueryLocationSubscriptionRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryLocationSubscriptionRequestsQuery, V2Gateway_QueryLocationSubscriptionRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryLocationSubscriptionRequestsQuery, V2Gateway_QueryLocationSubscriptionRequestsQueryVariables>(V2Gateway_QueryLocationSubscriptionRequestsDocument, options);
        }
export function useV2Gateway_QueryLocationSubscriptionRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryLocationSubscriptionRequestsQuery, V2Gateway_QueryLocationSubscriptionRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryLocationSubscriptionRequestsQuery, V2Gateway_QueryLocationSubscriptionRequestsQueryVariables>(V2Gateway_QueryLocationSubscriptionRequestsDocument, options);
        }
export type V2Gateway_QueryLocationSubscriptionRequestsQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationSubscriptionRequestsQuery>;
export type V2Gateway_QueryLocationSubscriptionRequestsLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationSubscriptionRequestsLazyQuery>;
export type V2Gateway_QueryLocationSubscriptionRequestsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationSubscriptionRequestsSuspenseQuery>;
export type V2Gateway_QueryLocationSubscriptionRequestsQueryResult = Apollo.QueryResult<V2Gateway_QueryLocationSubscriptionRequestsQuery, V2Gateway_QueryLocationSubscriptionRequestsQueryVariables>;
export const V2Gateway_CreateLocationSubscriptionRequestsDocument = gql`
    mutation V2Gateway_CreateLocationSubscriptionRequests($data: [CreateLocationSubscriptionRequestInput!]!) {
  createLocationSubscriptionRequests(data: $data) {
    internalUids
  }
}
    `;
export type V2Gateway_CreateLocationSubscriptionRequestsMutationFn = Apollo.MutationFunction<V2Gateway_CreateLocationSubscriptionRequestsMutation, V2Gateway_CreateLocationSubscriptionRequestsMutationVariables>;

/**
 * __useV2Gateway_CreateLocationSubscriptionRequestsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateLocationSubscriptionRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateLocationSubscriptionRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateLocationSubscriptionRequestsMutation, { data, loading, error }] = useV2Gateway_CreateLocationSubscriptionRequestsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateLocationSubscriptionRequestsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateLocationSubscriptionRequestsMutation, V2Gateway_CreateLocationSubscriptionRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateLocationSubscriptionRequestsMutation, V2Gateway_CreateLocationSubscriptionRequestsMutationVariables>(V2Gateway_CreateLocationSubscriptionRequestsDocument, options);
      }
export type V2Gateway_CreateLocationSubscriptionRequestsMutationHookResult = ReturnType<typeof useV2Gateway_CreateLocationSubscriptionRequestsMutation>;
export type V2Gateway_CreateLocationSubscriptionRequestsMutationResult = Apollo.MutationResult<V2Gateway_CreateLocationSubscriptionRequestsMutation>;
export type V2Gateway_CreateLocationSubscriptionRequestsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateLocationSubscriptionRequestsMutation, V2Gateway_CreateLocationSubscriptionRequestsMutationVariables>;
export const V2Gateway_DeleteLocationSubscriptionRequestDocument = gql`
    mutation V2Gateway_DeleteLocationSubscriptionRequest($uid: String!) {
  deleteLocationSubscriptionRequest(uid: $uid)
}
    `;
export type V2Gateway_DeleteLocationSubscriptionRequestMutationFn = Apollo.MutationFunction<V2Gateway_DeleteLocationSubscriptionRequestMutation, V2Gateway_DeleteLocationSubscriptionRequestMutationVariables>;

/**
 * __useV2Gateway_DeleteLocationSubscriptionRequestMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteLocationSubscriptionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteLocationSubscriptionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteLocationSubscriptionRequestMutation, { data, loading, error }] = useV2Gateway_DeleteLocationSubscriptionRequestMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useV2Gateway_DeleteLocationSubscriptionRequestMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteLocationSubscriptionRequestMutation, V2Gateway_DeleteLocationSubscriptionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteLocationSubscriptionRequestMutation, V2Gateway_DeleteLocationSubscriptionRequestMutationVariables>(V2Gateway_DeleteLocationSubscriptionRequestDocument, options);
      }
export type V2Gateway_DeleteLocationSubscriptionRequestMutationHookResult = ReturnType<typeof useV2Gateway_DeleteLocationSubscriptionRequestMutation>;
export type V2Gateway_DeleteLocationSubscriptionRequestMutationResult = Apollo.MutationResult<V2Gateway_DeleteLocationSubscriptionRequestMutation>;
export type V2Gateway_DeleteLocationSubscriptionRequestMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteLocationSubscriptionRequestMutation, V2Gateway_DeleteLocationSubscriptionRequestMutationVariables>;
export const DeleteLocationSubscriptionDocument = gql`
    mutation DeleteLocationSubscription($locationUid: String!) {
  deleteLocationSubscription(locationUid: $locationUid)
}
    `;
export type DeleteLocationSubscriptionMutationFn = Apollo.MutationFunction<DeleteLocationSubscriptionMutation, DeleteLocationSubscriptionMutationVariables>;

/**
 * __useDeleteLocationSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteLocationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationSubscriptionMutation, { data, loading, error }] = useDeleteLocationSubscriptionMutation({
 *   variables: {
 *      locationUid: // value for 'locationUid'
 *   },
 * });
 */
export function useDeleteLocationSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationSubscriptionMutation, DeleteLocationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationSubscriptionMutation, DeleteLocationSubscriptionMutationVariables>(DeleteLocationSubscriptionDocument, options);
      }
export type DeleteLocationSubscriptionMutationHookResult = ReturnType<typeof useDeleteLocationSubscriptionMutation>;
export type DeleteLocationSubscriptionMutationResult = Apollo.MutationResult<DeleteLocationSubscriptionMutation>;
export type DeleteLocationSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteLocationSubscriptionMutation, DeleteLocationSubscriptionMutationVariables>;
export const V2Gateway_CreateLocationsDocument = gql`
    mutation V2Gateway_CreateLocations($data: [CreateLocationInput!]!) {
  createLocations(data: $data) {
    internalUids
  }
}
    `;
export type V2Gateway_CreateLocationsMutationFn = Apollo.MutationFunction<V2Gateway_CreateLocationsMutation, V2Gateway_CreateLocationsMutationVariables>;

/**
 * __useV2Gateway_CreateLocationsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateLocationsMutation, { data, loading, error }] = useV2Gateway_CreateLocationsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateLocationsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateLocationsMutation, V2Gateway_CreateLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateLocationsMutation, V2Gateway_CreateLocationsMutationVariables>(V2Gateway_CreateLocationsDocument, options);
      }
export type V2Gateway_CreateLocationsMutationHookResult = ReturnType<typeof useV2Gateway_CreateLocationsMutation>;
export type V2Gateway_CreateLocationsMutationResult = Apollo.MutationResult<V2Gateway_CreateLocationsMutation>;
export type V2Gateway_CreateLocationsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateLocationsMutation, V2Gateway_CreateLocationsMutationVariables>;
export const V2Gateway_UpdateLocationsDocument = gql`
    mutation V2Gateway_UpdateLocations($data: [UpdateLocationInput!]!) {
  updateLocations(data: $data)
}
    `;
export type V2Gateway_UpdateLocationsMutationFn = Apollo.MutationFunction<V2Gateway_UpdateLocationsMutation, V2Gateway_UpdateLocationsMutationVariables>;

/**
 * __useV2Gateway_UpdateLocationsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateLocationsMutation, { data, loading, error }] = useV2Gateway_UpdateLocationsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateLocationsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateLocationsMutation, V2Gateway_UpdateLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateLocationsMutation, V2Gateway_UpdateLocationsMutationVariables>(V2Gateway_UpdateLocationsDocument, options);
      }
export type V2Gateway_UpdateLocationsMutationHookResult = ReturnType<typeof useV2Gateway_UpdateLocationsMutation>;
export type V2Gateway_UpdateLocationsMutationResult = Apollo.MutationResult<V2Gateway_UpdateLocationsMutation>;
export type V2Gateway_UpdateLocationsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateLocationsMutation, V2Gateway_UpdateLocationsMutationVariables>;
export const V2Gateway_DeleteLocationDocument = gql`
    mutation V2Gateway_DeleteLocation($locationUid: String!) {
  deleteLocation(locationUid: $locationUid)
}
    `;
export type V2Gateway_DeleteLocationMutationFn = Apollo.MutationFunction<V2Gateway_DeleteLocationMutation, V2Gateway_DeleteLocationMutationVariables>;

/**
 * __useV2Gateway_DeleteLocationMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteLocationMutation, { data, loading, error }] = useV2Gateway_DeleteLocationMutation({
 *   variables: {
 *      locationUid: // value for 'locationUid'
 *   },
 * });
 */
export function useV2Gateway_DeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteLocationMutation, V2Gateway_DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteLocationMutation, V2Gateway_DeleteLocationMutationVariables>(V2Gateway_DeleteLocationDocument, options);
      }
export type V2Gateway_DeleteLocationMutationHookResult = ReturnType<typeof useV2Gateway_DeleteLocationMutation>;
export type V2Gateway_DeleteLocationMutationResult = Apollo.MutationResult<V2Gateway_DeleteLocationMutation>;
export type V2Gateway_DeleteLocationMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteLocationMutation, V2Gateway_DeleteLocationMutationVariables>;
export const V2Gateway_GetProfileDocument = gql`
    query V2Gateway_GetProfile($ownerUid: String) {
  getProfileByOwnerUid(ownerUid: $ownerUid) {
    displayName
    description
    uid
    avatarImage {
      uid
      uploadedFile {
        publicUrl
      }
    }
    bannerImage {
      uid
      uploadedFile {
        publicUrl
      }
    }
    photoGallery {
      uid
      items {
        index
        uid
        imageFile {
          uid
          label
          index
          uploadedFile {
            publicUrl
            objectName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_GetProfileQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetProfileQuery({
 *   variables: {
 *      ownerUid: // value for 'ownerUid'
 *   },
 * });
 */
export function useV2Gateway_GetProfileQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetProfileQuery, V2Gateway_GetProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetProfileQuery, V2Gateway_GetProfileQueryVariables>(V2Gateway_GetProfileDocument, options);
      }
export function useV2Gateway_GetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetProfileQuery, V2Gateway_GetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetProfileQuery, V2Gateway_GetProfileQueryVariables>(V2Gateway_GetProfileDocument, options);
        }
export function useV2Gateway_GetProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetProfileQuery, V2Gateway_GetProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetProfileQuery, V2Gateway_GetProfileQueryVariables>(V2Gateway_GetProfileDocument, options);
        }
export type V2Gateway_GetProfileQueryHookResult = ReturnType<typeof useV2Gateway_GetProfileQuery>;
export type V2Gateway_GetProfileLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetProfileLazyQuery>;
export type V2Gateway_GetProfileSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetProfileSuspenseQuery>;
export type V2Gateway_GetProfileQueryResult = Apollo.QueryResult<V2Gateway_GetProfileQuery, V2Gateway_GetProfileQueryVariables>;
export const V2Gateway_UpdateProfileDocument = gql`
    mutation V2Gateway_UpdateProfile($profileUid: String!, $profile: ProfileInput!) {
  updateProfileByInternalUID(internalUid: $profileUid, profile: $profile)
}
    `;
export type V2Gateway_UpdateProfileMutationFn = Apollo.MutationFunction<V2Gateway_UpdateProfileMutation, V2Gateway_UpdateProfileMutationVariables>;

/**
 * __useV2Gateway_UpdateProfileMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateProfileMutation, { data, loading, error }] = useV2Gateway_UpdateProfileMutation({
 *   variables: {
 *      profileUid: // value for 'profileUid'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useV2Gateway_UpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateProfileMutation, V2Gateway_UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateProfileMutation, V2Gateway_UpdateProfileMutationVariables>(V2Gateway_UpdateProfileDocument, options);
      }
export type V2Gateway_UpdateProfileMutationHookResult = ReturnType<typeof useV2Gateway_UpdateProfileMutation>;
export type V2Gateway_UpdateProfileMutationResult = Apollo.MutationResult<V2Gateway_UpdateProfileMutation>;
export type V2Gateway_UpdateProfileMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateProfileMutation, V2Gateway_UpdateProfileMutationVariables>;
export const V2Gateway_CreateProfileDocument = gql`
    mutation V2Gateway_CreateProfile($profile: ProfileInput!) {
  createProfile(profile: $profile)
}
    `;
export type V2Gateway_CreateProfileMutationFn = Apollo.MutationFunction<V2Gateway_CreateProfileMutation, V2Gateway_CreateProfileMutationVariables>;

/**
 * __useV2Gateway_CreateProfileMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateProfileMutation, { data, loading, error }] = useV2Gateway_CreateProfileMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useV2Gateway_CreateProfileMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateProfileMutation, V2Gateway_CreateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateProfileMutation, V2Gateway_CreateProfileMutationVariables>(V2Gateway_CreateProfileDocument, options);
      }
export type V2Gateway_CreateProfileMutationHookResult = ReturnType<typeof useV2Gateway_CreateProfileMutation>;
export type V2Gateway_CreateProfileMutationResult = Apollo.MutationResult<V2Gateway_CreateProfileMutation>;
export type V2Gateway_CreateProfileMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateProfileMutation, V2Gateway_CreateProfileMutationVariables>;
export const V2Gateway_GetServiceAreasDocument = gql`
    query V2Gateway_GetServiceAreas($internalUids: [String!]!) {
  getServiceAreas(internalUids: $internalUids) {
    uid
    externalUid
    size
    name
    description
    files {
      uid
      externalUid
      label
      uploadedFile {
        objectName
        publicUrl
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_GetServiceAreasQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetServiceAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetServiceAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetServiceAreasQuery({
 *   variables: {
 *      internalUids: // value for 'internalUids'
 *   },
 * });
 */
export function useV2Gateway_GetServiceAreasQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetServiceAreasQuery, V2Gateway_GetServiceAreasQueryVariables> & ({ variables: V2Gateway_GetServiceAreasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetServiceAreasQuery, V2Gateway_GetServiceAreasQueryVariables>(V2Gateway_GetServiceAreasDocument, options);
      }
export function useV2Gateway_GetServiceAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetServiceAreasQuery, V2Gateway_GetServiceAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetServiceAreasQuery, V2Gateway_GetServiceAreasQueryVariables>(V2Gateway_GetServiceAreasDocument, options);
        }
export function useV2Gateway_GetServiceAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetServiceAreasQuery, V2Gateway_GetServiceAreasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetServiceAreasQuery, V2Gateway_GetServiceAreasQueryVariables>(V2Gateway_GetServiceAreasDocument, options);
        }
export type V2Gateway_GetServiceAreasQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceAreasQuery>;
export type V2Gateway_GetServiceAreasLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceAreasLazyQuery>;
export type V2Gateway_GetServiceAreasSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceAreasSuspenseQuery>;
export type V2Gateway_GetServiceAreasQueryResult = Apollo.QueryResult<V2Gateway_GetServiceAreasQuery, V2Gateway_GetServiceAreasQueryVariables>;
export const V2Gateway_UpdateServiceAreasDocument = gql`
    mutation V2Gateway_UpdateServiceAreas($data: [UpdateServiceAreaInput!]!) {
  updateServiceAreas(data: $data)
}
    `;
export type V2Gateway_UpdateServiceAreasMutationFn = Apollo.MutationFunction<V2Gateway_UpdateServiceAreasMutation, V2Gateway_UpdateServiceAreasMutationVariables>;

/**
 * __useV2Gateway_UpdateServiceAreasMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateServiceAreasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateServiceAreasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateServiceAreasMutation, { data, loading, error }] = useV2Gateway_UpdateServiceAreasMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateServiceAreasMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateServiceAreasMutation, V2Gateway_UpdateServiceAreasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateServiceAreasMutation, V2Gateway_UpdateServiceAreasMutationVariables>(V2Gateway_UpdateServiceAreasDocument, options);
      }
export type V2Gateway_UpdateServiceAreasMutationHookResult = ReturnType<typeof useV2Gateway_UpdateServiceAreasMutation>;
export type V2Gateway_UpdateServiceAreasMutationResult = Apollo.MutationResult<V2Gateway_UpdateServiceAreasMutation>;
export type V2Gateway_UpdateServiceAreasMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateServiceAreasMutation, V2Gateway_UpdateServiceAreasMutationVariables>;
export const V2Gateway_CreateServiceAreasDocument = gql`
    mutation V2Gateway_CreateServiceAreas($data: [CreateServiceAreaInput!]!) {
  createServiceAreas(data: $data) {
    uid
    nonce
  }
}
    `;
export type V2Gateway_CreateServiceAreasMutationFn = Apollo.MutationFunction<V2Gateway_CreateServiceAreasMutation, V2Gateway_CreateServiceAreasMutationVariables>;

/**
 * __useV2Gateway_CreateServiceAreasMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateServiceAreasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateServiceAreasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateServiceAreasMutation, { data, loading, error }] = useV2Gateway_CreateServiceAreasMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateServiceAreasMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateServiceAreasMutation, V2Gateway_CreateServiceAreasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateServiceAreasMutation, V2Gateway_CreateServiceAreasMutationVariables>(V2Gateway_CreateServiceAreasDocument, options);
      }
export type V2Gateway_CreateServiceAreasMutationHookResult = ReturnType<typeof useV2Gateway_CreateServiceAreasMutation>;
export type V2Gateway_CreateServiceAreasMutationResult = Apollo.MutationResult<V2Gateway_CreateServiceAreasMutation>;
export type V2Gateway_CreateServiceAreasMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateServiceAreasMutation, V2Gateway_CreateServiceAreasMutationVariables>;
export const V2Gateway_DeleteServiceAreasDocument = gql`
    mutation V2Gateway_DeleteServiceAreas($internalUids: [String!]!) {
  deleteServiceAreas(internalUids: $internalUids)
}
    `;
export type V2Gateway_DeleteServiceAreasMutationFn = Apollo.MutationFunction<V2Gateway_DeleteServiceAreasMutation, V2Gateway_DeleteServiceAreasMutationVariables>;

/**
 * __useV2Gateway_DeleteServiceAreasMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteServiceAreasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteServiceAreasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteServiceAreasMutation, { data, loading, error }] = useV2Gateway_DeleteServiceAreasMutation({
 *   variables: {
 *      internalUids: // value for 'internalUids'
 *   },
 * });
 */
export function useV2Gateway_DeleteServiceAreasMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteServiceAreasMutation, V2Gateway_DeleteServiceAreasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteServiceAreasMutation, V2Gateway_DeleteServiceAreasMutationVariables>(V2Gateway_DeleteServiceAreasDocument, options);
      }
export type V2Gateway_DeleteServiceAreasMutationHookResult = ReturnType<typeof useV2Gateway_DeleteServiceAreasMutation>;
export type V2Gateway_DeleteServiceAreasMutationResult = Apollo.MutationResult<V2Gateway_DeleteServiceAreasMutation>;
export type V2Gateway_DeleteServiceAreasMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteServiceAreasMutation, V2Gateway_DeleteServiceAreasMutationVariables>;
export const V2Gateway_GetTaxRateTogglesDocument = gql`
    query V2Gateway_GetTaxRateToggles($externalUids: [String!]!) {
  getTaxRateToggles(externalUids: $externalUids) {
    enabledTaxRateLineItemUids
    disabledTaxRateLineItems
    externalUid
  }
}
    `;

/**
 * __useV2Gateway_GetTaxRateTogglesQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetTaxRateTogglesQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetTaxRateTogglesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetTaxRateTogglesQuery({
 *   variables: {
 *      externalUids: // value for 'externalUids'
 *   },
 * });
 */
export function useV2Gateway_GetTaxRateTogglesQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetTaxRateTogglesQuery, V2Gateway_GetTaxRateTogglesQueryVariables> & ({ variables: V2Gateway_GetTaxRateTogglesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetTaxRateTogglesQuery, V2Gateway_GetTaxRateTogglesQueryVariables>(V2Gateway_GetTaxRateTogglesDocument, options);
      }
export function useV2Gateway_GetTaxRateTogglesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetTaxRateTogglesQuery, V2Gateway_GetTaxRateTogglesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetTaxRateTogglesQuery, V2Gateway_GetTaxRateTogglesQueryVariables>(V2Gateway_GetTaxRateTogglesDocument, options);
        }
export function useV2Gateway_GetTaxRateTogglesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetTaxRateTogglesQuery, V2Gateway_GetTaxRateTogglesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetTaxRateTogglesQuery, V2Gateway_GetTaxRateTogglesQueryVariables>(V2Gateway_GetTaxRateTogglesDocument, options);
        }
export type V2Gateway_GetTaxRateTogglesQueryHookResult = ReturnType<typeof useV2Gateway_GetTaxRateTogglesQuery>;
export type V2Gateway_GetTaxRateTogglesLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetTaxRateTogglesLazyQuery>;
export type V2Gateway_GetTaxRateTogglesSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetTaxRateTogglesSuspenseQuery>;
export type V2Gateway_GetTaxRateTogglesQueryResult = Apollo.QueryResult<V2Gateway_GetTaxRateTogglesQuery, V2Gateway_GetTaxRateTogglesQueryVariables>;
export const V2Gateway_UpdateTaxRateTogglesDocument = gql`
    mutation V2Gateway_UpdateTaxRateToggles($taxRateToggles: [TaxRateToggleInput!]!) {
  updateTaxRateToggles(taxRateToggles: $taxRateToggles)
}
    `;
export type V2Gateway_UpdateTaxRateTogglesMutationFn = Apollo.MutationFunction<V2Gateway_UpdateTaxRateTogglesMutation, V2Gateway_UpdateTaxRateTogglesMutationVariables>;

/**
 * __useV2Gateway_UpdateTaxRateTogglesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateTaxRateTogglesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateTaxRateTogglesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateTaxRateTogglesMutation, { data, loading, error }] = useV2Gateway_UpdateTaxRateTogglesMutation({
 *   variables: {
 *      taxRateToggles: // value for 'taxRateToggles'
 *   },
 * });
 */
export function useV2Gateway_UpdateTaxRateTogglesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateTaxRateTogglesMutation, V2Gateway_UpdateTaxRateTogglesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateTaxRateTogglesMutation, V2Gateway_UpdateTaxRateTogglesMutationVariables>(V2Gateway_UpdateTaxRateTogglesDocument, options);
      }
export type V2Gateway_UpdateTaxRateTogglesMutationHookResult = ReturnType<typeof useV2Gateway_UpdateTaxRateTogglesMutation>;
export type V2Gateway_UpdateTaxRateTogglesMutationResult = Apollo.MutationResult<V2Gateway_UpdateTaxRateTogglesMutation>;
export type V2Gateway_UpdateTaxRateTogglesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateTaxRateTogglesMutation, V2Gateway_UpdateTaxRateTogglesMutationVariables>;
export const V2Gateway_GetCustomTaxRateLineItemsByInternalUidDocument = gql`
    query V2Gateway_GetCustomTaxRateLineItemsByInternalUID($internalUids: [String!]!) {
  getCustomTaxRateLineItemsByInternalUid(internalUids: $internalUids) {
    microPercent
    name
    uid
  }
}
    `;

/**
 * __useV2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery({
 *   variables: {
 *      internalUids: // value for 'internalUids'
 *   },
 * });
 */
export function useV2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery, V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryVariables> & ({ variables: V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery, V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryVariables>(V2Gateway_GetCustomTaxRateLineItemsByInternalUidDocument, options);
      }
export function useV2Gateway_GetCustomTaxRateLineItemsByInternalUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery, V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery, V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryVariables>(V2Gateway_GetCustomTaxRateLineItemsByInternalUidDocument, options);
        }
export function useV2Gateway_GetCustomTaxRateLineItemsByInternalUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery, V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery, V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryVariables>(V2Gateway_GetCustomTaxRateLineItemsByInternalUidDocument, options);
        }
export type V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery>;
export type V2Gateway_GetCustomTaxRateLineItemsByInternalUidLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomTaxRateLineItemsByInternalUidLazyQuery>;
export type V2Gateway_GetCustomTaxRateLineItemsByInternalUidSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomTaxRateLineItemsByInternalUidSuspenseQuery>;
export type V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryResult = Apollo.QueryResult<V2Gateway_GetCustomTaxRateLineItemsByInternalUidQuery, V2Gateway_GetCustomTaxRateLineItemsByInternalUidQueryVariables>;
export const V2Gateway_GetTaxRateForServiceProviderDocument = gql`
    query V2Gateway_GetTaxRateForServiceProvider {
  getTaxRateForServiceProvider {
    lineItems {
      microPercent
      name
    }
  }
}
    `;

/**
 * __useV2Gateway_GetTaxRateForServiceProviderQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetTaxRateForServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetTaxRateForServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetTaxRateForServiceProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetTaxRateForServiceProviderQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetTaxRateForServiceProviderQuery, V2Gateway_GetTaxRateForServiceProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetTaxRateForServiceProviderQuery, V2Gateway_GetTaxRateForServiceProviderQueryVariables>(V2Gateway_GetTaxRateForServiceProviderDocument, options);
      }
export function useV2Gateway_GetTaxRateForServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetTaxRateForServiceProviderQuery, V2Gateway_GetTaxRateForServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetTaxRateForServiceProviderQuery, V2Gateway_GetTaxRateForServiceProviderQueryVariables>(V2Gateway_GetTaxRateForServiceProviderDocument, options);
        }
export function useV2Gateway_GetTaxRateForServiceProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetTaxRateForServiceProviderQuery, V2Gateway_GetTaxRateForServiceProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetTaxRateForServiceProviderQuery, V2Gateway_GetTaxRateForServiceProviderQueryVariables>(V2Gateway_GetTaxRateForServiceProviderDocument, options);
        }
export type V2Gateway_GetTaxRateForServiceProviderQueryHookResult = ReturnType<typeof useV2Gateway_GetTaxRateForServiceProviderQuery>;
export type V2Gateway_GetTaxRateForServiceProviderLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetTaxRateForServiceProviderLazyQuery>;
export type V2Gateway_GetTaxRateForServiceProviderSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetTaxRateForServiceProviderSuspenseQuery>;
export type V2Gateway_GetTaxRateForServiceProviderQueryResult = Apollo.QueryResult<V2Gateway_GetTaxRateForServiceProviderQuery, V2Gateway_GetTaxRateForServiceProviderQueryVariables>;
export const V2Gateway_GetServiceOfferingForBookingDocument = gql`
    query V2Gateway_GetServiceOfferingForBooking($query: ServiceOfferingQuery!) {
  queryServiceOfferings(query: $query) {
    serviceOfferings {
      title
    }
  }
}
    `;

/**
 * __useV2Gateway_GetServiceOfferingForBookingQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetServiceOfferingForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetServiceOfferingForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetServiceOfferingForBookingQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_GetServiceOfferingForBookingQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetServiceOfferingForBookingQuery, V2Gateway_GetServiceOfferingForBookingQueryVariables> & ({ variables: V2Gateway_GetServiceOfferingForBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetServiceOfferingForBookingQuery, V2Gateway_GetServiceOfferingForBookingQueryVariables>(V2Gateway_GetServiceOfferingForBookingDocument, options);
      }
export function useV2Gateway_GetServiceOfferingForBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetServiceOfferingForBookingQuery, V2Gateway_GetServiceOfferingForBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetServiceOfferingForBookingQuery, V2Gateway_GetServiceOfferingForBookingQueryVariables>(V2Gateway_GetServiceOfferingForBookingDocument, options);
        }
export function useV2Gateway_GetServiceOfferingForBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetServiceOfferingForBookingQuery, V2Gateway_GetServiceOfferingForBookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetServiceOfferingForBookingQuery, V2Gateway_GetServiceOfferingForBookingQueryVariables>(V2Gateway_GetServiceOfferingForBookingDocument, options);
        }
export type V2Gateway_GetServiceOfferingForBookingQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingForBookingQuery>;
export type V2Gateway_GetServiceOfferingForBookingLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingForBookingLazyQuery>;
export type V2Gateway_GetServiceOfferingForBookingSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingForBookingSuspenseQuery>;
export type V2Gateway_GetServiceOfferingForBookingQueryResult = Apollo.QueryResult<V2Gateway_GetServiceOfferingForBookingQuery, V2Gateway_GetServiceOfferingForBookingQueryVariables>;
export const BookingApi_CompleteBookingDocument = gql`
    mutation BookingAPI_CompleteBooking($uid: String!, $paymentGateway: PaymentGatewayType!) {
  completeBooking(uid: $uid, paymentGateway: $paymentGateway) {
    isSuccess
    error
  }
}
    `;
export type BookingApi_CompleteBookingMutationFn = Apollo.MutationFunction<BookingApi_CompleteBookingMutation, BookingApi_CompleteBookingMutationVariables>;

/**
 * __useBookingApi_CompleteBookingMutation__
 *
 * To run a mutation, you first call `useBookingApi_CompleteBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingApi_CompleteBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingApiCompleteBookingMutation, { data, loading, error }] = useBookingApi_CompleteBookingMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      paymentGateway: // value for 'paymentGateway'
 *   },
 * });
 */
export function useBookingApi_CompleteBookingMutation(baseOptions?: Apollo.MutationHookOptions<BookingApi_CompleteBookingMutation, BookingApi_CompleteBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookingApi_CompleteBookingMutation, BookingApi_CompleteBookingMutationVariables>(BookingApi_CompleteBookingDocument, options);
      }
export type BookingApi_CompleteBookingMutationHookResult = ReturnType<typeof useBookingApi_CompleteBookingMutation>;
export type BookingApi_CompleteBookingMutationResult = Apollo.MutationResult<BookingApi_CompleteBookingMutation>;
export type BookingApi_CompleteBookingMutationOptions = Apollo.BaseMutationOptions<BookingApi_CompleteBookingMutation, BookingApi_CompleteBookingMutationVariables>;
export const V2Gateway_UpdateBookingsDocument = gql`
    mutation V2Gateway_UpdateBookings($data: [UpdateBookingInput!]!) {
  updateBookings(data: $data)
}
    `;
export type V2Gateway_UpdateBookingsMutationFn = Apollo.MutationFunction<V2Gateway_UpdateBookingsMutation, V2Gateway_UpdateBookingsMutationVariables>;

/**
 * __useV2Gateway_UpdateBookingsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateBookingsMutation, { data, loading, error }] = useV2Gateway_UpdateBookingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateBookingsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateBookingsMutation, V2Gateway_UpdateBookingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateBookingsMutation, V2Gateway_UpdateBookingsMutationVariables>(V2Gateway_UpdateBookingsDocument, options);
      }
export type V2Gateway_UpdateBookingsMutationHookResult = ReturnType<typeof useV2Gateway_UpdateBookingsMutation>;
export type V2Gateway_UpdateBookingsMutationResult = Apollo.MutationResult<V2Gateway_UpdateBookingsMutation>;
export type V2Gateway_UpdateBookingsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateBookingsMutation, V2Gateway_UpdateBookingsMutationVariables>;
export const BookingApi_NoShowBookingDocument = gql`
    mutation BookingAPI_NoShowBooking($uid: String!) {
  noShowBooking(uid: $uid)
}
    `;
export type BookingApi_NoShowBookingMutationFn = Apollo.MutationFunction<BookingApi_NoShowBookingMutation, BookingApi_NoShowBookingMutationVariables>;

/**
 * __useBookingApi_NoShowBookingMutation__
 *
 * To run a mutation, you first call `useBookingApi_NoShowBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookingApi_NoShowBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookingApiNoShowBookingMutation, { data, loading, error }] = useBookingApi_NoShowBookingMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useBookingApi_NoShowBookingMutation(baseOptions?: Apollo.MutationHookOptions<BookingApi_NoShowBookingMutation, BookingApi_NoShowBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookingApi_NoShowBookingMutation, BookingApi_NoShowBookingMutationVariables>(BookingApi_NoShowBookingDocument, options);
      }
export type BookingApi_NoShowBookingMutationHookResult = ReturnType<typeof useBookingApi_NoShowBookingMutation>;
export type BookingApi_NoShowBookingMutationResult = Apollo.MutationResult<BookingApi_NoShowBookingMutation>;
export type BookingApi_NoShowBookingMutationOptions = Apollo.BaseMutationOptions<BookingApi_NoShowBookingMutation, BookingApi_NoShowBookingMutationVariables>;
export const GetAppointmentForAppointmentDetailsDocument = gql`
    query GetAppointmentForAppointmentDetails($appointmentUid: String!) {
  getAppointment(appointmentUid: $appointmentUid) {
    ...appointmentFieldsExtended
    bookings(statusQuery: {cancelledStatus: NOT_CANCELLED}) {
      id
      customerProfileId
      ...appointmentBookingFields
      isNoShow
      dropoff {
        dropoffDateTime
      }
      discounts {
        uid
        value
        name
        type
        isStackable
        change {
          type
          isCoveredByLocation
          isCoveredByPlatform
        }
      }
      customer {
        user {
          fullName
          emailAddress
          phoneNumber
        }
      }
    }
    serviceProvider {
      ...serviceProviderFullNew
      dayOfWeekAvailability {
        dayOfWeek
        timezone
        ownerUid
        availability {
          timeUtcSecondsBounds {
            min
            max
          }
        }
      }
      dateAvailability {
        date
        timezone
        ownerUid
        availability {
          timeUtcSecondsBounds {
            min
            max
          }
        }
      }
    }
  }
}
    ${AppointmentFieldsExtendedFragmentDoc}
${AppointmentBookingFieldsFragmentDoc}
${ServiceProviderFullNewFragmentDoc}`;

/**
 * __useGetAppointmentForAppointmentDetailsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentForAppointmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentForAppointmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentForAppointmentDetailsQuery({
 *   variables: {
 *      appointmentUid: // value for 'appointmentUid'
 *   },
 * });
 */
export function useGetAppointmentForAppointmentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentForAppointmentDetailsQuery, GetAppointmentForAppointmentDetailsQueryVariables> & ({ variables: GetAppointmentForAppointmentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentForAppointmentDetailsQuery, GetAppointmentForAppointmentDetailsQueryVariables>(GetAppointmentForAppointmentDetailsDocument, options);
      }
export function useGetAppointmentForAppointmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentForAppointmentDetailsQuery, GetAppointmentForAppointmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentForAppointmentDetailsQuery, GetAppointmentForAppointmentDetailsQueryVariables>(GetAppointmentForAppointmentDetailsDocument, options);
        }
export function useGetAppointmentForAppointmentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentForAppointmentDetailsQuery, GetAppointmentForAppointmentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentForAppointmentDetailsQuery, GetAppointmentForAppointmentDetailsQueryVariables>(GetAppointmentForAppointmentDetailsDocument, options);
        }
export type GetAppointmentForAppointmentDetailsQueryHookResult = ReturnType<typeof useGetAppointmentForAppointmentDetailsQuery>;
export type GetAppointmentForAppointmentDetailsLazyQueryHookResult = ReturnType<typeof useGetAppointmentForAppointmentDetailsLazyQuery>;
export type GetAppointmentForAppointmentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentForAppointmentDetailsSuspenseQuery>;
export type GetAppointmentForAppointmentDetailsQueryResult = Apollo.QueryResult<GetAppointmentForAppointmentDetailsQuery, GetAppointmentForAppointmentDetailsQueryVariables>;
export const V2Gateway_GetMerchantForAppointmentDetailsDocument = gql`
    query V2Gateway_GetMerchantForAppointmentDetails($merchantUid: String!) {
  getMerchant(uid: $merchantUid) {
    serviceType
  }
}
    `;

/**
 * __useV2Gateway_GetMerchantForAppointmentDetailsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetMerchantForAppointmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetMerchantForAppointmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetMerchantForAppointmentDetailsQuery({
 *   variables: {
 *      merchantUid: // value for 'merchantUid'
 *   },
 * });
 */
export function useV2Gateway_GetMerchantForAppointmentDetailsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetMerchantForAppointmentDetailsQuery, V2Gateway_GetMerchantForAppointmentDetailsQueryVariables> & ({ variables: V2Gateway_GetMerchantForAppointmentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetMerchantForAppointmentDetailsQuery, V2Gateway_GetMerchantForAppointmentDetailsQueryVariables>(V2Gateway_GetMerchantForAppointmentDetailsDocument, options);
      }
export function useV2Gateway_GetMerchantForAppointmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetMerchantForAppointmentDetailsQuery, V2Gateway_GetMerchantForAppointmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetMerchantForAppointmentDetailsQuery, V2Gateway_GetMerchantForAppointmentDetailsQueryVariables>(V2Gateway_GetMerchantForAppointmentDetailsDocument, options);
        }
export function useV2Gateway_GetMerchantForAppointmentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetMerchantForAppointmentDetailsQuery, V2Gateway_GetMerchantForAppointmentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetMerchantForAppointmentDetailsQuery, V2Gateway_GetMerchantForAppointmentDetailsQueryVariables>(V2Gateway_GetMerchantForAppointmentDetailsDocument, options);
        }
export type V2Gateway_GetMerchantForAppointmentDetailsQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantForAppointmentDetailsQuery>;
export type V2Gateway_GetMerchantForAppointmentDetailsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantForAppointmentDetailsLazyQuery>;
export type V2Gateway_GetMerchantForAppointmentDetailsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantForAppointmentDetailsSuspenseQuery>;
export type V2Gateway_GetMerchantForAppointmentDetailsQueryResult = Apollo.QueryResult<V2Gateway_GetMerchantForAppointmentDetailsQuery, V2Gateway_GetMerchantForAppointmentDetailsQueryVariables>;
export const V2Gateway_QueryServiceProvidersDocument = gql`
    query V2Gateway_QueryServiceProviders($query: ServiceProviderQuery!) {
  queryServiceProviders(query: $query) {
    hasMoreResults
    serviceProviders {
      displayName
      ownerUid
      id
      slug
      serviceType
      isApproved
      averageRating
      reviewCount
      profile {
        ...profileFragment
        socialLinks {
          platform
          url
        }
        introVideoURL
      }
      reviews {
        uid
        text
        isLike
        createdAt
        isExternal
        externalAuthor
      }
      serviceOfferings {
        uid
        basePrice
        baseTime
        title
        shortDesc
        type
      }
      serviceOfferingCategories {
        uid
        title
        description
        index
        serviceOfferings {
          uid
          title
          basePrice
          baseTime
          index
          type
        }
      }
      user {
        id
      }
      location {
        id
        phoneNumber
      }
      dayOfWeekAvailability {
        dayOfWeek
        availability {
          timeUtcSecondsBounds {
            min
            max
          }
        }
      }
      discountRules {
        id
        isDisabled
        label
        triggerCondition {
          siblingBookingTriggerCondition {
            requireBookingCount
            ignoreServiceOfferingUids
          }
          timeDurationBookedAtLocationTriggerCondition {
            requireDurationBookedSeconds
            ignoreServiceOfferingUids
          }
        }
        discountValue
        discountType
        priority
      }
    }
  }
}
    ${ProfileFragmentFragmentDoc}`;

/**
 * __useV2Gateway_QueryServiceProvidersQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryServiceProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryServiceProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryServiceProvidersQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryServiceProvidersQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryServiceProvidersQuery, V2Gateway_QueryServiceProvidersQueryVariables> & ({ variables: V2Gateway_QueryServiceProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryServiceProvidersQuery, V2Gateway_QueryServiceProvidersQueryVariables>(V2Gateway_QueryServiceProvidersDocument, options);
      }
export function useV2Gateway_QueryServiceProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryServiceProvidersQuery, V2Gateway_QueryServiceProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryServiceProvidersQuery, V2Gateway_QueryServiceProvidersQueryVariables>(V2Gateway_QueryServiceProvidersDocument, options);
        }
export function useV2Gateway_QueryServiceProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryServiceProvidersQuery, V2Gateway_QueryServiceProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryServiceProvidersQuery, V2Gateway_QueryServiceProvidersQueryVariables>(V2Gateway_QueryServiceProvidersDocument, options);
        }
export type V2Gateway_QueryServiceProvidersQueryHookResult = ReturnType<typeof useV2Gateway_QueryServiceProvidersQuery>;
export type V2Gateway_QueryServiceProvidersLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryServiceProvidersLazyQuery>;
export type V2Gateway_QueryServiceProvidersSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryServiceProvidersSuspenseQuery>;
export type V2Gateway_QueryServiceProvidersQueryResult = Apollo.QueryResult<V2Gateway_QueryServiceProvidersQuery, V2Gateway_QueryServiceProvidersQueryVariables>;
export const V2Gateway_GetProfilesDocument = gql`
    query V2Gateway_GetProfiles($ownerUids: [String!]!) {
  getProfilesByOwnerUid(ownerUids: $ownerUids) {
    ...profileFragment
    emailThemeHex
  }
}
    ${ProfileFragmentFragmentDoc}`;

/**
 * __useV2Gateway_GetProfilesQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetProfilesQuery({
 *   variables: {
 *      ownerUids: // value for 'ownerUids'
 *   },
 * });
 */
export function useV2Gateway_GetProfilesQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetProfilesQuery, V2Gateway_GetProfilesQueryVariables> & ({ variables: V2Gateway_GetProfilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetProfilesQuery, V2Gateway_GetProfilesQueryVariables>(V2Gateway_GetProfilesDocument, options);
      }
export function useV2Gateway_GetProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetProfilesQuery, V2Gateway_GetProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetProfilesQuery, V2Gateway_GetProfilesQueryVariables>(V2Gateway_GetProfilesDocument, options);
        }
export function useV2Gateway_GetProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetProfilesQuery, V2Gateway_GetProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetProfilesQuery, V2Gateway_GetProfilesQueryVariables>(V2Gateway_GetProfilesDocument, options);
        }
export type V2Gateway_GetProfilesQueryHookResult = ReturnType<typeof useV2Gateway_GetProfilesQuery>;
export type V2Gateway_GetProfilesLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetProfilesLazyQuery>;
export type V2Gateway_GetProfilesSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetProfilesSuspenseQuery>;
export type V2Gateway_GetProfilesQueryResult = Apollo.QueryResult<V2Gateway_GetProfilesQuery, V2Gateway_GetProfilesQueryVariables>;
export const V2Gateway_QueryDayOfWeekAvailabilityDocument = gql`
    query V2Gateway_QueryDayOfWeekAvailability($query: DayOfWeekAvailabilityQuery!) {
  queryDayOfWeekAvailability(query: $query) {
    dayOfWeekAvailability {
      ...dayOfWeekAvailabilityFields
    }
  }
}
    ${DayOfWeekAvailabilityFieldsFragmentDoc}`;

/**
 * __useV2Gateway_QueryDayOfWeekAvailabilityQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryDayOfWeekAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryDayOfWeekAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryDayOfWeekAvailabilityQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryDayOfWeekAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryDayOfWeekAvailabilityQuery, V2Gateway_QueryDayOfWeekAvailabilityQueryVariables> & ({ variables: V2Gateway_QueryDayOfWeekAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryDayOfWeekAvailabilityQuery, V2Gateway_QueryDayOfWeekAvailabilityQueryVariables>(V2Gateway_QueryDayOfWeekAvailabilityDocument, options);
      }
export function useV2Gateway_QueryDayOfWeekAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryDayOfWeekAvailabilityQuery, V2Gateway_QueryDayOfWeekAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryDayOfWeekAvailabilityQuery, V2Gateway_QueryDayOfWeekAvailabilityQueryVariables>(V2Gateway_QueryDayOfWeekAvailabilityDocument, options);
        }
export function useV2Gateway_QueryDayOfWeekAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryDayOfWeekAvailabilityQuery, V2Gateway_QueryDayOfWeekAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryDayOfWeekAvailabilityQuery, V2Gateway_QueryDayOfWeekAvailabilityQueryVariables>(V2Gateway_QueryDayOfWeekAvailabilityDocument, options);
        }
export type V2Gateway_QueryDayOfWeekAvailabilityQueryHookResult = ReturnType<typeof useV2Gateway_QueryDayOfWeekAvailabilityQuery>;
export type V2Gateway_QueryDayOfWeekAvailabilityLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryDayOfWeekAvailabilityLazyQuery>;
export type V2Gateway_QueryDayOfWeekAvailabilitySuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryDayOfWeekAvailabilitySuspenseQuery>;
export type V2Gateway_QueryDayOfWeekAvailabilityQueryResult = Apollo.QueryResult<V2Gateway_QueryDayOfWeekAvailabilityQuery, V2Gateway_QueryDayOfWeekAvailabilityQueryVariables>;
export const V2Gateway_QueryDateAvailabilityDocument = gql`
    query V2Gateway_QueryDateAvailability($query: DateAvailabilityQuery!) {
  queryDateAvailability(query: $query) {
    dateAvailability {
      ...dateAvailabilityFields
    }
  }
}
    ${DateAvailabilityFieldsFragmentDoc}`;

/**
 * __useV2Gateway_QueryDateAvailabilityQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryDateAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryDateAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryDateAvailabilityQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryDateAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryDateAvailabilityQuery, V2Gateway_QueryDateAvailabilityQueryVariables> & ({ variables: V2Gateway_QueryDateAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryDateAvailabilityQuery, V2Gateway_QueryDateAvailabilityQueryVariables>(V2Gateway_QueryDateAvailabilityDocument, options);
      }
export function useV2Gateway_QueryDateAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryDateAvailabilityQuery, V2Gateway_QueryDateAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryDateAvailabilityQuery, V2Gateway_QueryDateAvailabilityQueryVariables>(V2Gateway_QueryDateAvailabilityDocument, options);
        }
export function useV2Gateway_QueryDateAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryDateAvailabilityQuery, V2Gateway_QueryDateAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryDateAvailabilityQuery, V2Gateway_QueryDateAvailabilityQueryVariables>(V2Gateway_QueryDateAvailabilityDocument, options);
        }
export type V2Gateway_QueryDateAvailabilityQueryHookResult = ReturnType<typeof useV2Gateway_QueryDateAvailabilityQuery>;
export type V2Gateway_QueryDateAvailabilityLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryDateAvailabilityLazyQuery>;
export type V2Gateway_QueryDateAvailabilitySuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryDateAvailabilitySuspenseQuery>;
export type V2Gateway_QueryDateAvailabilityQueryResult = Apollo.QueryResult<V2Gateway_QueryDateAvailabilityQuery, V2Gateway_QueryDateAvailabilityQueryVariables>;
export const V2Gateway_SigninDocument = gql`
    mutation V2Gateway_Signin($idToken: String!, $timezoneLocation: String!, $createIfNotExists: Boolean!) {
  signin(
    idToken: $idToken
    timezoneLocation: $timezoneLocation
    createIfNotExists: $createIfNotExists
  ) {
    isNewUser
    jwt
    user {
      emailAddress
      fullName
      accountType
      uid
      country
    }
  }
}
    `;
export type V2Gateway_SigninMutationFn = Apollo.MutationFunction<V2Gateway_SigninMutation, V2Gateway_SigninMutationVariables>;

/**
 * __useV2Gateway_SigninMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SigninMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SigninMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySigninMutation, { data, loading, error }] = useV2Gateway_SigninMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *      timezoneLocation: // value for 'timezoneLocation'
 *      createIfNotExists: // value for 'createIfNotExists'
 *   },
 * });
 */
export function useV2Gateway_SigninMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SigninMutation, V2Gateway_SigninMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SigninMutation, V2Gateway_SigninMutationVariables>(V2Gateway_SigninDocument, options);
      }
export type V2Gateway_SigninMutationHookResult = ReturnType<typeof useV2Gateway_SigninMutation>;
export type V2Gateway_SigninMutationResult = Apollo.MutationResult<V2Gateway_SigninMutation>;
export type V2Gateway_SigninMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SigninMutation, V2Gateway_SigninMutationVariables>;
export const V2Gateway_SignoutDocument = gql`
    mutation V2Gateway_Signout {
  signout
}
    `;
export type V2Gateway_SignoutMutationFn = Apollo.MutationFunction<V2Gateway_SignoutMutation, V2Gateway_SignoutMutationVariables>;

/**
 * __useV2Gateway_SignoutMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SignoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SignoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySignoutMutation, { data, loading, error }] = useV2Gateway_SignoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_SignoutMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SignoutMutation, V2Gateway_SignoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SignoutMutation, V2Gateway_SignoutMutationVariables>(V2Gateway_SignoutDocument, options);
      }
export type V2Gateway_SignoutMutationHookResult = ReturnType<typeof useV2Gateway_SignoutMutation>;
export type V2Gateway_SignoutMutationResult = Apollo.MutationResult<V2Gateway_SignoutMutation>;
export type V2Gateway_SignoutMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SignoutMutation, V2Gateway_SignoutMutationVariables>;
export const V2Gateway_CheckSessionValidDocument = gql`
    query V2Gateway_checkSessionValid {
  checkSessionValid
}
    `;

/**
 * __useV2Gateway_CheckSessionValidQuery__
 *
 * To run a query within a React component, call `useV2Gateway_CheckSessionValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CheckSessionValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_CheckSessionValidQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_CheckSessionValidQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_CheckSessionValidQuery, V2Gateway_CheckSessionValidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_CheckSessionValidQuery, V2Gateway_CheckSessionValidQueryVariables>(V2Gateway_CheckSessionValidDocument, options);
      }
export function useV2Gateway_CheckSessionValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_CheckSessionValidQuery, V2Gateway_CheckSessionValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_CheckSessionValidQuery, V2Gateway_CheckSessionValidQueryVariables>(V2Gateway_CheckSessionValidDocument, options);
        }
export function useV2Gateway_CheckSessionValidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_CheckSessionValidQuery, V2Gateway_CheckSessionValidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_CheckSessionValidQuery, V2Gateway_CheckSessionValidQueryVariables>(V2Gateway_CheckSessionValidDocument, options);
        }
export type V2Gateway_CheckSessionValidQueryHookResult = ReturnType<typeof useV2Gateway_CheckSessionValidQuery>;
export type V2Gateway_CheckSessionValidLazyQueryHookResult = ReturnType<typeof useV2Gateway_CheckSessionValidLazyQuery>;
export type V2Gateway_CheckSessionValidSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_CheckSessionValidSuspenseQuery>;
export type V2Gateway_CheckSessionValidQueryResult = Apollo.QueryResult<V2Gateway_CheckSessionValidQuery, V2Gateway_CheckSessionValidQueryVariables>;
export const V2Gateway_GetStripeBalanceDocument = gql`
    query V2Gateway_GetStripeBalance {
  getStripeBalance {
    available {
      ...balanceFields
    }
    pending {
      ...balanceFields
    }
  }
}
    ${BalanceFieldsFragmentDoc}`;

/**
 * __useV2Gateway_GetStripeBalanceQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetStripeBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetStripeBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetStripeBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetStripeBalanceQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetStripeBalanceQuery, V2Gateway_GetStripeBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetStripeBalanceQuery, V2Gateway_GetStripeBalanceQueryVariables>(V2Gateway_GetStripeBalanceDocument, options);
      }
export function useV2Gateway_GetStripeBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetStripeBalanceQuery, V2Gateway_GetStripeBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetStripeBalanceQuery, V2Gateway_GetStripeBalanceQueryVariables>(V2Gateway_GetStripeBalanceDocument, options);
        }
export function useV2Gateway_GetStripeBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetStripeBalanceQuery, V2Gateway_GetStripeBalanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetStripeBalanceQuery, V2Gateway_GetStripeBalanceQueryVariables>(V2Gateway_GetStripeBalanceDocument, options);
        }
export type V2Gateway_GetStripeBalanceQueryHookResult = ReturnType<typeof useV2Gateway_GetStripeBalanceQuery>;
export type V2Gateway_GetStripeBalanceLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetStripeBalanceLazyQuery>;
export type V2Gateway_GetStripeBalanceSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetStripeBalanceSuspenseQuery>;
export type V2Gateway_GetStripeBalanceQueryResult = Apollo.QueryResult<V2Gateway_GetStripeBalanceQuery, V2Gateway_GetStripeBalanceQueryVariables>;
export const V2Gateway_GetStripeLoginLinkDocument = gql`
    query V2Gateway_GetStripeLoginLink {
  getStripeLoginLink
}
    `;

/**
 * __useV2Gateway_GetStripeLoginLinkQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetStripeLoginLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetStripeLoginLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetStripeLoginLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetStripeLoginLinkQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetStripeLoginLinkQuery, V2Gateway_GetStripeLoginLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetStripeLoginLinkQuery, V2Gateway_GetStripeLoginLinkQueryVariables>(V2Gateway_GetStripeLoginLinkDocument, options);
      }
export function useV2Gateway_GetStripeLoginLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetStripeLoginLinkQuery, V2Gateway_GetStripeLoginLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetStripeLoginLinkQuery, V2Gateway_GetStripeLoginLinkQueryVariables>(V2Gateway_GetStripeLoginLinkDocument, options);
        }
export function useV2Gateway_GetStripeLoginLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetStripeLoginLinkQuery, V2Gateway_GetStripeLoginLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetStripeLoginLinkQuery, V2Gateway_GetStripeLoginLinkQueryVariables>(V2Gateway_GetStripeLoginLinkDocument, options);
        }
export type V2Gateway_GetStripeLoginLinkQueryHookResult = ReturnType<typeof useV2Gateway_GetStripeLoginLinkQuery>;
export type V2Gateway_GetStripeLoginLinkLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetStripeLoginLinkLazyQuery>;
export type V2Gateway_GetStripeLoginLinkSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetStripeLoginLinkSuspenseQuery>;
export type V2Gateway_GetStripeLoginLinkQueryResult = Apollo.QueryResult<V2Gateway_GetStripeLoginLinkQuery, V2Gateway_GetStripeLoginLinkQueryVariables>;
export const V2Gateway_GetPaymentMethodsDocument = gql`
    query V2Gateway_GetPaymentMethods($masqueradeAsUid: String) {
  getPaymentMethods(masqueradeAsUid: $masqueradeAsUid) {
    brand
    lastFour
    expMonth
    expYear
    id
  }
  getStripeCustomer(masqueradeAsUid: $masqueradeAsUid) {
    defaultSource
    defaultPaymentMethodId
  }
}
    `;

/**
 * __useV2Gateway_GetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetPaymentMethodsQuery({
 *   variables: {
 *      masqueradeAsUid: // value for 'masqueradeAsUid'
 *   },
 * });
 */
export function useV2Gateway_GetPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetPaymentMethodsQuery, V2Gateway_GetPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetPaymentMethodsQuery, V2Gateway_GetPaymentMethodsQueryVariables>(V2Gateway_GetPaymentMethodsDocument, options);
      }
export function useV2Gateway_GetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetPaymentMethodsQuery, V2Gateway_GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetPaymentMethodsQuery, V2Gateway_GetPaymentMethodsQueryVariables>(V2Gateway_GetPaymentMethodsDocument, options);
        }
export function useV2Gateway_GetPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetPaymentMethodsQuery, V2Gateway_GetPaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetPaymentMethodsQuery, V2Gateway_GetPaymentMethodsQueryVariables>(V2Gateway_GetPaymentMethodsDocument, options);
        }
export type V2Gateway_GetPaymentMethodsQueryHookResult = ReturnType<typeof useV2Gateway_GetPaymentMethodsQuery>;
export type V2Gateway_GetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetPaymentMethodsLazyQuery>;
export type V2Gateway_GetPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetPaymentMethodsSuspenseQuery>;
export type V2Gateway_GetPaymentMethodsQueryResult = Apollo.QueryResult<V2Gateway_GetPaymentMethodsQuery, V2Gateway_GetPaymentMethodsQueryVariables>;
export const V2Gateway_GetSetupIntentSecretDocument = gql`
    query V2Gateway_GetSetupIntentSecret($masqueradeAsUid: String) {
  getSetupIntentSecret(masqueradeAsUid: $masqueradeAsUid)
}
    `;

/**
 * __useV2Gateway_GetSetupIntentSecretQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetSetupIntentSecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetSetupIntentSecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetSetupIntentSecretQuery({
 *   variables: {
 *      masqueradeAsUid: // value for 'masqueradeAsUid'
 *   },
 * });
 */
export function useV2Gateway_GetSetupIntentSecretQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetSetupIntentSecretQuery, V2Gateway_GetSetupIntentSecretQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetSetupIntentSecretQuery, V2Gateway_GetSetupIntentSecretQueryVariables>(V2Gateway_GetSetupIntentSecretDocument, options);
      }
export function useV2Gateway_GetSetupIntentSecretLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetSetupIntentSecretQuery, V2Gateway_GetSetupIntentSecretQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetSetupIntentSecretQuery, V2Gateway_GetSetupIntentSecretQueryVariables>(V2Gateway_GetSetupIntentSecretDocument, options);
        }
export function useV2Gateway_GetSetupIntentSecretSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetSetupIntentSecretQuery, V2Gateway_GetSetupIntentSecretQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetSetupIntentSecretQuery, V2Gateway_GetSetupIntentSecretQueryVariables>(V2Gateway_GetSetupIntentSecretDocument, options);
        }
export type V2Gateway_GetSetupIntentSecretQueryHookResult = ReturnType<typeof useV2Gateway_GetSetupIntentSecretQuery>;
export type V2Gateway_GetSetupIntentSecretLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetSetupIntentSecretLazyQuery>;
export type V2Gateway_GetSetupIntentSecretSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetSetupIntentSecretSuspenseQuery>;
export type V2Gateway_GetSetupIntentSecretQueryResult = Apollo.QueryResult<V2Gateway_GetSetupIntentSecretQuery, V2Gateway_GetSetupIntentSecretQueryVariables>;
export const V2Gateway_DetachPaymentMethodDocument = gql`
    mutation V2Gateway_DetachPaymentMethod($methodId: String!, $masqueradeAsUid: String) {
  detachPaymentMethod(methodId: $methodId, masqueradeAsUid: $masqueradeAsUid)
}
    `;
export type V2Gateway_DetachPaymentMethodMutationFn = Apollo.MutationFunction<V2Gateway_DetachPaymentMethodMutation, V2Gateway_DetachPaymentMethodMutationVariables>;

/**
 * __useV2Gateway_DetachPaymentMethodMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DetachPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DetachPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDetachPaymentMethodMutation, { data, loading, error }] = useV2Gateway_DetachPaymentMethodMutation({
 *   variables: {
 *      methodId: // value for 'methodId'
 *      masqueradeAsUid: // value for 'masqueradeAsUid'
 *   },
 * });
 */
export function useV2Gateway_DetachPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DetachPaymentMethodMutation, V2Gateway_DetachPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DetachPaymentMethodMutation, V2Gateway_DetachPaymentMethodMutationVariables>(V2Gateway_DetachPaymentMethodDocument, options);
      }
export type V2Gateway_DetachPaymentMethodMutationHookResult = ReturnType<typeof useV2Gateway_DetachPaymentMethodMutation>;
export type V2Gateway_DetachPaymentMethodMutationResult = Apollo.MutationResult<V2Gateway_DetachPaymentMethodMutation>;
export type V2Gateway_DetachPaymentMethodMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DetachPaymentMethodMutation, V2Gateway_DetachPaymentMethodMutationVariables>;
export const V2Gateway_SetDefaultPaymentMethodDocument = gql`
    mutation V2Gateway_SetDefaultPaymentMethod($methodId: String!, $masqueradeAsUid: String) {
  setDefaultPaymentMethod(methodId: $methodId, masqueradeAsUid: $masqueradeAsUid)
}
    `;
export type V2Gateway_SetDefaultPaymentMethodMutationFn = Apollo.MutationFunction<V2Gateway_SetDefaultPaymentMethodMutation, V2Gateway_SetDefaultPaymentMethodMutationVariables>;

/**
 * __useV2Gateway_SetDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SetDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SetDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySetDefaultPaymentMethodMutation, { data, loading, error }] = useV2Gateway_SetDefaultPaymentMethodMutation({
 *   variables: {
 *      methodId: // value for 'methodId'
 *      masqueradeAsUid: // value for 'masqueradeAsUid'
 *   },
 * });
 */
export function useV2Gateway_SetDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SetDefaultPaymentMethodMutation, V2Gateway_SetDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SetDefaultPaymentMethodMutation, V2Gateway_SetDefaultPaymentMethodMutationVariables>(V2Gateway_SetDefaultPaymentMethodDocument, options);
      }
export type V2Gateway_SetDefaultPaymentMethodMutationHookResult = ReturnType<typeof useV2Gateway_SetDefaultPaymentMethodMutation>;
export type V2Gateway_SetDefaultPaymentMethodMutationResult = Apollo.MutationResult<V2Gateway_SetDefaultPaymentMethodMutation>;
export type V2Gateway_SetDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SetDefaultPaymentMethodMutation, V2Gateway_SetDefaultPaymentMethodMutationVariables>;
export const GetAppointmentsDocument = gql`
    query GetAppointments($confirmedAppointmentsPage: Int!, $pendingAppointmentsPage: Int!) {
  getConfirmedAppointments(page: $confirmedAppointmentsPage) {
    ...appointmentFieldsExtended
  }
  getPendingAppointments(page: $pendingAppointmentsPage) {
    ...appointmentFieldsExtended
  }
  getConfirmedAppointmentsCount
  getPendingAppointmentsCount
}
    ${AppointmentFieldsExtendedFragmentDoc}`;

/**
 * __useGetAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsQuery({
 *   variables: {
 *      confirmedAppointmentsPage: // value for 'confirmedAppointmentsPage'
 *      pendingAppointmentsPage: // value for 'pendingAppointmentsPage'
 *   },
 * });
 */
export function useGetAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables> & ({ variables: GetAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
      }
export function useGetAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export function useGetAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export type GetAppointmentsQueryHookResult = ReturnType<typeof useGetAppointmentsQuery>;
export type GetAppointmentsLazyQueryHookResult = ReturnType<typeof useGetAppointmentsLazyQuery>;
export type GetAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsSuspenseQuery>;
export type GetAppointmentsQueryResult = Apollo.QueryResult<GetAppointmentsQuery, GetAppointmentsQueryVariables>;
export const GetAppointmentsForLocationsDocument = gql`
    query GetAppointmentsForLocations($locationUids: [String!]!, $page: Int!, $query: AppointmentQuery) {
  getAppointmentsForLocations(
    locationUids: $locationUids
    page: $page
    query: $query
  ) {
    startDateTime
    ownerUid
    userUid
    locationUid
    uid
    id
    serviceAreaUid
    isConfirmed
    isCoveredByBusiness
    bookingsWithSiblings {
      uid
      owner {
        fullName
      }
    }
    discountRuleProgress {
      progressPercent
      discountRule {
        label
        discountValue
        discountType
        priority
        requireDurationBookedSeconds
        requireBookingCount
      }
    }
    location {
      id
      uid
      streetAddress
      name
      type
      phoneNumber
      placeId
    }
    serviceProvider {
      ownerUid
      serviceType
      slug
      displayName
      averageRating
      serviceOfferings {
        uid
        title
        index
      }
      reviews {
        isLike
        isVerified
      }
      profile {
        displayName
        avatarImage {
          uploadedFile {
            publicUrl
          }
        }
      }
    }
    serviceArea {
      uid
      name
    }
    preferences {
      type
      value
    }
    serviceArea {
      uid
      name
    }
    bookings(statusQuery: {cancelledStatus: NOT_CANCELLED}) {
      uid
      ownerUid
    }
  }
  getAppointmentsForLocationsCount(locationUids: $locationUids)
}
    `;

/**
 * __useGetAppointmentsForLocationsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsForLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsForLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsForLocationsQuery({
 *   variables: {
 *      locationUids: // value for 'locationUids'
 *      page: // value for 'page'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAppointmentsForLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsForLocationsQuery, GetAppointmentsForLocationsQueryVariables> & ({ variables: GetAppointmentsForLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsForLocationsQuery, GetAppointmentsForLocationsQueryVariables>(GetAppointmentsForLocationsDocument, options);
      }
export function useGetAppointmentsForLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsForLocationsQuery, GetAppointmentsForLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsForLocationsQuery, GetAppointmentsForLocationsQueryVariables>(GetAppointmentsForLocationsDocument, options);
        }
export function useGetAppointmentsForLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentsForLocationsQuery, GetAppointmentsForLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsForLocationsQuery, GetAppointmentsForLocationsQueryVariables>(GetAppointmentsForLocationsDocument, options);
        }
export type GetAppointmentsForLocationsQueryHookResult = ReturnType<typeof useGetAppointmentsForLocationsQuery>;
export type GetAppointmentsForLocationsLazyQueryHookResult = ReturnType<typeof useGetAppointmentsForLocationsLazyQuery>;
export type GetAppointmentsForLocationsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsForLocationsSuspenseQuery>;
export type GetAppointmentsForLocationsQueryResult = Apollo.QueryResult<GetAppointmentsForLocationsQuery, GetAppointmentsForLocationsQueryVariables>;
export const V2Gateway_GetServiceOfferingsForServiceProviderDocument = gql`
    query V2Gateway_GetServiceOfferingsForServiceProvider($query: ServiceOfferingQuery!) {
  queryServiceOfferings(query: $query) {
    hasMoreResults
    serviceOfferings {
      title
      basePrice
      shortDesc
      baseTime
      imageUrl
      uid
      allowTip
      maxConcurrentBookings
      type
      index
    }
  }
}
    `;

/**
 * __useV2Gateway_GetServiceOfferingsForServiceProviderQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetServiceOfferingsForServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetServiceOfferingsForServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetServiceOfferingsForServiceProviderQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_GetServiceOfferingsForServiceProviderQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetServiceOfferingsForServiceProviderQuery, V2Gateway_GetServiceOfferingsForServiceProviderQueryVariables> & ({ variables: V2Gateway_GetServiceOfferingsForServiceProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetServiceOfferingsForServiceProviderQuery, V2Gateway_GetServiceOfferingsForServiceProviderQueryVariables>(V2Gateway_GetServiceOfferingsForServiceProviderDocument, options);
      }
export function useV2Gateway_GetServiceOfferingsForServiceProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetServiceOfferingsForServiceProviderQuery, V2Gateway_GetServiceOfferingsForServiceProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetServiceOfferingsForServiceProviderQuery, V2Gateway_GetServiceOfferingsForServiceProviderQueryVariables>(V2Gateway_GetServiceOfferingsForServiceProviderDocument, options);
        }
export function useV2Gateway_GetServiceOfferingsForServiceProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetServiceOfferingsForServiceProviderQuery, V2Gateway_GetServiceOfferingsForServiceProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetServiceOfferingsForServiceProviderQuery, V2Gateway_GetServiceOfferingsForServiceProviderQueryVariables>(V2Gateway_GetServiceOfferingsForServiceProviderDocument, options);
        }
export type V2Gateway_GetServiceOfferingsForServiceProviderQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingsForServiceProviderQuery>;
export type V2Gateway_GetServiceOfferingsForServiceProviderLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingsForServiceProviderLazyQuery>;
export type V2Gateway_GetServiceOfferingsForServiceProviderSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingsForServiceProviderSuspenseQuery>;
export type V2Gateway_GetServiceOfferingsForServiceProviderQueryResult = Apollo.QueryResult<V2Gateway_GetServiceOfferingsForServiceProviderQuery, V2Gateway_GetServiceOfferingsForServiceProviderQueryVariables>;
export const V2Gateway_GetBookingAttributesDocument = gql`
    query V2Gateway_GetBookingAttributes($bookingUid: String!) {
  getBookingAttributes(bookingUid: $bookingUid) {
    uid
    price
    duration
    description
    type
    bookingUid
  }
}
    `;

/**
 * __useV2Gateway_GetBookingAttributesQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetBookingAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetBookingAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetBookingAttributesQuery({
 *   variables: {
 *      bookingUid: // value for 'bookingUid'
 *   },
 * });
 */
export function useV2Gateway_GetBookingAttributesQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetBookingAttributesQuery, V2Gateway_GetBookingAttributesQueryVariables> & ({ variables: V2Gateway_GetBookingAttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetBookingAttributesQuery, V2Gateway_GetBookingAttributesQueryVariables>(V2Gateway_GetBookingAttributesDocument, options);
      }
export function useV2Gateway_GetBookingAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetBookingAttributesQuery, V2Gateway_GetBookingAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetBookingAttributesQuery, V2Gateway_GetBookingAttributesQueryVariables>(V2Gateway_GetBookingAttributesDocument, options);
        }
export function useV2Gateway_GetBookingAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetBookingAttributesQuery, V2Gateway_GetBookingAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetBookingAttributesQuery, V2Gateway_GetBookingAttributesQueryVariables>(V2Gateway_GetBookingAttributesDocument, options);
        }
export type V2Gateway_GetBookingAttributesQueryHookResult = ReturnType<typeof useV2Gateway_GetBookingAttributesQuery>;
export type V2Gateway_GetBookingAttributesLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetBookingAttributesLazyQuery>;
export type V2Gateway_GetBookingAttributesSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetBookingAttributesSuspenseQuery>;
export type V2Gateway_GetBookingAttributesQueryResult = Apollo.QueryResult<V2Gateway_GetBookingAttributesQuery, V2Gateway_GetBookingAttributesQueryVariables>;
export const V2Gateway_AddBookingAttributesDocument = gql`
    mutation V2Gateway_AddBookingAttributes($bookingAttributes: [BookingAttributeInput!]!) {
  addBookingAttributes(bookingAttributes: $bookingAttributes)
}
    `;
export type V2Gateway_AddBookingAttributesMutationFn = Apollo.MutationFunction<V2Gateway_AddBookingAttributesMutation, V2Gateway_AddBookingAttributesMutationVariables>;

/**
 * __useV2Gateway_AddBookingAttributesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_AddBookingAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_AddBookingAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayAddBookingAttributesMutation, { data, loading, error }] = useV2Gateway_AddBookingAttributesMutation({
 *   variables: {
 *      bookingAttributes: // value for 'bookingAttributes'
 *   },
 * });
 */
export function useV2Gateway_AddBookingAttributesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_AddBookingAttributesMutation, V2Gateway_AddBookingAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_AddBookingAttributesMutation, V2Gateway_AddBookingAttributesMutationVariables>(V2Gateway_AddBookingAttributesDocument, options);
      }
export type V2Gateway_AddBookingAttributesMutationHookResult = ReturnType<typeof useV2Gateway_AddBookingAttributesMutation>;
export type V2Gateway_AddBookingAttributesMutationResult = Apollo.MutationResult<V2Gateway_AddBookingAttributesMutation>;
export type V2Gateway_AddBookingAttributesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_AddBookingAttributesMutation, V2Gateway_AddBookingAttributesMutationVariables>;
export const V2Gateway_QueryDiscountsDocument = gql`
    query V2Gateway_QueryDiscounts($query: DiscountQuery!) {
  queryDiscounts(query: $query) {
    discounts {
      uid
      value
      name
      type
      isStackable
      booking {
        uid
      }
      change {
        type
        isCoveredByLocation
        isCoveredByPlatform
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_QueryDiscountsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryDiscountsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryDiscountsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryDiscountsQuery, V2Gateway_QueryDiscountsQueryVariables> & ({ variables: V2Gateway_QueryDiscountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryDiscountsQuery, V2Gateway_QueryDiscountsQueryVariables>(V2Gateway_QueryDiscountsDocument, options);
      }
export function useV2Gateway_QueryDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryDiscountsQuery, V2Gateway_QueryDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryDiscountsQuery, V2Gateway_QueryDiscountsQueryVariables>(V2Gateway_QueryDiscountsDocument, options);
        }
export function useV2Gateway_QueryDiscountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryDiscountsQuery, V2Gateway_QueryDiscountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryDiscountsQuery, V2Gateway_QueryDiscountsQueryVariables>(V2Gateway_QueryDiscountsDocument, options);
        }
export type V2Gateway_QueryDiscountsQueryHookResult = ReturnType<typeof useV2Gateway_QueryDiscountsQuery>;
export type V2Gateway_QueryDiscountsLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryDiscountsLazyQuery>;
export type V2Gateway_QueryDiscountsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryDiscountsSuspenseQuery>;
export type V2Gateway_QueryDiscountsQueryResult = Apollo.QueryResult<V2Gateway_QueryDiscountsQuery, V2Gateway_QueryDiscountsQueryVariables>;
export const GetAppointmentDocument = gql`
    query GetAppointment($appointmentUid: String!) {
  getAppointment(appointmentUid: $appointmentUid) {
    isCoveredByBusiness
    userUid
    uid
    id
    locationUid
    ownerUid
    startDateTime
    maxEndDateTime
    isCancelled
    isConfirmed
    eventEndDateTime
    preferences {
      type
      value
    }
    serviceArea {
      uid
      name
      description
      externalUid
      files {
        uid
        externalUid
        label
        uploadedFile {
          objectName
          publicUrl
        }
      }
    }
    location {
      id
      uid
      name
      formattedAddress
      phoneNumber
      type
      latitude
      longitude
      ownerUid
      placeId
      owner {
        fullName
        emailAddress
        phoneNumber
      }
    }
    serviceProvider {
      ...serviceProviderFullNew
    }
  }
}
    ${ServiceProviderFullNewFragmentDoc}`;

/**
 * __useGetAppointmentQuery__
 *
 * To run a query within a React component, call `useGetAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentQuery({
 *   variables: {
 *      appointmentUid: // value for 'appointmentUid'
 *   },
 * });
 */
export function useGetAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables> & ({ variables: GetAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
      }
export function useGetAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export function useGetAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export type GetAppointmentQueryHookResult = ReturnType<typeof useGetAppointmentQuery>;
export type GetAppointmentLazyQueryHookResult = ReturnType<typeof useGetAppointmentLazyQuery>;
export type GetAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentSuspenseQuery>;
export type GetAppointmentQueryResult = Apollo.QueryResult<GetAppointmentQuery, GetAppointmentQueryVariables>;
export const V2Gateway_GetMerchantDocument = gql`
    query V2Gateway_GetMerchant($uid: String!) {
  getMerchant(uid: $uid) {
    serviceType
  }
}
    `;

/**
 * __useV2Gateway_GetMerchantQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetMerchantQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useV2Gateway_GetMerchantQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetMerchantQuery, V2Gateway_GetMerchantQueryVariables> & ({ variables: V2Gateway_GetMerchantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetMerchantQuery, V2Gateway_GetMerchantQueryVariables>(V2Gateway_GetMerchantDocument, options);
      }
export function useV2Gateway_GetMerchantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetMerchantQuery, V2Gateway_GetMerchantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetMerchantQuery, V2Gateway_GetMerchantQueryVariables>(V2Gateway_GetMerchantDocument, options);
        }
export function useV2Gateway_GetMerchantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetMerchantQuery, V2Gateway_GetMerchantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetMerchantQuery, V2Gateway_GetMerchantQueryVariables>(V2Gateway_GetMerchantDocument, options);
        }
export type V2Gateway_GetMerchantQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantQuery>;
export type V2Gateway_GetMerchantLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantLazyQuery>;
export type V2Gateway_GetMerchantSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantSuspenseQuery>;
export type V2Gateway_GetMerchantQueryResult = Apollo.QueryResult<V2Gateway_GetMerchantQuery, V2Gateway_GetMerchantQueryVariables>;
export const GetUserBookingsForAppointmentDocument = gql`
    query GetUserBookingsForAppointment($appointmentUid: String!, $ownerUid: String) {
  getUserBookingsForAppointment(
    appointmentUid: $appointmentUid
    ownerUid: $ownerUid
  ) {
    uid
    ownerUid
    price
    tipPercent
    earnings
    serviceOfferingUid
    isComplete
    customerInputSelections {
      customerInputUid
      optionValue
    }
    customerInputGroupSelections {
      level
      customerInputUids
      optionValues
    }
    startDateTime
    endDateTime
    appointmentUid
  }
}
    `;

/**
 * __useGetUserBookingsForAppointmentQuery__
 *
 * To run a query within a React component, call `useGetUserBookingsForAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBookingsForAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBookingsForAppointmentQuery({
 *   variables: {
 *      appointmentUid: // value for 'appointmentUid'
 *      ownerUid: // value for 'ownerUid'
 *   },
 * });
 */
export function useGetUserBookingsForAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetUserBookingsForAppointmentQuery, GetUserBookingsForAppointmentQueryVariables> & ({ variables: GetUserBookingsForAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserBookingsForAppointmentQuery, GetUserBookingsForAppointmentQueryVariables>(GetUserBookingsForAppointmentDocument, options);
      }
export function useGetUserBookingsForAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserBookingsForAppointmentQuery, GetUserBookingsForAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserBookingsForAppointmentQuery, GetUserBookingsForAppointmentQueryVariables>(GetUserBookingsForAppointmentDocument, options);
        }
export function useGetUserBookingsForAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserBookingsForAppointmentQuery, GetUserBookingsForAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserBookingsForAppointmentQuery, GetUserBookingsForAppointmentQueryVariables>(GetUserBookingsForAppointmentDocument, options);
        }
export type GetUserBookingsForAppointmentQueryHookResult = ReturnType<typeof useGetUserBookingsForAppointmentQuery>;
export type GetUserBookingsForAppointmentLazyQueryHookResult = ReturnType<typeof useGetUserBookingsForAppointmentLazyQuery>;
export type GetUserBookingsForAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetUserBookingsForAppointmentSuspenseQuery>;
export type GetUserBookingsForAppointmentQueryResult = Apollo.QueryResult<GetUserBookingsForAppointmentQuery, GetUserBookingsForAppointmentQueryVariables>;
export const GetAppointmentRequestsDocument = gql`
    query GetAppointmentRequests($internalUids: [String!]!) {
  getAppointmentRequests(internalUids: $internalUids) {
    locationUid
    externalUid
    ownerUid
    startDateTime
    uid
    minEndDateTime
    status
    appointmentUid
    serviceArea {
      uid
      name
      description
    }
    location {
      id
      uid
      name
      formattedAddress
      phoneNumber
      type
      latitude
      longitude
      ownerUid
      placeId
    }
    serviceProvider {
      ...serviceProviderFull
    }
  }
}
    ${ServiceProviderFullFragmentDoc}`;

/**
 * __useGetAppointmentRequestsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentRequestsQuery({
 *   variables: {
 *      internalUids: // value for 'internalUids'
 *   },
 * });
 */
export function useGetAppointmentRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentRequestsQuery, GetAppointmentRequestsQueryVariables> & ({ variables: GetAppointmentRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentRequestsQuery, GetAppointmentRequestsQueryVariables>(GetAppointmentRequestsDocument, options);
      }
export function useGetAppointmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentRequestsQuery, GetAppointmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentRequestsQuery, GetAppointmentRequestsQueryVariables>(GetAppointmentRequestsDocument, options);
        }
export function useGetAppointmentRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentRequestsQuery, GetAppointmentRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentRequestsQuery, GetAppointmentRequestsQueryVariables>(GetAppointmentRequestsDocument, options);
        }
export type GetAppointmentRequestsQueryHookResult = ReturnType<typeof useGetAppointmentRequestsQuery>;
export type GetAppointmentRequestsLazyQueryHookResult = ReturnType<typeof useGetAppointmentRequestsLazyQuery>;
export type GetAppointmentRequestsSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentRequestsSuspenseQuery>;
export type GetAppointmentRequestsQueryResult = Apollo.QueryResult<GetAppointmentRequestsQuery, GetAppointmentRequestsQueryVariables>;
export const V2Gateway_GetLocationsDocument = gql`
    query V2Gateway_GetLocations {
  getLocations {
    uid
    name
    id
    formattedAddress
    streetAddress
    phoneNumber
    placeId
    type
    latitude
    longitude
    extendedAddress
    slug
    serviceAreas {
      uid
    }
    business {
      slug
    }
  }
}
    `;

/**
 * __useV2Gateway_GetLocationsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetLocationsQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetLocationsQuery, V2Gateway_GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetLocationsQuery, V2Gateway_GetLocationsQueryVariables>(V2Gateway_GetLocationsDocument, options);
      }
export function useV2Gateway_GetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetLocationsQuery, V2Gateway_GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetLocationsQuery, V2Gateway_GetLocationsQueryVariables>(V2Gateway_GetLocationsDocument, options);
        }
export function useV2Gateway_GetLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetLocationsQuery, V2Gateway_GetLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetLocationsQuery, V2Gateway_GetLocationsQueryVariables>(V2Gateway_GetLocationsDocument, options);
        }
export type V2Gateway_GetLocationsQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationsQuery>;
export type V2Gateway_GetLocationsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationsLazyQuery>;
export type V2Gateway_GetLocationsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationsSuspenseQuery>;
export type V2Gateway_GetLocationsQueryResult = Apollo.QueryResult<V2Gateway_GetLocationsQuery, V2Gateway_GetLocationsQueryVariables>;
export const V2Gateway_GetCalendarAccessDocument = gql`
    query V2Gateway_GetCalendarAccess($providers: [CalendarProvider!]!, $ownerUid: String) {
  getCalendarAccess(providers: $providers, ownerUid: $ownerUid)
}
    `;

/**
 * __useV2Gateway_GetCalendarAccessQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetCalendarAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetCalendarAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetCalendarAccessQuery({
 *   variables: {
 *      providers: // value for 'providers'
 *      ownerUid: // value for 'ownerUid'
 *   },
 * });
 */
export function useV2Gateway_GetCalendarAccessQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetCalendarAccessQuery, V2Gateway_GetCalendarAccessQueryVariables> & ({ variables: V2Gateway_GetCalendarAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetCalendarAccessQuery, V2Gateway_GetCalendarAccessQueryVariables>(V2Gateway_GetCalendarAccessDocument, options);
      }
export function useV2Gateway_GetCalendarAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetCalendarAccessQuery, V2Gateway_GetCalendarAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetCalendarAccessQuery, V2Gateway_GetCalendarAccessQueryVariables>(V2Gateway_GetCalendarAccessDocument, options);
        }
export function useV2Gateway_GetCalendarAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetCalendarAccessQuery, V2Gateway_GetCalendarAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetCalendarAccessQuery, V2Gateway_GetCalendarAccessQueryVariables>(V2Gateway_GetCalendarAccessDocument, options);
        }
export type V2Gateway_GetCalendarAccessQueryHookResult = ReturnType<typeof useV2Gateway_GetCalendarAccessQuery>;
export type V2Gateway_GetCalendarAccessLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetCalendarAccessLazyQuery>;
export type V2Gateway_GetCalendarAccessSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetCalendarAccessSuspenseQuery>;
export type V2Gateway_GetCalendarAccessQueryResult = Apollo.QueryResult<V2Gateway_GetCalendarAccessQuery, V2Gateway_GetCalendarAccessQueryVariables>;
export const V2Gateway_GetDiscountsForBookingUidsDocument = gql`
    query V2Gateway_GetDiscountsForBookingUids($bookingUids: [String!]!) {
  getDiscountsForBookingUids(bookingUids: $bookingUids) {
    value
    type
    booking {
      uid
    }
    change {
      type
      isCoveredByPlatform
      isCoveredByLocation
    }
    name
    isStackable
  }
}
    `;

/**
 * __useV2Gateway_GetDiscountsForBookingUidsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetDiscountsForBookingUidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetDiscountsForBookingUidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetDiscountsForBookingUidsQuery({
 *   variables: {
 *      bookingUids: // value for 'bookingUids'
 *   },
 * });
 */
export function useV2Gateway_GetDiscountsForBookingUidsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetDiscountsForBookingUidsQuery, V2Gateway_GetDiscountsForBookingUidsQueryVariables> & ({ variables: V2Gateway_GetDiscountsForBookingUidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetDiscountsForBookingUidsQuery, V2Gateway_GetDiscountsForBookingUidsQueryVariables>(V2Gateway_GetDiscountsForBookingUidsDocument, options);
      }
export function useV2Gateway_GetDiscountsForBookingUidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetDiscountsForBookingUidsQuery, V2Gateway_GetDiscountsForBookingUidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetDiscountsForBookingUidsQuery, V2Gateway_GetDiscountsForBookingUidsQueryVariables>(V2Gateway_GetDiscountsForBookingUidsDocument, options);
        }
export function useV2Gateway_GetDiscountsForBookingUidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetDiscountsForBookingUidsQuery, V2Gateway_GetDiscountsForBookingUidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetDiscountsForBookingUidsQuery, V2Gateway_GetDiscountsForBookingUidsQueryVariables>(V2Gateway_GetDiscountsForBookingUidsDocument, options);
        }
export type V2Gateway_GetDiscountsForBookingUidsQueryHookResult = ReturnType<typeof useV2Gateway_GetDiscountsForBookingUidsQuery>;
export type V2Gateway_GetDiscountsForBookingUidsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetDiscountsForBookingUidsLazyQuery>;
export type V2Gateway_GetDiscountsForBookingUidsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetDiscountsForBookingUidsSuspenseQuery>;
export type V2Gateway_GetDiscountsForBookingUidsQueryResult = Apollo.QueryResult<V2Gateway_GetDiscountsForBookingUidsQuery, V2Gateway_GetDiscountsForBookingUidsQueryVariables>;
export const V2Gateway_GetUpcomingBookingsDocument = gql`
    query V2Gateway_GetUpcomingBookings($page: Int!) {
  getUpcomingBookings(page: $page) {
    ...bookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;

/**
 * __useV2Gateway_GetUpcomingBookingsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetUpcomingBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetUpcomingBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetUpcomingBookingsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useV2Gateway_GetUpcomingBookingsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetUpcomingBookingsQuery, V2Gateway_GetUpcomingBookingsQueryVariables> & ({ variables: V2Gateway_GetUpcomingBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetUpcomingBookingsQuery, V2Gateway_GetUpcomingBookingsQueryVariables>(V2Gateway_GetUpcomingBookingsDocument, options);
      }
export function useV2Gateway_GetUpcomingBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetUpcomingBookingsQuery, V2Gateway_GetUpcomingBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetUpcomingBookingsQuery, V2Gateway_GetUpcomingBookingsQueryVariables>(V2Gateway_GetUpcomingBookingsDocument, options);
        }
export function useV2Gateway_GetUpcomingBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetUpcomingBookingsQuery, V2Gateway_GetUpcomingBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetUpcomingBookingsQuery, V2Gateway_GetUpcomingBookingsQueryVariables>(V2Gateway_GetUpcomingBookingsDocument, options);
        }
export type V2Gateway_GetUpcomingBookingsQueryHookResult = ReturnType<typeof useV2Gateway_GetUpcomingBookingsQuery>;
export type V2Gateway_GetUpcomingBookingsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetUpcomingBookingsLazyQuery>;
export type V2Gateway_GetUpcomingBookingsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetUpcomingBookingsSuspenseQuery>;
export type V2Gateway_GetUpcomingBookingsQueryResult = Apollo.QueryResult<V2Gateway_GetUpcomingBookingsQuery, V2Gateway_GetUpcomingBookingsQueryVariables>;
export const V2Gateway_GetBookingsByAppointmentUidsDocument = gql`
    query V2Gateway_GetBookingsByAppointmentUids($appointmentUids: [String!]!, $page: Int!) {
  getBookingsByAppointmentUids(appointmentUids: $appointmentUids, page: $page) {
    completeBookings {
      ...bookingFields
    }
    incompleteBookings {
      ...bookingFields
    }
  }
}
    ${BookingFieldsFragmentDoc}`;

/**
 * __useV2Gateway_GetBookingsByAppointmentUidsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetBookingsByAppointmentUidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetBookingsByAppointmentUidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetBookingsByAppointmentUidsQuery({
 *   variables: {
 *      appointmentUids: // value for 'appointmentUids'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useV2Gateway_GetBookingsByAppointmentUidsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetBookingsByAppointmentUidsQuery, V2Gateway_GetBookingsByAppointmentUidsQueryVariables> & ({ variables: V2Gateway_GetBookingsByAppointmentUidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetBookingsByAppointmentUidsQuery, V2Gateway_GetBookingsByAppointmentUidsQueryVariables>(V2Gateway_GetBookingsByAppointmentUidsDocument, options);
      }
export function useV2Gateway_GetBookingsByAppointmentUidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetBookingsByAppointmentUidsQuery, V2Gateway_GetBookingsByAppointmentUidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetBookingsByAppointmentUidsQuery, V2Gateway_GetBookingsByAppointmentUidsQueryVariables>(V2Gateway_GetBookingsByAppointmentUidsDocument, options);
        }
export function useV2Gateway_GetBookingsByAppointmentUidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetBookingsByAppointmentUidsQuery, V2Gateway_GetBookingsByAppointmentUidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetBookingsByAppointmentUidsQuery, V2Gateway_GetBookingsByAppointmentUidsQueryVariables>(V2Gateway_GetBookingsByAppointmentUidsDocument, options);
        }
export type V2Gateway_GetBookingsByAppointmentUidsQueryHookResult = ReturnType<typeof useV2Gateway_GetBookingsByAppointmentUidsQuery>;
export type V2Gateway_GetBookingsByAppointmentUidsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetBookingsByAppointmentUidsLazyQuery>;
export type V2Gateway_GetBookingsByAppointmentUidsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetBookingsByAppointmentUidsSuspenseQuery>;
export type V2Gateway_GetBookingsByAppointmentUidsQueryResult = Apollo.QueryResult<V2Gateway_GetBookingsByAppointmentUidsQuery, V2Gateway_GetBookingsByAppointmentUidsQueryVariables>;
export const V2Gateway_GetExpectedEarningsDocument = gql`
    query V2Gateway_GetExpectedEarnings($appointmentUids: [String!]!) {
  getExpectedEarningsForAppointments(appointmentUids: $appointmentUids) {
    expectedEarnings {
      value
      externalUid
    }
    bookingsExpectedEarnings {
      value
      externalUid
    }
  }
}
    `;

/**
 * __useV2Gateway_GetExpectedEarningsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetExpectedEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetExpectedEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetExpectedEarningsQuery({
 *   variables: {
 *      appointmentUids: // value for 'appointmentUids'
 *   },
 * });
 */
export function useV2Gateway_GetExpectedEarningsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetExpectedEarningsQuery, V2Gateway_GetExpectedEarningsQueryVariables> & ({ variables: V2Gateway_GetExpectedEarningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetExpectedEarningsQuery, V2Gateway_GetExpectedEarningsQueryVariables>(V2Gateway_GetExpectedEarningsDocument, options);
      }
export function useV2Gateway_GetExpectedEarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetExpectedEarningsQuery, V2Gateway_GetExpectedEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetExpectedEarningsQuery, V2Gateway_GetExpectedEarningsQueryVariables>(V2Gateway_GetExpectedEarningsDocument, options);
        }
export function useV2Gateway_GetExpectedEarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetExpectedEarningsQuery, V2Gateway_GetExpectedEarningsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetExpectedEarningsQuery, V2Gateway_GetExpectedEarningsQueryVariables>(V2Gateway_GetExpectedEarningsDocument, options);
        }
export type V2Gateway_GetExpectedEarningsQueryHookResult = ReturnType<typeof useV2Gateway_GetExpectedEarningsQuery>;
export type V2Gateway_GetExpectedEarningsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetExpectedEarningsLazyQuery>;
export type V2Gateway_GetExpectedEarningsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetExpectedEarningsSuspenseQuery>;
export type V2Gateway_GetExpectedEarningsQueryResult = Apollo.QueryResult<V2Gateway_GetExpectedEarningsQuery, V2Gateway_GetExpectedEarningsQueryVariables>;
export const V2Gateway_GetFilesByExternalUidsDocument = gql`
    query V2Gateway_GetFilesByExternalUids($externalUids: [String!]!) {
  getFilesByExternalUid(externalUids: $externalUids) {
    uid
    externalUid
    label
    index
    uploadedFile {
      publicUrl
    }
  }
}
    `;

/**
 * __useV2Gateway_GetFilesByExternalUidsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetFilesByExternalUidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetFilesByExternalUidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetFilesByExternalUidsQuery({
 *   variables: {
 *      externalUids: // value for 'externalUids'
 *   },
 * });
 */
export function useV2Gateway_GetFilesByExternalUidsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetFilesByExternalUidsQuery, V2Gateway_GetFilesByExternalUidsQueryVariables> & ({ variables: V2Gateway_GetFilesByExternalUidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetFilesByExternalUidsQuery, V2Gateway_GetFilesByExternalUidsQueryVariables>(V2Gateway_GetFilesByExternalUidsDocument, options);
      }
export function useV2Gateway_GetFilesByExternalUidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetFilesByExternalUidsQuery, V2Gateway_GetFilesByExternalUidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetFilesByExternalUidsQuery, V2Gateway_GetFilesByExternalUidsQueryVariables>(V2Gateway_GetFilesByExternalUidsDocument, options);
        }
export function useV2Gateway_GetFilesByExternalUidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetFilesByExternalUidsQuery, V2Gateway_GetFilesByExternalUidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetFilesByExternalUidsQuery, V2Gateway_GetFilesByExternalUidsQueryVariables>(V2Gateway_GetFilesByExternalUidsDocument, options);
        }
export type V2Gateway_GetFilesByExternalUidsQueryHookResult = ReturnType<typeof useV2Gateway_GetFilesByExternalUidsQuery>;
export type V2Gateway_GetFilesByExternalUidsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetFilesByExternalUidsLazyQuery>;
export type V2Gateway_GetFilesByExternalUidsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetFilesByExternalUidsSuspenseQuery>;
export type V2Gateway_GetFilesByExternalUidsQueryResult = Apollo.QueryResult<V2Gateway_GetFilesByExternalUidsQuery, V2Gateway_GetFilesByExternalUidsQueryVariables>;
export const V2Gateway_GetCustomerInputsDocument = gql`
    query V2Gateway_GetCustomerInputs {
  getCustomerInputs {
    ...customerInputFields
  }
}
    ${CustomerInputFieldsFragmentDoc}`;

/**
 * __useV2Gateway_GetCustomerInputsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetCustomerInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetCustomerInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetCustomerInputsQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetCustomerInputsQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetCustomerInputsQuery, V2Gateway_GetCustomerInputsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetCustomerInputsQuery, V2Gateway_GetCustomerInputsQueryVariables>(V2Gateway_GetCustomerInputsDocument, options);
      }
export function useV2Gateway_GetCustomerInputsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetCustomerInputsQuery, V2Gateway_GetCustomerInputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetCustomerInputsQuery, V2Gateway_GetCustomerInputsQueryVariables>(V2Gateway_GetCustomerInputsDocument, options);
        }
export function useV2Gateway_GetCustomerInputsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetCustomerInputsQuery, V2Gateway_GetCustomerInputsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetCustomerInputsQuery, V2Gateway_GetCustomerInputsQueryVariables>(V2Gateway_GetCustomerInputsDocument, options);
        }
export type V2Gateway_GetCustomerInputsQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputsQuery>;
export type V2Gateway_GetCustomerInputsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputsLazyQuery>;
export type V2Gateway_GetCustomerInputsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputsSuspenseQuery>;
export type V2Gateway_GetCustomerInputsQueryResult = Apollo.QueryResult<V2Gateway_GetCustomerInputsQuery, V2Gateway_GetCustomerInputsQueryVariables>;
export const V2Gateway_GetServiceOfferingCustomerInputGroupsDocument = gql`
    query V2Gateway_GetServiceOfferingCustomerInputGroups($serviceOfferingUid: String!) {
  getServiceOfferingCustomerInputGroups(serviceOfferingUid: $serviceOfferingUid) {
    ...customerInputGroupFields
  }
}
    ${CustomerInputGroupFieldsFragmentDoc}`;

/**
 * __useV2Gateway_GetServiceOfferingCustomerInputGroupsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetServiceOfferingCustomerInputGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetServiceOfferingCustomerInputGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetServiceOfferingCustomerInputGroupsQuery({
 *   variables: {
 *      serviceOfferingUid: // value for 'serviceOfferingUid'
 *   },
 * });
 */
export function useV2Gateway_GetServiceOfferingCustomerInputGroupsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetServiceOfferingCustomerInputGroupsQuery, V2Gateway_GetServiceOfferingCustomerInputGroupsQueryVariables> & ({ variables: V2Gateway_GetServiceOfferingCustomerInputGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetServiceOfferingCustomerInputGroupsQuery, V2Gateway_GetServiceOfferingCustomerInputGroupsQueryVariables>(V2Gateway_GetServiceOfferingCustomerInputGroupsDocument, options);
      }
export function useV2Gateway_GetServiceOfferingCustomerInputGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetServiceOfferingCustomerInputGroupsQuery, V2Gateway_GetServiceOfferingCustomerInputGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetServiceOfferingCustomerInputGroupsQuery, V2Gateway_GetServiceOfferingCustomerInputGroupsQueryVariables>(V2Gateway_GetServiceOfferingCustomerInputGroupsDocument, options);
        }
export function useV2Gateway_GetServiceOfferingCustomerInputGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetServiceOfferingCustomerInputGroupsQuery, V2Gateway_GetServiceOfferingCustomerInputGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetServiceOfferingCustomerInputGroupsQuery, V2Gateway_GetServiceOfferingCustomerInputGroupsQueryVariables>(V2Gateway_GetServiceOfferingCustomerInputGroupsDocument, options);
        }
export type V2Gateway_GetServiceOfferingCustomerInputGroupsQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingCustomerInputGroupsQuery>;
export type V2Gateway_GetServiceOfferingCustomerInputGroupsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingCustomerInputGroupsLazyQuery>;
export type V2Gateway_GetServiceOfferingCustomerInputGroupsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingCustomerInputGroupsSuspenseQuery>;
export type V2Gateway_GetServiceOfferingCustomerInputGroupsQueryResult = Apollo.QueryResult<V2Gateway_GetServiceOfferingCustomerInputGroupsQuery, V2Gateway_GetServiceOfferingCustomerInputGroupsQueryVariables>;
export const V2Gateway_GetCustomerInputsByUidDocument = gql`
    query V2Gateway_GetCustomerInputsByUid($customerInputUids: [String!]!) {
  getCustomerInputsByUid(customerInputUids: $customerInputUids) {
    ...customerInputFields
  }
}
    ${CustomerInputFieldsFragmentDoc}`;

/**
 * __useV2Gateway_GetCustomerInputsByUidQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetCustomerInputsByUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetCustomerInputsByUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetCustomerInputsByUidQuery({
 *   variables: {
 *      customerInputUids: // value for 'customerInputUids'
 *   },
 * });
 */
export function useV2Gateway_GetCustomerInputsByUidQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetCustomerInputsByUidQuery, V2Gateway_GetCustomerInputsByUidQueryVariables> & ({ variables: V2Gateway_GetCustomerInputsByUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetCustomerInputsByUidQuery, V2Gateway_GetCustomerInputsByUidQueryVariables>(V2Gateway_GetCustomerInputsByUidDocument, options);
      }
export function useV2Gateway_GetCustomerInputsByUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetCustomerInputsByUidQuery, V2Gateway_GetCustomerInputsByUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetCustomerInputsByUidQuery, V2Gateway_GetCustomerInputsByUidQueryVariables>(V2Gateway_GetCustomerInputsByUidDocument, options);
        }
export function useV2Gateway_GetCustomerInputsByUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetCustomerInputsByUidQuery, V2Gateway_GetCustomerInputsByUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetCustomerInputsByUidQuery, V2Gateway_GetCustomerInputsByUidQueryVariables>(V2Gateway_GetCustomerInputsByUidDocument, options);
        }
export type V2Gateway_GetCustomerInputsByUidQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputsByUidQuery>;
export type V2Gateway_GetCustomerInputsByUidLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputsByUidLazyQuery>;
export type V2Gateway_GetCustomerInputsByUidSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputsByUidSuspenseQuery>;
export type V2Gateway_GetCustomerInputsByUidQueryResult = Apollo.QueryResult<V2Gateway_GetCustomerInputsByUidQuery, V2Gateway_GetCustomerInputsByUidQueryVariables>;
export const V2Gateway_GetCustomerInputGroupsDocument = gql`
    query V2Gateway_GetCustomerInputGroups {
  getCustomerInputGroups {
    ...customerInputGroupFields
  }
}
    ${CustomerInputGroupFieldsFragmentDoc}`;

/**
 * __useV2Gateway_GetCustomerInputGroupsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetCustomerInputGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetCustomerInputGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetCustomerInputGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetCustomerInputGroupsQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetCustomerInputGroupsQuery, V2Gateway_GetCustomerInputGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetCustomerInputGroupsQuery, V2Gateway_GetCustomerInputGroupsQueryVariables>(V2Gateway_GetCustomerInputGroupsDocument, options);
      }
export function useV2Gateway_GetCustomerInputGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetCustomerInputGroupsQuery, V2Gateway_GetCustomerInputGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetCustomerInputGroupsQuery, V2Gateway_GetCustomerInputGroupsQueryVariables>(V2Gateway_GetCustomerInputGroupsDocument, options);
        }
export function useV2Gateway_GetCustomerInputGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetCustomerInputGroupsQuery, V2Gateway_GetCustomerInputGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetCustomerInputGroupsQuery, V2Gateway_GetCustomerInputGroupsQueryVariables>(V2Gateway_GetCustomerInputGroupsDocument, options);
        }
export type V2Gateway_GetCustomerInputGroupsQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputGroupsQuery>;
export type V2Gateway_GetCustomerInputGroupsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputGroupsLazyQuery>;
export type V2Gateway_GetCustomerInputGroupsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputGroupsSuspenseQuery>;
export type V2Gateway_GetCustomerInputGroupsQueryResult = Apollo.QueryResult<V2Gateway_GetCustomerInputGroupsQuery, V2Gateway_GetCustomerInputGroupsQueryVariables>;
export const V2Gateway_CreateCustomerInputsDocument = gql`
    mutation V2Gateway_CreateCustomerInputs($data: [CustomerInputInput!]!) {
  createCustomerInputs(data: $data) {
    customerInputs {
      customerInputUid
      options {
        customerInputOptionUid
        nonce
      }
    }
  }
}
    `;
export type V2Gateway_CreateCustomerInputsMutationFn = Apollo.MutationFunction<V2Gateway_CreateCustomerInputsMutation, V2Gateway_CreateCustomerInputsMutationVariables>;

/**
 * __useV2Gateway_CreateCustomerInputsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateCustomerInputsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateCustomerInputsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateCustomerInputsMutation, { data, loading, error }] = useV2Gateway_CreateCustomerInputsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateCustomerInputsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateCustomerInputsMutation, V2Gateway_CreateCustomerInputsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateCustomerInputsMutation, V2Gateway_CreateCustomerInputsMutationVariables>(V2Gateway_CreateCustomerInputsDocument, options);
      }
export type V2Gateway_CreateCustomerInputsMutationHookResult = ReturnType<typeof useV2Gateway_CreateCustomerInputsMutation>;
export type V2Gateway_CreateCustomerInputsMutationResult = Apollo.MutationResult<V2Gateway_CreateCustomerInputsMutation>;
export type V2Gateway_CreateCustomerInputsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateCustomerInputsMutation, V2Gateway_CreateCustomerInputsMutationVariables>;
export const V2Gateway_UpdateCustomerInputDocument = gql`
    mutation V2Gateway_UpdateCustomerInput($data: UpdateCustomerInputInput!) {
  updateCustomerInput(data: $data) {
    options {
      customerInputOptionUid
      nonce
    }
  }
}
    `;
export type V2Gateway_UpdateCustomerInputMutationFn = Apollo.MutationFunction<V2Gateway_UpdateCustomerInputMutation, V2Gateway_UpdateCustomerInputMutationVariables>;

/**
 * __useV2Gateway_UpdateCustomerInputMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateCustomerInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateCustomerInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateCustomerInputMutation, { data, loading, error }] = useV2Gateway_UpdateCustomerInputMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateCustomerInputMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateCustomerInputMutation, V2Gateway_UpdateCustomerInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateCustomerInputMutation, V2Gateway_UpdateCustomerInputMutationVariables>(V2Gateway_UpdateCustomerInputDocument, options);
      }
export type V2Gateway_UpdateCustomerInputMutationHookResult = ReturnType<typeof useV2Gateway_UpdateCustomerInputMutation>;
export type V2Gateway_UpdateCustomerInputMutationResult = Apollo.MutationResult<V2Gateway_UpdateCustomerInputMutation>;
export type V2Gateway_UpdateCustomerInputMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateCustomerInputMutation, V2Gateway_UpdateCustomerInputMutationVariables>;
export const V2Gateway_DeleteCustomerInputsDocument = gql`
    mutation V2Gateway_DeleteCustomerInputs($customerInputUid: String!) {
  deleteCustomerInput(customerInputUid: $customerInputUid)
}
    `;
export type V2Gateway_DeleteCustomerInputsMutationFn = Apollo.MutationFunction<V2Gateway_DeleteCustomerInputsMutation, V2Gateway_DeleteCustomerInputsMutationVariables>;

/**
 * __useV2Gateway_DeleteCustomerInputsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteCustomerInputsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteCustomerInputsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteCustomerInputsMutation, { data, loading, error }] = useV2Gateway_DeleteCustomerInputsMutation({
 *   variables: {
 *      customerInputUid: // value for 'customerInputUid'
 *   },
 * });
 */
export function useV2Gateway_DeleteCustomerInputsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteCustomerInputsMutation, V2Gateway_DeleteCustomerInputsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteCustomerInputsMutation, V2Gateway_DeleteCustomerInputsMutationVariables>(V2Gateway_DeleteCustomerInputsDocument, options);
      }
export type V2Gateway_DeleteCustomerInputsMutationHookResult = ReturnType<typeof useV2Gateway_DeleteCustomerInputsMutation>;
export type V2Gateway_DeleteCustomerInputsMutationResult = Apollo.MutationResult<V2Gateway_DeleteCustomerInputsMutation>;
export type V2Gateway_DeleteCustomerInputsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteCustomerInputsMutation, V2Gateway_DeleteCustomerInputsMutationVariables>;
export const V2Gateway_SetServiceOfferingCustomerInputGroupsDocument = gql`
    mutation V2Gateway_SetServiceOfferingCustomerInputGroups($serviceOfferingUid: String!, $customerInputGroupUids: [String!]!) {
  setServiceOfferingCustomerInputGroups(
    serviceOfferingUid: $serviceOfferingUid
    customerInputGroupUids: $customerInputGroupUids
  )
}
    `;
export type V2Gateway_SetServiceOfferingCustomerInputGroupsMutationFn = Apollo.MutationFunction<V2Gateway_SetServiceOfferingCustomerInputGroupsMutation, V2Gateway_SetServiceOfferingCustomerInputGroupsMutationVariables>;

/**
 * __useV2Gateway_SetServiceOfferingCustomerInputGroupsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SetServiceOfferingCustomerInputGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SetServiceOfferingCustomerInputGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySetServiceOfferingCustomerInputGroupsMutation, { data, loading, error }] = useV2Gateway_SetServiceOfferingCustomerInputGroupsMutation({
 *   variables: {
 *      serviceOfferingUid: // value for 'serviceOfferingUid'
 *      customerInputGroupUids: // value for 'customerInputGroupUids'
 *   },
 * });
 */
export function useV2Gateway_SetServiceOfferingCustomerInputGroupsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SetServiceOfferingCustomerInputGroupsMutation, V2Gateway_SetServiceOfferingCustomerInputGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SetServiceOfferingCustomerInputGroupsMutation, V2Gateway_SetServiceOfferingCustomerInputGroupsMutationVariables>(V2Gateway_SetServiceOfferingCustomerInputGroupsDocument, options);
      }
export type V2Gateway_SetServiceOfferingCustomerInputGroupsMutationHookResult = ReturnType<typeof useV2Gateway_SetServiceOfferingCustomerInputGroupsMutation>;
export type V2Gateway_SetServiceOfferingCustomerInputGroupsMutationResult = Apollo.MutationResult<V2Gateway_SetServiceOfferingCustomerInputGroupsMutation>;
export type V2Gateway_SetServiceOfferingCustomerInputGroupsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SetServiceOfferingCustomerInputGroupsMutation, V2Gateway_SetServiceOfferingCustomerInputGroupsMutationVariables>;
export const V2Gateway_GetFullMerchantDocument = gql`
    query V2Gateway_GetFullMerchant {
  getMerchant {
    serviceType
    isApproved
    currency
  }
}
    `;

/**
 * __useV2Gateway_GetFullMerchantQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetFullMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetFullMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetFullMerchantQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetFullMerchantQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetFullMerchantQuery, V2Gateway_GetFullMerchantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetFullMerchantQuery, V2Gateway_GetFullMerchantQueryVariables>(V2Gateway_GetFullMerchantDocument, options);
      }
export function useV2Gateway_GetFullMerchantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetFullMerchantQuery, V2Gateway_GetFullMerchantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetFullMerchantQuery, V2Gateway_GetFullMerchantQueryVariables>(V2Gateway_GetFullMerchantDocument, options);
        }
export function useV2Gateway_GetFullMerchantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetFullMerchantQuery, V2Gateway_GetFullMerchantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetFullMerchantQuery, V2Gateway_GetFullMerchantQueryVariables>(V2Gateway_GetFullMerchantDocument, options);
        }
export type V2Gateway_GetFullMerchantQueryHookResult = ReturnType<typeof useV2Gateway_GetFullMerchantQuery>;
export type V2Gateway_GetFullMerchantLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetFullMerchantLazyQuery>;
export type V2Gateway_GetFullMerchantSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetFullMerchantSuspenseQuery>;
export type V2Gateway_GetFullMerchantQueryResult = Apollo.QueryResult<V2Gateway_GetFullMerchantQuery, V2Gateway_GetFullMerchantQueryVariables>;
export const V2Gateway_PartnerContextDocument = gql`
    query V2Gateway_PartnerContext {
  checkSessionValid
  hasConnectedStripeAccount
}
    `;

/**
 * __useV2Gateway_PartnerContextQuery__
 *
 * To run a query within a React component, call `useV2Gateway_PartnerContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_PartnerContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_PartnerContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_PartnerContextQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_PartnerContextQuery, V2Gateway_PartnerContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_PartnerContextQuery, V2Gateway_PartnerContextQueryVariables>(V2Gateway_PartnerContextDocument, options);
      }
export function useV2Gateway_PartnerContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_PartnerContextQuery, V2Gateway_PartnerContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_PartnerContextQuery, V2Gateway_PartnerContextQueryVariables>(V2Gateway_PartnerContextDocument, options);
        }
export function useV2Gateway_PartnerContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_PartnerContextQuery, V2Gateway_PartnerContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_PartnerContextQuery, V2Gateway_PartnerContextQueryVariables>(V2Gateway_PartnerContextDocument, options);
        }
export type V2Gateway_PartnerContextQueryHookResult = ReturnType<typeof useV2Gateway_PartnerContextQuery>;
export type V2Gateway_PartnerContextLazyQueryHookResult = ReturnType<typeof useV2Gateway_PartnerContextLazyQuery>;
export type V2Gateway_PartnerContextSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_PartnerContextSuspenseQuery>;
export type V2Gateway_PartnerContextQueryResult = Apollo.QueryResult<V2Gateway_PartnerContextQuery, V2Gateway_PartnerContextQueryVariables>;
export const V2Gateway_GetServiceAreasForLocationsDocument = gql`
    query V2Gateway_GetServiceAreasForLocations($locationUids: [String!]!) {
  getServiceAreasByLocationUid(locationUids: $locationUids) {
    uid
    name
    description
    externalUid
    files {
      uid
      externalUid
      label
      uploadedFile {
        publicUrl
        objectName
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_GetServiceAreasForLocationsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetServiceAreasForLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetServiceAreasForLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetServiceAreasForLocationsQuery({
 *   variables: {
 *      locationUids: // value for 'locationUids'
 *   },
 * });
 */
export function useV2Gateway_GetServiceAreasForLocationsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetServiceAreasForLocationsQuery, V2Gateway_GetServiceAreasForLocationsQueryVariables> & ({ variables: V2Gateway_GetServiceAreasForLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetServiceAreasForLocationsQuery, V2Gateway_GetServiceAreasForLocationsQueryVariables>(V2Gateway_GetServiceAreasForLocationsDocument, options);
      }
export function useV2Gateway_GetServiceAreasForLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetServiceAreasForLocationsQuery, V2Gateway_GetServiceAreasForLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetServiceAreasForLocationsQuery, V2Gateway_GetServiceAreasForLocationsQueryVariables>(V2Gateway_GetServiceAreasForLocationsDocument, options);
        }
export function useV2Gateway_GetServiceAreasForLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetServiceAreasForLocationsQuery, V2Gateway_GetServiceAreasForLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetServiceAreasForLocationsQuery, V2Gateway_GetServiceAreasForLocationsQueryVariables>(V2Gateway_GetServiceAreasForLocationsDocument, options);
        }
export type V2Gateway_GetServiceAreasForLocationsQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceAreasForLocationsQuery>;
export type V2Gateway_GetServiceAreasForLocationsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceAreasForLocationsLazyQuery>;
export type V2Gateway_GetServiceAreasForLocationsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceAreasForLocationsSuspenseQuery>;
export type V2Gateway_GetServiceAreasForLocationsQueryResult = Apollo.QueryResult<V2Gateway_GetServiceAreasForLocationsQuery, V2Gateway_GetServiceAreasForLocationsQueryVariables>;
export const V2Gateway_HasConnectedStripeAccountDocument = gql`
    query V2Gateway_HasConnectedStripeAccount {
  hasConnectedStripeAccount
}
    `;

/**
 * __useV2Gateway_HasConnectedStripeAccountQuery__
 *
 * To run a query within a React component, call `useV2Gateway_HasConnectedStripeAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_HasConnectedStripeAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_HasConnectedStripeAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_HasConnectedStripeAccountQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_HasConnectedStripeAccountQuery, V2Gateway_HasConnectedStripeAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_HasConnectedStripeAccountQuery, V2Gateway_HasConnectedStripeAccountQueryVariables>(V2Gateway_HasConnectedStripeAccountDocument, options);
      }
export function useV2Gateway_HasConnectedStripeAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_HasConnectedStripeAccountQuery, V2Gateway_HasConnectedStripeAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_HasConnectedStripeAccountQuery, V2Gateway_HasConnectedStripeAccountQueryVariables>(V2Gateway_HasConnectedStripeAccountDocument, options);
        }
export function useV2Gateway_HasConnectedStripeAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_HasConnectedStripeAccountQuery, V2Gateway_HasConnectedStripeAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_HasConnectedStripeAccountQuery, V2Gateway_HasConnectedStripeAccountQueryVariables>(V2Gateway_HasConnectedStripeAccountDocument, options);
        }
export type V2Gateway_HasConnectedStripeAccountQueryHookResult = ReturnType<typeof useV2Gateway_HasConnectedStripeAccountQuery>;
export type V2Gateway_HasConnectedStripeAccountLazyQueryHookResult = ReturnType<typeof useV2Gateway_HasConnectedStripeAccountLazyQuery>;
export type V2Gateway_HasConnectedStripeAccountSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_HasConnectedStripeAccountSuspenseQuery>;
export type V2Gateway_HasConnectedStripeAccountQueryResult = Apollo.QueryResult<V2Gateway_HasConnectedStripeAccountQuery, V2Gateway_HasConnectedStripeAccountQueryVariables>;
export const QueryBookingsDocument = gql`
    query QueryBookings($query: BookingQuery!) {
  queryBookings(query: $query) {
    bookings {
      isInProgress
      ...deepBookingFields
      appointment {
        uid
        id
        isConfirmed
        serviceArea {
          uid
          name
          description
          externalUid
          files {
            uid
            externalUid
            label
            uploadedFile {
              objectName
              publicUrl
            }
          }
        }
        startDateTime
        maxEndDateTime
        location {
          uid
          formattedAddress
          name
          type
          phoneNumber
          owner {
            fullName
            emailAddress
            phoneNumber
          }
        }
        serviceProvider {
          serviceType
          ownerUid
          displayName
          slug
          profile {
            ...profileFragment
          }
        }
      }
    }
  }
}
    ${DeepBookingFieldsFragmentDoc}
${ProfileFragmentFragmentDoc}`;

/**
 * __useQueryBookingsQuery__
 *
 * To run a query within a React component, call `useQueryBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryBookingsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useQueryBookingsQuery(baseOptions: Apollo.QueryHookOptions<QueryBookingsQuery, QueryBookingsQueryVariables> & ({ variables: QueryBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryBookingsQuery, QueryBookingsQueryVariables>(QueryBookingsDocument, options);
      }
export function useQueryBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryBookingsQuery, QueryBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryBookingsQuery, QueryBookingsQueryVariables>(QueryBookingsDocument, options);
        }
export function useQueryBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryBookingsQuery, QueryBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryBookingsQuery, QueryBookingsQueryVariables>(QueryBookingsDocument, options);
        }
export type QueryBookingsQueryHookResult = ReturnType<typeof useQueryBookingsQuery>;
export type QueryBookingsLazyQueryHookResult = ReturnType<typeof useQueryBookingsLazyQuery>;
export type QueryBookingsSuspenseQueryHookResult = ReturnType<typeof useQueryBookingsSuspenseQuery>;
export type QueryBookingsQueryResult = Apollo.QueryResult<QueryBookingsQuery, QueryBookingsQueryVariables>;
export const V2Gateway_QueryRecentBookingsDocument = gql`
    query V2Gateway_QueryRecentBookings($query: BookingQuery!) {
  queryBookings(query: $query) {
    bookings {
      ...deepBookingFields
      accountingRecord {
        total
      }
      appointment {
        uid
        serviceProvider {
          serviceType
          ownerUid
          displayName
          slug
          profile {
            ...profileFragment
          }
          profile {
            ...profileFragment
          }
          serviceOfferings {
            uid
            title
          }
          reviewCount
          averageRating
          reviews {
            uid
            isLike
          }
        }
      }
    }
  }
}
    ${DeepBookingFieldsFragmentDoc}
${ProfileFragmentFragmentDoc}`;

/**
 * __useV2Gateway_QueryRecentBookingsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryRecentBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryRecentBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryRecentBookingsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryRecentBookingsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryRecentBookingsQuery, V2Gateway_QueryRecentBookingsQueryVariables> & ({ variables: V2Gateway_QueryRecentBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryRecentBookingsQuery, V2Gateway_QueryRecentBookingsQueryVariables>(V2Gateway_QueryRecentBookingsDocument, options);
      }
export function useV2Gateway_QueryRecentBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryRecentBookingsQuery, V2Gateway_QueryRecentBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryRecentBookingsQuery, V2Gateway_QueryRecentBookingsQueryVariables>(V2Gateway_QueryRecentBookingsDocument, options);
        }
export function useV2Gateway_QueryRecentBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryRecentBookingsQuery, V2Gateway_QueryRecentBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryRecentBookingsQuery, V2Gateway_QueryRecentBookingsQueryVariables>(V2Gateway_QueryRecentBookingsDocument, options);
        }
export type V2Gateway_QueryRecentBookingsQueryHookResult = ReturnType<typeof useV2Gateway_QueryRecentBookingsQuery>;
export type V2Gateway_QueryRecentBookingsLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryRecentBookingsLazyQuery>;
export type V2Gateway_QueryRecentBookingsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryRecentBookingsSuspenseQuery>;
export type V2Gateway_QueryRecentBookingsQueryResult = Apollo.QueryResult<V2Gateway_QueryRecentBookingsQuery, V2Gateway_QueryRecentBookingsQueryVariables>;
export const QueryBookingsCountDocument = gql`
    query QueryBookingsCount($query: BookingQuery!) {
  queryBookingsCount(query: $query)
}
    `;

/**
 * __useQueryBookingsCountQuery__
 *
 * To run a query within a React component, call `useQueryBookingsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryBookingsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryBookingsCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useQueryBookingsCountQuery(baseOptions: Apollo.QueryHookOptions<QueryBookingsCountQuery, QueryBookingsCountQueryVariables> & ({ variables: QueryBookingsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryBookingsCountQuery, QueryBookingsCountQueryVariables>(QueryBookingsCountDocument, options);
      }
export function useQueryBookingsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryBookingsCountQuery, QueryBookingsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryBookingsCountQuery, QueryBookingsCountQueryVariables>(QueryBookingsCountDocument, options);
        }
export function useQueryBookingsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryBookingsCountQuery, QueryBookingsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryBookingsCountQuery, QueryBookingsCountQueryVariables>(QueryBookingsCountDocument, options);
        }
export type QueryBookingsCountQueryHookResult = ReturnType<typeof useQueryBookingsCountQuery>;
export type QueryBookingsCountLazyQueryHookResult = ReturnType<typeof useQueryBookingsCountLazyQuery>;
export type QueryBookingsCountSuspenseQueryHookResult = ReturnType<typeof useQueryBookingsCountSuspenseQuery>;
export type QueryBookingsCountQueryResult = Apollo.QueryResult<QueryBookingsCountQuery, QueryBookingsCountQueryVariables>;
export const V2Gateway_QueryServiceOfferingsDocument = gql`
    query V2Gateway_QueryServiceOfferings($query: ServiceOfferingQuery!) {
  queryServiceOfferings(query: $query) {
    hasMoreResults
    serviceOfferings {
      title
      imageUrl
      basePrice
      baseTime
      uid
      shortDesc
      type
      maxConcurrentBookings
      allowTip
      index
      postServiceNote
    }
  }
}
    `;

/**
 * __useV2Gateway_QueryServiceOfferingsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryServiceOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryServiceOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryServiceOfferingsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryServiceOfferingsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryServiceOfferingsQuery, V2Gateway_QueryServiceOfferingsQueryVariables> & ({ variables: V2Gateway_QueryServiceOfferingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryServiceOfferingsQuery, V2Gateway_QueryServiceOfferingsQueryVariables>(V2Gateway_QueryServiceOfferingsDocument, options);
      }
export function useV2Gateway_QueryServiceOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryServiceOfferingsQuery, V2Gateway_QueryServiceOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryServiceOfferingsQuery, V2Gateway_QueryServiceOfferingsQueryVariables>(V2Gateway_QueryServiceOfferingsDocument, options);
        }
export function useV2Gateway_QueryServiceOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryServiceOfferingsQuery, V2Gateway_QueryServiceOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryServiceOfferingsQuery, V2Gateway_QueryServiceOfferingsQueryVariables>(V2Gateway_QueryServiceOfferingsDocument, options);
        }
export type V2Gateway_QueryServiceOfferingsQueryHookResult = ReturnType<typeof useV2Gateway_QueryServiceOfferingsQuery>;
export type V2Gateway_QueryServiceOfferingsLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryServiceOfferingsLazyQuery>;
export type V2Gateway_QueryServiceOfferingsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryServiceOfferingsSuspenseQuery>;
export type V2Gateway_QueryServiceOfferingsQueryResult = Apollo.QueryResult<V2Gateway_QueryServiceOfferingsQuery, V2Gateway_QueryServiceOfferingsQueryVariables>;
export const V2Gateway_QueryLocationSubscriptionsDocument = gql`
    query V2Gateway_QueryLocationSubscriptions($query: LocationSubscriptionQuery!) {
  queryLocationSubscriptions(query: $query) {
    location {
      uid
      id
      name
      formattedAddress
      streetAddress
      type
      latitude
      longitude
      placeId
      phoneNumber
      ownerUid
      slug
    }
    locationUid
    ownerUid
    owner {
      isTemporary
    }
  }
}
    `;

/**
 * __useV2Gateway_QueryLocationSubscriptionsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryLocationSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryLocationSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryLocationSubscriptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryLocationSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryLocationSubscriptionsQuery, V2Gateway_QueryLocationSubscriptionsQueryVariables> & ({ variables: V2Gateway_QueryLocationSubscriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryLocationSubscriptionsQuery, V2Gateway_QueryLocationSubscriptionsQueryVariables>(V2Gateway_QueryLocationSubscriptionsDocument, options);
      }
export function useV2Gateway_QueryLocationSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryLocationSubscriptionsQuery, V2Gateway_QueryLocationSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryLocationSubscriptionsQuery, V2Gateway_QueryLocationSubscriptionsQueryVariables>(V2Gateway_QueryLocationSubscriptionsDocument, options);
        }
export function useV2Gateway_QueryLocationSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryLocationSubscriptionsQuery, V2Gateway_QueryLocationSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryLocationSubscriptionsQuery, V2Gateway_QueryLocationSubscriptionsQueryVariables>(V2Gateway_QueryLocationSubscriptionsDocument, options);
        }
export type V2Gateway_QueryLocationSubscriptionsQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationSubscriptionsQuery>;
export type V2Gateway_QueryLocationSubscriptionsLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationSubscriptionsLazyQuery>;
export type V2Gateway_QueryLocationSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryLocationSubscriptionsSuspenseQuery>;
export type V2Gateway_QueryLocationSubscriptionsQueryResult = Apollo.QueryResult<V2Gateway_QueryLocationSubscriptionsQuery, V2Gateway_QueryLocationSubscriptionsQueryVariables>;
export const V2Gateway_QueryBusinessesDocument = gql`
    query V2Gateway_QueryBusinesses($query: BusinessQuery!) {
  queryBusinesses(query: $query) {
    businesses {
      name
      uid
      locations {
        id
        uid
        name
        formattedAddress
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_QueryBusinessesQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryBusinessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryBusinessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryBusinessesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryBusinessesQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryBusinessesQuery, V2Gateway_QueryBusinessesQueryVariables> & ({ variables: V2Gateway_QueryBusinessesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryBusinessesQuery, V2Gateway_QueryBusinessesQueryVariables>(V2Gateway_QueryBusinessesDocument, options);
      }
export function useV2Gateway_QueryBusinessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryBusinessesQuery, V2Gateway_QueryBusinessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryBusinessesQuery, V2Gateway_QueryBusinessesQueryVariables>(V2Gateway_QueryBusinessesDocument, options);
        }
export function useV2Gateway_QueryBusinessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryBusinessesQuery, V2Gateway_QueryBusinessesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryBusinessesQuery, V2Gateway_QueryBusinessesQueryVariables>(V2Gateway_QueryBusinessesDocument, options);
        }
export type V2Gateway_QueryBusinessesQueryHookResult = ReturnType<typeof useV2Gateway_QueryBusinessesQuery>;
export type V2Gateway_QueryBusinessesLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryBusinessesLazyQuery>;
export type V2Gateway_QueryBusinessesSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryBusinessesSuspenseQuery>;
export type V2Gateway_QueryBusinessesQueryResult = Apollo.QueryResult<V2Gateway_QueryBusinessesQuery, V2Gateway_QueryBusinessesQueryVariables>;
export const V2Gateway_QueryAppointmentOracleDocument = gql`
    query V2Gateway_QueryAppointmentOracle($query: AppointmentOracleQuery!) {
  queryAppointmentOracle(query: $query) {
    startDateTime
    isConfirmed
    isCoveredByBusiness
    uid
    id
    serviceProvider {
      ownerUid
      displayName
      serviceType
      profile {
        displayName
      }
    }
    location {
      id
      uid
    }
  }
}
    `;

/**
 * __useV2Gateway_QueryAppointmentOracleQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryAppointmentOracleQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryAppointmentOracleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryAppointmentOracleQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryAppointmentOracleQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryAppointmentOracleQuery, V2Gateway_QueryAppointmentOracleQueryVariables> & ({ variables: V2Gateway_QueryAppointmentOracleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryAppointmentOracleQuery, V2Gateway_QueryAppointmentOracleQueryVariables>(V2Gateway_QueryAppointmentOracleDocument, options);
      }
export function useV2Gateway_QueryAppointmentOracleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryAppointmentOracleQuery, V2Gateway_QueryAppointmentOracleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryAppointmentOracleQuery, V2Gateway_QueryAppointmentOracleQueryVariables>(V2Gateway_QueryAppointmentOracleDocument, options);
        }
export function useV2Gateway_QueryAppointmentOracleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryAppointmentOracleQuery, V2Gateway_QueryAppointmentOracleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryAppointmentOracleQuery, V2Gateway_QueryAppointmentOracleQueryVariables>(V2Gateway_QueryAppointmentOracleDocument, options);
        }
export type V2Gateway_QueryAppointmentOracleQueryHookResult = ReturnType<typeof useV2Gateway_QueryAppointmentOracleQuery>;
export type V2Gateway_QueryAppointmentOracleLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryAppointmentOracleLazyQuery>;
export type V2Gateway_QueryAppointmentOracleSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryAppointmentOracleSuspenseQuery>;
export type V2Gateway_QueryAppointmentOracleQueryResult = Apollo.QueryResult<V2Gateway_QueryAppointmentOracleQuery, V2Gateway_QueryAppointmentOracleQueryVariables>;
export const V2Gateway_SearchReviewsDocument = gql`
    query V2Gateway_SearchReviews($query: ReviewQuery!) {
  searchReviews(query: $query) {
    reviews {
      uid
      text
      rating
      createdAt
      isExternal
      externalAuthor
      serviceProvider {
        ownerUid
      }
      owner {
        fullName
      }
      booking {
        uid
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_SearchReviewsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_SearchReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SearchReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_SearchReviewsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_SearchReviewsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_SearchReviewsQuery, V2Gateway_SearchReviewsQueryVariables> & ({ variables: V2Gateway_SearchReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_SearchReviewsQuery, V2Gateway_SearchReviewsQueryVariables>(V2Gateway_SearchReviewsDocument, options);
      }
export function useV2Gateway_SearchReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_SearchReviewsQuery, V2Gateway_SearchReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_SearchReviewsQuery, V2Gateway_SearchReviewsQueryVariables>(V2Gateway_SearchReviewsDocument, options);
        }
export function useV2Gateway_SearchReviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_SearchReviewsQuery, V2Gateway_SearchReviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_SearchReviewsQuery, V2Gateway_SearchReviewsQueryVariables>(V2Gateway_SearchReviewsDocument, options);
        }
export type V2Gateway_SearchReviewsQueryHookResult = ReturnType<typeof useV2Gateway_SearchReviewsQuery>;
export type V2Gateway_SearchReviewsLazyQueryHookResult = ReturnType<typeof useV2Gateway_SearchReviewsLazyQuery>;
export type V2Gateway_SearchReviewsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_SearchReviewsSuspenseQuery>;
export type V2Gateway_SearchReviewsQueryResult = Apollo.QueryResult<V2Gateway_SearchReviewsQuery, V2Gateway_SearchReviewsQueryVariables>;
export const V2Gateway_SearchAppointmentRequestsDocument = gql`
    query V2Gateway_SearchAppointmentRequests($query: AppointmentRequestQuery!) {
  searchAppointmentRequests(query: $query) {
    ...appointmentRequestFields
  }
}
    ${AppointmentRequestFieldsFragmentDoc}`;

/**
 * __useV2Gateway_SearchAppointmentRequestsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_SearchAppointmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SearchAppointmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_SearchAppointmentRequestsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_SearchAppointmentRequestsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_SearchAppointmentRequestsQuery, V2Gateway_SearchAppointmentRequestsQueryVariables> & ({ variables: V2Gateway_SearchAppointmentRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_SearchAppointmentRequestsQuery, V2Gateway_SearchAppointmentRequestsQueryVariables>(V2Gateway_SearchAppointmentRequestsDocument, options);
      }
export function useV2Gateway_SearchAppointmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_SearchAppointmentRequestsQuery, V2Gateway_SearchAppointmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_SearchAppointmentRequestsQuery, V2Gateway_SearchAppointmentRequestsQueryVariables>(V2Gateway_SearchAppointmentRequestsDocument, options);
        }
export function useV2Gateway_SearchAppointmentRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_SearchAppointmentRequestsQuery, V2Gateway_SearchAppointmentRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_SearchAppointmentRequestsQuery, V2Gateway_SearchAppointmentRequestsQueryVariables>(V2Gateway_SearchAppointmentRequestsDocument, options);
        }
export type V2Gateway_SearchAppointmentRequestsQueryHookResult = ReturnType<typeof useV2Gateway_SearchAppointmentRequestsQuery>;
export type V2Gateway_SearchAppointmentRequestsLazyQueryHookResult = ReturnType<typeof useV2Gateway_SearchAppointmentRequestsLazyQuery>;
export type V2Gateway_SearchAppointmentRequestsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_SearchAppointmentRequestsSuspenseQuery>;
export type V2Gateway_SearchAppointmentRequestsQueryResult = Apollo.QueryResult<V2Gateway_SearchAppointmentRequestsQuery, V2Gateway_SearchAppointmentRequestsQueryVariables>;
export const V1Gateway_RegisterUserDocument = gql`
    mutation V1Gateway_RegisterUser($accountType: Int!, $country: String!, $idToken: String!, $timezoneLocation: String!, $businessInfo: BusinessRegistrationInfo, $serviceProviderInfo: ServiceProviderRegistrationInfo, $employeeInfo: EmployeeRegistrationInfo, $referrer: String) {
  register(
    accountType: $accountType
    idToken: $idToken
    country: $country
    timezoneLocation: $timezoneLocation
    businessInfo: $businessInfo
    serviceProviderInfo: $serviceProviderInfo
    employeeInfo: $employeeInfo
    referrer: $referrer
  )
}
    `;
export type V1Gateway_RegisterUserMutationFn = Apollo.MutationFunction<V1Gateway_RegisterUserMutation, V1Gateway_RegisterUserMutationVariables>;

/**
 * __useV1Gateway_RegisterUserMutation__
 *
 * To run a mutation, you first call `useV1Gateway_RegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV1Gateway_RegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v1GatewayRegisterUserMutation, { data, loading, error }] = useV1Gateway_RegisterUserMutation({
 *   variables: {
 *      accountType: // value for 'accountType'
 *      country: // value for 'country'
 *      idToken: // value for 'idToken'
 *      timezoneLocation: // value for 'timezoneLocation'
 *      businessInfo: // value for 'businessInfo'
 *      serviceProviderInfo: // value for 'serviceProviderInfo'
 *      employeeInfo: // value for 'employeeInfo'
 *      referrer: // value for 'referrer'
 *   },
 * });
 */
export function useV1Gateway_RegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<V1Gateway_RegisterUserMutation, V1Gateway_RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V1Gateway_RegisterUserMutation, V1Gateway_RegisterUserMutationVariables>(V1Gateway_RegisterUserDocument, options);
      }
export type V1Gateway_RegisterUserMutationHookResult = ReturnType<typeof useV1Gateway_RegisterUserMutation>;
export type V1Gateway_RegisterUserMutationResult = Apollo.MutationResult<V1Gateway_RegisterUserMutation>;
export type V1Gateway_RegisterUserMutationOptions = Apollo.BaseMutationOptions<V1Gateway_RegisterUserMutation, V1Gateway_RegisterUserMutationVariables>;
export const V2Gateway_SearchServiceOfferingCategoriesDocument = gql`
    query V2Gateway_SearchServiceOfferingCategories($query: ServiceOfferingCategoryQuery!) {
  searchServiceOfferingCategories(query: $query) {
    serviceOfferingCategories {
      ...serviceOfferingCategoryFields
    }
  }
}
    ${ServiceOfferingCategoryFieldsFragmentDoc}`;

/**
 * __useV2Gateway_SearchServiceOfferingCategoriesQuery__
 *
 * To run a query within a React component, call `useV2Gateway_SearchServiceOfferingCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SearchServiceOfferingCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_SearchServiceOfferingCategoriesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_SearchServiceOfferingCategoriesQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_SearchServiceOfferingCategoriesQuery, V2Gateway_SearchServiceOfferingCategoriesQueryVariables> & ({ variables: V2Gateway_SearchServiceOfferingCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_SearchServiceOfferingCategoriesQuery, V2Gateway_SearchServiceOfferingCategoriesQueryVariables>(V2Gateway_SearchServiceOfferingCategoriesDocument, options);
      }
export function useV2Gateway_SearchServiceOfferingCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_SearchServiceOfferingCategoriesQuery, V2Gateway_SearchServiceOfferingCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_SearchServiceOfferingCategoriesQuery, V2Gateway_SearchServiceOfferingCategoriesQueryVariables>(V2Gateway_SearchServiceOfferingCategoriesDocument, options);
        }
export function useV2Gateway_SearchServiceOfferingCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_SearchServiceOfferingCategoriesQuery, V2Gateway_SearchServiceOfferingCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_SearchServiceOfferingCategoriesQuery, V2Gateway_SearchServiceOfferingCategoriesQueryVariables>(V2Gateway_SearchServiceOfferingCategoriesDocument, options);
        }
export type V2Gateway_SearchServiceOfferingCategoriesQueryHookResult = ReturnType<typeof useV2Gateway_SearchServiceOfferingCategoriesQuery>;
export type V2Gateway_SearchServiceOfferingCategoriesLazyQueryHookResult = ReturnType<typeof useV2Gateway_SearchServiceOfferingCategoriesLazyQuery>;
export type V2Gateway_SearchServiceOfferingCategoriesSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_SearchServiceOfferingCategoriesSuspenseQuery>;
export type V2Gateway_SearchServiceOfferingCategoriesQueryResult = Apollo.QueryResult<V2Gateway_SearchServiceOfferingCategoriesQuery, V2Gateway_SearchServiceOfferingCategoriesQueryVariables>;
export const CreateAppointmentChangeProposalDocument = gql`
    mutation CreateAppointmentChangeProposal($input: AppointmentChangeProposalInput!) {
  createAppointmentChangeProposal(input: $input)
}
    `;
export type CreateAppointmentChangeProposalMutationFn = Apollo.MutationFunction<CreateAppointmentChangeProposalMutation, CreateAppointmentChangeProposalMutationVariables>;

/**
 * __useCreateAppointmentChangeProposalMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentChangeProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentChangeProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentChangeProposalMutation, { data, loading, error }] = useCreateAppointmentChangeProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentChangeProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentChangeProposalMutation, CreateAppointmentChangeProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentChangeProposalMutation, CreateAppointmentChangeProposalMutationVariables>(CreateAppointmentChangeProposalDocument, options);
      }
export type CreateAppointmentChangeProposalMutationHookResult = ReturnType<typeof useCreateAppointmentChangeProposalMutation>;
export type CreateAppointmentChangeProposalMutationResult = Apollo.MutationResult<CreateAppointmentChangeProposalMutation>;
export type CreateAppointmentChangeProposalMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentChangeProposalMutation, CreateAppointmentChangeProposalMutationVariables>;
export const UpdateAppointmentChangeProposalDocument = gql`
    mutation UpdateAppointmentChangeProposal($id: ID!, $input: AppointmentChangeProposalInput!) {
  updateAppointmentChangeProposal(id: $id, input: $input)
}
    `;
export type UpdateAppointmentChangeProposalMutationFn = Apollo.MutationFunction<UpdateAppointmentChangeProposalMutation, UpdateAppointmentChangeProposalMutationVariables>;

/**
 * __useUpdateAppointmentChangeProposalMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentChangeProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentChangeProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentChangeProposalMutation, { data, loading, error }] = useUpdateAppointmentChangeProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppointmentChangeProposalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentChangeProposalMutation, UpdateAppointmentChangeProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentChangeProposalMutation, UpdateAppointmentChangeProposalMutationVariables>(UpdateAppointmentChangeProposalDocument, options);
      }
export type UpdateAppointmentChangeProposalMutationHookResult = ReturnType<typeof useUpdateAppointmentChangeProposalMutation>;
export type UpdateAppointmentChangeProposalMutationResult = Apollo.MutationResult<UpdateAppointmentChangeProposalMutation>;
export type UpdateAppointmentChangeProposalMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentChangeProposalMutation, UpdateAppointmentChangeProposalMutationVariables>;
export const DeleteAppointmentChangeProposalDocument = gql`
    mutation DeleteAppointmentChangeProposal($id: ID!) {
  deleteAppointmentChangeProposal(id: $id)
}
    `;
export type DeleteAppointmentChangeProposalMutationFn = Apollo.MutationFunction<DeleteAppointmentChangeProposalMutation, DeleteAppointmentChangeProposalMutationVariables>;

/**
 * __useDeleteAppointmentChangeProposalMutation__
 *
 * To run a mutation, you first call `useDeleteAppointmentChangeProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppointmentChangeProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppointmentChangeProposalMutation, { data, loading, error }] = useDeleteAppointmentChangeProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAppointmentChangeProposalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppointmentChangeProposalMutation, DeleteAppointmentChangeProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppointmentChangeProposalMutation, DeleteAppointmentChangeProposalMutationVariables>(DeleteAppointmentChangeProposalDocument, options);
      }
export type DeleteAppointmentChangeProposalMutationHookResult = ReturnType<typeof useDeleteAppointmentChangeProposalMutation>;
export type DeleteAppointmentChangeProposalMutationResult = Apollo.MutationResult<DeleteAppointmentChangeProposalMutation>;
export type DeleteAppointmentChangeProposalMutationOptions = Apollo.BaseMutationOptions<DeleteAppointmentChangeProposalMutation, DeleteAppointmentChangeProposalMutationVariables>;
export const GetAppointmentChangeProposalByIdDocument = gql`
    query GetAppointmentChangeProposalById($id: ID!) {
  getAppointmentChangeProposalById(id: $id) {
    id
    appointmentId
    ownerUserUID
    startDateTime
    createdAt
    updatedAt
    status
    message
  }
}
    `;

/**
 * __useGetAppointmentChangeProposalByIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentChangeProposalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentChangeProposalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentChangeProposalByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppointmentChangeProposalByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentChangeProposalByIdQuery, GetAppointmentChangeProposalByIdQueryVariables> & ({ variables: GetAppointmentChangeProposalByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentChangeProposalByIdQuery, GetAppointmentChangeProposalByIdQueryVariables>(GetAppointmentChangeProposalByIdDocument, options);
      }
export function useGetAppointmentChangeProposalByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentChangeProposalByIdQuery, GetAppointmentChangeProposalByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentChangeProposalByIdQuery, GetAppointmentChangeProposalByIdQueryVariables>(GetAppointmentChangeProposalByIdDocument, options);
        }
export function useGetAppointmentChangeProposalByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentChangeProposalByIdQuery, GetAppointmentChangeProposalByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentChangeProposalByIdQuery, GetAppointmentChangeProposalByIdQueryVariables>(GetAppointmentChangeProposalByIdDocument, options);
        }
export type GetAppointmentChangeProposalByIdQueryHookResult = ReturnType<typeof useGetAppointmentChangeProposalByIdQuery>;
export type GetAppointmentChangeProposalByIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentChangeProposalByIdLazyQuery>;
export type GetAppointmentChangeProposalByIdSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentChangeProposalByIdSuspenseQuery>;
export type GetAppointmentChangeProposalByIdQueryResult = Apollo.QueryResult<GetAppointmentChangeProposalByIdQuery, GetAppointmentChangeProposalByIdQueryVariables>;
export const GetAppointmentChangeProposalsByAppointmentIdDocument = gql`
    query GetAppointmentChangeProposalsByAppointmentId($appointmentId: ID!) {
  getAppointmentChangeProposalsByAppointmentId(appointmentId: $appointmentId) {
    id
    appointmentId
    ownerUserUID
    startDateTime
    createdAt
    updatedAt
    status
    message
  }
}
    `;

/**
 * __useGetAppointmentChangeProposalsByAppointmentIdQuery__
 *
 * To run a query within a React component, call `useGetAppointmentChangeProposalsByAppointmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentChangeProposalsByAppointmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentChangeProposalsByAppointmentIdQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentChangeProposalsByAppointmentIdQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentChangeProposalsByAppointmentIdQuery, GetAppointmentChangeProposalsByAppointmentIdQueryVariables> & ({ variables: GetAppointmentChangeProposalsByAppointmentIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentChangeProposalsByAppointmentIdQuery, GetAppointmentChangeProposalsByAppointmentIdQueryVariables>(GetAppointmentChangeProposalsByAppointmentIdDocument, options);
      }
export function useGetAppointmentChangeProposalsByAppointmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentChangeProposalsByAppointmentIdQuery, GetAppointmentChangeProposalsByAppointmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentChangeProposalsByAppointmentIdQuery, GetAppointmentChangeProposalsByAppointmentIdQueryVariables>(GetAppointmentChangeProposalsByAppointmentIdDocument, options);
        }
export function useGetAppointmentChangeProposalsByAppointmentIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentChangeProposalsByAppointmentIdQuery, GetAppointmentChangeProposalsByAppointmentIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentChangeProposalsByAppointmentIdQuery, GetAppointmentChangeProposalsByAppointmentIdQueryVariables>(GetAppointmentChangeProposalsByAppointmentIdDocument, options);
        }
export type GetAppointmentChangeProposalsByAppointmentIdQueryHookResult = ReturnType<typeof useGetAppointmentChangeProposalsByAppointmentIdQuery>;
export type GetAppointmentChangeProposalsByAppointmentIdLazyQueryHookResult = ReturnType<typeof useGetAppointmentChangeProposalsByAppointmentIdLazyQuery>;
export type GetAppointmentChangeProposalsByAppointmentIdSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentChangeProposalsByAppointmentIdSuspenseQuery>;
export type GetAppointmentChangeProposalsByAppointmentIdQueryResult = Apollo.QueryResult<GetAppointmentChangeProposalsByAppointmentIdQuery, GetAppointmentChangeProposalsByAppointmentIdQueryVariables>;
export const V2Gateway_CreateBookingsDocument = gql`
    mutation V2Gateway_CreateBookings($data: [CreateBookingInput!]!) {
  createBookings(data: $data) {
    uid
    nonce
  }
}
    `;
export type V2Gateway_CreateBookingsMutationFn = Apollo.MutationFunction<V2Gateway_CreateBookingsMutation, V2Gateway_CreateBookingsMutationVariables>;

/**
 * __useV2Gateway_CreateBookingsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateBookingsMutation, { data, loading, error }] = useV2Gateway_CreateBookingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateBookingsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateBookingsMutation, V2Gateway_CreateBookingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateBookingsMutation, V2Gateway_CreateBookingsMutationVariables>(V2Gateway_CreateBookingsDocument, options);
      }
export type V2Gateway_CreateBookingsMutationHookResult = ReturnType<typeof useV2Gateway_CreateBookingsMutation>;
export type V2Gateway_CreateBookingsMutationResult = Apollo.MutationResult<V2Gateway_CreateBookingsMutation>;
export type V2Gateway_CreateBookingsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateBookingsMutation, V2Gateway_CreateBookingsMutationVariables>;
export const V2Gateway_CreateRedeemableRedemptionsDocument = gql`
    mutation V2Gateway_CreateRedeemableRedemptions($data: [RedeemableRedemptionInput!]!) {
  createRedeemableRedemptions(data: $data)
}
    `;
export type V2Gateway_CreateRedeemableRedemptionsMutationFn = Apollo.MutationFunction<V2Gateway_CreateRedeemableRedemptionsMutation, V2Gateway_CreateRedeemableRedemptionsMutationVariables>;

/**
 * __useV2Gateway_CreateRedeemableRedemptionsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateRedeemableRedemptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateRedeemableRedemptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateRedeemableRedemptionsMutation, { data, loading, error }] = useV2Gateway_CreateRedeemableRedemptionsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateRedeemableRedemptionsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateRedeemableRedemptionsMutation, V2Gateway_CreateRedeemableRedemptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateRedeemableRedemptionsMutation, V2Gateway_CreateRedeemableRedemptionsMutationVariables>(V2Gateway_CreateRedeemableRedemptionsDocument, options);
      }
export type V2Gateway_CreateRedeemableRedemptionsMutationHookResult = ReturnType<typeof useV2Gateway_CreateRedeemableRedemptionsMutation>;
export type V2Gateway_CreateRedeemableRedemptionsMutationResult = Apollo.MutationResult<V2Gateway_CreateRedeemableRedemptionsMutation>;
export type V2Gateway_CreateRedeemableRedemptionsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateRedeemableRedemptionsMutation, V2Gateway_CreateRedeemableRedemptionsMutationVariables>;
export const V2Gateway_QueryRedeemablesDocument = gql`
    query V2Gateway_QueryRedeemables($query: RedeemableQuery!) {
  queryRedeemables(query: $query) {
    redeemables {
      uid
      sideEffect {
        discount {
          uid
          value
          name
          type
          isStackable
          change {
            type
            isCoveredByPlatform
            isCoveredByLocation
          }
        }
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_QueryRedeemablesQuery__
 *
 * To run a query within a React component, call `useV2Gateway_QueryRedeemablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_QueryRedeemablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_QueryRedeemablesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_QueryRedeemablesQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_QueryRedeemablesQuery, V2Gateway_QueryRedeemablesQueryVariables> & ({ variables: V2Gateway_QueryRedeemablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_QueryRedeemablesQuery, V2Gateway_QueryRedeemablesQueryVariables>(V2Gateway_QueryRedeemablesDocument, options);
      }
export function useV2Gateway_QueryRedeemablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_QueryRedeemablesQuery, V2Gateway_QueryRedeemablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_QueryRedeemablesQuery, V2Gateway_QueryRedeemablesQueryVariables>(V2Gateway_QueryRedeemablesDocument, options);
        }
export function useV2Gateway_QueryRedeemablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_QueryRedeemablesQuery, V2Gateway_QueryRedeemablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_QueryRedeemablesQuery, V2Gateway_QueryRedeemablesQueryVariables>(V2Gateway_QueryRedeemablesDocument, options);
        }
export type V2Gateway_QueryRedeemablesQueryHookResult = ReturnType<typeof useV2Gateway_QueryRedeemablesQuery>;
export type V2Gateway_QueryRedeemablesLazyQueryHookResult = ReturnType<typeof useV2Gateway_QueryRedeemablesLazyQuery>;
export type V2Gateway_QueryRedeemablesSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_QueryRedeemablesSuspenseQuery>;
export type V2Gateway_QueryRedeemablesQueryResult = Apollo.QueryResult<V2Gateway_QueryRedeemablesQuery, V2Gateway_QueryRedeemablesQueryVariables>;
export const V2Gateway_IsRedeemableRedeemableDocument = gql`
    query V2Gateway_IsRedeemableRedeemable($uid: String!, $secret: String!, $redeemAt: Int!) {
  isRedeemableRedeemable(uid: $uid, secret: $secret, redeemAt: $redeemAt)
}
    `;

/**
 * __useV2Gateway_IsRedeemableRedeemableQuery__
 *
 * To run a query within a React component, call `useV2Gateway_IsRedeemableRedeemableQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_IsRedeemableRedeemableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_IsRedeemableRedeemableQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      secret: // value for 'secret'
 *      redeemAt: // value for 'redeemAt'
 *   },
 * });
 */
export function useV2Gateway_IsRedeemableRedeemableQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_IsRedeemableRedeemableQuery, V2Gateway_IsRedeemableRedeemableQueryVariables> & ({ variables: V2Gateway_IsRedeemableRedeemableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_IsRedeemableRedeemableQuery, V2Gateway_IsRedeemableRedeemableQueryVariables>(V2Gateway_IsRedeemableRedeemableDocument, options);
      }
export function useV2Gateway_IsRedeemableRedeemableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_IsRedeemableRedeemableQuery, V2Gateway_IsRedeemableRedeemableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_IsRedeemableRedeemableQuery, V2Gateway_IsRedeemableRedeemableQueryVariables>(V2Gateway_IsRedeemableRedeemableDocument, options);
        }
export function useV2Gateway_IsRedeemableRedeemableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_IsRedeemableRedeemableQuery, V2Gateway_IsRedeemableRedeemableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_IsRedeemableRedeemableQuery, V2Gateway_IsRedeemableRedeemableQueryVariables>(V2Gateway_IsRedeemableRedeemableDocument, options);
        }
export type V2Gateway_IsRedeemableRedeemableQueryHookResult = ReturnType<typeof useV2Gateway_IsRedeemableRedeemableQuery>;
export type V2Gateway_IsRedeemableRedeemableLazyQueryHookResult = ReturnType<typeof useV2Gateway_IsRedeemableRedeemableLazyQuery>;
export type V2Gateway_IsRedeemableRedeemableSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_IsRedeemableRedeemableSuspenseQuery>;
export type V2Gateway_IsRedeemableRedeemableQueryResult = Apollo.QueryResult<V2Gateway_IsRedeemableRedeemableQuery, V2Gateway_IsRedeemableRedeemableQueryVariables>;
export const V2Gateway_GetServiceOfferingDocument = gql`
    query V2Gateway_GetServiceOffering($query: ServiceOfferingQuery!) {
  queryServiceOfferings(query: $query) {
    hasMoreResults
    serviceOfferings {
      title
      imageUrl
    }
  }
}
    `;

/**
 * __useV2Gateway_GetServiceOfferingQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetServiceOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetServiceOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetServiceOfferingQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_GetServiceOfferingQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetServiceOfferingQuery, V2Gateway_GetServiceOfferingQueryVariables> & ({ variables: V2Gateway_GetServiceOfferingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetServiceOfferingQuery, V2Gateway_GetServiceOfferingQueryVariables>(V2Gateway_GetServiceOfferingDocument, options);
      }
export function useV2Gateway_GetServiceOfferingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetServiceOfferingQuery, V2Gateway_GetServiceOfferingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetServiceOfferingQuery, V2Gateway_GetServiceOfferingQueryVariables>(V2Gateway_GetServiceOfferingDocument, options);
        }
export function useV2Gateway_GetServiceOfferingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetServiceOfferingQuery, V2Gateway_GetServiceOfferingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetServiceOfferingQuery, V2Gateway_GetServiceOfferingQueryVariables>(V2Gateway_GetServiceOfferingDocument, options);
        }
export type V2Gateway_GetServiceOfferingQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingQuery>;
export type V2Gateway_GetServiceOfferingLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingLazyQuery>;
export type V2Gateway_GetServiceOfferingSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingSuspenseQuery>;
export type V2Gateway_GetServiceOfferingQueryResult = Apollo.QueryResult<V2Gateway_GetServiceOfferingQuery, V2Gateway_GetServiceOfferingQueryVariables>;
export const V2Gateway_DeleteBookingsDocument = gql`
    mutation V2Gateway_DeleteBookings($uids: [String!]!, $cancelReason: String!) {
  deleteBookings(uids: $uids, cancelReason: $cancelReason)
}
    `;
export type V2Gateway_DeleteBookingsMutationFn = Apollo.MutationFunction<V2Gateway_DeleteBookingsMutation, V2Gateway_DeleteBookingsMutationVariables>;

/**
 * __useV2Gateway_DeleteBookingsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteBookingsMutation, { data, loading, error }] = useV2Gateway_DeleteBookingsMutation({
 *   variables: {
 *      uids: // value for 'uids'
 *      cancelReason: // value for 'cancelReason'
 *   },
 * });
 */
export function useV2Gateway_DeleteBookingsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteBookingsMutation, V2Gateway_DeleteBookingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteBookingsMutation, V2Gateway_DeleteBookingsMutationVariables>(V2Gateway_DeleteBookingsDocument, options);
      }
export type V2Gateway_DeleteBookingsMutationHookResult = ReturnType<typeof useV2Gateway_DeleteBookingsMutation>;
export type V2Gateway_DeleteBookingsMutationResult = Apollo.MutationResult<V2Gateway_DeleteBookingsMutation>;
export type V2Gateway_DeleteBookingsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteBookingsMutation, V2Gateway_DeleteBookingsMutationVariables>;
export const V2Gateway_GetLocationSubscriptionsDocument = gql`
    query V2Gateway_GetLocationSubscriptions {
  getLocationSubscriptions {
    locationUid
    location {
      id
      name
      formattedAddress
      streetAddress
      uid
      latitude
      longitude
      ownerUid
      type
      slug
    }
  }
}
    `;

/**
 * __useV2Gateway_GetLocationSubscriptionsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetLocationSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetLocationSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetLocationSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetLocationSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetLocationSubscriptionsQuery, V2Gateway_GetLocationSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetLocationSubscriptionsQuery, V2Gateway_GetLocationSubscriptionsQueryVariables>(V2Gateway_GetLocationSubscriptionsDocument, options);
      }
export function useV2Gateway_GetLocationSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetLocationSubscriptionsQuery, V2Gateway_GetLocationSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetLocationSubscriptionsQuery, V2Gateway_GetLocationSubscriptionsQueryVariables>(V2Gateway_GetLocationSubscriptionsDocument, options);
        }
export function useV2Gateway_GetLocationSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetLocationSubscriptionsQuery, V2Gateway_GetLocationSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetLocationSubscriptionsQuery, V2Gateway_GetLocationSubscriptionsQueryVariables>(V2Gateway_GetLocationSubscriptionsDocument, options);
        }
export type V2Gateway_GetLocationSubscriptionsQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationSubscriptionsQuery>;
export type V2Gateway_GetLocationSubscriptionsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationSubscriptionsLazyQuery>;
export type V2Gateway_GetLocationSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationSubscriptionsSuspenseQuery>;
export type V2Gateway_GetLocationSubscriptionsQueryResult = Apollo.QueryResult<V2Gateway_GetLocationSubscriptionsQuery, V2Gateway_GetLocationSubscriptionsQueryVariables>;
export const V2Gateway_CreateLocationSubscriptionsDocument = gql`
    mutation V2Gateway_CreateLocationSubscriptions($data: [CreateLocationSubscriptionInput!]!) {
  createLocationSubscriptions(data: $data)
}
    `;
export type V2Gateway_CreateLocationSubscriptionsMutationFn = Apollo.MutationFunction<V2Gateway_CreateLocationSubscriptionsMutation, V2Gateway_CreateLocationSubscriptionsMutationVariables>;

/**
 * __useV2Gateway_CreateLocationSubscriptionsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateLocationSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateLocationSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateLocationSubscriptionsMutation, { data, loading, error }] = useV2Gateway_CreateLocationSubscriptionsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateLocationSubscriptionsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateLocationSubscriptionsMutation, V2Gateway_CreateLocationSubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateLocationSubscriptionsMutation, V2Gateway_CreateLocationSubscriptionsMutationVariables>(V2Gateway_CreateLocationSubscriptionsDocument, options);
      }
export type V2Gateway_CreateLocationSubscriptionsMutationHookResult = ReturnType<typeof useV2Gateway_CreateLocationSubscriptionsMutation>;
export type V2Gateway_CreateLocationSubscriptionsMutationResult = Apollo.MutationResult<V2Gateway_CreateLocationSubscriptionsMutation>;
export type V2Gateway_CreateLocationSubscriptionsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateLocationSubscriptionsMutation, V2Gateway_CreateLocationSubscriptionsMutationVariables>;
export const V2Gateway_SetUserCountryDocument = gql`
    mutation V2Gateway_SetUserCountry($country: String!, $masqueradeAsUid: String) {
  setUserCountry(country: $country, masqueradeAsUid: $masqueradeAsUid)
}
    `;
export type V2Gateway_SetUserCountryMutationFn = Apollo.MutationFunction<V2Gateway_SetUserCountryMutation, V2Gateway_SetUserCountryMutationVariables>;

/**
 * __useV2Gateway_SetUserCountryMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SetUserCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SetUserCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySetUserCountryMutation, { data, loading, error }] = useV2Gateway_SetUserCountryMutation({
 *   variables: {
 *      country: // value for 'country'
 *      masqueradeAsUid: // value for 'masqueradeAsUid'
 *   },
 * });
 */
export function useV2Gateway_SetUserCountryMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SetUserCountryMutation, V2Gateway_SetUserCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SetUserCountryMutation, V2Gateway_SetUserCountryMutationVariables>(V2Gateway_SetUserCountryDocument, options);
      }
export type V2Gateway_SetUserCountryMutationHookResult = ReturnType<typeof useV2Gateway_SetUserCountryMutation>;
export type V2Gateway_SetUserCountryMutationResult = Apollo.MutationResult<V2Gateway_SetUserCountryMutation>;
export type V2Gateway_SetUserCountryMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SetUserCountryMutation, V2Gateway_SetUserCountryMutationVariables>;
export const V2Gateway_GetLocationsByUidDocument = gql`
    query V2Gateway_GetLocationsByUid($locationUids: [String!]!) {
  getLocationsByUid(locationUids: $locationUids) {
    name
    id
    formattedAddress
    streetAddress
    uid
    latitude
    longitude
    ownerUid
    type
    slug
    business {
      slug
    }
  }
}
    `;

/**
 * __useV2Gateway_GetLocationsByUidQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetLocationsByUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetLocationsByUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetLocationsByUidQuery({
 *   variables: {
 *      locationUids: // value for 'locationUids'
 *   },
 * });
 */
export function useV2Gateway_GetLocationsByUidQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetLocationsByUidQuery, V2Gateway_GetLocationsByUidQueryVariables> & ({ variables: V2Gateway_GetLocationsByUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetLocationsByUidQuery, V2Gateway_GetLocationsByUidQueryVariables>(V2Gateway_GetLocationsByUidDocument, options);
      }
export function useV2Gateway_GetLocationsByUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetLocationsByUidQuery, V2Gateway_GetLocationsByUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetLocationsByUidQuery, V2Gateway_GetLocationsByUidQueryVariables>(V2Gateway_GetLocationsByUidDocument, options);
        }
export function useV2Gateway_GetLocationsByUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetLocationsByUidQuery, V2Gateway_GetLocationsByUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetLocationsByUidQuery, V2Gateway_GetLocationsByUidQueryVariables>(V2Gateway_GetLocationsByUidDocument, options);
        }
export type V2Gateway_GetLocationsByUidQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationsByUidQuery>;
export type V2Gateway_GetLocationsByUidLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationsByUidLazyQuery>;
export type V2Gateway_GetLocationsByUidSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationsByUidSuspenseQuery>;
export type V2Gateway_GetLocationsByUidQueryResult = Apollo.QueryResult<V2Gateway_GetLocationsByUidQuery, V2Gateway_GetLocationsByUidQueryVariables>;
export const GetAppointmentByBookingUidDocument = gql`
    query GetAppointmentByBookingUid($bookingUid: String!) {
  getAppointmentByBookingUid(bookingUid: $bookingUid) {
    uid
    locationUid
    userUid
    ownerUid
    startDateTime
    maxEndDateTime
    bookings {
      isComplete
      uid
    }
  }
}
    `;

/**
 * __useGetAppointmentByBookingUidQuery__
 *
 * To run a query within a React component, call `useGetAppointmentByBookingUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentByBookingUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentByBookingUidQuery({
 *   variables: {
 *      bookingUid: // value for 'bookingUid'
 *   },
 * });
 */
export function useGetAppointmentByBookingUidQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentByBookingUidQuery, GetAppointmentByBookingUidQueryVariables> & ({ variables: GetAppointmentByBookingUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentByBookingUidQuery, GetAppointmentByBookingUidQueryVariables>(GetAppointmentByBookingUidDocument, options);
      }
export function useGetAppointmentByBookingUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentByBookingUidQuery, GetAppointmentByBookingUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentByBookingUidQuery, GetAppointmentByBookingUidQueryVariables>(GetAppointmentByBookingUidDocument, options);
        }
export function useGetAppointmentByBookingUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentByBookingUidQuery, GetAppointmentByBookingUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentByBookingUidQuery, GetAppointmentByBookingUidQueryVariables>(GetAppointmentByBookingUidDocument, options);
        }
export type GetAppointmentByBookingUidQueryHookResult = ReturnType<typeof useGetAppointmentByBookingUidQuery>;
export type GetAppointmentByBookingUidLazyQueryHookResult = ReturnType<typeof useGetAppointmentByBookingUidLazyQuery>;
export type GetAppointmentByBookingUidSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentByBookingUidSuspenseQuery>;
export type GetAppointmentByBookingUidQueryResult = Apollo.QueryResult<GetAppointmentByBookingUidQuery, GetAppointmentByBookingUidQueryVariables>;
export const GetAppointmentsByInternalUidDocument = gql`
    query GetAppointmentsByInternalUid($uids: [String!]!) {
  getAppointments(uids: $uids) {
    ...appointmentFieldsExtended
  }
}
    ${AppointmentFieldsExtendedFragmentDoc}`;

/**
 * __useGetAppointmentsByInternalUidQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsByInternalUidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsByInternalUidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsByInternalUidQuery({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useGetAppointmentsByInternalUidQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsByInternalUidQuery, GetAppointmentsByInternalUidQueryVariables> & ({ variables: GetAppointmentsByInternalUidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsByInternalUidQuery, GetAppointmentsByInternalUidQueryVariables>(GetAppointmentsByInternalUidDocument, options);
      }
export function useGetAppointmentsByInternalUidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsByInternalUidQuery, GetAppointmentsByInternalUidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsByInternalUidQuery, GetAppointmentsByInternalUidQueryVariables>(GetAppointmentsByInternalUidDocument, options);
        }
export function useGetAppointmentsByInternalUidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentsByInternalUidQuery, GetAppointmentsByInternalUidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentsByInternalUidQuery, GetAppointmentsByInternalUidQueryVariables>(GetAppointmentsByInternalUidDocument, options);
        }
export type GetAppointmentsByInternalUidQueryHookResult = ReturnType<typeof useGetAppointmentsByInternalUidQuery>;
export type GetAppointmentsByInternalUidLazyQueryHookResult = ReturnType<typeof useGetAppointmentsByInternalUidLazyQuery>;
export type GetAppointmentsByInternalUidSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentsByInternalUidSuspenseQuery>;
export type GetAppointmentsByInternalUidQueryResult = Apollo.QueryResult<GetAppointmentsByInternalUidQuery, GetAppointmentsByInternalUidQueryVariables>;
export const V2Gateway_SetReviewsDocument = gql`
    mutation V2Gateway_SetReviews($data: [ReviewInput!]!) {
  setReviews(data: $data)
}
    `;
export type V2Gateway_SetReviewsMutationFn = Apollo.MutationFunction<V2Gateway_SetReviewsMutation, V2Gateway_SetReviewsMutationVariables>;

/**
 * __useV2Gateway_SetReviewsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SetReviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SetReviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySetReviewsMutation, { data, loading, error }] = useV2Gateway_SetReviewsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_SetReviewsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SetReviewsMutation, V2Gateway_SetReviewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SetReviewsMutation, V2Gateway_SetReviewsMutationVariables>(V2Gateway_SetReviewsDocument, options);
      }
export type V2Gateway_SetReviewsMutationHookResult = ReturnType<typeof useV2Gateway_SetReviewsMutation>;
export type V2Gateway_SetReviewsMutationResult = Apollo.MutationResult<V2Gateway_SetReviewsMutation>;
export type V2Gateway_SetReviewsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SetReviewsMutation, V2Gateway_SetReviewsMutationVariables>;
export const V2Gateway_GetPartnerAttributionsDocument = gql`
    query V2Gateway_GetPartnerAttributions($page: Int!) {
  getPartnerAttributions(page: $page) {
    earnings
  }
  getPartnerAttributionsCount
  getPartnerTotalAttributionEarnings
}
    `;

/**
 * __useV2Gateway_GetPartnerAttributionsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetPartnerAttributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetPartnerAttributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetPartnerAttributionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useV2Gateway_GetPartnerAttributionsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetPartnerAttributionsQuery, V2Gateway_GetPartnerAttributionsQueryVariables> & ({ variables: V2Gateway_GetPartnerAttributionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetPartnerAttributionsQuery, V2Gateway_GetPartnerAttributionsQueryVariables>(V2Gateway_GetPartnerAttributionsDocument, options);
      }
export function useV2Gateway_GetPartnerAttributionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetPartnerAttributionsQuery, V2Gateway_GetPartnerAttributionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetPartnerAttributionsQuery, V2Gateway_GetPartnerAttributionsQueryVariables>(V2Gateway_GetPartnerAttributionsDocument, options);
        }
export function useV2Gateway_GetPartnerAttributionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetPartnerAttributionsQuery, V2Gateway_GetPartnerAttributionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetPartnerAttributionsQuery, V2Gateway_GetPartnerAttributionsQueryVariables>(V2Gateway_GetPartnerAttributionsDocument, options);
        }
export type V2Gateway_GetPartnerAttributionsQueryHookResult = ReturnType<typeof useV2Gateway_GetPartnerAttributionsQuery>;
export type V2Gateway_GetPartnerAttributionsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetPartnerAttributionsLazyQuery>;
export type V2Gateway_GetPartnerAttributionsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetPartnerAttributionsSuspenseQuery>;
export type V2Gateway_GetPartnerAttributionsQueryResult = Apollo.QueryResult<V2Gateway_GetPartnerAttributionsQuery, V2Gateway_GetPartnerAttributionsQueryVariables>;
export const V2Gateway_SigninPartnerDocument = gql`
    mutation V2Gateway_SigninPartner($idToken: String!) {
  signinPartner(idToken: $idToken)
}
    `;
export type V2Gateway_SigninPartnerMutationFn = Apollo.MutationFunction<V2Gateway_SigninPartnerMutation, V2Gateway_SigninPartnerMutationVariables>;

/**
 * __useV2Gateway_SigninPartnerMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SigninPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SigninPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySigninPartnerMutation, { data, loading, error }] = useV2Gateway_SigninPartnerMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *   },
 * });
 */
export function useV2Gateway_SigninPartnerMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SigninPartnerMutation, V2Gateway_SigninPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SigninPartnerMutation, V2Gateway_SigninPartnerMutationVariables>(V2Gateway_SigninPartnerDocument, options);
      }
export type V2Gateway_SigninPartnerMutationHookResult = ReturnType<typeof useV2Gateway_SigninPartnerMutation>;
export type V2Gateway_SigninPartnerMutationResult = Apollo.MutationResult<V2Gateway_SigninPartnerMutation>;
export type V2Gateway_SigninPartnerMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SigninPartnerMutation, V2Gateway_SigninPartnerMutationVariables>;
export const ConnectStripeAccountDocument = gql`
    mutation ConnectStripeAccount($code: String!) {
  connectStripeAccount(code: $code)
}
    `;
export type ConnectStripeAccountMutationFn = Apollo.MutationFunction<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>;

/**
 * __useConnectStripeAccountMutation__
 *
 * To run a mutation, you first call `useConnectStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectStripeAccountMutation, { data, loading, error }] = useConnectStripeAccountMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConnectStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>(ConnectStripeAccountDocument, options);
      }
export type ConnectStripeAccountMutationHookResult = ReturnType<typeof useConnectStripeAccountMutation>;
export type ConnectStripeAccountMutationResult = Apollo.MutationResult<ConnectStripeAccountMutation>;
export type ConnectStripeAccountMutationOptions = Apollo.BaseMutationOptions<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>;
export const V2Gateway_GetIdentityDocument = gql`
    query V2Gateway_GetIdentity {
  getIdentity {
    uid
    emailAddress
    fullName
    providerId
  }
}
    `;

/**
 * __useV2Gateway_GetIdentityQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetIdentityQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetIdentityQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetIdentityQuery, V2Gateway_GetIdentityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetIdentityQuery, V2Gateway_GetIdentityQueryVariables>(V2Gateway_GetIdentityDocument, options);
      }
export function useV2Gateway_GetIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetIdentityQuery, V2Gateway_GetIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetIdentityQuery, V2Gateway_GetIdentityQueryVariables>(V2Gateway_GetIdentityDocument, options);
        }
export function useV2Gateway_GetIdentitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetIdentityQuery, V2Gateway_GetIdentityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetIdentityQuery, V2Gateway_GetIdentityQueryVariables>(V2Gateway_GetIdentityDocument, options);
        }
export type V2Gateway_GetIdentityQueryHookResult = ReturnType<typeof useV2Gateway_GetIdentityQuery>;
export type V2Gateway_GetIdentityLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetIdentityLazyQuery>;
export type V2Gateway_GetIdentitySuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetIdentitySuspenseQuery>;
export type V2Gateway_GetIdentityQueryResult = Apollo.QueryResult<V2Gateway_GetIdentityQuery, V2Gateway_GetIdentityQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($uid: String) {
  getUser(uid: $uid) {
    uid
    accountType
    fullName
    country
    emailAddress
    phoneNumber
    isTemporary
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const V2Gateway_CreateNoCalendarAccessDocument = gql`
    mutation V2Gateway_CreateNoCalendarAccess {
  createNoCalendarAccess
}
    `;
export type V2Gateway_CreateNoCalendarAccessMutationFn = Apollo.MutationFunction<V2Gateway_CreateNoCalendarAccessMutation, V2Gateway_CreateNoCalendarAccessMutationVariables>;

/**
 * __useV2Gateway_CreateNoCalendarAccessMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateNoCalendarAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateNoCalendarAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateNoCalendarAccessMutation, { data, loading, error }] = useV2Gateway_CreateNoCalendarAccessMutation({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_CreateNoCalendarAccessMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateNoCalendarAccessMutation, V2Gateway_CreateNoCalendarAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateNoCalendarAccessMutation, V2Gateway_CreateNoCalendarAccessMutationVariables>(V2Gateway_CreateNoCalendarAccessDocument, options);
      }
export type V2Gateway_CreateNoCalendarAccessMutationHookResult = ReturnType<typeof useV2Gateway_CreateNoCalendarAccessMutation>;
export type V2Gateway_CreateNoCalendarAccessMutationResult = Apollo.MutationResult<V2Gateway_CreateNoCalendarAccessMutation>;
export type V2Gateway_CreateNoCalendarAccessMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateNoCalendarAccessMutation, V2Gateway_CreateNoCalendarAccessMutationVariables>;
export const V2Gateway_CreateGoogleCalendarAccessDocument = gql`
    mutation V2Gateway_CreateGoogleCalendarAccess($code: String!) {
  createGoogleCalendarAccess(code: $code)
}
    `;
export type V2Gateway_CreateGoogleCalendarAccessMutationFn = Apollo.MutationFunction<V2Gateway_CreateGoogleCalendarAccessMutation, V2Gateway_CreateGoogleCalendarAccessMutationVariables>;

/**
 * __useV2Gateway_CreateGoogleCalendarAccessMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateGoogleCalendarAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateGoogleCalendarAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateGoogleCalendarAccessMutation, { data, loading, error }] = useV2Gateway_CreateGoogleCalendarAccessMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useV2Gateway_CreateGoogleCalendarAccessMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateGoogleCalendarAccessMutation, V2Gateway_CreateGoogleCalendarAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateGoogleCalendarAccessMutation, V2Gateway_CreateGoogleCalendarAccessMutationVariables>(V2Gateway_CreateGoogleCalendarAccessDocument, options);
      }
export type V2Gateway_CreateGoogleCalendarAccessMutationHookResult = ReturnType<typeof useV2Gateway_CreateGoogleCalendarAccessMutation>;
export type V2Gateway_CreateGoogleCalendarAccessMutationResult = Apollo.MutationResult<V2Gateway_CreateGoogleCalendarAccessMutation>;
export type V2Gateway_CreateGoogleCalendarAccessMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateGoogleCalendarAccessMutation, V2Gateway_CreateGoogleCalendarAccessMutationVariables>;
export const V2Gateway_SetDefaultAvailabilityDocument = gql`
    mutation V2Gateway_SetDefaultAvailability($data: [DayOfWeekAvailabilityInput!]!) {
  setDayOfWeekAvailability(data: $data)
}
    `;
export type V2Gateway_SetDefaultAvailabilityMutationFn = Apollo.MutationFunction<V2Gateway_SetDefaultAvailabilityMutation, V2Gateway_SetDefaultAvailabilityMutationVariables>;

/**
 * __useV2Gateway_SetDefaultAvailabilityMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SetDefaultAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SetDefaultAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySetDefaultAvailabilityMutation, { data, loading, error }] = useV2Gateway_SetDefaultAvailabilityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_SetDefaultAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SetDefaultAvailabilityMutation, V2Gateway_SetDefaultAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SetDefaultAvailabilityMutation, V2Gateway_SetDefaultAvailabilityMutationVariables>(V2Gateway_SetDefaultAvailabilityDocument, options);
      }
export type V2Gateway_SetDefaultAvailabilityMutationHookResult = ReturnType<typeof useV2Gateway_SetDefaultAvailabilityMutation>;
export type V2Gateway_SetDefaultAvailabilityMutationResult = Apollo.MutationResult<V2Gateway_SetDefaultAvailabilityMutation>;
export type V2Gateway_SetDefaultAvailabilityMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SetDefaultAvailabilityMutation, V2Gateway_SetDefaultAvailabilityMutationVariables>;
export const V2Gateway_SetDateAvailabilityDocument = gql`
    mutation V2Gateway_SetDateAvailability($data: [DateAvailabilityInput!]!) {
  setDateAvailability(data: $data)
}
    `;
export type V2Gateway_SetDateAvailabilityMutationFn = Apollo.MutationFunction<V2Gateway_SetDateAvailabilityMutation, V2Gateway_SetDateAvailabilityMutationVariables>;

/**
 * __useV2Gateway_SetDateAvailabilityMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SetDateAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SetDateAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySetDateAvailabilityMutation, { data, loading, error }] = useV2Gateway_SetDateAvailabilityMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_SetDateAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SetDateAvailabilityMutation, V2Gateway_SetDateAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SetDateAvailabilityMutation, V2Gateway_SetDateAvailabilityMutationVariables>(V2Gateway_SetDateAvailabilityDocument, options);
      }
export type V2Gateway_SetDateAvailabilityMutationHookResult = ReturnType<typeof useV2Gateway_SetDateAvailabilityMutation>;
export type V2Gateway_SetDateAvailabilityMutationResult = Apollo.MutationResult<V2Gateway_SetDateAvailabilityMutation>;
export type V2Gateway_SetDateAvailabilityMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SetDateAvailabilityMutation, V2Gateway_SetDateAvailabilityMutationVariables>;
export const V2Gateway_GetMerchantForPayoutSetupDocument = gql`
    query V2Gateway_GetMerchantForPayoutSetup {
  getMerchant {
    payoutMethod
    moblFeePercent
  }
  hasConnectedStripeAccount
}
    `;

/**
 * __useV2Gateway_GetMerchantForPayoutSetupQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetMerchantForPayoutSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetMerchantForPayoutSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetMerchantForPayoutSetupQuery({
 *   variables: {
 *   },
 * });
 */
export function useV2Gateway_GetMerchantForPayoutSetupQuery(baseOptions?: Apollo.QueryHookOptions<V2Gateway_GetMerchantForPayoutSetupQuery, V2Gateway_GetMerchantForPayoutSetupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetMerchantForPayoutSetupQuery, V2Gateway_GetMerchantForPayoutSetupQueryVariables>(V2Gateway_GetMerchantForPayoutSetupDocument, options);
      }
export function useV2Gateway_GetMerchantForPayoutSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetMerchantForPayoutSetupQuery, V2Gateway_GetMerchantForPayoutSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetMerchantForPayoutSetupQuery, V2Gateway_GetMerchantForPayoutSetupQueryVariables>(V2Gateway_GetMerchantForPayoutSetupDocument, options);
        }
export function useV2Gateway_GetMerchantForPayoutSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetMerchantForPayoutSetupQuery, V2Gateway_GetMerchantForPayoutSetupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetMerchantForPayoutSetupQuery, V2Gateway_GetMerchantForPayoutSetupQueryVariables>(V2Gateway_GetMerchantForPayoutSetupDocument, options);
        }
export type V2Gateway_GetMerchantForPayoutSetupQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantForPayoutSetupQuery>;
export type V2Gateway_GetMerchantForPayoutSetupLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantForPayoutSetupLazyQuery>;
export type V2Gateway_GetMerchantForPayoutSetupSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetMerchantForPayoutSetupSuspenseQuery>;
export type V2Gateway_GetMerchantForPayoutSetupQueryResult = Apollo.QueryResult<V2Gateway_GetMerchantForPayoutSetupQuery, V2Gateway_GetMerchantForPayoutSetupQueryVariables>;
export const V2Gateway_GetCustomerInputGroupServiceOfferingLinksDocument = gql`
    query V2Gateway_GetCustomerInputGroupServiceOfferingLinks($customerInputGroupUid: String!) {
  getCustomerInputGroupServiceOfferingLinks(
    customerInputGroupUid: $customerInputGroupUid
  )
}
    `;

/**
 * __useV2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery({
 *   variables: {
 *      customerInputGroupUid: // value for 'customerInputGroupUid'
 *   },
 * });
 */
export function useV2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery, V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryVariables> & ({ variables: V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery, V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryVariables>(V2Gateway_GetCustomerInputGroupServiceOfferingLinksDocument, options);
      }
export function useV2Gateway_GetCustomerInputGroupServiceOfferingLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery, V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery, V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryVariables>(V2Gateway_GetCustomerInputGroupServiceOfferingLinksDocument, options);
        }
export function useV2Gateway_GetCustomerInputGroupServiceOfferingLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery, V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery, V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryVariables>(V2Gateway_GetCustomerInputGroupServiceOfferingLinksDocument, options);
        }
export type V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery>;
export type V2Gateway_GetCustomerInputGroupServiceOfferingLinksLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputGroupServiceOfferingLinksLazyQuery>;
export type V2Gateway_GetCustomerInputGroupServiceOfferingLinksSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetCustomerInputGroupServiceOfferingLinksSuspenseQuery>;
export type V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryResult = Apollo.QueryResult<V2Gateway_GetCustomerInputGroupServiceOfferingLinksQuery, V2Gateway_GetCustomerInputGroupServiceOfferingLinksQueryVariables>;
export const V2Gateway_CreateCustomerInputGroupDocument = gql`
    mutation V2Gateway_CreateCustomerInputGroup($data: CustomerInputGroupInput!) {
  createCustomerInputGroup(data: $data)
}
    `;
export type V2Gateway_CreateCustomerInputGroupMutationFn = Apollo.MutationFunction<V2Gateway_CreateCustomerInputGroupMutation, V2Gateway_CreateCustomerInputGroupMutationVariables>;

/**
 * __useV2Gateway_CreateCustomerInputGroupMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateCustomerInputGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateCustomerInputGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateCustomerInputGroupMutation, { data, loading, error }] = useV2Gateway_CreateCustomerInputGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateCustomerInputGroupMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateCustomerInputGroupMutation, V2Gateway_CreateCustomerInputGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateCustomerInputGroupMutation, V2Gateway_CreateCustomerInputGroupMutationVariables>(V2Gateway_CreateCustomerInputGroupDocument, options);
      }
export type V2Gateway_CreateCustomerInputGroupMutationHookResult = ReturnType<typeof useV2Gateway_CreateCustomerInputGroupMutation>;
export type V2Gateway_CreateCustomerInputGroupMutationResult = Apollo.MutationResult<V2Gateway_CreateCustomerInputGroupMutation>;
export type V2Gateway_CreateCustomerInputGroupMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateCustomerInputGroupMutation, V2Gateway_CreateCustomerInputGroupMutationVariables>;
export const V2Gateway_UpdateCustomerInputGroupDocument = gql`
    mutation V2Gateway_UpdateCustomerInputGroup($customerInputGroupUid: String!, $data: CustomerInputGroupInput!) {
  updateCustomerInputGroup(
    customerInputGroupUid: $customerInputGroupUid
    data: $data
  )
}
    `;
export type V2Gateway_UpdateCustomerInputGroupMutationFn = Apollo.MutationFunction<V2Gateway_UpdateCustomerInputGroupMutation, V2Gateway_UpdateCustomerInputGroupMutationVariables>;

/**
 * __useV2Gateway_UpdateCustomerInputGroupMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateCustomerInputGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateCustomerInputGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateCustomerInputGroupMutation, { data, loading, error }] = useV2Gateway_UpdateCustomerInputGroupMutation({
 *   variables: {
 *      customerInputGroupUid: // value for 'customerInputGroupUid'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateCustomerInputGroupMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateCustomerInputGroupMutation, V2Gateway_UpdateCustomerInputGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateCustomerInputGroupMutation, V2Gateway_UpdateCustomerInputGroupMutationVariables>(V2Gateway_UpdateCustomerInputGroupDocument, options);
      }
export type V2Gateway_UpdateCustomerInputGroupMutationHookResult = ReturnType<typeof useV2Gateway_UpdateCustomerInputGroupMutation>;
export type V2Gateway_UpdateCustomerInputGroupMutationResult = Apollo.MutationResult<V2Gateway_UpdateCustomerInputGroupMutation>;
export type V2Gateway_UpdateCustomerInputGroupMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateCustomerInputGroupMutation, V2Gateway_UpdateCustomerInputGroupMutationVariables>;
export const V2Gateway_DeleteCustomerInputGroupDocument = gql`
    mutation V2Gateway_DeleteCustomerInputGroup($customerInputGroupUid: String!) {
  deleteCustomerInputGroup(customerInputGroupUid: $customerInputGroupUid)
}
    `;
export type V2Gateway_DeleteCustomerInputGroupMutationFn = Apollo.MutationFunction<V2Gateway_DeleteCustomerInputGroupMutation, V2Gateway_DeleteCustomerInputGroupMutationVariables>;

/**
 * __useV2Gateway_DeleteCustomerInputGroupMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteCustomerInputGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteCustomerInputGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteCustomerInputGroupMutation, { data, loading, error }] = useV2Gateway_DeleteCustomerInputGroupMutation({
 *   variables: {
 *      customerInputGroupUid: // value for 'customerInputGroupUid'
 *   },
 * });
 */
export function useV2Gateway_DeleteCustomerInputGroupMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteCustomerInputGroupMutation, V2Gateway_DeleteCustomerInputGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteCustomerInputGroupMutation, V2Gateway_DeleteCustomerInputGroupMutationVariables>(V2Gateway_DeleteCustomerInputGroupDocument, options);
      }
export type V2Gateway_DeleteCustomerInputGroupMutationHookResult = ReturnType<typeof useV2Gateway_DeleteCustomerInputGroupMutation>;
export type V2Gateway_DeleteCustomerInputGroupMutationResult = Apollo.MutationResult<V2Gateway_DeleteCustomerInputGroupMutation>;
export type V2Gateway_DeleteCustomerInputGroupMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteCustomerInputGroupMutation, V2Gateway_DeleteCustomerInputGroupMutationVariables>;
export const V2Gateway_CreateServiceOfferingCategoriesDocument = gql`
    mutation V2Gateway_CreateServiceOfferingCategories($data: [CreateServiceOfferingCategoryInput!]!) {
  createServiceOfferingCategories(data: $data)
}
    `;
export type V2Gateway_CreateServiceOfferingCategoriesMutationFn = Apollo.MutationFunction<V2Gateway_CreateServiceOfferingCategoriesMutation, V2Gateway_CreateServiceOfferingCategoriesMutationVariables>;

/**
 * __useV2Gateway_CreateServiceOfferingCategoriesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateServiceOfferingCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateServiceOfferingCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateServiceOfferingCategoriesMutation, { data, loading, error }] = useV2Gateway_CreateServiceOfferingCategoriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateServiceOfferingCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateServiceOfferingCategoriesMutation, V2Gateway_CreateServiceOfferingCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateServiceOfferingCategoriesMutation, V2Gateway_CreateServiceOfferingCategoriesMutationVariables>(V2Gateway_CreateServiceOfferingCategoriesDocument, options);
      }
export type V2Gateway_CreateServiceOfferingCategoriesMutationHookResult = ReturnType<typeof useV2Gateway_CreateServiceOfferingCategoriesMutation>;
export type V2Gateway_CreateServiceOfferingCategoriesMutationResult = Apollo.MutationResult<V2Gateway_CreateServiceOfferingCategoriesMutation>;
export type V2Gateway_CreateServiceOfferingCategoriesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateServiceOfferingCategoriesMutation, V2Gateway_CreateServiceOfferingCategoriesMutationVariables>;
export const V2Gateway_UpdateServiceOfferingCategoriesDocument = gql`
    mutation V2Gateway_UpdateServiceOfferingCategories($data: [UpdateServiceOfferingCategoryInput!]!) {
  updateServiceOfferingCategories(data: $data)
}
    `;
export type V2Gateway_UpdateServiceOfferingCategoriesMutationFn = Apollo.MutationFunction<V2Gateway_UpdateServiceOfferingCategoriesMutation, V2Gateway_UpdateServiceOfferingCategoriesMutationVariables>;

/**
 * __useV2Gateway_UpdateServiceOfferingCategoriesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateServiceOfferingCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateServiceOfferingCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateServiceOfferingCategoriesMutation, { data, loading, error }] = useV2Gateway_UpdateServiceOfferingCategoriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateServiceOfferingCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateServiceOfferingCategoriesMutation, V2Gateway_UpdateServiceOfferingCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateServiceOfferingCategoriesMutation, V2Gateway_UpdateServiceOfferingCategoriesMutationVariables>(V2Gateway_UpdateServiceOfferingCategoriesDocument, options);
      }
export type V2Gateway_UpdateServiceOfferingCategoriesMutationHookResult = ReturnType<typeof useV2Gateway_UpdateServiceOfferingCategoriesMutation>;
export type V2Gateway_UpdateServiceOfferingCategoriesMutationResult = Apollo.MutationResult<V2Gateway_UpdateServiceOfferingCategoriesMutation>;
export type V2Gateway_UpdateServiceOfferingCategoriesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateServiceOfferingCategoriesMutation, V2Gateway_UpdateServiceOfferingCategoriesMutationVariables>;
export const V2Gateway_DeleteServiceOfferingCategoriesDocument = gql`
    mutation V2Gateway_DeleteServiceOfferingCategories($uids: [String!]!) {
  deleteServiceOfferingCategories(uids: $uids)
}
    `;
export type V2Gateway_DeleteServiceOfferingCategoriesMutationFn = Apollo.MutationFunction<V2Gateway_DeleteServiceOfferingCategoriesMutation, V2Gateway_DeleteServiceOfferingCategoriesMutationVariables>;

/**
 * __useV2Gateway_DeleteServiceOfferingCategoriesMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteServiceOfferingCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteServiceOfferingCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteServiceOfferingCategoriesMutation, { data, loading, error }] = useV2Gateway_DeleteServiceOfferingCategoriesMutation({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useV2Gateway_DeleteServiceOfferingCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteServiceOfferingCategoriesMutation, V2Gateway_DeleteServiceOfferingCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteServiceOfferingCategoriesMutation, V2Gateway_DeleteServiceOfferingCategoriesMutationVariables>(V2Gateway_DeleteServiceOfferingCategoriesDocument, options);
      }
export type V2Gateway_DeleteServiceOfferingCategoriesMutationHookResult = ReturnType<typeof useV2Gateway_DeleteServiceOfferingCategoriesMutation>;
export type V2Gateway_DeleteServiceOfferingCategoriesMutationResult = Apollo.MutationResult<V2Gateway_DeleteServiceOfferingCategoriesMutation>;
export type V2Gateway_DeleteServiceOfferingCategoriesMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteServiceOfferingCategoriesMutation, V2Gateway_DeleteServiceOfferingCategoriesMutationVariables>;
export const V2Gateway_GetServiceOfferingCustomerInputsDocument = gql`
    query V2Gateway_GetServiceOfferingCustomerInputs($serviceOfferingUid: String!) {
  getServiceOfferingCustomerInputs(serviceOfferingUid: $serviceOfferingUid) {
    uid
    title
  }
}
    `;

/**
 * __useV2Gateway_GetServiceOfferingCustomerInputsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetServiceOfferingCustomerInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetServiceOfferingCustomerInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetServiceOfferingCustomerInputsQuery({
 *   variables: {
 *      serviceOfferingUid: // value for 'serviceOfferingUid'
 *   },
 * });
 */
export function useV2Gateway_GetServiceOfferingCustomerInputsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetServiceOfferingCustomerInputsQuery, V2Gateway_GetServiceOfferingCustomerInputsQueryVariables> & ({ variables: V2Gateway_GetServiceOfferingCustomerInputsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetServiceOfferingCustomerInputsQuery, V2Gateway_GetServiceOfferingCustomerInputsQueryVariables>(V2Gateway_GetServiceOfferingCustomerInputsDocument, options);
      }
export function useV2Gateway_GetServiceOfferingCustomerInputsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetServiceOfferingCustomerInputsQuery, V2Gateway_GetServiceOfferingCustomerInputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetServiceOfferingCustomerInputsQuery, V2Gateway_GetServiceOfferingCustomerInputsQueryVariables>(V2Gateway_GetServiceOfferingCustomerInputsDocument, options);
        }
export function useV2Gateway_GetServiceOfferingCustomerInputsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetServiceOfferingCustomerInputsQuery, V2Gateway_GetServiceOfferingCustomerInputsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetServiceOfferingCustomerInputsQuery, V2Gateway_GetServiceOfferingCustomerInputsQueryVariables>(V2Gateway_GetServiceOfferingCustomerInputsDocument, options);
        }
export type V2Gateway_GetServiceOfferingCustomerInputsQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingCustomerInputsQuery>;
export type V2Gateway_GetServiceOfferingCustomerInputsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingCustomerInputsLazyQuery>;
export type V2Gateway_GetServiceOfferingCustomerInputsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingCustomerInputsSuspenseQuery>;
export type V2Gateway_GetServiceOfferingCustomerInputsQueryResult = Apollo.QueryResult<V2Gateway_GetServiceOfferingCustomerInputsQuery, V2Gateway_GetServiceOfferingCustomerInputsQueryVariables>;
export const V2Gateway_SetServiceOfferingCustomerInputsDocument = gql`
    mutation V2Gateway_SetServiceOfferingCustomerInputs($serviceOfferingUid: String!, $customerInputUids: [String!]!) {
  setServiceOfferingCustomerInputs(
    serviceOfferingUid: $serviceOfferingUid
    customerInputUids: $customerInputUids
  )
}
    `;
export type V2Gateway_SetServiceOfferingCustomerInputsMutationFn = Apollo.MutationFunction<V2Gateway_SetServiceOfferingCustomerInputsMutation, V2Gateway_SetServiceOfferingCustomerInputsMutationVariables>;

/**
 * __useV2Gateway_SetServiceOfferingCustomerInputsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_SetServiceOfferingCustomerInputsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_SetServiceOfferingCustomerInputsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewaySetServiceOfferingCustomerInputsMutation, { data, loading, error }] = useV2Gateway_SetServiceOfferingCustomerInputsMutation({
 *   variables: {
 *      serviceOfferingUid: // value for 'serviceOfferingUid'
 *      customerInputUids: // value for 'customerInputUids'
 *   },
 * });
 */
export function useV2Gateway_SetServiceOfferingCustomerInputsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_SetServiceOfferingCustomerInputsMutation, V2Gateway_SetServiceOfferingCustomerInputsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_SetServiceOfferingCustomerInputsMutation, V2Gateway_SetServiceOfferingCustomerInputsMutationVariables>(V2Gateway_SetServiceOfferingCustomerInputsDocument, options);
      }
export type V2Gateway_SetServiceOfferingCustomerInputsMutationHookResult = ReturnType<typeof useV2Gateway_SetServiceOfferingCustomerInputsMutation>;
export type V2Gateway_SetServiceOfferingCustomerInputsMutationResult = Apollo.MutationResult<V2Gateway_SetServiceOfferingCustomerInputsMutation>;
export type V2Gateway_SetServiceOfferingCustomerInputsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_SetServiceOfferingCustomerInputsMutation, V2Gateway_SetServiceOfferingCustomerInputsMutationVariables>;
export const V2Gateway_CreateServiceOfferingDocument = gql`
    mutation V2Gateway_CreateServiceOffering($data: CreateServiceOfferingInput!) {
  createServiceOffering(data: $data) {
    uid
  }
}
    `;
export type V2Gateway_CreateServiceOfferingMutationFn = Apollo.MutationFunction<V2Gateway_CreateServiceOfferingMutation, V2Gateway_CreateServiceOfferingMutationVariables>;

/**
 * __useV2Gateway_CreateServiceOfferingMutation__
 *
 * To run a mutation, you first call `useV2Gateway_CreateServiceOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_CreateServiceOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayCreateServiceOfferingMutation, { data, loading, error }] = useV2Gateway_CreateServiceOfferingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_CreateServiceOfferingMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_CreateServiceOfferingMutation, V2Gateway_CreateServiceOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_CreateServiceOfferingMutation, V2Gateway_CreateServiceOfferingMutationVariables>(V2Gateway_CreateServiceOfferingDocument, options);
      }
export type V2Gateway_CreateServiceOfferingMutationHookResult = ReturnType<typeof useV2Gateway_CreateServiceOfferingMutation>;
export type V2Gateway_CreateServiceOfferingMutationResult = Apollo.MutationResult<V2Gateway_CreateServiceOfferingMutation>;
export type V2Gateway_CreateServiceOfferingMutationOptions = Apollo.BaseMutationOptions<V2Gateway_CreateServiceOfferingMutation, V2Gateway_CreateServiceOfferingMutationVariables>;
export const V2Gateway_UpdateServiceOfferingDocument = gql`
    mutation V2Gateway_UpdateServiceOffering($data: UpdateServiceOfferingInput!) {
  updateServiceOffering(data: $data)
}
    `;
export type V2Gateway_UpdateServiceOfferingMutationFn = Apollo.MutationFunction<V2Gateway_UpdateServiceOfferingMutation, V2Gateway_UpdateServiceOfferingMutationVariables>;

/**
 * __useV2Gateway_UpdateServiceOfferingMutation__
 *
 * To run a mutation, you first call `useV2Gateway_UpdateServiceOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_UpdateServiceOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayUpdateServiceOfferingMutation, { data, loading, error }] = useV2Gateway_UpdateServiceOfferingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useV2Gateway_UpdateServiceOfferingMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_UpdateServiceOfferingMutation, V2Gateway_UpdateServiceOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_UpdateServiceOfferingMutation, V2Gateway_UpdateServiceOfferingMutationVariables>(V2Gateway_UpdateServiceOfferingDocument, options);
      }
export type V2Gateway_UpdateServiceOfferingMutationHookResult = ReturnType<typeof useV2Gateway_UpdateServiceOfferingMutation>;
export type V2Gateway_UpdateServiceOfferingMutationResult = Apollo.MutationResult<V2Gateway_UpdateServiceOfferingMutation>;
export type V2Gateway_UpdateServiceOfferingMutationOptions = Apollo.BaseMutationOptions<V2Gateway_UpdateServiceOfferingMutation, V2Gateway_UpdateServiceOfferingMutationVariables>;
export const V2Gateway_GetServiceOfferingsDocument = gql`
    query V2Gateway_GetServiceOfferings($query: ServiceOfferingQuery!) {
  queryServiceOfferings(query: $query) {
    hasMoreResults
    serviceOfferings {
      title
      basePrice
      shortDesc
      baseTime
      imageUrl
      uid
      type
      allowTip
      maxConcurrentBookings
      index
      postServiceNote
      isHidden
      customerInputs {
        uid
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_GetServiceOfferingsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetServiceOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetServiceOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetServiceOfferingsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useV2Gateway_GetServiceOfferingsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetServiceOfferingsQuery, V2Gateway_GetServiceOfferingsQueryVariables> & ({ variables: V2Gateway_GetServiceOfferingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetServiceOfferingsQuery, V2Gateway_GetServiceOfferingsQueryVariables>(V2Gateway_GetServiceOfferingsDocument, options);
      }
export function useV2Gateway_GetServiceOfferingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetServiceOfferingsQuery, V2Gateway_GetServiceOfferingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetServiceOfferingsQuery, V2Gateway_GetServiceOfferingsQueryVariables>(V2Gateway_GetServiceOfferingsDocument, options);
        }
export function useV2Gateway_GetServiceOfferingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetServiceOfferingsQuery, V2Gateway_GetServiceOfferingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetServiceOfferingsQuery, V2Gateway_GetServiceOfferingsQueryVariables>(V2Gateway_GetServiceOfferingsDocument, options);
        }
export type V2Gateway_GetServiceOfferingsQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingsQuery>;
export type V2Gateway_GetServiceOfferingsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingsLazyQuery>;
export type V2Gateway_GetServiceOfferingsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetServiceOfferingsSuspenseQuery>;
export type V2Gateway_GetServiceOfferingsQueryResult = Apollo.QueryResult<V2Gateway_GetServiceOfferingsQuery, V2Gateway_GetServiceOfferingsQueryVariables>;
export const V2Gateway_DeleteServiceOfferingsDocument = gql`
    mutation V2Gateway_DeleteServiceOfferings($uids: [String!]!) {
  deleteServiceOfferings(uids: $uids)
}
    `;
export type V2Gateway_DeleteServiceOfferingsMutationFn = Apollo.MutationFunction<V2Gateway_DeleteServiceOfferingsMutation, V2Gateway_DeleteServiceOfferingsMutationVariables>;

/**
 * __useV2Gateway_DeleteServiceOfferingsMutation__
 *
 * To run a mutation, you first call `useV2Gateway_DeleteServiceOfferingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_DeleteServiceOfferingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [v2GatewayDeleteServiceOfferingsMutation, { data, loading, error }] = useV2Gateway_DeleteServiceOfferingsMutation({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useV2Gateway_DeleteServiceOfferingsMutation(baseOptions?: Apollo.MutationHookOptions<V2Gateway_DeleteServiceOfferingsMutation, V2Gateway_DeleteServiceOfferingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<V2Gateway_DeleteServiceOfferingsMutation, V2Gateway_DeleteServiceOfferingsMutationVariables>(V2Gateway_DeleteServiceOfferingsDocument, options);
      }
export type V2Gateway_DeleteServiceOfferingsMutationHookResult = ReturnType<typeof useV2Gateway_DeleteServiceOfferingsMutation>;
export type V2Gateway_DeleteServiceOfferingsMutationResult = Apollo.MutationResult<V2Gateway_DeleteServiceOfferingsMutation>;
export type V2Gateway_DeleteServiceOfferingsMutationOptions = Apollo.BaseMutationOptions<V2Gateway_DeleteServiceOfferingsMutation, V2Gateway_DeleteServiceOfferingsMutationVariables>;
export const V2Gateway_GetLocationDocument = gql`
    query V2Gateway_GetLocation($locationUid: String!) {
  getLocation(locationUid: $locationUid) {
    uid
    id
    name
    streetAddress
    formattedAddress
    phoneNumber
    type
    extendedAddress
    latitude
    longitude
    ownerUid
    placeId
    slug
    serviceAreas {
      uid
      name
      description
      externalUid
      files {
        uid
        index
        label
        uploadedFile {
          publicUrl
          objectName
        }
      }
    }
    business {
      slug
      uid
    }
    files {
      uid
      index
      label
      uploadedFile {
        publicUrl
        objectName
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_GetLocationQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetLocationQuery({
 *   variables: {
 *      locationUid: // value for 'locationUid'
 *   },
 * });
 */
export function useV2Gateway_GetLocationQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetLocationQuery, V2Gateway_GetLocationQueryVariables> & ({ variables: V2Gateway_GetLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetLocationQuery, V2Gateway_GetLocationQueryVariables>(V2Gateway_GetLocationDocument, options);
      }
export function useV2Gateway_GetLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetLocationQuery, V2Gateway_GetLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetLocationQuery, V2Gateway_GetLocationQueryVariables>(V2Gateway_GetLocationDocument, options);
        }
export function useV2Gateway_GetLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetLocationQuery, V2Gateway_GetLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetLocationQuery, V2Gateway_GetLocationQueryVariables>(V2Gateway_GetLocationDocument, options);
        }
export type V2Gateway_GetLocationQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationQuery>;
export type V2Gateway_GetLocationLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationLazyQuery>;
export type V2Gateway_GetLocationSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationSuspenseQuery>;
export type V2Gateway_GetLocationQueryResult = Apollo.QueryResult<V2Gateway_GetLocationQuery, V2Gateway_GetLocationQueryVariables>;
export const V2Gateway_GetLocationWithConfirmedAppointmentsDocument = gql`
    query V2Gateway_GetLocationWithConfirmedAppointments($locationUid: String!, $minStartTime: Int!) {
  getLocation(locationUid: $locationUid) {
    formattedAddress
    name
    externalUid
    ownerUid
    type
    phoneNumber
    uid
    id
    files {
      uid
      index
      uploadedFile {
        publicUrl
        objectName
      }
    }
    appointments(
      query: {confirmedStatus: CONFIRMED, cancelledStatus: NOT_CANCELLED, completeStatus: INCOMPLETE, timeUtcSecondsBounds: {min: $minStartTime}}
    ) {
      startDateTime
      maxEndDateTime
      uid
      id
      serviceProvider {
        ownerUid
        serviceType
        displayName
        serviceOfferings {
          uid
          title
          index
        }
        reviews {
          isLike
          isVerified
        }
        profile {
          displayName
          avatarImage {
            uploadedFile {
              publicUrl
            }
          }
        }
        insuranceInformation {
          titlePrefix
          titleSuffix
        }
      }
      serviceArea {
        uid
        name
      }
      preferences {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useV2Gateway_GetLocationWithConfirmedAppointmentsQuery__
 *
 * To run a query within a React component, call `useV2Gateway_GetLocationWithConfirmedAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useV2Gateway_GetLocationWithConfirmedAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useV2Gateway_GetLocationWithConfirmedAppointmentsQuery({
 *   variables: {
 *      locationUid: // value for 'locationUid'
 *      minStartTime: // value for 'minStartTime'
 *   },
 * });
 */
export function useV2Gateway_GetLocationWithConfirmedAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<V2Gateway_GetLocationWithConfirmedAppointmentsQuery, V2Gateway_GetLocationWithConfirmedAppointmentsQueryVariables> & ({ variables: V2Gateway_GetLocationWithConfirmedAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<V2Gateway_GetLocationWithConfirmedAppointmentsQuery, V2Gateway_GetLocationWithConfirmedAppointmentsQueryVariables>(V2Gateway_GetLocationWithConfirmedAppointmentsDocument, options);
      }
export function useV2Gateway_GetLocationWithConfirmedAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<V2Gateway_GetLocationWithConfirmedAppointmentsQuery, V2Gateway_GetLocationWithConfirmedAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<V2Gateway_GetLocationWithConfirmedAppointmentsQuery, V2Gateway_GetLocationWithConfirmedAppointmentsQueryVariables>(V2Gateway_GetLocationWithConfirmedAppointmentsDocument, options);
        }
export function useV2Gateway_GetLocationWithConfirmedAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<V2Gateway_GetLocationWithConfirmedAppointmentsQuery, V2Gateway_GetLocationWithConfirmedAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<V2Gateway_GetLocationWithConfirmedAppointmentsQuery, V2Gateway_GetLocationWithConfirmedAppointmentsQueryVariables>(V2Gateway_GetLocationWithConfirmedAppointmentsDocument, options);
        }
export type V2Gateway_GetLocationWithConfirmedAppointmentsQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationWithConfirmedAppointmentsQuery>;
export type V2Gateway_GetLocationWithConfirmedAppointmentsLazyQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationWithConfirmedAppointmentsLazyQuery>;
export type V2Gateway_GetLocationWithConfirmedAppointmentsSuspenseQueryHookResult = ReturnType<typeof useV2Gateway_GetLocationWithConfirmedAppointmentsSuspenseQuery>;
export type V2Gateway_GetLocationWithConfirmedAppointmentsQueryResult = Apollo.QueryResult<V2Gateway_GetLocationWithConfirmedAppointmentsQuery, V2Gateway_GetLocationWithConfirmedAppointmentsQueryVariables>;